(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.Nj.bU === region.qb.bU)
	{
		return 'on line ' + region.Nj.bU;
	}
	return 'on lines ' + region.Nj.bU + ' through ' + region.qb.bU;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.cR,
		impl.dJ,
		impl.dC,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		bp: func(record.bp),
		Wo: record.Wo,
		V1: record.V1
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.bp;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.Wo;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.V1) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.cR,
		impl.dJ,
		impl.dC,
		function(sendToApp, initialModel) {
			var view = impl.dM;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.cR,
		impl.dJ,
		impl.dC,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.eO && impl.eO(sendToApp)
			var view = impl.dM;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.a2);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.WC) && (_VirtualDom_doc.title = title = doc.WC);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.CU;
	var onUrlRequest = impl.CV;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		eO: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.F5 === next.F5
							&& curr.t_ === next.t_
							&& curr.Fk.a === next.Fk.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		cR: function(flags)
		{
			return A3(impl.cR, flags, _Browser_getUrl(), key);
		},
		dM: impl.dM,
		dJ: impl.dJ,
		dC: impl.dC
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { tG: 'hidden', kB: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { tG: 'mozHidden', kB: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { tG: 'msHidden', kB: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { tG: 'webkitHidden', kB: 'webkitvisibilitychange' }
		: { tG: 'hidden', kB: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		We: _Browser_getScene(),
		WX: {
			TM: _Browser_window.pageXOffset,
			m: _Browser_window.pageYOffset,
			bF: _Browser_doc.documentElement.clientWidth,
			tE: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		bF: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		tE: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			We: {
				bF: node.scrollWidth,
				tE: node.scrollHeight
			},
			WX: {
				TM: node.scrollLeft,
				m: node.scrollTop,
				bF: node.clientWidth,
				tE: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			We: _Browser_getScene(),
			WX: {
				TM: x,
				m: y,
				bF: _Browser_doc.documentElement.clientWidth,
				tE: _Browser_doc.documentElement.clientHeight
			},
			pp: {
				TM: x + rect.left,
				m: y + rect.top,
				bF: rect.width,
				tE: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.cH.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.cH.b, xhr)); });
		$elm$core$Maybe$isJust(request.WM) && _Http_track(router, xhr, request.WM.a);

		try {
			xhr.open(request.c0, request.dK, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.dK));
		}

		_Http_configureRequest(xhr, request);

		request.a2.a && xhr.setRequestHeader('Content-Type', request.a2.a);
		xhr.send(request.a2.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.cL; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.dF.a || 0;
	xhr.responseType = request.cH.d;
	xhr.withCredentials = request.T9;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		dK: xhr.responseURL,
		Wm: xhr.status,
		Wn: xhr.statusText,
		cL: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			K5: event.loaded,
			dz: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			V5: event.loaded,
			dz: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.Vw) { flags += 'm'; }
	if (options.Uo) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}




function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.r) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.t),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.t);
		} else {
			var treeLen = builder.r * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.y) : builder.y;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.r);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.t) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.t);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{y: nodeList, r: (len / $elm$core$Array$branchFactor) | 0, t: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {U4: fragment, t_: host, Ex: path, Fk: port_, F5: protocol, V3: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Browser$Custom$elementWithFlags = F2(
	function (decoder, program) {
		return $elm$browser$Browser$element(
			{
				cR: function (value) {
					var _v0 = A2($elm$json$Json$Decode$decodeValue, decoder, value);
					if (!_v0.$) {
						var flags = _v0.a;
						return A2(
							$elm$core$Tuple$mapFirst,
							$elm$core$Result$Ok,
							program.cR(flags));
					} else {
						var err = _v0.a;
						return _Utils_Tuple2(
							$elm$core$Result$Err(err),
							$elm$core$Platform$Cmd$none);
					}
				},
				dC: function (result) {
					if (!result.$) {
						var model = result.a;
						return program.dC(model);
					} else {
						return $elm$core$Platform$Sub$none;
					}
				},
				dJ: F2(
					function (msg, result) {
						if (!result.$) {
							var model = result.a;
							return A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$Result$Ok,
								A2(program.dJ, msg, model));
						} else {
							return _Utils_Tuple2(result, $elm$core$Platform$Cmd$none);
						}
					}),
				dM: function (result) {
					if (!result.$) {
						var model = result.a;
						return program.dM(model);
					} else {
						var err = result.a;
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Invalid flags')
										])),
									A2(
									$elm$html$Html$pre,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$json$Json$Decode$errorToString(err))
										]))
								]));
					}
				}
			});
	});
var $author$project$Model$Component$Properties$VacancyFilterOptionSearch$Flags$Flags = F7(
	function (domainId, filterId, sessionToken, location, placeholder, noResultMessage, currentOptions) {
		return {ng: currentOptions, cF: domainId, rI: filterId, eq: location, B0: noResultMessage, dd: placeholder, av: sessionToken};
	});
var $author$project$Data$Id$Id = $elm$core$Basics$identity;
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Data$Id$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $elm$json$Json$Decode$list = _Json_decodeList;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$field = _Json_decodeField;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Model$Component$Properties$VacancyFilterOptionSearch$Flags$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'currentOptions',
	$elm$json$Json$Decode$list($author$project$Data$Id$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'noResultMessage',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'placeholder',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'location',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'sessionToken',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'filterId',
						$author$project$Data$Id$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'domainId',
							$author$project$Data$Id$decoder,
							$elm$json$Json$Decode$succeed($author$project$Model$Component$Properties$VacancyFilterOptionSearch$Flags$Flags))))))));
var $author$project$VacancyFilterOptionSearch$FilterSearchMsg = $elm$core$Basics$identity;
var $lydell$elm_app_url$AppUrl$AppUrl = F3(
	function (path, queryParameters, fragment) {
		return {U4: fragment, Ex: path, b3: queryParameters};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $lydell$elm_app_url$AppUrl$percentDecode = function (string) {
	return A2(
		$elm$core$Maybe$withDefault,
		string,
		$elm$url$Url$percentDecode(string));
};
var $lydell$elm_app_url$AppUrl$trimLeadingSlash = function (string) {
	return A2($elm$core$String$startsWith, '/', string) ? A2($elm$core$String$dropLeft, 1, string) : string;
};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$endsWith = _String_endsWith;
var $lydell$elm_app_url$AppUrl$trimTrailingSlash = function (string) {
	return A2($elm$core$String$endsWith, '/', string) ? A2($elm$core$String$dropRight, 1, string) : string;
};
var $lydell$elm_app_url$AppUrl$parsePath = function (path) {
	var trimmed = $lydell$elm_app_url$AppUrl$trimTrailingSlash(
		$lydell$elm_app_url$AppUrl$trimLeadingSlash(path));
	return $elm$core$String$isEmpty(trimmed) ? _List_Nil : A2(
		$elm$core$List$map,
		$lydell$elm_app_url$AppUrl$percentDecode,
		A2($elm$core$String$split, '/', trimmed));
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $lydell$elm_app_url$AppUrl$insert = F2(
	function (value, maybeList) {
		return $elm$core$Maybe$Just(
			A2(
				$elm$core$List$cons,
				value,
				A2($elm$core$Maybe$withDefault, _List_Nil, maybeList)));
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $lydell$elm_app_url$AppUrl$queryParameterDecode = A2(
	$elm$core$Basics$composeR,
	A2($elm$core$String$replace, '+', ' '),
	$lydell$elm_app_url$AppUrl$percentDecode);
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $lydell$elm_app_url$AppUrl$parseQueryParameter = F2(
	function (segment, queryParameters) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if (!_v0.b) {
			return queryParameters;
		} else {
			if ((_v0.a === '') && (!_v0.b.b)) {
				return queryParameters;
			} else {
				var rawKey = _v0.a;
				var rest = _v0.b;
				return A3(
					$elm$core$Dict$update,
					$lydell$elm_app_url$AppUrl$queryParameterDecode(rawKey),
					$lydell$elm_app_url$AppUrl$insert(
						$lydell$elm_app_url$AppUrl$queryParameterDecode(
							A2($elm$core$String$join, '=', rest))),
					queryParameters);
			}
		}
	});
var $lydell$elm_app_url$AppUrl$parseQueryParameters = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$split('&'),
	A2($elm$core$List$foldr, $lydell$elm_app_url$AppUrl$parseQueryParameter, $elm$core$Dict$empty));
var $lydell$elm_app_url$AppUrl$fromUrl = function (url) {
	return {
		U4: A2($elm$core$Maybe$map, $lydell$elm_app_url$AppUrl$percentDecode, url.U4),
		Ex: $lydell$elm_app_url$AppUrl$parsePath(url.Ex),
		b3: A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Dict$empty,
			A2($elm$core$Maybe$map, $lydell$elm_app_url$AppUrl$parseQueryParameters, url.V3))
	};
};
var $author$project$View$Autocomplete$Http$State = $elm$core$Basics$identity;
var $author$project$Data$Key$Key = $elm$core$Basics$identity;
var $author$project$Data$Key$newKey = 0;
var $author$project$Data$Autocomplete$Unknown = {$: 3};
var $author$project$Data$Autocomplete$unknown = $author$project$Data$Autocomplete$Unknown;
var $author$project$View$Autocomplete$Http$init = {s: $author$project$Data$Autocomplete$unknown, T: '', wF: $author$project$Data$Key$newKey};
var $author$project$View$FilterOptionSuggestions$init = function (flags) {
	var location = A2(
		$elm$core$Maybe$withDefault,
		A3($lydell$elm_app_url$AppUrl$AppUrl, _List_Nil, $elm$core$Dict$empty, $elm$core$Maybe$Nothing),
		A2(
			$elm$core$Maybe$map,
			function (url) {
				return _Utils_update(
					url,
					{U4: $elm$core$Maybe$Nothing});
			},
			A2(
				$elm$core$Maybe$map,
				$lydell$elm_app_url$AppUrl$fromUrl,
				$elm$url$Url$fromString(flags.eq))));
	return _Utils_Tuple2(
		{
			ng: flags.ng,
			cF: flags.cF,
			rI: flags.rI,
			aC: $author$project$View$Autocomplete$Http$init,
			eq: location,
			B0: flags.B0,
			dd: flags.dd,
			av: $elm$core$Maybe$Just(flags.av)
		},
		$elm$core$Platform$Cmd$none);
};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$VacancyFilterOptionSearch$init = function (flags) {
	var _v0 = $author$project$View$FilterOptionSuggestions$init(flags);
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		{bD: model},
		A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
};
var $author$project$View$FilterOptionSuggestions$FilterOptionAutocompleteMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$Autocomplete$Http$Link = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $author$project$Copy$copy = {fc: 'Over ons', fe: 'Accepteer alles', ff: 'Accepteer noodzakelijke cookies', fg: 'Accordion (enkel)', fh: 'Accordion start in open positie', fi: 'Accordion (groep)', fl: 'Actie uitgevoerd', fm: 'Soort actie', fn: 'Gesprek', fo: 'Standaard', fp: 'Review', fq: 'Acties', fs: 'Stel job alert in', ft: 'Actieve sollicitaties', fv: 'Actieve gebruikers', fw: 'Actieve vacatures', fx: 'Aantal actieve vacatures', fy: 'Activiteit', fz: 'Voeg toe', fA: 'Voeg een aria label toe', fB: 'Voeg toe', fC: 'Notitie toevoegen\n    ', fD: 'Voeg contract toe', fE: 'Voeg CTA kaart toe', fF: 'Upload je cv', fG: 'Voeg extra beschrijving toe', fH: 'Voeg formuliervelden toe', fI: 'Voeg icoon toe', fJ: 'Voeg een extra item toe', fK: 'Voeg jouw motivatie toe', fL: 'Upload je motivatie', fM: 'Voeg nieuwe categorie toe', fN: 'Voeg nieuw organisatieonderdeel toe', fO: 'Voeg extra organisatiekenmerk toe', fP: 'Telefoonnummer', fQ: 'Voeg stap toe', fR: 'Voeg salariscalculator toe', fS: 'Voeg toe aan checkout', fT: 'Voeg nieuwe gebruiker toe', fU: 'Voeg gebruikers toe', fV: 'Voeg extra vacaturekenmerk toe', fW: 'Voeg file toe', fX: 'Voeg een nieuwe versie toe', fZ: 'Upload document (1)', f_: 'Kies bestand', f$: 'Upload document (2)', f0: 'Kies bestand', f2: 'Adres ongeldig', f3: 'Adres', f4: 'Adres (met autofill)', f5: 'Aanpassen:', f6: 'Pas SEO informatie aan', f9: 'Afghanistan', ga: 'Afrika', gb: 'Na vacature kaart nummer', gc: 'Middag', gd: 'Leeftijd', ge: 'Aland-eilanden', gf: 'Albanië', gg: 'Algerije', gh: 'Onder', gi: 'Midden', gj: 'Uitvullen', gm: 'Links', gn: 'Rechts', gp: 'Boven', gq: 'Alle', gr: 'Gebruiker heeft autorisatie voor alle organisatiekenmerken in dit domein.\n    ', gs: 'Gebruiker heeft autorisatie voor alle organisatiekenmerken in de categorie {0}.', gt: 'Gebruiker heeft autorisatie voor alle locaties.', gu: 'Alle gebruikers uit het bestand kunnen succesvol geüpload worden.', gv: 'Alle vacatures', gw: 'Alle vacatures voor', gz: 'Toegestaan in de volgende kolommen', gA: 'Toegestaan in de volgende groepen', gE: 'Alternatieve styling', gF: 'Amerika', gG: 'Amerikaans Samoa', gH: 'Analytics', gI: 'Google Analytics (GA3)', gK: 'Anchor link', gL: 'En', gM: 'en/of', gN: 'Andorra', gO: 'Angola', gP: 'Anguilla', gQ: 'Antigua en Barbuda', gW: 'Appetizer', gX: 'Appetizer overschrijven', gY: 'Apple mail', gZ: 'Totale aantal Apple mail gebruikers.', g_: 'Journey', g$: 'Journeys (slider)', g0: 'Journeys (slider)', g1: 'Applicant journey met hover', g2: 'Journeys (tabs + video)', g3: 'Journeys (tabs)', g4: 'Sollicitatie', g5: 'Actie', g6: 'Actie verwijderd', g7: 'Acties', g8: 'Sollicitaties succesvol bijgewerkt', ha: 'Dit sollicitatieformulier wordt gebruikt door een vacature', hc: 'Sollcitatieformulier bekeken', hd: 'Sollicitatie funnel', he: 'Funnel van website bezoeken tot aan aangenomen kandidaten', hf: 'Aangenomen', hg: 'Overzicht sollicitaties', hh: 'Templates sollicitatiepagina', hi: 'Sollicitatieprocedure verwijderd', hk: 'Sollicitatieproces', hl: 'Voorbeeld titel', hm: 'Sollicitatieproces opgeslagen.', hn: 'Solicitatie stap', ho: 'Sollicitatieproces stappen', hp: 'Sollicitatieprocedure', hq: 'Sollicitatieproces', hr: 'Afgewezen', hs: 'Sollicitatie gestart', ht: 'Sollicitatie status', hu: 'Sollicitatiestatussen', hv: 'Type sollicitatie', hw: 'Sollicitaties', hx: 'Sollicitaties vorige periode', hy: 'sollicitaties per pagina', hz: 'Sollicitatie op vacature', hA: 'Solliciteer direct', hB: 'Sollicitatie button overschrijven', hC: 'Sollicitatiedatum', hD: 'Toepassen filters', hE: 'Solliciteer op deze vacature', hF: 'Banner met sollicitatieformulier', hG: 'Solliciteer op passende vacatures', hH: 'Banner met sollicitatiepagina', hI: 'Dit template geld voor:', hJ: 'Apply url', hK: 'Solliciteer via', hL: 'Goedgekeurd', hN: 'Gearchiveerd op:', hO: 'Weet je zeker dat je dit item wilt verwijderen?', hQ: 'Argentinië', hR: 'Een aria label bevordert de toegankelijkheid van de site wanneer de bezoeker hulpmiddelen zoals een screenreader gebruikt. De aria label is hetgeen wat voorgelezen wordt aan de bezoeker.', hS: 'Armenië', h4: 'Aruba', h5: 'Azië', h6: 'Vraag naar de locatie?', h8: 'Toewijzen aan', h9: 'Toegewezen aan', ia: 'Minstens één van', ib: 'Minimaal een versie vereist', ic: 'om', $8: 'Bijlage (optioneel)', ih: 'Product id', ij: 'Audio', ik: 'Australië', Ug: 'Oostenrijk', il: 'We hebben jouw verzoek ontvangen', $9: 'Auteur', io: 'Voeg auteur toe', ip: 'Autorisatie', iq: 'Automatisch afspelen', ir: 'Als dit veld aanstaat speelt de video automatisch af zonder geluid en word de thumbnail niet getoond.', is: 'Bepaal automatisch op basis van de achtergrond kleur', iu: 'Beschikbaarheid (dagdeel)', iv: 'Beschikbaarheidsmatrix', iw: 'Beschikbare dagdelen', iy: 'Gemiddeld aantal sollicitaties in deze periode:', iz: 'Gemiddelde sessie duur', iA: 'Azerbeidzjan', iM: 'Onverwachte response body', iN: 'Het decoden van de response body is niet gelukt.', iO: 'Ongeldig verzoek', iP: 'Bad Url', iQ: 'Bahamas', iR: 'Bahrein', iS: 'Balans', iT: 'Bangladesh', iU: 'Banner (Afbeelding)', iV: 'Banner (buttons)', iW: 'Banner (met doorklik)', iX: 'Hoe wil je de media in de banner uitlijnen?', i_: 'Banner locatie zoeken (afbeelding)', i$: 'Banner locatie zoeken (afbeelding)', i0: 'Banner locatie zoeken (afbeelding)', i1: 'Banner zoeken (afbeelding)', i3: 'Vacaturebanner', i4: 'Banner boven vacature met appetizer', i5: 'Banner vacature met recrubo', i6: 'Vacaturebanner (uitklap form)', i7: 'Ik ken iemand', i8: 'Banner (Video)', i9: 'Banner locatie zoeken (video)', ja: 'Banner locatie zoeken (video)', jc: 'Banner zoeken (video)', jd: 'Barbados', jg: 'Basisinstellingen', jh: 'BCC', ji: 'Wit-Rusland', Ui: 'België', jj: 'Belize', jk: 'Benin', jl: 'Bermuda', jm: 'Better uptime', js: 'Bhutan', jt: 'Fiets', ju: 'Facturering', jA: 'Bolivia', jD: 'Bosnië-Herzegovina', jF: 'Botswana', jG: 'Bouncepercentage', jH: 'Bounces', jI: 'Brazilië', jJ: 'Pagina titel', jK: 'Kruimelpad', jL: 'Brits-Indisch oceaan gebied', jM: 'Britse Maagdeneilanden', jN: 'Browse media', jQ: 'Analytics data per browser', jR: 'Browsers', jS: 'Browsers / Sollicitaties', jT: 'Brunei', jU: 'Bulgarije', jV: 'Kies actie op geselecteerde sollicitaties:', jW: 'Verstuur e-mail(s)', jX: 'Burkina Faso', jY: 'Burundi', jZ: 'Button', j_: 'Knop link', j0: 'Te voet', j2: 'Bereken salaris', j4: 'Cambodja', j5: 'Kameroen', j6: 'Campagne', j8: 'Campagne id', j9: 'Campagne', ka: 'Campagne status', kb: 'Campagnes', kc: 'Sollicitaties informatie per campagne', kd: 'Canada', Un: 'Annuleren', ke: 'Deze categorie kan niet verwijderd worden, aangezien er nog onderliggende organisatie kenmerken actief zijn.<br><br>Verwijder eerst de onderliggende organisatie kenmerken voordat deze categorie verwijderd kan worden.', kf: 'Deze categorie kan niet verwijderd worden, aangezien er nog onderliggende vacature kenmerken actief zijn.<br><br>Verwijder eerst de onderliggende vacature kenmerken voordat deze categorie verwijderd kan worden.', kg: 'De volgende gebruikers kunnen niet geüpload worden:', kh: 'Kaapverdië', ki: 'Ondertiteling', kj: 'Auto', kk: 'Kaart', kl: 'Aantal kaarten om te tonen', kn: 'Kaarten (slider)', ks: 'Caribisch Nederland', kt: 'Categorie', ku: 'Beheer categorieën', kv: 'Sortering onderliggende vacaturekenmerken op basis van', kw: 'Type categorie', kx: 'Kaaiman Eilanden', ky: 'Midden', kz: 'Centraal Afrikaanse Republiek', kA: 'Tsjaad', kB: 'Wijzig', kC: 'Wijzig toegewezen aan', kD: 'Wijzig categorie', kE: 'Wijzigingsdatum', kF: 'Wijzig bestand', kG: 'Wijzig gegevens uit import', kH: 'Wijzig organisatieonderdeel', kI: 'Wijzig de status van de vacature', kJ: 'Kies welke actie je wilt uitvoeren:', kK: 'Wijzig de status van de sollicitatie', kL: 'De status van de sollicitatie zal als volgt wijzigen:', kM: 'De status van de vacature zal als volgt wijzigen:', kN: 'Wijzig status', kP: 'Gewijzigd van import', kQ: 'Kanalen', kU: 'Checkout', kW: 'Chili', Us: 'China', kX: 'Kies een tekstkleur', kY: 'Kies actie', kZ: 'Kies een type categorie', k_: 'Kies communicatie', k$: 'Kies component', k0: 'Kies een custom component', k1: 'Kies nieuw bestand', k2: 'Kies vakgebied', k3: 'Kies bestand', k4: 'Kies groep(en)', k5: 'Kies interviewer(s)', k6: 'Kies locatie', k7: 'Kies optie(s) voor', k8: 'Kies bovenliggende categorie', k9: 'Kies persoon', la: 'Kies vacature', lb: 'Kersteiland', lc: 'Chrome', ld: 'Totale aantal Chrome gebruikers.', le: 'Stad', lg: 'Woonplaats', lh: 'Voer je woonplaats in', li: 'Woonplaats', lj: 'Woonplaats', lk: 'Leeg', ll: 'Wis periode', lm: 'Verwijder selectie', ln: 'Klik om te verwijderen', lp: 'Geklikt', lq: 'Totaal aantal aangeklikte links. Dit totaal omvat ontvangers die meerdere keren op links in uw e-mail hebben geklikt.', ls: 'Sluiten', lt: 'Sluit submenu', lu: 'Sluit vacature', lv: 'Gesloten', lw: 'Afgeronde sollicitaties', lx: 'Gesloten vacatures', ly: 'Sollicitatie aangemaakt', lz: 'Sollicitatie beoordeeld', lA: 'Sollicitatiestatus', lB: 'Statussen', lC: 'Sollicitatie aangepast', lD: 'Extra document', lE: 'Motivatie', lF: 'Curriculum vitae', lG: 'Cocos (Keeling) -ilanden', lJ: 'Colombia', lK: 'Kleur', lL: 'Kolom', lM: 'Kolommen', lN: 'Opmerking (optioneel)', lO: 'Notitie toegevoegd', lP: 'Beste {{sollicitatieToegewezenVoornaam}},<br><br>{{gebruikerVoornaam}} heeft een opmerking geplaatst bij de sollicitatie van {{sollicitantVoornaam}} {{sollicitantAchternaam}} ({{vacatureTitel}}):<br><br>{{opmerking}}<br><br>{{{sollicitatieLink}}}', lQ: 'Opmerking geplaatst', lR: 'Opmerking geplaatst bij {{sollicitantVoornaam}}', lS: 'Notitie verwijderd', lT: 'Voeg notitie toe', lU: 'Communicatie', lV: 'Communicatie verstuurd', lW: 'Inhoud', lX: 'Titel communicatie', lY: 'Onderwerp e-mail', lZ: 'Comoros', l$: 'Compleet', l1: 'Concept', l2: 'Bevestiging sollicitatie', l3: 'Beste {{sollicitantVoornaam}},<br><br>Bedankt voor je interesse in {{bedrijfsnaam}} en jouw sollicitatie op de functie van {{vacaturetitel}} op {{sollicitatiedatum}}.<br><br>We gaan je sollicitatie goed bekijken. Uiterlijk binnen twee weken krijg je een inhoudelijke reactie.<br><br>Voor vragen kun je natuurlijk altijd contact opnemen via onderstaande gegevens.<br><br>Met vriendelijke groet,<br><br>{{vacatureToegewezenVoornaam}} {{vacatureToegewezenAchternaam}}<br>{{vacatureToegewezenTelefoonnummer}}<br>{{vacatureToegewezenEmail}}', l4: 'Bevestiging sollicitatie', l5: 'Jouw sollicitatie bij {{bedrijfsnaam}}', l6: 'Bevestig verwijderen', l7: 'Congo', mb: 'Contactformulier', mc: 'Contactpersoon', me: 'Naam contactpersoon', mf: 'Contactpersoon bij vacature', cv: 'Content', mg: 'Content', mh: 'Content (slider)', mi: 'Contract informatie', mj: 'Contracttype', mk: 'Contracten', ml: 'Cook Islands', mm: 'Alleen noodzakelijke cookies', mn: 'Accepteren', mo: 'Weigeren', mp: 'Accepteer geselecteerde cookies', mq: 'Deze website maakt gebruik van cookies', mr: 'Wij, en derde partijen, maken op onze website gebruik van cookies. Wij gebruiken cookies om ervoor te zorgen dat onze website goed functioneert, om jouw voorkeuren op te slaan, om inzicht te verkrijgen in bezoekersgedrag, maar ook voor marketing en social media doeleinden (laten zien van gepersonaliseerde advertenties). Door op ‘Accepteren’ te klikken, ga je akkoord met het gebruik van alle cookies. In onze Cookieverklaring kun je meer lezen over de cookies die wij gebruiken en kun je jouw voorkeuren opslaan of wijzigen.  Door ‘Weigeren’ te klikken ga je alleen akkoord met het gebruik van functionele cookies.', ms: 'Cookies', mt: 'Kopieer', mu: 'Kopieer de inhoud van een bestaande pagina', mv: 'Kopieer de inhoud van een bestaande vacature (optioneel)', mw: 'Kopieer de preview url', mC: 'Corporate site', mF: 'Costa Rica', mH: 'Land', mI: 'Voer land  in', mJ: 'Aanmaken', mK: 'Maak evenement', mL: 'Voeg nieuw formulier toe', mM: 'Nieuwe groep', mN: 'Groep succesvol aangemaakt', mO: 'Voeg media tag toe', mP: 'Maak nieuwe aan...', mQ: 'Maak nieuwe vacature aan', mR: 'Voeg nieuws toe', mS: 'Maak nieuwsitem', mT: 'Voeg ShareTool tag toe', mU: 'Maak een social media-item', mV: 'Voeg tag toe', mW: 'Voeg tag toe', mX: 'Voeg template toe', mY: 'Nieuwe gebruiker', mZ: 'Upload CSV bestand', m_: 'Gebruikers succesvol geimporteerd.', m$: 'Pas op je overschrijft de groepen van users die al bestaan', m0: 'Gebruiker successvol aangemaakt', m1: 'Aangemaakt op', m2: 'Aanmaakdatum', m3: 'Kroatië', m4: 'Details', m5: 'CSS', m7: 'CSS bestand', m9: 'CTA kaart', na: 'CTA in button', nd: 'Cuba', ne: 'Curacao', nf: '€', nh: 'Huidige periode', ni: 'Grafiek van gebruikers en sollicitaties over de huidige periode', nj: 'Huidige titel', nk: 'Huidige tablad', nm: 'Custom categorie', no: 'Custom', np: 'Hoe ben je hier gekomen?', nq: '', ns: 'Custom spacer', nu: 'Cyprus', nv: 'Tsjechische Republiek', nx: 'Zwarte tekst', ny: 'Dashboard', nz: 'Gegevens', nA: 'Datum', nB: 'Datum en tijd', nC: 'Geboortedatum', nD: 'Geboortedatum buiten bereik', nE: 'Voer je geboortedaags in', nF: 'en/of filter op datum sollicitatie:', nG: 'van', nH: 'tot', nK: 'Dagdeel beschikbaarheid omschrijving', nL: 'Dagdeel beschikbaarheid', nN: 'Dagen om te verwerken', nO: 'Dagen om in te stellen', nP: 'Gebruiker succesvol gearchiveerd', nQ: 'Standaard', nR: 'Default communicatie', nS: 'Standaard', nV: 'U hoeft geen filters te selecteren. Deze template wordt automatisch gebruikt wanneer geen andere templates overeenkomen.', UJ: 'Verwijder', nX: 'Verwijder categorie', nY: 'Verwijder notitie', nZ: 'Verwijder evenement', n_: 'Verwijder Event tag', n$: 'Verwijder file', n0: 'Verwijder mediatag', n1: 'Mediatag verwijderd', n2: 'Verwijder nieuwsitem', n3: 'Verwijder nieuws tag', n4: 'Verwijder organisatieonderdeel', n5: 'Verwijder pagina', n6: 'Delen Tool Tag verwijderen', n7: 'Succesvol verwijderd Delen Tool Tag', n8: 'Status verwijderen', n9: 'Stap verwijderen', oa: 'Verwijder tag', ob: 'Verwijder template', oc: 'Verwijder UBEEO Vacatures', od: 'UBEEO vacatures verwijderd', oe: 'Weet je zeker dat je deze gearchiveerde gebruiker wilt verwijderen? De gebruiker zal met deze actie compleet verwijderd zijn en zal een \'verwijderde gebruiker\' worden.', of: 'Gebruiker verwijderen', og: 'Verwijder vacaturekenmerk', oh: 'Verwijder versie', oi: 'Verwijderd', oj: 'Bezorgd op', UK: 'Denemarken', ok: 'Afdeling', cD: 'Beschrijving', ol: 'Beschrijving 7', om: 'Beschrijving 5', on: 'Beschrijving 4', oo: 'Beschrijving 1', op: 'Voeg beschrijving toe', oq: 'Beschrijving 7', or: 'Beschrijving 6', os: 'Beschrijving 3', ot: 'Beschrijving 2', ou: 'Desktop', ov: 'Totale aantal desktop gebruikers die op de link hebben geklikt in de email.', ow: 'Totale aantal desktop gebruikers die de email hebben geopend.', ox: 'Vacature', oz: 'Detail url', oA: 'Details', oB: 'Apparaat', oD: 'Apparaten', oE: 'Apparaten / Sollicitaties', oF: 'Sollicitaties onderverdeeld per apparaat', oG: 'Het is niet mogelijk om een actie uit te voeren. Check of de sollicitant een emailadres heeft en is gekoppeld aan een vacature.', oH: 'Vakgebied', oI: 'Welk vakgebied behoort tot deze pagina?', oJ: 'Vakgebied(en)', oK: 'Disclaimer', oN: 'Afstand in kilometer', oQ: 'Djibouti', oU: 'Domein', oX: 'Dominica', oY: 'Dominicaanse Republiek', oZ: 'Download voorbeeld CSV', o_: 'Download jobalert aanmeldingen', o$: 'Concept', o0: 'Drag & Drop', o1: 'Dupliceren', o2: 'Looptijd', o4: 'Nederlands', o5: 'Dynamische titel', o6: 'Ecuador', o7: 'Edge', o8: 'Totale aantal Edge gebruikers.', o9: 'Wijzig', pa: 'Wijzig vacaturekenmerk', pb: 'Edit pagina', pc: 'Wijzig CTA kaart', pd: 'Pas de items in de lijst aan', pe: 'Nieuwsbericht aanpassen', pf: 'Nieuwsbericht aanpassen', pg: 'Edit nieuws tags', ph: 'Wijzig versienaam', pj: 'Editor', pk: 'Opleiding', pl: 'Opleidingsniveau', pm: 'Welk opleidingsniveau behoort tot deze pagina?', pn: 'Egypte', po: 'El Salvador', d4: 'E-mail', pq: 'E-mailadres', pr: 'hallo@example.com', pt: 'Email clients', pu: 'Alleen e-mailadressen eindigend op {0} mogen worden toegevoegd', pv: 'E-mailadres al in gebruik', pw: 'E-mailadres al in gebruik bij andere afkomst', px: 'E-mail (extern)', pz: 'Graag een geldig e-mailadres invullen.', pA: 'Heb je problemen met bovestaande knop? Kopieer dan de volgende URL en plak deze in je web browser.', pC: 'Heb je hulp nodig? Bekijk onze documentatie:', pD: 'Inloggen', pE: 'Met hartelijke groet,', pF: '<p>Je wilt graag toegang tot jouw account van Hamilton CMS. Door de volgende stappen te volgen zou dit eenvoudig moeten zijn:<p><ul><li>Klik op onderstaande \'Inloggen\' button</li><li>Wanneer je op de button klikt, wordt je automatisch doorgestuurd naar de unieke link waar je een code kan invoeren</li><li>Voer de code in die per SMS naar jouw mobiele nummer is verstuurd</li><li>Je wordt automatisch naar jouw account tot Hamilton CMS doorgestuurd</li></ul><p>Veel plezier met het gebruik van Hamilton CMS!</p>', pG: 'Mocht je geen SMS hebben ontvangen, dan kan het zijn dat bij ons een ander mobiel nummer bekend is. Neem dan contact op met de beheerders van Hamilton CMS binnen jouw organisatie.', pH: 'Login bij Hamilton CMS', pI: 'E-mail wachtwoord', pM: 'Inloggen', pN: 'Hartelijke groet', pO: 'Je bent uitgenodigd om Hamilton CMS te gebruiken. Gebruik onderstaande button om te beginnen.', pP: 'Je bent uitgenodigd', pQ: 'emails zijn gebounced.', pR: 'Embedded chat', UN: 'Emea', pS: 'Werknemer', pT: 'Werknemers content', pU: 'Gedeelde content (share tool)', pW: 'Content info', p_: 'Naam van de medewerker', p$: 'Werknemer-ID', p0: 'Scores medewerkers', p1: 'Werknemer scores', p2: 'Soort dienstverband', p5: 'Leeg', p6: 'Leeg', p7: 'Achtergrondkleur', p8: 'Voeg een spacer toe aan de onderkant', p9: 'Toon filter in vacature overzicht', qc: 'Sluit op', qd: 'Engels', qe: 'Enter details...', qf: 'Equatoriaal-Guinea', qg: 'Eritrea', bL: 'Error', qh: 'Deze pagina bestaat niet.', qi: 'Interne server error.', qj: 'Neem contact op met de interne beheerder(s) van Hamilton CMS.', qk: 'Je bent niet geautoriseerd om deze sollicitatie te bekijken.', ql: 'Foutieve invoer melding', qm: 'Veld verplicht melding', qn: 'Estland', qo: 'Eswatini', qp: 'Ethiopië', qq: 'Europa', qr: 'Avond', qs: 'Evenement', qu: 'Details evenement', qw: 'Overzicht evenementen', qx: 'Evenement', qy: 'Evenement opgeslagen', qz: 'Event tag toegevoegd', qA: 'Event tag aangepast', qB: 'Event tags', qC: 'Evenementen', qD: 'Alles', qE: 'Voorbeeld template titel', qF: 'Geef aan welke vacatures niet getoond mogen worden in het vacature overzicht op basis van de vacature kenmerken', qH: 'Uitsluiten kenmerk in vacature-overzicht', qN: 'ATS', qO: 'Extern id', qP: 'Externe titel', qQ: 'Vacaturekenmerken', qR: 'Selecteer banner-afbeeldingen in vacature', qS: 'Content', q$: 'Extra gegevens', q0: 'Extra groot (80px)', q2: 'Medewerkers tooling', q4: 'Factor om het berekende salaris mee te vermenigvuldigen als de ingevulde uren lager zijn dan 12', q5: 'Notitie toevoegen mislukt', q6: 'Verwijderen notitie mislukt', q7: 'Falkland Eilanden', q8: 'FaroElands', q9: 'Favicon', ra: 'Sla de vacature op in je favorieten', rc: 'Bekijk mijn favoriete vacatures', rd: 'Favorieten overzicht', rg: 'Feedback', rh: 'Veld-ID\'s moeten uniek zijn', ri: 'Veld ontbreekt uit webformulier', rj: 'Veldopties', rk: 'Dit is een verplicht veld', rl: 'Dit veld is vereist door het systeem', ro: 'Fiji', rr: 'Bestandsnaam', rs: 'Graag een bestand toevoegen.', rt: 'Bestandsgrootte', ru: 'Dit bestand is groter dan het maximale formaat.', rv: 'Selecteer een niet leeg bestand.', rw: 'Fout bij het wegschrijven van bestand', ry: 'Vul het aantal secondes in', rz: 'Filter', rA: 'Filter op type kenmerk', rB: 'Filter op evenement', rC: 'Filter op groep:', rD: 'Filter op tag:', rE: 'Filter content', rF: 'Filter content per device', rL: 'Filter op:', rM: 'Filteroptie verwijderd', rS: 'Filter inschrijvingen', rT: 'Filter scores', rU: 'Filter zoekbalk', rV: 'Filteropties', rW: 'Filter resultaten', rX: 'Afgeronde sollicitaties', U_: 'Finland', rY: 'Firefox', rZ: 'Totale aantal Firefox gebruikers.', r_: 'Eerste kleur', r$: 'Eerste weergave', r0: 'Stuur uitnodiging eerste gesprek', r2: 'Eerste betekenisvolle weergave', r3: 'Voornaam', r5: 'Voornaam', r6: 'Vul je voornaam in', r9: 'Kaarten (uitklap)', sa: 'Positie in footer (nummer)', bP: 'Formulier', sd: 'Formulier verwijderd', se: 'Het versturen van het formulier is mislukt', sg: 'Formulier wordt gebruikt door een component. Verwijder deze eerst.', sh: 'Vorm bestaat niet', si: 'Overzicht formulieren', sl: 'Formulieren', sm: 'Vierde kleur', U5: 'Frankrijk', sn: 'Frans-Guyana', so: 'Frans-Polynesië', sp: 'Vrijdag', sq: 'Vr', sr: 'Van', ss: 'Start kleur', sv: 'Parttime/Fulltime', sx: 'Functioneel', sy: 'Functionele cookies zorgen ervoor dat deze website informatie kan onthouden die van invloed is op het gedrag en de vormgeving van de website, zoals bijvoorbeeld welke vacatures jouw favorieten zijn.', sz: 'Functies', sA: 'Gabon', sB: 'Gambia', sD: 'Georgië', U7: 'Duitsland', sE: 'Ghana', sF: 'Gibraltar', U8: 'Global', sK: 'Gmail', sL: 'Ga terug', sM: 'Terug naar', sN: 'Ga naar de bedrijfswebsite', sO: 'Ga naar mijn persoonlijke pagina', sP: 'Terug naar vorige pagina', sQ: 'Toon gearchiveerde gebruikers', sR: 'Toon actieve gebruikers', sS: 'Terug naar alle vacatures', sT: 'Goede lengte', sV: 'Google Analytics (GA4)', sZ: 'Grades bachelor 1', s_: 'Kies bestand', s$: 'Grades bachelor 2', s0: 'Kies bestand', s1: 'Grades master 1', s2: 'Kies bestand', s3: 'Grades master 2', s4: 'Kies bestand', Vc: 'Verenigd Koninkrijk', s5: 'Griekenland', ta: 'Groenland', tb: 'Grenada', tc: 'Groep', td: 'Groep verwijderd', te: 'Een groep kan niet verwijderd worden als er zich nog actieve of gearchiveerde gebruikers in bevinden. Zorg eerst dat geen gebruikers meer aan deze groep gekoppeld zijn voordat deze verwijderd kan worden.', tg: 'Groepen', th: 'Groep succesvol opgeslagen', ti: 'Groepen', tj: 'Guadeloupe', tk: 'Guam', tl: 'Guatemala', tm: 'Guernsey', tn: 'Guinea', to: 'Guinee Bissau', tq: 'Guyana', tr: 'Haïti', ts: 'Hamilton id', tt: 'Hardbounces', tu: 'Geeft een permanent error aan, maar kan ook veroorzaakt worden door een security email filter.', tv: 'Afbeelding', tw: 'Content', tz: 'Positie in header (nummer)', tA: 'Titel', tB: 'Heading', tH: 'Systeem gebruiker', cM: 'Toon label visueel niet', tI: 'Verberg het label', tJ: 'Als dit veld aan staat wordt het label van het formulier veld niet getoond', tN: 'Extra filter switch', tP: 'Afgerond', tQ: 'Succesvol afgerond', tR: 'Hiring manager', tT: 'Hiring manager portal', tV: 'De Homepage is verplicht in de sitemap.', tX: 'Honduras', tY: 'Hong Kong', t$: 'uur', t0: 'Urenrange', t1: 'uren', t2: 'Hoeveel uur wil je werken?', t4: 'Maximaal aantal uren', t5: 'Minimaal aantal uren', t9: 'huisnummer', ua: 'Voer je huisnummer in', ub: 'huisnummer', uc: 'huisnummer', ui: 'Begin de url met http:// of https://', ec: 'HTML', uj: 'Aspect ratio', uk: 'Gebruik een aspect van 16:9 voor de html, handig voor iframe\'s', ul: 'Aspect Ratio is de verhouding tussen breedte en hoogte van de afbeelding.', um: 'Hoogte van html container instellen (px)', un: 'Zet de hoogte op 0 om automatisch de hoogte van de html te bepalen', uo: 'Html source', up: 'Http error', ur: 'Hongarije', us: 'Ik accepteer de', ut: 'IJsland', aH: 'Icoon', uu: 'Icoon kleur', cO: 'Id', uw: 'Iframe', ux: 'Afbeelding', uz: 'Afbeelding', uB: 'Afbeeldingen', uC: 'Import', uE: 'In proces', uF: 'In behandeling', uG: 'In review', uP: 'India', uQ: 'Indonesië', uR: 'Industrieën', uS: 'Industrie', uU: 'Loop items oneindig', Vg: 'Informatie', u0: 'Onvoldoende saldo om uit te checken', u3: 'Interne sollicitatie', u4: 'Ik werk hier', u5: 'Interne pagina\'s kunnen niet in de sitemap zijn.', u6: 'Interne recruitmentsite', u8: 'Internship evaluation 1', u9: 'Kies bestand', va: 'Internship evaluation 2', vb: 'Kies bestand', vc: 'Interviewer(s)', vd: 'Introductie', ve: 'Introductie tekst', vf: 'Ongeldig verzoek', vg: 'Ongeldig bestandsformaat', vh: 'Ongeldige LinkedIn URL', vi: 'Ongeldig menu', vj: 'Ongeldig telefoonnummer', vk: 'Ongeldige screeningsvraag', vl: 'Url moet starten met een /', vm: 'Url moet starten met een /', vn: 'Geselecteerde optie is ongeldig', vo: 'Ongeldige template', vp: 'Ongeldige URL', vq: 'Ongeldige vacature', vr: 'Ongeldige Xing url', vs: 'Stuur uitnodiging assessment', vt: 'Beste {{sollicitantVoornaam}},<br><br>Graag nodigen wij je uit voor een assessment als volgende stap in onze selectieprocedure.<br><br>Details van het assessment:<br><br>Datum: {{uitnodigingTijdstip}}<br>Locatie: {{locatieAdres}}, {{locatiePostcode}} {{locatieStad}} / of online via…<br>Duur: 1,5 tot 2 uur<br><br>Tijdens het assessment krijg je de kans om je vaardigheden en competenties te laten zien die relevant zijn voor de functie. We zullen (kort uitleggen wat het assessment inhoudt, bijvoorbeeld: een cognitieve test, een praktijkopdracht of een rollenspel).<br><br>Indien je verhinderd bent of deze datum en tijdstip niet tot jouw mogelijkheden behoort in je agenda neem dan even contact met ons op via onderstaande gegevens.<br><br>We kijken uit naar je deelname en wensen je alvast veel succes!<br><br>Met vriendelijke groet,<br><br>{{sollicitatieToegewezenVoornaam}} {{sollicitatieToegewezenAchternaam}}<br>{{sollicitatieToegewezenTelefoonnummer}}<br>{{sollicitatieToegewezenEmail}}', vu: 'Uitnodiging assessment', vv: 'Uitnodiging voor assessment', vx: 'Beste {{sollicitantVoornaam}},<br><br>Graag nodigen wij je uit voor een kennismakingsgesprek op {{uitnodigingTijdstip}} bij ons op kantoor met adres:<br><br>{{locatieAdres}}<br>{{locatiePostcode}} {{locatieStad}}<br><br>Je zal het gesprek hebben met {{interviewerNaam}}.<br><br>Indien je verhinderd bent of deze datum en tijdstip niet tot jouw mogelijkheden behoort in je agenda neem dan even contact met ons op via onderstaande gegevens.<br><br>We kijken uit naar het gesprek!<br><br>Met vriendelijke groet,<br><br>{{sollicitatieToegewezenVoornaam}} {{sollicitatieToegewezenAchternaam}}<br>{{sollicitatieToegewezenTelefoonnummer}}<br>{{sollicitatieToegewezenEmail}}', vy: 'Uitnodiging 1e gesprek', vz: 'Uitnodiging kennismakingsgesprek', vA: 'Stuur door voor review', vB: 'Beste {{interviewerVoornaam}},<br><br>Hierbij stuur ik je deze sollicitaties(s) door ter beoordeling:<br><br>{{{reviewLinks}}}<br><br>Mijn opmerking:<br><br>{{opmerking}}<br><br>Met vriendelijke groet,<br><br>{{gebruikerVoornaam}} {{gebruikerAchternaam}}<br>{{gebruikerTelefoonnummer}}<br>{{gebruikerEmail}}', vC: 'Stuur door voor review', vD: 'Review sollicitant(en)', vE: 'Beste {{sollicitantVoornaam}},<br><br>Graag nodigen wij je uit voor een vervolggesprek op {{uitnodigingTijdstip}} bij ons op kantoor met adres:<br><br>{{locatieAdres}}<br>{{locatiePostcode}} {{locatieStad}}<br><br>Je zal het gesprek hebben met {{interviewerNaam}}.<br><br>Indien je verhinderd bent of deze datum en tijdstip niet tot jouw mogelijkheden behoort in je agenda neem dan even contact met ons op via onderstaande gegevens.<br><br>We kijken uit naar het gesprek!<br><br>Met vriendelijke groet,<br><br>{{sollicitatieToegewezenVoornaam}} {{sollicitatieToegewezenAchternaam}}<br>{{sollicitatieToegewezenTelefoonnummer}}<br>{{sollicitatieToegewezenEmail}}', vF: 'Uitnodiging 2e gesprek', vG: 'Uitnodiging vervolggesprek', vH: 'Iran', vI: 'Irak', vJ: 'Ierland', vL: 'Actief', vQ: 'Uitklappen', vS: 'Laat deze pagina zien in het submenu van pagina', vT: 'Is dit een leuke baan voor jou?', vU: 'Eiland van de mens', vW: 'Israël', vZ: 'Italië', v1: 'Ivoorkust', v2: 'Jamaica', v3: 'Japan', v4: 'Jersey', v5: 'Job alert', v6: 'Ga naar de job alert pagina', v7: 'Overschrijf job alert button', v8: 'Job Alert Email', v9: 'Job alert email bericht', wa: 'Er zijn vacatures voor {{companyName}} die overeenkomen met jouw job alert.', wb: 'Schrijf hier het bericht voor de email. Dit bericht komt boven de vacatures te staan in de job alert email.', wc: 'Job Alert email instellingen', wd: 'Onderwerp van de email', we: 'Job alerts van {{ companyName }}', wf: 'Jouw job alert voor {{companyName}}', wg: 'Vul het onderwerp voor de job alert email in', wh: 'Job alert email afmeld bericht', wi: 'Hier kan je het email bericht van de job alert aanpassen.\n    Het bericht komt onder de volgende text in de email: Hi {{ voornaam }}.', wj: 'Als je onze job alerts niet meer wil ontvangen, kan je je uitschrijven via deze link', wk: 'Job alert formulier', wl: 'E-mailadres', wm: 'Blijf op de hoogte van relevante nieuwe vacatures', wn: 'Dit sollicitatieformulier is beschermd', wo: 'Dit sollicitatieformulier wordt gebruikt door een template', wp: 'Sollicitatie', wq: 'Bezorgd op', wr: 'Vacaturebezoek', ws: 'Industrie', wt: 'Vacature titel', wu: 'Jordanië', wv: 'Niveau in journey', ww: 'Op welk niveau van de journey zit deze pagina?', wB: 'Uitvullen', wD: 'Kazachstan', wE: 'Kenia', wG: 'Trefwoord en locatie', wH: 'Trefwoord', wI: 'Vacature search', wK: 'Kiribati', wL: 'Kosovo', wM: 'Koeweit', wN: 'Kirgizië', bj: 'Label', wO: 'Dit label is al in gebruik', wP: 'Combinatie van label en fase bestaat al', wQ: 'Voeg een label toe', wR: 'Naam boven veld', wT: 'Domeincode', wU: 'Laos', wV: 'Groot (800px)', wW: 'Grote bestanden op de pagina', wX: 'Groot (40px)', wY: 'Laatste 30 dagen', wZ: 'Laatste 7 dagen', w_: 'Datum laatste actie', w$: 'Laatst ingelogd', w0: 'Vorige maand', w1: 'Achternaam', w3: 'Achternaam', w4: 'Voer je achternaam in', w5: 'Laatste periode', w6: 'Grafiek van gebruikers en sollicitaties over de vorige periode', w9: 'Letland', xk: 'Libanon', cX: 'Links', xl: 'Lesotho', xm: 'Liberia', xn: 'Libië', xo: 'Liechtenstein', xq: 'Witte tekst', xs: 'Log in met het geregistreerde e-mailadres. Toegang is verboden voor onbevoegden.', xt: 'Hiermee kan je potentiële nieuwe collega’s persoonlijk uitnodigen om kennis te maken met jouw bedrijf. Toegang is verboden voor onbevoegden.', xu: 'Hiermee kan je jouw bedrijf helpen om inspirerende content te creëren voor de recruitmentsite. Potentiële nieuwe collega’s kunnen zo zien hoe het is om bij jullie te werken. Toegang is verboden voor onbevoegden.', xv: 'Link', xC: 'Link (Optioneel)', xD: 'Subitem(s) of link naar pagina verplicht', xE: 'Overschrijf link in kaart', xF: 'Link naar pagina verplicht', xG: 'Link tracking', xK: 'LinkedIn URL', xL: 'https://www.linkedin.com/username', xP: 'Litouwen', xQ: 'Live', xR: 'Laden', xS: 'Video bestand', eq: 'Locatie', xW: 'Contactgegevens locatie', xY: 'Alleen locatie', xZ: 'Locatie overzicht', x_: 'Locatie opgeslagen', x$: 'Jouw locatie', x0: 'Type locatie', x1: 'Locatie niet beschikbaar', x4: 'Locatie(s)', x5: 'Inloggen', x6: 'Log in', x7: 'Log in als medewerker', x8: 'Ik ben een kandidaat', x9: 'Log uit', ya: 'Ingelogd als', yb: 'We hebben jouw verzoek ontvangen', yc: 'Logo', yd: 'Logo onder communicatie', yf: 'Uitloggen', Vo: 'Luxemburg', yh: 'Macau', yi: 'Macedonië', yj: 'Madagascar', yk: 'Hoofd navigatie', yl: 'Malawi', ym: 'Maleisië', yn: 'Maldiven', yo: 'Mali', yp: 'Malta', yq: 'Beheer organisatieonderdelen', yr: 'Beheer vacaturekenmerken', ys: 'Handmatige invoer', yt: 'of voer handmatig in', yu: 'Handmatige configuratie vereist', yx: 'Marketing', yy: 'Marketing cookies worden op deze site gebruikt om eventueel video’s via YouTube af te kunnen spelen. Verder ook om relevante advertenties weer te geven tijdens het bezoeken van andere websites.', yz: 'Marshall eilanden', yA: 'Martinique', yC: 'Categorie successvol aangemaakt', yD: 'Categorie successvol verwijderd', yE: 'Categorie successvol aangepast', yH: 'Mauritanië', yI: 'Mauritius', c_: 'Max.', yL: 'Maximum van 5 opties, verwijder een tag om verder te zoeken', er: 'Maximaal aantal uur', yN: 'Als je meerdere bestanden uploadt, probeer dan minder bestanden tegelijk te uploaden.', yO: 'Upload is te groot', yP: 'Maximaal salaris', yS: 'Maximaal', yT: 'Maximale leeftijd', yU: 'Maximale datum', yV: 'Maximale bestandsgrootte', yW: 'Maximale bestandsgrootte in MB', yX: 'Maximum aantal karakters invoer', yY: 'Mayotte', y_: 'Mediaitem verwijderd', y$: 'Mediaitem opgeslagen', y1: 'Media', y2: 'Media', y3: 'Overzicht media', y4: 'Mediatag toegevoegd', y5: 'Mediatag aangepast', y6: 'Media tags', y7: 'Normaal (600px)', y8: 'Normaal (20px)', y9: 'Menu', za: 'Menu editor', zb: 'Lees meer', bp: 'Bericht', zc: 'Metabeschrijving', zd: 'Meta beschrijving gebruikt door zoekmachines', ze: 'De omschrijving is te lang, de maximale lengte is 158 karakters', zf: 'Mexico', zg: 'Micronesië', bX: 'Min.', eu: 'Minimum aantal uur', zl: 'Voeg min-marge toe bij de rij', ev: 'Minimaal salaris', zm: 'Minimale cookies accepteren', zo: 'Wijzigingsdatum', zp: 'Minimaal', zq: 'Minimum leeftijd', zr: 'Minimale datum', zs: 'Minimum aantal karakters invoer', zu: 'Ontbrekende screeningsvraag', zv: 'Mobiel', zw: 'Totale aantal mobiel gebruikers die op de link hebben geklikt in de email.', zy: 'Totale aantal mobiel gebruikers die de email hebben geopend.', zA: 'Wijzigingsdatum', zB: 'Moldavië', zC: 'Monaco', zD: 'Maandag', zE: 'Ma', zF: 'Mongolië', zH: 'Montenegro', zK: 'Montserrat', zL: 'Ochtend', zM: 'Marokko', zO: 'Upload motivatie', zP: 'Upload je motivatie', zQ: 'Schrijf je motivatie', zR: 'Schrijf je motivatie hier', zS: 'Verplaats', zT: 'Mozambique', zU: 'Mijn sollicitaties', zV: 'Mijn vacatures', zW: 'Myanmar', zX: 'naar', c4: 'Naam', zY: 'Deze naam is in gebruik door een andere pagina', zZ: 'Deze naam is al in gebruik', z_: 'Er bestaat al een sollicitatieformulier met deze naam en taal combinatie', z0: 'Namibië', z1: 'Nauru', z2: 'Noodzakelijk', z3: 'Custom min marge', z4: 'Extra groot (-200px)', z5: 'Groot (-100px)', z6: 'Large plus (-150px)', z7: 'Normaal (-60px)', z8: 'Klein (-20px)', z9: 'Nepal', Aa: 'Noodzakelijke cookies worden op deze website alleen gebruikt voor het onthouden van jouw cookie voorkeuren.', Vy: 'Nederland', Ab: 'Network Error', Ac: 'Er is iets misgegaan met de netwerk connectie, probeer het later nog eens.', Ad: 'Nooit ingelogd', Ae: 'Nieuw', Af: 'Nieuwe sollicitatie', Ag: 'Nieuwe actie', Ah: 'Nieuwe sollicitatieprocedure', Ai: 'Nieuw', Aj: 'Nieuw-Caledonië', Ak: 'Nieuwe categorie', Al: 'Voer titel van de categorie in', Am: 'Nieuwe kolom', An: 'Nieuwe communicatie', Ao: 'Nieuw item', Ap: 'Voer titel van het organisatie onderdeel in', Aq: 'Nieuw organisatieonderdeel', Ar: 'Nieuwe pagina', As: 'Nieuwe recruitment chat', At: 'Nieuwe redirect', Au: 'Nieuwe status', Av: 'Voeg een taglabel toe', Aw: 'Nieuw template', Ax: 'Nieuwe titel', Ay: 'Nieuwe gebruikers', Az: 'Nieuwe vacatures', AA: 'Nieuwe vacature', AB: 'Voer titel van het vacaturekenmerk in', AC: 'Voer titel van het vacature kenmerk in', AD: 'Nieuw vacaturekenmerk onder', AE: 'Nieuw vacaturekenmerk', AF: 'Voeg nieuw vacaturekenmerk toe', AG: 'Nieuwe versie', AH: 'Nieuw tablad', AI: 'Nieuw-Zeeland', AJ: 'Nieuws', AK: 'Nieuws kan niet verwijderd worden als het gepubliceerd is', AL: 'Nieuws informatie', AM: 'Nieuwsbericht', AN: 'Nieuwsbericht', AO: 'Nieuwsitem opgeslagen', AP: 'Nieuws', AQ: 'Nieuws items', AR: 'Nieuwsoverzicht', AS: 'Nieuws (overzicht)', AT: 'Overzicht nieuws', AU: 'Nieuws tag toegevoegd', AV: 'Nieuwstag verwijderd', AW: 'Nieuws tag aangepast', AX: 'Nieuws tags', AY: 'Nieuws tags', AZ: 'Groot (40px)', A_: 'Abonneren op de nieuwsbrief', A$: 'Abonneren op de nieuwsbrief', A0: 'Volgende stap', A1: 'Nicaragua', A2: 'Niger', A3: 'Nigeria', A4: 'Nacht', A5: 'Niue', A6: 'Nee', A7: 'Geen sollicitatie gevonden', A8: 'Geen sollicitatie formulier op de pagina', A9: 'Geen sollicitatie procedure gevonden.', Ba: 'Er zijn geen sollicitaties om te tonen', Bb: 'Geen actieve campagnes gevonden', Bc: 'Geen actieve contracten gevonden', Bd: 'Geen medewerkers gevonden', Be: 'Je hebt nog geen medewerkers die iemand hebben aangedragen', Bf: 'Je hebt nog geen medewerkers die content hebben geupload', Bg: 'Geen events gevonden', Bh: 'Je hebt nog geen events. Voeg een event toe om te beginnen.', Bi: 'Geen eventtags gevonden', Bj: 'Je hebt nog geen tags. Voeg een tag toe om te beginnen.', Bk: 'Nog geen feedback', Bl: 'Helaas geen filteroptie suggesties', Bm: 'U hebt geen filters in uw organisatie', Bn: 'Je hebt nog geen filters', Bo: 'Geen groepen gevonden', Bp: 'Geen groepen gevonden. Maak er een aan.', Bq: 'Geen items gevonden', Br: 'Je hebt nog geen items. Begin met het maken van een item.', Bs: 'Helaas geen locatie suggesties', Bt: 'Geen locaties gevonden', Bu: 'Geen handmatige configuratie vereist', Bv: 'Geen margin', Bw: 'Geen media gevonden', Bx: 'Je hebt nog geen bestanden. Voeg een bestand toe om te beginnen.', By: 'Geen mediaitem geselecteerd', Bz: 'Geen media tags gevonden', BA: 'Je hebt nog geen media tags. Maak een media tag aan om te starten.', BB: 'Geen nieuwsitems gevonden', BC: 'Je hebt nog geen nieuwsitems gemaakt. Maak een nieuwsitem aan om te starten.', BD: 'Geen nieuwstags gevonden', BE: 'Je hebt nog geen nieuwstags gemaakt. Maak een nieuwstag aan om te starten.', BF: 'Nog geen nieuwsberichten.', BG: 'Geen open checkout gevonden', BH: 'Er zijn nog geen categorieën binnen de organisatie', BI: 'Geen categorieën in je organisatie gevonden', BJ: 'Er zijn geen organisatie onderdelen binnen de organisatie', BK: 'Geen organisatieonderdelen gevonden', BL: 'Geen pagina\'s beschikbaar', BM: 'Geen pagina\'s gevonden', BN: 'Je hebt nog geen pagina\'s. Voeg een page toe om te beginnen.', BO: 'Geen voorkeur', BP: 'Geen datum bereik', BQ: 'Geen recruiters gevonden', BR: 'Je hebt geen recruiters in uw organisatie.', BS: 'Geen recruitmentchats gevonden', BT: 'Je hebt nog geen recruitmentchats. Voeg een chat toe om te beginnen.', BU: 'Je hebt nog geen redirects', BV: 'Dit domein heeft nog geen ingestelde redirects.', BW: 'Geen referrals gevonden', BX: 'Er zijn nog geen referrals voorgesteld.', BY: 'Geen inschrijvingen gevonden', BZ: 'U hebt nog geen inschrijvingen voor evenementen.', B_: 'Not ok', B$: 'Geen resultaat', B0: 'Geen resultaten bericht', B2: 'Geen salariscalculator gevonden', B3: 'Er is geen salariscalculator beschikbaar binnen je organisatie.', B4: 'Geen salaris calculator geselecteerd', B5: 'Geen sharetool tags gevonden', B6: 'Je hebt nog geen sharetool tags gemaakt. Maak een sharetool tag aan om te starten.', B7: 'Geen tags gevonden', B8: 'Je hebt nog geen tags. Voeg een tag toe om te beginnen.', B9: 'Geen vacature templates gevonden', Ca: 'Je hebt nog geen vacature templates. Voeg een template toe om te beginnen.', Cb: 'Geen transacties gevonden', Cc: 'Geen transomaten gevonden', Cd: 'Geen vertalingen waar gevonden', Ce: 'Geen uploads gevonden', Cf: 'We konden nog geen uploads voor u vinden', Cg: 'Geen gebruikers gevonden', Ch: 'Geen gebruikers gevonden binnen je zoekopdracht', Ci: 'Binnen deze selectie zijn geen vacatures beschikbaar. Verwijder je selectie om verder te gaan.', Cj: 'Geen vacatures beschikbaar binnen je selectie', Ck: 'Geen vacatures gevonden', Cl: 'Er zijn geen vacatures beschikbaar binnen je organisatie.', Cm: 'Geen vacature', Cn: 'Geen vacaturefilter opties gevonden', Co: 'Er zijn vacaturefilter opties beschikbaar binnen de organisatie', Cp: 'Geen vacaturefilters gevonden', Cq: 'Er zijn vacaturefilters beschikbaar binnen de organisatie', Cr: 'Geen vacature geselecteerd voor de preview', Cs: 'Helaas geen vacature suggesties', Ct: 'Norfolk Island', Cu: 'Noord Korea', Cv: 'noordelijke Mariana eilanden', VI: 'Noorwegen', Cw: 'Je bent niet geautoriseerd om sollicitaties te bekijken binnen dit domein.', Cx: 'Je bent niet geautoriseerd om vacatures te bekijken binnen dit domein.', Cy: 'Niet gevonden', Cz: 'Niet verwerkt', CA: 'Niet gepubliceerd', CB: '', CC: 'Verberg WhatsApp button op deze pagina', CG: 'Aantal uur', CH: 'Aantal items te tonen', CI: 'Oceanië', CK: 'Van deze emails,', VP: 'Uit', CM: 'Stuur aanbieding', CN: 'Beste {{sollicitantVoornaam}},<br><br>Met veel plezier delen wij mee dat wij je graag een aanbod willen doen voor de functie van {{vacatureTitel}} bij {{bedrijfsnaam}}! We zijn erg enthousiast over de gesprekken die we hebben gevoerd en geloven dat je een waardevolle aanvulling op ons team zult zijn.<br><br>Hieronder vind je de belangrijkste details van het aanbod:<br><br>Functietitel: {{vacatureTitel}}<br>Startdatum: <br>Salaris: <br>Standplaats: {{locatie}}<br>Contractduur:<br><br>In de bijlage vind je de officiële aanbieding met alle details over het contract en arbeidsvoorwaarden. We willen je vragen om deze zorgvuldig door te nemen. Mocht je vragen hebben of bepaalde zaken willen bespreken, aarzel dan niet om contact met ons op te nemen.<br><br>We hopen natuurlijk dat je enthousiast bent en kijken ernaar uit om je binnen ons team te verwelkomen. Laat ons snel weten of je ons aanbod accepteert.<br><br>We kijken uit naar je reactie!<br><br>Met vriendelijke groet,<br><br>{{sollicitatieToegewezenVoornaam}} {{sollicitatieToegewezenAchternaam}}<br>{{sollicitatieToegewezenTelefoonnummer}}<br>{{sollicitatieToegewezenEmail}}', CO: 'Aanbod contract', CP: 'Ons aanbod voor de functie van {{vacatureTitel}}', CQ: 'Offline', CR: 'Oke', CS: 'Oman', VQ: 'Aan', CW: 'Een van de twee velden verplicht maken', CX: 'Een of meer e-mailadressen bestaan al:', CY: 'Online', CZ: 'Open sollicitatie', C0: 'Selectieveld (4)', C1: 'Extra checkbox 4-tekst', C2: 'Selectieveld (1)', C3: 'Extra checkbox 1-tekst', C4: 'Selectieveld (3)', C5: 'Extra checkbox 3-tekst', C6: 'Selectieveld (2)', C7: 'Extra checkbox 2 -tekst', C8: 'Open sollicitatie', Da: 'Open select omschrijving', Db: 'Open select', Dc: 'Open select optie 5', Dd: 'Open select optie 4', De: 'Open select optie 1', Df: 'Open select optie 3', Dg: 'Open select optie 2', Dh: 'Open submenu', Di: 'Tekstveld', Dj: 'Tekstveld', Dk: 'Tekstveld Placeholder', Dl: 'Open tracking', Dm: 'Geopende emails', Dn: 'Totale hoeveelheid emails die zijn geopened', Do: 'Optimale cookies accepteren', Du: 'optioneel', Dv: 'Optioneel veld', VT: 'Opties', Dx: 'of', Dy: 'of voeg een externe link toe', Dz: 'Order campaign', DA: 'Volgordenummer', DB: 'Order status', DC: 'Besteld', DD: 'Lijst (genummerd)', DE: 'Organisatie', DF: 'Categorieën in de organisatie', DG: 'Categorieën in de organisatie', DH: 'Organisatieonderdeel', DK: 'Origineel', DL: 'Gebruik deze code om in te loggen:', DW: 'Outlook 2016', DX: 'Totale aantal Outlook gebruikers.', DZ: 'Overzicht', D_: 'Vacaturekaart', D0: 'Overzicht vacatures', D1: 'Button text overschrijven', D2: 'Titel bij e-mail', D3: 'WhatsApp telefoonnummer overschrijven', D4: 'WhatsApp button overschrijven', D5: 'Titel bij WhatsApp', D7: 'Pagina verwijderd', D9: 'Ongeldig pagina id', Ea: 'Deze pagina bestaat niet, kies een andere pagina.', Eb: 'Pagina opgeslagen', Ec: 'Pagina instellingen', Ed: 'Voorbeeld pagina titel', Ee: 'Deze pagina wordt gebruikt in het menu. Verwijder de pagina eerst uit het menu', Eg: 'Overzicht pagina\'s', Eh: 'Pagina\'s', Ei: 'Analytics data per pagina', Ej: 't/m', Ek: 'van', El: 'Pakistan', Em: 'Palau', En: 'Palestina', Eo: 'Panama', Ep: 'Papoea-Nieuw-Guinea', Eq: 'Paraguay', Er: 'Parameter', Eu: 'Type onderdeel', Ex: 'Pad', Ey: 'Dit pad is in gebruik door een andere pagina', Ez: 'Ongeldig pad. Gebruik letters, nummers of een koppelteken', EA: 'voorbeeld-pad', EB: 'Pad moet beginnen met het pad voorvoegsel', EC: 'Dit pad is te lang', ED: 'On hold', EE: 'Zet vacature on hold', EF: 'On hold', EG: 'Let op', EH: 'De benaming wordt in Hamilton CMS gewijzigd en zal niet meer door de import overschreven worden.', EI: 'In behandeling', EJ: 'Per uur', EK: 'Per maand', EL: 'Performance', EM: 'Permissies', EP: 'Persoonlijke afbeelding voor de referral', EQ: 'Persoonlijk bericht', ER: 'Dit is waar het persoonlijk bericht van jullie werknemer aan de potentiële kandidaat getoond wordt.', ES: 'Persoonlijk bericht voor de referral', ET: 'Peru', EU: 'Fase', EV: 'Filippijnen', EY: 'Een geldig telefoonnummer bestaat uit minstens 10 cijfers.', E_: 'Telefoonnummer (extern)', VY: 'Telefoonnummer', E$: 'Vul je telefoonnummer in', E0: 'Telefoonnummer (landcode)', E1: 'Vul je telefoonnummer in', E3: 'Kies een platform', E4: 'Hint: Kies een eind datum', E5: 'Hint: Kies een start datum', E8: 'Tekst in veld', E9: 'Tekst', Fa: 'Platform', Fb: 'Platforms', Fc: 'Voer SMS code in', Fd: 'Selecteer een nieuws-tag', Fe: 'Welkom bij Hamilton CMS', Ff: 'Welkom bij de Hiring Manager Portal', Fg: 'Welkom bij de Referral Tool', Fh: 'Welkom bij de Employee Share Tool', V$: 'Polen', Fi: 'open chat na x aantal seconden', Fj: 'Selecteer de hoeveelheid secondes voordat de chatbot tevoorschijn komt', V0: 'Portugal', Fl: 'Functie', Fr: 'Postcode', Fs: 'Ongeldige combinatie van postcode en huisnummer', Ft: 'Postcode', Fu: 'Voer postcode in', Fv: 'Postcode te lang', Fw: 'Postcode', Fx: 'Postcode', Fz: 'Vereisten voor posten', FA: 'Postmark analytics', FG: 'Preview', FH: 'Prijs', FI: 'Print deze vacature', FJ: 'Prioriteit', FK: 'Privacy', FL: 'Privacyverklaring', FM: 'Privacyvoorwaarden', FN: 'Ik accepteer de', FO: 'Ik verklaar dat ik akkoord ga met de', FP: 'Graag de privacy voorwaarden accepteren.', FQ: 'Privacyverklaring', FR: 'Privacyvoorwaarden', FT: 'privacyvoorwaarden', FU: '', FV: 'Privacyverklaring', FW: 'Privacyvoorwaarden', FX: 'Ik accepteer de', FY: 'Ik accepteer de', F1: 'Product id', F2: 'Product niet gevonden', F3: 'Products', F4: 'Eigendommen', F6: 'Provincie', F7: 'Voer provincie in', F9: 'Publicatiedatum', Ga: 'Publicatienaam', Gb: 'Publiceren', Gc: 'Publiceer vacature', Gd: 'Gepubliceerd', Ge: 'Gepubliceerd op', Gf: 'Puerto Rico', Gg: 'Qatar', Gi: 'sollicitaties / vacaturebezoeken', Gj: 'Heractiveer gebruiker', Gk: 'Gebruiker succesvol gereactiveerd', Gl: 'Call-to-action bij meer vacatures', Gm: 'Lees meer in de cookieverklaring', Gn: 'Call-to-action bij meer nieuws', Go: 'Redenen', Gp: 'Aanbevolen', Gs: 'Contactpersoon uit ATS', Gt: 'Recruiter verwijderd', Gx: 'Contactpersonen', Gy: 'Recruiter opgeslagen', GA: 'Recruitment chat', GB: 'Recruitment chat verwijderd', GD: 'Recruitment chat niet gevonden', GE: 'Recruitment chat is embed in een andere recruitment chat', GF: 'Recruitment chat is in gebruik door een pagina', GH: 'Dit label is in gebruik door een andere recruitment chat', GI: 'Alle tekst nodes direct na de salaris calculator kunnen de volgende variablen gebruiken: age, hours, function and total', GJ: 'Structuur chats', GK: 'Structuur', GL: 'Alle nodes onder het vacature overzicht worden getoond na een succesvolle solliciatie', GM: 'Lees meer', GO: 'Redirect aangemaakt', GP: 'Url moet starten met een /', GQ: 'Redirect niet toegestaan', GR: 'Bron url wordt al gebruikt door een andere redirect', GS: 'Bron url en doel url moeten uniek zijn', GT: 'Redirect aangepast', GU: 'Redirects', GX: 'Je referral is succesvol verstuurd', GY: 'Referral', GZ: 'hebben gesolliciteerd', G_: 'Referral tool banner afbeelding', G$: 'Button tekst voor de persoonlijke paginalink in uitnodigingsmail', G0: 'Hier', G1: 'Bericht in de uitnodigingsmail', G2: 'Beste {{firstName}},\n    \n    Goed nieuws - u bent zojuist persoonlijk uitgenodigd door {{employeeFirstName}} om bij ons te solliciteren!\n    En het wordt nog beter! We hebben de best passende banen op een rij gezet en hebben enkele persoonlijke tips & tricks voor je om bij ons een droombaan te vinden.\n    \n    Klik op {{button}} om naar je persoonlijke pagina te gaan.\n    \n    Tot ziens!', G3: 'E-mail onderwerp van de uitnodiging', G4: 'Je bent uitgenodigd door {{employeeFirstName}} om te solliciteren bij ons!', G5: 'Afmeldbericht in de uitnodigingsmail', G6: 'Is deze e-mail niets voor jou of wil je je gegevens verwijderen? Klik hier.', G7: 'Welkom', G8: 'E-mail', G9: 'Voer je e-mailadres in', Ha: 'Referral formulier', Hb: 'Welke banen zijn interessant?', Hc: 'Voornaam', Hd: 'Vul je voornaam in', He: 'Heb jij iemand in gedachten die perfect zou passen bij ons? Word ambassador en stuur je vriend een persoonlijke uitnodiging om bij ons te solliciteren.', Hf: 'Achternaam', Hg: 'Voer je achternaam in', Hh: 'Wat voor soort vacatures passen het beste bij degene die je aandraagt?', Hi: 'Jammer dat je gaat', Hj: 'Persoonlijk bericht', Hk: 'Voer een persoonlijk bericht in voor de persoon die je naar ons verwijst', Hl: 'Telefoonnummer', Hm: 'Voeg telefoonnummer toe', Hn: 'Telefoonnummer', Ho: 'Op welke website wil je dat de persoon die je aandraagt solliciteert?', Hp: 'Selecteer een persoonlijke foto', Hq: 'zijn uitgenodigd', Hr: 'Referral tool inlogscherm', Hs: 'Login logo', Ht: 'Het logo van het inlogscherm van de referral tool.', Hu: 'Login tekst', Hv: 'De tekst van het inlogscherm van de referral tool.', Hw: 'Login titel', Hx: 'Welkom bij de Referral Tool', Hy: 'De titel van het inlogscherm van de referral tool.', Hz: 'Overzicht referrals', HA: 'Pagina templates', HB: 'Referral indienen', HC: 'Bedankt voor je referral!', HD: 'Bedankt voor je verwijzing! Samen met jouw hulp kunnen we blijven groeien. Jouw vertrouwen in ons wordt zeer op prijs gesteld!', HE: 'Referral tool', HF: 'De banner afbeelding die wordt gebruikt op de referral pagina om iemand aan te dragen.', HG: 'Wat voor soort vacatures passen het beste bij je?', HH: 'De tekst in de button in de uitnodigingsmail.', HI: 'Het bericht dat een referral ziet in de uitnodigingsmail.', HJ: 'Het onderwerp van de uitnodigingsmail.', HK: 'De tekst in de link om de informatie van een referal anoniem te maken.', HL: 'Referral tool instellingen', HM: 'Referral tool', HN: 'Persoonlijke pagina bezocht', HO: 'Referrals', HP: 'Aantal referrals', HQ: 'Referrals met sollicitaties', V8: 'Regio', HT: 'Inschrijvingen', HU: 'Afgewezen', HV: 'Stuur afwijzing', HW: 'Beste {{sollicitantVoornaam}},<br><br>Hartelijk dank voor je sollicitatie voor de functie van {{vacatureTitel}} bij {{bedrijfsnaam}}. We hebben je sollicitatie met interesse bekeken en waarderen de tijd en moeite die je hebt genomen om te solliciteren.<br><br>Na een zorgvuldige afweging en vergelijking van alle kandidaten, hebben wij helaas besloten om voor deze functie een andere kandidaat te selecteren. Dit betekent echter niet dat we je kwaliteiten en ervaring niet waarderen. De keuze was niet eenvoudig, gezien het aantal sterke sollicitanten dat we hebben mogen ontvangen.<br><br>Wij moedigen je aan om in de toekomst opnieuw te solliciteren op andere passende functies binnen {{bedrijfsnaam}}. Mocht je interesse hebben in verdere mogelijkheden, dan nodigen we je graag uit om onze vacatures in de gaten te houden op {{{linkVacatureOverzicht}}}.<br><br>Nogmaals dank voor je interesse in ons bedrijf. We wensen je veel succes bij toekomstige sollicitaties en je verdere loopbaan.<br><br>Met vriendelijke groet,<br><br>{{sollicitatieToegewezenVoornaam}} {{sollicitatieToegewezenAchternaam}}<br>{{sollicitatieToegewezenTelefoonnummer}}<br>{{sollicitatieToegewezenEmail}}', HX: 'Afwijzing', HY: 'Je sollicitatie voor {{vacatureTitel}}', H_: 'Nieuws (selectie)', H$: 'Vacatures (selectie)', H0: 'Vacatures (slider)', H1: 'Remote', H2: 'Ok', H3: 'Verwijder', H4: 'Verwijder CTA kaart', H5: 'Wis filters', H6: 'Verwijder uit import', H8: 'Verwijderd uit import', H9: 'Herordende items van sociale media', Ia: 'Rapportage', Ib: 'Republiek Congo', dl: 'Verplicht', Ig: 'Verplicht veld', Ih: 'Als dit veld aan staat wordt het formulier veld verplicht om in te vullen op de website', Ij: 'Afbeelding', Il: 'Resultaat', In: 'Upload CV', Io: 'Upload CV', Ip: 'Bewaartermijn', Iq: 'Probeer opnieuw', Ir: 'Terug', Is: 'Bijeenkomst', Iu: 'Geef afbeelding links weer', Iv: 'Draai kolommen om', Iw: 'Review', Ix: 'Selecteer tekst om opmaak te kunnen selecteren', Iy: 'Rechts', Wc: 'Roemenië', IB: 'Rij', IE: 'Rij is bestemd voor extra content', II: 'Wijzig sollicitaties', IJ: 'Rusland', IK: 'Rwanda', IL: 'Geeft aan dat het email adres van de ontvanger niet overeenkomt met de SMTP username.', IM: 'Safari', IN: 'Totale aantal Safari gebruikers.', IO: 'Sint-Bartholomeus', IP: 'Saint Helena Ascension en Tristanda Cunha', IQ: 'Saint Kitts en Nevis', IR: 'Saint Lucia', IS: 'Sint-Maarten', IT: 'Saint Pierre en Miquelon', IU: 'Saint Vincent en de Grenadines', IV: 'salary', IW: 'Salariscalculator', IX: 'SalarisCalculator gekoppeld aan vacature', IY: 'Salariscalculator overzicht', IZ: 'Salariscalculator succesvol opgeslagen', I_: 'Hoeveel wil je verdienen?', I0: 'Salaris van', I2: 'Salarisindicatie', I3: 'Salarisindicatie', I4: 'Salarisperiode', I5: 'Salarisrange', I6: 'Salaris tot', I8: 'Samoa', I9: 'San Marino', Jb: 'Sao Tomé en Príncipe', Jd: 'Zaterdag', Je: 'Za', Jf: 'Saoedi-Arabië', Jg: 'Opslaan', Jh: 'OK', Ji: 'Opslaan & publiceren', Jj: 'Opgeslagen', Jk: 'Scores', Jl: 'Pagina\'s / sessie', Jm: 'Vul je antwoord in', Jn: 'Selectie Vragen', Jo: 'Zoeken...', Jp: 'Zoek en selecteer een locatie uit de lijst', Jq: 'Zoekbalk placeholder', Jr: 'Welke vacature zoek je?', Js: 'Wat is je adres?', Jt: 'Zoek op meerdere velden door \'&&\' te gebruiken. (Bijvoorbeeld: NL && Amsterdam)', Jv: 'Welke zoekfunctionaliteit wil je laten zien?', Jw: 'Zoek filter opties...', Jy: 'Zoek een vacature', Jz: 'Tweede kleur', JA: 'Stuur uitnodiging tweede gesprek', JE: 'Kies', JF: 'Selecteer een kleur', JG: 'Selecteer een formulier', JH: 'Selecteer een transparantie', JI: 'Selecteer een pagina en daarna een versie om te dupliceren (optioneel)', JJ: 'Selecteer een recruiter type', JK: 'Afbeelding voor thumbnail', JL: '', JM: 'Selecteer een website', JN: 'Selecteer alles', JO: 'Selecteer een avatar', JP: 'Kies een evenement', JQ: 'Selecteer een extra afbeelding', JR: 'Selecteer een afbeelding', JS: 'Titel van de afbeelding', JT: 'Selecteer afbeeldingen voor social media.', JU: 'Selecteer een andere afbeelding', JV: 'Selecteer een sollicitatieprocedure', JW: 'Selecteer ten minste één vacature', JX: 'Selecteer een audio bestand', JY: 'Selecteer een achtergrond', JZ: 'Selecteer een achtergrondgradiënt', J_: 'Selecteer hoogte', J$: 'Welke banner wil je laten zien?', J0: 'Selecteer welke tabs zichtbaar zijn boven de zoekbalk', J1: 'Selecteer een browser', J2: 'Selecteer een campagne', J3: 'Selecteer een overlay kleur', J4: 'Kies contactpersoon', J5: 'Aantal evenementen', J6: 'Selecteer file', J7: 'Kies welke groep(en) deze gebruiker toe behoort:', J8: 'Selecteer een titelgrootte', J9: 'Kies hiring manager', Ka: 'Horizontale uitlijning', Kb: 'Selecteer afbeeldingen', Kc: 'Selecteer de job alert velden', Kd: 'Kies locatie', Ke: 'Selecteer een', Kf: 'Selecteer de dichtheid van de overlay', Kg: 'Selecteer een pagina', Kh: 'Selecteer een pagina', Ki: 'Selecteer recruitment chat', Kj: 'Selecteer een referral om te previewen', Kk: 'Aantal nieuws items', Kl: 'Aantal vacatures', Km: 'Toegepast filter', Kn: 'Selecteer een bron', Ko: 'Selecteer een hoogte', Kp: 'Selecteer waar de link opent', Kq: 'Horizontale uitlijning', Kr: 'Selecteer vacature', Ks: 'Selecteer welke invoer verwacht wordt', Kt: 'Selecteer een vacature om te previewen', Ku: 'Kies vacaturekenmerk', Kv: 'Selecteer een vacature-beschrijving', Kw: 'Selecteer een versie', Kx: 'Verticale uitlijning', Ky: 'Alt-tekst (voor SEO)', Kz: 'Selecteer een vacaturefilter waar de banner afbeelding naar kijkt', KA: 'Selecteer een kleur', KB: 'Call-to-action', KC: 'Beschrijving', KD: 'Afbeelding voor desktop', KE: 'E-mail', KF: 'Selecteer welke extra content je wil weergeven', KG: 'Vul de gehele kolom', KH: 'Voornaam', KI: 'Hyperlink', KJ: 'Selecteer een link kleur', KK: 'Maximale breedte content', KL: 'Maximale breedte achtergrond', KM: 'Afbeelding voor mobiel', KN: 'Telefoonnummer', KO: 'Functie', KP: 'Afbeelding voor tablet', KQ: 'Open nieuwe pagina in', KR: 'Titel', KS: 'Selecteer een achtergrond video', KT: 'Video ID', KU: 'Plak alleen de video id bijv. \'ScMzIvxBSi4\'', KV: 'Selecteer een platform', KW: 'Geselecteerde locatie', KX: 'Stuur een WhatsApp bericht', KY: 'Stuur een e-mail', KZ: 'Overschrijf contact formulier button', K_: 'Stuur communicatie', K$: 'Stuur afwijzing', K0: 'Verstuur', K1: 'Stuur naar', K2: 'Senegal', K3: 'Ervaring', K4: 'Welk level van senioriteit behoort tot deze pagina?', K5: 'Verstuurd', K6: 'Totale hoeveelheid emails die je hebt verstuurd', K7: 'Verstuurde emails', K8: 'Doorgestuurd naar', K9: 'SEO overzicht', Lc: 'Servië', Ld: 'Sessies', Lf: 'Instellingen', Lg: 'Configuratie vereist', Lh: 'Seychellen', Lm: 'Deel', Ln: 'Deel', Lo: 'Deel op social media:', Lp: 'Share tool', Lq: 'ShareTool tag toegevoegd', Lr: 'ShareTool tag aangepast', Ls: 'ShareTool tags', Lt: 'Share tool', Lu: 'Deel deze vacature via Email', Lv: 'Deel deze vacature via Facebook', Lw: 'Deel deze vacature via Linkedin', Lx: 'Deel deze vacature via X', Ly: 'Deel deze vacature via Whatsapp', Lz: 'Share tool tags', LB: 'Toon', LC: 'Toon actieve sollicitaties', LD: 'Toon actieve vacatures', LE: 'Toon alle activiteiten', LF: 'Toon als tag in vacature', LG: 'Toon chat na x aantal seconden', LH: 'Toon afgeronde sollicitaties', LI: 'Toon gesloten vacatures', LK: 'Geef de cookie modal weer op de pagina', LL: 'Toon CTA kaart in vacature overzicht', LM: 'Toon alleen content voor desktop', LN: 'Zelf instellen', LO: 'Bekijk preview op een apparaat', LP: 'Toon alle content', LR: 'Geef de footer weer op de pagina', LU: 'Laat ruimte zien tussen kolommen', LV: 'Geef de header weer op de pagina', LW: 'Overlay op afbeelding', LX: 'Toon in Share Tool formulier', LY: 'Laat de pagina zien in de sitemap', LZ: 'Tonen in vacaturekaart', L_: 'Laat keyword search velden zien', L0: 'Laat locatie velden zien', L1: 'Selecteer logo in vacature-kaart', L2: 'Selecteer logo in vacature kaart en banner', L3: 'Toon als masonry', L4: 'Toon alleen content voor mobiel', L5: 'Toon meer', L6: 'Bekijk meer nieuws', L7: 'Bekijk meer vacatures', L8: 'Toon filters in nieuwsoverzicht', L9: 'Geef tags weer in news item', Ma: 'Toon op:', Mb: 'Geef rij weer op apparaat.', Mc: 'Toon tag op website', Md: 'Toon alleen notities', Me: 'Toon publicatiedatum bij nieuwsbericht', Mf: 'Geef slider weer in', Mg: 'Laat alleen spotlight vacatures zien', Mh: 'Toon alleen content voor tablet', Mi: 'Toon tag in', Ml: 'Toon starttijd op website', Mm: 'Toon WhatsApp button op deze pagina', Mn: 'Selecteer de velden in de formulieren', Mo: 'Sierra Leone', Mp: 'Log in', Wi: 'Singapore', Mq: 'SintMaarten', Ms: 'Menu-items overslaan', My: '5 kaarten', Mz: '4 kaarten', MA: '1 kaart', MB: '3 kaarten', MC: '2 kaarten', Wk: 'Slowakije', ME: 'Slovenië', MF: 'Klein (400px)', MG: 'Klein (10px)', MJ: 'SMS Code', MK: 'SMTP errors', MN: 'Gemaakt social media-item', MO: 'Verwijderde sociale media-item', MP: 'Socials in footer', MQ: 'Sociale media', MR: 'Succesvol bijgewerkt Social Media Item', MS: 'Softbounces', MT: 'De mailbox van de ontvanger is vol en accepteert geen emails meer.', MU: 'Solomon eilanden', MV: 'Somalië', MW: 'Er is iets mis gegaan', MY: 'Alfabet', MZ: 'Sorteer op', M_: 'Volgordenummer', M$: 'Aantal vacatures', M0: 'Bron url', M1: 'Bron / sollicitaties', M2: 'Diagram met verhouding van sollicitaties per bron', M4: 'Bron', M5: 'Sollicitaties informatie per bron', M6: 'Bronnen', M7: 'Bronnen / Sollicitaties', M8: 'Zuid-Afrika', M9: 'Zuid-Korea', Na: 'Zuid Soedan', Nb: 'Spacer', Wl: 'Spanje', Ne: 'spam klachten.', Nf: 'Spotlight', Ng: 'Sri Lanka', Nl: 'Start datum', Nn: 'Statistieken', No: 'Statistische cookies helpen ons te begrijpen hoe bezoekers deze website gebruiken, door anoniem gegevens te verzamelen en te rapporteren.', eW: 'Status', Np: 'Permanent verplaatst (301)', Nq: 'Tijdelijk verplaatst (302)', Nr: 'Zie andere (303)', Ns: 'Naar sollicitatie status', Nt: 'Goedgekeurd', Nu: 'Assessment', Nv: 'Statuswijziging', Nw: 'Status gewijzigd  van', Wm: 'Statuscode', Nx: 'Status verwijderd', Ny: 'Status beschrijving', Nz: '1e gesprek', NA: 'Aangenomen', NB: 'You rock!', NC: 'Status kan niet worden verwijderd. Deze is beschermd.', ND: 'Nieuw', NE: 'Aanbod', NF: 'In afwachting', NG: 'Telefonisch interview', NH: 'Afgewezen', NI: 'Opnieuw proberen', NJ: 'Review', NK: 'Screening', NL: '2e gesprek', NM: 'Status wordt nog gebruikt in een actie. Wijs je actie toe aan een andere status voordat je de status verwijdert.', NN: 'Status wordt nog gebruikt in een sollicitatie. Wijs je sollicitatie toe aan een andere status voordat je de status verwijdert.', NO: 'Status wordt nog gebruikt in een communicatie template. Wijs je communicatie template toe aan een andere status voordat je de status verwijdert.', NP: 'Teruggetrokken', NQ: 'Statussen', eX: 'Stap', NS: 'Je verkent Stibbe als', NT: 'Data langer bewaren', NU: 'Winkelnummer', NV: 'Straat', NW: 'Straat + huisnummer', NX: 'Voer straat en huisnummer in', NY: 'Straatnaam', N_: 'Voer je straatnaam in', N$: 'Straatnaam', N0: 'Straatnaam', N5: 'Selecteer het contracttype voor Google', Wq: 'Verstuur', Oa: 'Verstuur', Wr: 'Formulier succesvol verstuurd', Od: 'Voeg subtitel toe', Oe: 'Notitie toegevoegd', Of: 'Besteld', Og: 'Dat was leuk om het opnieuw te doen', Oh: 'Uw inhoud is', Oi: 'Ingediend!', Oj: 'Uw inhoud is ingediend. Het wordt binnenkort gecontroleerd! Je kunt je inzendingen en hun statussen zien door op het Star-Icon te tikken! Volgende keer dat u zich aanmeldt, wordt u op de hoogte gebracht wanneer de status is gewijzigd!', Ok: 'Goed gedaan!', Ol: 'Volg HKM People Instagram-kanaal', Om: 'Zie alle inzendingen', On: 'Notitie verwijderd', Oo: 'Je hebt via e-mail een tijdelijke link ontvangen waarmee je kan inloggen op Hamilton CMS met gebruik van de unieke code die via SMS is verzonden.', Op: 'Soedan', Oq: 'Voeg samenvatting toe', Or: 'Zondag', Os: 'Zo', Ou: '<b>Dit organisatie onderdeel is geïmporteerd. Weet je zeker dat je dit organisatieonderdeel wilt verwijderen?</b>\n    \n    Als dit onderdeel nog aanwezig is in het externe systeem, dan zal deze tijdens de volgende import weer teruggeplaatst worden.\n    \n    Het kan ook zijn dat er nog vacatures aan gekoppeld zijn. Wij adviseren om eerst deze vacatures aan een ander onderdeel te koppelen of dit  onderdeel te hernoemen.', Ov: '<b>Dit organisatie onderdeel is geïmporteerd. Weet je zeker dat je dit organisatieonderdeel wilt verwijderen?</b>\n    \n    Als dit onderdeel nog aanwezig is in het externe systeem, dan zal deze tijdens de volgende import weer teruggeplaatst worden.\n    \n    Het kan ook zijn dat er nog vacatures aan gekoppeld zijn. Wij adviseren om eerst deze vacatures aan een ander onderdeel te koppelen of dit  onderdeel te hernoemen.', Ow: '<b>Dit vacaturekenmerk is geïmporteerd. Weet je zeker dat je dit vacaturekenmerk wilt verwijderen?</b>\n    Als dit onderdeel nog aanwezig is in het externe systeem, dan zal deze tijdens de volgende import weer teruggeplaatst worden.\n    \n    Het kan ook zijn dat er nog vacatures aan gekoppeld zijn. Wij adviseren om eerst deze vacatures aan een ander kenmerk te koppelen of dit kenmerk te hernoemen.', Ox: '<b>Dit vacaturekenmerk is geïmporteerd. Weet je zeker dat je dit vacaturekenmerk wilt verwijderen?</b>Als dit onderdeel nog aanwezig is in het externe systeem, dan zal deze tijdens de volgende import weer teruggeplaatst worden.\n    \n    Het kan ook zijn dat er nog vacatures aan gekoppeld zijn. Wij adviseren om eerst deze vacatures aan een ander onderdeel te koppelen of dit  onderdeel te hernoemen.', Oy: 'Weet je zeker dat je dit item wilt verwijderen?', Oz: 'Weet je zeker dat je alle UBEEO vacatures wilt verwijderen?', OA: 'Suriname', OB: 'Svalbard en Jan Mayen', Wx: 'Zweden', Wy: 'Zwitserland', OC: 'Syrië', OF: 'Tablet', OH: 'Tag aangemaakt', OI: 'Deze titel is al in gebruik door een andere tag', OJ: 'Dit label is te lang, de maximale lengte is 255 karakters.', OK: 'Tag aangepast', OM: 'Pagina tags', ON: 'Taiwan', OO: 'Tadjikistan', OP: 'Haal offline', OQ: 'Weet je zeker dat je dit offline wil halen?', OR: 'Tanzania', OS: 'Doel url', OV: 'Template toegevoegd', OW: 'Template verwijderd', OX: 'Template kan niet worden verwijderd. Het is beschermd', O_: 'Vacature templates', O$: 'Templates vacature', O0: 'Testimonial', O1: 'Inhoud', O3: 'Textkleur', O4: 'Tekst', O6: 'Tekst te lang', O7: 'Tekst te kort', O8: 'Tekst', O9: 'Thailand', Pa: 'Dankbericht bij succesvol solliciteren', Pb: 'Bedankt', Pc: 'Templates bedankpagina', Pe: 'Derde kleur', Pf: 'Deze maand', Pg: 'Thunderbird', Ph: 'Totale aantal Thunderbird gebruikers.', Pi: 'Donderdag', Pj: 'Do', Pm: 'tot', dF: 'Timeout', Po: 'Het request duurde te lang.', Pp: 'Timorleste', Pq: 'Type', WC: 'Titel', Pr: 'Voorbeeld titel', Ps: 'Tot en met', Pt: 'Eindkleur', Pv: 'Ga naar het begin van de pagina', e2: 'Vandaag', Pw: 'Gaan', Px: 'Tokelau', Pz: 'Tonga', PA: 'Te lang', PB: 'Te veel kolommen', PC: 'Voor SEO doeleinde is dit geen goed idee.', PD: 'Je probeert meer dan 1 H1 toe te voegen op de pagina...', PE: 'Te veel spotlight vacatures (max. 5)', PF: 'Te kort', PG: 'Totaal', PH: 'Sollicitaties', PI: 'Totaal aantal dagen', PJ: 'Totale laadtijd', PK: 'Totale score', PM: 'Actieve vacatures', PN: 'Vacature weergave', PO: 'Tracked emails', PP: 'Aantal verzonden e-mails met Link of Open Tracking ingeschakeld. Een e-mail waarin beide soorten tracking zijn ingeschakeld, verhoogt dit totaal alleen met 1.', PQ: 'Tracking', PR: 'De Tracking code is niet valide', PV: 'Transacties', PY: 'Transient bounces', PZ: 'Geeft een tijdelijk probleem aan bij de server van de ontvanger, of een andere tijdelijk technisch probleem.', P_: 'Openbaar vervoer', P$: 'Vertalingen', P1: 'Reistijdcalculator', P2: 'Trinidad en Tobago', P3: 'Dinsdag', P4: 'Di', P6: 'Tunesië', P7: 'Turkije', P8: 'Turkmenistan', P9: 'Turken en Caicoseilanden', Qa: 'Tuvalu', Qc: 'Txt', Qd: 'Ubeeo evenement', Qe: 'Oeganda', WO: 'Oekraïne', Qf: 'Lijst (bullets)', Qg: 'Depubliceren', Qh: 'Kan het bestand niet lezen', Qi: 'Schuif huidige rij onder vorige rij', Qk: 'Ongedaan maken', Ql: 'Uniek geklikt', Qm: 'Geeft het totale aantal unieke links aan waarop is geklikt. Links worden beschouwd als uniek voor elke ontvanger, per e-mail. Dezelfde URL in zowel de tekst als de html-body\'s wordt echter behandeld als dezelfde link.', Qn: 'Uniek geopende emails', Qo: 'Totale hoeveelheid unieke emails die zijn geopened', Qp: 'Verenigde Arabische Emiraten', Qq: 'Verenigd Koninkrijk', WQ: 'Verenigde Staten', Qr: 'Verenigde Staten Maagdeneilanden', Qs: 'Anders', Qt: 'Onbekend domein', WR: 'Er is iets misgegaan', Qu: 'Totale aantal gebruikers met een onbekende platform op de link hebben geklikt in de email.', Qv: 'Totale aantal gebruikers met een onbekende platform die de email hebben geopend.', Qw: 'Niet toegewezen', Qx: 'Gedepubliceerd', Qz: 'Event tag aanpassen', QA: 'Mediatag aanpassen', QB: 'Nieuwstag aanpassen', QC: 'Oops dit is niet toegestaan', QD: 'ShareTool tag aanpassen', QE: 'Update Social Media Item', QF: 'Wijzig status', QG: 'Update tag', QI: 'Gewijzigd op', QJ: 'Filters succesvol opgeslagen', QK: 'Upload', QM: 'Upload media', QN: 'Upload nieuw CSV bestand', QO: 'Overzicht uploads', QP: 'Laten we gaan', QQ: 'Deel uw inhoud', QR: '(Optioneel) Heeft u suggestie voor een bijschrift om met uw inhoud te komen?', QS: 'Ja, ik heb alle personen gevraagd in de geüploade inhoud voor goedkeuring van het gebruik (zorg ervoor dat u schriftelijke toestemming hebt).', QT: 'Voeg je tags toe', QU: 'Lees verder', QV: '', QW: 'Stap 1', QX: 'Stap 2', QY: 'Stap 3', QZ: 'Voeg je tags toe', Q_: 'Uploads', Q$: 'Uptime', dK: 'Url', Q0: 'Url', Q2: 'https://www.voorbeeld.url', Q4: 'Uruguay', Q5: 'Gradient', Q6: 'Afbeelding', Q7: 'Gebruik huidige locatie', Ra: 'Handige links', Rb: 'Gebruiker', Rc: 'Gearchiveerde gebruikers', Rd: '{0} heeft geen toegang tot locatie {1}', Re: '{0} heeft geen toegang tot open sollicitatie', Rf: '{0} heeft geen toegang tot {1}', Rg: '{0} heeft geen toegang tot vacature {1}', Ri: 'Gebruiker successvol verwijderd', Rj: 'Gebruiker is gekoppeld aan één of meer vacatures of sollicitaties', Rk: 'Gebruiker is hiring manager voor één of meer vacatures', Rl: 'Deze gebruiker kan niet worden toegewezen', Rm: 'Deze gebruiker kan niet getoond worden als hiring manager', Rn: 'Deze gebruiker kan niet getoond worden als contactpersoon', Ro: 'Gebruiker is contactpersoon voor één of meer vacatures', Rp: 'Soort gebruiker', Rq: 'Gebruikers', Rr: 'Gebruiker successvol opgeslagen', Rs: 'Gebruiker', Rt: 'onbekend', Rv: 'Door deze wijziging verliest de gebruiker toegang tot één of meer gekoppelde vacatures of sollicitaties', Rx: 'Gebruikers vorige periode', Ry: 'Usp', Rz: 'Usp', RA: 'UTM Campagne', RB: 'UTM Source', RD: 'Oezbekistan', RE: 'Vacatures', RF: 'Vacatures in de buurt', RG: 'Sollicitaties informatie per vacature', RH: 'Vacature', RI: '404 pagina template', RJ: 'Templates 404 vacature', RK: 'Vacaturetekst accordion', RL: 'Vacaturetekst accordion (groep)', RM: 'Vacature appetizer', RN: 'Vacature geassociëerde opties', RO: 'Vacaturekenmerk', RP: 'Categorieën vacaturekenmerken', RQ: 'Titel vacaturekenmerk', RS: 'Nieuw aangemaakt', RU: 'Vacature verwijderd', RV: 'Verwijderd', RW: 'Gehele vacature beschrijving (oud)', RX: 'Vacature beschrijving', RY: 'Vacaturepagina', R_: 'Bedankpagina', R$: 'Vacature template', R0: 'Vacaturefilter', R1: 'Categorie titel is al in gebruik door een andere categorie.', R2: 'Vacaturelinks', R3: 'Categorie type is al in gebruik door een andere categorie.', R5: 'uur', R6: 'Vacature id', R8: 'Vacature specificatie', Sb: 'Vacature niet gevonden', Sc: 'Vacature overzicht', Sd: 'Vacatures (alle)', Sg: 'Vacaturekenmerk', Si: 'in', Sk: 'Pagina template', Sl: 'Vacaturetekst', Sm: 'Vacature text groep', Sn: 'Bedanktpagina template', Sp: 'Voer titel van de vacature in', Sq: 'Vacature aangepast', Sr: 'Vacature bekeken', Ss: 'Dit veld moet een geldig emailadres zijn.', St: 'Gebruik valide html', Su: 'Validatie CSV bestand', Sv: 'Valideer CSV bestand', Sx: 'Vanuatu', Sy: 'Vaticaanstad', Sz: 'Venezuela', SA: 'Versie', SB: 'Versie verwijderd', SC: 'Helpt gebruikers verschillende versies te onderscheiden in het CMS.', SE: 'Versie opgeslagen', SF: 'Versies', SG: 'Video', SH: 'Video bestand', SI: 'Video', SJ: 'Plak alleen de video id bijv. \'ScMzIvxBSi4\'', SL: 'Om de video af te spelen, zul je de marketing cookies moeten accepteren. Wil je de marketing cookies accepteren?', SM: 'Ja, ik wil de video afspelen', SN: 'Vietnam', dM: 'Bekijk', SO: 'Bekijk sollicitatie', SP: 'Bekijk gegevens', SQ: 'Bekijk e-mail', SR: 'Bekijk meer vacatures', SS: 'Bekijk preview', ST: 'Bekijk training', SU: 'Bekijk vacatures', SV: 'Bekijk vacature', SW: 'Weergeven', SX: 'Vimeo', SZ: 'Alleen CMS', S_: 'Share tool formulier', S0: 'Website', S1: 'Share tool formulier & Website', S2: 'Bezoek onze {{Platform}} pagina', S3: 'Website bezoek', S6: 'Wallis en Futuna', S7: 'Webmail', S8: 'Totale aantal webmail gebruikers die de email hebben geopend.', S9: 'Website', Ta: 'Website instellingen', Tc: 'Woensdag', Td: 'Wo', Tg: 'Deel je passie', Th: 'Dien uw inhoud in', Ti: 'Wij zijn zo\'n leuk en gepassioneerd merk! We willen dit graag nog meer delen met onze (s) helden die in Hunkmöller over de hele wereld winkelen! Laten we ze inspireren wat HKM betekent! Help ons om inhoud te maken die we kunnen delen op internationale platforms! We zijn super benieuwd naar je ideeën!', Tj: 'Deel leuke en authentieke inhoud uit uw winkel-team', Tk: 'Geen enkele klanten zijn toegestaan in beeldmateriaal', Tl: 'Iedereen die in beeldmateriaal wordt weergegeven, gaat ermee akkoord de inhoud te delen', Tm: 'De basis', Tn: 'Je organisatie staat niet stil, net als de arbeidsmarkt. Dat betekent ook dat je recruitmentsite dynamisch moet zijn en met de ontwikkelingen meebeweegt. Met dit CMS kan je zelf aan de knoppen zitten en je recruitmentsite opbouwen en uitbreiden zoals nodig is. Als je vragen hebt over het gebruik van Hamilton CMS staat onze ServiceDesk tijdens kantooruren telefonisch ter beschikking via +31(0)20 244 0492.', To: '<p>We staan altijd klaar om te helpen met gebruikersvragen of problemen, maar ook om mee te denken in strategische keuzes om jouw recruitmentsite blijvend inspirerend te houden. Daarom willen wij je graag verzoeken om vragen en wensen voor Customer Support aan te melden via onze Customer Support Portal en deze niet via andere kanalen te versturen.</p> <br><br><p>De SuperUsers van jouw organisatie kunnen de Customer Support Portal <a target=\'_blank\' href=\'https://floydhamilton.atlassian.net/servicedesk/customer/portals\'>hier</a> bereiken.</p><br><br><p>Ook kunnen zij de <a target=\'_blank\' href=\'https://floydhamilton.atlassian.net/servicedesk/customer/portal/4/topic/391bcd24-7cd6-48cb-ae3d-a7565ea35590/article/2278457915\'>handleiding van Hamilton CMS</a> lezen en de laatste <a target=\'_blank\' href=\'https://floydhamilton.atlassian.net/servicedesk/customer/portal/4/topic/b3d54bef-4b9c-4f82-b9df-66c2c061628f\'>release notes</a> bekijken.</p><br><br><p>Veel plezier met het gebruik van Hamilton CMS!</p>', Tp: 'Welkom in Hamilton CMS!', Tq: 'emails zijn op geklikt.', Tr: 'waren geopend.', Ts: 'Westelijke Sahara', Tu: 'WhatsApp nummer', Tw: 'Ik wil graag solliciteren op de vacature', Tx: 'Is dit een leuke baan voor jou?', TA: 'WhatsApp ons', TB: 'Wit', TC: 'met de volgende opmerking:', TD: 'Verwijderen', TF: 'Wereldkaart', TL: 'Schrijf een persoonlijk bericht voor je vriend of vriendin', TO: 'Xing url', TP: 'https://www.xing.com/profile/username', TS: 'Werkervaring', TT: 'Jemen', TU: 'Ja', TV: 'Gisteren', TW: 'Wie zoeken wij', TX: 'You rock!', TY: 'Je hebt', TZ: 'emails.', T_: 'YouTube', T$: 'Z-index rij', T0: 'Zambia', T3: 'Zimbabwe'};
var $elm$core$Basics$ge = _Utils_ge;
var $author$project$View$FilterOptionSuggestions$makeNoResultsMessage = function (model) {
	return ($elm$core$List$length(model.ng) >= 5) ? $author$project$Copy$copy.yL : ($elm$core$String$isEmpty(model.B0) ? $author$project$Copy$copy.B$ : model.B0);
};
var $author$project$View$FilterOptionSuggestions$makePlaceholder = function (model) {
	return $elm$core$String$isEmpty(model.dd) ? $author$project$Copy$copy.Jw : model.dd;
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.Wm));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $author$project$Model$FilterOptionSuggestion$FilterOptionSuggestion = F2(
	function (optionLabel, optionKey) {
		return {Ds: optionKey, Dt: optionLabel};
	});
var $author$project$Model$FilterOptionSuggestion$filterOptionSuggestionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'optionKey',
	$author$project$Data$Id$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'optionLabel',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$FilterOptionSuggestion$FilterOptionSuggestion)));
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {Ic: reqs, Ob: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.WM;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.Ic));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.Ob)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					T9: r.T9,
					a2: r.a2,
					cH: A2(_Http_mapExpect, func, r.cH),
					cL: r.cL,
					c0: r.c0,
					dF: r.dF,
					WM: r.WM,
					dK: r.dK
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{T9: false, a2: r.a2, cH: r.cH, cL: r.cL, c0: r.c0, dF: r.dF, WM: r.WM, dK: r.dK}));
};
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Data$Id$toInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Data$Id$toString = A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $author$project$Data$Id$toInt);
var $author$project$View$FilterOptionSuggestions$requestFilterOptionSuggestion = F3(
	function (model, trackingId, keyword) {
		var params = A2(
			$elm$core$List$cons,
			A2($elm$url$Url$Builder$string, 'keywords', keyword),
			A2(
				$elm$core$List$map,
				function (option) {
					return A2(
						$elm$url$Url$Builder$string,
						'current-options',
						$author$project$Data$Id$toString(option));
				},
				model.ng));
		return $elm$http$Http$request(
			{
				a2: $elm$http$Http$emptyBody,
				cH: A2(
					$elm$http$Http$expectJson,
					$elm$core$Basics$identity,
					A3(
						$elm$json$Json$Decode$map2,
						$elm$core$Tuple$pair,
						A2(
							$elm$json$Json$Decode$index,
							0,
							$elm$json$Json$Decode$list($author$project$Model$FilterOptionSuggestion$filterOptionSuggestionDecoder)),
						$elm$json$Json$Decode$maybe(
							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$int)))),
				cL: _List_Nil,
				c0: 'GET',
				dF: $elm$core$Maybe$Nothing,
				WM: $elm$core$Maybe$Just(trackingId),
				dK: A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						[
							'api',
							$author$project$Data$Id$toString(model.cF),
							'suggestions',
							'filter-options',
							$author$project$Data$Id$toString(model.rI)
						]),
					params)
			});
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $author$project$View$FilterOptionSuggestions$filterOptionParam = 'fo';
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $lydell$elm_app_url$Escape$Fragment = 3;
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $lydell$elm_app_url$Escape$forPath = function (_char) {
	switch (_char) {
		case '/':
			return '%2F';
		case '?':
			return '%3F';
		case '#':
			return '%23';
		default:
			return $elm$core$String$fromChar(_char);
	}
};
var $lydell$elm_app_url$Escape$forQueryKey = function (_char) {
	switch (_char) {
		case '=':
			return '%3D';
		case '&':
			return '%26';
		case '#':
			return '%23';
		default:
			return $elm$core$String$fromChar(_char);
	}
};
var $lydell$elm_app_url$Escape$forQueryValue = function (_char) {
	switch (_char) {
		case '&':
			return '%26';
		case '#':
			return '%23';
		default:
			return $elm$core$String$fromChar(_char);
	}
};
var $lydell$elm_app_url$Escape$escapePart = function (part) {
	switch (part) {
		case 0:
			return $lydell$elm_app_url$Escape$forPath;
		case 1:
			return $lydell$elm_app_url$Escape$forQueryKey;
		case 2:
			return $lydell$elm_app_url$Escape$forQueryValue;
		default:
			return $elm$core$String$fromChar;
	}
};
var $lydell$elm_app_url$Escape$shouldHandlePlusAndSpace = function (part) {
	switch (part) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $lydell$elm_app_url$Escape$forAll = F2(
	function (part, _char) {
		switch (_char) {
			case '\u0000':
				return '%00';
			case '\u0001':
				return '%01';
			case '\u0002':
				return '%02';
			case '\u0003':
				return '%03';
			case '\u0004':
				return '%04';
			case '\u0005':
				return '%05';
			case '\u0006':
				return '%06';
			case '\u0007':
				return '%07';
			case '\u0008':
				return '%08';
			case '\t':
				return '%09';
			case '\n':
				return '%0A';
			case '\u000B':
				return '%0B';
			case '\u000C':
				return '%0C';
			case '\u000D':
				return '%0D';
			case '\u000E':
				return '%0E';
			case '\u000F':
				return '%0F';
			case '\u0010':
				return '%10';
			case '\u0011':
				return '%11';
			case '\u0012':
				return '%12';
			case '\u0013':
				return '%13';
			case '\u0014':
				return '%14';
			case '\u0015':
				return '%15';
			case '\u0016':
				return '%16';
			case '\u0017':
				return '%17';
			case '\u0018':
				return '%18';
			case '\u0019':
				return '%19';
			case '\u001A':
				return '%1A';
			case '\u001B':
				return '%1B';
			case '\u001C':
				return '%1C';
			case '\u001D':
				return '%1D';
			case '\u001E':
				return '%1E';
			case '\u001F':
				return '%1F';
			case ' ':
				return $lydell$elm_app_url$Escape$shouldHandlePlusAndSpace(part) ? '+' : '%20';
			case '%':
				return '%25';
			case '+':
				return $lydell$elm_app_url$Escape$shouldHandlePlusAndSpace(part) ? '%2B' : $elm$core$String$fromChar(_char);
			case '\u00A0':
				return '%C2%A0';
			case '\u1680':
				return '%E1%9A%80';
			case '\u2000':
				return '%E2%80%80';
			case '\u2001':
				return '%E2%80%81';
			case '\u2002':
				return '%E2%80%82';
			case '\u2003':
				return '%E2%80%83';
			case '\u2004':
				return '%E2%80%84';
			case '\u2005':
				return '%E2%80%85';
			case '\u2006':
				return '%E2%80%86';
			case '\u2007':
				return '%E2%80%87';
			case '\u2008':
				return '%E2%80%88';
			case '\u2009':
				return '%E2%80%89';
			case '\u200A':
				return '%E2%80%8A';
			case '\u2028':
				return '%E2%80%A8';
			case '\u2029':
				return '%E2%80%A9';
			case '\u202F':
				return '%E2%80%AF';
			case '\u205F':
				return '%E2%81%9F';
			case '\u3000':
				return '%E3%80%80';
			case '\uFEFF':
				return '%EF%BB%BF';
			default:
				return A2($lydell$elm_app_url$Escape$escapePart, part, _char);
		}
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $lydell$elm_app_url$AppUrl$percentEncode = F2(
	function (part, string) {
		return $elm$core$String$concat(
			A2(
				$elm$core$List$map,
				$lydell$elm_app_url$Escape$forAll(part),
				$elm$core$String$toList(string)));
	});
var $lydell$elm_app_url$AppUrl$fragmentToString = function (maybeFragment) {
	if (!maybeFragment.$) {
		var fragment = maybeFragment.a;
		return '#' + A2($lydell$elm_app_url$AppUrl$percentEncode, 3, fragment);
	} else {
		return '';
	}
};
var $lydell$elm_app_url$Escape$Path = 0;
var $lydell$elm_app_url$AppUrl$pathToString = function (path) {
	return '/' + A2(
		$elm$core$String$join,
		'/',
		A2(
			$elm$core$List$map,
			$lydell$elm_app_url$AppUrl$percentEncode(0),
			path));
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Basics$not = _Basics_not;
var $lydell$elm_app_url$Escape$QueryKey = 1;
var $lydell$elm_app_url$Escape$QueryValue = 2;
var $lydell$elm_app_url$AppUrl$queryParameterToString = function (_v0) {
	var key = _v0.a;
	var values = _v0.b;
	return A2(
		$elm$core$List$map,
		function (value) {
			return ((!$elm$core$String$isEmpty(key)) && $elm$core$String$isEmpty(value)) ? A2($lydell$elm_app_url$AppUrl$percentEncode, 1, key) : (A2($lydell$elm_app_url$AppUrl$percentEncode, 1, key) + ('=' + A2($lydell$elm_app_url$AppUrl$percentEncode, 2, value)));
		},
		values);
};
var $lydell$elm_app_url$AppUrl$queryParametersToString = function (queryParameters) {
	var filteredQueryParameters = A2(
		$elm$core$Dict$filter,
		F2(
			function (_v0, values) {
				return !$elm$core$List$isEmpty(values);
			}),
		queryParameters);
	return $elm$core$Dict$isEmpty(filteredQueryParameters) ? '' : ('?' + A2(
		$elm$core$String$join,
		'&',
		A2(
			$elm$core$List$concatMap,
			$lydell$elm_app_url$AppUrl$queryParameterToString,
			$elm$core$Dict$toList(filteredQueryParameters))));
};
var $lydell$elm_app_url$AppUrl$toString = function (url) {
	return _Utils_ap(
		$lydell$elm_app_url$AppUrl$pathToString(url.Ex),
		_Utils_ap(
			$lydell$elm_app_url$AppUrl$queryParametersToString(url.b3),
			$lydell$elm_app_url$AppUrl$fragmentToString(url.U4)));
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$View$FilterOptionSuggestions$toUrl = F2(
	function (url, filterOptionId) {
		var values = $elm$core$Dict$values(url.b3);
		var paramValue = $author$project$Data$Id$toString(filterOptionId);
		var isMember = A2(
			$elm$core$List$member,
			paramValue,
			$elm$core$List$concat(values));
		var currentParams = A2($elm$core$Dict$get, $author$project$View$FilterOptionSuggestions$filterOptionParam, url.b3);
		return isMember ? $lydell$elm_app_url$AppUrl$toString(url) : $lydell$elm_app_url$AppUrl$toString(
			_Utils_update(
				url,
				{
					b3: function () {
						if (currentParams.$ === 1) {
							return A3(
								$elm$core$Dict$insert,
								$author$project$View$FilterOptionSuggestions$filterOptionParam,
								_List_fromArray(
									[paramValue]),
								url.b3);
						} else {
							return A3(
								$elm$core$Dict$update,
								$author$project$View$FilterOptionSuggestions$filterOptionParam,
								$elm$core$Maybe$map(
									$elm$core$List$append(
										_List_fromArray(
											[paramValue]))),
								url.b3);
						}
					}()
				}));
	});
var $author$project$View$FilterOptionSuggestions$filterSearchConfig = function (model) {
	var id = 'filter-option';
	return {
		dT: $elm$core$Maybe$Nothing,
		cO: id,
		xp: $author$project$View$FilterOptionSuggestions$FilterOptionAutocompleteMsg,
		B1: $author$project$View$FilterOptionSuggestions$makeNoResultsMessage(model),
		dd: $author$project$View$FilterOptionSuggestions$makePlaceholder(model),
		Ie: A2($author$project$View$FilterOptionSuggestions$requestFilterOptionSuggestion, model, id),
		Wv: $author$project$View$Autocomplete$Http$Link(
			{
				Wt: A2(
					$elm$core$Basics$composeL,
					$author$project$View$FilterOptionSuggestions$toUrl(model.eq),
					function ($) {
						return $.Ds;
					}),
				PL: $elm$core$Maybe$Nothing
			}),
		Pu: $elm$core$Basics$always($elm$core$Maybe$Nothing),
		WI: function ($) {
			return $.Dt;
		},
		e3: $elm$core$Maybe$Nothing,
		e4: id
	};
};
var $elm$core$Platform$Sub$map = _Platform_map;
var $author$project$View$Autocomplete$Http$SetAutocomplete = function (a) {
	return {$: 5, a: a};
};
var $author$project$View$Autocomplete$Http$SetInputFromAutocomplete = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$View$Autocomplete$Http$Close = {$: 6};
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {E6: pids, Ob: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {qs: event, wF: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.E6,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.wF;
		var event = _v0.qs;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.Ob);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onMouseDown = A2($elm$browser$Browser$Events$on, 0, 'mousedown');
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Data$DropDown$invertDecoder = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (maybe) {
			return _Utils_eq(maybe, $elm$core$Maybe$Nothing) ? $elm$json$Json$Decode$succeed(0) : $elm$json$Json$Decode$fail('');
		},
		$elm$json$Json$Decode$maybe(decoder));
};
var $author$project$Data$DropDown$succeedIfBloodlineHasId = function (targetId) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (id) {
			return _Utils_eq(id, targetId) ? $elm$json$Json$Decode$succeed(0) : A2(
				$elm$json$Json$Decode$field,
				'parentNode',
				$author$project$Data$DropDown$succeedIfBloodlineHasId(targetId));
		},
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
};
var $author$project$Data$DropDown$succeedIfClickOustideOfId = function (targetId) {
	return $author$project$Data$DropDown$invertDecoder(
		A2(
			$elm$json$Json$Decode$field,
			'relatedTarget',
			$author$project$Data$DropDown$succeedIfBloodlineHasId(targetId)));
};
var $author$project$View$Autocomplete$Http$clickOutSideSubscription = function (config) {
	return $elm$browser$Browser$Events$onMouseDown(
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Basics$always(
				config.xp($author$project$View$Autocomplete$Http$Close)),
			$author$project$Data$DropDown$succeedIfClickOustideOfId(config.cO)));
};
var $wernerdegroot$listzipper$List$Zipper$current = function (_v0) {
	var x = _v0.b;
	return x;
};
var $author$project$Keyboard$matchKey = F2(
	function (key, msg) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (s) {
				return _Utils_eq(key, s) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('Not a match');
			},
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	});
var $author$project$Data$Autocomplete$HasFocus = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Autocomplete$NoFocus = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Data$Autocomplete$NothingToSuggest = {$: 2};
var $wernerdegroot$listzipper$List$Zipper$after = function (_v0) {
	var rs = _v0.c;
	return rs;
};
var $wernerdegroot$listzipper$List$Zipper$Zipper = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $wernerdegroot$listzipper$List$Zipper$first = function (zipper) {
	var ls = zipper.a;
	var x = zipper.b;
	var rs = zipper.c;
	var _v0 = $elm$core$List$reverse(ls);
	if (!_v0.b) {
		return zipper;
	} else {
		var y = _v0.a;
		var ys = _v0.b;
		return A3(
			$wernerdegroot$listzipper$List$Zipper$Zipper,
			_List_Nil,
			y,
			_Utils_ap(
				ys,
				_Utils_ap(
					_List_fromArray(
						[x]),
					rs)));
	}
};
var $wernerdegroot$listzipper$List$Zipper$fromCons = F2(
	function (x, xs) {
		return A3($wernerdegroot$listzipper$List$Zipper$Zipper, _List_Nil, x, xs);
	});
var $wernerdegroot$listzipper$List$Zipper$next = function (_v0) {
	var ls = _v0.a;
	var x = _v0.b;
	var rs = _v0.c;
	if (!rs.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var y = rs.a;
		var ys = rs.b;
		return $elm$core$Maybe$Just(
			A3(
				$wernerdegroot$listzipper$List$Zipper$Zipper,
				A2($elm$core$List$cons, x, ls),
				y,
				ys));
	}
};
var $author$project$Data$Autocomplete$next = function (suggestions) {
	switch (suggestions.$) {
		case 3:
			return $author$project$Data$Autocomplete$Unknown;
		case 2:
			return $author$project$Data$Autocomplete$NothingToSuggest;
		case 0:
			var x = suggestions.a;
			var xs = suggestions.b;
			return $author$project$Data$Autocomplete$HasFocus(
				$wernerdegroot$listzipper$List$Zipper$first(
					A2($wernerdegroot$listzipper$List$Zipper$fromCons, x, xs)));
		default:
			var zipper = suggestions.a;
			var _v1 = $wernerdegroot$listzipper$List$Zipper$next(zipper);
			if (_v1.$ === 1) {
				return A2(
					$author$project$Data$Autocomplete$NoFocus,
					$wernerdegroot$listzipper$List$Zipper$current(
						$wernerdegroot$listzipper$List$Zipper$first(zipper)),
					$wernerdegroot$listzipper$List$Zipper$after(
						$wernerdegroot$listzipper$List$Zipper$first(zipper)));
			} else {
				var zipper_ = _v1.a;
				return $author$project$Data$Autocomplete$HasFocus(zipper_);
			}
	}
};
var $wernerdegroot$listzipper$List$Zipper$last = function (zipper) {
	var ls = zipper.a;
	var x = zipper.b;
	var rs = zipper.c;
	var _v0 = $elm$core$List$reverse(rs);
	if (!_v0.b) {
		return zipper;
	} else {
		var y = _v0.a;
		var ys = _v0.b;
		return A3(
			$wernerdegroot$listzipper$List$Zipper$Zipper,
			_Utils_ap(
				ys,
				_Utils_ap(
					_List_fromArray(
						[x]),
					ls)),
			y,
			_List_Nil);
	}
};
var $wernerdegroot$listzipper$List$Zipper$previous = function (_v0) {
	var ls = _v0.a;
	var x = _v0.b;
	var rs = _v0.c;
	if (!ls.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var y = ls.a;
		var ys = ls.b;
		return $elm$core$Maybe$Just(
			A3(
				$wernerdegroot$listzipper$List$Zipper$Zipper,
				ys,
				y,
				A2($elm$core$List$cons, x, rs)));
	}
};
var $author$project$Data$Autocomplete$previous = function (suggestions) {
	switch (suggestions.$) {
		case 3:
			return $author$project$Data$Autocomplete$Unknown;
		case 2:
			return $author$project$Data$Autocomplete$NothingToSuggest;
		case 0:
			var x = suggestions.a;
			var xs = suggestions.b;
			return $author$project$Data$Autocomplete$HasFocus(
				$wernerdegroot$listzipper$List$Zipper$last(
					A2($wernerdegroot$listzipper$List$Zipper$fromCons, x, xs)));
		default:
			var zipper = suggestions.a;
			var _v1 = $wernerdegroot$listzipper$List$Zipper$previous(zipper);
			if (_v1.$ === 1) {
				return A2(
					$author$project$Data$Autocomplete$NoFocus,
					$wernerdegroot$listzipper$List$Zipper$current(
						$wernerdegroot$listzipper$List$Zipper$first(zipper)),
					$wernerdegroot$listzipper$List$Zipper$after(
						$wernerdegroot$listzipper$List$Zipper$first(zipper)));
			} else {
				var zipper_ = _v1.a;
				return $author$project$Data$Autocomplete$HasFocus(zipper_);
			}
	}
};
var $author$project$View$Autocomplete$Http$navigationSubscriptions = function (autocomplete) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$author$project$Keyboard$matchKey,
				'ArrowUp',
				$author$project$View$Autocomplete$Http$SetAutocomplete(
					$author$project$Data$Autocomplete$previous(autocomplete))),
				A2(
				$author$project$Keyboard$matchKey,
				'ArrowDown',
				$author$project$View$Autocomplete$Http$SetAutocomplete(
					$author$project$Data$Autocomplete$next(autocomplete))),
				A2(
				$author$project$Keyboard$matchKey,
				'Escape',
				$author$project$View$Autocomplete$Http$SetAutocomplete($author$project$Data$Autocomplete$unknown))
			]));
};
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
var $author$project$View$Autocomplete$Http$subscriptions = F2(
	function (config, _v0) {
		var state = _v0;
		var _v1 = state.s;
		switch (_v1.$) {
			case 3:
				return $elm$core$Platform$Sub$none;
			case 2:
				return $elm$core$Platform$Sub$batch(
					_List_fromArray(
						[
							$author$project$View$Autocomplete$Http$clickOutSideSubscription(config),
							A2(
							$elm$core$Platform$Sub$map,
							config.xp,
							$elm$browser$Browser$Events$onKeyDown(
								A2(
									$author$project$Keyboard$matchKey,
									'Escape',
									$author$project$View$Autocomplete$Http$SetAutocomplete($author$project$Data$Autocomplete$unknown))))
						]));
			case 0:
				return $elm$core$Platform$Sub$batch(
					_List_fromArray(
						[
							$author$project$View$Autocomplete$Http$clickOutSideSubscription(config),
							A2(
							$elm$core$Platform$Sub$map,
							config.xp,
							$elm$browser$Browser$Events$onKeyDown(
								$author$project$View$Autocomplete$Http$navigationSubscriptions(state.s)))
						]));
			default:
				var autocomplete = _v1.a;
				return $elm$browser$Browser$Events$onKeyDown(
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								function () {
								var _v2 = _Utils_Tuple2(
									$wernerdegroot$listzipper$List$Zipper$current(autocomplete),
									config.Wv);
								if (!_v2.a.$) {
									if (_v2.b.$ === 1) {
										var suggestion = _v2.a.a;
										var btn = _v2.b.a;
										return $elm$json$Json$Decode$oneOf(
											_List_fromArray(
												[
													A2(
													$author$project$Keyboard$matchKey,
													'Enter',
													btn.Wu(suggestion)),
													A2(
													$author$project$Keyboard$matchKey,
													'Tab',
													btn.Wu(suggestion))
												]));
									} else {
										var suggestion = _v2.a.a;
										return A2(
											$elm$json$Json$Decode$map,
											config.xp,
											A2(
												$author$project$Keyboard$matchKey,
												'Tab',
												A2(
													$author$project$View$Autocomplete$Http$SetInputFromAutocomplete,
													config.cO,
													config.WI(suggestion))));
									}
								} else {
									return $elm$json$Json$Decode$fail('');
								}
							}(),
								A2(
								$elm$json$Json$Decode$map,
								config.xp,
								$author$project$View$Autocomplete$Http$navigationSubscriptions(state.s))
							])));
		}
	});
var $author$project$View$FilterOptionSuggestions$subscriptions = F2(
	function (lift, model) {
		return A2(
			$elm$core$Platform$Sub$map,
			lift,
			$elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$author$project$View$Autocomplete$Http$subscriptions,
						$author$project$View$FilterOptionSuggestions$filterSearchConfig(model),
						model.aC)
					])));
	});
var $author$project$VacancyFilterOptionSearch$subscriptions = function (model) {
	return A2($author$project$View$FilterOptionSuggestions$subscriptions, $elm$core$Basics$identity, model.bD);
};
var $author$project$View$Autocomplete$Http$currentlyFocussedValue = function (_v0) {
	var state = _v0;
	var _v1 = state.s;
	if (_v1.$ === 1) {
		var suggestions = _v1.a;
		var _v2 = $wernerdegroot$listzipper$List$Zipper$current(suggestions);
		if (!_v2.$) {
			var suggestion = _v2.a;
			return $elm$core$Maybe$Just(suggestion);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$View$Autocomplete$Http$GotSuggestions = function (a) {
	return {$: 4, a: a};
};
var $author$project$View$Autocomplete$Http$NoOp = {$: 0};
var $author$project$View$Autocomplete$Http$RequestSuggestions = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$View$Autocomplete$Http$Suggestion = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Autocomplete$Http$TotalSuggestions = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $author$project$Data$Autocomplete$blur = function (suggestions) {
	switch (suggestions.$) {
		case 3:
			return $author$project$Data$Autocomplete$Unknown;
		case 2:
			return $author$project$Data$Autocomplete$NothingToSuggest;
		case 0:
			var x = suggestions.a;
			var xs = suggestions.b;
			return A2($author$project$Data$Autocomplete$NoFocus, x, xs);
		default:
			var zipper = suggestions.a;
			return A2(
				$author$project$Data$Autocomplete$NoFocus,
				$wernerdegroot$listzipper$List$Zipper$current(
					$wernerdegroot$listzipper$List$Zipper$first(zipper)),
				$wernerdegroot$listzipper$List$Zipper$after(
					$wernerdegroot$listzipper$List$Zipper$first(zipper)));
	}
};
var $elm$http$Http$cancel = function (tracker) {
	return $elm$http$Http$command(
		$elm$http$Http$Cancel(tracker));
};
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Data$Autocomplete$noFocus = $author$project$Data$Autocomplete$NoFocus;
var $author$project$Data$Autocomplete$nothingToSuggest = $author$project$Data$Autocomplete$NothingToSuggest;
var $author$project$Data$Autocomplete$fromList = function (xs) {
	if (xs.b) {
		var y = xs.a;
		var ys = xs.b;
		return A2($author$project$Data$Autocomplete$noFocus, y, ys);
	} else {
		return $author$project$Data$Autocomplete$nothingToSuggest;
	}
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation = F2(
	function (replacements, _v0) {
		var match = _v0.Vq;
		var ordinalString = A2(
			$elm$core$Basics$composeL,
			$elm$core$String$dropLeft(1),
			$elm$core$String$dropRight(1))(match);
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function (value) {
					return A2($elm$core$Array$get, value, replacements);
				},
				$elm$core$String$toInt(ordinalString)));
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{y: nodeList, r: nodeListSize, t: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {uN: index, Vq: match, VO: number, N8: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{Uo: false, Vw: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('\\{\\d+\\}'));
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $lukewestby$elm_string_interpolate$String$Interpolate$interpolate = F2(
	function (string, args) {
		var asArray = $elm$core$Array$fromList(args);
		return A3(
			$elm$regex$Regex$replace,
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex,
			$lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation(asArray),
			string);
	});
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Data$Key$nextKey = function (_v0) {
	var k = _v0;
	return k + 1;
};
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$View$Autocomplete$Http$update = F4(
	function (lift, config, msg, state_) {
		var state = state_;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map(lift),
			function () {
				switch (msg.$) {
					case 0:
						return _Utils_Tuple2(state_, $elm$core$Platform$Cmd$none);
					case 6:
						return _Utils_Tuple2(
							_Utils_update(
								state,
								{s: $author$project$Data$Autocomplete$unknown}),
							$elm$core$Platform$Cmd$none);
					case 2:
						var id = msg.a;
						var suggestion = msg.b;
						return _Utils_Tuple2(
							_Utils_update(
								state,
								{s: $author$project$Data$Autocomplete$unknown, T: suggestion}),
							A2(
								$elm$core$Task$attempt,
								function (_v1) {
									return $author$project$View$Autocomplete$Http$NoOp;
								},
								$elm$browser$Browser$Dom$focus(
									A2(
										$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
										'form-input-{0}',
										_List_fromArray(
											[id])))));
					case 1:
						if (msg.a === '') {
							var val = msg.a;
							return _Utils_Tuple2(
								{
									s: $author$project$Data$Autocomplete$unknown,
									T: val,
									wF: $author$project$Data$Key$nextKey(state.wF)
								},
								$elm$core$Platform$Cmd$none);
						} else {
							var val = msg.a;
							var nextKey = $author$project$Data$Key$nextKey(state.wF);
							var _v2 = ($elm$core$String$length(val) >= 2) ? _Utils_Tuple2(
								$author$project$Data$Autocomplete$blur(state.s),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$elm$http$Http$cancel(config.e4),
											A2(
											$elm$core$Task$perform,
											function (_v3) {
												return A2($author$project$View$Autocomplete$Http$RequestSuggestions, nextKey, val);
											},
											$elm$core$Process$sleep(500))
										]))) : _Utils_Tuple2($author$project$Data$Autocomplete$unknown, $elm$core$Platform$Cmd$none);
							var autocomplete = _v2.a;
							var querySuggestCmd = _v2.b;
							return _Utils_Tuple2(
								{s: autocomplete, T: val, wF: nextKey},
								querySuggestCmd);
						}
					case 3:
						var key = msg.a;
						var val = msg.b;
						return _Utils_eq(key, state.wF) ? _Utils_Tuple2(
							state_,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$View$Autocomplete$Http$GotSuggestions,
								config.Ie(val))) : _Utils_Tuple2(state_, $elm$core$Platform$Cmd$none);
					case 4:
						if (!msg.a.$) {
							var _v4 = msg.a.a;
							var suggestions = _v4.a;
							var maybeTotal = _v4.b;
							var totalToHref = function () {
								var _v7 = config.Wv;
								if (!_v7.$) {
									var x = _v7.a;
									return A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$always(0),
										x.PL);
								} else {
									var x = _v7.a;
									return A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$always(0),
										x.WL);
								}
							}();
							var total = function () {
								var _v5 = A3($elm$core$Maybe$map2, $elm$core$Tuple$pair, maybeTotal, totalToHref);
								if (_v5.$ === 1) {
									return _List_Nil;
								} else {
									var _v6 = _v5.a;
									var n = _v6.a;
									return (n > 5) ? _List_fromArray(
										[
											$author$project$View$Autocomplete$Http$TotalSuggestions(n)
										]) : _List_Nil;
								}
							}();
							return _Utils_Tuple2(
								_Utils_update(
									state,
									{
										s: $author$project$Data$Autocomplete$fromList(
											_Utils_ap(
												A2($elm$core$List$map, $author$project$View$Autocomplete$Http$Suggestion, suggestions),
												total))
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
						}
					default:
						var autocomplete = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								state,
								{s: autocomplete}),
							$elm$core$Platform$Cmd$none);
				}
			}());
	});
var $author$project$View$FilterOptionSuggestions$update = F2(
	function (msg, model) {
		if (!msg.$) {
			return _Utils_Tuple2(
				model,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								$elm$browser$Browser$Navigation$load,
								$author$project$View$FilterOptionSuggestions$toUrl(model.eq)),
							function ($) {
								return $.Ds;
							}),
						$author$project$View$Autocomplete$Http$currentlyFocussedValue(model.aC))));
		} else {
			var autoMsg = msg.a;
			var _v1 = A4(
				$author$project$View$Autocomplete$Http$update,
				$author$project$View$FilterOptionSuggestions$FilterOptionAutocompleteMsg,
				$author$project$View$FilterOptionSuggestions$filterSearchConfig(model),
				autoMsg,
				model.aC);
			var autocompleteState = _v1.a;
			var autocompleteCmds = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{aC: autocompleteState}),
				autocompleteCmds);
		}
	});
var $author$project$VacancyFilterOptionSearch$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A2($author$project$View$FilterOptionSuggestions$update, subMsg, model.bD);
		var model_ = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{bD: model_}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$json$Json$Encode$string = _Json_wrap;
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $author$project$View$FilterOptionSuggestions$OnSubmit = {$: 0};
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $elm$html$Html$form = _VirtualDom_node('form');
var $author$project$View$Autocomplete$Http$OnInput = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $wernerdegroot$listzipper$List$Zipper$before = function (_v0) {
	var ls = _v0.a;
	return $elm$core$List$reverse(ls);
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Util$View$viewMaybe = F2(
	function (maybe, html) {
		if (!maybe.$) {
			var a = maybe.a;
			return html(a);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $wernerdegroot$listzipper$List$Zipper$find = F2(
	function (predicate, zipper) {
		find:
		while (true) {
			var ls = zipper.a;
			var x = zipper.b;
			var rs = zipper.c;
			if (predicate(x)) {
				return $elm$core$Maybe$Just(zipper);
			} else {
				var _v0 = $wernerdegroot$listzipper$List$Zipper$next(zipper);
				if (!_v0.$) {
					var nextZipper = _v0.a;
					var $temp$predicate = predicate,
						$temp$zipper = nextZipper;
					predicate = $temp$predicate;
					zipper = $temp$zipper;
					continue find;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $wernerdegroot$listzipper$List$Zipper$findFirst = function (predicate) {
	return A2(
		$elm$core$Basics$composeL,
		$wernerdegroot$listzipper$List$Zipper$find(predicate),
		$wernerdegroot$listzipper$List$Zipper$first);
};
var $author$project$Data$Autocomplete$focus = F2(
	function (val, suggestions) {
		switch (suggestions.$) {
			case 3:
				return $author$project$Data$Autocomplete$Unknown;
			case 2:
				return $author$project$Data$Autocomplete$NothingToSuggest;
			case 0:
				var x = suggestions.a;
				var xs = suggestions.b;
				var _v1 = A2(
					$wernerdegroot$listzipper$List$Zipper$findFirst,
					$elm$core$Basics$eq(val),
					A2($wernerdegroot$listzipper$List$Zipper$fromCons, x, xs));
				if (_v1.$ === 1) {
					return suggestions;
				} else {
					var zipper_ = _v1.a;
					return $author$project$Data$Autocomplete$HasFocus(zipper_);
				}
			default:
				var zipper = suggestions.a;
				var _v2 = A2(
					$wernerdegroot$listzipper$List$Zipper$findFirst,
					$elm$core$Basics$eq(val),
					zipper);
				if (_v2.$ === 1) {
					return suggestions;
				} else {
					var zipper_ = _v2.a;
					return $author$project$Data$Autocomplete$HasFocus(zipper_);
				}
		}
	});
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseOut = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseout',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseOver = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$View$Autocomplete$Http$viewSuggestionValue = F2(
	function (config, suggestion) {
		var _v0 = config.Pu(suggestion);
		if (_v0.$ === 1) {
			return $elm$html$Html$text(
				config.WI(suggestion));
		} else {
			var count = _v0.a;
			return $elm$html$Html$text(
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0} ({1})',
					_List_fromArray(
						[
							config.WI(suggestion),
							$elm$core$String$fromInt(count)
						])));
		}
	});
var $author$project$View$Autocomplete$Http$viewSuggestion = F5(
	function (config, inputValue, suggestions, extraClass, suggestionOrTotal) {
		var focus = A3(
			$elm$core$Basics$composeL,
			config.xp,
			$author$project$View$Autocomplete$Http$SetAutocomplete,
			A2($author$project$Data$Autocomplete$focus, suggestionOrTotal, suggestions));
		var blur = A3(
			$elm$core$Basics$composeL,
			config.xp,
			$author$project$View$Autocomplete$Http$SetAutocomplete,
			$author$project$Data$Autocomplete$blur(suggestions));
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Events$onMouseOver(focus),
					$elm$html$Html$Events$onMouseOut(blur)
				]),
			function () {
				if (!suggestionOrTotal.$) {
					var suggestion = suggestionOrTotal.a;
					var _v1 = config.Wv;
					if (!_v1.$) {
						var link = _v1.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(
										link.Wt(suggestion)),
										$elm$html$Html$Attributes$class('search-suggestion ' + extraClass)
									]),
								_List_fromArray(
									[
										A2($author$project$View$Autocomplete$Http$viewSuggestionValue, config, suggestion)
									]))
							]);
					} else {
						var btn = _v1.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										btn.Wu(suggestion)),
										$elm$html$Html$Attributes$class('search-suggestion ' + extraClass)
									]),
								_List_fromArray(
									[
										A2($author$project$View$Autocomplete$Http$viewSuggestionValue, config, suggestion)
									]))
							]);
					}
				} else {
					var total = suggestionOrTotal.a;
					var _v2 = config.Wv;
					if (!_v2.$) {
						var link = _v2.a;
						var _v3 = link.PL;
						if (_v3.$ === 1) {
							return _List_Nil;
						} else {
							var f = _v3.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											A2(f, total, inputValue).IA),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('search-suggestion', true),
													_Utils_Tuple2(extraClass, true),
													_Utils_Tuple2(
													A2($elm$core$Maybe$withDefault, '', config.e3),
													true)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(f, total, inputValue).WC)
										]))
								]);
						}
					} else {
						var btn = _v2.a;
						var _v4 = btn.WL;
						if (_v4.$ === 1) {
							return _List_Nil;
						} else {
							var f = _v4.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											A2(f, total, inputValue).WG),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('search-suggestion', true),
													_Utils_Tuple2(extraClass, true),
													_Utils_Tuple2(
													A2($elm$core$Maybe$withDefault, '', config.e3),
													true)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(f, total, inputValue).WC)
										]))
								]);
						}
					}
				}
			}());
	});
var $author$project$View$Autocomplete$Http$viewAutocomplete = F3(
	function (inputValue, suggestions, config) {
		var viewSuggestion_ = F2(
			function (extraClass, suggestion) {
				return A5($author$project$View$Autocomplete$Http$viewSuggestion, config, inputValue, suggestions, extraClass, suggestion);
			});
		switch (suggestions.$) {
			case 3:
				return $elm$html$Html$text('');
			case 2:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('search-suggestions')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('search-suggestion')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(config.B1)
								]))
						]));
			case 0:
				var hd = suggestions.a;
				var tail = suggestions.b;
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('search-suggestions')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								A2(
								$elm$core$List$map,
								viewSuggestion_(''),
								A2($elm$core$List$cons, hd, tail)),
								_List_fromArray(
								[
									A2(
									$author$project$Util$View$viewMaybe,
									config.dT,
									function (url) {
										return A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(url)
												]),
											_List_Nil);
									})
								])
							])));
			default:
				var suggestions_ = suggestions.a;
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('search-suggestions')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								A2(
								$elm$core$List$map,
								viewSuggestion_(''),
								$wernerdegroot$listzipper$List$Zipper$before(suggestions_)),
								_List_fromArray(
								[
									A2(
									viewSuggestion_,
									'-current',
									$wernerdegroot$listzipper$List$Zipper$current(suggestions_))
								]),
								A2(
								$elm$core$List$map,
								viewSuggestion_(''),
								$wernerdegroot$listzipper$List$Zipper$after(suggestions_)),
								_List_fromArray(
								[
									A2(
									$author$project$Util$View$viewMaybe,
									config.dT,
									function (url) {
										return A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(url)
												]),
											_List_Nil);
									})
								])
							])));
		}
	});
var $author$project$View$Autocomplete$Http$view = F2(
	function (config, _v0) {
		var state = _v0;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				config.xp,
				A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$name(config.cO),
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$autocomplete(false),
							$elm$html$Html$Attributes$class('form-input'),
							$elm$html$Html$Attributes$id(
							A2(
								$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
								'form-input-{0}',
								_List_fromArray(
									[config.cO]))),
							$elm$html$Html$Attributes$placeholder(config.dd),
							$elm$html$Html$Attributes$value(state.T),
							$elm$html$Html$Events$onInput($author$project$View$Autocomplete$Http$OnInput)
						]),
					_List_Nil)),
				A3($author$project$View$Autocomplete$Http$viewAutocomplete, state.T, state.s, config)
			]);
	});
var $author$project$View$FilterOptionSuggestions$viewFilterSearch = function (model) {
	var msg = $elm$json$Json$Decode$succeed(
		{bp: $author$project$View$FilterOptionSuggestions$OnSubmit, V1: true, Wo: true});
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-search'),
					A2($elm$html$Html$Events$custom, 'submit', msg)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-field')
						]),
					A2(
						$author$project$View$Autocomplete$Http$view,
						$author$project$View$FilterOptionSuggestions$filterSearchConfig(model),
						model.aC))
				]))
		]);
};
var $author$project$View$FilterOptionSuggestions$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-bar-content')
			]),
		$author$project$View$FilterOptionSuggestions$viewFilterSearch(model));
};
var $author$project$VacancyFilterOptionSearch$view = function (model) {
	return A2(
		$elm$html$Html$map,
		$elm$core$Basics$identity,
		$author$project$View$FilterOptionSuggestions$view(model.bD));
};
var $author$project$VacancyFilterOptionSearch$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$Model$Component$Properties$VacancyFilterOptionSearch$Flags$flagsDecoder,
	{cR: $author$project$VacancyFilterOptionSearch$init, dC: $author$project$VacancyFilterOptionSearch$subscriptions, dJ: $author$project$VacancyFilterOptionSearch$update, dM: $author$project$VacancyFilterOptionSearch$view});
var $author$project$TravelTime$Flags = F6(
	function (id, domain, windowWidth, latitude, longitude, sessionToken) {
		return {oU: domain, cO: id, w8: latitude, yg: longitude, av: sessionToken, ch: windowWidth};
	});
var $author$project$Data$Entity$Entity = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Data$Entity$decoder = A2(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Entity$Entity,
	A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decoder));
var $author$project$Model$Domain$Domain = function (addressEnabled) {
	return function (altCss) {
		return function (betterUptimeUrl) {
			return function (consentDefault) {
				return function (corporateWebsite) {
					return function (corporateWebsiteUrl) {
						return function (cssClass) {
							return function (customFavicon) {
								return function (customLogo) {
									return function (domainSwitchLabel) {
										return function (email) {
											return function (googleAnalyticsApiKey) {
												return function (googleAnalyticsStreamId) {
													return function (googleCloudApiKey) {
														return function (googleCloudMapsApiKey) {
															return function (googleDataStudioUrl) {
																return function (googleGeocodingRegion) {
																	return function (googleTagManagerId) {
																		return function (headSnippets) {
																			return function (headerJobAlertTitle) {
																				return function (hoursFilterEnabled) {
																					return function (includeInCmsSwitch) {
																						return function (includeInLanguageSwitch) {
																							return function (includeInTopBarDomainSwitch) {
																								return function (indeedConversionCode) {
																									return function (indeedFulltimeThreshold) {
																										return function (isInternal) {
																											return function (isNonVacancyDomain) {
																												return function (label) {
																													return function (langCode) {
																														return function (linkedDomainKey) {
																															return function (linkedInPixel) {
																																return function (locationUrlPrefix) {
																																	return function (mobileSubMenuToggle) {
																																		return function (name) {
																																			return function (pathPrefix) {
																																				return function (possibleAltCss) {
																																					return function (postmarkApiKey) {
																																						return function (region) {
																																							return function (salaryFilterEnabled) {
																																								return function (samlLoginText) {
																																									return function (seedPages) {
																																										return function (showDomainSwitch) {
																																											return function (systemPreferences) {
																																												return function (title) {
																																													return function (vacancyDetailMetadata) {
																																														return function (vacancyItemImageDefault) {
																																															return function (vacancyOverviewMetadata) {
																																																return function (whatsappNumber) {
																																																	return function (whatsappConfig) {
																																																		return function (seqNo) {
																																																			return {f1: addressEnabled, gD: altCss, Uj: betterUptimeUrl, l9: consentDefault, mD: corporateWebsite, mE: corporateWebsiteUrl, m6: cssClass, nn: customFavicon, nr: customLogo, oW: domainSwitchLabel, d4: email, sU: googleAnalyticsApiKey, U9: googleAnalyticsStreamId, Va: googleCloudApiKey, sW: googleCloudMapsApiKey, Vb: googleDataStudioUrl, sX: googleGeocodingRegion, sY: googleTagManagerId, tx: headSnippets, ty: headerJobAlertTitle, t3: hoursFilterEnabled, uH: includeInCmsSwitch, uI: includeInLanguageSwitch, uJ: includeInTopBarDomainSwitch, uK: indeedConversionCode, uL: indeedFulltimeThreshold, Vk: isInternal, vP: isNonVacancyDomain, bj: label, wS: langCode, xH: linkedDomainKey, xI: linkedInPixel, x2: locationUrlPrefix, zz: mobileSubMenuToggle, c4: name, VV: pathPrefix, Fp: possibleAltCss, FB: postmarkApiKey, V8: region, I$: salaryFilterEnabled, I7: samlLoginText, JD: seedPages, Lb: seqNo, LQ: showDomainSwitch, OE: systemPreferences, WC: title, RZ: vacancyDetailMetadata, R9: vacancyItemImageDefault, Se: vacancyOverviewMetadata, dO: whatsappConfig, Tv: whatsappNumber};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$AltCss$AltCss = F2(
	function (label, file) {
		return {rp: file, bj: label};
	});
var $author$project$Model$AltCss$altCssDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'file',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'label',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$AltCss$AltCss)));
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Model$CookieConsent$Functional = 1;
var $author$project$Model$CookieConsent$Marketing = 3;
var $author$project$Model$CookieConsent$Necessary = 0;
var $author$project$Model$CookieConsent$Statistics = 2;
var $author$project$Model$CookieConsent$cookieConsentDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'necessary':
				return $elm$json$Json$Decode$succeed(0);
			case 'functional':
				return $elm$json$Json$Decode$succeed(1);
			case 'statistics':
				return $elm$json$Json$Decode$succeed(2);
			case 'marketing':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$CorporateLink = F2(
	function (url, label) {
		return {bj: label, dK: url};
	});
var $author$project$Model$corporateLinkDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'label',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'url',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$CorporateLink)));
var $author$project$Model$WhatsappConfig$WhatsappConfig = F4(
	function (countryCallingCode, phone, disable, btnText) {
		return {dW: btnText, d$: countryCallingCode, d2: disable, aM: phone};
	});
var $author$project$Util$Json$maybeToDecoder = F2(
	function (decoder, f) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (x) {
				var _v0 = f(x);
				if (_v0.$ === 1) {
					return $elm$json$Json$Decode$fail('Maybe value was Nothing');
				} else {
					var y = _v0.a;
					return $elm$json$Json$Decode$succeed(y);
				}
			},
			decoder);
	});
var $author$project$Util$Json$enumDecoder = function (fromString) {
	return A2($author$project$Util$Json$maybeToDecoder, $elm$json$Json$Decode$string, fromString);
};
var $author$project$Model$CountryCallingCode$Afghanistan = 0;
var $author$project$Model$CountryCallingCode$AlandIslands = 1;
var $author$project$Model$CountryCallingCode$Albania = 2;
var $author$project$Model$CountryCallingCode$Algeria = 3;
var $author$project$Model$CountryCallingCode$AmericanSamoa = 4;
var $author$project$Model$CountryCallingCode$Andorra = 5;
var $author$project$Model$CountryCallingCode$Angola = 6;
var $author$project$Model$CountryCallingCode$Anguilla = 7;
var $author$project$Model$CountryCallingCode$AntiguaandBarbuda = 8;
var $author$project$Model$CountryCallingCode$Argentina = 9;
var $author$project$Model$CountryCallingCode$Armenia = 10;
var $author$project$Model$CountryCallingCode$Aruba = 11;
var $author$project$Model$CountryCallingCode$Australia = 12;
var $author$project$Model$CountryCallingCode$Austria = 13;
var $author$project$Model$CountryCallingCode$Azerbaijan = 14;
var $author$project$Model$CountryCallingCode$Bahamas = 15;
var $author$project$Model$CountryCallingCode$Bahrain = 16;
var $author$project$Model$CountryCallingCode$Bangladesh = 17;
var $author$project$Model$CountryCallingCode$Barbados = 18;
var $author$project$Model$CountryCallingCode$Belarus = 19;
var $author$project$Model$CountryCallingCode$Belgium = 20;
var $author$project$Model$CountryCallingCode$Belize = 21;
var $author$project$Model$CountryCallingCode$Benin = 22;
var $author$project$Model$CountryCallingCode$Bermuda = 23;
var $author$project$Model$CountryCallingCode$Bhutan = 24;
var $author$project$Model$CountryCallingCode$Bolivia = 25;
var $author$project$Model$CountryCallingCode$BosniaandHerzegovina = 26;
var $author$project$Model$CountryCallingCode$Botswana = 27;
var $author$project$Model$CountryCallingCode$Brazil = 28;
var $author$project$Model$CountryCallingCode$BritishIndianOceanTerritory = 29;
var $author$project$Model$CountryCallingCode$BritishVirginIslands = 30;
var $author$project$Model$CountryCallingCode$Brunei = 31;
var $author$project$Model$CountryCallingCode$Bulgaria = 32;
var $author$project$Model$CountryCallingCode$BurkinaFaso = 33;
var $author$project$Model$CountryCallingCode$Burundi = 34;
var $author$project$Model$CountryCallingCode$Cambodia = 35;
var $author$project$Model$CountryCallingCode$Cameroon = 36;
var $author$project$Model$CountryCallingCode$Canada = 37;
var $author$project$Model$CountryCallingCode$CapeVerde = 38;
var $author$project$Model$CountryCallingCode$CaribbeanNetherlands = 39;
var $author$project$Model$CountryCallingCode$CaymanIslands = 40;
var $author$project$Model$CountryCallingCode$CentralAfricanRepublic = 41;
var $author$project$Model$CountryCallingCode$Chad = 42;
var $author$project$Model$CountryCallingCode$Chile = 43;
var $author$project$Model$CountryCallingCode$China = 44;
var $author$project$Model$CountryCallingCode$ChristmasIsland = 45;
var $author$project$Model$CountryCallingCode$CocosKeelingIslands = 46;
var $author$project$Model$CountryCallingCode$Colombia = 47;
var $author$project$Model$CountryCallingCode$Comoros = 48;
var $author$project$Model$CountryCallingCode$Congo = 56;
var $author$project$Model$CountryCallingCode$CookIslands = 49;
var $author$project$Model$CountryCallingCode$CostaRica = 50;
var $author$project$Model$CountryCallingCode$Croatia = 51;
var $author$project$Model$CountryCallingCode$Cuba = 52;
var $author$project$Model$CountryCallingCode$Curacao = 53;
var $author$project$Model$CountryCallingCode$Cyprus = 54;
var $author$project$Model$CountryCallingCode$CzechRepublic = 55;
var $author$project$Model$CountryCallingCode$Denmark = 57;
var $author$project$Model$CountryCallingCode$Djibouti = 58;
var $author$project$Model$CountryCallingCode$Dominica = 59;
var $author$project$Model$CountryCallingCode$DominicanRepublic = 60;
var $author$project$Model$CountryCallingCode$Ecuador = 61;
var $author$project$Model$CountryCallingCode$Egypt = 62;
var $author$project$Model$CountryCallingCode$ElSalvador = 63;
var $author$project$Model$CountryCallingCode$EquatorialGuinea = 64;
var $author$project$Model$CountryCallingCode$Eritrea = 65;
var $author$project$Model$CountryCallingCode$Estonia = 66;
var $author$project$Model$CountryCallingCode$Eswatini = 67;
var $author$project$Model$CountryCallingCode$Ethiopia = 68;
var $author$project$Model$CountryCallingCode$FalklandIslands = 69;
var $author$project$Model$CountryCallingCode$FaroeIslands = 70;
var $author$project$Model$CountryCallingCode$Fiji = 71;
var $author$project$Model$CountryCallingCode$Finland = 72;
var $author$project$Model$CountryCallingCode$France = 73;
var $author$project$Model$CountryCallingCode$FrenchGuiana = 74;
var $author$project$Model$CountryCallingCode$FrenchPolynesia = 75;
var $author$project$Model$CountryCallingCode$Gabon = 76;
var $author$project$Model$CountryCallingCode$Gambia = 77;
var $author$project$Model$CountryCallingCode$Georgia = 78;
var $author$project$Model$CountryCallingCode$Germany = 79;
var $author$project$Model$CountryCallingCode$Ghana = 80;
var $author$project$Model$CountryCallingCode$Gibraltar = 81;
var $author$project$Model$CountryCallingCode$Greece = 82;
var $author$project$Model$CountryCallingCode$Greenland = 83;
var $author$project$Model$CountryCallingCode$Grenada = 84;
var $author$project$Model$CountryCallingCode$Guadeloupe = 85;
var $author$project$Model$CountryCallingCode$Guam = 86;
var $author$project$Model$CountryCallingCode$Guatemala = 87;
var $author$project$Model$CountryCallingCode$Guernsey = 88;
var $author$project$Model$CountryCallingCode$Guinea = 89;
var $author$project$Model$CountryCallingCode$GuineaBissau = 90;
var $author$project$Model$CountryCallingCode$Guyana = 91;
var $author$project$Model$CountryCallingCode$Haiti = 92;
var $author$project$Model$CountryCallingCode$Honduras = 93;
var $author$project$Model$CountryCallingCode$HongKong = 94;
var $author$project$Model$CountryCallingCode$Hungary = 95;
var $author$project$Model$CountryCallingCode$Iceland = 96;
var $author$project$Model$CountryCallingCode$India = 97;
var $author$project$Model$CountryCallingCode$Indonesia = 98;
var $author$project$Model$CountryCallingCode$Iran = 99;
var $author$project$Model$CountryCallingCode$Iraq = 100;
var $author$project$Model$CountryCallingCode$Ireland = 101;
var $author$project$Model$CountryCallingCode$IsleofMan = 102;
var $author$project$Model$CountryCallingCode$Israel = 103;
var $author$project$Model$CountryCallingCode$Italy = 104;
var $author$project$Model$CountryCallingCode$IvoryCoast = 105;
var $author$project$Model$CountryCallingCode$Jamaica = 106;
var $author$project$Model$CountryCallingCode$Japan = 107;
var $author$project$Model$CountryCallingCode$Jersey = 108;
var $author$project$Model$CountryCallingCode$Jordan = 109;
var $author$project$Model$CountryCallingCode$Kazakhstan = 110;
var $author$project$Model$CountryCallingCode$Kenya = 111;
var $author$project$Model$CountryCallingCode$Kiribati = 112;
var $author$project$Model$CountryCallingCode$Kosovo = 113;
var $author$project$Model$CountryCallingCode$Kuwait = 114;
var $author$project$Model$CountryCallingCode$Kyrgyzstan = 115;
var $author$project$Model$CountryCallingCode$Laos = 116;
var $author$project$Model$CountryCallingCode$Latvia = 117;
var $author$project$Model$CountryCallingCode$Lebanon = 118;
var $author$project$Model$CountryCallingCode$Lesotho = 119;
var $author$project$Model$CountryCallingCode$Liberia = 120;
var $author$project$Model$CountryCallingCode$Libya = 121;
var $author$project$Model$CountryCallingCode$Liechtenstein = 122;
var $author$project$Model$CountryCallingCode$Lithuania = 123;
var $author$project$Model$CountryCallingCode$Luxembourg = 124;
var $author$project$Model$CountryCallingCode$Macau = 125;
var $author$project$Model$CountryCallingCode$Macedonia = 126;
var $author$project$Model$CountryCallingCode$Madagascar = 127;
var $author$project$Model$CountryCallingCode$Malawi = 128;
var $author$project$Model$CountryCallingCode$Malaysia = 129;
var $author$project$Model$CountryCallingCode$Maldives = 130;
var $author$project$Model$CountryCallingCode$Mali = 131;
var $author$project$Model$CountryCallingCode$Malta = 132;
var $author$project$Model$CountryCallingCode$MarshallIslands = 133;
var $author$project$Model$CountryCallingCode$Martinique = 134;
var $author$project$Model$CountryCallingCode$Mauritania = 135;
var $author$project$Model$CountryCallingCode$Mauritius = 136;
var $author$project$Model$CountryCallingCode$Mayotte = 137;
var $author$project$Model$CountryCallingCode$Mexico = 138;
var $author$project$Model$CountryCallingCode$Micronesia = 139;
var $author$project$Model$CountryCallingCode$Moldova = 140;
var $author$project$Model$CountryCallingCode$Monaco = 141;
var $author$project$Model$CountryCallingCode$Mongolia = 142;
var $author$project$Model$CountryCallingCode$Montenegro = 143;
var $author$project$Model$CountryCallingCode$Montserrat = 144;
var $author$project$Model$CountryCallingCode$Morocco = 145;
var $author$project$Model$CountryCallingCode$Mozambique = 146;
var $author$project$Model$CountryCallingCode$Myanmar = 147;
var $author$project$Model$CountryCallingCode$Namibia = 148;
var $author$project$Model$CountryCallingCode$Nauru = 149;
var $author$project$Model$CountryCallingCode$Nepal = 150;
var $author$project$Model$CountryCallingCode$Netherlands = 151;
var $author$project$Model$CountryCallingCode$NewCaledonia = 152;
var $author$project$Model$CountryCallingCode$NewZealand = 153;
var $author$project$Model$CountryCallingCode$Nicaragua = 154;
var $author$project$Model$CountryCallingCode$Niger = 155;
var $author$project$Model$CountryCallingCode$Nigeria = 156;
var $author$project$Model$CountryCallingCode$Niue = 157;
var $author$project$Model$CountryCallingCode$NorfolkIsland = 158;
var $author$project$Model$CountryCallingCode$NorthKorea = 159;
var $author$project$Model$CountryCallingCode$NorthernMarianaIslands = 160;
var $author$project$Model$CountryCallingCode$Norway = 161;
var $author$project$Model$CountryCallingCode$Oman = 162;
var $author$project$Model$CountryCallingCode$Pakistan = 163;
var $author$project$Model$CountryCallingCode$Palau = 164;
var $author$project$Model$CountryCallingCode$Palestine = 165;
var $author$project$Model$CountryCallingCode$Panama = 166;
var $author$project$Model$CountryCallingCode$PapuaNewGuinea = 167;
var $author$project$Model$CountryCallingCode$Paraguay = 168;
var $author$project$Model$CountryCallingCode$Peru = 169;
var $author$project$Model$CountryCallingCode$Philippines = 170;
var $author$project$Model$CountryCallingCode$Poland = 171;
var $author$project$Model$CountryCallingCode$Portugal = 172;
var $author$project$Model$CountryCallingCode$PuertoRico = 173;
var $author$project$Model$CountryCallingCode$Qatar = 174;
var $author$project$Model$CountryCallingCode$RepublicoftheCongo = 175;
var $author$project$Model$CountryCallingCode$Reunion = 179;
var $author$project$Model$CountryCallingCode$Romania = 176;
var $author$project$Model$CountryCallingCode$Russia = 177;
var $author$project$Model$CountryCallingCode$Rwanda = 178;
var $author$project$Model$CountryCallingCode$SaintBarthelemy = 180;
var $author$project$Model$CountryCallingCode$SaintHelenaAscensionandTristandaCunha = 181;
var $author$project$Model$CountryCallingCode$SaintKittsandNevis = 182;
var $author$project$Model$CountryCallingCode$SaintLucia = 183;
var $author$project$Model$CountryCallingCode$SaintMartin = 184;
var $author$project$Model$CountryCallingCode$SaintPierreandMiquelon = 185;
var $author$project$Model$CountryCallingCode$SaintVincentandtheGrenadines = 186;
var $author$project$Model$CountryCallingCode$Samoa = 187;
var $author$project$Model$CountryCallingCode$SanMarino = 188;
var $author$project$Model$CountryCallingCode$SaoTomeandPrincipe = 189;
var $author$project$Model$CountryCallingCode$SaudiArabia = 190;
var $author$project$Model$CountryCallingCode$Senegal = 191;
var $author$project$Model$CountryCallingCode$Serbia = 192;
var $author$project$Model$CountryCallingCode$Seychelles = 193;
var $author$project$Model$CountryCallingCode$SierraLeone = 194;
var $author$project$Model$CountryCallingCode$Singapore = 195;
var $author$project$Model$CountryCallingCode$SintMaarten = 196;
var $author$project$Model$CountryCallingCode$Slovakia = 197;
var $author$project$Model$CountryCallingCode$Slovenia = 198;
var $author$project$Model$CountryCallingCode$SolomonIslands = 199;
var $author$project$Model$CountryCallingCode$Somalia = 200;
var $author$project$Model$CountryCallingCode$SouthAfrica = 201;
var $author$project$Model$CountryCallingCode$SouthKorea = 202;
var $author$project$Model$CountryCallingCode$SouthSudan = 203;
var $author$project$Model$CountryCallingCode$Spain = 204;
var $author$project$Model$CountryCallingCode$SriLanka = 205;
var $author$project$Model$CountryCallingCode$Sudan = 206;
var $author$project$Model$CountryCallingCode$Suriname = 207;
var $author$project$Model$CountryCallingCode$SvalbardandJanMayen = 208;
var $author$project$Model$CountryCallingCode$Sweden = 209;
var $author$project$Model$CountryCallingCode$Switzerland = 210;
var $author$project$Model$CountryCallingCode$Syria = 211;
var $author$project$Model$CountryCallingCode$Taiwan = 212;
var $author$project$Model$CountryCallingCode$Tajikistan = 213;
var $author$project$Model$CountryCallingCode$Tanzania = 214;
var $author$project$Model$CountryCallingCode$Thailand = 215;
var $author$project$Model$CountryCallingCode$TimorLeste = 216;
var $author$project$Model$CountryCallingCode$Togo = 217;
var $author$project$Model$CountryCallingCode$Tokelau = 218;
var $author$project$Model$CountryCallingCode$Tonga = 219;
var $author$project$Model$CountryCallingCode$TrinidadandTobago = 220;
var $author$project$Model$CountryCallingCode$Tunisia = 221;
var $author$project$Model$CountryCallingCode$Turkey = 222;
var $author$project$Model$CountryCallingCode$Turkmenistan = 223;
var $author$project$Model$CountryCallingCode$TurksandCaicosIslands = 224;
var $author$project$Model$CountryCallingCode$Tuvalu = 225;
var $author$project$Model$CountryCallingCode$Uganda = 226;
var $author$project$Model$CountryCallingCode$Ukraine = 227;
var $author$project$Model$CountryCallingCode$UnitedArabEmirates = 228;
var $author$project$Model$CountryCallingCode$UnitedKingdom = 229;
var $author$project$Model$CountryCallingCode$UnitedStates = 230;
var $author$project$Model$CountryCallingCode$UnitedStatesVirginIslands = 231;
var $author$project$Model$CountryCallingCode$Uruguay = 232;
var $author$project$Model$CountryCallingCode$Uzbekistan = 233;
var $author$project$Model$CountryCallingCode$Vanuatu = 234;
var $author$project$Model$CountryCallingCode$VaticanCity = 235;
var $author$project$Model$CountryCallingCode$Venezuela = 236;
var $author$project$Model$CountryCallingCode$Vietnam = 237;
var $author$project$Model$CountryCallingCode$WallisandFutuna = 238;
var $author$project$Model$CountryCallingCode$WesternSahara = 239;
var $author$project$Model$CountryCallingCode$Yemen = 240;
var $author$project$Model$CountryCallingCode$Zambia = 241;
var $author$project$Model$CountryCallingCode$Zimbabwe = 242;
var $author$project$Model$CountryCallingCode$fromString = function (a) {
	switch (a) {
		case 'afghanistan':
			return $elm$core$Maybe$Just(0);
		case 'aland-islands':
			return $elm$core$Maybe$Just(1);
		case 'albania':
			return $elm$core$Maybe$Just(2);
		case 'algeria':
			return $elm$core$Maybe$Just(3);
		case 'american-samoa':
			return $elm$core$Maybe$Just(4);
		case 'andorra':
			return $elm$core$Maybe$Just(5);
		case 'angola':
			return $elm$core$Maybe$Just(6);
		case 'anguilla':
			return $elm$core$Maybe$Just(7);
		case 'antiguaand-barbuda':
			return $elm$core$Maybe$Just(8);
		case 'argentina':
			return $elm$core$Maybe$Just(9);
		case 'armenia':
			return $elm$core$Maybe$Just(10);
		case 'aruba':
			return $elm$core$Maybe$Just(11);
		case 'australia':
			return $elm$core$Maybe$Just(12);
		case 'austria':
			return $elm$core$Maybe$Just(13);
		case 'azerbaijan':
			return $elm$core$Maybe$Just(14);
		case 'bahamas':
			return $elm$core$Maybe$Just(15);
		case 'bahrain':
			return $elm$core$Maybe$Just(16);
		case 'bangladesh':
			return $elm$core$Maybe$Just(17);
		case 'barbados':
			return $elm$core$Maybe$Just(18);
		case 'belarus':
			return $elm$core$Maybe$Just(19);
		case 'belgium':
			return $elm$core$Maybe$Just(20);
		case 'belize':
			return $elm$core$Maybe$Just(21);
		case 'benin':
			return $elm$core$Maybe$Just(22);
		case 'bermuda':
			return $elm$core$Maybe$Just(23);
		case 'bhutan':
			return $elm$core$Maybe$Just(24);
		case 'bolivia':
			return $elm$core$Maybe$Just(25);
		case 'bosniaand-herzegovina':
			return $elm$core$Maybe$Just(26);
		case 'botswana':
			return $elm$core$Maybe$Just(27);
		case 'brazil':
			return $elm$core$Maybe$Just(28);
		case 'british-indian-ocean-territory':
			return $elm$core$Maybe$Just(29);
		case 'british-virgin-islands':
			return $elm$core$Maybe$Just(30);
		case 'brunei':
			return $elm$core$Maybe$Just(31);
		case 'bulgaria':
			return $elm$core$Maybe$Just(32);
		case 'burkina-faso':
			return $elm$core$Maybe$Just(33);
		case 'burundi':
			return $elm$core$Maybe$Just(34);
		case 'cambodia':
			return $elm$core$Maybe$Just(35);
		case 'cameroon':
			return $elm$core$Maybe$Just(36);
		case 'canada':
			return $elm$core$Maybe$Just(37);
		case 'cape-verde':
			return $elm$core$Maybe$Just(38);
		case 'caribbean-netherlands':
			return $elm$core$Maybe$Just(39);
		case 'cayman-islands':
			return $elm$core$Maybe$Just(40);
		case 'central-african-republic':
			return $elm$core$Maybe$Just(41);
		case 'chad':
			return $elm$core$Maybe$Just(42);
		case 'chile':
			return $elm$core$Maybe$Just(43);
		case 'china':
			return $elm$core$Maybe$Just(44);
		case 'christmas-island':
			return $elm$core$Maybe$Just(45);
		case 'cocos-keeling-islands':
			return $elm$core$Maybe$Just(46);
		case 'colombia':
			return $elm$core$Maybe$Just(47);
		case 'comoros':
			return $elm$core$Maybe$Just(48);
		case 'cook-islands':
			return $elm$core$Maybe$Just(49);
		case 'costa-rica':
			return $elm$core$Maybe$Just(50);
		case 'croatia':
			return $elm$core$Maybe$Just(51);
		case 'cuba':
			return $elm$core$Maybe$Just(52);
		case 'curacao':
			return $elm$core$Maybe$Just(53);
		case 'cyprus':
			return $elm$core$Maybe$Just(54);
		case 'czech-republic':
			return $elm$core$Maybe$Just(55);
		case 'congo':
			return $elm$core$Maybe$Just(56);
		case 'denmark':
			return $elm$core$Maybe$Just(57);
		case 'djibouti':
			return $elm$core$Maybe$Just(58);
		case 'dominica':
			return $elm$core$Maybe$Just(59);
		case 'dominican-republic':
			return $elm$core$Maybe$Just(60);
		case 'ecuador':
			return $elm$core$Maybe$Just(61);
		case 'egypt':
			return $elm$core$Maybe$Just(62);
		case 'el-salvador':
			return $elm$core$Maybe$Just(63);
		case 'equatorial-guinea':
			return $elm$core$Maybe$Just(64);
		case 'eritrea':
			return $elm$core$Maybe$Just(65);
		case 'estonia':
			return $elm$core$Maybe$Just(66);
		case 'eswatini':
			return $elm$core$Maybe$Just(67);
		case 'ethiopia':
			return $elm$core$Maybe$Just(68);
		case 'falkland-islands':
			return $elm$core$Maybe$Just(69);
		case 'faroe-islands':
			return $elm$core$Maybe$Just(70);
		case 'fiji':
			return $elm$core$Maybe$Just(71);
		case 'finland':
			return $elm$core$Maybe$Just(72);
		case 'france':
			return $elm$core$Maybe$Just(73);
		case 'french-guiana':
			return $elm$core$Maybe$Just(74);
		case 'french-polynesia':
			return $elm$core$Maybe$Just(75);
		case 'gabon':
			return $elm$core$Maybe$Just(76);
		case 'gambia':
			return $elm$core$Maybe$Just(77);
		case 'georgia':
			return $elm$core$Maybe$Just(78);
		case 'germany':
			return $elm$core$Maybe$Just(79);
		case 'ghana':
			return $elm$core$Maybe$Just(80);
		case 'gibraltar':
			return $elm$core$Maybe$Just(81);
		case 'greece':
			return $elm$core$Maybe$Just(82);
		case 'greenland':
			return $elm$core$Maybe$Just(83);
		case 'grenada':
			return $elm$core$Maybe$Just(84);
		case 'guadeloupe':
			return $elm$core$Maybe$Just(85);
		case 'guam':
			return $elm$core$Maybe$Just(86);
		case 'guatemala':
			return $elm$core$Maybe$Just(87);
		case 'guernsey':
			return $elm$core$Maybe$Just(88);
		case 'guinea':
			return $elm$core$Maybe$Just(89);
		case 'guinea-bissau':
			return $elm$core$Maybe$Just(90);
		case 'guyana':
			return $elm$core$Maybe$Just(91);
		case 'haiti':
			return $elm$core$Maybe$Just(92);
		case 'honduras':
			return $elm$core$Maybe$Just(93);
		case 'hong-kong':
			return $elm$core$Maybe$Just(94);
		case 'hungary':
			return $elm$core$Maybe$Just(95);
		case 'iceland':
			return $elm$core$Maybe$Just(96);
		case 'india':
			return $elm$core$Maybe$Just(97);
		case 'indonesia':
			return $elm$core$Maybe$Just(98);
		case 'iran':
			return $elm$core$Maybe$Just(99);
		case 'iraq':
			return $elm$core$Maybe$Just(100);
		case 'ireland':
			return $elm$core$Maybe$Just(101);
		case 'isleof-man':
			return $elm$core$Maybe$Just(102);
		case 'israel':
			return $elm$core$Maybe$Just(103);
		case 'italy':
			return $elm$core$Maybe$Just(104);
		case 'ivory-coast':
			return $elm$core$Maybe$Just(105);
		case 'jamaica':
			return $elm$core$Maybe$Just(106);
		case 'japan':
			return $elm$core$Maybe$Just(107);
		case 'jersey':
			return $elm$core$Maybe$Just(108);
		case 'jordan':
			return $elm$core$Maybe$Just(109);
		case 'kazakhstan':
			return $elm$core$Maybe$Just(110);
		case 'kenya':
			return $elm$core$Maybe$Just(111);
		case 'kiribati':
			return $elm$core$Maybe$Just(112);
		case 'kosovo':
			return $elm$core$Maybe$Just(113);
		case 'kuwait':
			return $elm$core$Maybe$Just(114);
		case 'kyrgyzstan':
			return $elm$core$Maybe$Just(115);
		case 'laos':
			return $elm$core$Maybe$Just(116);
		case 'latvia':
			return $elm$core$Maybe$Just(117);
		case 'lebanon':
			return $elm$core$Maybe$Just(118);
		case 'lesotho':
			return $elm$core$Maybe$Just(119);
		case 'liberia':
			return $elm$core$Maybe$Just(120);
		case 'libya':
			return $elm$core$Maybe$Just(121);
		case 'liechtenstein':
			return $elm$core$Maybe$Just(122);
		case 'lithuania':
			return $elm$core$Maybe$Just(123);
		case 'luxembourg':
			return $elm$core$Maybe$Just(124);
		case 'macau':
			return $elm$core$Maybe$Just(125);
		case 'macedonia':
			return $elm$core$Maybe$Just(126);
		case 'madagascar':
			return $elm$core$Maybe$Just(127);
		case 'malawi':
			return $elm$core$Maybe$Just(128);
		case 'malaysia':
			return $elm$core$Maybe$Just(129);
		case 'maldives':
			return $elm$core$Maybe$Just(130);
		case 'mali':
			return $elm$core$Maybe$Just(131);
		case 'malta':
			return $elm$core$Maybe$Just(132);
		case 'marshall-islands':
			return $elm$core$Maybe$Just(133);
		case 'martinique':
			return $elm$core$Maybe$Just(134);
		case 'mauritania':
			return $elm$core$Maybe$Just(135);
		case 'mauritius':
			return $elm$core$Maybe$Just(136);
		case 'mayotte':
			return $elm$core$Maybe$Just(137);
		case 'mexico':
			return $elm$core$Maybe$Just(138);
		case 'micronesia':
			return $elm$core$Maybe$Just(139);
		case 'moldova':
			return $elm$core$Maybe$Just(140);
		case 'monaco':
			return $elm$core$Maybe$Just(141);
		case 'mongolia':
			return $elm$core$Maybe$Just(142);
		case 'montenegro':
			return $elm$core$Maybe$Just(143);
		case 'montserrat':
			return $elm$core$Maybe$Just(144);
		case 'morocco':
			return $elm$core$Maybe$Just(145);
		case 'mozambique':
			return $elm$core$Maybe$Just(146);
		case 'myanmar':
			return $elm$core$Maybe$Just(147);
		case 'namibia':
			return $elm$core$Maybe$Just(148);
		case 'nauru':
			return $elm$core$Maybe$Just(149);
		case 'nepal':
			return $elm$core$Maybe$Just(150);
		case 'netherlands':
			return $elm$core$Maybe$Just(151);
		case 'new-caledonia':
			return $elm$core$Maybe$Just(152);
		case 'new-zealand':
			return $elm$core$Maybe$Just(153);
		case 'nicaragua':
			return $elm$core$Maybe$Just(154);
		case 'niger':
			return $elm$core$Maybe$Just(155);
		case 'nigeria':
			return $elm$core$Maybe$Just(156);
		case 'niue':
			return $elm$core$Maybe$Just(157);
		case 'norfolk-island':
			return $elm$core$Maybe$Just(158);
		case 'north-korea':
			return $elm$core$Maybe$Just(159);
		case 'northern-mariana-islands':
			return $elm$core$Maybe$Just(160);
		case 'norway':
			return $elm$core$Maybe$Just(161);
		case 'oman':
			return $elm$core$Maybe$Just(162);
		case 'pakistan':
			return $elm$core$Maybe$Just(163);
		case 'palau':
			return $elm$core$Maybe$Just(164);
		case 'palestine':
			return $elm$core$Maybe$Just(165);
		case 'panama':
			return $elm$core$Maybe$Just(166);
		case 'papua-new-guinea':
			return $elm$core$Maybe$Just(167);
		case 'paraguay':
			return $elm$core$Maybe$Just(168);
		case 'peru':
			return $elm$core$Maybe$Just(169);
		case 'philippines':
			return $elm$core$Maybe$Just(170);
		case 'poland':
			return $elm$core$Maybe$Just(171);
		case 'portugal':
			return $elm$core$Maybe$Just(172);
		case 'puerto-rico':
			return $elm$core$Maybe$Just(173);
		case 'qatar':
			return $elm$core$Maybe$Just(174);
		case 'republicofthe-congo':
			return $elm$core$Maybe$Just(175);
		case 'romania':
			return $elm$core$Maybe$Just(176);
		case 'russia':
			return $elm$core$Maybe$Just(177);
		case 'rwanda':
			return $elm$core$Maybe$Just(178);
		case 'reunion':
			return $elm$core$Maybe$Just(179);
		case 'saint-barthelemy':
			return $elm$core$Maybe$Just(180);
		case 'saint-helena-ascensionand-tristanda-cunha':
			return $elm$core$Maybe$Just(181);
		case 'saint-kittsand-nevis':
			return $elm$core$Maybe$Just(182);
		case 'saint-lucia':
			return $elm$core$Maybe$Just(183);
		case 'saint-martin':
			return $elm$core$Maybe$Just(184);
		case 'saint-pierreand-miquelon':
			return $elm$core$Maybe$Just(185);
		case 'saint-vincentandthe-grenadines':
			return $elm$core$Maybe$Just(186);
		case 'samoa':
			return $elm$core$Maybe$Just(187);
		case 'san-marino':
			return $elm$core$Maybe$Just(188);
		case 'sao-tomeand-principe':
			return $elm$core$Maybe$Just(189);
		case 'saudi-arabia':
			return $elm$core$Maybe$Just(190);
		case 'senegal':
			return $elm$core$Maybe$Just(191);
		case 'serbia':
			return $elm$core$Maybe$Just(192);
		case 'seychelles':
			return $elm$core$Maybe$Just(193);
		case 'sierra-leone':
			return $elm$core$Maybe$Just(194);
		case 'singapore':
			return $elm$core$Maybe$Just(195);
		case 'sint-maarten':
			return $elm$core$Maybe$Just(196);
		case 'slovakia':
			return $elm$core$Maybe$Just(197);
		case 'slovenia':
			return $elm$core$Maybe$Just(198);
		case 'solomon-islands':
			return $elm$core$Maybe$Just(199);
		case 'somalia':
			return $elm$core$Maybe$Just(200);
		case 'south-africa':
			return $elm$core$Maybe$Just(201);
		case 'south-korea':
			return $elm$core$Maybe$Just(202);
		case 'south-sudan':
			return $elm$core$Maybe$Just(203);
		case 'spain':
			return $elm$core$Maybe$Just(204);
		case 'sri-lanka':
			return $elm$core$Maybe$Just(205);
		case 'sudan':
			return $elm$core$Maybe$Just(206);
		case 'suriname':
			return $elm$core$Maybe$Just(207);
		case 'svalbardand-jan-mayen':
			return $elm$core$Maybe$Just(208);
		case 'sweden':
			return $elm$core$Maybe$Just(209);
		case 'switzerland':
			return $elm$core$Maybe$Just(210);
		case 'syria':
			return $elm$core$Maybe$Just(211);
		case 'taiwan':
			return $elm$core$Maybe$Just(212);
		case 'tajikistan':
			return $elm$core$Maybe$Just(213);
		case 'tanzania':
			return $elm$core$Maybe$Just(214);
		case 'thailand':
			return $elm$core$Maybe$Just(215);
		case 'timor-leste':
			return $elm$core$Maybe$Just(216);
		case 'togo':
			return $elm$core$Maybe$Just(217);
		case 'tokelau':
			return $elm$core$Maybe$Just(218);
		case 'tonga':
			return $elm$core$Maybe$Just(219);
		case 'trinidadand-tobago':
			return $elm$core$Maybe$Just(220);
		case 'tunisia':
			return $elm$core$Maybe$Just(221);
		case 'turkey':
			return $elm$core$Maybe$Just(222);
		case 'turkmenistan':
			return $elm$core$Maybe$Just(223);
		case 'turksand-caicos-islands':
			return $elm$core$Maybe$Just(224);
		case 'tuvalu':
			return $elm$core$Maybe$Just(225);
		case 'uganda':
			return $elm$core$Maybe$Just(226);
		case 'ukraine':
			return $elm$core$Maybe$Just(227);
		case 'united-arab-emirates':
			return $elm$core$Maybe$Just(228);
		case 'united-kingdom':
			return $elm$core$Maybe$Just(229);
		case 'united-states':
			return $elm$core$Maybe$Just(230);
		case 'united-states-virgin-islands':
			return $elm$core$Maybe$Just(231);
		case 'uruguay':
			return $elm$core$Maybe$Just(232);
		case 'uzbekistan':
			return $elm$core$Maybe$Just(233);
		case 'vanuatu':
			return $elm$core$Maybe$Just(234);
		case 'vatican-city':
			return $elm$core$Maybe$Just(235);
		case 'venezuela':
			return $elm$core$Maybe$Just(236);
		case 'vietnam':
			return $elm$core$Maybe$Just(237);
		case 'wallisand-futuna':
			return $elm$core$Maybe$Just(238);
		case 'western-sahara':
			return $elm$core$Maybe$Just(239);
		case 'yemen':
			return $elm$core$Maybe$Just(240);
		case 'zambia':
			return $elm$core$Maybe$Just(241);
		case 'zimbabwe':
			return $elm$core$Maybe$Just(242);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Model$WhatsappConfig$decodeWhatsappConfig = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'btnText',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'disable',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'phone',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'countryCallingCode',
				$author$project$Util$Json$enumDecoder($author$project$Model$CountryCallingCode$fromString),
				$elm$json$Json$Decode$succeed($author$project$Model$WhatsappConfig$WhatsappConfig)))));
var $author$project$Model$LangCode$LangCodeDa = 0;
var $author$project$Model$LangCode$LangCodeDe = 1;
var $author$project$Model$LangCode$LangCodeDeAt = 2;
var $author$project$Model$LangCode$LangCodeDeCh = 3;
var $author$project$Model$LangCode$LangCodeDeLu = 4;
var $author$project$Model$LangCode$LangCodeEn = 5;
var $author$project$Model$LangCode$LangCodeEnGb = 6;
var $author$project$Model$LangCode$LangCodeEnUs = 7;
var $author$project$Model$LangCode$LangCodeEs = 8;
var $author$project$Model$LangCode$LangCodeFi = 9;
var $author$project$Model$LangCode$LangCodeFr = 10;
var $author$project$Model$LangCode$LangCodeFrBe = 11;
var $author$project$Model$LangCode$LangCodeFrCh = 12;
var $author$project$Model$LangCode$LangCodeFrLu = 13;
var $author$project$Model$LangCode$LangCodeNl = 14;
var $author$project$Model$LangCode$LangCodeNlBe = 15;
var $author$project$Model$LangCode$LangCodeNo = 16;
var $author$project$Model$LangCode$LangCodePl = 17;
var $author$project$Model$LangCode$LangCodePt = 18;
var $author$project$Model$LangCode$LangCodeRo = 19;
var $author$project$Model$LangCode$LangCodeSk = 20;
var $author$project$Model$LangCode$LangCodeSv = 21;
var $author$project$Model$LangCode$LangCodeUk = 22;
var $author$project$Model$LangCode$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'da':
				return $elm$json$Json$Decode$succeed(0);
			case 'de':
				return $elm$json$Json$Decode$succeed(1);
			case 'de-at':
				return $elm$json$Json$Decode$succeed(2);
			case 'de-ch':
				return $elm$json$Json$Decode$succeed(3);
			case 'de-lu':
				return $elm$json$Json$Decode$succeed(4);
			case 'en':
				return $elm$json$Json$Decode$succeed(5);
			case 'en-gb':
				return $elm$json$Json$Decode$succeed(6);
			case 'en-us':
				return $elm$json$Json$Decode$succeed(7);
			case 'es':
				return $elm$json$Json$Decode$succeed(8);
			case 'fi':
				return $elm$json$Json$Decode$succeed(9);
			case 'fr':
				return $elm$json$Json$Decode$succeed(10);
			case 'fr-be':
				return $elm$json$Json$Decode$succeed(11);
			case 'fr-ch':
				return $elm$json$Json$Decode$succeed(12);
			case 'fr-lu':
				return $elm$json$Json$Decode$succeed(13);
			case 'nl':
				return $elm$json$Json$Decode$succeed(14);
			case 'nl-be':
				return $elm$json$Json$Decode$succeed(15);
			case 'no':
				return $elm$json$Json$Decode$succeed(16);
			case 'pl':
				return $elm$json$Json$Decode$succeed(17);
			case 'pt':
				return $elm$json$Json$Decode$succeed(18);
			case 'ro':
				return $elm$json$Json$Decode$succeed(19);
			case 'sk':
				return $elm$json$Json$Decode$succeed(20);
			case 'sv':
				return $elm$json$Json$Decode$succeed(21);
			case 'uk':
				return $elm$json$Json$Decode$succeed(22);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Model$Country$GeocodingRegion = function (geocodingRegionToNonEmpty) {
	return {sC: geocodingRegionToNonEmpty};
};
var $author$project$Model$Country$AT = 0;
var $author$project$Model$Country$BE = 1;
var $author$project$Model$Country$CH = 2;
var $author$project$Model$Country$CN = 3;
var $author$project$Model$Country$DE = 4;
var $author$project$Model$Country$DK = 5;
var $author$project$Model$Country$ES = 6;
var $author$project$Model$Country$FI = 7;
var $author$project$Model$Country$FR = 8;
var $author$project$Model$Country$GB = 9;
var $author$project$Model$Country$LU = 10;
var $author$project$Model$Country$NL = 11;
var $author$project$Model$Country$NO = 12;
var $author$project$Model$Country$PL = 13;
var $author$project$Model$Country$PT = 14;
var $author$project$Model$Country$RO = 15;
var $author$project$Model$Country$SE = 17;
var $author$project$Model$Country$SK = 16;
var $author$project$Model$Country$UK = 19;
var $author$project$Model$Country$US = 18;
var $author$project$Model$Country$countryDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'at':
				return $elm$json$Json$Decode$succeed(0);
			case 'be':
				return $elm$json$Json$Decode$succeed(1);
			case 'ch':
				return $elm$json$Json$Decode$succeed(2);
			case 'cn':
				return $elm$json$Json$Decode$succeed(3);
			case 'de':
				return $elm$json$Json$Decode$succeed(4);
			case 'dk':
				return $elm$json$Json$Decode$succeed(5);
			case 'es':
				return $elm$json$Json$Decode$succeed(6);
			case 'fi':
				return $elm$json$Json$Decode$succeed(7);
			case 'fr':
				return $elm$json$Json$Decode$succeed(8);
			case 'gb':
				return $elm$json$Json$Decode$succeed(9);
			case 'lu':
				return $elm$json$Json$Decode$succeed(10);
			case 'nl':
				return $elm$json$Json$Decode$succeed(11);
			case 'no':
				return $elm$json$Json$Decode$succeed(12);
			case 'pl':
				return $elm$json$Json$Decode$succeed(13);
			case 'pt':
				return $elm$json$Json$Decode$succeed(14);
			case 'ro':
				return $elm$json$Json$Decode$succeed(15);
			case 'sk':
				return $elm$json$Json$Decode$succeed(16);
			case 'se':
				return $elm$json$Json$Decode$succeed(17);
			case 'us':
				return $elm$json$Json$Decode$succeed(18);
			case 'uk':
				return $elm$json$Json$Decode$succeed(19);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $mgold$elm_nonempty_list$List$Nonempty$Nonempty = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$oneOrMoreHelp = F2(
	function (toValue, xs) {
		if (!xs.b) {
			return $elm$json$Json$Decode$fail('a ARRAY with at least ONE element');
		} else {
			var y = xs.a;
			var ys = xs.b;
			return $elm$json$Json$Decode$succeed(
				A2(toValue, y, ys));
		}
	});
var $elm$json$Json$Decode$oneOrMore = F2(
	function (toValue, decoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			$elm$json$Json$Decode$oneOrMoreHelp(toValue),
			$elm$json$Json$Decode$list(decoder));
	});
var $langyu_app$elm_ancillary_nonempty_list$List$Nonempty$Ancillary$decodeArray = function (d) {
	return A2($elm$json$Json$Decode$oneOrMore, $mgold$elm_nonempty_list$List$Nonempty$Nonempty, d);
};
var $author$project$Model$Country$geocodingRegionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'geocodingRegionToNonEmpty',
	$langyu_app$elm_ancillary_nonempty_list$List$Nonempty$Ancillary$decodeArray($author$project$Model$Country$countryDecoder),
	$elm$json$Json$Decode$succeed($author$project$Model$Country$GeocodingRegion));
var $author$project$Model$Region$Austria = 0;
var $author$project$Model$Region$Belgium = 1;
var $author$project$Model$Region$China = 2;
var $author$project$Model$Region$Denmark = 4;
var $author$project$Model$Region$Emea = 5;
var $author$project$Model$Region$Finland = 6;
var $author$project$Model$Region$France = 7;
var $author$project$Model$Region$Germany = 8;
var $author$project$Model$Region$Global = 9;
var $author$project$Model$Region$GreatBritain = 10;
var $author$project$Model$Region$Luxembourg = 11;
var $author$project$Model$Region$Netherlands = 12;
var $author$project$Model$Region$Norway = 13;
var $author$project$Model$Region$Poland = 15;
var $author$project$Model$Region$Portugal = 16;
var $author$project$Model$Region$Romania = 17;
var $author$project$Model$Region$Singapore = 19;
var $author$project$Model$Region$Slovakia = 18;
var $author$project$Model$Region$Spain = 20;
var $author$project$Model$Region$Sweden = 21;
var $author$project$Model$Region$Switzerland = 3;
var $author$project$Model$Region$Ukraine = 14;
var $author$project$Model$Region$UnitedStates = 22;
var $author$project$Model$Region$regionDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'austria':
				return $elm$json$Json$Decode$succeed(0);
			case 'belgium':
				return $elm$json$Json$Decode$succeed(1);
			case 'china':
				return $elm$json$Json$Decode$succeed(2);
			case 'switzerland':
				return $elm$json$Json$Decode$succeed(3);
			case 'denmark':
				return $elm$json$Json$Decode$succeed(4);
			case 'emea':
				return $elm$json$Json$Decode$succeed(5);
			case 'finland':
				return $elm$json$Json$Decode$succeed(6);
			case 'france':
				return $elm$json$Json$Decode$succeed(7);
			case 'germany':
				return $elm$json$Json$Decode$succeed(8);
			case 'global':
				return $elm$json$Json$Decode$succeed(9);
			case 'great-britain':
				return $elm$json$Json$Decode$succeed(10);
			case 'luxembourg':
				return $elm$json$Json$Decode$succeed(11);
			case 'netherlands':
				return $elm$json$Json$Decode$succeed(12);
			case 'norway':
				return $elm$json$Json$Decode$succeed(13);
			case 'ukraine':
				return $elm$json$Json$Decode$succeed(14);
			case 'poland':
				return $elm$json$Json$Decode$succeed(15);
			case 'portugal':
				return $elm$json$Json$Decode$succeed(16);
			case 'romania':
				return $elm$json$Json$Decode$succeed(17);
			case 'slovakia':
				return $elm$json$Json$Decode$succeed(18);
			case 'singapore':
				return $elm$json$Json$Decode$succeed(19);
			case 'spain':
				return $elm$json$Json$Decode$succeed(20);
			case 'sweden':
				return $elm$json$Json$Decode$succeed(21);
			case 'united-states':
				return $elm$json$Json$Decode$succeed(22);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$SystemPreferences$SystemPreferences = function (_export) {
	return {qL: _export};
};
var $author$project$Model$SystemPreferences$Export$Afas = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$SystemPreferences$Export$Bullhorn = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$SystemPreferences$Export$Carerix = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$SystemPreferences$Export$Connexys = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$SystemPreferences$Export$Cornerstone = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$SystemPreferences$Export$Emply = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$SystemPreferences$Export$Greenhouse = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$SystemPreferences$Export$Homerun = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$SystemPreferences$Export$HrOffice = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$SystemPreferences$Export$Jobylon = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$SystemPreferences$Export$Otys = function (a) {
	return {$: 10, a: a};
};
var $author$project$Model$SystemPreferences$Export$Recruitee = function (a) {
	return {$: 13, a: a};
};
var $author$project$Model$SystemPreferences$Export$RecruiteeAts = function (a) {
	return {$: 14, a: a};
};
var $author$project$Model$SystemPreferences$Export$SmartRecruiters = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$SystemPreferences$Export$SuccessFactors = function (a) {
	return {$: 12, a: a};
};
var $author$project$Model$SystemPreferences$Export$Talentsoft = function (a) {
	return {$: 15, a: a};
};
var $author$project$Model$SystemPreferences$Export$Teamtailor = function (a) {
	return {$: 16, a: a};
};
var $author$project$Model$SystemPreferences$Export$Tigris = function (a) {
	return {$: 17, a: a};
};
var $author$project$Model$SystemPreferences$Export$Trakstar = function (a) {
	return {$: 18, a: a};
};
var $author$project$Model$SystemPreferences$Export$Webqube = function (a) {
	return {$: 19, a: a};
};
var $author$project$Model$SystemPreferences$Export$Workday = function (a) {
	return {$: 20, a: a};
};
var $author$project$Model$SystemPreferences$Export$AfasConfig = F2(
	function (afasUrl, afasKey) {
		return {f7: afasKey, f8: afasUrl};
	});
var $author$project$Model$SystemPreferences$Export$afasConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'afasKey',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'afasUrl',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$AfasConfig)));
var $author$project$Model$SystemPreferences$Export$BullhornConfig = F6(
	function (authUrl, restUrl, bhClientId, bhClientSecret, bhClientUser, bhClientPass) {
		return {im: authUrl, jo: bhClientId, jp: bhClientPass, jq: bhClientSecret, jr: bhClientUser, Ik: restUrl};
	});
var $author$project$Model$SystemPreferences$Export$bullhornConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'bhClientPass',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'bhClientUser',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'bhClientSecret',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'bhClientId',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'restUrl',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'authUrl',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$BullhornConfig)))))));
var $author$project$Model$SystemPreferences$Export$CarerixConfig = F3(
	function (carerixUrl, carerixUser, carerixToken) {
		return {kp: carerixToken, kq: carerixUrl, kr: carerixUser};
	});
var $author$project$Model$SystemPreferences$Export$carerixConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'carerixToken',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'carerixUser',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'carerixUrl',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$CarerixConfig))));
var $author$project$Model$SystemPreferences$Export$ConnexysConfig = F5(
	function (issuer, url, publicKey, privateKey, tokenScriptPath) {
		return {vX: issuer, FZ: privateKey, F8: publicKey, Py: tokenScriptPath, dK: url};
	});
var $author$project$Model$SystemPreferences$Export$connexysConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tokenScriptPath',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'privateKey',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'publicKey',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'url',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'issuer',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$ConnexysConfig))))));
var $author$project$Model$SystemPreferences$Export$CornerstoneConfig = F5(
	function (cornerstoneClientID_, cornerstoneClientSecret_, cornerstoneGrantType_, cornerstoneScope_, cornerstoneURL_) {
		return {mx: cornerstoneClientID_, my: cornerstoneClientSecret_, mz: cornerstoneGrantType_, mA: cornerstoneScope_, mB: cornerstoneURL_};
	});
var $author$project$Model$SystemPreferences$Export$cornerstoneConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'cornerstoneURL_',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'cornerstoneScope_',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'cornerstoneGrantType_',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'cornerstoneClientSecret_',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'cornerstoneClientID_',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$CornerstoneConfig))))));
var $author$project$Model$SystemPreferences$Export$EmplyConfig = function (emplyApiKey) {
	return function (emplyURL) {
		return function (firstNameFieldId) {
			return function (lastNameFieldId) {
				return function (emailFieldId) {
					return function (resumeFieldId) {
						return function (motivationFieldId) {
							return function (privacyPolicyFieldId) {
								return function (phoneFieldId) {
									return function (cityFieldId) {
										return function (salaryIndicationFieldId) {
											return function (extendedStorageOptionId) {
												return function (defaultStorageOptionId) {
													return {lf: cityFieldId, nU: defaultStorageOptionId, py: emailFieldId, p3: emplyApiKey, p4: emplyURL, qM: extendedStorageOptionId, r4: firstNameFieldId, w2: lastNameFieldId, zN: motivationFieldId, EW: phoneFieldId, FS: privacyPolicyFieldId, Im: resumeFieldId, I1: salaryIndicationFieldId};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $danyx23$elm_uuid$Uuid$Uuid = $elm$core$Basics$identity;
var $elm$regex$Regex$contains = _Regex_contains;
var $danyx23$elm_uuid$Uuid$Barebones$uuidRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9A-Fa-f]{8,8}-[0-9A-Fa-f]{4,4}-[1-5][0-9A-Fa-f]{3,3}-[8-9A-Ba-b][0-9A-Fa-f]{3,3}-[0-9A-Fa-f]{12,12}$'));
var $danyx23$elm_uuid$Uuid$Barebones$isValidUuid = function (uuidAsString) {
	return A2($elm$regex$Regex$contains, $danyx23$elm_uuid$Uuid$Barebones$uuidRegex, uuidAsString);
};
var $elm$core$String$toLower = _String_toLower;
var $danyx23$elm_uuid$Uuid$fromString = function (text) {
	return $danyx23$elm_uuid$Uuid$Barebones$isValidUuid(text) ? $elm$core$Maybe$Just(
		$elm$core$String$toLower(text)) : $elm$core$Maybe$Nothing;
};
var $danyx23$elm_uuid$Uuid$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $danyx23$elm_uuid$Uuid$fromString(string);
		if (!_v0.$) {
			var uuid = _v0.a;
			return $elm$json$Json$Decode$succeed(uuid);
		} else {
			return $elm$json$Json$Decode$fail('Not a valid UUID');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$SystemPreferences$Export$emplyConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'defaultStorageOptionId',
	$danyx23$elm_uuid$Uuid$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'extendedStorageOptionId',
		$danyx23$elm_uuid$Uuid$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'salaryIndicationFieldId',
			$danyx23$elm_uuid$Uuid$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'cityFieldId',
				$danyx23$elm_uuid$Uuid$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'phoneFieldId',
					$danyx23$elm_uuid$Uuid$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'privacyPolicyFieldId',
						$danyx23$elm_uuid$Uuid$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'motivationFieldId',
							$danyx23$elm_uuid$Uuid$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'resumeFieldId',
								$danyx23$elm_uuid$Uuid$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'emailFieldId',
									$danyx23$elm_uuid$Uuid$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'lastNameFieldId',
										$danyx23$elm_uuid$Uuid$decoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'firstNameFieldId',
											$danyx23$elm_uuid$Uuid$decoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'emplyURL',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'emplyApiKey',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$EmplyConfig))))))))))))));
var $author$project$Model$SystemPreferences$Export$GreenhouseConfig = F3(
	function (greenhouseUrl, greenhouseApiKey, greenhouseUserId) {
		return {s7: greenhouseApiKey, s8: greenhouseUrl, s9: greenhouseUserId};
	});
var $author$project$Model$SystemPreferences$Export$greenhouseConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'greenhouseUserId',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'greenhouseApiKey',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'greenhouseUrl',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$GreenhouseConfig))));
var $author$project$Model$SystemPreferences$Export$HomerunConfig = F2(
	function (apiKey, homerunUrl) {
		return {gS: apiKey, tW: homerunUrl};
	});
var $author$project$Model$SystemPreferences$Export$homerunConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'homerunUrl',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'apiKey',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$HomerunConfig)));
var $author$project$Model$SystemPreferences$Export$HrOfficeConfig = F3(
	function (hrOfficeUrl, hrOfficePortalId, hrOfficeKey) {
		return {ue: hrOfficeKey, uf: hrOfficePortalId, ug: hrOfficeUrl};
	});
var $author$project$Model$SystemPreferences$Export$hrOfficeConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hrOfficeKey',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'hrOfficePortalId',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'hrOfficeUrl',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$HrOfficeConfig))));
var $author$project$Model$SystemPreferences$Export$JobylonConfig = F5(
	function (appId, appKey, apiDomain, apiVersion, openJobApplicationId) {
		return {gR: apiDomain, gT: apiVersion, gU: appId, gV: appKey, C9: openJobApplicationId};
	});
var $author$project$Model$SystemPreferences$Export$jobylonConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'openJobApplicationId',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'apiVersion',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'apiDomain',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'appKey',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'appId',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$JobylonConfig))))));
var $author$project$Model$SystemPreferences$Export$OtysConfig = function (otysApiKey) {
	return function (otysCandidateStatusId) {
		return function (otysApplicationStatusId) {
			return function (otysMotivationFileTypeId) {
				return function (otysSetCandidateOwner) {
					return function (otysCustomerRightsLevel) {
						return function (otysSendCustomMail) {
							return function (otysDefaultFromEmail) {
								return function (otysDefaultFromName) {
									return function (otysDefaultUserId) {
										return {DM: otysApiKey, DN: otysApplicationStatusId, DO: otysCandidateStatusId, DP: otysCustomerRightsLevel, DQ: otysDefaultFromEmail, DR: otysDefaultFromName, DS: otysDefaultUserId, DT: otysMotivationFileTypeId, DU: otysSendCustomMail, DV: otysSetCandidateOwner};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$SystemPreferences$Export$otysConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'otysDefaultUserId',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'otysDefaultFromName',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'otysDefaultFromEmail',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'otysSendCustomMail',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'otysCustomerRightsLevel',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'otysSetCandidateOwner',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'otysMotivationFileTypeId',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'otysApplicationStatusId',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'otysCandidateStatusId',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'otysApiKey',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$OtysConfig)))))))))));
var $author$project$Model$SystemPreferences$Export$RecruiteeAtsConfig = F2(
	function (recruiteeCompanyCode, recruiteeApiKey) {
		return {Gr: recruiteeApiKey, di: recruiteeCompanyCode};
	});
var $author$project$Model$SystemPreferences$Export$recruiteeAtsConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'recruiteeApiKey',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'recruiteeCompanyCode',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$RecruiteeAtsConfig)));
var $author$project$Model$SystemPreferences$Export$RecruiteeConfig = function (recruiteeCompanyCode) {
	return {di: recruiteeCompanyCode};
};
var $author$project$Model$SystemPreferences$Export$recruiteeConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'recruiteeCompanyCode',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$RecruiteeConfig));
var $author$project$Model$SystemPreferences$Export$SmartRecruitersConfig = function (smartRecruitersSmartToken) {
	return {MH: smartRecruitersSmartToken};
};
var $author$project$Model$SystemPreferences$Export$smartRecruitersConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'smartRecruitersSmartToken',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$SmartRecruitersConfig));
var $author$project$Model$SystemPreferences$Export$SuccessFactorsConfig = F8(
	function (sfClientId, sfClientSecret, sfBaseURL, sfSecurityURL, isBasicAuth, username, password, skipUpdateCandidate) {
		return {vM: isBasicAuth, Ew: password, Li: sfBaseURL, Lj: sfClientId, Lk: sfClientSecret, Ll: sfSecurityURL, Mt: skipUpdateCandidate, Rw: username};
	});
var $author$project$Model$SystemPreferences$Export$successFactorsConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'skipUpdateCandidate',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'password',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'username',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'isBasicAuth',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'sfSecurityURL',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'sfBaseURL',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'sfClientSecret',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'sfClientId',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$SuccessFactorsConfig)))))))));
var $author$project$Model$SystemPreferences$Export$TalentsoftConfig = F4(
	function (clientId, clientSecret, frontOfficeUrl, openApplicationOrganisationLabel) {
		return {dZ: clientId, cs: clientSecret, su: frontOfficeUrl, C$: openApplicationOrganisationLabel};
	});
var $author$project$Model$SystemPreferences$Export$talentsoftConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'openApplicationOrganisationLabel',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'frontOfficeUrl',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'clientSecret',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'clientId',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$TalentsoftConfig)))));
var $author$project$Model$SystemPreferences$Export$TeamtailorConfig = F2(
	function (teamTailorApiKey, teamTailorURL) {
		return {OT: teamTailorApiKey, OU: teamTailorURL};
	});
var $author$project$Model$SystemPreferences$Export$teamTailorTeamtailorConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'teamTailorURL',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'teamTailorApiKey',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$TeamtailorConfig)));
var $author$project$Model$SystemPreferences$Export$TigrisConfig = F4(
	function (clientId, clientSecret, tigrisUrl, openApplicationOffice) {
		return {dZ: clientId, cs: clientSecret, C_: openApplicationOffice, Pk: tigrisUrl};
	});
var $author$project$Model$SystemPreferences$Export$tigrisConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'openApplicationOffice',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tigrisUrl',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'clientSecret',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'clientId',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$TigrisConfig)))));
var $author$project$Model$SystemPreferences$Export$TrakstarConfig = function (trakstarApiKey) {
	return {PU: trakstarApiKey};
};
var $author$project$Model$SystemPreferences$Export$trakstarConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'trakstarApiKey',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$TrakstarConfig));
var $author$project$Model$SystemPreferences$Export$WebqubeConfig = F4(
	function (wqEndpoint, wqApiKey, wqGdprPreservationDays, wqMedium) {
		return {TH: wqApiKey, TI: wqEndpoint, TJ: wqGdprPreservationDays, TK: wqMedium};
	});
var $author$project$Model$SystemPreferences$Export$webqubeConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'wqMedium',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'wqGdprPreservationDays',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'wqApiKey',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'wqEndpoint',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$WebqubeConfig)))));
var $author$project$Model$SystemPreferences$Export$WorkdayConfig = F3(
	function (user, pass, baseUrl) {
		return {jf: baseUrl, Ev: pass, Rb: user};
	});
var $author$project$Model$SystemPreferences$Export$workdayConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'baseUrl',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'pass',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'user',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$WorkdayConfig))));
var $author$project$Model$SystemPreferences$Export$exportDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'afas':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$afasConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$Afas));
			case 'bullhorn':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$bullhornConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$Bullhorn));
			case 'carerix':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$carerixConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$Carerix));
			case 'connexys':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$connexysConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$Connexys));
			case 'cornerstone':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$cornerstoneConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$Cornerstone));
			case 'emply':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$emplyConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$Emply));
			case 'greenhouse':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$greenhouseConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$Greenhouse));
			case 'hr-office':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$hrOfficeConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$HrOffice));
			case 'homerun':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$homerunConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$Homerun));
			case 'jobylon':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$jobylonConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$Jobylon));
			case 'otys':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$otysConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$Otys));
			case 'smart-recruiters':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$smartRecruitersConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$SmartRecruiters));
			case 'success-factors':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$successFactorsConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$SuccessFactors));
			case 'recruitee':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$recruiteeConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$Recruitee));
			case 'recruitee-ats':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$recruiteeAtsConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$RecruiteeAts));
			case 'talentsoft':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$talentsoftConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$Talentsoft));
			case 'teamtailor':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$teamTailorTeamtailorConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$Teamtailor));
			case 'tigris':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$tigrisConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$Tigris));
			case 'trakstar':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$trakstarConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$Trakstar));
			case 'webqube':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$webqubeConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$Webqube));
			case 'workday':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$SystemPreferences$Export$workdayConfigDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$Export$Workday));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$SystemPreferences$systemPreferencesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'export',
	$author$project$Model$SystemPreferences$Export$exportDecoder,
	$elm$json$Json$Decode$succeed($author$project$Model$SystemPreferences$SystemPreferences));
var $author$project$Model$VacancyFilterType$City = 0;
var $author$project$Model$VacancyFilterType$ContractType = 1;
var $author$project$Model$VacancyFilterType$Country = 2;
var $author$project$Model$VacancyFilterType$CustomFilter01 = 3;
var $author$project$Model$VacancyFilterType$CustomFilter02 = 4;
var $author$project$Model$VacancyFilterType$CustomFilter03 = 5;
var $author$project$Model$VacancyFilterType$CustomFilter04 = 6;
var $author$project$Model$VacancyFilterType$CustomFilter05 = 7;
var $author$project$Model$VacancyFilterType$CustomFilter06 = 8;
var $author$project$Model$VacancyFilterType$Department = 9;
var $author$project$Model$VacancyFilterType$Discipline = 10;
var $author$project$Model$VacancyFilterType$EducationLevel = 11;
var $author$project$Model$VacancyFilterType$EndDate = 12;
var $author$project$Model$VacancyFilterType$ExperienceLevel = 13;
var $author$project$Model$VacancyFilterType$FulltimeParttime = 14;
var $author$project$Model$VacancyFilterType$Hours = 15;
var $author$project$Model$VacancyFilterType$Location = 16;
var $author$project$Model$VacancyFilterType$LocationName = 17;
var $author$project$Model$VacancyFilterType$LocationType = 18;
var $author$project$Model$VacancyFilterType$Province = 19;
var $author$project$Model$VacancyFilterType$PublicationDate = 20;
var $author$project$Model$VacancyFilterType$Salary = 21;
var $author$project$Model$VacancyFilterType$vacancyFilterTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'city':
				return $elm$json$Json$Decode$succeed(0);
			case 'contract-type':
				return $elm$json$Json$Decode$succeed(1);
			case 'country':
				return $elm$json$Json$Decode$succeed(2);
			case 'custom-filter01':
				return $elm$json$Json$Decode$succeed(3);
			case 'custom-filter02':
				return $elm$json$Json$Decode$succeed(4);
			case 'custom-filter03':
				return $elm$json$Json$Decode$succeed(5);
			case 'custom-filter04':
				return $elm$json$Json$Decode$succeed(6);
			case 'custom-filter05':
				return $elm$json$Json$Decode$succeed(7);
			case 'custom-filter06':
				return $elm$json$Json$Decode$succeed(8);
			case 'department':
				return $elm$json$Json$Decode$succeed(9);
			case 'discipline':
				return $elm$json$Json$Decode$succeed(10);
			case 'education-level':
				return $elm$json$Json$Decode$succeed(11);
			case 'end-date':
				return $elm$json$Json$Decode$succeed(12);
			case 'experience-level':
				return $elm$json$Json$Decode$succeed(13);
			case 'fulltime-parttime':
				return $elm$json$Json$Decode$succeed(14);
			case 'hours':
				return $elm$json$Json$Decode$succeed(15);
			case 'location':
				return $elm$json$Json$Decode$succeed(16);
			case 'location-name':
				return $elm$json$Json$Decode$succeed(17);
			case 'location-type':
				return $elm$json$Json$Decode$succeed(18);
			case 'province':
				return $elm$json$Json$Decode$succeed(19);
			case 'publication-date':
				return $elm$json$Json$Decode$succeed(20);
			case 'salary':
				return $elm$json$Json$Decode$succeed(21);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Domain$domainDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'domainSeqNo',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'domainWhatsappConfig',
		$elm$json$Json$Decode$nullable($author$project$Model$WhatsappConfig$decodeWhatsappConfig),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'domainWhatsappNumber',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'domainVacancyOverviewMetadata',
				$elm$json$Json$Decode$list($author$project$Model$VacancyFilterType$vacancyFilterTypeDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'domainVacancyItemImageDefault',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'domainVacancyDetailMetadata',
						$elm$json$Json$Decode$list($author$project$Model$VacancyFilterType$vacancyFilterTypeDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'domainTitle',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'domainSystemPreferences',
								$elm$json$Json$Decode$nullable($author$project$Model$SystemPreferences$systemPreferencesDecoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'domainShowDomainSwitch',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'domainSeedPages',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'domainSamlLoginText',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'domainSalaryFilterEnabled',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'domainRegion',
													$author$project$Model$Region$regionDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'domainPostmarkApiKey',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'domainPossibleAltCss',
															$elm$json$Json$Decode$list($author$project$Model$AltCss$altCssDecoder),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'domainPathPrefix',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'domainName',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'domainMobileSubMenuToggle',
																		$elm$json$Json$Decode$bool,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'domainLocationUrlPrefix',
																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'domainLinkedInPixel',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'domainLinkedDomainKey',
																					$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'domainLangCode',
																						$author$project$Model$LangCode$decoder,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'domainLabel',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'domainIsNonVacancyDomain',
																								$elm$json$Json$Decode$bool,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'domainIsInternal',
																									$elm$json$Json$Decode$bool,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'domainIndeedFulltimeThreshold',
																										$elm$json$Json$Decode$float,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'domainIndeedConversionCode',
																											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'domainIncludeInTopBarDomainSwitch',
																												$elm$json$Json$Decode$bool,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'domainIncludeInLanguageSwitch',
																													$elm$json$Json$Decode$bool,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'domainIncludeInCmsSwitch',
																														$elm$json$Json$Decode$bool,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'domainHoursFilterEnabled',
																															$elm$json$Json$Decode$bool,
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'domainHeaderJobAlertTitle',
																																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'domainHeadSnippets',
																																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'domainGoogleTagManagerId',
																																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'domainGoogleGeocodingRegion',
																																			$elm$json$Json$Decode$nullable($author$project$Model$Country$geocodingRegionDecoder),
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'domainGoogleDataStudioUrl',
																																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'domainGoogleCloudMapsApiKey',
																																					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																					A3(
																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																						'domainGoogleCloudApiKey',
																																						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																						A3(
																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																							'domainGoogleAnalyticsStreamId',
																																							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																							A3(
																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																								'domainGoogleAnalyticsApiKey',
																																								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																								A3(
																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																									'domainEmail',
																																									$elm$json$Json$Decode$string,
																																									A3(
																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																										'domainDomainSwitchLabel',
																																										$elm$json$Json$Decode$string,
																																										A3(
																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																											'domainCustomLogo',
																																											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																											A3(
																																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																												'domainCustomFavicon',
																																												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																												A3(
																																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																													'domainCssClass',
																																													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																													A3(
																																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																														'domainCorporateWebsiteUrl',
																																														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																														A3(
																																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																															'domainCorporateWebsite',
																																															$elm$json$Json$Decode$nullable($author$project$Model$corporateLinkDecoder),
																																															A3(
																																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																'domainConsentDefault',
																																																$author$project$Model$CookieConsent$cookieConsentDecoder,
																																																A3(
																																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																	'domainBetterUptimeUrl',
																																																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																																	A3(
																																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																		'domainAltCss',
																																																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																																		A3(
																																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																			'domainAddressEnabled',
																																																			$elm$json$Json$Decode$bool,
																																																			$elm$json$Json$Decode$succeed($author$project$Model$Domain$Domain))))))))))))))))))))))))))))))))))))))))))))))))))));
var $author$project$Browser$Dom$Breakpoint$WindowWidth = $elm$core$Basics$identity;
var $author$project$Browser$Dom$Breakpoint$windowWidthDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$float);
var $author$project$TravelTime$decodeFlags = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'sessionToken',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'longitude',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'latitude',
			$elm$json$Json$Decode$float,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'windowWidth',
				$author$project$Browser$Dom$Breakpoint$windowWidthDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'domain',
					$author$project$Data$Entity$decoder($author$project$Model$Domain$domainDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$TravelTime$Flags)))))));
var $author$project$TravelTime$Car = 2;
var $author$project$TravelTime$Setup = {$: 0};
var $author$project$View$LocationSuggestions$State = $elm$core$Basics$identity;
var $author$project$View$LocationSuggestions$Unknown = {$: 0};
var $author$project$View$LocationSuggestions$init = {U: $author$project$View$Autocomplete$Http$init, az: $author$project$View$LocationSuggestions$Unknown};
var $author$project$TravelTime$encodeDrivingMode = function (drivingMode) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (drivingMode) {
				case 2:
					return 'DRIVING';
				case 0:
					return 'BICYCLING';
				case 1:
					return 'WALKING';
				default:
					return 'TRANSIT';
			}
		}());
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$TravelTime$encodeEventAttributes = function (event) {
	if (event.$ === 1) {
		var config = event.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'drivingMode',
				$author$project$TravelTime$encodeDrivingMode(config.af)),
				_Utils_Tuple2(
				'latitude',
				$elm$json$Json$Encode$float(config.eq.w8)),
				_Utils_Tuple2(
				'longitude',
				$elm$json$Json$Encode$float(config.eq.yg))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$TravelTime$eventToString = function (event) {
	if (!event.$) {
		return 'setup';
	} else {
		return 'distance';
	}
};
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$TravelTime$encodeTravelTimeEvent = function (event) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'kind',
				$elm$json$Json$Encode$string(
					$author$project$TravelTime$eventToString(event))),
			$author$project$TravelTime$encodeEventAttributes(event)));
};
var $author$project$TravelTime$travelTimeStream = _Platform_outgoingPort('travelTimeStream', $elm$core$Basics$identity);
var $author$project$TravelTime$pushTravelTimeEvent = function (event) {
	return $author$project$TravelTime$travelTimeStream(
		$author$project$TravelTime$encodeTravelTimeEvent(event));
};
var $author$project$TravelTime$init = function (flags) {
	var _v0 = flags.oU;
	var domainId = _v0.a;
	return _Utils_Tuple2(
		{
			cq: $elm$core$Maybe$Nothing,
			cF: domainId,
			af: 2,
			cG: $elm$core$Maybe$Nothing,
			cO: flags.cO,
			ah: $author$project$View$LocationSuggestions$init,
			av: $elm$core$Maybe$Just(flags.av),
			Nk: {w8: flags.w8, yg: flags.yg},
			ch: flags.ch
		},
		$author$project$TravelTime$pushTravelTimeEvent($author$project$TravelTime$Setup));
};
var $author$project$View$Autocomplete$Http$Button = function (a) {
	return {$: 1, a: a};
};
var $author$project$TravelTime$LocationSuggestionsMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$TravelTime$SetLocationSuggestion = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$LocationSuggestions$TomTom = 1;
var $author$project$TravelTime$locationSuggestionsConfig = F2(
	function (domainId, sessionToken) {
		return {
			cr: 'location-search-only',
			cF: domainId,
			xp: $author$project$TravelTime$LocationSuggestionsMsg,
			Wh: 1,
			av: sessionToken,
			Wv: $author$project$View$Autocomplete$Http$Button(
				{Wu: $author$project$TravelTime$SetLocationSuggestion, WL: $elm$core$Maybe$Nothing}),
			e4: 'location-search-travel-time'
		};
	});
var $author$project$View$LocationSuggestions$GotVisitorCoordinates = function (a) {
	return {$: 2, a: a};
};
var $author$project$View$LocationSuggestions$gotVisitorCoordinates = _Platform_incomingPort('gotVisitorCoordinates', $elm$json$Json$Decode$value);
var $author$project$View$LocationSuggestions$LocationAutocompleteMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Suggestion$LocationSuggestion = F5(
	function (locationDescription, streetName, localName, latitude, longitude) {
		return {w8: latitude, xT: localName, Vn: locationDescription, yg: longitude, NZ: streetName};
	});
var $author$project$Model$Suggestion$locationSuggestionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'longitude',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'latitude',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'localName',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'streetName',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'locationDescription',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$Suggestion$LocationSuggestion))))));
var $author$project$View$LocationSuggestions$serviceParam = function (service) {
	return A2(
		$elm$url$Url$Builder$string,
		'service',
		function () {
			if (service === 1) {
				return 'tomtom';
			} else {
				return 'google';
			}
		}());
};
var $author$project$View$LocationSuggestions$requestLocationSuggestions = F5(
	function (domainId, service, trackingId, mSessionToken, keyword) {
		var defaultParams = _List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'keywords', keyword),
				$author$project$View$LocationSuggestions$serviceParam(service)
			]);
		var paramsWithSessionToken = A2(
			$elm$core$Maybe$withDefault,
			defaultParams,
			A2(
				$elm$core$Maybe$map,
				function (sessionToken) {
					return _Utils_ap(
						defaultParams,
						_List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'sessionToken', sessionToken)
							]));
				},
				mSessionToken));
		return $elm$http$Http$request(
			{
				a2: $elm$http$Http$emptyBody,
				cH: A2(
					$elm$http$Http$expectJson,
					$elm$core$Basics$identity,
					A2(
						$elm$json$Json$Decode$map,
						function (suggestions) {
							return _Utils_Tuple2(suggestions, $elm$core$Maybe$Nothing);
						},
						$elm$json$Json$Decode$list($author$project$Model$Suggestion$locationSuggestionDecoder))),
				cL: _List_Nil,
				c0: 'GET',
				dF: $elm$core$Maybe$Nothing,
				WM: $elm$core$Maybe$Just(trackingId),
				dK: A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						[
							'api',
							$author$project$Data$Id$toString(domainId),
							'suggestions',
							'locations'
						]),
					paramsWithSessionToken)
			});
	});
var $author$project$View$LocationSuggestions$locationSearchConfig = F2(
	function (config, _v0) {
		return {
			dT: function () {
				var _v1 = config.Wh;
				if (_v1 === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Just(
						A2(
							$elm$url$Url$Builder$absolute,
							_List_fromArray(
								['static', 'images', 'powered_by_google_on_white_hdpi.png']),
							_List_Nil));
				}
			}(),
			cO: 'location',
			xp: A2($elm$core$Basics$composeL, config.xp, $author$project$View$LocationSuggestions$LocationAutocompleteMsg),
			B1: $author$project$Copy$copy.Bs,
			dd: $author$project$Copy$copy.Js,
			Ie: A4($author$project$View$LocationSuggestions$requestLocationSuggestions, config.cF, config.Wh, config.e4, config.av),
			Wv: config.Wv,
			Pu: $elm$core$Basics$always($elm$core$Maybe$Nothing),
			WI: function ($) {
				return $.Vn;
			},
			e3: $elm$core$Maybe$Just('all-vacancies'),
			e4: config.e4
		};
	});
var $author$project$View$LocationSuggestions$Known = function (a) {
	return {$: 4, a: a};
};
var $author$project$View$LocationSuggestions$VisitorRequestError = {$: 2};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$View$LocationSuggestions$visitorCoordinates = function (value) {
	var decoder = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (lat, lng) {
				return $author$project$View$LocationSuggestions$Known(
					{em: lat, ep: lng});
			}),
		A2($elm$json$Json$Decode$field, 'lat', $elm$json$Json$Decode$float),
		A2($elm$json$Json$Decode$field, 'lng', $elm$json$Json$Decode$float));
	return A2(
		$elm$core$Result$withDefault,
		$author$project$View$LocationSuggestions$VisitorRequestError,
		A2($elm$json$Json$Decode$decodeValue, decoder, value));
};
var $author$project$View$LocationSuggestions$subscriptions = F2(
	function (config, state) {
		var state_ = state;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$author$project$View$Autocomplete$Http$subscriptions,
					A2($author$project$View$LocationSuggestions$locationSearchConfig, config, state),
					state_.U),
					A2(
					$elm$core$Platform$Sub$map,
					config.xp,
					$author$project$View$LocationSuggestions$gotVisitorCoordinates(
						A2($elm$core$Basics$composeL, $author$project$View$LocationSuggestions$GotVisitorCoordinates, $author$project$View$LocationSuggestions$visitorCoordinates)))
				]));
	});
var $author$project$TravelTime$subscriptions = function (model) {
	return A2(
		$author$project$View$LocationSuggestions$subscriptions,
		A2($author$project$TravelTime$locationSuggestionsConfig, model.cF, model.av),
		model.ah);
};
var $author$project$TravelTime$CalculateDistance = function (a) {
	return {$: 1, a: a};
};
var $author$project$TravelTime$toCalcEvent = F2(
	function (drivingMode, latlong) {
		return $author$project$TravelTime$pushTravelTimeEvent(
			$author$project$TravelTime$CalculateDistance(
				{af: drivingMode, eq: latlong}));
	});
var $author$project$TravelTime$cmdCalcDistance = F2(
	function (drivingMode, latlong) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				$author$project$TravelTime$toCalcEvent(drivingMode),
				latlong));
	});
var $author$project$View$Autocomplete$Http$reset = function (_v0) {
	var state = _v0;
	return _Utils_update(
		state,
		{s: $author$project$Data$Autocomplete$unknown, wF: $author$project$Data$Key$newKey});
};
var $author$project$View$LocationSuggestions$reset = function (_v0) {
	var state = _v0;
	return _Utils_update(
		state,
		{
			U: $author$project$View$Autocomplete$Http$reset(state.U),
			az: $author$project$View$LocationSuggestions$Unknown
		});
};
var $author$project$TravelTime$toLatLong = function (location) {
	return A3(
		$elm$core$Maybe$map2,
		F2(
			function (lat, _long) {
				return {w8: lat, yg: _long};
			}),
		location.w8,
		location.yg);
};
var $author$project$View$LocationSuggestions$Requested = {$: 1};
var $author$project$View$LocationSuggestions$ReverseGeocodingError = function (a) {
	return {$: 3, a: a};
};
var $author$project$View$Autocomplete$Http$fromList = function (xs) {
	return {
		s: $author$project$Data$Autocomplete$fromList(
			A2($elm$core$List$map, $author$project$View$Autocomplete$Http$Suggestion, xs)),
		T: '',
		wF: $author$project$Data$Key$newKey
	};
};
var $author$project$View$LocationSuggestions$GotReverseGeocoding = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{a2: $elm$http$Http$emptyBody, cH: r.cH, cL: _List_Nil, c0: 'GET', dF: $elm$core$Maybe$Nothing, WM: $elm$core$Maybe$Nothing, dK: r.dK});
};
var $author$project$View$LocationSuggestions$requestReverseGeocoding = F3(
	function (domainId, service, coordinates) {
		return $elm$http$Http$get(
			{
				cH: A2(
					$elm$http$Http$expectJson,
					$author$project$View$LocationSuggestions$GotReverseGeocoding(
						$author$project$View$LocationSuggestions$Known(coordinates)),
					$elm$json$Json$Decode$list($author$project$Model$Suggestion$locationSuggestionDecoder)),
				dK: A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						[
							'api',
							$author$project$Data$Id$toString(domainId),
							'suggestions',
							'reverse-geocoding'
						]),
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'lat',
							$elm$core$String$fromFloat(coordinates.em)),
							A2(
							$elm$url$Url$Builder$string,
							'lng',
							$elm$core$String$fromFloat(coordinates.ep)),
							$author$project$View$LocationSuggestions$serviceParam(service)
						]))
			});
	});
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$View$LocationSuggestions$requestVisitorCoordinates = _Platform_outgoingPort(
	'requestVisitorCoordinates',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$View$LocationSuggestions$update = F3(
	function (config, msg, state) {
		var state_ = state;
		switch (msg.$) {
			case 0:
				var msg_ = msg.a;
				var _v1 = A4(
					$author$project$View$Autocomplete$Http$update,
					A2($elm$core$Basics$composeL, config.xp, $author$project$View$LocationSuggestions$LocationAutocompleteMsg),
					A2($author$project$View$LocationSuggestions$locationSearchConfig, config, state),
					msg_,
					state_.U);
				var autocompleteState = _v1.a;
				var autocompleteCmds = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						state_,
						{U: autocompleteState}),
					autocompleteCmds);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						state_,
						{az: $author$project$View$LocationSuggestions$Requested}),
					$author$project$View$LocationSuggestions$requestVisitorCoordinates(0));
			case 2:
				if (msg.a.$ === 4) {
					var coordinates = msg.a.a;
					return _Utils_Tuple2(
						state,
						A2(
							$elm$core$Platform$Cmd$map,
							config.xp,
							A3($author$project$View$LocationSuggestions$requestReverseGeocoding, config.cF, config.Wh, coordinates)));
				} else {
					var location = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{az: location}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				if (msg.b.$ === 1) {
					var err = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{
								az: $author$project$View$LocationSuggestions$ReverseGeocodingError(err)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var visitorLocation = msg.a;
					var suggestions = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{
								U: $author$project$View$Autocomplete$Http$fromList(suggestions),
								az: visitorLocation
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$TravelTime$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 3:
				var distance = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cq: $elm$core$Maybe$Just(distance)
						}),
					$elm$core$Platform$Cmd$none);
			case 0:
				var mode = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{af: mode}),
					A2($author$project$TravelTime$cmdCalcDistance, mode, model.cG));
			case 1:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cG: $author$project$TravelTime$toLatLong(location),
							ah: $author$project$View$LocationSuggestions$reset(model.ah)
						}),
					A2(
						$author$project$TravelTime$cmdCalcDistance,
						model.af,
						$author$project$TravelTime$toLatLong(location)));
			default:
				var locationSuggestionsMsg = msg.a;
				var _v1 = A3(
					$author$project$View$LocationSuggestions$update,
					A2($author$project$TravelTime$locationSuggestionsConfig, model.cF, model.av),
					locationSuggestionsMsg,
					model.ah);
				var locationSuggestionsModel = _v1.a;
				var locationSuggestionsCmds = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ah: locationSuggestionsModel}),
					locationSuggestionsCmds);
		}
	});
var $author$project$Data$Icon$Path = $elm$core$Basics$identity;
var $author$project$Data$Icon$path = {fg: '/static/icons/accordion.svg', fi: '/static/icons/accordion-group.svg', fr: '/static/icons/activate.svg', fz: '/static/icons/add.svg', T6: '/static/icons/address.svg', T7: '/static/icons/address-autofill.svg', gi: '/static/icons/align-center.svg', gl: '/static/icons/align-justify.svg', gm: '/static/icons/align-left.svg', gn: '/static/icons/align-right.svg', go: '/static/icons/align-stretch.svg', gH: '/static/icons/analytics.svg', gK: '/static/icons/anchor-link.svg', gW: '/static/icons/appetizer.svg', g$: '/static/icons/applicant-journey-group.svg', hq: '/static/icons/application-process.svg', hM: '/static/icons/archive.svg', hT: '/static/icons/arrow-down.svg', hU: '/static/icons/arrow-down-light.svg', hV: '/static/icons/arrow-down-new.svg', hW: '/static/icons/arrow-down-openluchtmuseum.svg', hX: '/static/icons/arrow-left.svg', hY: '/static/icons/arrow-left-new.svg', hZ: '/static/icons/arrow-left-openluchtmuseum.svg', h_: '/static/icons/arrow-right.svg', Ue: '/static/icons/arrow-right-new.svg', h$: '/static/icons/arrow-right-openluchtmuseum.svg', h0: '/static/icons/arrow-up.svg', h1: '/static/icons/arrow-up-light.svg', h2: '/static/icons/arrow-up-new.svg', h3: '/static/icons/arrows-rotate.svg', h7: '/static/icons/assessment.svg', id: '/static/icons/atom.svg', ii: '/static/icons/audio.svg', Ug: '/static/icons/austria.svg', it: '/static/icons/availability.svg', iU: '/static/icons/banner.svg', i0: '/static/icons/banner-location-search.svg', i1: '/static/icons/banner-search.svg', i8: '/static/icons/banner-video.svg', jb: '/static/icons/banner-video-location-search.svg', jc: '/static/icons/banner-video-search.svg', Ui: '/static/icons/belgium.svg', jt: '/static/icons/bike.svg', Uk: '/static/icons/birthday.svg', jz: '/static/icons/bold.svg', jK: '/static/icons/breadcrumbs.svg', jZ: '/static/icons/button.svg', j3: '/static/icons/calendar.svg', Um: '/static/icons/calendar-new.svg', kj: '/static/icons/car.svg', kk: '/static/icons/card.svg', km: '/static/icons/card-fold-out.svg', kn: '/static/icons/card-slider.svg', kS: '/static/icons/chat.svg', Up: '/static/icons/checkmark.svg', Uq: '/static/icons/checkmark-new.svg', Us: '/static/icons/china.svg', le: '/static/icons/city.svg', lo: '/static/icons/click-trough.svg', lr: '/static/icons/clock.svg', d_: '/static/icons/code.svg', l8: '/static/icons/consent.svg', ma: '/static/icons/contact.svg', mb: '/static/icons/contact-form.svg', mc: '/static/icons/contact-person.svg', md: '/static/icons/contact-person-ats.svg', cv: '/static/icons/content.svg', mh: '/static/icons/content-slider.svg', mj: '/static/icons/contract-type.svg', mt: '/static/icons/copy.svg', mH: '/static/icons/country.svg', nt: '/static/icons/cv.svg', ny: '/static/icons/dashboard.svg', nI: '/static/icons/datepicker.svg', UJ: '/static/icons/delete.svg', UK: '/static/icons/denmark.svg', ok: '/static/icons/department.svg', ou: '/static/icons/desktop.svg', oH: '/static/icons/discipline.svg', oM: '/static/icons/distance.svg', oS: '/static/icons/document.svg', oT: '/static/icons/documents.svg', o9: '/static/icons/edit.svg', pk: '/static/icons/education.svg', d4: '/static/icons/email.svg', pT: '/static/icons/employee-content.svg', qc: '/static/icons/end-date.svg', qd: '/static/icons/english.svg', qv: '/static/icons/event-items.svg', qC: '/static/icons/events.svg', qI: '/static/icons/expand.svg', qK: '/static/icons/experience.svg', q3: '/static/icons/facebook.svg', rb: '/static/icons/favorites.svg', rp: '/static/icons/file.svg', rq: '/static/icons/file-browser.png', rz: '/static/icons/filter.svg', U_: '/static/icons/finland.svg', r1: '/static/icons/first-live-interview.svg', r3: '/static/icons/first-name.svg', bP: '/static/icons/form.svg', sb: '/static/icons/formBuilder.svg', sl: '/static/icons/forms.svg', U5: '/static/icons/france.svg', U7: '/static/icons/germany.svg', U8: '/static/icons/global.svg', sJ: '/static/icons/globe.svg', tA: '/static/icons/heading.svg', tD: '/static/icons/heart.svg', tU: '/static/icons/home.svg', t6: '/static/icons/house.svg', t7: '/static/icons/houseAutocomplete.svg', ec: '/static/icons/html.svg', uw: '/static/icons/iframe.svg', ux: '/static/icons/image.svg', Vg: '/static/icons/info.svg', uZ: '/static/icons/input-text.svg', u$: '/static/icons/instagram.svg', Vh: '/static/icons/intro.svg', vY: '/static/icons/italic.svg', v5: '/static/icons/job-alert.svg', wx: '/static/icons/journey-slider.svg', wy: '/static/icons/journey-tabs.svg', wz: '/static/icons/journey-tabs-video.svg', wI: '/static/icons/keyword-search.svg', xa: '/static/icons/layout1.svg', xb: '/static/icons/layout2.svg', xc: '/static/icons/layout3.svg', xd: '/static/icons/layout4.svg', xe: '/static/icons/layout5.svg', xf: '/static/icons/layout6.svg', xg: '/static/icons/layout7.svg', xh: '/static/icons/layout8.svg', xv: '/static/icons/link.svg', xM: '/static/icons/linkedin.svg', xN: '/static/icons/linkedin-outline.svg', Vm: '/static/icons/linkedin-url.svg', xO: '/static/icons/list-item-defenture.svg', xR: '/static/icons/loading.svg', eq: '/static/icons/location.svg', xV: '/static/icons/location-contact.svg', x3: '/static/icons/location-vector.svg', yf: '/static/icons/logout.svg', Vo: '/static/icons/luxembourg.svg', yv: '/static/icons/map.svg', Vp: '/static/icons/map-new.svg', y0: '/static/icons/mediaLibrary.svg', zn: '/static/icons/minimize.svg', zx: '/static/icons/mobile-phone.svg', Vv: '/static/icons/motivation.svg', zS: '/static/icons/move.svg', Vy: '/static/icons/netherlands.svg', AR: '/static/icons/news-overview.svg', VI: '/static/icons/norway.svg', CD: '/static/icons/not-visible.svg', CE: '/static/icons/notification.svg', VJ: '/static/icons/notification-checkmark.svg', VK: '/static/icons/notification-close.svg', VL: '/static/icons/notification-error.svg', VM: '/static/icons/notification-info.svg', VN: '/static/icons/notification-warning.svg', CL: '/static/icons/offer.svg', DD: '/static/icons/ordered-list.svg', DI: '/static/icons/orientation-day.svg', Eg: '/static/icons/pages.svg', Eh: '/static/icons/pagesOverview.svg', Ex: '/static/icons/Path.svg', VW: '/static/icons/person.svg', EN: '/static/icons/personCms.svg', aM: '/static/icons/phone.svg', EX: '/static/icons/phone-interview.svg', VX: '/static/icons/phone-new.svg', E2: '/static/icons/phone-with-country-code.svg', E7: '/static/icons/pinterest.svg', V$: '/static/icons/poland.svg', V0: '/static/icons/portugal.svg', Gb: '/static/icons/publish.svg', GV: '/static/icons/redo.svg', HZ: '/static/icons/related-news.svg', H$: '/static/icons/related-vacancies.svg', H0: '/static/icons/related-vacancies-slider.svg', H3: '/static/icons/remove.svg', Wc: '/static/icons/romania.svg', Iz: '/static/icons/rotate.svg', IA: '/static/icons/route.svg', IB: '/static/icons/row.svg', IW: '/static/icons/salary-calculator.svg', Wd: '/static/icons/salary-indication.svg', Jg: '/static/icons/save.svg', Jo: '/static/icons/search.svg', Jx: '/static/icons/search-glass.svg', JB: '/static/icons/second-live-interview.svg', JE: '/static/icons/select.svg', Lf: '/static/icons/settings.svg', LA: '/static/icons/sharp-light-camera-user.svg', Wi: '/static/icons/singapore.svg', Mr: '/static/icons/skill-test.svg', Mu: '/static/icons/skype.svg', Mw: '/static/icons/slider-arrow.svg', Mx: '/static/icons/slider-arrow-white.svg', Wk: '/static/icons/slovakia.svg', ML: '/static/icons/snapchat.svg', Nb: '/static/icons/spacer.svg', Nd: '/static/icons/spacing.svg', Wl: '/static/icons/spain.svg', Nh: '/static/icons/star-filled.svg', Ni: '/static/icons/star-outline.svg', Nj: '/static/icons/start.svg', Wp: '/static/icons/store-data.svg', N2: '/static/icons/strikethrough.svg', N9: '/static/icons/submit-application.svg', Wx: '/static/icons/sweden.svg', Wy: '/static/icons/switzerland.svg', OF: '/static/icons/tablet.svg', OG: '/static/icons/tabs-video.svg', O0: '/static/icons/testimonial.svg', O1: '/static/icons/text.svg', WB: '/static/icons/text-area.svg', Pd: '/static/icons/the-netherlands.svg', Pl: '/static/icons/tiktok.svg', PT: '/static/icons/train.svg', P0: '/static/icons/trash.svg', P1: '/static/icons/travel-time.svg', P5: '/static/icons/tumblr.svg', Qb: '/static/icons/twitter.svg', WO: '/static/icons/ukraine.svg', Qj: '/static/icons/underline.svg', Qk: '/static/icons/undo.svg', Qq: '/static/icons/united-kingdom.svg', WQ: '/static/icons/united-states.svg', WU: '/static/icons/unordered-list.svg', QL: '/static/icons/upload-file.svg', Ru: '/static/icons/user-unlock.svg', Ry: '/static/icons/usp.svg', RN: '/static/icons/vacancy-associated-options.svg', RR: '/static/icons/vacancy-banner.svg', RW: '/static/icons/vacancy-description.svg', R2: '/static/icons/vacancy-filter-links.svg', R4: '/static/icons/vacancy-hidden-form.svg', Sc: '/static/icons/vacancy-overview.svg', Sh: '/static/icons/vacancy-search.svg', SG: '/static/icons/video.svg', SK: '/static/icons/video-interview.svg', SY: '/static/icons/visible.svg', S4: '/static/icons/walking.svg', S5: '/static/icons/wallet.svg', Tb: '/static/icons/wechat.svg', Tt: '/static/icons/whatsapp.svg', TE: '/static/icons/world.svg', TG: '/static/icons/worldmap.svg', TM: '/static/icons/x.svg', TN: '/static/icons/xing.svg', T_: '/static/icons/youtube.svg'};
var $author$project$View$Icon$path = $author$project$Data$Icon$path;
var $author$project$TravelTime$modeToIcon = function (drivingMode) {
	switch (drivingMode) {
		case 2:
			return $author$project$View$Icon$path.kj;
		case 0:
			return $author$project$View$Icon$path.jt;
		case 3:
			return $author$project$View$Icon$path.PT;
		default:
			return $author$project$View$Icon$path.S4;
	}
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Model$MaskColor$Secondary = 3;
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Data$MaskColor$toClass = function (maskColor) {
	switch (maskColor) {
		case 0:
			return 'bg-white';
		case 1:
			return 'bg-text';
		case 2:
			return 'bg-color-1';
		case 3:
			return 'bg-color-2';
		default:
			return '';
	}
};
var $author$project$View$Icon$viewMasked = F2(
	function (color, _v0) {
		var iconPath = _v0;
		var maskImage = A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'url(\'{0}\')',
			_List_fromArray(
				[iconPath]));
		var style_ = function () {
			if (color === 4) {
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'background-image', maskImage)
					]);
			} else {
				return _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'mask-image', maskImage),
						A2($elm$html$Html$Attributes$style, '-webkit-mask-image', maskImage)
					]);
			}
		}();
		var class_ = $elm$html$Html$Attributes$class(
			$author$project$Data$MaskColor$toClass(color));
		var attrs = _Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('icon'),
					class_
				]),
			style_);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('colored-icon')
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$div, attrs, _List_Nil)
				]));
	});
var $author$project$View$Icon$viewColored = $author$project$View$Icon$viewMasked(3);
var $author$project$TravelTime$viewDistance = function (model) {
	return A2(
		$author$project$Util$View$viewMaybe,
		model.cq,
		function (distance) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('info-window')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('distance-info')
							]),
						_List_fromArray(
							[
								$author$project$View$Icon$viewColored(
								$author$project$TravelTime$modeToIcon(model.af)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('duration')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(distance.o2)
									]))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('distance')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(distance.oM)
							]))
					]));
		});
};
var $author$project$TravelTime$GotNewDistance = function (a) {
	return {$: 3, a: a};
};
var $author$project$Util$Decode$debugHelper = F3(
	function (_v0, decoder, _v1) {
		return decoder;
	});
var $author$project$Util$Decode$debug = F2(
	function (message, decoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			A2($author$project$Util$Decode$debugHelper, message, decoder),
			$elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$resolve = $elm$json$Json$Decode$andThen($elm$core$Basics$identity);
var $author$project$TravelTime$decodeDistance = function () {
	var toDistance = F4(
		function (distance, distanceVal, durationStr, durationVal) {
			return $elm$json$Json$Decode$succeed(
				$author$project$TravelTime$GotNewDistance(
					{oM: distance, oP: distanceVal, o2: durationStr, o3: durationVal}));
		});
	return A2(
		$author$project$Util$Decode$debug,
		'distance: ',
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$resolve(
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['detail', 'duration', 'value']),
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['detail', 'duration', 'text']),
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['detail', 'distance', 'value']),
						$elm$json$Json$Decode$float,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['detail', 'distance', 'text']),
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed(toDistance)))))));
}();
var $author$project$TravelTime$viewMap = function (id_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('map'),
				$elm$html$Html$Attributes$id(id_),
				A2($elm$html$Html$Events$on, 'onDistanceChange', $author$project$TravelTime$decodeDistance)
			]),
		_List_Nil);
};
var $author$project$View$LocationSuggestions$viewHiddenCoordinateInputs = function (visitorLocation) {
	if (visitorLocation.$ === 4) {
		var location = visitorLocation.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('hidden'),
							$elm$html$Html$Attributes$name('latitude'),
							$elm$html$Html$Attributes$value(
							$elm$core$String$fromFloat(location.em))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('hidden'),
							$elm$html$Html$Attributes$name('longitude'),
							$elm$html$Html$Attributes$value(
							$elm$core$String$fromFloat(location.ep))
						]),
					_List_Nil)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$View$LocationSuggestions$RequestVisitorLocation = {$: 1};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$View$LocationSuggestions$viewRequestVisitorLocation = function (visitorLocation) {
	switch (visitorLocation.$) {
		case 3:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('visitor-location-error')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('visitor-location-btn-text')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Copy$copy.x1)
							]))
					]));
		case 2:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('visitor-location-error')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('visitor-location-btn-text')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Copy$copy.x1)
							]))
					]));
		case 1:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('visitor-location-loading')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('visitor-location-btn-text')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Copy$copy.xR)
							]))
					]));
		case 4:
			return $elm$html$Html$text('');
		default:
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('visitor-location-btn'),
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Attributes$title($author$project$Copy$copy.Js),
						A2($elm$html$Html$Attributes$attribute, 'aria-label', $author$project$Copy$copy.Js),
						A2(
						$elm$html$Html$Events$preventDefaultOn,
						'click',
						$elm$json$Json$Decode$succeed(
							_Utils_Tuple2($author$project$View$LocationSuggestions$RequestVisitorLocation, true)))
					]),
				_List_fromArray(
					[
						$author$project$View$Icon$viewColored($author$project$View$Icon$path.oM)
					]));
	}
};
var $author$project$View$LocationSuggestions$view = F2(
	function (config, state) {
		var state_ = state;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-field'),
					$elm$html$Html$Attributes$class(config.cr),
					$elm$html$Html$Attributes$id('form-field-location')
				]),
			_Utils_ap(
				A2(
					$author$project$View$Autocomplete$Http$view,
					A2($author$project$View$LocationSuggestions$locationSearchConfig, config, state),
					state_.U),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						config.xp,
						$author$project$View$LocationSuggestions$viewRequestVisitorLocation(state_.az)),
						$author$project$View$LocationSuggestions$viewHiddenCoordinateInputs(state_.az)
					])));
	});
var $author$project$TravelTime$Bike = 0;
var $author$project$TravelTime$ByFoot = 1;
var $author$project$TravelTime$SetDrivingMode = function (a) {
	return {$: 0, a: a};
};
var $author$project$TravelTime$Transit = 3;
var $author$project$TravelTime$modeToTranslation = function (drivingMode) {
	switch (drivingMode) {
		case 2:
			return $author$project$Copy$copy.kj;
		case 0:
			return $author$project$Copy$copy.jt;
		case 3:
			return $author$project$Copy$copy.P_;
		default:
			return $author$project$Copy$copy.j0;
	}
};
var $author$project$TravelTime$viewDrivingMode = function (drivingMode) {
	var toButton = function (mode) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('btn', true),
							_Utils_Tuple2(
							'active',
							_Utils_eq(drivingMode, mode))
						])),
					$elm$html$Html$Events$onClick(
					$author$project$TravelTime$SetDrivingMode(mode)),
					$elm$html$Html$Attributes$title(
					$author$project$TravelTime$modeToTranslation(mode))
				]),
			_List_fromArray(
				[
					$author$project$View$Icon$viewColored(
					$author$project$TravelTime$modeToIcon(mode))
				]));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('driving-mode')
			]),
		_List_fromArray(
			[
				toButton(0),
				toButton(1),
				toButton(2),
				toButton(3)
			]));
};
var $author$project$TravelTime$viewNavigation = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('navigation')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$View$LocationSuggestions$view,
				A2($author$project$TravelTime$locationSuggestionsConfig, model.cF, model.av),
				model.ah),
				$author$project$TravelTime$viewDrivingMode(model.af)
			]));
};
var $author$project$TravelTime$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('travel-time')
			]),
		_List_fromArray(
			[
				$author$project$TravelTime$viewNavigation(model),
				$author$project$TravelTime$viewDistance(model),
				$author$project$TravelTime$viewMap(model.cO)
			]));
};
var $author$project$TravelTime$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$TravelTime$decodeFlags,
	{cR: $author$project$TravelTime$init, dC: $author$project$TravelTime$subscriptions, dJ: $author$project$TravelTime$update, dM: $author$project$TravelTime$view});
var $author$project$Model$Component$Slider$ElmFlags = F5(
	function (slider, sliderType, windowWidth, infinity, useDifferentArrow) {
		return {uT: infinity, Mv: slider, MD: sliderType, Q8: useDifferentArrow, ch: windowWidth};
	});
var $author$project$Model$Component$Slider$ApplicantJourneySlider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Component$Slider$ApplicantJourneyWithHoverSlider = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Component$Slider$ApplicationProcedureSlider = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Component$Slider$CardSlider = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Component$Slider$ContentSlider = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Component$Slider$RelatedVacanciesSlider = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$Content$ApplicantJourney$ApplicantJourney = F5(
	function (title, description, image, cta, link) {
		return {m8: cta, cD: description, ux: image, xv: link, WC: title};
	});
var $author$project$Model$Content$Image$Image = F7(
	function (src, alt, title, align, horizontalAlign, url, ariaLabel) {
		return {Y: align, gC: alt, Ud: ariaLabel, tZ: horizontalAlign, dA: src, WC: title, dK: url};
	});
var $author$project$Model$Align$HorizontalAlignCenter = 1;
var $author$project$Model$Align$HorizontalAlignFill = 3;
var $author$project$Model$Align$HorizontalAlignLeft = 0;
var $author$project$Model$Align$HorizontalAlignRight = 2;
var $author$project$Model$Align$horizontalAlignDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'horizontal-align-left':
				return $elm$json$Json$Decode$succeed(0);
			case 'horizontal-align-center':
				return $elm$json$Json$Decode$succeed(1);
			case 'horizontal-align-right':
				return $elm$json$Json$Decode$succeed(2);
			case 'horizontal-align-fill':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Align$VerticalAlignBottom = 0;
var $author$project$Model$Align$VerticalAlignCenter = 1;
var $author$project$Model$Align$VerticalAlignFill = 3;
var $author$project$Model$Align$VerticalAlignTop = 2;
var $author$project$Model$Align$verticalAlignDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'vertical-align-bottom':
				return $elm$json$Json$Decode$succeed(0);
			case 'vertical-align-center':
				return $elm$json$Json$Decode$succeed(1);
			case 'vertical-align-top':
				return $elm$json$Json$Decode$succeed(2);
			case 'vertical-align-fill':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Content$Image$imageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ariaLabel',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'url',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'horizontalAlign',
			$author$project$Model$Align$horizontalAlignDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'align',
				$author$project$Model$Align$verticalAlignDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'title',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'alt',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'src',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Model$Content$Image$Image))))))));
var $author$project$Model$Content$ApplicantJourney$applicantJourneyDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'link',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'cta',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'image',
			$author$project$Model$Content$Image$imageDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'description',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'title',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$ApplicantJourney$ApplicantJourney))))));
var $author$project$Model$Content$ApplicantJourneyWithHover$ApplicantJourneyWithHover = F6(
	function (title, description, image, hoverVideo, cta, link) {
		return {m8: cta, cD: description, ud: hoverVideo, ux: image, xv: link, WC: title};
	});
var $author$project$Model$Content$Video$Video = F6(
	function (source, poster, showControls, aspectRatio, ariaLabel, autoPlay) {
		return {Ud: ariaLabel, Uf: aspectRatio, iq: autoPlay, b0: poster, LJ: showControls, M0: source};
	});
var $author$project$Model$Content$Video$AspectRatio$FourByThree = 2;
var $author$project$Model$Content$Video$AspectRatio$NineBySixteen = 1;
var $author$project$Model$Content$Video$AspectRatio$Original = 3;
var $author$project$Model$Content$Video$AspectRatio$SixteenByNine = 0;
var $author$project$Model$Content$Video$AspectRatio$aspectRatioDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'sixteen-by-nine':
				return $elm$json$Json$Decode$succeed(0);
			case 'nine-by-sixteen':
				return $elm$json$Json$Decode$succeed(1);
			case 'four-by-three':
				return $elm$json$Json$Decode$succeed(2);
			case 'original':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Content$Video$Url = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Content$Video$Vimeo = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Content$Video$YouTube = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Content$Video$VimeoId = $elm$core$Basics$identity;
var $author$project$Model$Content$Video$vimeoIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Model$Content$Video$YouTubeId = $elm$core$Basics$identity;
var $author$project$Model$Content$Video$youTubeIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Model$Content$Video$sourceDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'you-tube':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$Video$youTubeIdDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Video$YouTube));
			case 'vimeo':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$Video$vimeoIdDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Video$Vimeo));
			case 'url':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Video$Url));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$Content$Video$videoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'autoPlay',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ariaLabel',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'aspectRatio',
			$author$project$Model$Content$Video$AspectRatio$aspectRatioDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'showControls',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'poster',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'source',
						$author$project$Model$Content$Video$sourceDecoder,
						$elm$json$Json$Decode$succeed($author$project$Model$Content$Video$Video)))))));
var $author$project$Model$Content$ApplicantJourneyWithHover$applicantJourneyWithHoverDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'link',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'cta',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'hoverVideo',
			$author$project$Model$Content$Video$videoDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'image',
				$author$project$Model$Content$Image$imageDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'description',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Model$Content$ApplicantJourneyWithHover$ApplicantJourneyWithHover)))))));
var $author$project$Model$Component$Card$Card = F5(
	function (heading, image, linkElement, plainText, spacer) {
		return {tA: heading, ux: image, xz: linkElement, E9: plainText, Nb: spacer};
	});
var $author$project$Model$Content$Heading$Heading = F4(
	function (text, size, align, color) {
		return {Y: align, lK: color, dz: size, O1: text};
	});
var $author$project$Model$TextAlign$TextAlignCenter = 1;
var $author$project$Model$TextAlign$TextAlignJustify = 3;
var $author$project$Model$TextAlign$TextAlignLeft = 0;
var $author$project$Model$TextAlign$TextAlignRight = 2;
var $author$project$Model$TextAlign$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'left':
				return $elm$json$Json$Decode$succeed(0);
			case 'center':
				return $elm$json$Json$Decode$succeed(1);
			case 'right':
				return $elm$json$Json$Decode$succeed(2);
			case 'justify':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$TextColor$BackgroundDependent = 0;
var $author$project$Model$TextColor$Dark = 2;
var $author$project$Model$TextColor$Light = 1;
var $author$project$Model$TextColor$textColorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'background-dependent':
				return $elm$json$Json$Decode$succeed(0);
			case 'light':
				return $elm$json$Json$Decode$succeed(1);
			case 'dark':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Content$Heading$headingDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'color',
	$author$project$Model$TextColor$textColorDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'align',
		$author$project$Model$TextAlign$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'size',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'text',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$Content$Heading$Heading)))));
var $author$project$Model$Content$Link$Link = F6(
	function (text, href, target, style, align, ariaLabel) {
		return {Y: align, Ud: ariaLabel, uh: href, W: style, OS: target, O1: text};
	});
var $author$project$Model$Content$Link$Style$Style1 = 0;
var $author$project$Model$Content$Link$Style$Style2 = 1;
var $author$project$Model$Content$Link$Style$Style3 = 2;
var $author$project$Model$Content$Link$Style$Style4 = 3;
var $author$project$Model$Content$Link$Style$styleDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'style1':
				return $elm$json$Json$Decode$succeed(0);
			case 'style2':
				return $elm$json$Json$Decode$succeed(1);
			case 'style3':
				return $elm$json$Json$Decode$succeed(2);
			case 'style4':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Content$Link$linkDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ariaLabel',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'align',
		$author$project$Model$Align$horizontalAlignDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'style',
			$author$project$Model$Content$Link$Style$styleDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'target',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'href',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'text',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Model$Content$Link$Link)))))));
var $author$project$Model$Content$PlainText$PlainText = F3(
	function (text, align, color) {
		return {Y: align, lK: color, O1: text};
	});
var $author$project$Model$Content$PlainText$plainTextDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'color',
	$author$project$Model$TextColor$textColorDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'align',
		$author$project$Model$TextAlign$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'text',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Model$Content$PlainText$PlainText))));
var $author$project$Model$Size$SizeCustom = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Size$SizeExtraLarge = {$: 3};
var $author$project$Model$Size$SizeLarge = {$: 2};
var $author$project$Model$Size$SizeMedium = {$: 1};
var $author$project$Model$Size$SizeSmall = {$: 0};
var $author$project$Model$Size$sizeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'size-small':
				return $elm$json$Json$Decode$succeed($author$project$Model$Size$SizeSmall);
			case 'size-medium':
				return $elm$json$Json$Decode$succeed($author$project$Model$Size$SizeMedium);
			case 'size-large':
				return $elm$json$Json$Decode$succeed($author$project$Model$Size$SizeLarge);
			case 'size-extra-large':
				return $elm$json$Json$Decode$succeed($author$project$Model$Size$SizeExtraLarge);
			case 'size-custom':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Model$Size$SizeCustom));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$Component$Card$cardDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'spacer',
	$elm$json$Json$Decode$nullable($author$project$Model$Size$sizeDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'plainText',
		$author$project$Model$Content$PlainText$plainTextDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'linkElement',
			$author$project$Model$Content$Link$linkDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'image',
				$author$project$Model$Content$Image$imageDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'heading',
					$author$project$Model$Content$Heading$headingDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Component$Card$Card))))));
var $author$project$Model$Component$ContentGroup$ContentGroup = F3(
	function (align, content, maxWidth) {
		return {Y: align, cv: content, yQ: maxWidth};
	});
var $author$project$Model$Content$AnchorLink = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Content$ApplicantJourney = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Content$ApplicantJourneyWithHover = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Content$Button = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Content$Heading = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Content$Image = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$Content$IntroText = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$Content$Link = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$Content$OrderedList = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$Content$PlainText = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$Content$ResponsiveImage = function (a) {
	return {$: 10, a: a};
};
var $author$project$Model$Content$Spacer = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$Content$UnorderedList = function (a) {
	return {$: 13, a: a};
};
var $author$project$Model$Content$Usp = function (a) {
	return {$: 12, a: a};
};
var $author$project$Model$Content$Video = function (a) {
	return {$: 14, a: a};
};
var $author$project$Model$Content$AnchorLink$AnchorLink = function (anchor) {
	return {gJ: anchor};
};
var $author$project$Model$Content$AnchorLink$anchorLinkDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'anchor',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Model$Content$AnchorLink$AnchorLink));
var $author$project$Model$Content$Button$Button = F6(
	function (text, href, target, style, align, ariaLabel) {
		return {Y: align, Ud: ariaLabel, uh: href, W: style, OS: target, O1: text};
	});
var $author$project$Model$Content$Button$Style$Style1 = 0;
var $author$project$Model$Content$Button$Style$Style2 = 1;
var $author$project$Model$Content$Button$Style$Style3 = 2;
var $author$project$Model$Content$Button$Style$Style4 = 3;
var $author$project$Model$Content$Button$Style$styleDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'style1':
				return $elm$json$Json$Decode$succeed(0);
			case 'style2':
				return $elm$json$Json$Decode$succeed(1);
			case 'style3':
				return $elm$json$Json$Decode$succeed(2);
			case 'style4':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Content$Button$buttonDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ariaLabel',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'align',
		$author$project$Model$Align$horizontalAlignDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'style',
			$author$project$Model$Content$Button$Style$styleDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'target',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'href',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'text',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Model$Content$Button$Button)))))));
var $author$project$Model$Content$IntroText$IntroText = F3(
	function (text, align, color) {
		return {Y: align, lK: color, O1: text};
	});
var $author$project$Model$Content$IntroText$introTextDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'color',
	$author$project$Model$TextColor$textColorDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'align',
		$author$project$Model$TextAlign$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'text',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Model$Content$IntroText$IntroText))));
var $author$project$Model$Content$OrderedList$OrderedList = F2(
	function (items, ariaLabel) {
		return {Ud: ariaLabel, v0: items};
	});
var $author$project$Model$Content$OrderedList$orderedListDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ariaLabel',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'items',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Model$Content$OrderedList$OrderedList)));
var $author$project$Model$Content$ResponsiveImage$ResponsiveImage = F5(
	function (alt, title, mobile, tablet, desktop) {
		return {gC: alt, ou: desktop, zv: mobile, OF: tablet, WC: title};
	});
var $author$project$Model$Content$ResponsiveImage$responsiveImageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'desktop',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tablet',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'mobile',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'alt',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$ResponsiveImage$ResponsiveImage))))));
var $author$project$Model$Content$Spacer$Spacer = function (size) {
	return {dz: size};
};
var $author$project$Model$Content$Spacer$spacerDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'size',
	$author$project$Model$Size$sizeDecoder,
	$elm$json$Json$Decode$succeed($author$project$Model$Content$Spacer$Spacer));
var $author$project$Model$Content$UnorderedList$UnorderedList = F2(
	function (items, ariaLabel) {
		return {Ud: ariaLabel, v0: items};
	});
var $author$project$Model$Content$UnorderedList$unorderedListDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ariaLabel',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'items',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Model$Content$UnorderedList$UnorderedList)));
var $author$project$Model$Content$Usp$Usp = F8(
	function (text, src, alt, title, ariaLabel, url, description, bgFill) {
		return {gC: alt, Ud: ariaLabel, jn: bgFill, cD: description, dA: src, O1: text, WC: title, dK: url};
	});
var $author$project$Model$BackgroundFill$BackgroundGradient = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$BackgroundFill$BackgroundImage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BackgroundFill$BackgroundVideo = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$BackgroundGradient$BackgroundGradient = F2(
	function (from, to) {
		return {sr: from, Ps: to};
	});
var $author$project$Model$Color$Rgba = F4(
	function (red, green, blue, alpha) {
		return {gB: alpha, jy: blue, s6: green, GN: red};
	});
var $author$project$Model$Color$rgbaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'alpha',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'blue',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'green',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'red',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Model$Color$Rgba)))));
var $author$project$Model$BackgroundGradient$backgroundGradientDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to',
	$author$project$Model$Color$rgbaDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from',
		$author$project$Model$Color$rgbaDecoder,
		$elm$json$Json$Decode$succeed($author$project$Model$BackgroundGradient$BackgroundGradient)));
var $author$project$Model$BackgroundFill$backgroundFillDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'background-gradient':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$BackgroundGradient$backgroundGradientDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$BackgroundFill$BackgroundGradient));
			case 'background-image':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$BackgroundFill$BackgroundImage));
			case 'background-video':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$BackgroundFill$BackgroundVideo));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$Content$Usp$uspDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'bgFill',
	$elm$json$Json$Decode$nullable($author$project$Model$BackgroundFill$backgroundFillDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'url',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'ariaLabel',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'title',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'alt',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'src',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'text',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Model$Content$Usp$Usp)))))))));
var $author$project$Model$Content$contentDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'anchor-link':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$AnchorLink$anchorLinkDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$AnchorLink));
			case 'applicant-journey':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$ApplicantJourney$applicantJourneyDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$ApplicantJourney));
			case 'applicant-journey-with-hover':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$ApplicantJourneyWithHover$applicantJourneyWithHoverDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$ApplicantJourneyWithHover));
			case 'button':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$Button$buttonDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Button));
			case 'heading':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$Heading$headingDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Heading));
			case 'image':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$Image$imageDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Image));
			case 'intro-text':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$IntroText$introTextDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$IntroText));
			case 'link':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$Link$linkDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Link));
			case 'ordered-list':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$OrderedList$orderedListDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$OrderedList));
			case 'plain-text':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$PlainText$plainTextDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$PlainText));
			case 'responsive-image':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$ResponsiveImage$responsiveImageDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$ResponsiveImage));
			case 'spacer':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$Spacer$spacerDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Spacer));
			case 'usp':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$Usp$uspDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Usp));
			case 'unordered-list':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$UnorderedList$unorderedListDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$UnorderedList));
			case 'video':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$Video$videoDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Content$Video));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$Component$ContentGroup$contentGroupDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxWidth',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'content',
		$elm$json$Json$Decode$list($author$project$Model$Content$contentDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'align',
			$author$project$Model$Align$verticalAlignDecoder,
			$elm$json$Json$Decode$succeed($author$project$Model$Component$ContentGroup$ContentGroup))));
var $author$project$Model$ApplicationProcedure$ApplicationProcedureStep = F4(
	function (title, description, icon, maskColor) {
		return {cD: description, aH: icon, yB: maskColor, WC: title};
	});
var $author$project$Model$MaskColor$NoMask = 4;
var $author$project$Model$MaskColor$Primary = 2;
var $author$project$Model$MaskColor$TextColor = 1;
var $author$project$Model$MaskColor$White = 0;
var $author$project$Model$MaskColor$maskColorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'white':
				return $elm$json$Json$Decode$succeed(0);
			case 'text-color':
				return $elm$json$Json$Decode$succeed(1);
			case 'primary':
				return $elm$json$Json$Decode$succeed(2);
			case 'secondary':
				return $elm$json$Json$Decode$succeed(3);
			case 'no-mask':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$ApplicationProcedure$stepDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maskColor',
	$author$project$Model$MaskColor$maskColorDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'icon',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$ApplicationProcedure$ApplicationProcedureStep)))));
var $author$project$Model$Component$Slider$sliderDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'applicant-journey-slider':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list($author$project$Model$Content$ApplicantJourney$applicantJourneyDecoder),
					$elm$json$Json$Decode$succeed($author$project$Model$Component$Slider$ApplicantJourneySlider));
			case 'applicant-journey-with-hover-slider':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list($author$project$Model$Content$ApplicantJourneyWithHover$applicantJourneyWithHoverDecoder),
					$elm$json$Json$Decode$succeed($author$project$Model$Component$Slider$ApplicantJourneyWithHoverSlider));
			case 'application-procedure-slider':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list($author$project$Model$ApplicationProcedure$stepDecoder),
					$elm$json$Json$Decode$succeed($author$project$Model$Component$Slider$ApplicationProcedureSlider));
			case 'card-slider':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list($author$project$Model$Component$Card$cardDecoder),
					$elm$json$Json$Decode$succeed($author$project$Model$Component$Slider$CardSlider));
			case 'content-slider':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list($author$project$Model$Component$ContentGroup$contentGroupDecoder),
					$elm$json$Json$Decode$succeed($author$project$Model$Component$Slider$ContentSlider));
			case 'related-vacancies-slider':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$Component$Slider$RelatedVacanciesSlider));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$SliderType$InFives = 4;
var $author$project$Model$SliderType$InFours = 3;
var $author$project$Model$SliderType$InOne = 0;
var $author$project$Model$SliderType$InThrees = 2;
var $author$project$Model$SliderType$InTwos = 1;
var $author$project$Model$SliderType$sliderTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'in-one':
				return $elm$json$Json$Decode$succeed(0);
			case 'in-twos':
				return $elm$json$Json$Decode$succeed(1);
			case 'in-threes':
				return $elm$json$Json$Decode$succeed(2);
			case 'in-fours':
				return $elm$json$Json$Decode$succeed(3);
			case 'in-fives':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Component$Slider$elmFlagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'useDifferentArrow',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'infinity',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'windowWidth',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sliderType',
				$author$project$Model$SliderType$sliderTypeDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'slider',
					$author$project$Model$Component$Slider$sliderDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Component$Slider$ElmFlags))))));
var $author$project$Slider$amountOfVisibleCards = function (sliderType) {
	switch (sliderType) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		default:
			return 5;
	}
};
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $hecrj$html_parser$Html$Parser$Element = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {lH: col, Ut: contextStack, F_: problem, IB: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.IB, s.lH, x, s.f));
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.G, s.dA);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{lH: 1, f: s.f, g: s.g, G: s.G + 1, IB: s.IB + 1, dA: s.dA}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{lH: s.lH + 1, f: s.f, g: s.g, G: newOffset, IB: s.IB, dA: s.dA}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.dA);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.G, offset) < 0,
					0,
					{lH: col, f: s0.f, g: s0.g, G: offset, IB: row, dA: s0.dA});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.G, s.IB, s.lH, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
	return A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$chompIf(fn),
		$elm$parser$Parser$chompWhile(fn));
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.G, s1.G, s0.dA),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
	return (c === ' ') || ((c === '\t') || ((c === '\n') || ((c === '\u000D') || ((c === '\u000C') || (c === '\u00A0')))));
};
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $hecrj$html_parser$Html$Parser$closingTag = function (name) {
	var chompName = A2(
		$elm$parser$Parser$andThen,
		function (closingName) {
			return _Utils_eq(
				$elm$core$String$toLower(closingName),
				name) ? $elm$parser$Parser$succeed(0) : $elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
		},
		$elm$parser$Parser$getChompedString(
			$hecrj$html_parser$Html$Parser$chompOneOrMore(
				function (c) {
					return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== '>');
				})));
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<')),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('/'))),
				chompName),
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('>')));
};
var $hecrj$html_parser$Html$Parser$Comment = function (a) {
	return {$: 2, a: a};
};
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.G, s.IB, s.lH, s.dA);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.f)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.G, newOffset) < 0,
			0,
			{lH: newCol, f: s.f, g: s.g, G: newOffset, IB: newRow, dA: s.dA});
	};
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.G, s.IB, s.lH, s.dA);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{lH: newCol, f: s.f, g: s.g, G: newOffset, IB: newRow, dA: s.dA});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $hecrj$html_parser$Html$Parser$commentString = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$token('<!')),
		$elm$parser$Parser$token('--')),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompUntil('-->')),
		$elm$parser$Parser$token('-->')));
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $hecrj$html_parser$Html$Parser$comment = A2($elm$parser$Parser$map, $hecrj$html_parser$Html$Parser$Comment, $hecrj$html_parser$Html$Parser$commentString);
var $hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var $hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
	return A2($elm$core$List$member, name, $hecrj$html_parser$Html$Parser$voidElements);
};
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $hecrj$html_parser$Html$Parser$many = function (parser_) {
	return A2(
		$elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$map,
						function (_new) {
							return $elm$parser$Parser$Loop(
								A2($elm$core$List$cons, _new, list));
						},
						parser_),
						$elm$parser$Parser$succeed(
						$elm$parser$Parser$Done(
							$elm$core$List$reverse(list)))
					]));
		});
};
var $hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
	return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '>') && ((c !== '/') && (c !== '=')))));
};
var $hecrj$html_parser$Html$Parser$tagAttributeName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
var $hecrj$html_parser$Html$Parser$chompSemicolon = $elm$parser$Parser$chompIf(
	$elm$core$Basics$eq(';'));
var $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Aacute', 'Á'),
			_Utils_Tuple2('aacute', 'á'),
			_Utils_Tuple2('Abreve', 'Ă'),
			_Utils_Tuple2('abreve', 'ă'),
			_Utils_Tuple2('ac', '∾'),
			_Utils_Tuple2('acd', '∿'),
			_Utils_Tuple2('acE', '∾̳'),
			_Utils_Tuple2('Acirc', 'Â'),
			_Utils_Tuple2('acirc', 'â'),
			_Utils_Tuple2('acute', '´'),
			_Utils_Tuple2('Acy', 'А'),
			_Utils_Tuple2('acy', 'а'),
			_Utils_Tuple2('AElig', 'Æ'),
			_Utils_Tuple2('aelig', 'æ'),
			_Utils_Tuple2('af', '\u2061'),
			_Utils_Tuple2('Afr', '\uD835\uDD04'),
			_Utils_Tuple2('afr', '\uD835\uDD1E'),
			_Utils_Tuple2('Agrave', 'À'),
			_Utils_Tuple2('agrave', 'à'),
			_Utils_Tuple2('alefsym', 'ℵ'),
			_Utils_Tuple2('aleph', 'ℵ'),
			_Utils_Tuple2('Alpha', 'Α'),
			_Utils_Tuple2('alpha', 'α'),
			_Utils_Tuple2('Amacr', 'Ā'),
			_Utils_Tuple2('amacr', 'ā'),
			_Utils_Tuple2('amalg', '⨿'),
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('AMP', '&'),
			_Utils_Tuple2('andand', '⩕'),
			_Utils_Tuple2('And', '⩓'),
			_Utils_Tuple2('and', '∧'),
			_Utils_Tuple2('andd', '⩜'),
			_Utils_Tuple2('andslope', '⩘'),
			_Utils_Tuple2('andv', '⩚'),
			_Utils_Tuple2('ang', '∠'),
			_Utils_Tuple2('ange', '⦤'),
			_Utils_Tuple2('angle', '∠'),
			_Utils_Tuple2('angmsdaa', '⦨'),
			_Utils_Tuple2('angmsdab', '⦩'),
			_Utils_Tuple2('angmsdac', '⦪'),
			_Utils_Tuple2('angmsdad', '⦫'),
			_Utils_Tuple2('angmsdae', '⦬'),
			_Utils_Tuple2('angmsdaf', '⦭'),
			_Utils_Tuple2('angmsdag', '⦮'),
			_Utils_Tuple2('angmsdah', '⦯'),
			_Utils_Tuple2('angmsd', '∡'),
			_Utils_Tuple2('angrt', '∟'),
			_Utils_Tuple2('angrtvb', '⊾'),
			_Utils_Tuple2('angrtvbd', '⦝'),
			_Utils_Tuple2('angsph', '∢'),
			_Utils_Tuple2('angst', 'Å'),
			_Utils_Tuple2('angzarr', '⍼'),
			_Utils_Tuple2('Aogon', 'Ą'),
			_Utils_Tuple2('aogon', 'ą'),
			_Utils_Tuple2('Aopf', '\uD835\uDD38'),
			_Utils_Tuple2('aopf', '\uD835\uDD52'),
			_Utils_Tuple2('apacir', '⩯'),
			_Utils_Tuple2('ap', '≈'),
			_Utils_Tuple2('apE', '⩰'),
			_Utils_Tuple2('ape', '≊'),
			_Utils_Tuple2('apid', '≋'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('ApplyFunction', '\u2061'),
			_Utils_Tuple2('approx', '≈'),
			_Utils_Tuple2('approxeq', '≊'),
			_Utils_Tuple2('Aring', 'Å'),
			_Utils_Tuple2('aring', 'å'),
			_Utils_Tuple2('Ascr', '\uD835\uDC9C'),
			_Utils_Tuple2('ascr', '\uD835\uDCB6'),
			_Utils_Tuple2('Assign', '≔'),
			_Utils_Tuple2('ast', '*'),
			_Utils_Tuple2('asymp', '≈'),
			_Utils_Tuple2('asympeq', '≍'),
			_Utils_Tuple2('Atilde', 'Ã'),
			_Utils_Tuple2('atilde', 'ã'),
			_Utils_Tuple2('Auml', 'Ä'),
			_Utils_Tuple2('auml', 'ä'),
			_Utils_Tuple2('awconint', '∳'),
			_Utils_Tuple2('awint', '⨑'),
			_Utils_Tuple2('backcong', '≌'),
			_Utils_Tuple2('backepsilon', '϶'),
			_Utils_Tuple2('backprime', '‵'),
			_Utils_Tuple2('backsim', '∽'),
			_Utils_Tuple2('backsimeq', '⋍'),
			_Utils_Tuple2('Backslash', '∖'),
			_Utils_Tuple2('Barv', '⫧'),
			_Utils_Tuple2('barvee', '⊽'),
			_Utils_Tuple2('barwed', '⌅'),
			_Utils_Tuple2('Barwed', '⌆'),
			_Utils_Tuple2('barwedge', '⌅'),
			_Utils_Tuple2('bbrk', '⎵'),
			_Utils_Tuple2('bbrktbrk', '⎶'),
			_Utils_Tuple2('bcong', '≌'),
			_Utils_Tuple2('Bcy', 'Б'),
			_Utils_Tuple2('bcy', 'б'),
			_Utils_Tuple2('bdquo', '„'),
			_Utils_Tuple2('becaus', '∵'),
			_Utils_Tuple2('because', '∵'),
			_Utils_Tuple2('Because', '∵'),
			_Utils_Tuple2('bemptyv', '⦰'),
			_Utils_Tuple2('bepsi', '϶'),
			_Utils_Tuple2('bernou', 'ℬ'),
			_Utils_Tuple2('Bernoullis', 'ℬ'),
			_Utils_Tuple2('Beta', 'Β'),
			_Utils_Tuple2('beta', 'β'),
			_Utils_Tuple2('beth', 'ℶ'),
			_Utils_Tuple2('between', '≬'),
			_Utils_Tuple2('Bfr', '\uD835\uDD05'),
			_Utils_Tuple2('bfr', '\uD835\uDD1F'),
			_Utils_Tuple2('bigcap', '⋂'),
			_Utils_Tuple2('bigcirc', '◯'),
			_Utils_Tuple2('bigcup', '⋃'),
			_Utils_Tuple2('bigodot', '⨀'),
			_Utils_Tuple2('bigoplus', '⨁'),
			_Utils_Tuple2('bigotimes', '⨂'),
			_Utils_Tuple2('bigsqcup', '⨆'),
			_Utils_Tuple2('bigstar', '★'),
			_Utils_Tuple2('bigtriangledown', '▽'),
			_Utils_Tuple2('bigtriangleup', '△'),
			_Utils_Tuple2('biguplus', '⨄'),
			_Utils_Tuple2('bigvee', '⋁'),
			_Utils_Tuple2('bigwedge', '⋀'),
			_Utils_Tuple2('bkarow', '⤍'),
			_Utils_Tuple2('blacklozenge', '⧫'),
			_Utils_Tuple2('blacksquare', '▪'),
			_Utils_Tuple2('blacktriangle', '▴'),
			_Utils_Tuple2('blacktriangledown', '▾'),
			_Utils_Tuple2('blacktriangleleft', '◂'),
			_Utils_Tuple2('blacktriangleright', '▸'),
			_Utils_Tuple2('blank', '␣'),
			_Utils_Tuple2('blk12', '▒'),
			_Utils_Tuple2('blk14', '░'),
			_Utils_Tuple2('blk34', '▓'),
			_Utils_Tuple2('block', '█'),
			_Utils_Tuple2('bne', '=⃥'),
			_Utils_Tuple2('bnequiv', '≡⃥'),
			_Utils_Tuple2('bNot', '⫭'),
			_Utils_Tuple2('bnot', '⌐'),
			_Utils_Tuple2('Bopf', '\uD835\uDD39'),
			_Utils_Tuple2('bopf', '\uD835\uDD53'),
			_Utils_Tuple2('bot', '⊥'),
			_Utils_Tuple2('bottom', '⊥'),
			_Utils_Tuple2('bowtie', '⋈'),
			_Utils_Tuple2('boxbox', '⧉'),
			_Utils_Tuple2('boxdl', '┐'),
			_Utils_Tuple2('boxdL', '╕'),
			_Utils_Tuple2('boxDl', '╖'),
			_Utils_Tuple2('boxDL', '╗'),
			_Utils_Tuple2('boxdr', '┌'),
			_Utils_Tuple2('boxdR', '╒'),
			_Utils_Tuple2('boxDr', '╓'),
			_Utils_Tuple2('boxDR', '╔'),
			_Utils_Tuple2('boxh', '─'),
			_Utils_Tuple2('boxH', '═'),
			_Utils_Tuple2('boxhd', '┬'),
			_Utils_Tuple2('boxHd', '╤'),
			_Utils_Tuple2('boxhD', '╥'),
			_Utils_Tuple2('boxHD', '╦'),
			_Utils_Tuple2('boxhu', '┴'),
			_Utils_Tuple2('boxHu', '╧'),
			_Utils_Tuple2('boxhU', '╨'),
			_Utils_Tuple2('boxHU', '╩'),
			_Utils_Tuple2('boxminus', '⊟'),
			_Utils_Tuple2('boxplus', '⊞'),
			_Utils_Tuple2('boxtimes', '⊠'),
			_Utils_Tuple2('boxul', '┘'),
			_Utils_Tuple2('boxuL', '╛'),
			_Utils_Tuple2('boxUl', '╜'),
			_Utils_Tuple2('boxUL', '╝'),
			_Utils_Tuple2('boxur', '└'),
			_Utils_Tuple2('boxuR', '╘'),
			_Utils_Tuple2('boxUr', '╙'),
			_Utils_Tuple2('boxUR', '╚'),
			_Utils_Tuple2('boxv', '│'),
			_Utils_Tuple2('boxV', '║'),
			_Utils_Tuple2('boxvh', '┼'),
			_Utils_Tuple2('boxvH', '╪'),
			_Utils_Tuple2('boxVh', '╫'),
			_Utils_Tuple2('boxVH', '╬'),
			_Utils_Tuple2('boxvl', '┤'),
			_Utils_Tuple2('boxvL', '╡'),
			_Utils_Tuple2('boxVl', '╢'),
			_Utils_Tuple2('boxVL', '╣'),
			_Utils_Tuple2('boxvr', '├'),
			_Utils_Tuple2('boxvR', '╞'),
			_Utils_Tuple2('boxVr', '╟'),
			_Utils_Tuple2('boxVR', '╠'),
			_Utils_Tuple2('bprime', '‵'),
			_Utils_Tuple2('breve', '˘'),
			_Utils_Tuple2('Breve', '˘'),
			_Utils_Tuple2('brvbar', '¦'),
			_Utils_Tuple2('bscr', '\uD835\uDCB7'),
			_Utils_Tuple2('Bscr', 'ℬ'),
			_Utils_Tuple2('bsemi', '⁏'),
			_Utils_Tuple2('bsim', '∽'),
			_Utils_Tuple2('bsime', '⋍'),
			_Utils_Tuple2('bsolb', '⧅'),
			_Utils_Tuple2('bsol', '\\'),
			_Utils_Tuple2('bsolhsub', '⟈'),
			_Utils_Tuple2('bull', '•'),
			_Utils_Tuple2('bullet', '•'),
			_Utils_Tuple2('bump', '≎'),
			_Utils_Tuple2('bumpE', '⪮'),
			_Utils_Tuple2('bumpe', '≏'),
			_Utils_Tuple2('Bumpeq', '≎'),
			_Utils_Tuple2('bumpeq', '≏'),
			_Utils_Tuple2('Cacute', 'Ć'),
			_Utils_Tuple2('cacute', 'ć'),
			_Utils_Tuple2('capand', '⩄'),
			_Utils_Tuple2('capbrcup', '⩉'),
			_Utils_Tuple2('capcap', '⩋'),
			_Utils_Tuple2('cap', '∩'),
			_Utils_Tuple2('Cap', '⋒'),
			_Utils_Tuple2('capcup', '⩇'),
			_Utils_Tuple2('capdot', '⩀'),
			_Utils_Tuple2('CapitalDifferentialD', 'ⅅ'),
			_Utils_Tuple2('caps', '∩︀'),
			_Utils_Tuple2('caret', '⁁'),
			_Utils_Tuple2('caron', 'ˇ'),
			_Utils_Tuple2('Cayleys', 'ℭ'),
			_Utils_Tuple2('ccaps', '⩍'),
			_Utils_Tuple2('Ccaron', 'Č'),
			_Utils_Tuple2('ccaron', 'č'),
			_Utils_Tuple2('Ccedil', 'Ç'),
			_Utils_Tuple2('ccedil', 'ç'),
			_Utils_Tuple2('Ccirc', 'Ĉ'),
			_Utils_Tuple2('ccirc', 'ĉ'),
			_Utils_Tuple2('Cconint', '∰'),
			_Utils_Tuple2('ccups', '⩌'),
			_Utils_Tuple2('ccupssm', '⩐'),
			_Utils_Tuple2('Cdot', 'Ċ'),
			_Utils_Tuple2('cdot', 'ċ'),
			_Utils_Tuple2('cedil', '¸'),
			_Utils_Tuple2('Cedilla', '¸'),
			_Utils_Tuple2('cemptyv', '⦲'),
			_Utils_Tuple2('cent', '¢'),
			_Utils_Tuple2('centerdot', '·'),
			_Utils_Tuple2('CenterDot', '·'),
			_Utils_Tuple2('cfr', '\uD835\uDD20'),
			_Utils_Tuple2('Cfr', 'ℭ'),
			_Utils_Tuple2('CHcy', 'Ч'),
			_Utils_Tuple2('chcy', 'ч'),
			_Utils_Tuple2('check', '✓'),
			_Utils_Tuple2('checkmark', '✓'),
			_Utils_Tuple2('Chi', 'Χ'),
			_Utils_Tuple2('chi', 'χ'),
			_Utils_Tuple2('circ', 'ˆ'),
			_Utils_Tuple2('circeq', '≗'),
			_Utils_Tuple2('circlearrowleft', '↺'),
			_Utils_Tuple2('circlearrowright', '↻'),
			_Utils_Tuple2('circledast', '⊛'),
			_Utils_Tuple2('circledcirc', '⊚'),
			_Utils_Tuple2('circleddash', '⊝'),
			_Utils_Tuple2('CircleDot', '⊙'),
			_Utils_Tuple2('circledR', '®'),
			_Utils_Tuple2('circledS', 'Ⓢ'),
			_Utils_Tuple2('CircleMinus', '⊖'),
			_Utils_Tuple2('CirclePlus', '⊕'),
			_Utils_Tuple2('CircleTimes', '⊗'),
			_Utils_Tuple2('cir', '○'),
			_Utils_Tuple2('cirE', '⧃'),
			_Utils_Tuple2('cire', '≗'),
			_Utils_Tuple2('cirfnint', '⨐'),
			_Utils_Tuple2('cirmid', '⫯'),
			_Utils_Tuple2('cirscir', '⧂'),
			_Utils_Tuple2('ClockwiseContourIntegral', '∲'),
			_Utils_Tuple2('CloseCurlyDoubleQuote', '”'),
			_Utils_Tuple2('CloseCurlyQuote', '’'),
			_Utils_Tuple2('clubs', '♣'),
			_Utils_Tuple2('clubsuit', '♣'),
			_Utils_Tuple2('colon', ':'),
			_Utils_Tuple2('Colon', '∷'),
			_Utils_Tuple2('Colone', '⩴'),
			_Utils_Tuple2('colone', '≔'),
			_Utils_Tuple2('coloneq', '≔'),
			_Utils_Tuple2('comma', ','),
			_Utils_Tuple2('commat', '@'),
			_Utils_Tuple2('comp', '∁'),
			_Utils_Tuple2('compfn', '∘'),
			_Utils_Tuple2('complement', '∁'),
			_Utils_Tuple2('complexes', 'ℂ'),
			_Utils_Tuple2('cong', '≅'),
			_Utils_Tuple2('congdot', '⩭'),
			_Utils_Tuple2('Congruent', '≡'),
			_Utils_Tuple2('conint', '∮'),
			_Utils_Tuple2('Conint', '∯'),
			_Utils_Tuple2('ContourIntegral', '∮'),
			_Utils_Tuple2('copf', '\uD835\uDD54'),
			_Utils_Tuple2('Copf', 'ℂ'),
			_Utils_Tuple2('coprod', '∐'),
			_Utils_Tuple2('Coproduct', '∐'),
			_Utils_Tuple2('copy', '©'),
			_Utils_Tuple2('COPY', '©'),
			_Utils_Tuple2('copysr', '℗'),
			_Utils_Tuple2('CounterClockwiseContourIntegral', '∳'),
			_Utils_Tuple2('crarr', '↵'),
			_Utils_Tuple2('cross', '✗'),
			_Utils_Tuple2('Cross', '⨯'),
			_Utils_Tuple2('Cscr', '\uD835\uDC9E'),
			_Utils_Tuple2('cscr', '\uD835\uDCB8'),
			_Utils_Tuple2('csub', '⫏'),
			_Utils_Tuple2('csube', '⫑'),
			_Utils_Tuple2('csup', '⫐'),
			_Utils_Tuple2('csupe', '⫒'),
			_Utils_Tuple2('ctdot', '⋯'),
			_Utils_Tuple2('cudarrl', '⤸'),
			_Utils_Tuple2('cudarrr', '⤵'),
			_Utils_Tuple2('cuepr', '⋞'),
			_Utils_Tuple2('cuesc', '⋟'),
			_Utils_Tuple2('cularr', '↶'),
			_Utils_Tuple2('cularrp', '⤽'),
			_Utils_Tuple2('cupbrcap', '⩈'),
			_Utils_Tuple2('cupcap', '⩆'),
			_Utils_Tuple2('CupCap', '≍'),
			_Utils_Tuple2('cup', '∪'),
			_Utils_Tuple2('Cup', '⋓'),
			_Utils_Tuple2('cupcup', '⩊'),
			_Utils_Tuple2('cupdot', '⊍'),
			_Utils_Tuple2('cupor', '⩅'),
			_Utils_Tuple2('cups', '∪︀'),
			_Utils_Tuple2('curarr', '↷'),
			_Utils_Tuple2('curarrm', '⤼'),
			_Utils_Tuple2('curlyeqprec', '⋞'),
			_Utils_Tuple2('curlyeqsucc', '⋟'),
			_Utils_Tuple2('curlyvee', '⋎'),
			_Utils_Tuple2('curlywedge', '⋏'),
			_Utils_Tuple2('curren', '¤'),
			_Utils_Tuple2('curvearrowleft', '↶'),
			_Utils_Tuple2('curvearrowright', '↷'),
			_Utils_Tuple2('cuvee', '⋎'),
			_Utils_Tuple2('cuwed', '⋏'),
			_Utils_Tuple2('cwconint', '∲'),
			_Utils_Tuple2('cwint', '∱'),
			_Utils_Tuple2('cylcty', '⌭'),
			_Utils_Tuple2('dagger', '†'),
			_Utils_Tuple2('Dagger', '‡'),
			_Utils_Tuple2('daleth', 'ℸ'),
			_Utils_Tuple2('darr', '↓'),
			_Utils_Tuple2('Darr', '↡'),
			_Utils_Tuple2('dArr', '⇓'),
			_Utils_Tuple2('dash', '‐'),
			_Utils_Tuple2('Dashv', '⫤'),
			_Utils_Tuple2('dashv', '⊣'),
			_Utils_Tuple2('dbkarow', '⤏'),
			_Utils_Tuple2('dblac', '˝'),
			_Utils_Tuple2('Dcaron', 'Ď'),
			_Utils_Tuple2('dcaron', 'ď'),
			_Utils_Tuple2('Dcy', 'Д'),
			_Utils_Tuple2('dcy', 'д'),
			_Utils_Tuple2('ddagger', '‡'),
			_Utils_Tuple2('ddarr', '⇊'),
			_Utils_Tuple2('DD', 'ⅅ'),
			_Utils_Tuple2('dd', 'ⅆ'),
			_Utils_Tuple2('DDotrahd', '⤑'),
			_Utils_Tuple2('ddotseq', '⩷'),
			_Utils_Tuple2('deg', '°'),
			_Utils_Tuple2('Del', '∇'),
			_Utils_Tuple2('Delta', 'Δ'),
			_Utils_Tuple2('delta', 'δ'),
			_Utils_Tuple2('demptyv', '⦱'),
			_Utils_Tuple2('dfisht', '⥿'),
			_Utils_Tuple2('Dfr', '\uD835\uDD07'),
			_Utils_Tuple2('dfr', '\uD835\uDD21'),
			_Utils_Tuple2('dHar', '⥥'),
			_Utils_Tuple2('dharl', '⇃'),
			_Utils_Tuple2('dharr', '⇂'),
			_Utils_Tuple2('DiacriticalAcute', '´'),
			_Utils_Tuple2('DiacriticalDot', '˙'),
			_Utils_Tuple2('DiacriticalDoubleAcute', '˝'),
			_Utils_Tuple2('DiacriticalGrave', '`'),
			_Utils_Tuple2('DiacriticalTilde', '˜'),
			_Utils_Tuple2('diam', '⋄'),
			_Utils_Tuple2('diamond', '⋄'),
			_Utils_Tuple2('Diamond', '⋄'),
			_Utils_Tuple2('diamondsuit', '♦'),
			_Utils_Tuple2('diams', '♦'),
			_Utils_Tuple2('die', '¨'),
			_Utils_Tuple2('DifferentialD', 'ⅆ'),
			_Utils_Tuple2('digamma', 'ϝ'),
			_Utils_Tuple2('disin', '⋲'),
			_Utils_Tuple2('div', '÷'),
			_Utils_Tuple2('divide', '÷'),
			_Utils_Tuple2('divideontimes', '⋇'),
			_Utils_Tuple2('divonx', '⋇'),
			_Utils_Tuple2('DJcy', 'Ђ'),
			_Utils_Tuple2('djcy', 'ђ'),
			_Utils_Tuple2('dlcorn', '⌞'),
			_Utils_Tuple2('dlcrop', '⌍'),
			_Utils_Tuple2('dollar', '$'),
			_Utils_Tuple2('Dopf', '\uD835\uDD3B'),
			_Utils_Tuple2('dopf', '\uD835\uDD55'),
			_Utils_Tuple2('Dot', '¨'),
			_Utils_Tuple2('dot', '˙'),
			_Utils_Tuple2('DotDot', '⃜'),
			_Utils_Tuple2('doteq', '≐'),
			_Utils_Tuple2('doteqdot', '≑'),
			_Utils_Tuple2('DotEqual', '≐'),
			_Utils_Tuple2('dotminus', '∸'),
			_Utils_Tuple2('dotplus', '∔'),
			_Utils_Tuple2('dotsquare', '⊡'),
			_Utils_Tuple2('doublebarwedge', '⌆'),
			_Utils_Tuple2('DoubleContourIntegral', '∯'),
			_Utils_Tuple2('DoubleDot', '¨'),
			_Utils_Tuple2('DoubleDownArrow', '⇓'),
			_Utils_Tuple2('DoubleLeftArrow', '⇐'),
			_Utils_Tuple2('DoubleLeftRightArrow', '⇔'),
			_Utils_Tuple2('DoubleLeftTee', '⫤'),
			_Utils_Tuple2('DoubleLongLeftArrow', '⟸'),
			_Utils_Tuple2('DoubleLongLeftRightArrow', '⟺'),
			_Utils_Tuple2('DoubleLongRightArrow', '⟹'),
			_Utils_Tuple2('DoubleRightArrow', '⇒'),
			_Utils_Tuple2('DoubleRightTee', '⊨'),
			_Utils_Tuple2('DoubleUpArrow', '⇑'),
			_Utils_Tuple2('DoubleUpDownArrow', '⇕'),
			_Utils_Tuple2('DoubleVerticalBar', '∥'),
			_Utils_Tuple2('DownArrowBar', '⤓'),
			_Utils_Tuple2('downarrow', '↓'),
			_Utils_Tuple2('DownArrow', '↓'),
			_Utils_Tuple2('Downarrow', '⇓'),
			_Utils_Tuple2('DownArrowUpArrow', '⇵'),
			_Utils_Tuple2('DownBreve', '̑'),
			_Utils_Tuple2('downdownarrows', '⇊'),
			_Utils_Tuple2('downharpoonleft', '⇃'),
			_Utils_Tuple2('downharpoonright', '⇂'),
			_Utils_Tuple2('DownLeftRightVector', '⥐'),
			_Utils_Tuple2('DownLeftTeeVector', '⥞'),
			_Utils_Tuple2('DownLeftVectorBar', '⥖'),
			_Utils_Tuple2('DownLeftVector', '↽'),
			_Utils_Tuple2('DownRightTeeVector', '⥟'),
			_Utils_Tuple2('DownRightVectorBar', '⥗'),
			_Utils_Tuple2('DownRightVector', '⇁'),
			_Utils_Tuple2('DownTeeArrow', '↧'),
			_Utils_Tuple2('DownTee', '⊤'),
			_Utils_Tuple2('drbkarow', '⤐'),
			_Utils_Tuple2('drcorn', '⌟'),
			_Utils_Tuple2('drcrop', '⌌'),
			_Utils_Tuple2('Dscr', '\uD835\uDC9F'),
			_Utils_Tuple2('dscr', '\uD835\uDCB9'),
			_Utils_Tuple2('DScy', 'Ѕ'),
			_Utils_Tuple2('dscy', 'ѕ'),
			_Utils_Tuple2('dsol', '⧶'),
			_Utils_Tuple2('Dstrok', 'Đ'),
			_Utils_Tuple2('dstrok', 'đ'),
			_Utils_Tuple2('dtdot', '⋱'),
			_Utils_Tuple2('dtri', '▿'),
			_Utils_Tuple2('dtrif', '▾'),
			_Utils_Tuple2('duarr', '⇵'),
			_Utils_Tuple2('duhar', '⥯'),
			_Utils_Tuple2('dwangle', '⦦'),
			_Utils_Tuple2('DZcy', 'Џ'),
			_Utils_Tuple2('dzcy', 'џ'),
			_Utils_Tuple2('dzigrarr', '⟿'),
			_Utils_Tuple2('Eacute', 'É'),
			_Utils_Tuple2('eacute', 'é'),
			_Utils_Tuple2('easter', '⩮'),
			_Utils_Tuple2('Ecaron', 'Ě'),
			_Utils_Tuple2('ecaron', 'ě'),
			_Utils_Tuple2('Ecirc', 'Ê'),
			_Utils_Tuple2('ecirc', 'ê'),
			_Utils_Tuple2('ecir', '≖'),
			_Utils_Tuple2('ecolon', '≕'),
			_Utils_Tuple2('Ecy', 'Э'),
			_Utils_Tuple2('ecy', 'э'),
			_Utils_Tuple2('eDDot', '⩷'),
			_Utils_Tuple2('Edot', 'Ė'),
			_Utils_Tuple2('edot', 'ė'),
			_Utils_Tuple2('eDot', '≑'),
			_Utils_Tuple2('ee', 'ⅇ'),
			_Utils_Tuple2('efDot', '≒'),
			_Utils_Tuple2('Efr', '\uD835\uDD08'),
			_Utils_Tuple2('efr', '\uD835\uDD22'),
			_Utils_Tuple2('eg', '⪚'),
			_Utils_Tuple2('Egrave', 'È'),
			_Utils_Tuple2('egrave', 'è'),
			_Utils_Tuple2('egs', '⪖'),
			_Utils_Tuple2('egsdot', '⪘'),
			_Utils_Tuple2('el', '⪙'),
			_Utils_Tuple2('Element', '∈'),
			_Utils_Tuple2('elinters', '⏧'),
			_Utils_Tuple2('ell', 'ℓ'),
			_Utils_Tuple2('els', '⪕'),
			_Utils_Tuple2('elsdot', '⪗'),
			_Utils_Tuple2('Emacr', 'Ē'),
			_Utils_Tuple2('emacr', 'ē'),
			_Utils_Tuple2('empty', '∅'),
			_Utils_Tuple2('emptyset', '∅'),
			_Utils_Tuple2('EmptySmallSquare', '◻'),
			_Utils_Tuple2('emptyv', '∅'),
			_Utils_Tuple2('EmptyVerySmallSquare', '▫'),
			_Utils_Tuple2('emsp13', '\u2004'),
			_Utils_Tuple2('emsp14', '\u2005'),
			_Utils_Tuple2('emsp', '\u2003'),
			_Utils_Tuple2('ENG', 'Ŋ'),
			_Utils_Tuple2('eng', 'ŋ'),
			_Utils_Tuple2('ensp', '\u2002'),
			_Utils_Tuple2('Eogon', 'Ę'),
			_Utils_Tuple2('eogon', 'ę'),
			_Utils_Tuple2('Eopf', '\uD835\uDD3C'),
			_Utils_Tuple2('eopf', '\uD835\uDD56'),
			_Utils_Tuple2('epar', '⋕'),
			_Utils_Tuple2('eparsl', '⧣'),
			_Utils_Tuple2('eplus', '⩱'),
			_Utils_Tuple2('epsi', 'ε'),
			_Utils_Tuple2('Epsilon', 'Ε'),
			_Utils_Tuple2('epsilon', 'ε'),
			_Utils_Tuple2('epsiv', 'ϵ'),
			_Utils_Tuple2('eqcirc', '≖'),
			_Utils_Tuple2('eqcolon', '≕'),
			_Utils_Tuple2('eqsim', '≂'),
			_Utils_Tuple2('eqslantgtr', '⪖'),
			_Utils_Tuple2('eqslantless', '⪕'),
			_Utils_Tuple2('Equal', '⩵'),
			_Utils_Tuple2('equals', '='),
			_Utils_Tuple2('EqualTilde', '≂'),
			_Utils_Tuple2('equest', '≟'),
			_Utils_Tuple2('Equilibrium', '⇌'),
			_Utils_Tuple2('equiv', '≡'),
			_Utils_Tuple2('equivDD', '⩸'),
			_Utils_Tuple2('eqvparsl', '⧥'),
			_Utils_Tuple2('erarr', '⥱'),
			_Utils_Tuple2('erDot', '≓'),
			_Utils_Tuple2('escr', 'ℯ'),
			_Utils_Tuple2('Escr', 'ℰ'),
			_Utils_Tuple2('esdot', '≐'),
			_Utils_Tuple2('Esim', '⩳'),
			_Utils_Tuple2('esim', '≂'),
			_Utils_Tuple2('Eta', 'Η'),
			_Utils_Tuple2('eta', 'η'),
			_Utils_Tuple2('ETH', 'Ð'),
			_Utils_Tuple2('eth', 'ð'),
			_Utils_Tuple2('Euml', 'Ë'),
			_Utils_Tuple2('euml', 'ë'),
			_Utils_Tuple2('euro', '€'),
			_Utils_Tuple2('excl', '!'),
			_Utils_Tuple2('exist', '∃'),
			_Utils_Tuple2('Exists', '∃'),
			_Utils_Tuple2('expectation', 'ℰ'),
			_Utils_Tuple2('exponentiale', 'ⅇ'),
			_Utils_Tuple2('ExponentialE', 'ⅇ'),
			_Utils_Tuple2('fallingdotseq', '≒'),
			_Utils_Tuple2('Fcy', 'Ф'),
			_Utils_Tuple2('fcy', 'ф'),
			_Utils_Tuple2('female', '♀'),
			_Utils_Tuple2('ffilig', 'ﬃ'),
			_Utils_Tuple2('fflig', 'ﬀ'),
			_Utils_Tuple2('ffllig', 'ﬄ'),
			_Utils_Tuple2('Ffr', '\uD835\uDD09'),
			_Utils_Tuple2('ffr', '\uD835\uDD23'),
			_Utils_Tuple2('filig', 'ﬁ'),
			_Utils_Tuple2('FilledSmallSquare', '◼'),
			_Utils_Tuple2('FilledVerySmallSquare', '▪'),
			_Utils_Tuple2('fjlig', 'fj'),
			_Utils_Tuple2('flat', '♭'),
			_Utils_Tuple2('fllig', 'ﬂ'),
			_Utils_Tuple2('fltns', '▱'),
			_Utils_Tuple2('fnof', 'ƒ'),
			_Utils_Tuple2('Fopf', '\uD835\uDD3D'),
			_Utils_Tuple2('fopf', '\uD835\uDD57'),
			_Utils_Tuple2('forall', '∀'),
			_Utils_Tuple2('ForAll', '∀'),
			_Utils_Tuple2('fork', '⋔'),
			_Utils_Tuple2('forkv', '⫙'),
			_Utils_Tuple2('Fouriertrf', 'ℱ'),
			_Utils_Tuple2('fpartint', '⨍'),
			_Utils_Tuple2('frac12', '½'),
			_Utils_Tuple2('frac13', '⅓'),
			_Utils_Tuple2('frac14', '¼'),
			_Utils_Tuple2('frac15', '⅕'),
			_Utils_Tuple2('frac16', '⅙'),
			_Utils_Tuple2('frac18', '⅛'),
			_Utils_Tuple2('frac23', '⅔'),
			_Utils_Tuple2('frac25', '⅖'),
			_Utils_Tuple2('frac34', '¾'),
			_Utils_Tuple2('frac35', '⅗'),
			_Utils_Tuple2('frac38', '⅜'),
			_Utils_Tuple2('frac45', '⅘'),
			_Utils_Tuple2('frac56', '⅚'),
			_Utils_Tuple2('frac58', '⅝'),
			_Utils_Tuple2('frac78', '⅞'),
			_Utils_Tuple2('frasl', '⁄'),
			_Utils_Tuple2('frown', '⌢'),
			_Utils_Tuple2('fscr', '\uD835\uDCBB'),
			_Utils_Tuple2('Fscr', 'ℱ'),
			_Utils_Tuple2('gacute', 'ǵ'),
			_Utils_Tuple2('Gamma', 'Γ'),
			_Utils_Tuple2('gamma', 'γ'),
			_Utils_Tuple2('Gammad', 'Ϝ'),
			_Utils_Tuple2('gammad', 'ϝ'),
			_Utils_Tuple2('gap', '⪆'),
			_Utils_Tuple2('Gbreve', 'Ğ'),
			_Utils_Tuple2('gbreve', 'ğ'),
			_Utils_Tuple2('Gcedil', 'Ģ'),
			_Utils_Tuple2('Gcirc', 'Ĝ'),
			_Utils_Tuple2('gcirc', 'ĝ'),
			_Utils_Tuple2('Gcy', 'Г'),
			_Utils_Tuple2('gcy', 'г'),
			_Utils_Tuple2('Gdot', 'Ġ'),
			_Utils_Tuple2('gdot', 'ġ'),
			_Utils_Tuple2('ge', '≥'),
			_Utils_Tuple2('gE', '≧'),
			_Utils_Tuple2('gEl', '⪌'),
			_Utils_Tuple2('gel', '⋛'),
			_Utils_Tuple2('geq', '≥'),
			_Utils_Tuple2('geqq', '≧'),
			_Utils_Tuple2('geqslant', '⩾'),
			_Utils_Tuple2('gescc', '⪩'),
			_Utils_Tuple2('ges', '⩾'),
			_Utils_Tuple2('gesdot', '⪀'),
			_Utils_Tuple2('gesdoto', '⪂'),
			_Utils_Tuple2('gesdotol', '⪄'),
			_Utils_Tuple2('gesl', '⋛︀'),
			_Utils_Tuple2('gesles', '⪔'),
			_Utils_Tuple2('Gfr', '\uD835\uDD0A'),
			_Utils_Tuple2('gfr', '\uD835\uDD24'),
			_Utils_Tuple2('gg', '≫'),
			_Utils_Tuple2('Gg', '⋙'),
			_Utils_Tuple2('ggg', '⋙'),
			_Utils_Tuple2('gimel', 'ℷ'),
			_Utils_Tuple2('GJcy', 'Ѓ'),
			_Utils_Tuple2('gjcy', 'ѓ'),
			_Utils_Tuple2('gla', '⪥'),
			_Utils_Tuple2('gl', '≷'),
			_Utils_Tuple2('glE', '⪒'),
			_Utils_Tuple2('glj', '⪤'),
			_Utils_Tuple2('gnap', '⪊'),
			_Utils_Tuple2('gnapprox', '⪊'),
			_Utils_Tuple2('gne', '⪈'),
			_Utils_Tuple2('gnE', '≩'),
			_Utils_Tuple2('gneq', '⪈'),
			_Utils_Tuple2('gneqq', '≩'),
			_Utils_Tuple2('gnsim', '⋧'),
			_Utils_Tuple2('Gopf', '\uD835\uDD3E'),
			_Utils_Tuple2('gopf', '\uD835\uDD58'),
			_Utils_Tuple2('grave', '`'),
			_Utils_Tuple2('GreaterEqual', '≥'),
			_Utils_Tuple2('GreaterEqualLess', '⋛'),
			_Utils_Tuple2('GreaterFullEqual', '≧'),
			_Utils_Tuple2('GreaterGreater', '⪢'),
			_Utils_Tuple2('GreaterLess', '≷'),
			_Utils_Tuple2('GreaterSlantEqual', '⩾'),
			_Utils_Tuple2('GreaterTilde', '≳'),
			_Utils_Tuple2('Gscr', '\uD835\uDCA2'),
			_Utils_Tuple2('gscr', 'ℊ'),
			_Utils_Tuple2('gsim', '≳'),
			_Utils_Tuple2('gsime', '⪎'),
			_Utils_Tuple2('gsiml', '⪐'),
			_Utils_Tuple2('gtcc', '⪧'),
			_Utils_Tuple2('gtcir', '⩺'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('GT', '>'),
			_Utils_Tuple2('Gt', '≫'),
			_Utils_Tuple2('gtdot', '⋗'),
			_Utils_Tuple2('gtlPar', '⦕'),
			_Utils_Tuple2('gtquest', '⩼'),
			_Utils_Tuple2('gtrapprox', '⪆'),
			_Utils_Tuple2('gtrarr', '⥸'),
			_Utils_Tuple2('gtrdot', '⋗'),
			_Utils_Tuple2('gtreqless', '⋛'),
			_Utils_Tuple2('gtreqqless', '⪌'),
			_Utils_Tuple2('gtrless', '≷'),
			_Utils_Tuple2('gtrsim', '≳'),
			_Utils_Tuple2('gvertneqq', '≩︀'),
			_Utils_Tuple2('gvnE', '≩︀'),
			_Utils_Tuple2('Hacek', 'ˇ'),
			_Utils_Tuple2('hairsp', '\u200A'),
			_Utils_Tuple2('half', '½'),
			_Utils_Tuple2('hamilt', 'ℋ'),
			_Utils_Tuple2('HARDcy', 'Ъ'),
			_Utils_Tuple2('hardcy', 'ъ'),
			_Utils_Tuple2('harrcir', '⥈'),
			_Utils_Tuple2('harr', '↔'),
			_Utils_Tuple2('hArr', '⇔'),
			_Utils_Tuple2('harrw', '↭'),
			_Utils_Tuple2('Hat', '^'),
			_Utils_Tuple2('hbar', 'ℏ'),
			_Utils_Tuple2('Hcirc', 'Ĥ'),
			_Utils_Tuple2('hcirc', 'ĥ'),
			_Utils_Tuple2('hearts', '♥'),
			_Utils_Tuple2('heartsuit', '♥'),
			_Utils_Tuple2('hellip', '…'),
			_Utils_Tuple2('hercon', '⊹'),
			_Utils_Tuple2('hfr', '\uD835\uDD25'),
			_Utils_Tuple2('Hfr', 'ℌ'),
			_Utils_Tuple2('HilbertSpace', 'ℋ'),
			_Utils_Tuple2('hksearow', '⤥'),
			_Utils_Tuple2('hkswarow', '⤦'),
			_Utils_Tuple2('hoarr', '⇿'),
			_Utils_Tuple2('homtht', '∻'),
			_Utils_Tuple2('hookleftarrow', '↩'),
			_Utils_Tuple2('hookrightarrow', '↪'),
			_Utils_Tuple2('hopf', '\uD835\uDD59'),
			_Utils_Tuple2('Hopf', 'ℍ'),
			_Utils_Tuple2('horbar', '―'),
			_Utils_Tuple2('HorizontalLine', '─'),
			_Utils_Tuple2('hscr', '\uD835\uDCBD'),
			_Utils_Tuple2('Hscr', 'ℋ'),
			_Utils_Tuple2('hslash', 'ℏ'),
			_Utils_Tuple2('Hstrok', 'Ħ'),
			_Utils_Tuple2('hstrok', 'ħ'),
			_Utils_Tuple2('HumpDownHump', '≎'),
			_Utils_Tuple2('HumpEqual', '≏'),
			_Utils_Tuple2('hybull', '⁃'),
			_Utils_Tuple2('hyphen', '‐'),
			_Utils_Tuple2('Iacute', 'Í'),
			_Utils_Tuple2('iacute', 'í'),
			_Utils_Tuple2('ic', '\u2063'),
			_Utils_Tuple2('Icirc', 'Î'),
			_Utils_Tuple2('icirc', 'î'),
			_Utils_Tuple2('Icy', 'И'),
			_Utils_Tuple2('icy', 'и'),
			_Utils_Tuple2('Idot', 'İ'),
			_Utils_Tuple2('IEcy', 'Е'),
			_Utils_Tuple2('iecy', 'е'),
			_Utils_Tuple2('iexcl', '¡'),
			_Utils_Tuple2('iff', '⇔'),
			_Utils_Tuple2('ifr', '\uD835\uDD26'),
			_Utils_Tuple2('Ifr', 'ℑ'),
			_Utils_Tuple2('Igrave', 'Ì'),
			_Utils_Tuple2('igrave', 'ì'),
			_Utils_Tuple2('ii', 'ⅈ'),
			_Utils_Tuple2('iiiint', '⨌'),
			_Utils_Tuple2('iiint', '∭'),
			_Utils_Tuple2('iinfin', '⧜'),
			_Utils_Tuple2('iiota', '℩'),
			_Utils_Tuple2('IJlig', 'Ĳ'),
			_Utils_Tuple2('ijlig', 'ĳ'),
			_Utils_Tuple2('Imacr', 'Ī'),
			_Utils_Tuple2('imacr', 'ī'),
			_Utils_Tuple2('image', 'ℑ'),
			_Utils_Tuple2('ImaginaryI', 'ⅈ'),
			_Utils_Tuple2('imagline', 'ℐ'),
			_Utils_Tuple2('imagpart', 'ℑ'),
			_Utils_Tuple2('imath', 'ı'),
			_Utils_Tuple2('Im', 'ℑ'),
			_Utils_Tuple2('imof', '⊷'),
			_Utils_Tuple2('imped', 'Ƶ'),
			_Utils_Tuple2('Implies', '⇒'),
			_Utils_Tuple2('incare', '℅'),
			_Utils_Tuple2('in', '∈'),
			_Utils_Tuple2('infin', '∞'),
			_Utils_Tuple2('infintie', '⧝'),
			_Utils_Tuple2('inodot', 'ı'),
			_Utils_Tuple2('intcal', '⊺'),
			_Utils_Tuple2('int', '∫'),
			_Utils_Tuple2('Int', '∬'),
			_Utils_Tuple2('integers', 'ℤ'),
			_Utils_Tuple2('Integral', '∫'),
			_Utils_Tuple2('intercal', '⊺'),
			_Utils_Tuple2('Intersection', '⋂'),
			_Utils_Tuple2('intlarhk', '⨗'),
			_Utils_Tuple2('intprod', '⨼'),
			_Utils_Tuple2('InvisibleComma', '\u2063'),
			_Utils_Tuple2('InvisibleTimes', '\u2062'),
			_Utils_Tuple2('IOcy', 'Ё'),
			_Utils_Tuple2('iocy', 'ё'),
			_Utils_Tuple2('Iogon', 'Į'),
			_Utils_Tuple2('iogon', 'į'),
			_Utils_Tuple2('Iopf', '\uD835\uDD40'),
			_Utils_Tuple2('iopf', '\uD835\uDD5A'),
			_Utils_Tuple2('Iota', 'Ι'),
			_Utils_Tuple2('iota', 'ι'),
			_Utils_Tuple2('iprod', '⨼'),
			_Utils_Tuple2('iquest', '¿'),
			_Utils_Tuple2('iscr', '\uD835\uDCBE'),
			_Utils_Tuple2('Iscr', 'ℐ'),
			_Utils_Tuple2('isin', '∈'),
			_Utils_Tuple2('isindot', '⋵'),
			_Utils_Tuple2('isinE', '⋹'),
			_Utils_Tuple2('isins', '⋴'),
			_Utils_Tuple2('isinsv', '⋳'),
			_Utils_Tuple2('isinv', '∈'),
			_Utils_Tuple2('it', '\u2062'),
			_Utils_Tuple2('Itilde', 'Ĩ'),
			_Utils_Tuple2('itilde', 'ĩ'),
			_Utils_Tuple2('Iukcy', 'І'),
			_Utils_Tuple2('iukcy', 'і'),
			_Utils_Tuple2('Iuml', 'Ï'),
			_Utils_Tuple2('iuml', 'ï'),
			_Utils_Tuple2('Jcirc', 'Ĵ'),
			_Utils_Tuple2('jcirc', 'ĵ'),
			_Utils_Tuple2('Jcy', 'Й'),
			_Utils_Tuple2('jcy', 'й'),
			_Utils_Tuple2('Jfr', '\uD835\uDD0D'),
			_Utils_Tuple2('jfr', '\uD835\uDD27'),
			_Utils_Tuple2('jmath', 'ȷ'),
			_Utils_Tuple2('Jopf', '\uD835\uDD41'),
			_Utils_Tuple2('jopf', '\uD835\uDD5B'),
			_Utils_Tuple2('Jscr', '\uD835\uDCA5'),
			_Utils_Tuple2('jscr', '\uD835\uDCBF'),
			_Utils_Tuple2('Jsercy', 'Ј'),
			_Utils_Tuple2('jsercy', 'ј'),
			_Utils_Tuple2('Jukcy', 'Є'),
			_Utils_Tuple2('jukcy', 'є'),
			_Utils_Tuple2('Kappa', 'Κ'),
			_Utils_Tuple2('kappa', 'κ'),
			_Utils_Tuple2('kappav', 'ϰ'),
			_Utils_Tuple2('Kcedil', 'Ķ'),
			_Utils_Tuple2('kcedil', 'ķ'),
			_Utils_Tuple2('Kcy', 'К'),
			_Utils_Tuple2('kcy', 'к'),
			_Utils_Tuple2('Kfr', '\uD835\uDD0E'),
			_Utils_Tuple2('kfr', '\uD835\uDD28'),
			_Utils_Tuple2('kgreen', 'ĸ'),
			_Utils_Tuple2('KHcy', 'Х'),
			_Utils_Tuple2('khcy', 'х'),
			_Utils_Tuple2('KJcy', 'Ќ'),
			_Utils_Tuple2('kjcy', 'ќ'),
			_Utils_Tuple2('Kopf', '\uD835\uDD42'),
			_Utils_Tuple2('kopf', '\uD835\uDD5C'),
			_Utils_Tuple2('Kscr', '\uD835\uDCA6'),
			_Utils_Tuple2('kscr', '\uD835\uDCC0'),
			_Utils_Tuple2('lAarr', '⇚'),
			_Utils_Tuple2('Lacute', 'Ĺ'),
			_Utils_Tuple2('lacute', 'ĺ'),
			_Utils_Tuple2('laemptyv', '⦴'),
			_Utils_Tuple2('lagran', 'ℒ'),
			_Utils_Tuple2('Lambda', 'Λ'),
			_Utils_Tuple2('lambda', 'λ'),
			_Utils_Tuple2('lang', '⟨'),
			_Utils_Tuple2('Lang', '⟪'),
			_Utils_Tuple2('langd', '⦑'),
			_Utils_Tuple2('langle', '⟨'),
			_Utils_Tuple2('lap', '⪅'),
			_Utils_Tuple2('Laplacetrf', 'ℒ'),
			_Utils_Tuple2('laquo', '«'),
			_Utils_Tuple2('larrb', '⇤'),
			_Utils_Tuple2('larrbfs', '⤟'),
			_Utils_Tuple2('larr', '←'),
			_Utils_Tuple2('Larr', '↞'),
			_Utils_Tuple2('lArr', '⇐'),
			_Utils_Tuple2('larrfs', '⤝'),
			_Utils_Tuple2('larrhk', '↩'),
			_Utils_Tuple2('larrlp', '↫'),
			_Utils_Tuple2('larrpl', '⤹'),
			_Utils_Tuple2('larrsim', '⥳'),
			_Utils_Tuple2('larrtl', '↢'),
			_Utils_Tuple2('latail', '⤙'),
			_Utils_Tuple2('lAtail', '⤛'),
			_Utils_Tuple2('lat', '⪫'),
			_Utils_Tuple2('late', '⪭'),
			_Utils_Tuple2('lates', '⪭︀'),
			_Utils_Tuple2('lbarr', '⤌'),
			_Utils_Tuple2('lBarr', '⤎'),
			_Utils_Tuple2('lbbrk', '❲'),
			_Utils_Tuple2('lbrace', '{'),
			_Utils_Tuple2('lbrack', '['),
			_Utils_Tuple2('lbrke', '⦋'),
			_Utils_Tuple2('lbrksld', '⦏'),
			_Utils_Tuple2('lbrkslu', '⦍'),
			_Utils_Tuple2('Lcaron', 'Ľ'),
			_Utils_Tuple2('lcaron', 'ľ'),
			_Utils_Tuple2('Lcedil', 'Ļ'),
			_Utils_Tuple2('lcedil', 'ļ'),
			_Utils_Tuple2('lceil', '⌈'),
			_Utils_Tuple2('lcub', '{'),
			_Utils_Tuple2('Lcy', 'Л'),
			_Utils_Tuple2('lcy', 'л'),
			_Utils_Tuple2('ldca', '⤶'),
			_Utils_Tuple2('ldquo', '“'),
			_Utils_Tuple2('ldquor', '„'),
			_Utils_Tuple2('ldrdhar', '⥧'),
			_Utils_Tuple2('ldrushar', '⥋'),
			_Utils_Tuple2('ldsh', '↲'),
			_Utils_Tuple2('le', '≤'),
			_Utils_Tuple2('lE', '≦'),
			_Utils_Tuple2('LeftAngleBracket', '⟨'),
			_Utils_Tuple2('LeftArrowBar', '⇤'),
			_Utils_Tuple2('leftarrow', '←'),
			_Utils_Tuple2('LeftArrow', '←'),
			_Utils_Tuple2('Leftarrow', '⇐'),
			_Utils_Tuple2('LeftArrowRightArrow', '⇆'),
			_Utils_Tuple2('leftarrowtail', '↢'),
			_Utils_Tuple2('LeftCeiling', '⌈'),
			_Utils_Tuple2('LeftDoubleBracket', '⟦'),
			_Utils_Tuple2('LeftDownTeeVector', '⥡'),
			_Utils_Tuple2('LeftDownVectorBar', '⥙'),
			_Utils_Tuple2('LeftDownVector', '⇃'),
			_Utils_Tuple2('LeftFloor', '⌊'),
			_Utils_Tuple2('leftharpoondown', '↽'),
			_Utils_Tuple2('leftharpoonup', '↼'),
			_Utils_Tuple2('leftleftarrows', '⇇'),
			_Utils_Tuple2('leftrightarrow', '↔'),
			_Utils_Tuple2('LeftRightArrow', '↔'),
			_Utils_Tuple2('Leftrightarrow', '⇔'),
			_Utils_Tuple2('leftrightarrows', '⇆'),
			_Utils_Tuple2('leftrightharpoons', '⇋'),
			_Utils_Tuple2('leftrightsquigarrow', '↭'),
			_Utils_Tuple2('LeftRightVector', '⥎'),
			_Utils_Tuple2('LeftTeeArrow', '↤'),
			_Utils_Tuple2('LeftTee', '⊣'),
			_Utils_Tuple2('LeftTeeVector', '⥚'),
			_Utils_Tuple2('leftthreetimes', '⋋'),
			_Utils_Tuple2('LeftTriangleBar', '⧏'),
			_Utils_Tuple2('LeftTriangle', '⊲'),
			_Utils_Tuple2('LeftTriangleEqual', '⊴'),
			_Utils_Tuple2('LeftUpDownVector', '⥑'),
			_Utils_Tuple2('LeftUpTeeVector', '⥠'),
			_Utils_Tuple2('LeftUpVectorBar', '⥘'),
			_Utils_Tuple2('LeftUpVector', '↿'),
			_Utils_Tuple2('LeftVectorBar', '⥒'),
			_Utils_Tuple2('LeftVector', '↼'),
			_Utils_Tuple2('lEg', '⪋'),
			_Utils_Tuple2('leg', '⋚'),
			_Utils_Tuple2('leq', '≤'),
			_Utils_Tuple2('leqq', '≦'),
			_Utils_Tuple2('leqslant', '⩽'),
			_Utils_Tuple2('lescc', '⪨'),
			_Utils_Tuple2('les', '⩽'),
			_Utils_Tuple2('lesdot', '⩿'),
			_Utils_Tuple2('lesdoto', '⪁'),
			_Utils_Tuple2('lesdotor', '⪃'),
			_Utils_Tuple2('lesg', '⋚︀'),
			_Utils_Tuple2('lesges', '⪓'),
			_Utils_Tuple2('lessapprox', '⪅'),
			_Utils_Tuple2('lessdot', '⋖'),
			_Utils_Tuple2('lesseqgtr', '⋚'),
			_Utils_Tuple2('lesseqqgtr', '⪋'),
			_Utils_Tuple2('LessEqualGreater', '⋚'),
			_Utils_Tuple2('LessFullEqual', '≦'),
			_Utils_Tuple2('LessGreater', '≶'),
			_Utils_Tuple2('lessgtr', '≶'),
			_Utils_Tuple2('LessLess', '⪡'),
			_Utils_Tuple2('lesssim', '≲'),
			_Utils_Tuple2('LessSlantEqual', '⩽'),
			_Utils_Tuple2('LessTilde', '≲'),
			_Utils_Tuple2('lfisht', '⥼'),
			_Utils_Tuple2('lfloor', '⌊'),
			_Utils_Tuple2('Lfr', '\uD835\uDD0F'),
			_Utils_Tuple2('lfr', '\uD835\uDD29'),
			_Utils_Tuple2('lg', '≶'),
			_Utils_Tuple2('lgE', '⪑'),
			_Utils_Tuple2('lHar', '⥢'),
			_Utils_Tuple2('lhard', '↽'),
			_Utils_Tuple2('lharu', '↼'),
			_Utils_Tuple2('lharul', '⥪'),
			_Utils_Tuple2('lhblk', '▄'),
			_Utils_Tuple2('LJcy', 'Љ'),
			_Utils_Tuple2('ljcy', 'љ'),
			_Utils_Tuple2('llarr', '⇇'),
			_Utils_Tuple2('ll', '≪'),
			_Utils_Tuple2('Ll', '⋘'),
			_Utils_Tuple2('llcorner', '⌞'),
			_Utils_Tuple2('Lleftarrow', '⇚'),
			_Utils_Tuple2('llhard', '⥫'),
			_Utils_Tuple2('lltri', '◺'),
			_Utils_Tuple2('Lmidot', 'Ŀ'),
			_Utils_Tuple2('lmidot', 'ŀ'),
			_Utils_Tuple2('lmoustache', '⎰'),
			_Utils_Tuple2('lmoust', '⎰'),
			_Utils_Tuple2('lnap', '⪉'),
			_Utils_Tuple2('lnapprox', '⪉'),
			_Utils_Tuple2('lne', '⪇'),
			_Utils_Tuple2('lnE', '≨'),
			_Utils_Tuple2('lneq', '⪇'),
			_Utils_Tuple2('lneqq', '≨'),
			_Utils_Tuple2('lnsim', '⋦'),
			_Utils_Tuple2('loang', '⟬'),
			_Utils_Tuple2('loarr', '⇽'),
			_Utils_Tuple2('lobrk', '⟦'),
			_Utils_Tuple2('longleftarrow', '⟵'),
			_Utils_Tuple2('LongLeftArrow', '⟵'),
			_Utils_Tuple2('Longleftarrow', '⟸'),
			_Utils_Tuple2('longleftrightarrow', '⟷'),
			_Utils_Tuple2('LongLeftRightArrow', '⟷'),
			_Utils_Tuple2('Longleftrightarrow', '⟺'),
			_Utils_Tuple2('longmapsto', '⟼'),
			_Utils_Tuple2('longrightarrow', '⟶'),
			_Utils_Tuple2('LongRightArrow', '⟶'),
			_Utils_Tuple2('Longrightarrow', '⟹'),
			_Utils_Tuple2('looparrowleft', '↫'),
			_Utils_Tuple2('looparrowright', '↬'),
			_Utils_Tuple2('lopar', '⦅'),
			_Utils_Tuple2('Lopf', '\uD835\uDD43'),
			_Utils_Tuple2('lopf', '\uD835\uDD5D'),
			_Utils_Tuple2('loplus', '⨭'),
			_Utils_Tuple2('lotimes', '⨴'),
			_Utils_Tuple2('lowast', '∗'),
			_Utils_Tuple2('lowbar', '_'),
			_Utils_Tuple2('LowerLeftArrow', '↙'),
			_Utils_Tuple2('LowerRightArrow', '↘'),
			_Utils_Tuple2('loz', '◊'),
			_Utils_Tuple2('lozenge', '◊'),
			_Utils_Tuple2('lozf', '⧫'),
			_Utils_Tuple2('lpar', '('),
			_Utils_Tuple2('lparlt', '⦓'),
			_Utils_Tuple2('lrarr', '⇆'),
			_Utils_Tuple2('lrcorner', '⌟'),
			_Utils_Tuple2('lrhar', '⇋'),
			_Utils_Tuple2('lrhard', '⥭'),
			_Utils_Tuple2('lrm', '\u200E'),
			_Utils_Tuple2('lrtri', '⊿'),
			_Utils_Tuple2('lsaquo', '‹'),
			_Utils_Tuple2('lscr', '\uD835\uDCC1'),
			_Utils_Tuple2('Lscr', 'ℒ'),
			_Utils_Tuple2('lsh', '↰'),
			_Utils_Tuple2('Lsh', '↰'),
			_Utils_Tuple2('lsim', '≲'),
			_Utils_Tuple2('lsime', '⪍'),
			_Utils_Tuple2('lsimg', '⪏'),
			_Utils_Tuple2('lsqb', '['),
			_Utils_Tuple2('lsquo', '‘'),
			_Utils_Tuple2('lsquor', '‚'),
			_Utils_Tuple2('Lstrok', 'Ł'),
			_Utils_Tuple2('lstrok', 'ł'),
			_Utils_Tuple2('ltcc', '⪦'),
			_Utils_Tuple2('ltcir', '⩹'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('LT', '<'),
			_Utils_Tuple2('Lt', '≪'),
			_Utils_Tuple2('ltdot', '⋖'),
			_Utils_Tuple2('lthree', '⋋'),
			_Utils_Tuple2('ltimes', '⋉'),
			_Utils_Tuple2('ltlarr', '⥶'),
			_Utils_Tuple2('ltquest', '⩻'),
			_Utils_Tuple2('ltri', '◃'),
			_Utils_Tuple2('ltrie', '⊴'),
			_Utils_Tuple2('ltrif', '◂'),
			_Utils_Tuple2('ltrPar', '⦖'),
			_Utils_Tuple2('lurdshar', '⥊'),
			_Utils_Tuple2('luruhar', '⥦'),
			_Utils_Tuple2('lvertneqq', '≨︀'),
			_Utils_Tuple2('lvnE', '≨︀'),
			_Utils_Tuple2('macr', '¯'),
			_Utils_Tuple2('male', '♂'),
			_Utils_Tuple2('malt', '✠'),
			_Utils_Tuple2('maltese', '✠'),
			_Utils_Tuple2('Map', '⤅'),
			_Utils_Tuple2('map', '↦'),
			_Utils_Tuple2('mapsto', '↦'),
			_Utils_Tuple2('mapstodown', '↧'),
			_Utils_Tuple2('mapstoleft', '↤'),
			_Utils_Tuple2('mapstoup', '↥'),
			_Utils_Tuple2('marker', '▮'),
			_Utils_Tuple2('mcomma', '⨩'),
			_Utils_Tuple2('Mcy', 'М'),
			_Utils_Tuple2('mcy', 'м'),
			_Utils_Tuple2('mdash', '—'),
			_Utils_Tuple2('mDDot', '∺'),
			_Utils_Tuple2('measuredangle', '∡'),
			_Utils_Tuple2('MediumSpace', '\u205F'),
			_Utils_Tuple2('Mellintrf', 'ℳ'),
			_Utils_Tuple2('Mfr', '\uD835\uDD10'),
			_Utils_Tuple2('mfr', '\uD835\uDD2A'),
			_Utils_Tuple2('mho', '℧'),
			_Utils_Tuple2('micro', 'µ'),
			_Utils_Tuple2('midast', '*'),
			_Utils_Tuple2('midcir', '⫰'),
			_Utils_Tuple2('mid', '∣'),
			_Utils_Tuple2('middot', '·'),
			_Utils_Tuple2('minusb', '⊟'),
			_Utils_Tuple2('minus', '−'),
			_Utils_Tuple2('minusd', '∸'),
			_Utils_Tuple2('minusdu', '⨪'),
			_Utils_Tuple2('MinusPlus', '∓'),
			_Utils_Tuple2('mlcp', '⫛'),
			_Utils_Tuple2('mldr', '…'),
			_Utils_Tuple2('mnplus', '∓'),
			_Utils_Tuple2('models', '⊧'),
			_Utils_Tuple2('Mopf', '\uD835\uDD44'),
			_Utils_Tuple2('mopf', '\uD835\uDD5E'),
			_Utils_Tuple2('mp', '∓'),
			_Utils_Tuple2('mscr', '\uD835\uDCC2'),
			_Utils_Tuple2('Mscr', 'ℳ'),
			_Utils_Tuple2('mstpos', '∾'),
			_Utils_Tuple2('Mu', 'Μ'),
			_Utils_Tuple2('mu', 'μ'),
			_Utils_Tuple2('multimap', '⊸'),
			_Utils_Tuple2('mumap', '⊸'),
			_Utils_Tuple2('nabla', '∇'),
			_Utils_Tuple2('Nacute', 'Ń'),
			_Utils_Tuple2('nacute', 'ń'),
			_Utils_Tuple2('nang', '∠⃒'),
			_Utils_Tuple2('nap', '≉'),
			_Utils_Tuple2('napE', '⩰̸'),
			_Utils_Tuple2('napid', '≋̸'),
			_Utils_Tuple2('napos', 'ŉ'),
			_Utils_Tuple2('napprox', '≉'),
			_Utils_Tuple2('natural', '♮'),
			_Utils_Tuple2('naturals', 'ℕ'),
			_Utils_Tuple2('natur', '♮'),
			_Utils_Tuple2('nbsp', '\u00A0'),
			_Utils_Tuple2('nbump', '≎̸'),
			_Utils_Tuple2('nbumpe', '≏̸'),
			_Utils_Tuple2('ncap', '⩃'),
			_Utils_Tuple2('Ncaron', 'Ň'),
			_Utils_Tuple2('ncaron', 'ň'),
			_Utils_Tuple2('Ncedil', 'Ņ'),
			_Utils_Tuple2('ncedil', 'ņ'),
			_Utils_Tuple2('ncong', '≇'),
			_Utils_Tuple2('ncongdot', '⩭̸'),
			_Utils_Tuple2('ncup', '⩂'),
			_Utils_Tuple2('Ncy', 'Н'),
			_Utils_Tuple2('ncy', 'н'),
			_Utils_Tuple2('ndash', '–'),
			_Utils_Tuple2('nearhk', '⤤'),
			_Utils_Tuple2('nearr', '↗'),
			_Utils_Tuple2('neArr', '⇗'),
			_Utils_Tuple2('nearrow', '↗'),
			_Utils_Tuple2('ne', '≠'),
			_Utils_Tuple2('nedot', '≐̸'),
			_Utils_Tuple2('NegativeMediumSpace', '\u200B'),
			_Utils_Tuple2('NegativeThickSpace', '\u200B'),
			_Utils_Tuple2('NegativeThinSpace', '\u200B'),
			_Utils_Tuple2('NegativeVeryThinSpace', '\u200B'),
			_Utils_Tuple2('nequiv', '≢'),
			_Utils_Tuple2('nesear', '⤨'),
			_Utils_Tuple2('nesim', '≂̸'),
			_Utils_Tuple2('NestedGreaterGreater', '≫'),
			_Utils_Tuple2('NestedLessLess', '≪'),
			_Utils_Tuple2('NewLine', '\n'),
			_Utils_Tuple2('nexist', '∄'),
			_Utils_Tuple2('nexists', '∄'),
			_Utils_Tuple2('Nfr', '\uD835\uDD11'),
			_Utils_Tuple2('nfr', '\uD835\uDD2B'),
			_Utils_Tuple2('ngE', '≧̸'),
			_Utils_Tuple2('nge', '≱'),
			_Utils_Tuple2('ngeq', '≱'),
			_Utils_Tuple2('ngeqq', '≧̸'),
			_Utils_Tuple2('ngeqslant', '⩾̸'),
			_Utils_Tuple2('nges', '⩾̸'),
			_Utils_Tuple2('nGg', '⋙̸'),
			_Utils_Tuple2('ngsim', '≵'),
			_Utils_Tuple2('nGt', '≫⃒'),
			_Utils_Tuple2('ngt', '≯'),
			_Utils_Tuple2('ngtr', '≯'),
			_Utils_Tuple2('nGtv', '≫̸'),
			_Utils_Tuple2('nharr', '↮'),
			_Utils_Tuple2('nhArr', '⇎'),
			_Utils_Tuple2('nhpar', '⫲'),
			_Utils_Tuple2('ni', '∋'),
			_Utils_Tuple2('nis', '⋼'),
			_Utils_Tuple2('nisd', '⋺'),
			_Utils_Tuple2('niv', '∋'),
			_Utils_Tuple2('NJcy', 'Њ'),
			_Utils_Tuple2('njcy', 'њ'),
			_Utils_Tuple2('nlarr', '↚'),
			_Utils_Tuple2('nlArr', '⇍'),
			_Utils_Tuple2('nldr', '‥'),
			_Utils_Tuple2('nlE', '≦̸'),
			_Utils_Tuple2('nle', '≰'),
			_Utils_Tuple2('nleftarrow', '↚'),
			_Utils_Tuple2('nLeftarrow', '⇍'),
			_Utils_Tuple2('nleftrightarrow', '↮'),
			_Utils_Tuple2('nLeftrightarrow', '⇎'),
			_Utils_Tuple2('nleq', '≰'),
			_Utils_Tuple2('nleqq', '≦̸'),
			_Utils_Tuple2('nleqslant', '⩽̸'),
			_Utils_Tuple2('nles', '⩽̸'),
			_Utils_Tuple2('nless', '≮'),
			_Utils_Tuple2('nLl', '⋘̸'),
			_Utils_Tuple2('nlsim', '≴'),
			_Utils_Tuple2('nLt', '≪⃒'),
			_Utils_Tuple2('nlt', '≮'),
			_Utils_Tuple2('nltri', '⋪'),
			_Utils_Tuple2('nltrie', '⋬'),
			_Utils_Tuple2('nLtv', '≪̸'),
			_Utils_Tuple2('nmid', '∤'),
			_Utils_Tuple2('NoBreak', '\u2060'),
			_Utils_Tuple2('NonBreakingSpace', '\u00A0'),
			_Utils_Tuple2('nopf', '\uD835\uDD5F'),
			_Utils_Tuple2('Nopf', 'ℕ'),
			_Utils_Tuple2('Not', '⫬'),
			_Utils_Tuple2('not', '¬'),
			_Utils_Tuple2('NotCongruent', '≢'),
			_Utils_Tuple2('NotCupCap', '≭'),
			_Utils_Tuple2('NotDoubleVerticalBar', '∦'),
			_Utils_Tuple2('NotElement', '∉'),
			_Utils_Tuple2('NotEqual', '≠'),
			_Utils_Tuple2('NotEqualTilde', '≂̸'),
			_Utils_Tuple2('NotExists', '∄'),
			_Utils_Tuple2('NotGreater', '≯'),
			_Utils_Tuple2('NotGreaterEqual', '≱'),
			_Utils_Tuple2('NotGreaterFullEqual', '≧̸'),
			_Utils_Tuple2('NotGreaterGreater', '≫̸'),
			_Utils_Tuple2('NotGreaterLess', '≹'),
			_Utils_Tuple2('NotGreaterSlantEqual', '⩾̸'),
			_Utils_Tuple2('NotGreaterTilde', '≵'),
			_Utils_Tuple2('NotHumpDownHump', '≎̸'),
			_Utils_Tuple2('NotHumpEqual', '≏̸'),
			_Utils_Tuple2('notin', '∉'),
			_Utils_Tuple2('notindot', '⋵̸'),
			_Utils_Tuple2('notinE', '⋹̸'),
			_Utils_Tuple2('notinva', '∉'),
			_Utils_Tuple2('notinvb', '⋷'),
			_Utils_Tuple2('notinvc', '⋶'),
			_Utils_Tuple2('NotLeftTriangleBar', '⧏̸'),
			_Utils_Tuple2('NotLeftTriangle', '⋪'),
			_Utils_Tuple2('NotLeftTriangleEqual', '⋬'),
			_Utils_Tuple2('NotLess', '≮'),
			_Utils_Tuple2('NotLessEqual', '≰'),
			_Utils_Tuple2('NotLessGreater', '≸'),
			_Utils_Tuple2('NotLessLess', '≪̸'),
			_Utils_Tuple2('NotLessSlantEqual', '⩽̸'),
			_Utils_Tuple2('NotLessTilde', '≴'),
			_Utils_Tuple2('NotNestedGreaterGreater', '⪢̸'),
			_Utils_Tuple2('NotNestedLessLess', '⪡̸'),
			_Utils_Tuple2('notni', '∌'),
			_Utils_Tuple2('notniva', '∌'),
			_Utils_Tuple2('notnivb', '⋾'),
			_Utils_Tuple2('notnivc', '⋽'),
			_Utils_Tuple2('NotPrecedes', '⊀'),
			_Utils_Tuple2('NotPrecedesEqual', '⪯̸'),
			_Utils_Tuple2('NotPrecedesSlantEqual', '⋠'),
			_Utils_Tuple2('NotReverseElement', '∌'),
			_Utils_Tuple2('NotRightTriangleBar', '⧐̸'),
			_Utils_Tuple2('NotRightTriangle', '⋫'),
			_Utils_Tuple2('NotRightTriangleEqual', '⋭'),
			_Utils_Tuple2('NotSquareSubset', '⊏̸'),
			_Utils_Tuple2('NotSquareSubsetEqual', '⋢'),
			_Utils_Tuple2('NotSquareSuperset', '⊐̸'),
			_Utils_Tuple2('NotSquareSupersetEqual', '⋣'),
			_Utils_Tuple2('NotSubset', '⊂⃒'),
			_Utils_Tuple2('NotSubsetEqual', '⊈'),
			_Utils_Tuple2('NotSucceeds', '⊁'),
			_Utils_Tuple2('NotSucceedsEqual', '⪰̸'),
			_Utils_Tuple2('NotSucceedsSlantEqual', '⋡'),
			_Utils_Tuple2('NotSucceedsTilde', '≿̸'),
			_Utils_Tuple2('NotSuperset', '⊃⃒'),
			_Utils_Tuple2('NotSupersetEqual', '⊉'),
			_Utils_Tuple2('NotTilde', '≁'),
			_Utils_Tuple2('NotTildeEqual', '≄'),
			_Utils_Tuple2('NotTildeFullEqual', '≇'),
			_Utils_Tuple2('NotTildeTilde', '≉'),
			_Utils_Tuple2('NotVerticalBar', '∤'),
			_Utils_Tuple2('nparallel', '∦'),
			_Utils_Tuple2('npar', '∦'),
			_Utils_Tuple2('nparsl', '⫽⃥'),
			_Utils_Tuple2('npart', '∂̸'),
			_Utils_Tuple2('npolint', '⨔'),
			_Utils_Tuple2('npr', '⊀'),
			_Utils_Tuple2('nprcue', '⋠'),
			_Utils_Tuple2('nprec', '⊀'),
			_Utils_Tuple2('npreceq', '⪯̸'),
			_Utils_Tuple2('npre', '⪯̸'),
			_Utils_Tuple2('nrarrc', '⤳̸'),
			_Utils_Tuple2('nrarr', '↛'),
			_Utils_Tuple2('nrArr', '⇏'),
			_Utils_Tuple2('nrarrw', '↝̸'),
			_Utils_Tuple2('nrightarrow', '↛'),
			_Utils_Tuple2('nRightarrow', '⇏'),
			_Utils_Tuple2('nrtri', '⋫'),
			_Utils_Tuple2('nrtrie', '⋭'),
			_Utils_Tuple2('nsc', '⊁'),
			_Utils_Tuple2('nsccue', '⋡'),
			_Utils_Tuple2('nsce', '⪰̸'),
			_Utils_Tuple2('Nscr', '\uD835\uDCA9'),
			_Utils_Tuple2('nscr', '\uD835\uDCC3'),
			_Utils_Tuple2('nshortmid', '∤'),
			_Utils_Tuple2('nshortparallel', '∦'),
			_Utils_Tuple2('nsim', '≁'),
			_Utils_Tuple2('nsime', '≄'),
			_Utils_Tuple2('nsimeq', '≄'),
			_Utils_Tuple2('nsmid', '∤'),
			_Utils_Tuple2('nspar', '∦'),
			_Utils_Tuple2('nsqsube', '⋢'),
			_Utils_Tuple2('nsqsupe', '⋣'),
			_Utils_Tuple2('nsub', '⊄'),
			_Utils_Tuple2('nsubE', '⫅̸'),
			_Utils_Tuple2('nsube', '⊈'),
			_Utils_Tuple2('nsubset', '⊂⃒'),
			_Utils_Tuple2('nsubseteq', '⊈'),
			_Utils_Tuple2('nsubseteqq', '⫅̸'),
			_Utils_Tuple2('nsucc', '⊁'),
			_Utils_Tuple2('nsucceq', '⪰̸'),
			_Utils_Tuple2('nsup', '⊅'),
			_Utils_Tuple2('nsupE', '⫆̸'),
			_Utils_Tuple2('nsupe', '⊉'),
			_Utils_Tuple2('nsupset', '⊃⃒'),
			_Utils_Tuple2('nsupseteq', '⊉'),
			_Utils_Tuple2('nsupseteqq', '⫆̸'),
			_Utils_Tuple2('ntgl', '≹'),
			_Utils_Tuple2('Ntilde', 'Ñ'),
			_Utils_Tuple2('ntilde', 'ñ'),
			_Utils_Tuple2('ntlg', '≸'),
			_Utils_Tuple2('ntriangleleft', '⋪'),
			_Utils_Tuple2('ntrianglelefteq', '⋬'),
			_Utils_Tuple2('ntriangleright', '⋫'),
			_Utils_Tuple2('ntrianglerighteq', '⋭'),
			_Utils_Tuple2('Nu', 'Ν'),
			_Utils_Tuple2('nu', 'ν'),
			_Utils_Tuple2('num', '#'),
			_Utils_Tuple2('numero', '№'),
			_Utils_Tuple2('numsp', '\u2007'),
			_Utils_Tuple2('nvap', '≍⃒'),
			_Utils_Tuple2('nvdash', '⊬'),
			_Utils_Tuple2('nvDash', '⊭'),
			_Utils_Tuple2('nVdash', '⊮'),
			_Utils_Tuple2('nVDash', '⊯'),
			_Utils_Tuple2('nvge', '≥⃒'),
			_Utils_Tuple2('nvgt', '>⃒'),
			_Utils_Tuple2('nvHarr', '⤄'),
			_Utils_Tuple2('nvinfin', '⧞'),
			_Utils_Tuple2('nvlArr', '⤂'),
			_Utils_Tuple2('nvle', '≤⃒'),
			_Utils_Tuple2('nvlt', '<⃒'),
			_Utils_Tuple2('nvltrie', '⊴⃒'),
			_Utils_Tuple2('nvrArr', '⤃'),
			_Utils_Tuple2('nvrtrie', '⊵⃒'),
			_Utils_Tuple2('nvsim', '∼⃒'),
			_Utils_Tuple2('nwarhk', '⤣'),
			_Utils_Tuple2('nwarr', '↖'),
			_Utils_Tuple2('nwArr', '⇖'),
			_Utils_Tuple2('nwarrow', '↖'),
			_Utils_Tuple2('nwnear', '⤧'),
			_Utils_Tuple2('Oacute', 'Ó'),
			_Utils_Tuple2('oacute', 'ó'),
			_Utils_Tuple2('oast', '⊛'),
			_Utils_Tuple2('Ocirc', 'Ô'),
			_Utils_Tuple2('ocirc', 'ô'),
			_Utils_Tuple2('ocir', '⊚'),
			_Utils_Tuple2('Ocy', 'О'),
			_Utils_Tuple2('ocy', 'о'),
			_Utils_Tuple2('odash', '⊝'),
			_Utils_Tuple2('Odblac', 'Ő'),
			_Utils_Tuple2('odblac', 'ő'),
			_Utils_Tuple2('odiv', '⨸'),
			_Utils_Tuple2('odot', '⊙'),
			_Utils_Tuple2('odsold', '⦼'),
			_Utils_Tuple2('OElig', 'Œ'),
			_Utils_Tuple2('oelig', 'œ'),
			_Utils_Tuple2('ofcir', '⦿'),
			_Utils_Tuple2('Ofr', '\uD835\uDD12'),
			_Utils_Tuple2('ofr', '\uD835\uDD2C'),
			_Utils_Tuple2('ogon', '˛'),
			_Utils_Tuple2('Ograve', 'Ò'),
			_Utils_Tuple2('ograve', 'ò'),
			_Utils_Tuple2('ogt', '⧁'),
			_Utils_Tuple2('ohbar', '⦵'),
			_Utils_Tuple2('ohm', 'Ω'),
			_Utils_Tuple2('oint', '∮'),
			_Utils_Tuple2('olarr', '↺'),
			_Utils_Tuple2('olcir', '⦾'),
			_Utils_Tuple2('olcross', '⦻'),
			_Utils_Tuple2('oline', '‾'),
			_Utils_Tuple2('olt', '⧀'),
			_Utils_Tuple2('Omacr', 'Ō'),
			_Utils_Tuple2('omacr', 'ō'),
			_Utils_Tuple2('Omega', 'Ω'),
			_Utils_Tuple2('omega', 'ω'),
			_Utils_Tuple2('Omicron', 'Ο'),
			_Utils_Tuple2('omicron', 'ο'),
			_Utils_Tuple2('omid', '⦶'),
			_Utils_Tuple2('ominus', '⊖'),
			_Utils_Tuple2('Oopf', '\uD835\uDD46'),
			_Utils_Tuple2('oopf', '\uD835\uDD60'),
			_Utils_Tuple2('opar', '⦷'),
			_Utils_Tuple2('OpenCurlyDoubleQuote', '“'),
			_Utils_Tuple2('OpenCurlyQuote', '‘'),
			_Utils_Tuple2('operp', '⦹'),
			_Utils_Tuple2('oplus', '⊕'),
			_Utils_Tuple2('orarr', '↻'),
			_Utils_Tuple2('Or', '⩔'),
			_Utils_Tuple2('or', '∨'),
			_Utils_Tuple2('ord', '⩝'),
			_Utils_Tuple2('order', 'ℴ'),
			_Utils_Tuple2('orderof', 'ℴ'),
			_Utils_Tuple2('ordf', 'ª'),
			_Utils_Tuple2('ordm', 'º'),
			_Utils_Tuple2('origof', '⊶'),
			_Utils_Tuple2('oror', '⩖'),
			_Utils_Tuple2('orslope', '⩗'),
			_Utils_Tuple2('orv', '⩛'),
			_Utils_Tuple2('oS', 'Ⓢ'),
			_Utils_Tuple2('Oscr', '\uD835\uDCAA'),
			_Utils_Tuple2('oscr', 'ℴ'),
			_Utils_Tuple2('Oslash', 'Ø'),
			_Utils_Tuple2('oslash', 'ø'),
			_Utils_Tuple2('osol', '⊘'),
			_Utils_Tuple2('Otilde', 'Õ'),
			_Utils_Tuple2('otilde', 'õ'),
			_Utils_Tuple2('otimesas', '⨶'),
			_Utils_Tuple2('Otimes', '⨷'),
			_Utils_Tuple2('otimes', '⊗'),
			_Utils_Tuple2('Ouml', 'Ö'),
			_Utils_Tuple2('ouml', 'ö'),
			_Utils_Tuple2('ovbar', '⌽'),
			_Utils_Tuple2('OverBar', '‾'),
			_Utils_Tuple2('OverBrace', '⏞'),
			_Utils_Tuple2('OverBracket', '⎴'),
			_Utils_Tuple2('OverParenthesis', '⏜'),
			_Utils_Tuple2('para', '¶'),
			_Utils_Tuple2('parallel', '∥'),
			_Utils_Tuple2('par', '∥'),
			_Utils_Tuple2('parsim', '⫳'),
			_Utils_Tuple2('parsl', '⫽'),
			_Utils_Tuple2('part', '∂'),
			_Utils_Tuple2('PartialD', '∂'),
			_Utils_Tuple2('Pcy', 'П'),
			_Utils_Tuple2('pcy', 'п'),
			_Utils_Tuple2('percnt', '%'),
			_Utils_Tuple2('period', '.'),
			_Utils_Tuple2('permil', '‰'),
			_Utils_Tuple2('perp', '⊥'),
			_Utils_Tuple2('pertenk', '‱'),
			_Utils_Tuple2('Pfr', '\uD835\uDD13'),
			_Utils_Tuple2('pfr', '\uD835\uDD2D'),
			_Utils_Tuple2('Phi', 'Φ'),
			_Utils_Tuple2('phi', 'φ'),
			_Utils_Tuple2('phiv', 'ϕ'),
			_Utils_Tuple2('phmmat', 'ℳ'),
			_Utils_Tuple2('phone', '☎'),
			_Utils_Tuple2('Pi', 'Π'),
			_Utils_Tuple2('pi', 'π'),
			_Utils_Tuple2('pitchfork', '⋔'),
			_Utils_Tuple2('piv', 'ϖ'),
			_Utils_Tuple2('planck', 'ℏ'),
			_Utils_Tuple2('planckh', 'ℎ'),
			_Utils_Tuple2('plankv', 'ℏ'),
			_Utils_Tuple2('plusacir', '⨣'),
			_Utils_Tuple2('plusb', '⊞'),
			_Utils_Tuple2('pluscir', '⨢'),
			_Utils_Tuple2('plus', '+'),
			_Utils_Tuple2('plusdo', '∔'),
			_Utils_Tuple2('plusdu', '⨥'),
			_Utils_Tuple2('pluse', '⩲'),
			_Utils_Tuple2('PlusMinus', '±'),
			_Utils_Tuple2('plusmn', '±'),
			_Utils_Tuple2('plussim', '⨦'),
			_Utils_Tuple2('plustwo', '⨧'),
			_Utils_Tuple2('pm', '±'),
			_Utils_Tuple2('Poincareplane', 'ℌ'),
			_Utils_Tuple2('pointint', '⨕'),
			_Utils_Tuple2('popf', '\uD835\uDD61'),
			_Utils_Tuple2('Popf', 'ℙ'),
			_Utils_Tuple2('pound', '£'),
			_Utils_Tuple2('prap', '⪷'),
			_Utils_Tuple2('Pr', '⪻'),
			_Utils_Tuple2('pr', '≺'),
			_Utils_Tuple2('prcue', '≼'),
			_Utils_Tuple2('precapprox', '⪷'),
			_Utils_Tuple2('prec', '≺'),
			_Utils_Tuple2('preccurlyeq', '≼'),
			_Utils_Tuple2('Precedes', '≺'),
			_Utils_Tuple2('PrecedesEqual', '⪯'),
			_Utils_Tuple2('PrecedesSlantEqual', '≼'),
			_Utils_Tuple2('PrecedesTilde', '≾'),
			_Utils_Tuple2('preceq', '⪯'),
			_Utils_Tuple2('precnapprox', '⪹'),
			_Utils_Tuple2('precneqq', '⪵'),
			_Utils_Tuple2('precnsim', '⋨'),
			_Utils_Tuple2('pre', '⪯'),
			_Utils_Tuple2('prE', '⪳'),
			_Utils_Tuple2('precsim', '≾'),
			_Utils_Tuple2('prime', '′'),
			_Utils_Tuple2('Prime', '″'),
			_Utils_Tuple2('primes', 'ℙ'),
			_Utils_Tuple2('prnap', '⪹'),
			_Utils_Tuple2('prnE', '⪵'),
			_Utils_Tuple2('prnsim', '⋨'),
			_Utils_Tuple2('prod', '∏'),
			_Utils_Tuple2('Product', '∏'),
			_Utils_Tuple2('profalar', '⌮'),
			_Utils_Tuple2('profline', '⌒'),
			_Utils_Tuple2('profsurf', '⌓'),
			_Utils_Tuple2('prop', '∝'),
			_Utils_Tuple2('Proportional', '∝'),
			_Utils_Tuple2('Proportion', '∷'),
			_Utils_Tuple2('propto', '∝'),
			_Utils_Tuple2('prsim', '≾'),
			_Utils_Tuple2('prurel', '⊰'),
			_Utils_Tuple2('Pscr', '\uD835\uDCAB'),
			_Utils_Tuple2('pscr', '\uD835\uDCC5'),
			_Utils_Tuple2('Psi', 'Ψ'),
			_Utils_Tuple2('psi', 'ψ'),
			_Utils_Tuple2('puncsp', '\u2008'),
			_Utils_Tuple2('Qfr', '\uD835\uDD14'),
			_Utils_Tuple2('qfr', '\uD835\uDD2E'),
			_Utils_Tuple2('qint', '⨌'),
			_Utils_Tuple2('qopf', '\uD835\uDD62'),
			_Utils_Tuple2('Qopf', 'ℚ'),
			_Utils_Tuple2('qprime', '⁗'),
			_Utils_Tuple2('Qscr', '\uD835\uDCAC'),
			_Utils_Tuple2('qscr', '\uD835\uDCC6'),
			_Utils_Tuple2('quaternions', 'ℍ'),
			_Utils_Tuple2('quatint', '⨖'),
			_Utils_Tuple2('quest', '?'),
			_Utils_Tuple2('questeq', '≟'),
			_Utils_Tuple2('quot', '\"'),
			_Utils_Tuple2('QUOT', '\"'),
			_Utils_Tuple2('rAarr', '⇛'),
			_Utils_Tuple2('race', '∽̱'),
			_Utils_Tuple2('Racute', 'Ŕ'),
			_Utils_Tuple2('racute', 'ŕ'),
			_Utils_Tuple2('radic', '√'),
			_Utils_Tuple2('raemptyv', '⦳'),
			_Utils_Tuple2('rang', '⟩'),
			_Utils_Tuple2('Rang', '⟫'),
			_Utils_Tuple2('rangd', '⦒'),
			_Utils_Tuple2('range', '⦥'),
			_Utils_Tuple2('rangle', '⟩'),
			_Utils_Tuple2('raquo', '»'),
			_Utils_Tuple2('rarrap', '⥵'),
			_Utils_Tuple2('rarrb', '⇥'),
			_Utils_Tuple2('rarrbfs', '⤠'),
			_Utils_Tuple2('rarrc', '⤳'),
			_Utils_Tuple2('rarr', '→'),
			_Utils_Tuple2('Rarr', '↠'),
			_Utils_Tuple2('rArr', '⇒'),
			_Utils_Tuple2('rarrfs', '⤞'),
			_Utils_Tuple2('rarrhk', '↪'),
			_Utils_Tuple2('rarrlp', '↬'),
			_Utils_Tuple2('rarrpl', '⥅'),
			_Utils_Tuple2('rarrsim', '⥴'),
			_Utils_Tuple2('Rarrtl', '⤖'),
			_Utils_Tuple2('rarrtl', '↣'),
			_Utils_Tuple2('rarrw', '↝'),
			_Utils_Tuple2('ratail', '⤚'),
			_Utils_Tuple2('rAtail', '⤜'),
			_Utils_Tuple2('ratio', '∶'),
			_Utils_Tuple2('rationals', 'ℚ'),
			_Utils_Tuple2('rbarr', '⤍'),
			_Utils_Tuple2('rBarr', '⤏'),
			_Utils_Tuple2('RBarr', '⤐'),
			_Utils_Tuple2('rbbrk', '❳'),
			_Utils_Tuple2('rbrace', '}'),
			_Utils_Tuple2('rbrack', ']'),
			_Utils_Tuple2('rbrke', '⦌'),
			_Utils_Tuple2('rbrksld', '⦎'),
			_Utils_Tuple2('rbrkslu', '⦐'),
			_Utils_Tuple2('Rcaron', 'Ř'),
			_Utils_Tuple2('rcaron', 'ř'),
			_Utils_Tuple2('Rcedil', 'Ŗ'),
			_Utils_Tuple2('rcedil', 'ŗ'),
			_Utils_Tuple2('rceil', '⌉'),
			_Utils_Tuple2('rcub', '}'),
			_Utils_Tuple2('Rcy', 'Р'),
			_Utils_Tuple2('rcy', 'р'),
			_Utils_Tuple2('rdca', '⤷'),
			_Utils_Tuple2('rdldhar', '⥩'),
			_Utils_Tuple2('rdquo', '”'),
			_Utils_Tuple2('rdquor', '”'),
			_Utils_Tuple2('rdsh', '↳'),
			_Utils_Tuple2('real', 'ℜ'),
			_Utils_Tuple2('realine', 'ℛ'),
			_Utils_Tuple2('realpart', 'ℜ'),
			_Utils_Tuple2('reals', 'ℝ'),
			_Utils_Tuple2('Re', 'ℜ'),
			_Utils_Tuple2('rect', '▭'),
			_Utils_Tuple2('reg', '®'),
			_Utils_Tuple2('REG', '®'),
			_Utils_Tuple2('ReverseElement', '∋'),
			_Utils_Tuple2('ReverseEquilibrium', '⇋'),
			_Utils_Tuple2('ReverseUpEquilibrium', '⥯'),
			_Utils_Tuple2('rfisht', '⥽'),
			_Utils_Tuple2('rfloor', '⌋'),
			_Utils_Tuple2('rfr', '\uD835\uDD2F'),
			_Utils_Tuple2('Rfr', 'ℜ'),
			_Utils_Tuple2('rHar', '⥤'),
			_Utils_Tuple2('rhard', '⇁'),
			_Utils_Tuple2('rharu', '⇀'),
			_Utils_Tuple2('rharul', '⥬'),
			_Utils_Tuple2('Rho', 'Ρ'),
			_Utils_Tuple2('rho', 'ρ'),
			_Utils_Tuple2('rhov', 'ϱ'),
			_Utils_Tuple2('RightAngleBracket', '⟩'),
			_Utils_Tuple2('RightArrowBar', '⇥'),
			_Utils_Tuple2('rightarrow', '→'),
			_Utils_Tuple2('RightArrow', '→'),
			_Utils_Tuple2('Rightarrow', '⇒'),
			_Utils_Tuple2('RightArrowLeftArrow', '⇄'),
			_Utils_Tuple2('rightarrowtail', '↣'),
			_Utils_Tuple2('RightCeiling', '⌉'),
			_Utils_Tuple2('RightDoubleBracket', '⟧'),
			_Utils_Tuple2('RightDownTeeVector', '⥝'),
			_Utils_Tuple2('RightDownVectorBar', '⥕'),
			_Utils_Tuple2('RightDownVector', '⇂'),
			_Utils_Tuple2('RightFloor', '⌋'),
			_Utils_Tuple2('rightharpoondown', '⇁'),
			_Utils_Tuple2('rightharpoonup', '⇀'),
			_Utils_Tuple2('rightleftarrows', '⇄'),
			_Utils_Tuple2('rightleftharpoons', '⇌'),
			_Utils_Tuple2('rightrightarrows', '⇉'),
			_Utils_Tuple2('rightsquigarrow', '↝'),
			_Utils_Tuple2('RightTeeArrow', '↦'),
			_Utils_Tuple2('RightTee', '⊢'),
			_Utils_Tuple2('RightTeeVector', '⥛'),
			_Utils_Tuple2('rightthreetimes', '⋌'),
			_Utils_Tuple2('RightTriangleBar', '⧐'),
			_Utils_Tuple2('RightTriangle', '⊳'),
			_Utils_Tuple2('RightTriangleEqual', '⊵'),
			_Utils_Tuple2('RightUpDownVector', '⥏'),
			_Utils_Tuple2('RightUpTeeVector', '⥜'),
			_Utils_Tuple2('RightUpVectorBar', '⥔'),
			_Utils_Tuple2('RightUpVector', '↾'),
			_Utils_Tuple2('RightVectorBar', '⥓'),
			_Utils_Tuple2('RightVector', '⇀'),
			_Utils_Tuple2('ring', '˚'),
			_Utils_Tuple2('risingdotseq', '≓'),
			_Utils_Tuple2('rlarr', '⇄'),
			_Utils_Tuple2('rlhar', '⇌'),
			_Utils_Tuple2('rlm', '\u200F'),
			_Utils_Tuple2('rmoustache', '⎱'),
			_Utils_Tuple2('rmoust', '⎱'),
			_Utils_Tuple2('rnmid', '⫮'),
			_Utils_Tuple2('roang', '⟭'),
			_Utils_Tuple2('roarr', '⇾'),
			_Utils_Tuple2('robrk', '⟧'),
			_Utils_Tuple2('ropar', '⦆'),
			_Utils_Tuple2('ropf', '\uD835\uDD63'),
			_Utils_Tuple2('Ropf', 'ℝ'),
			_Utils_Tuple2('roplus', '⨮'),
			_Utils_Tuple2('rotimes', '⨵'),
			_Utils_Tuple2('RoundImplies', '⥰'),
			_Utils_Tuple2('rpar', ')'),
			_Utils_Tuple2('rpargt', '⦔'),
			_Utils_Tuple2('rppolint', '⨒'),
			_Utils_Tuple2('rrarr', '⇉'),
			_Utils_Tuple2('Rrightarrow', '⇛'),
			_Utils_Tuple2('rsaquo', '›'),
			_Utils_Tuple2('rscr', '\uD835\uDCC7'),
			_Utils_Tuple2('Rscr', 'ℛ'),
			_Utils_Tuple2('rsh', '↱'),
			_Utils_Tuple2('Rsh', '↱'),
			_Utils_Tuple2('rsqb', ']'),
			_Utils_Tuple2('rsquo', '’'),
			_Utils_Tuple2('rsquor', '’'),
			_Utils_Tuple2('rthree', '⋌'),
			_Utils_Tuple2('rtimes', '⋊'),
			_Utils_Tuple2('rtri', '▹'),
			_Utils_Tuple2('rtrie', '⊵'),
			_Utils_Tuple2('rtrif', '▸'),
			_Utils_Tuple2('rtriltri', '⧎'),
			_Utils_Tuple2('RuleDelayed', '⧴'),
			_Utils_Tuple2('ruluhar', '⥨'),
			_Utils_Tuple2('rx', '℞'),
			_Utils_Tuple2('Sacute', 'Ś'),
			_Utils_Tuple2('sacute', 'ś'),
			_Utils_Tuple2('sbquo', '‚'),
			_Utils_Tuple2('scap', '⪸'),
			_Utils_Tuple2('Scaron', 'Š'),
			_Utils_Tuple2('scaron', 'š'),
			_Utils_Tuple2('Sc', '⪼'),
			_Utils_Tuple2('sc', '≻'),
			_Utils_Tuple2('sccue', '≽'),
			_Utils_Tuple2('sce', '⪰'),
			_Utils_Tuple2('scE', '⪴'),
			_Utils_Tuple2('Scedil', 'Ş'),
			_Utils_Tuple2('scedil', 'ş'),
			_Utils_Tuple2('Scirc', 'Ŝ'),
			_Utils_Tuple2('scirc', 'ŝ'),
			_Utils_Tuple2('scnap', '⪺'),
			_Utils_Tuple2('scnE', '⪶'),
			_Utils_Tuple2('scnsim', '⋩'),
			_Utils_Tuple2('scpolint', '⨓'),
			_Utils_Tuple2('scsim', '≿'),
			_Utils_Tuple2('Scy', 'С'),
			_Utils_Tuple2('scy', 'с'),
			_Utils_Tuple2('sdotb', '⊡'),
			_Utils_Tuple2('sdot', '⋅'),
			_Utils_Tuple2('sdote', '⩦'),
			_Utils_Tuple2('searhk', '⤥'),
			_Utils_Tuple2('searr', '↘'),
			_Utils_Tuple2('seArr', '⇘'),
			_Utils_Tuple2('searrow', '↘'),
			_Utils_Tuple2('sect', '§'),
			_Utils_Tuple2('semi', ';'),
			_Utils_Tuple2('seswar', '⤩'),
			_Utils_Tuple2('setminus', '∖'),
			_Utils_Tuple2('setmn', '∖'),
			_Utils_Tuple2('sext', '✶'),
			_Utils_Tuple2('Sfr', '\uD835\uDD16'),
			_Utils_Tuple2('sfr', '\uD835\uDD30'),
			_Utils_Tuple2('sfrown', '⌢'),
			_Utils_Tuple2('sharp', '♯'),
			_Utils_Tuple2('SHCHcy', 'Щ'),
			_Utils_Tuple2('shchcy', 'щ'),
			_Utils_Tuple2('SHcy', 'Ш'),
			_Utils_Tuple2('shcy', 'ш'),
			_Utils_Tuple2('ShortDownArrow', '↓'),
			_Utils_Tuple2('ShortLeftArrow', '←'),
			_Utils_Tuple2('shortmid', '∣'),
			_Utils_Tuple2('shortparallel', '∥'),
			_Utils_Tuple2('ShortRightArrow', '→'),
			_Utils_Tuple2('ShortUpArrow', '↑'),
			_Utils_Tuple2('shy', '\u00AD'),
			_Utils_Tuple2('Sigma', 'Σ'),
			_Utils_Tuple2('sigma', 'σ'),
			_Utils_Tuple2('sigmaf', 'ς'),
			_Utils_Tuple2('sigmav', 'ς'),
			_Utils_Tuple2('sim', '∼'),
			_Utils_Tuple2('simdot', '⩪'),
			_Utils_Tuple2('sime', '≃'),
			_Utils_Tuple2('simeq', '≃'),
			_Utils_Tuple2('simg', '⪞'),
			_Utils_Tuple2('simgE', '⪠'),
			_Utils_Tuple2('siml', '⪝'),
			_Utils_Tuple2('simlE', '⪟'),
			_Utils_Tuple2('simne', '≆'),
			_Utils_Tuple2('simplus', '⨤'),
			_Utils_Tuple2('simrarr', '⥲'),
			_Utils_Tuple2('slarr', '←'),
			_Utils_Tuple2('SmallCircle', '∘'),
			_Utils_Tuple2('smallsetminus', '∖'),
			_Utils_Tuple2('smashp', '⨳'),
			_Utils_Tuple2('smeparsl', '⧤'),
			_Utils_Tuple2('smid', '∣'),
			_Utils_Tuple2('smile', '⌣'),
			_Utils_Tuple2('smt', '⪪'),
			_Utils_Tuple2('smte', '⪬'),
			_Utils_Tuple2('smtes', '⪬︀'),
			_Utils_Tuple2('SOFTcy', 'Ь'),
			_Utils_Tuple2('softcy', 'ь'),
			_Utils_Tuple2('solbar', '⌿'),
			_Utils_Tuple2('solb', '⧄'),
			_Utils_Tuple2('sol', '/'),
			_Utils_Tuple2('Sopf', '\uD835\uDD4A'),
			_Utils_Tuple2('sopf', '\uD835\uDD64'),
			_Utils_Tuple2('spades', '♠'),
			_Utils_Tuple2('spadesuit', '♠'),
			_Utils_Tuple2('spar', '∥'),
			_Utils_Tuple2('sqcap', '⊓'),
			_Utils_Tuple2('sqcaps', '⊓︀'),
			_Utils_Tuple2('sqcup', '⊔'),
			_Utils_Tuple2('sqcups', '⊔︀'),
			_Utils_Tuple2('Sqrt', '√'),
			_Utils_Tuple2('sqsub', '⊏'),
			_Utils_Tuple2('sqsube', '⊑'),
			_Utils_Tuple2('sqsubset', '⊏'),
			_Utils_Tuple2('sqsubseteq', '⊑'),
			_Utils_Tuple2('sqsup', '⊐'),
			_Utils_Tuple2('sqsupe', '⊒'),
			_Utils_Tuple2('sqsupset', '⊐'),
			_Utils_Tuple2('sqsupseteq', '⊒'),
			_Utils_Tuple2('square', '□'),
			_Utils_Tuple2('Square', '□'),
			_Utils_Tuple2('SquareIntersection', '⊓'),
			_Utils_Tuple2('SquareSubset', '⊏'),
			_Utils_Tuple2('SquareSubsetEqual', '⊑'),
			_Utils_Tuple2('SquareSuperset', '⊐'),
			_Utils_Tuple2('SquareSupersetEqual', '⊒'),
			_Utils_Tuple2('SquareUnion', '⊔'),
			_Utils_Tuple2('squarf', '▪'),
			_Utils_Tuple2('squ', '□'),
			_Utils_Tuple2('squf', '▪'),
			_Utils_Tuple2('srarr', '→'),
			_Utils_Tuple2('Sscr', '\uD835\uDCAE'),
			_Utils_Tuple2('sscr', '\uD835\uDCC8'),
			_Utils_Tuple2('ssetmn', '∖'),
			_Utils_Tuple2('ssmile', '⌣'),
			_Utils_Tuple2('sstarf', '⋆'),
			_Utils_Tuple2('Star', '⋆'),
			_Utils_Tuple2('star', '☆'),
			_Utils_Tuple2('starf', '★'),
			_Utils_Tuple2('straightepsilon', 'ϵ'),
			_Utils_Tuple2('straightphi', 'ϕ'),
			_Utils_Tuple2('strns', '¯'),
			_Utils_Tuple2('sub', '⊂'),
			_Utils_Tuple2('Sub', '⋐'),
			_Utils_Tuple2('subdot', '⪽'),
			_Utils_Tuple2('subE', '⫅'),
			_Utils_Tuple2('sube', '⊆'),
			_Utils_Tuple2('subedot', '⫃'),
			_Utils_Tuple2('submult', '⫁'),
			_Utils_Tuple2('subnE', '⫋'),
			_Utils_Tuple2('subne', '⊊'),
			_Utils_Tuple2('subplus', '⪿'),
			_Utils_Tuple2('subrarr', '⥹'),
			_Utils_Tuple2('subset', '⊂'),
			_Utils_Tuple2('Subset', '⋐'),
			_Utils_Tuple2('subseteq', '⊆'),
			_Utils_Tuple2('subseteqq', '⫅'),
			_Utils_Tuple2('SubsetEqual', '⊆'),
			_Utils_Tuple2('subsetneq', '⊊'),
			_Utils_Tuple2('subsetneqq', '⫋'),
			_Utils_Tuple2('subsim', '⫇'),
			_Utils_Tuple2('subsub', '⫕'),
			_Utils_Tuple2('subsup', '⫓'),
			_Utils_Tuple2('succapprox', '⪸'),
			_Utils_Tuple2('succ', '≻'),
			_Utils_Tuple2('succcurlyeq', '≽'),
			_Utils_Tuple2('Succeeds', '≻'),
			_Utils_Tuple2('SucceedsEqual', '⪰'),
			_Utils_Tuple2('SucceedsSlantEqual', '≽'),
			_Utils_Tuple2('SucceedsTilde', '≿'),
			_Utils_Tuple2('succeq', '⪰'),
			_Utils_Tuple2('succnapprox', '⪺'),
			_Utils_Tuple2('succneqq', '⪶'),
			_Utils_Tuple2('succnsim', '⋩'),
			_Utils_Tuple2('succsim', '≿'),
			_Utils_Tuple2('SuchThat', '∋'),
			_Utils_Tuple2('sum', '∑'),
			_Utils_Tuple2('Sum', '∑'),
			_Utils_Tuple2('sung', '♪'),
			_Utils_Tuple2('sup1', '¹'),
			_Utils_Tuple2('sup2', '²'),
			_Utils_Tuple2('sup3', '³'),
			_Utils_Tuple2('sup', '⊃'),
			_Utils_Tuple2('Sup', '⋑'),
			_Utils_Tuple2('supdot', '⪾'),
			_Utils_Tuple2('supdsub', '⫘'),
			_Utils_Tuple2('supE', '⫆'),
			_Utils_Tuple2('supe', '⊇'),
			_Utils_Tuple2('supedot', '⫄'),
			_Utils_Tuple2('Superset', '⊃'),
			_Utils_Tuple2('SupersetEqual', '⊇'),
			_Utils_Tuple2('suphsol', '⟉'),
			_Utils_Tuple2('suphsub', '⫗'),
			_Utils_Tuple2('suplarr', '⥻'),
			_Utils_Tuple2('supmult', '⫂'),
			_Utils_Tuple2('supnE', '⫌'),
			_Utils_Tuple2('supne', '⊋'),
			_Utils_Tuple2('supplus', '⫀'),
			_Utils_Tuple2('supset', '⊃'),
			_Utils_Tuple2('Supset', '⋑'),
			_Utils_Tuple2('supseteq', '⊇'),
			_Utils_Tuple2('supseteqq', '⫆'),
			_Utils_Tuple2('supsetneq', '⊋'),
			_Utils_Tuple2('supsetneqq', '⫌'),
			_Utils_Tuple2('supsim', '⫈'),
			_Utils_Tuple2('supsub', '⫔'),
			_Utils_Tuple2('supsup', '⫖'),
			_Utils_Tuple2('swarhk', '⤦'),
			_Utils_Tuple2('swarr', '↙'),
			_Utils_Tuple2('swArr', '⇙'),
			_Utils_Tuple2('swarrow', '↙'),
			_Utils_Tuple2('swnwar', '⤪'),
			_Utils_Tuple2('szlig', 'ß'),
			_Utils_Tuple2('Tab', '\t'),
			_Utils_Tuple2('target', '⌖'),
			_Utils_Tuple2('Tau', 'Τ'),
			_Utils_Tuple2('tau', 'τ'),
			_Utils_Tuple2('tbrk', '⎴'),
			_Utils_Tuple2('Tcaron', 'Ť'),
			_Utils_Tuple2('tcaron', 'ť'),
			_Utils_Tuple2('Tcedil', 'Ţ'),
			_Utils_Tuple2('tcedil', 'ţ'),
			_Utils_Tuple2('Tcy', 'Т'),
			_Utils_Tuple2('tcy', 'т'),
			_Utils_Tuple2('tdot', '⃛'),
			_Utils_Tuple2('telrec', '⌕'),
			_Utils_Tuple2('Tfr', '\uD835\uDD17'),
			_Utils_Tuple2('tfr', '\uD835\uDD31'),
			_Utils_Tuple2('there4', '∴'),
			_Utils_Tuple2('therefore', '∴'),
			_Utils_Tuple2('Therefore', '∴'),
			_Utils_Tuple2('Theta', 'Θ'),
			_Utils_Tuple2('theta', 'θ'),
			_Utils_Tuple2('thetasym', 'ϑ'),
			_Utils_Tuple2('thetav', 'ϑ'),
			_Utils_Tuple2('thickapprox', '≈'),
			_Utils_Tuple2('thicksim', '∼'),
			_Utils_Tuple2('ThickSpace', '\u205F\u200A'),
			_Utils_Tuple2('ThinSpace', '\u2009'),
			_Utils_Tuple2('thinsp', '\u2009'),
			_Utils_Tuple2('thkap', '≈'),
			_Utils_Tuple2('thksim', '∼'),
			_Utils_Tuple2('THORN', 'Þ'),
			_Utils_Tuple2('thorn', 'þ'),
			_Utils_Tuple2('tilde', '˜'),
			_Utils_Tuple2('Tilde', '∼'),
			_Utils_Tuple2('TildeEqual', '≃'),
			_Utils_Tuple2('TildeFullEqual', '≅'),
			_Utils_Tuple2('TildeTilde', '≈'),
			_Utils_Tuple2('timesbar', '⨱'),
			_Utils_Tuple2('timesb', '⊠'),
			_Utils_Tuple2('times', '×'),
			_Utils_Tuple2('timesd', '⨰'),
			_Utils_Tuple2('tint', '∭'),
			_Utils_Tuple2('toea', '⤨'),
			_Utils_Tuple2('topbot', '⌶'),
			_Utils_Tuple2('topcir', '⫱'),
			_Utils_Tuple2('top', '⊤'),
			_Utils_Tuple2('Topf', '\uD835\uDD4B'),
			_Utils_Tuple2('topf', '\uD835\uDD65'),
			_Utils_Tuple2('topfork', '⫚'),
			_Utils_Tuple2('tosa', '⤩'),
			_Utils_Tuple2('tprime', '‴'),
			_Utils_Tuple2('trade', '™'),
			_Utils_Tuple2('TRADE', '™'),
			_Utils_Tuple2('triangle', '▵'),
			_Utils_Tuple2('triangledown', '▿'),
			_Utils_Tuple2('triangleleft', '◃'),
			_Utils_Tuple2('trianglelefteq', '⊴'),
			_Utils_Tuple2('triangleq', '≜'),
			_Utils_Tuple2('triangleright', '▹'),
			_Utils_Tuple2('trianglerighteq', '⊵'),
			_Utils_Tuple2('tridot', '◬'),
			_Utils_Tuple2('trie', '≜'),
			_Utils_Tuple2('triminus', '⨺'),
			_Utils_Tuple2('TripleDot', '⃛'),
			_Utils_Tuple2('triplus', '⨹'),
			_Utils_Tuple2('trisb', '⧍'),
			_Utils_Tuple2('tritime', '⨻'),
			_Utils_Tuple2('trpezium', '⏢'),
			_Utils_Tuple2('Tscr', '\uD835\uDCAF'),
			_Utils_Tuple2('tscr', '\uD835\uDCC9'),
			_Utils_Tuple2('TScy', 'Ц'),
			_Utils_Tuple2('tscy', 'ц'),
			_Utils_Tuple2('TSHcy', 'Ћ'),
			_Utils_Tuple2('tshcy', 'ћ'),
			_Utils_Tuple2('Tstrok', 'Ŧ'),
			_Utils_Tuple2('tstrok', 'ŧ'),
			_Utils_Tuple2('twixt', '≬'),
			_Utils_Tuple2('twoheadleftarrow', '↞'),
			_Utils_Tuple2('twoheadrightarrow', '↠'),
			_Utils_Tuple2('Uacute', 'Ú'),
			_Utils_Tuple2('uacute', 'ú'),
			_Utils_Tuple2('uarr', '↑'),
			_Utils_Tuple2('Uarr', '↟'),
			_Utils_Tuple2('uArr', '⇑'),
			_Utils_Tuple2('Uarrocir', '⥉'),
			_Utils_Tuple2('Ubrcy', 'Ў'),
			_Utils_Tuple2('ubrcy', 'ў'),
			_Utils_Tuple2('Ubreve', 'Ŭ'),
			_Utils_Tuple2('ubreve', 'ŭ'),
			_Utils_Tuple2('Ucirc', 'Û'),
			_Utils_Tuple2('ucirc', 'û'),
			_Utils_Tuple2('Ucy', 'У'),
			_Utils_Tuple2('ucy', 'у'),
			_Utils_Tuple2('udarr', '⇅'),
			_Utils_Tuple2('Udblac', 'Ű'),
			_Utils_Tuple2('udblac', 'ű'),
			_Utils_Tuple2('udhar', '⥮'),
			_Utils_Tuple2('ufisht', '⥾'),
			_Utils_Tuple2('Ufr', '\uD835\uDD18'),
			_Utils_Tuple2('ufr', '\uD835\uDD32'),
			_Utils_Tuple2('Ugrave', 'Ù'),
			_Utils_Tuple2('ugrave', 'ù'),
			_Utils_Tuple2('uHar', '⥣'),
			_Utils_Tuple2('uharl', '↿'),
			_Utils_Tuple2('uharr', '↾'),
			_Utils_Tuple2('uhblk', '▀'),
			_Utils_Tuple2('ulcorn', '⌜'),
			_Utils_Tuple2('ulcorner', '⌜'),
			_Utils_Tuple2('ulcrop', '⌏'),
			_Utils_Tuple2('ultri', '◸'),
			_Utils_Tuple2('Umacr', 'Ū'),
			_Utils_Tuple2('umacr', 'ū'),
			_Utils_Tuple2('uml', '¨'),
			_Utils_Tuple2('UnderBar', '_'),
			_Utils_Tuple2('UnderBrace', '⏟'),
			_Utils_Tuple2('UnderBracket', '⎵'),
			_Utils_Tuple2('UnderParenthesis', '⏝'),
			_Utils_Tuple2('Union', '⋃'),
			_Utils_Tuple2('UnionPlus', '⊎'),
			_Utils_Tuple2('Uogon', 'Ų'),
			_Utils_Tuple2('uogon', 'ų'),
			_Utils_Tuple2('Uopf', '\uD835\uDD4C'),
			_Utils_Tuple2('uopf', '\uD835\uDD66'),
			_Utils_Tuple2('UpArrowBar', '⤒'),
			_Utils_Tuple2('uparrow', '↑'),
			_Utils_Tuple2('UpArrow', '↑'),
			_Utils_Tuple2('Uparrow', '⇑'),
			_Utils_Tuple2('UpArrowDownArrow', '⇅'),
			_Utils_Tuple2('updownarrow', '↕'),
			_Utils_Tuple2('UpDownArrow', '↕'),
			_Utils_Tuple2('Updownarrow', '⇕'),
			_Utils_Tuple2('UpEquilibrium', '⥮'),
			_Utils_Tuple2('upharpoonleft', '↿'),
			_Utils_Tuple2('upharpoonright', '↾'),
			_Utils_Tuple2('uplus', '⊎'),
			_Utils_Tuple2('UpperLeftArrow', '↖'),
			_Utils_Tuple2('UpperRightArrow', '↗'),
			_Utils_Tuple2('upsi', 'υ'),
			_Utils_Tuple2('Upsi', 'ϒ'),
			_Utils_Tuple2('upsih', 'ϒ'),
			_Utils_Tuple2('Upsilon', 'Υ'),
			_Utils_Tuple2('upsilon', 'υ'),
			_Utils_Tuple2('UpTeeArrow', '↥'),
			_Utils_Tuple2('UpTee', '⊥'),
			_Utils_Tuple2('upuparrows', '⇈'),
			_Utils_Tuple2('urcorn', '⌝'),
			_Utils_Tuple2('urcorner', '⌝'),
			_Utils_Tuple2('urcrop', '⌎'),
			_Utils_Tuple2('Uring', 'Ů'),
			_Utils_Tuple2('uring', 'ů'),
			_Utils_Tuple2('urtri', '◹'),
			_Utils_Tuple2('Uscr', '\uD835\uDCB0'),
			_Utils_Tuple2('uscr', '\uD835\uDCCA'),
			_Utils_Tuple2('utdot', '⋰'),
			_Utils_Tuple2('Utilde', 'Ũ'),
			_Utils_Tuple2('utilde', 'ũ'),
			_Utils_Tuple2('utri', '▵'),
			_Utils_Tuple2('utrif', '▴'),
			_Utils_Tuple2('uuarr', '⇈'),
			_Utils_Tuple2('Uuml', 'Ü'),
			_Utils_Tuple2('uuml', 'ü'),
			_Utils_Tuple2('uwangle', '⦧'),
			_Utils_Tuple2('vangrt', '⦜'),
			_Utils_Tuple2('varepsilon', 'ϵ'),
			_Utils_Tuple2('varkappa', 'ϰ'),
			_Utils_Tuple2('varnothing', '∅'),
			_Utils_Tuple2('varphi', 'ϕ'),
			_Utils_Tuple2('varpi', 'ϖ'),
			_Utils_Tuple2('varpropto', '∝'),
			_Utils_Tuple2('varr', '↕'),
			_Utils_Tuple2('vArr', '⇕'),
			_Utils_Tuple2('varrho', 'ϱ'),
			_Utils_Tuple2('varsigma', 'ς'),
			_Utils_Tuple2('varsubsetneq', '⊊︀'),
			_Utils_Tuple2('varsubsetneqq', '⫋︀'),
			_Utils_Tuple2('varsupsetneq', '⊋︀'),
			_Utils_Tuple2('varsupsetneqq', '⫌︀'),
			_Utils_Tuple2('vartheta', 'ϑ'),
			_Utils_Tuple2('vartriangleleft', '⊲'),
			_Utils_Tuple2('vartriangleright', '⊳'),
			_Utils_Tuple2('vBar', '⫨'),
			_Utils_Tuple2('Vbar', '⫫'),
			_Utils_Tuple2('vBarv', '⫩'),
			_Utils_Tuple2('Vcy', 'В'),
			_Utils_Tuple2('vcy', 'в'),
			_Utils_Tuple2('vdash', '⊢'),
			_Utils_Tuple2('vDash', '⊨'),
			_Utils_Tuple2('Vdash', '⊩'),
			_Utils_Tuple2('VDash', '⊫'),
			_Utils_Tuple2('Vdashl', '⫦'),
			_Utils_Tuple2('veebar', '⊻'),
			_Utils_Tuple2('vee', '∨'),
			_Utils_Tuple2('Vee', '⋁'),
			_Utils_Tuple2('veeeq', '≚'),
			_Utils_Tuple2('vellip', '⋮'),
			_Utils_Tuple2('verbar', '|'),
			_Utils_Tuple2('Verbar', '‖'),
			_Utils_Tuple2('vert', '|'),
			_Utils_Tuple2('Vert', '‖'),
			_Utils_Tuple2('VerticalBar', '∣'),
			_Utils_Tuple2('VerticalLine', '|'),
			_Utils_Tuple2('VerticalSeparator', '❘'),
			_Utils_Tuple2('VerticalTilde', '≀'),
			_Utils_Tuple2('VeryThinSpace', '\u200A'),
			_Utils_Tuple2('Vfr', '\uD835\uDD19'),
			_Utils_Tuple2('vfr', '\uD835\uDD33'),
			_Utils_Tuple2('vltri', '⊲'),
			_Utils_Tuple2('vnsub', '⊂⃒'),
			_Utils_Tuple2('vnsup', '⊃⃒'),
			_Utils_Tuple2('Vopf', '\uD835\uDD4D'),
			_Utils_Tuple2('vopf', '\uD835\uDD67'),
			_Utils_Tuple2('vprop', '∝'),
			_Utils_Tuple2('vrtri', '⊳'),
			_Utils_Tuple2('Vscr', '\uD835\uDCB1'),
			_Utils_Tuple2('vscr', '\uD835\uDCCB'),
			_Utils_Tuple2('vsubnE', '⫋︀'),
			_Utils_Tuple2('vsubne', '⊊︀'),
			_Utils_Tuple2('vsupnE', '⫌︀'),
			_Utils_Tuple2('vsupne', '⊋︀'),
			_Utils_Tuple2('Vvdash', '⊪'),
			_Utils_Tuple2('vzigzag', '⦚'),
			_Utils_Tuple2('Wcirc', 'Ŵ'),
			_Utils_Tuple2('wcirc', 'ŵ'),
			_Utils_Tuple2('wedbar', '⩟'),
			_Utils_Tuple2('wedge', '∧'),
			_Utils_Tuple2('Wedge', '⋀'),
			_Utils_Tuple2('wedgeq', '≙'),
			_Utils_Tuple2('weierp', '℘'),
			_Utils_Tuple2('Wfr', '\uD835\uDD1A'),
			_Utils_Tuple2('wfr', '\uD835\uDD34'),
			_Utils_Tuple2('Wopf', '\uD835\uDD4E'),
			_Utils_Tuple2('wopf', '\uD835\uDD68'),
			_Utils_Tuple2('wp', '℘'),
			_Utils_Tuple2('wr', '≀'),
			_Utils_Tuple2('wreath', '≀'),
			_Utils_Tuple2('Wscr', '\uD835\uDCB2'),
			_Utils_Tuple2('wscr', '\uD835\uDCCC'),
			_Utils_Tuple2('xcap', '⋂'),
			_Utils_Tuple2('xcirc', '◯'),
			_Utils_Tuple2('xcup', '⋃'),
			_Utils_Tuple2('xdtri', '▽'),
			_Utils_Tuple2('Xfr', '\uD835\uDD1B'),
			_Utils_Tuple2('xfr', '\uD835\uDD35'),
			_Utils_Tuple2('xharr', '⟷'),
			_Utils_Tuple2('xhArr', '⟺'),
			_Utils_Tuple2('Xi', 'Ξ'),
			_Utils_Tuple2('xi', 'ξ'),
			_Utils_Tuple2('xlarr', '⟵'),
			_Utils_Tuple2('xlArr', '⟸'),
			_Utils_Tuple2('xmap', '⟼'),
			_Utils_Tuple2('xnis', '⋻'),
			_Utils_Tuple2('xodot', '⨀'),
			_Utils_Tuple2('Xopf', '\uD835\uDD4F'),
			_Utils_Tuple2('xopf', '\uD835\uDD69'),
			_Utils_Tuple2('xoplus', '⨁'),
			_Utils_Tuple2('xotime', '⨂'),
			_Utils_Tuple2('xrarr', '⟶'),
			_Utils_Tuple2('xrArr', '⟹'),
			_Utils_Tuple2('Xscr', '\uD835\uDCB3'),
			_Utils_Tuple2('xscr', '\uD835\uDCCD'),
			_Utils_Tuple2('xsqcup', '⨆'),
			_Utils_Tuple2('xuplus', '⨄'),
			_Utils_Tuple2('xutri', '△'),
			_Utils_Tuple2('xvee', '⋁'),
			_Utils_Tuple2('xwedge', '⋀'),
			_Utils_Tuple2('Yacute', 'Ý'),
			_Utils_Tuple2('yacute', 'ý'),
			_Utils_Tuple2('YAcy', 'Я'),
			_Utils_Tuple2('yacy', 'я'),
			_Utils_Tuple2('Ycirc', 'Ŷ'),
			_Utils_Tuple2('ycirc', 'ŷ'),
			_Utils_Tuple2('Ycy', 'Ы'),
			_Utils_Tuple2('ycy', 'ы'),
			_Utils_Tuple2('yen', '¥'),
			_Utils_Tuple2('Yfr', '\uD835\uDD1C'),
			_Utils_Tuple2('yfr', '\uD835\uDD36'),
			_Utils_Tuple2('YIcy', 'Ї'),
			_Utils_Tuple2('yicy', 'ї'),
			_Utils_Tuple2('Yopf', '\uD835\uDD50'),
			_Utils_Tuple2('yopf', '\uD835\uDD6A'),
			_Utils_Tuple2('Yscr', '\uD835\uDCB4'),
			_Utils_Tuple2('yscr', '\uD835\uDCCE'),
			_Utils_Tuple2('YUcy', 'Ю'),
			_Utils_Tuple2('yucy', 'ю'),
			_Utils_Tuple2('yuml', 'ÿ'),
			_Utils_Tuple2('Yuml', 'Ÿ'),
			_Utils_Tuple2('Zacute', 'Ź'),
			_Utils_Tuple2('zacute', 'ź'),
			_Utils_Tuple2('Zcaron', 'Ž'),
			_Utils_Tuple2('zcaron', 'ž'),
			_Utils_Tuple2('Zcy', 'З'),
			_Utils_Tuple2('zcy', 'з'),
			_Utils_Tuple2('Zdot', 'Ż'),
			_Utils_Tuple2('zdot', 'ż'),
			_Utils_Tuple2('zeetrf', 'ℨ'),
			_Utils_Tuple2('ZeroWidthSpace', '\u200B'),
			_Utils_Tuple2('Zeta', 'Ζ'),
			_Utils_Tuple2('zeta', 'ζ'),
			_Utils_Tuple2('zfr', '\uD835\uDD37'),
			_Utils_Tuple2('Zfr', 'ℨ'),
			_Utils_Tuple2('ZHcy', 'Ж'),
			_Utils_Tuple2('zhcy', 'ж'),
			_Utils_Tuple2('zigrarr', '⇝'),
			_Utils_Tuple2('zopf', '\uD835\uDD6B'),
			_Utils_Tuple2('Zopf', 'ℤ'),
			_Utils_Tuple2('Zscr', '\uD835\uDCB5'),
			_Utils_Tuple2('zscr', '\uD835\uDCCF'),
			_Utils_Tuple2('zwj', '\u200D'),
			_Utils_Tuple2('zwnj', '\u200C')
		]));
var $hecrj$html_parser$Html$Parser$namedCharacterReference = A2(
	$elm$parser$Parser$map,
	function (reference) {
		return A2(
			$elm$core$Maybe$withDefault,
			'&' + (reference + ';'),
			A2($elm$core$Dict$get, reference, $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isAlpha)));
var $elm$core$Char$fromCode = _Char_fromCode;
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $hecrj$html_parser$Html$Parser$hexadecimal = A2(
	$elm$parser$Parser$andThen,
	function (hex) {
		var _v0 = $rtfeldman$elm_hex$Hex$fromString(
			$elm$core$String$toLower(hex));
		if (!_v0.$) {
			var value = _v0.a;
			return $elm$parser$Parser$succeed(value);
		} else {
			var error = _v0.a;
			return $elm$parser$Parser$problem(error);
		}
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isHexDigit)));
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {lH: s.lH + (newOffset - s.G), f: s.f, g: s.g, G: newOffset, IB: s.IB, dA: s.dA};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.G, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$core$String$toFloat = _String_toFloat;
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.dA);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.IB, s.lH - (floatOffset + s.G), invalid, s.f));
		} else {
			if (_Utils_eq(s.G, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.G, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.G, floatOffset, s.dA));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.G, s.dA)) {
			var zeroOffset = s.G + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.dA) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.Vi,
				c.tF,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.dA),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.dA) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.Vi,
				c.CJ,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.dA),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.dA) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.Vi,
				c.jv,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.dA),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.Vi,
				c.qJ,
				c.u1,
				c.r7,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.Vi,
				c.qJ,
				c.u1,
				c.r7,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.G, s.dA),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				jv: $elm$core$Result$Err(invalid),
				qJ: expecting,
				r7: $elm$core$Result$Err(invalid),
				tF: $elm$core$Result$Err(invalid),
				u1: $elm$core$Result$Ok($elm$core$Basics$identity),
				Vi: invalid,
				CJ: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
	var codepoint = $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						function (c) {
							return (c === 'x') || (c === 'X');
						})),
				$hecrj$html_parser$Html$Parser$hexadecimal),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq('0'))),
				$elm$parser$Parser$int)
			]));
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq('#'))),
		A2(
			$elm$parser$Parser$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			codepoint));
}();
var $hecrj$html_parser$Html$Parser$characterReference = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('&'))),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$namedCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$numericCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				$elm$parser$Parser$succeed('&')
			])));
var $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
	var isQuotedValueChar = function (c) {
		return (!_Utils_eq(c, quote)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$map,
				$elm$core$String$join(''),
				$hecrj$html_parser$Html$Parser$many(
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$getChompedString(
								$hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
								$hecrj$html_parser$Html$Parser$characterReference
							])))),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))));
};
var $hecrj$html_parser$Html$Parser$oneOrMore = F2(
	function (type_, parser_) {
		return A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			function (list) {
				return $elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (_new) {
								return $elm$parser$Parser$Loop(
									A2($elm$core$List$cons, _new, list));
							},
							parser_),
							$elm$core$List$isEmpty(list) ? $elm$parser$Parser$problem('expecting at least one ' + type_) : $elm$parser$Parser$succeed(
							$elm$parser$Parser$Done(
								$elm$core$List$reverse(list)))
						]));
			});
	});
var $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
	var isUnquotedValueChar = function (c) {
		return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '=') && ((c !== '<') && ((c !== '>') && ((c !== '`') && (c !== '&')))))));
	};
	return A2(
		$elm$parser$Parser$map,
		$elm$core$String$join(''),
		A2(
			$hecrj$html_parser$Html$Parser$oneOrMore,
			'attribute value',
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$getChompedString(
						$hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
						$hecrj$html_parser$Html$Parser$characterReference
					]))));
}();
var $hecrj$html_parser$Html$Parser$tagAttributeValue = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('='))),
				$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
					]))),
			$elm$parser$Parser$succeed('')
		]));
var $hecrj$html_parser$Html$Parser$tagAttribute = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Tuple$pair),
		A2(
			$elm$parser$Parser$ignorer,
			$hecrj$html_parser$Html$Parser$tagAttributeName,
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
	A2(
		$elm$parser$Parser$ignorer,
		$hecrj$html_parser$Html$Parser$tagAttributeValue,
		$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)));
var $hecrj$html_parser$Html$Parser$tagAttributes = $hecrj$html_parser$Html$Parser$many($hecrj$html_parser$Html$Parser$tagAttribute);
var $hecrj$html_parser$Html$Parser$tagName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$chompIf($elm$core$Char$isAlphaNum),
			$elm$parser$Parser$chompWhile(
				function (c) {
					return $elm$core$Char$isAlphaNum(c) || (c === '-');
				}))));
var $hecrj$html_parser$Html$Parser$Text = function (a) {
	return {$: 0, a: a};
};
var $hecrj$html_parser$Html$Parser$text = A2(
	$elm$parser$Parser$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$join(''),
		$hecrj$html_parser$Html$Parser$Text),
	A2(
		$hecrj$html_parser$Html$Parser$oneOrMore,
		'text element',
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$getChompedString(
					$hecrj$html_parser$Html$Parser$chompOneOrMore(
						function (c) {
							return (c !== '<') && (c !== '&');
						})),
					$hecrj$html_parser$Html$Parser$characterReference
				]))));
function $hecrj$html_parser$Html$Parser$cyclic$node() {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$hecrj$html_parser$Html$Parser$text,
				$hecrj$html_parser$Html$Parser$comment,
				$hecrj$html_parser$Html$Parser$cyclic$element()
			]));
}
function $hecrj$html_parser$Html$Parser$cyclic$element() {
	return A2(
		$elm$parser$Parser$andThen,
		function (_v0) {
			var name = _v0.a;
			var attributes = _v0.b;
			return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A3($hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$chompIf(
								$elm$core$Basics$eq('/')),
								$elm$parser$Parser$succeed(0)
							]))),
				$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('>'))) : A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A2($hecrj$html_parser$Html$Parser$Element, name, attributes)),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('>'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$many(
						$elm$parser$Parser$backtrackable(
							$hecrj$html_parser$Html$Parser$cyclic$node())),
					$hecrj$html_parser$Html$Parser$closingTag(name)));
		},
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Tuple$pair),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$tagName,
					$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
			$hecrj$html_parser$Html$Parser$tagAttributes));
}
var $hecrj$html_parser$Html$Parser$node = $hecrj$html_parser$Html$Parser$cyclic$node();
$hecrj$html_parser$Html$Parser$cyclic$node = function () {
	return $hecrj$html_parser$Html$Parser$node;
};
var $hecrj$html_parser$Html$Parser$element = $hecrj$html_parser$Html$Parser$cyclic$element();
$hecrj$html_parser$Html$Parser$cyclic$element = function () {
	return $hecrj$html_parser$Html$Parser$element;
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {lH: col, F_: problem, IB: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.IB, p.lH, p.F_);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{lH: 1, f: _List_Nil, g: 1, G: 0, IB: 1, dA: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $hecrj$html_parser$Html$Parser$run = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(_List_Nil) : A2(
		$elm$parser$Parser$run,
		A2($hecrj$html_parser$Html$Parser$oneOrMore, 'node', $hecrj$html_parser$Html$Parser$node),
		str);
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $hecrj$html_parser$Html$Parser$Util$toAttribute = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return A2($elm$html$Html$Attributes$attribute, name, value);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDom = function (nodes) {
	return A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach, nodes);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach = function (node) {
	switch (node.$) {
		case 1:
			var name = node.a;
			var attrs = node.b;
			var children = node.c;
			return A3(
				$elm$html$Html$node,
				name,
				A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toAttribute, attrs),
				$hecrj$html_parser$Html$Parser$Util$toVirtualDom(children));
		case 0:
			var s = node.a;
			return $elm$html$Html$text(s);
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Util$Html$parseOnly = function (content) {
	return A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		A2(
			$elm$core$Result$map,
			function (x) {
				return $hecrj$html_parser$Html$Parser$Util$toVirtualDom(x);
			},
			$hecrj$html_parser$Html$Parser$run(
				A3($elm$core$String$replace, '\n', '', content))));
};
var $author$project$Slider$getSliderLength = function (slider) {
	switch (slider.$) {
		case 0:
			var slides = slider.a;
			return $elm$core$List$length(slides);
		case 1:
			var slides = slider.a;
			return $elm$core$List$length(slides);
		case 2:
			var slides = slider.a;
			return $elm$core$List$length(slides);
		case 3:
			var slides = slider.a;
			return $elm$core$List$length(slides);
		case 5:
			var slides = slider.a;
			return $elm$core$List$length(
				$author$project$Util$Html$parseOnly(slides));
		default:
			var slides = slider.a;
			return $elm$core$List$length(slides);
	}
};
var $author$project$Slider$allowInfinitySlider = F3(
	function (infinity, slider, sliderType) {
		return infinity && (_Utils_cmp(
			$author$project$Slider$getSliderLength(slider),
			$author$project$Slider$amountOfVisibleCards(sliderType)) > -1);
	});
var $author$project$Slider$init = function (flags) {
	return _Utils_Tuple2(
		{
			aB: $elm$core$Maybe$Nothing,
			bR: $elm$core$Maybe$Nothing,
			S: A3($author$project$Slider$allowInfinitySlider, flags.uT, flags.Mv, flags.MD) ? $elm$core$Maybe$Just(
				{
					G: $author$project$Slider$getSliderLength(flags.Mv),
					bB: true
				}) : $elm$core$Maybe$Nothing,
			G: 0,
			Mv: flags.Mv,
			MD: flags.MD,
			ca: 250,
			Q8: flags.Q8,
			ch: flags.ch
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Slider$OnBrowserResize = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$browser$Browser$Events$Window = 1;
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $author$project$Slider$subscriptions = function (_v0) {
	return $elm$browser$Browser$Events$onResize($author$project$Slider$OnBrowserResize);
};
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $author$project$Slider$SetOffset = function (a) {
	return {$: 0, a: a};
};
var $author$project$Slider$toInfinitySettings = F3(
	function (slider, offset, infinity) {
		return (_Utils_cmp(
			offset,
			$author$project$Slider$getSliderLength(slider)) > -1) ? _Utils_Tuple2(
			-1,
			$elm$core$Maybe$Just(
				_Utils_update(
					infinity,
					{bB: false}))) : ((offset < 0) ? _Utils_Tuple2(
			$author$project$Slider$getSliderLength(slider),
			$elm$core$Maybe$Just(
				_Utils_update(
					infinity,
					{bB: false}))) : _Utils_Tuple2(
			offset,
			$elm$core$Maybe$Just(
				_Utils_update(
					infinity,
					{bB: true}))));
	});
var $author$project$Slider$setOffset = F2(
	function (model, offset) {
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(offset, $elm$core$Maybe$Nothing),
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Slider$toInfinitySettings, model.Mv, offset),
				model.S));
		var newOffset = _v0.a;
		var newSettings = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{bR: $elm$core$Maybe$Nothing, S: newSettings, G: newOffset}),
			_Utils_eq(newOffset, -1) ? A2(
				$elm$core$Task$perform,
				function (_v1) {
					return $author$project$Slider$SetOffset(newOffset + 1);
				},
				$elm$core$Process$sleep(model.ca - 150)) : ((_Utils_eq(offset, -1) && _Utils_eq(
				newOffset,
				$author$project$Slider$getSliderLength(model.Mv))) ? A2(
				$elm$core$Task$perform,
				function (_v2) {
					return $author$project$Slider$SetOffset(newOffset - 1);
				},
				$elm$core$Process$sleep(model.ca - 150)) : $elm$core$Platform$Cmd$none));
	});
var $author$project$Slider$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var offset = msg.a;
				return A2($author$project$Slider$setOffset, model, offset);
			case 1:
				var coordinate = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aB: $elm$core$Maybe$Just(
								{Uu: coordinate, Nj: coordinate})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var coordinate = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aB: A2(
								$elm$core$Maybe$map,
								function (drag) {
									return _Utils_update(
										drag,
										{Uu: coordinate});
								},
								model.aB)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var drag = msg.a;
				var keepWithinBounds = A2(
					$elm$core$Basics$clamp,
					0,
					$author$project$Slider$getSliderLength(model.Mv) - 1);
				var _v1 = ($elm$core$Basics$abs(drag.Nj.m - drag.Uu.m) > 20) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : ((_Utils_cmp(drag.Nj.TM, drag.Uu.TM) < 0) ? A2($author$project$Slider$setOffset, model, model.G - 1) : A2($author$project$Slider$setOffset, model, model.G + 1));
				var newModel = _v1.a;
				var newCmd = _v1.b;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								G: keepWithinBounds(newModel.G)
							}),
						newCmd),
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							return _Utils_Tuple2(newModel, newCmd);
						},
						model.S));
			case 4:
				var w = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ch: w}),
					$elm$core$Platform$Cmd$none);
			default:
				var maybeIndex = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bR: maybeIndex}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Slider$isMobile = function (windowWidth) {
	return windowWidth < 992;
};
var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
	if (m.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Slider$toIcon = F2(
	function (useDifferentArrow, defaultPath) {
		return $author$project$View$Icon$viewColored(
			useDifferentArrow ? $author$project$View$Icon$path.h$ : defaultPath);
	});
var $author$project$Util$View$viewIf = F2(
	function (bool, html) {
		return bool ? html(0) : $elm$html$Html$text('');
	});
var $author$project$Slider$viewDot = F6(
	function (sliderType, infinitySettings, currentIndex, mobile, max, dotIndex) {
		var check = (mobile || $elm_community$maybe_extra$Maybe$Extra$isJust(infinitySettings)) ? (_Utils_cmp(dotIndex, max - 1) < 1) : ((_Utils_cmp(
			max,
			$author$project$Slider$amountOfVisibleCards(sliderType)) > 0) && (_Utils_cmp(
			dotIndex,
			max - $author$project$Slider$amountOfVisibleCards(sliderType)) < 1));
		return A2(
			$author$project$Util$View$viewIf,
			check,
			function (_v0) {
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Slider$SetOffset(dotIndex)),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('dot', true),
									_Utils_Tuple2(
									'active',
									_Utils_eq(
										dotIndex,
										$elm$core$Basics$abs(currentIndex)))
								]))
						]),
					_List_Nil);
			});
	});
var $author$project$Util$View$viewIfNot = F2(
	function (bool, html) {
		return (!bool) ? html(0) : $elm$html$Html$text('');
	});
var $author$project$Slider$viewControls = F6(
	function (useDifferentArrow, sliderType, slideLength, currentIndex, infinitySettings, mobile) {
		var mobileArrows = mobile ? 1 : $author$project$Slider$amountOfVisibleCards(sliderType);
		var isInactive = _Utils_eq(currentIndex, slideLength - mobileArrows) && (!$elm_community$maybe_extra$Maybe$Extra$isJust(infinitySettings));
		var condition = A2(
			$elm$core$List$member,
			true,
			_List_fromArray(
				[
					(_Utils_cmp(
					slideLength,
					$author$project$Slider$amountOfVisibleCards(sliderType)) < 1) && ($elm_community$maybe_extra$Maybe$Extra$isNothing(infinitySettings) && (!mobile)),
					_Utils_cmp(
					slideLength,
					$author$project$Slider$amountOfVisibleCards(sliderType)) < 0
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('controller show')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('slider-control-buttons')
						]),
					A2(
						$elm$core$List$map,
						A5($author$project$Slider$viewDot, sliderType, infinitySettings, currentIndex, mobile, slideLength),
						A2($elm$core$List$range, 0, slideLength))),
					A2(
					$author$project$Util$View$viewIfNot,
					condition,
					function (_v0) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slider-arrows')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$Slider$SetOffset(currentIndex - 1)),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('slider-arrow', true),
													_Utils_Tuple2('slider-arrow-left', true),
													_Utils_Tuple2(
													'inactive',
													(!currentIndex) && (!$elm_community$maybe_extra$Maybe$Extra$isJust(infinitySettings)))
												]))
										]),
									_List_fromArray(
										[
											A2($author$project$Slider$toIcon, useDifferentArrow, $author$project$View$Icon$path.Mw)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$Slider$SetOffset(currentIndex + 1)),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('slider-arrow', true),
													_Utils_Tuple2('slider-arrow-right', true),
													_Utils_Tuple2('inactive', isInactive)
												]))
										]),
									_List_fromArray(
										[
											A2($author$project$Slider$toIcon, useDifferentArrow, $author$project$View$Icon$path.Mw)
										]))
								]));
					})
				]));
	});
var $author$project$Slider$OnDragAt = function (a) {
	return {$: 2, a: a};
};
var $author$project$Slider$OnDragEnd = function (a) {
	return {$: 3, a: a};
};
var $author$project$Slider$OnDragStart = function (a) {
	return {$: 1, a: a};
};
var $author$project$Slider$Coordinate = F2(
	function (x, y) {
		return {TM: x, m: y};
	});
var $author$project$Slider$decodeCoordinate = function () {
	var decoder = A3(
		$elm$json$Json$Decode$map2,
		$author$project$Slider$Coordinate,
		A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$float),
		A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$float));
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				decoder,
				A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['touches', '0']),
				decoder)
			]));
}();
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Slider$sliderTypeToClass = function (sliderType) {
	switch (sliderType) {
		case 0:
			return 'one';
		case 1:
			return 'twos';
		case 2:
			return 'thirds';
		case 3:
			return 'fours';
		default:
			return 'fives';
	}
};
var $author$project$Slider$transform = F4(
	function (sliderType, offset, infinitySettings, windowWidth) {
		var infinityOffset = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.G;
				},
				infinitySettings));
		var offset_ = offset + infinityOffset;
		var amountOfVisibleCards_ = $author$project$Slider$amountOfVisibleCards(sliderType);
		var calculate = $author$project$Slider$isMobile(windowWidth) ? (100 * offset_) : ((100 / amountOfVisibleCards_) * offset_);
		return A2(
			$elm$html$Html$Attributes$style,
			'transform',
			A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'translateX({0}%)',
				_List_fromArray(
					[
						$elm$core$String$fromFloat(-calculate)
					])));
	});
var $author$project$Slider$transition = F2(
	function (transitionSpeed, infinitySettings) {
		var needsTransition = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.bB;
				},
				infinitySettings));
		return needsTransition ? A2(
			$elm$html$Html$Attributes$style,
			'transition',
			A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'{0}ms ease-in-out',
				_List_fromArray(
					[
						$elm$core$String$fromFloat(transitionSpeed)
					]))) : A2($elm$html$Html$Attributes$style, '', '');
	});
var $author$project$Data$Link$toLink = F2(
	function (text, href) {
		return {Y: 3, Ud: '', uh: href, W: 1, OS: '', O1: text};
	});
var $author$project$Util$Regex$replace = F3(
	function (userRegex, replacer, string) {
		var _v0 = $elm$regex$Regex$fromString(userRegex);
		if (_v0.$ === 1) {
			return string;
		} else {
			var regex = _v0.a;
			return A3($elm$regex$Regex$replace, regex, replacer, string);
		}
	});
var $author$project$Util$Regex$replaceNewLine = function (text) {
	return A3(
		$author$project$Util$Regex$replace,
		'(\u000D\n|\u000D|\n)',
		function (_v0) {
			return '<br />';
		},
		text);
};
var $author$project$Util$Html$parse = function (content) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$elm$html$Html$text(content)
			]),
		A2(
			$elm$core$Result$map,
			function (x) {
				return $hecrj$html_parser$Html$Parser$Util$toVirtualDom(x);
			},
			$hecrj$html_parser$Html$Parser$run(
				$author$project$Util$Regex$replaceNewLine(content))));
};
var $author$project$Util$Html$parseWithElement = F2(
	function (textValue, htmlEl) {
		return htmlEl(
			$author$project$Util$Html$parse(textValue));
	});
var $author$project$Slider$viewDescription = function (description) {
	return A2(
		$author$project$Util$Html$parseWithElement,
		description,
		$elm$html$Html$div(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text description text-align-left')
				])));
};
var $author$project$Slider$viewIfNotEmpty = F2(
	function (toView, value) {
		return A2(
			$author$project$Util$View$viewIfNot,
			$elm$core$String$isEmpty(value),
			function (_v0) {
				return toView(value);
			});
	});
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $author$project$Slider$viewImage = function (image) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('image image-align-center image-horizontal-align-fill')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('image-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src(image.dA),
								$elm$html$Html$Attributes$title(image.WC),
								$elm$html$Html$Attributes$alt(image.gC),
								A2($elm$html$Html$Attributes$attribute, 'aria-label', image.Ud)
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Slider$alignToClass = function (align) {
	switch (align) {
		case 0:
			return 'horizontal-align-left';
		case 1:
			return 'horizontal-align-center';
		case 2:
			return 'horizontal-align-right';
		default:
			return 'horizontal-align-fill';
	}
};
var $author$project$Slider$styleToClass = function (style) {
	switch (style) {
		case 0:
			return 'color-1';
		case 1:
			return 'color-2';
		case 2:
			return 'color-3';
		default:
			return 'color-4';
	}
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Slider$viewLink = F2(
	function (useDifferentArrow, link) {
		var linkValueEmpty = $elm$core$String$isEmpty(link.O1) && $elm$core$String$isEmpty(link.uh);
		return A2(
			$author$project$Util$View$viewIfNot,
			linkValueEmpty,
			function (_v0) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
								'link-group link-{0}',
								_List_fromArray(
									[
										$author$project$Slider$alignToClass(link.Y)
									])))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(
									A2(
										$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
										'link {0}',
										_List_fromArray(
											[
												$author$project$Slider$styleToClass(link.W)
											]))),
									$elm$html$Html$Attributes$href(link.uh),
									$elm$html$Html$Attributes$target(link.OS)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(link.O1)
										])),
									A2($author$project$Slider$toIcon, useDifferentArrow, $author$project$View$Icon$path.Ue)
								]))
						]));
			});
	});
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $author$project$Slider$viewTitle = function (title) {
	return A2(
		$author$project$Util$Html$parseWithElement,
		title,
		$elm$html$Html$h3(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('title')
				])));
};
var $author$project$Slider$viewApplicantJourneySlide = F2(
	function (useDifferentArrow, slide) {
		return $elm$core$String$isEmpty(slide.xv) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('slide-item')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('slide-item-card')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Slider$viewIfNotEmpty,
							function (_v0) {
								return $author$project$Slider$viewImage(slide.ux);
							},
							slide.ux.dA),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slide-item-body')
								]),
							_List_fromArray(
								[
									A2($author$project$Slider$viewIfNotEmpty, $author$project$Slider$viewTitle, slide.WC),
									A2($author$project$Slider$viewIfNotEmpty, $author$project$Slider$viewDescription, slide.cD)
								]))
						]))
				])) : A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(slide.xv),
					$elm$html$Html$Attributes$class('slide-item')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('slide-item-card')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Slider$viewIfNotEmpty,
							function (_v1) {
								return $author$project$Slider$viewImage(slide.ux);
							},
							slide.ux.dA),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slide-item-body')
								]),
							_List_fromArray(
								[
									A2($author$project$Slider$viewIfNotEmpty, $author$project$Slider$viewTitle, slide.WC),
									A2($author$project$Slider$viewIfNotEmpty, $author$project$Slider$viewDescription, slide.cD),
									A2(
									$author$project$Slider$viewLink,
									useDifferentArrow,
									A2($author$project$Data$Link$toLink, slide.m8, slide.xv))
								]))
						]))
				]));
	});
var $author$project$Slider$Hovering = function (a) {
	return {$: 5, a: a};
};
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Slider$toVideoSource = F2(
	function (mPoster, src) {
		var _v0 = _Utils_Tuple2(mPoster, src);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (_v0.b.$ === 2) {
					var source = _v0.b.a;
					return source;
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b.$ === 2) {
					var _v1 = _v0.a;
					var source = _v0.b.a;
					return A2(
						$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
						'{0}#t=0.1',
						_List_fromArray(
							[source]));
				} else {
					break _v0$2;
				}
			}
		}
		return '';
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$autoplay = $elm$html$Html$Attributes$boolProperty('autoplay');
var $elm$html$Html$Attributes$loop = $elm$html$Html$Attributes$boolProperty('loop');
var $elm$html$Html$Attributes$poster = $elm$html$Html$Attributes$stringProperty('poster');
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $elm$html$Html$video = _VirtualDom_node('video');
var $author$project$Slider$viewVideo = function (_v0) {
	var source = _v0.M0;
	var poster = _v0.b0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('video video-align-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('video-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$video,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$autoplay(true),
								A2(
								$elm$html$Html$Attributes$property,
								'muted',
								$elm$json$Json$Encode$bool(true)),
								$elm$html$Html$Attributes$src(
								A2($author$project$Slider$toVideoSource, poster, source)),
								$elm$html$Html$Attributes$loop(true),
								$elm$html$Html$Attributes$poster(
								A2($elm$core$Maybe$withDefault, '', poster))
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Slider$viewApplicantJourneyWithHoverSlide = F6(
	function (offset, sliderType, useDifferentArrow, currentlyHovering, index, slide) {
		var nonEmptyVideo = !$elm$core$String$isEmpty(
			A2($author$project$Slider$toVideoSource, $elm$core$Maybe$Nothing, slide.ud.M0));
		var isVisible = (_Utils_cmp(index, offset) > -1) && (_Utils_cmp(
			index,
			(offset + $author$project$Slider$amountOfVisibleCards(sliderType)) - 1) < 1);
		var isHoveringCurrent = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (hoverIndex) {
					return _Utils_eq(hoverIndex, index);
				},
				currentlyHovering));
		var video = A2(
			$author$project$Util$View$viewIf,
			isHoveringCurrent && nonEmptyVideo,
			function (_v1) {
				return $author$project$Slider$viewVideo(slide.ud);
			});
		var image = A2(
			$author$project$Slider$viewIfNotEmpty,
			function (_v0) {
				return $author$project$Slider$viewImage(slide.ux);
			},
			slide.ux.dA);
		var generalAttributes = _List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('slide-item', true),
						_Utils_Tuple2('visible', isVisible),
						_Utils_Tuple2(
						'hovering',
						$elm_community$maybe_extra$Maybe$Extra$isJust(currentlyHovering) && (isHoveringCurrent && isVisible)),
						_Utils_Tuple2(
						'not-hovering',
						$elm_community$maybe_extra$Maybe$Extra$isJust(currentlyHovering) && ((!isHoveringCurrent) && isVisible))
					])),
				$elm$html$Html$Events$onMouseEnter(
				$author$project$Slider$Hovering(
					$elm$core$Maybe$Just(index))),
				$elm$html$Html$Events$onMouseLeave(
				$author$project$Slider$Hovering($elm$core$Maybe$Nothing))
			]);
		return $elm$core$String$isEmpty(slide.xv) ? A2(
			$elm$html$Html$div,
			generalAttributes,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('slide-item-card')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slide-item-media')
								]),
							_List_fromArray(
								[video, image])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slide-item-body')
								]),
							_List_fromArray(
								[
									A2($author$project$Slider$viewIfNotEmpty, $author$project$Slider$viewTitle, slide.WC),
									A2($author$project$Slider$viewIfNotEmpty, $author$project$Slider$viewDescription, slide.cD)
								]))
						]))
				])) : A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$href(slide.xv),
				generalAttributes),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('slide-item-card')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slide-item-media')
								]),
							_List_fromArray(
								[video, image])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slide-item-body')
								]),
							_List_fromArray(
								[
									A2($author$project$Slider$viewIfNotEmpty, $author$project$Slider$viewTitle, slide.WC),
									A2($author$project$Slider$viewIfNotEmpty, $author$project$Slider$viewDescription, slide.cD),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('link-group')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href(slide.xv),
													$elm$html$Html$Attributes$class('link color-2')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(slide.m8)
												])),
											A2($author$project$Slider$toIcon, useDifferentArrow, $author$project$View$Icon$path.Ue)
										]))
								]))
						]))
				]));
	});
var $author$project$Slider$offsetHelper = F3(
	function (lst, elem, defaultOffset) {
		offsetHelper:
		while (true) {
			if (!lst.b) {
				return -1;
			} else {
				var _v1 = lst.a;
				var index = _v1.a;
				var x = _v1.b;
				var xs = lst.b;
				if (_Utils_eq(x, elem)) {
					return index;
				} else {
					var $temp$lst = xs,
						$temp$elem = elem,
						$temp$defaultOffset = defaultOffset + 1;
					lst = $temp$lst;
					elem = $temp$elem;
					defaultOffset = $temp$defaultOffset;
					continue offsetHelper;
				}
			}
		}
	});
var $author$project$Slider$indexOf = F2(
	function (lst, element) {
		return A3($author$project$Slider$offsetHelper, lst, element, 0);
	});
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Data$MimeType$imageFileExtensions = $elm$core$Set$fromList(
	_List_fromArray(
		['gif', 'heic', 'heif', 'jfi', 'jfif', 'jif', 'jpe', 'jpeg', 'jpg', 'png', 'webp']));
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$MimeType$toFileExtension = A2(
	$elm$core$Basics$composeL,
	A2(
		$elm$core$Basics$composeL,
		A2($elm$core$Basics$composeL, $elm$core$List$head, $elm$core$List$reverse),
		$elm$core$String$split('.')),
	$elm$core$String$toLower);
var $author$project$Data$MimeType$isImage = function (mediaItem) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (extension) {
				return A2($elm$core$Set$member, extension, $author$project$Data$MimeType$imageFileExtensions);
			},
			$author$project$Data$MimeType$toFileExtension(mediaItem)));
};
var $author$project$Data$MimeType$svgXmlFileExtensions = $elm$core$Set$fromList(
	_List_fromArray(
		['svg']));
var $author$project$Data$MimeType$isSvg = function (mediaItem) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (extension) {
				return A2($elm$core$Set$member, extension, $author$project$Data$MimeType$svgXmlFileExtensions);
			},
			$author$project$Data$MimeType$toFileExtension(mediaItem)));
};
var $author$project$Slider$viewIcon = F3(
	function (stepIcon, offset, maskColor) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('slide-icon')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('slide-offset')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slide-step')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Copy$copy.eX)
								])),
							$elm$html$Html$text(
							$elm$core$String$fromInt(offset + 1))
						])),
					A2($author$project$View$Icon$viewMasked, maskColor, stepIcon)
				]));
	});
var $author$project$Slider$viewApplicationProcedureSlide = F4(
	function (mInfintiySettings, slides, index, slide) {
		var toOffset = A2(
			$elm$core$Maybe$withDefault,
			index,
			A2(
				$elm$core$Maybe$map,
				function (_v2) {
					return A2($author$project$Slider$indexOf, slides, slide);
				},
				mInfintiySettings));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('slide-item', true),
							_Utils_Tuple2(
							'with-image',
							$author$project$Data$MimeType$isImage(slide.aH))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('slide-item-card')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Util$View$viewIf,
							$author$project$Data$MimeType$isImage(slide.aH),
							function (_v0) {
								return $author$project$Slider$viewImage(
									{Y: 3, gC: slide.aH, Ud: '', tZ: 3, dA: slide.aH, WC: slide.aH, dK: ''});
							}),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slide-item-body')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Util$View$viewIf,
									$author$project$Data$MimeType$isSvg(slide.aH),
									function (_v1) {
										return A3($author$project$Slider$viewIcon, slide.aH, toOffset, slide.yB);
									}),
									$author$project$Slider$viewTitle(slide.WC),
									$author$project$Slider$viewDescription(slide.cD)
								]))
						]))
				]));
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Data$Content$View$allowEmpty = F3(
	function (config, val, f) {
		return config.gx ? f : A2(
			$author$project$Util$View$viewIfNot,
			val,
			$elm$core$Basics$always(f));
	});
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $author$project$Data$TextAlign$toClass = function (align) {
	switch (align) {
		case 0:
			return 'text-align-left';
		case 1:
			return 'text-align-center';
		case 2:
			return 'text-align-right';
		default:
			return 'text-align-justify';
	}
};
var $author$project$Data$TextColor$toClass = function (textColor) {
	switch (textColor) {
		case 0:
			return '';
		case 2:
			return 'text-dark';
		default:
			return 'text-white';
	}
};
var $author$project$Data$Content$View$viewHeading = F2(
	function (config, content) {
		var _v0 = function () {
			var _v1 = content.dz;
			switch (_v1) {
				case 1:
					return _Utils_Tuple2($elm$html$Html$h1, 'heading-one');
				case 2:
					return _Utils_Tuple2($elm$html$Html$h2, 'heading-two');
				case 3:
					return _Utils_Tuple2($elm$html$Html$h3, 'heading-three');
				case 4:
					return _Utils_Tuple2($elm$html$Html$h4, 'heading-four');
				default:
					return _Utils_Tuple2($elm$html$Html$h3, 'heading-three');
			}
		}();
		var elem = _v0.a;
		var class_ = _v0.b;
		var classes = A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'heading {0} {1} {2}',
			_List_fromArray(
				[
					$author$project$Data$TextColor$toClass(content.lK),
					$author$project$Data$TextAlign$toClass(content.Y),
					class_
				]));
		return A3(
			$author$project$Data$Content$View$allowEmpty,
			config,
			$elm$core$String$isEmpty(content.O1),
			A2(
				$author$project$Util$Html$parseWithElement,
				content.O1,
				elem(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(classes)
						]))));
	});
var $author$project$Data$Content$View$viewPlainText = F2(
	function (config, content) {
		return A3(
			$author$project$Data$Content$View$allowEmpty,
			config,
			$elm$core$String$isEmpty(content.O1),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2(
							$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
							'text {0} {1}',
							_List_fromArray(
								[
									$author$project$Data$TextAlign$toClass(content.Y),
									$author$project$Data$TextColor$toClass(content.lK)
								])))
					]),
				$author$project$Util$Html$parse(content.O1)));
	});
var $author$project$Slider$viewCard = F2(
	function (useDifferentArrow, card) {
		var values = _List_fromArray(
			[card.tA.O1, card.E9.O1, card.xz.O1]);
		var showBody = A2(
			$elm$core$List$all,
			$elm$core$Basics$identity,
			A2($elm$core$List$map, $elm$core$String$isEmpty, values));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('slide-item')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Slider$viewIfNotEmpty,
							function (_v0) {
								return $author$project$Slider$viewImage(card.ux);
							},
							card.ux.dA),
							A2(
							$author$project$Util$View$viewIfNot,
							showBody,
							function (_v1) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-body')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Data$Content$View$viewHeading,
											{gx: false, Q9: false},
											card.tA),
											A2(
											$author$project$Data$Content$View$viewPlainText,
											{gx: false, Q9: false},
											card.E9),
											A2(
											$author$project$Util$View$viewIfNot,
											$elm$core$String$isEmpty(card.xz.O1),
											function (_v2) {
												return A2($author$project$Slider$viewLink, useDifferentArrow, card.xz);
											})
										]));
							})
						]))
				]));
	});
var $author$project$Data$Align$verticalAlignToClass = function (align) {
	switch (align) {
		case 2:
			return 'vertical-align-top';
		case 1:
			return 'vertical-align-center';
		case 0:
			return 'vertical-align-bottom';
		default:
			return 'vertical-align-fill';
	}
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Data$Content$View$viewHeadingSimple = F3(
	function (config, size, text) {
		return A2(
			$author$project$Data$Content$View$viewHeading,
			config,
			{Y: 0, lK: 2, dz: size, O1: text});
	});
var $author$project$Data$Align$horizontalAlignToClass = function (align) {
	switch (align) {
		case 0:
			return 'horizontal-align-left';
		case 1:
			return 'horizontal-align-center';
		case 2:
			return 'horizontal-align-right';
		default:
			return 'horizontal-align-fill';
	}
};
var $author$project$Data$Content$View$viewImageHtml = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'image image-{0} image-{1}',
					_List_fromArray(
						[
							$author$project$Data$Align$verticalAlignToClass(content.Y),
							$author$project$Data$Align$horizontalAlignToClass(content.tZ)
						])))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('image-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src(content.dA)
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Data$Content$View$viewImage = F2(
	function (config, content) {
		return A3(
			$author$project$Data$Content$View$allowEmpty,
			config,
			$elm$core$String$isEmpty(content.dA),
			$elm$core$String$isEmpty(content.dK) ? $author$project$Data$Content$View$viewImageHtml(content) : A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('image-link'),
						$elm$html$Html$Attributes$href(content.dK)
					]),
				_List_fromArray(
					[
						$author$project$Data$Content$View$viewImageHtml(content)
					])));
	});
var $author$project$Data$Content$View$viewApplicantJourney = F2(
	function (config, content) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Data$Content$View$viewImage, config, content.ux),
					A3($author$project$Data$Content$View$viewHeadingSimple, config, 3, content.WC),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(content.cD)
						])),
					$elm$html$Html$text(content.m8)
				]));
	});
var $author$project$Data$Content$View$viewApplicantJourneyWithHover = F2(
	function (config, content) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Data$Content$View$viewImage, config, content.ux),
					A3($author$project$Data$Content$View$viewHeadingSimple, config, 3, content.WC),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(content.cD)
						])),
					$elm$html$Html$text(content.m8)
				]));
	});
var $author$project$Data$Button$toClass = function (style) {
	switch (style) {
		case 0:
			return 'bg-color-1';
		case 1:
			return 'bg-color-2';
		case 2:
			return 'bg-color-3';
		default:
			return 'bg-color-4';
	}
};
var $author$project$Data$Content$View$viewButton = function (content) {
	return A2(
		$author$project$Util$View$viewIfNot,
		$elm$core$String$isEmpty(content.O1),
		function (_v0) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2(
							$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
							'btn-group btn-{0}',
							_List_fromArray(
								[
									$author$project$Data$Align$horizontalAlignToClass(content.Y)
								])))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(content.uh),
								$elm$html$Html$Attributes$class(
								A2(
									$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
									'btn color-white {0}',
									_List_fromArray(
										[
											$author$project$Data$Button$toClass(content.W)
										])))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(content.O1)
							]))
					]));
		});
};
var $author$project$Data$Content$View$viewIntroText = F2(
	function (config, content) {
		return A3(
			$author$project$Data$Content$View$allowEmpty,
			config,
			$elm$core$String$isEmpty(content.O1),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2(
							$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
							'intro {0}',
							_List_fromArray(
								[
									$author$project$Data$TextAlign$toClass(content.Y)
								])))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(
								A2(
									$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
									'text {0}',
									_List_fromArray(
										[
											$author$project$Data$TextColor$toClass(content.lK)
										])))
							]),
						$author$project$Util$Html$parse(content.O1))
					])));
	});
var $author$project$Data$Link$toClass = function (style) {
	switch (style) {
		case 0:
			return 'color-1';
		case 1:
			return 'color-2';
		case 2:
			return 'color-3';
		default:
			return 'color-4';
	}
};
var $author$project$Data$Link$toMaskColor = function (style) {
	switch (style) {
		case 0:
			return 2;
		case 1:
			return 3;
		case 2:
			return 1;
		default:
			return 1;
	}
};
var $author$project$Data$Content$View$viewLink = function (content) {
	return A2(
		$author$project$Util$View$viewIfNot,
		$elm$core$String$isEmpty(content.O1),
		function (_v0) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2(
							$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
							'link-group link-{0}',
							_List_fromArray(
								[
									$author$project$Data$Align$horizontalAlignToClass(content.Y)
								])))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(content.uh),
								$elm$html$Html$Attributes$target(content.OS),
								$elm$html$Html$Attributes$class(
								A2(
									$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
									'link {0}',
									_List_fromArray(
										[
											$author$project$Data$Link$toClass(content.W)
										])))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(content.O1)
									])),
								A2(
								$author$project$View$Icon$viewMasked,
								$author$project$Data$Link$toMaskColor(content.W),
								$author$project$View$Icon$path.Ue)
							]))
					]));
		});
};
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $author$project$Data$Content$View$viewOrderedListItems = function (content) {
	return A2(
		$elm$html$Html$ol,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list list-ordered')
			]),
		A2(
			$elm$core$List$map,
			function (item) {
				return A2(
					$elm$html$Html$li,
					_List_Nil,
					$author$project$Util$Html$parse(item));
			},
			content.v0));
};
var $author$project$Data$Content$View$viewResponsiveImage = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(content.ou)
					]),
				_List_Nil)
			]));
};
var $author$project$Data$Size$toStyle = function (size) {
	switch (size.$) {
		case 0:
			return _Utils_Tuple2('sm', '');
		case 1:
			return _Utils_Tuple2('md', '');
		case 2:
			return _Utils_Tuple2('lg', '');
		case 3:
			return _Utils_Tuple2('xl', '');
		default:
			var sizeValue = size.a;
			return _Utils_Tuple2(
				'custom',
				$elm$core$String$fromInt(sizeValue));
	}
};
var $author$project$Data$Content$View$viewSpacer = function (content) {
	var _v0 = $author$project$Data$Size$toStyle(content.dz);
	var size_ = _v0.a;
	var style_ = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'spacer spacer-size-{0}',
					_List_fromArray(
						[size_]))),
				A2(
				$elm$html$Html$Attributes$style,
				'height',
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0}px',
					_List_fromArray(
						[style_])))
			]),
		_List_Nil);
};
var $author$project$Data$Content$View$viewUnOrderedListItems = function (content) {
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list list-unordered')
			]),
		A2(
			$elm$core$List$map,
			function (item) {
				return A2(
					$elm$html$Html$li,
					_List_Nil,
					$author$project$Util$Html$parse(item));
			},
			content.v0));
};
var $author$project$Data$Content$View$viewUsp = F2(
	function (config, content) {
		var el = $elm$core$String$isEmpty(content.dK) ? $elm$html$Html$div(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('usp')
				])) : $elm$html$Html$a(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('usp'),
					$elm$html$Html$Attributes$href(content.dK)
				]));
		return el(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('usp-aside')
						]),
					_List_fromArray(
						[
							$author$project$Data$Content$View$viewImageHtml(
							{Y: 2, gC: content.gC, Ud: '', tZ: 3, dA: content.dA, WC: content.WC, dK: ''})
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('usp-body')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Data$Content$View$allowEmpty,
							config,
							$elm$core$String$isEmpty(content.O1),
							A2(
								$author$project$Data$Content$View$viewHeading,
								config,
								{Y: 0, lK: 0, dz: 3, O1: content.O1})),
							A3(
							$author$project$Data$Content$View$allowEmpty,
							config,
							$elm$core$String$isEmpty(content.cD),
							A2(
								$author$project$Data$Content$View$viewPlainText,
								config,
								{Y: 0, lK: 0, O1: content.cD}))
						]))
				]));
	});
var $author$project$Data$AspectRatio$toClass = function (aspectRatio) {
	switch (aspectRatio) {
		case 3:
			return '';
		case 1:
			return 'aspect-9-16';
		case 2:
			return 'aspect-4-3';
		default:
			return 'aspect-16-9';
	}
};
var $elm$html$Html$Attributes$controls = $elm$html$Html$Attributes$boolProperty('controls');
var $elm$html$Html$iframe = _VirtualDom_node('iframe');
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $elm$html$Html$Attributes$srcdoc = $elm$html$Html$Attributes$stringProperty('srcdoc');
var $author$project$Data$Content$View$toVideoSource = F3(
	function (mPoster, source, autoPlay) {
		var autoplayParams = autoPlay ? '?autoplay=1&muted=1&mute=1' : '';
		var _v0 = _Utils_Tuple2(mPoster, source);
		switch (_v0.b.$) {
			case 2:
				if (!_v0.a.$) {
					var src = _v0.b.a;
					return src;
				} else {
					var _v1 = _v0.a;
					var src = _v0.b.a;
					return A2(
						$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
						'{0}#t=0.1',
						_List_fromArray(
							[src]));
				}
			case 0:
				var youtubeId = _v0.b.a;
				return A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'https://www.youtube-nocookie.com/embed/{0}{1}',
					_List_fromArray(
						[youtubeId, autoplayParams]));
			default:
				var vimeoId = _v0.b.a;
				return A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'https://player.vimeo.com/video/{0}{1}',
					_List_fromArray(
						[vimeoId, autoplayParams]));
		}
	});
var $author$project$Data$Content$View$viewSrcDoc = F3(
	function (source, autoPlay, poster) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'\n        <style>\n          * { padding:0; margin:0; overflow:hidden }\n          html,body{height:100% }\n          img, span { position:absolute; width:100%; height: 100%; top:0; bottom:0; margin:auto; object-fit: cover;}\n          span{ height:1.5em; text-align:center; font:48px/1.5 sans-serif; color:white; text-shadow:0 0 0.5em black }\n        </style>\n        <a href="{0}?autoplay=1&muted=1&mute=1"><img src="{1}"><span>▶</span></a>\n        ',
			_List_fromArray(
				[
					A3(
					$author$project$Data$Content$View$toVideoSource,
					$elm$core$Maybe$Just(poster),
					source,
					autoPlay),
					poster
				]));
	});
var $author$project$Data$Content$View$toVideoHtml = function (props) {
	var toSrcDoc = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $elm$core$List$singleton, $elm$html$Html$Attributes$srcdoc),
				A2($author$project$Data$Content$View$viewSrcDoc, props.M0, props.iq)),
			props.b0));
	var toAutoplayProps = props.iq ? _List_fromArray(
		[
			$elm$html$Html$Attributes$autoplay(true),
			A2(
			$elm$html$Html$Attributes$property,
			'muted',
			$elm$json$Json$Encode$bool(true)),
			$elm$html$Html$Attributes$loop(true)
		]) : _List_Nil;
	var _v0 = props.M0;
	switch (_v0.$) {
		case 2:
			return A2(
				$elm$html$Html$video,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(
							A3($author$project$Data$Content$View$toVideoSource, props.b0, props.M0, props.iq)),
							$elm$html$Html$Attributes$controls(true),
							$elm$html$Html$Attributes$poster(
							A2($elm$core$Maybe$withDefault, '', props.b0))
						]),
					toAutoplayProps),
				_List_Nil);
		case 0:
			return A2(
				$elm$html$Html$iframe,
				_Utils_ap(
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'frameborder', '0'),
							A2($elm$html$Html$Attributes$attribute, 'allowfullscreen', 'true'),
							$elm$html$Html$Attributes$src(
							A3($author$project$Data$Content$View$toVideoSource, props.b0, props.M0, props.iq))
						]),
					toSrcDoc),
				_List_Nil);
		default:
			return A2(
				$elm$html$Html$iframe,
				_Utils_ap(
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'frameborder', '0'),
							A2($elm$html$Html$Attributes$attribute, 'allowfullscreen', 'true'),
							$elm$html$Html$Attributes$src(
							A3($author$project$Data$Content$View$toVideoSource, props.b0, props.M0, props.iq))
						]),
					toSrcDoc),
				_List_Nil);
	}
};
var $author$project$Data$Content$View$viewVideoHtml = function (video_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'video {0}',
					_List_fromArray(
						[
							$author$project$Data$AspectRatio$toClass(video_.Uf)
						])))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('video-wrapper')
					]),
				_List_fromArray(
					[
						$author$project$Data$Content$View$toVideoHtml(video_)
					]))
			]));
};
var $author$project$Data$Content$View$viewVideoPlaceholder = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src('/static/images/video-placeholder.png')
				]),
			_List_Nil)
		]));
var $author$project$Data$Content$View$viewVideo = F2(
	function (config, video) {
		return config.Q9 ? $author$project$Data$Content$View$viewVideoPlaceholder : $author$project$Data$Content$View$viewVideoHtml(video);
	});
var $author$project$Data$Content$View$view = F2(
	function (config, content) {
		switch (content.$) {
			case 0:
				return $elm$html$Html$text('');
			case 1:
				var applicantJourney = content.a;
				return A2($author$project$Data$Content$View$viewApplicantJourney, config, applicantJourney);
			case 2:
				var applicantJourneyWithHover = content.a;
				return A2($author$project$Data$Content$View$viewApplicantJourneyWithHover, config, applicantJourneyWithHover);
			case 3:
				var button = content.a;
				return $author$project$Data$Content$View$viewButton(button);
			case 4:
				var heading = content.a;
				return A2($author$project$Data$Content$View$viewHeading, config, heading);
			case 5:
				var image = content.a;
				return A2($author$project$Data$Content$View$viewImage, config, image);
			case 6:
				var introText = content.a;
				return A2($author$project$Data$Content$View$viewIntroText, config, introText);
			case 7:
				var link = content.a;
				return $author$project$Data$Content$View$viewLink(link);
			case 8:
				var list = content.a;
				return $author$project$Data$Content$View$viewOrderedListItems(list);
			case 9:
				var plainText = content.a;
				return A2($author$project$Data$Content$View$viewPlainText, config, plainText);
			case 10:
				var responsiveImage = content.a;
				return $author$project$Data$Content$View$viewResponsiveImage(responsiveImage);
			case 11:
				var spacer = content.a;
				return $author$project$Data$Content$View$viewSpacer(spacer);
			case 12:
				var usp = content.a;
				return A2($author$project$Data$Content$View$viewUsp, config, usp);
			case 13:
				var list = content.a;
				return $author$project$Data$Content$View$viewUnOrderedListItems(list);
			default:
				var video = content.a;
				return A2($author$project$Data$Content$View$viewVideo, config, video);
		}
	});
var $author$project$Slider$viewContentGroup = function (contentGroup) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('slide-item')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('group', true),
								_Utils_Tuple2('full-width', contentGroup.yQ),
								_Utils_Tuple2(
								A2(
									$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
									'group-{0}',
									_List_fromArray(
										[
											$author$project$Data$Align$verticalAlignToClass(contentGroup.Y)
										])),
								true)
							]))
					]),
				A2(
					$elm$core$List$map,
					$author$project$Data$Content$View$view(
						{gx: false, Q9: false}),
					contentGroup.cv))
			]));
};
var $author$project$Slider$viewSlider = function (model) {
	var toSlider = function (slides) {
		return A2(
			$elm$core$Maybe$withDefault,
			slides,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always(
					$elm$core$List$concat(
						A2($elm$core$List$repeat, 3, slides))),
				model.S));
	};
	var dragEndEvents = function () {
		var _v1 = model.aB;
		if (_v1.$ === 1) {
			return _List_Nil;
		} else {
			var drag = _v1.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$Events$on,
					'touchend',
					$elm$json$Json$Decode$succeed(
						$author$project$Slider$OnDragEnd(drag))),
					A2(
					$elm$html$Html$Events$on,
					'touchcancel',
					$elm$json$Json$Decode$succeed(
						$author$project$Slider$OnDragEnd(drag)))
				]);
		}
	}();
	return A2(
		$elm$html$Html$div,
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2(
						$elm$html$Html$Events$on,
						'touchstart',
						A2($elm$json$Json$Decode$map, $author$project$Slider$OnDragStart, $author$project$Slider$decodeCoordinate)),
						A2(
						$elm$html$Html$Events$on,
						'touchmove',
						A2($elm$json$Json$Decode$map, $author$project$Slider$OnDragAt, $author$project$Slider$decodeCoordinate)),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('slider-container', true),
								_Utils_Tuple2(
								$author$project$Slider$sliderTypeToClass(model.MD),
								true)
							])),
						A4($author$project$Slider$transform, model.MD, model.G, model.S, model.ch),
						A2($author$project$Slider$transition, model.ca, model.S)
					]),
					dragEndEvents
				])),
		function () {
			var _v0 = model.Mv;
			switch (_v0.$) {
				case 0:
					var slides = _v0.a;
					return A2(
						$elm$core$List$map,
						$author$project$Slider$viewApplicantJourneySlide(model.Q8),
						toSlider(slides));
				case 1:
					var slides = _v0.a;
					return A2(
						$elm$core$List$indexedMap,
						A4($author$project$Slider$viewApplicantJourneyWithHoverSlide, model.G, model.MD, model.Q8, model.bR),
						toSlider(slides));
				case 2:
					var slides = _v0.a;
					return A2(
						$elm$core$List$indexedMap,
						A2(
							$author$project$Slider$viewApplicationProcedureSlide,
							model.S,
							A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, slides)),
						toSlider(slides));
				case 3:
					var slides = _v0.a;
					return A2(
						$elm$core$List$map,
						$author$project$Slider$viewCard(model.Q8),
						toSlider(slides));
				case 5:
					var slides = _v0.a;
					return toSlider(
						$author$project$Util$Html$parseOnly(slides));
				default:
					var slides = _v0.a;
					return A2(
						$elm$core$List$map,
						$author$project$Slider$viewContentGroup,
						toSlider(slides));
			}
		}());
};
var $author$project$Slider$viewStyleNoVerticalScroll = function (_v0) {
	var start = _v0.Nj;
	var current = _v0.Uu;
	return A2(
		$author$project$Util$View$viewIf,
		($elm$core$Basics$abs(start.m - current.m) < 20) && (!_Utils_eq(start.TM, current.TM)),
		function (_v1) {
			return A3(
				$elm$html$Html$node,
				'style',
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('body { overflow-y: hidden; }')
					]));
		});
};
var $author$project$Slider$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('slider-wrapper', true),
						_Utils_Tuple2(
						'infinity-slider',
						$elm_community$maybe_extra$Maybe$Extra$isJust(model.S))
					]))
			]),
		_List_fromArray(
			[
				A2($author$project$Util$View$viewMaybe, model.aB, $author$project$Slider$viewStyleNoVerticalScroll),
				$author$project$Slider$viewSlider(model),
				A6(
				$author$project$Slider$viewControls,
				model.Q8,
				model.MD,
				$author$project$Slider$getSliderLength(model.Mv),
				model.G,
				model.S,
				$author$project$Slider$isMobile(model.ch))
			]));
};
var $author$project$Slider$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$Model$Component$Slider$elmFlagsDecoder,
	{cR: $author$project$Slider$init, dC: $author$project$Slider$subscriptions, dJ: $author$project$Slider$update, dM: $author$project$Slider$view});
var $author$project$ShareToolForm$Flags = F3(
	function (tags, translations, currentLangCode) {
		return {a9: currentLangCode, OM: tags, P$: translations};
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Model$ShareToolTag$ShareToolTag = F6(
	function (label, itemIds, availableToEmployee, visibleOnSite, inserted, updated) {
		return {ix: availableToEmployee, u_: inserted, v$: itemIds, bj: label, QH: updated, S$: visibleOnSite};
	});
var $elm$parser$Parser$deadEndsToString = function (deadEnds) {
	return 'TODO deadEndsToString';
};
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.dA),
			s.G) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$core$Basics$round = _Basics_round;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$core$String$append = _String_append;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_v0.$ === 1) {
			var deadEnds = _v0.a;
			return $elm$json$Json$Decode$fail(
				$elm$parser$Parser$deadEndsToString(deadEnds));
		} else {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(time);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$ShareToolTag$shareToolTagDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'shareToolTagUpdated',
	$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'shareToolTagInserted',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'shareToolTagVisibleOnSite',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'shareToolTagAvailableToEmployee',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'shareToolTagItemIds',
					$elm$json$Json$Decode$list($author$project$Data$Id$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'shareToolTagLabel',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Model$ShareToolTag$ShareToolTag)))))));
var $author$project$Data$Translation$Translations = $elm$core$Basics$identity;
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$Data$Translation$translationsDecoder = A2(
	$elm$json$Json$Decode$field,
	'translations',
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$identity,
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)));
var $author$project$ShareToolForm$decodeFlags = A4(
	$elm$json$Json$Decode$map3,
	$author$project$ShareToolForm$Flags,
	A2(
		$elm$json$Json$Decode$field,
		'tags',
		$elm$json$Json$Decode$list(
			$author$project$Data$Entity$decoder($author$project$Model$ShareToolTag$shareToolTagDecoder))),
	$author$project$Data$Translation$translationsDecoder,
	A2($elm$json$Json$Decode$field, 'currentLangCode', $author$project$Model$LangCode$decoder));
var $author$project$ShareToolForm$initForm = {ki: '', l8: false, yZ: $elm$core$Maybe$Nothing, eZ: _List_Nil};
var $author$project$ShareToolForm$init = function (flags) {
	return _Utils_Tuple2(
		{
			a9: flags.a9,
			Z: _Utils_Tuple2($author$project$ShareToolForm$initForm, $elm$core$Maybe$Nothing),
			OM: flags.OM,
			P$: flags.P$,
			ce: $elm$core$Maybe$Nothing
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$ShareToolForm$GotProgress = function (a) {
	return {$: 7, a: a};
};
var $elm$http$Http$track = F2(
	function (tracker, toMsg) {
		return $elm$http$Http$subscription(
			A2($elm$http$Http$MySub, tracker, toMsg));
	});
var $author$project$ShareToolForm$subscriptions = function (_v0) {
	return A2($elm$http$Http$track, 'submit', $author$project$ShareToolForm$GotProgress);
};
var $author$project$ShareToolForm$GotCreateEmployeeContent = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$ShareToolForm$GotPreviews = function (a) {
	return {$: 2, a: a};
};
var $author$project$ShareToolForm$SelectFiles = {$: 3};
var $author$project$ShareToolForm$SelectedFiles = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Api$DecodeError = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$HttpError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$NetworkError = {$: 2};
var $author$project$Api$Timeout = {$: 1};
var $author$project$Api$ValidationDecodeError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$ValidationError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$ValidationResponse$ValidationResponse = F3(
	function (globalError, parseError, fieldError) {
		return {UY: fieldError, sI: globalError, Et: parseError};
	});
var $author$project$Api$ValidationResponse$validationResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'fieldError',
	$elm$json$Json$Decode$dict(
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'parseError',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'globalError',
			$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Api$ValidationResponse$ValidationResponse))));
var $author$project$Api$decodeValidationError = function (body) {
	var _v0 = A2($elm$json$Json$Decode$decodeString, $author$project$Api$ValidationResponse$validationResponseDecoder, body);
	if (!_v0.$) {
		var validationErrors = _v0.a;
		return $author$project$Api$ValidationError(validationErrors);
	} else {
		var err = _v0.a;
		return $author$project$Api$HttpError(
			$author$project$Api$ValidationDecodeError(
				$elm$json$Json$Decode$errorToString(err)));
	}
};
var $author$project$Api$expectResponse = F2(
	function (toMsg, parseString) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			function (response) {
				switch (response.$) {
					case 0:
						var url = response.a;
						return $elm$core$Result$Err(
							$author$project$Api$HttpError(
								$author$project$Api$BadUrl(url)));
					case 1:
						return $elm$core$Result$Err(
							$author$project$Api$HttpError($author$project$Api$Timeout));
					case 2:
						return $elm$core$Result$Err(
							$author$project$Api$HttpError($author$project$Api$NetworkError));
					case 3:
						var metadata = response.a;
						var body = response.b;
						var _v1 = metadata.Wm;
						if (_v1 === 400) {
							return $elm$core$Result$Err(
								$author$project$Api$decodeValidationError(body));
						} else {
							var statusCode = _v1;
							return $elm$core$Result$Err(
								$author$project$Api$HttpError(
									$author$project$Api$BadStatus(statusCode)));
						}
					default:
						var metadata = response.a;
						var body = response.b;
						return A2(parseString, metadata, body);
				}
			});
	});
var $author$project$Api$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$author$project$Api$expectResponse,
			toMsg,
			F2(
				function (_v0, body) {
					var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
					if (!_v1.$) {
						var value = _v1.a;
						return $elm$core$Result$Ok(value);
					} else {
						var err = _v1.a;
						return $elm$core$Result$Err(
							$author$project$Api$HttpError(
								$author$project$Api$DecodeError(
									$elm$json$Json$Decode$errorToString(err))));
					}
				}));
	});
var $elm$file$File$Select$files = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				var f = _v0.a;
				var fs = _v0.b;
				return A2(toMsg, f, fs);
			},
			_File_uploadOneOrMore(mimes));
	});
var $elm$http$Http$fractionSent = function (p) {
	return (!p.dz) ? 1 : A3($elm$core$Basics$clamp, 0, 1, p.K5 / p.dz);
};
var $author$project$Model$RedirectUrl$RedirectUrl = function (unRedirectUrl) {
	return {WP: unRedirectUrl};
};
var $author$project$Model$RedirectUrl$redirectUrlDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'unRedirectUrl',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Model$RedirectUrl$RedirectUrl));
var $elm$http$Http$filePart = _Http_pair;
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $elm$http$Http$stringPart = _Http_pair;
var $author$project$ShareToolForm$toMultiPartBody = function (form) {
	var toFilePart = function (mediaToUpload) {
		return A2($elm$http$Http$filePart, 'media', mediaToUpload.rp);
	};
	var tagsStringPart = $elm$core$List$map(
		A2(
			$elm$core$Basics$composeL,
			$elm$http$Http$stringPart('tagIds'),
			$author$project$Data$Id$toString));
	var fileParts = function (maybeFiles) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$map(toFilePart),
				maybeFiles));
	};
	return $elm$http$Http$multipartBody(
		A2(
			$elm$core$List$cons,
			A2($elm$http$Http$stringPart, 'caption', form.ki),
			_Utils_ap(
				tagsStringPart(form.eZ),
				fileParts(form.yZ))));
};
var $author$project$Data$MimeType$Audio = 4;
var $author$project$Data$MimeType$Image = 0;
var $author$project$Data$MimeType$Pdf = 1;
var $author$project$Data$MimeType$SvgXml = 3;
var $author$project$Data$MimeType$Video = 2;
var $author$project$Data$MimeType$fromBase64 = function (base64) {
	return A2($elm$core$String$startsWith, 'data:image/svg+xml', base64) ? $elm$core$Maybe$Just(3) : (A2($elm$core$String$startsWith, 'data:application/pdf', base64) ? $elm$core$Maybe$Just(1) : (A2($elm$core$String$startsWith, 'data:image/', base64) ? $elm$core$Maybe$Just(0) : (A2($elm$core$String$startsWith, 'data:video/', base64) ? $elm$core$Maybe$Just(2) : (A2($elm$core$String$startsWith, 'data:audio/', base64) ? $elm$core$Maybe$Just(4) : $elm$core$Maybe$Nothing))));
};
var $author$project$ShareToolForm$maxImageSize = _Utils_Tuple2(10000000, '10MB');
var $author$project$ShareToolForm$maxVideoSize = _Utils_Tuple2(60000000, '60MB');
var $author$project$ShareToolForm$toPreview = function (base64) {
	var maybeMimeType = $author$project$Data$MimeType$fromBase64(base64);
	if (!maybeMimeType.$) {
		if (maybeMimeType.a === 2) {
			var _v1 = maybeMimeType.a;
			return {dV: base64, cP: '/static/images/video-placeholder.png', bW: $author$project$ShareToolForm$maxVideoSize};
		} else {
			return {dV: base64, cP: base64, bW: $author$project$ShareToolForm$maxImageSize};
		}
	} else {
		return {dV: base64, cP: '/static/images/image-placeholder.png', bW: $author$project$ShareToolForm$maxImageSize};
	}
};
var $elm$file$File$toUrl = _File_toUrl;
var $author$project$ShareToolForm$update = F2(
	function (msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					var _v1 = model.Z;
					var contentForm = _v1.a;
					return _Utils_Tuple2(
						model,
						$elm$http$Http$request(
							{
								a2: $author$project$ShareToolForm$toMultiPartBody(contentForm),
								cH: A2(
									$author$project$Api$expectJson,
									$author$project$ShareToolForm$GotCreateEmployeeContent(contentForm),
									$author$project$Model$RedirectUrl$redirectUrlDecoder),
								cL: _List_Nil,
								c0: 'POST',
								dF: $elm$core$Maybe$Nothing,
								WM: $elm$core$Maybe$Just('submit'),
								dK: '/api/employee-content'
							}));
				case 1:
					if (!msg.b.$) {
						var unRedirectUrl = msg.b.a.WP;
						return _Utils_Tuple2(
							model,
							$elm$browser$Browser$Navigation$load(unRedirectUrl));
					} else {
						if (!msg.b.a.$) {
							var form = msg.a;
							var error = msg.b.a.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										Z: _Utils_Tuple2(
											form,
											$elm$core$Maybe$Just(error)),
										ce: $elm$core$Maybe$Nothing
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{ce: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$none);
						}
					}
				case 6:
					var form = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{Z: form}),
						$elm$core$Platform$Cmd$none);
				case 3:
					return _Utils_Tuple2(
						model,
						A2(
							$elm$file$File$Select$files,
							_List_fromArray(
								['image/*', 'video/*']),
							$author$project$ShareToolForm$SelectedFiles));
				case 5:
					var _v2 = model.Z;
					var form = _v2.a;
					var error = _v2.b;
					var $temp$msg = $author$project$ShareToolForm$SelectFiles,
						$temp$model = _Utils_update(
						model,
						{
							Z: _Utils_Tuple2(
								_Utils_update(
									form,
									{yZ: $elm$core$Maybe$Nothing}),
								error)
						});
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 4:
					var file = msg.a;
					var files = msg.b;
					var fileToMediaItemToUpload = function (f) {
						return A2(
							$elm$core$Task$map,
							function (base64) {
								return {
									rp: f,
									FG: $author$project$ShareToolForm$toPreview(base64)
								};
							},
							$elm$file$File$toUrl(f));
					};
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$perform,
							$author$project$ShareToolForm$GotPreviews,
							$elm$core$Task$sequence(
								A2(
									$elm$core$List$map,
									fileToMediaItemToUpload,
									A2($elm$core$List$cons, file, files)))));
				case 2:
					var previews = msg.a;
					var _v3 = model.Z;
					var form = _v3.a;
					var errorResponse = _v3.b;
					var previews_ = A2(
						$elm$core$Maybe$withDefault,
						previews,
						A2(
							$elm$core$Maybe$map,
							function (xs) {
								return _Utils_ap(xs, previews);
							},
							form.yZ));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								Z: _Utils_Tuple2(
									_Utils_update(
										form,
										{
											yZ: $elm$core$Maybe$Just(previews_)
										}),
									errorResponse)
							}),
						$elm$core$Platform$Cmd$none);
				default:
					if (msg.a.$ === 1) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var progress = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ce: $elm$core$Maybe$Just(
										$elm$http$Http$fractionSent(progress))
								}),
							$elm$core$Platform$Cmd$none);
					}
			}
		}
	});
var $author$project$ShareToolForm$CreateEmployeeContent = {$: 0};
var $author$project$ShareToolForm$UpdateEmployeeContentForm = function (a) {
	return {$: 6, a: a};
};
var $elm$file$File$size = _File_size;
var $author$project$ShareToolForm$mediaItemAccepted = function (_v0) {
	var file = _v0.rp;
	var preview = _v0.FG;
	return _Utils_cmp(
		$elm$file$File$size(file),
		preview.bW.a) < 1;
};
var $author$project$ShareToolForm$mediaAccepted = function (maybeItems) {
	return A2(
		$elm$core$Maybe$withDefault,
		true,
		A2(
			$elm$core$Maybe$map,
			$elm$core$List$all($author$project$ShareToolForm$mediaItemAccepted),
			maybeItems));
};
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$ShareToolForm$maxRequestSize = _Utils_Tuple2(100000000, '100MB');
var $author$project$ShareToolForm$toTotalRequestSize = function (previews) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (_v0, acc) {
				var file = _v0.rp;
				return acc + $elm$file$File$size(file);
			}),
		0,
		previews);
};
var $author$project$ShareToolForm$requestSizeAccepted = function (maybeItems) {
	if (maybeItems.$ === 1) {
		return true;
	} else {
		var items = maybeItems.a;
		return _Utils_cmp(
			$author$project$ShareToolForm$toTotalRequestSize(items),
			$author$project$ShareToolForm$maxRequestSize.a) < 0;
	}
};
var $author$project$Util$LangCode$toString = function (langCode) {
	switch (langCode) {
		case 1:
			return 'de';
		case 2:
			return 'de-at';
		case 3:
			return 'de-ch';
		case 4:
			return 'de-lu';
		case 0:
			return 'da';
		case 5:
			return 'en';
		case 6:
			return 'en-gb';
		case 7:
			return 'en-us';
		case 8:
			return 'es';
		case 9:
			return 'fi';
		case 10:
			return 'fr';
		case 11:
			return 'fr-be';
		case 12:
			return 'fr-ch';
		case 13:
			return 'fr-lu';
		case 14:
			return 'nl';
		case 15:
			return 'nl-be';
		case 16:
			return 'no';
		case 17:
			return 'pl';
		case 18:
			return 'pt';
		case 19:
			return 'ro';
		case 20:
			return 'sk';
		case 21:
			return 'sv';
		default:
			return 'uk';
	}
};
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $author$project$Data$Translation$toString = F2(
	function (_v0, _v1) {
		var translations = _v0;
		var name = _v1;
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Dict$get, name, translations));
	});
var $author$project$Data$Translation$text = function (translations) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$html$Html$text,
		$author$project$Data$Translation$toString(translations));
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Model$Translation$TranslationName = $elm$core$Basics$identity;
var $author$project$Model$Translation$uploadPageCaptionLabel = 'upload-page-caption-label';
var $author$project$Model$Translation$uploadPageStep3 = 'upload-page-step3';
var $author$project$ShareToolForm$viewCaption = F3(
	function (translations, form, toMsg) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('share-tool-form__step-title')
						]),
					_List_fromArray(
						[
							A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$uploadPageStep3)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('share-tool-form__step-description')
						]),
					_List_fromArray(
						[
							A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$uploadPageCaptionLabel)
						])),
					A2(
					$elm$html$Html$textarea,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(form.ki),
							$elm$html$Html$Attributes$rows(5),
							$elm$html$Html$Events$onInput(
							A2(
								$elm$core$Basics$composeL,
								toMsg,
								function (v) {
									return _Utils_update(
										form,
										{ki: v});
								}))
						]),
					_List_Nil)
				]));
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$label = _VirtualDom_node('label');
var $author$project$Model$Translation$uploadPageConsentText = 'upload-page-consent-text';
var $author$project$Model$Translation$uploadPagePrivacyLinkPath = 'upload-page-privacy-link-path';
var $author$project$ShareToolForm$viewPrivacyStatementLink = function (translations) {
	var linkPath = A2($author$project$Data$Translation$toString, translations, $author$project$Model$Translation$uploadPagePrivacyLinkPath);
	var linkLabel = A2($author$project$Data$Translation$toString, translations, $author$project$Model$Translation$uploadPagePrivacyLinkPath);
	var isValid = function (key) {
		return $elm$core$String$length(key) > 0;
	};
	return A2(
		$author$project$Util$View$viewIf,
		isValid(linkLabel) && isValid(linkPath),
		function (_v0) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('link'),
						$elm$html$Html$Attributes$href(linkPath)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(linkLabel)
					]));
		});
};
var $author$project$ShareToolForm$viewConsent = F3(
	function (translations, form, toMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('share-tool-form__consent-field')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-checkbox-label')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$id('consent'),
									$elm$html$Html$Attributes$name('consent'),
									$elm$html$Html$Attributes$checked(form.l8),
									$elm$html$Html$Attributes$class('form-checkbox'),
									$elm$html$Html$Events$onClick(
									toMsg(
										_Utils_update(
											form,
											{l8: !form.l8})))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('checkbox')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$uploadPageConsentText),
									$author$project$ShareToolForm$viewPrivacyStatementLink(translations)
								]))
						]))
				]));
	});
var $author$project$Model$Translation$uploadPageMediaLabel = 'upload-page-media-label';
var $author$project$Model$Translation$uploadPageStep1 = 'upload-page-step1';
var $author$project$Model$Translation$browseMedia = 'browse-media';
var $author$project$ShareToolForm$viewBrowseMediaButton = F2(
	function (translations, maybeMedia) {
		var maxRequestSizeExceeded = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (media) {
					return _Utils_cmp(
						$author$project$ShareToolForm$toTotalRequestSize(media),
						$author$project$ShareToolForm$maxRequestSize.a) > -1;
				},
				maybeMedia));
		return A2(
			$author$project$Util$View$viewIfNot,
			maxRequestSizeExceeded,
			function (_v0) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('btn btn-submit bg-color-1 color-white'),
							$elm$html$Html$Events$onClick($author$project$ShareToolForm$SelectFiles)
						]),
					_List_fromArray(
						[
							A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$browseMedia)
						]));
			});
	});
var $author$project$Component$Form$Input$viewFormField = F3(
	function (translation, error, field) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-field', true),
							_Utils_Tuple2(
							'error',
							$elm_community$maybe_extra$Maybe$Extra$isJust(error))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Util$View$viewIfNot,
					$elm$core$String$isEmpty(translation),
					function (_v0) {
						return A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(translation)
								]));
					}),
					field,
					A2(
					$author$project$Util$View$viewMaybe,
					error,
					function (message) {
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('error-message')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(message)
								]));
					})
				]));
	});
var $author$project$ShareToolForm$RedoSelectFiles = {$: 5};
var $author$project$Model$Translation$maxRequestSizeExceededDescription = 'max-request-size-exceeded-description';
var $author$project$Model$Translation$maxRequestSizeExceededTitle = 'max-request-size-exceeded-title';
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$Util$List$removeByIndex = F2(
	function (index, xs) {
		return _Utils_ap(
			A2($elm$core$List$take, index, xs),
			A2($elm$core$List$drop, index + 1, xs));
	});
var $author$project$Component$Message$viewDescription = function (_v0) {
	var description = _v0.cD;
	return A2(
		$author$project$Util$View$viewIfNot,
		$elm$core$String$isEmpty(description),
		function (_v1) {
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('description')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(description)
					]));
		});
};
var $author$project$Component$Message$viewExtraHtml = function (_v0) {
	var html = _v0.ec;
	return A2($author$project$Util$View$viewMaybe, html, $elm$core$Basics$identity);
};
var $author$project$Component$Message$viewTitle = function (_v0) {
	var title = _v0.WC;
	return A2(
		$author$project$Util$View$viewIfNot,
		$elm$core$String$isEmpty(title),
		function (_v1) {
			return A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					]));
		});
};
var $author$project$Component$Message$view = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('message')
			]),
		_List_fromArray(
			[
				$author$project$Component$Message$viewTitle(message),
				$author$project$Component$Message$viewDescription(message),
				$author$project$Component$Message$viewExtraHtml(message)
			]));
};
var $author$project$Util$Translation$FileTooBig = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$Translation$clickToRemove = 'click-to-remove';
var $elm$file$File$name = _File_name;
var $author$project$Copy$language = 14;
var $author$project$Util$Translation$translation = function (translationKey) {
	switch (translationKey.$) {
		case 0:
			var status = translationKey.a;
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				Uw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				Ux: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				Uy: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				Uz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				UO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				UP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				o: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				UQ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Estado {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Tila {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				U0: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Statut {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				U1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Statut {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				U2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Statut {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				U3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Statut {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				Vz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						]))
			};
		case 1:
			var status = translationKey.a;
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Anmodningen mislykkedes med statuskode {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				Uw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die Anforderung ist mit dem Statuscode fehlgeschlagen {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				Ux: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die Anforderung ist mit dem Statuscode fehlgeschlagen {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				Uy: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die Anforderung ist mit dem Statuscode fehlgeschlagen {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				Uz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die Anforderung ist mit dem Statuscode fehlgeschlagen {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				UO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The request failed with status code {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				UP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The request failed with status code {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The request failed with status code {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				o: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The request failed with status code {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The request failed with status code {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				UQ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The request failed with status code {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La solicitud falló con el código de estado {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Pyyntö epäonnistui tilakoodilla {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				U0: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le serveur répond avec un code d\'état {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				U1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le serveur répond avec un code d\'état {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				U2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le serveur répond avec un code d\'état {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				U3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le serveur répond avec un code d\'état {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				Vz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'De server antwoord met statuscode {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'De server antwoord met statuscode {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Forespørselen mislyktes med statuskoden {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Żądanie nie powiodło się z kodem stanu {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'O servidor responde com o código de status {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Serverul răspunde cu codul de stare {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Server odpovie stavovým kódom {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Begäran misslyckades med statuskoden {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Сервер відповідає кодом статусу {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(status)
						]))
			};
		case 2:
			var url = translationKey.a;
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Adres URL {0} nie istnieje.',
					_List_fromArray(
						[url])),
				Uw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die URL {0} existiert nicht.',
					_List_fromArray(
						[url])),
				Ux: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die URL {0} existiert nicht.',
					_List_fromArray(
						[url])),
				Uy: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die URL {0} existiert nicht.',
					_List_fromArray(
						[url])),
				Uz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die URL {0} existiert nicht.',
					_List_fromArray(
						[url])),
				UO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The url {0} does not exist.',
					_List_fromArray(
						[url])),
				UP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The url {0} does not exist.',
					_List_fromArray(
						[url])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The url {0} does not exist.',
					_List_fromArray(
						[url])),
				o: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The url {0} does not exist.',
					_List_fromArray(
						[url])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The url {0} does not exist.',
					_List_fromArray(
						[url])),
				UQ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The url {0} does not exist.',
					_List_fromArray(
						[url])),
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La URL {0} no existe.',
					_List_fromArray(
						[url])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'URL -osoitetta {0} ei ole olemassa.',
					_List_fromArray(
						[url])),
				U0: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'L\'url {0} n\'existe pas.',
					_List_fromArray(
						[url])),
				U1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'L\'url {0} n\'existe pas.',
					_List_fromArray(
						[url])),
				U2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'L\'url {0} n\'existe pas.',
					_List_fromArray(
						[url])),
				U3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'L\'url {0} n\'existe pas.',
					_List_fromArray(
						[url])),
				Vz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'De url {0} bestaat niet.',
					_List_fromArray(
						[url])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'De url {0} bestaat niet.',
					_List_fromArray(
						[url])),
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Nettadressen {0} eksisterer ikke.',
					_List_fromArray(
						[url])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Adres URL {0} nie istnieje.',
					_List_fromArray(
						[url])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'O URL {0} não existe.',
					_List_fromArray(
						[url])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Adresa URL {0} nu există.',
					_List_fromArray(
						[url])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Adresa URL {0} neexistuje.',
					_List_fromArray(
						[url])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Webbadressen {0} finns inte.',
					_List_fromArray(
						[url])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'URL-адреса {0} не існує',
					_List_fromArray(
						[url]))
			};
		case 9:
			var max = translationKey.a;
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Det maksimale beløb for {0} offentliggjorte konti på sociale medier er nået.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Uw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Der Höchstbetrag von {0} veröffentlichten Social-Media-Konten ist erreicht.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Ux: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Der Höchstbetrag von {0} veröffentlichten Social-Media-Konten ist erreicht.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Uy: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Der Höchstbetrag von {0} veröffentlichten Social-Media-Konten ist erreicht.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Uz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Der Höchstbetrag von {0} veröffentlichten Social-Media-Konten ist erreicht.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				UO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum amount of {0} published social media accounts is reached.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				UP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum amount of {0} published social media accounts is reached.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum amount of {0} published social media accounts is reached.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				o: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum amount of {0} published social media accounts is reached.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum amount of {0} published social media accounts is reached.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				UQ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum amount of {0} published social media accounts is reached.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Se alcanza la cantidad máxima de cuentas de redes sociales publicadas.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Julkaistujen sosiaalisen median tilien enimmäismäärä on saavutettu.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				U0: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le nombre maximal de {0} comptes de médias sociaux publiés est atteint.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				U1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le nombre maximal de {0} comptes de médias sociaux publiés est atteint.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				U2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le nombre maximal de {0} comptes de médias sociaux publiés est atteint.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				U3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le nombre maximal de {0} comptes de médias sociaux publiés est atteint.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Vz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Het maximale aantal van {0} gepubliceerde social media accounts is bereikt.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Het maximale aantal van {0} gepubliceerde social media accounts is bereikt.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maksimalt antall {0} publiserte sosiale medier -kontoer er nådd.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Osiągnięto maksymalną liczbę {0} opublikowanych kont w mediach społecznościowych.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'O número máximo de {0} contas de mídia social publicadas foi atingido.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'A fost atinsă cantitatea maximă de {0} conturi de social media publicate.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dosiahli ste maximálny počet {0} zverejnených účtov sociálnych médií.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Det högsta beloppet för {0} publicerade sociala mediekonton har uppnåtts.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Досягнуто максимальної кількості опублікованих облікових записів соціальних мереж: {0}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						]))
			};
		case 8:
			var max = translationKey.a;
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Högst {0} sökandesresor tillåtna',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Uw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximal {0} Antragsteller-Reisen erlaubt',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Ux: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximal {0} Antragsteller-Reisen erlaubt',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Uy: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximal {0} Antragsteller-Reisen erlaubt',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Uz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximal {0} Antragsteller-Reisen erlaubt',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				UO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} applicant journeys allowed',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				UP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} applicant journeys allowed',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} applicant journeys allowed',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				o: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} applicant journeys allowed',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} applicant journeys allowed',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				UQ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} applicant journeys allowed',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Máximo {0} Viajes solicitantes permitidos',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Suurin sallittu {0} hakijamatka',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				U0: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} voyages de candidat autorisés',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				U1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} voyages de candidat autorisés',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				U2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} voyages de candidat autorisés',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				U3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} voyages de candidat autorisés',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Vz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximaal {0} applicant journeys toegestaan',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximaal {0} applicant journeys toegestaan',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maksimalt tillatte {0} søkereiser',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maksymalna dozwolona liczba podróży {0} kandydata',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Máximo de {0} viagens de candidatos permitidas',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximum {0} călătorii ale solicitantului permise',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximálny povolený počet ciest žiadateľa je {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Högst {0} sökandesresor tillåtna',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Максимальна кількість заявників: {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						]))
			};
		case 11:
			var tag = translationKey.a;
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Er du sikker på, at du vil fjerne denne {0}?',
					_List_fromArray(
						[tag])),
				Uw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sind Sie sicher, dass Sie diese {0} entfernen möchten?',
					_List_fromArray(
						[tag])),
				Ux: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sind Sie sicher, dass Sie diese {0} entfernen möchten?',
					_List_fromArray(
						[tag])),
				Uy: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sind Sie sicher, dass Sie diese {0} entfernen möchten?',
					_List_fromArray(
						[tag])),
				Uz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sind Sie sicher, dass Sie diese {0} entfernen möchten?',
					_List_fromArray(
						[tag])),
				UO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Are you sure you want to remove this {0}?',
					_List_fromArray(
						[tag])),
				UP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Are you sure you want to remove this {0}?',
					_List_fromArray(
						[tag])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Are you sure you want to remove this {0}?',
					_List_fromArray(
						[tag])),
				o: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Are you sure you want to remove this {0}?',
					_List_fromArray(
						[tag])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Are you sure you want to remove this {0}?',
					_List_fromArray(
						[tag])),
				UQ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Are you sure you want to remove this {0}?',
					_List_fromArray(
						[tag])),
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Está seguro de que desea eliminar este {0}?',
					_List_fromArray(
						[tag])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Haluatko varmasti poistaa tämän {0}?',
					_List_fromArray(
						[tag])),
				U0: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Êtes-vous sûr de vouloir supprimer ces {0}?',
					_List_fromArray(
						[tag])),
				U1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Êtes-vous sûr de vouloir supprimer ces {0}?',
					_List_fromArray(
						[tag])),
				U2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Êtes-vous sûr de vouloir supprimer ces {0}?',
					_List_fromArray(
						[tag])),
				U3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Êtes-vous sûr de vouloir supprimer ces {0}?',
					_List_fromArray(
						[tag])),
				Vz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Weet je zeker dat je deze {0} wilt verwijderen?',
					_List_fromArray(
						[tag])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Weet je zeker dat je deze {0} wilt verwijderen?',
					_List_fromArray(
						[tag])),
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Er du sikker på at du vil fjerne denne {0}?',
					_List_fromArray(
						[tag])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Czy na pewno chcesz usunąć ten {0}?',
					_List_fromArray(
						[tag])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Tem certeza de que deseja excluir este {0}?',
					_List_fromArray(
						[tag])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sigur doriți să eliminați acest {0}?',
					_List_fromArray(
						[tag])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Naozaj chcete odstrániť toto {0}?',
					_List_fromArray(
						[tag])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Är du säker på att du vill ta bort den här {0}?',
					_List_fromArray(
						[tag])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ви впевнені, що хочете видалити цей {0}?',
					_List_fromArray(
						[tag]))
			};
		case 12:
			var max = translationKey.a;
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'For mange filtre aktiveret. Maks. {0} filtre',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Uw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Zu viele Filter aktiviert. Max {0} Filter',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Ux: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Zu viele Filter aktiviert. Max {0} Filter',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Uy: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Zu viele Filter aktiviert. Max {0} Filter',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Uz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Zu viele Filter aktiviert. Max {0} Filter',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				UO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Too many filters enabled. Max {0} filters',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				UP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Too many filters enabled. Max {0} filters',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Too many filters enabled. Max {0} filters',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				o: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Too many filters enabled. Max {0} filters',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Too many filters enabled. Max {0} filters',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				UQ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Too many filters enabled. Max {0} filters',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Demasiados filtros habilitados. Max {0} filtros',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Liian monta suodatinta käytössä. Enintään {0} suodatinta',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				U0: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Trop de filtres activés. Maximum {0} filtres.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				U1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Trop de filtres activés. Maximum {0} filtres.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				U2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Trop de filtres activés. Maximum {0} filtres.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				U3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Trop de filtres activés. Maximum {0} filtres.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Vz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Te veel filters geselecteerd. Maximaal {0} filters',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Te veel filters geselecteerd. Maximaal {0} filters',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'For mange filtre aktivert. Maks. {0} filtre',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Włączono zbyt wiele filtrów. Maks. {0} filtrów',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Muitos filtros selecionados. Máximo de {0} filtros',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Prea multe filtre activate. Max {0} filtre',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Je povolených príliš veľa filtrov. Maximálny počet filtrov: {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'För många filter aktiverade. Max. {0} filter',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Вибрано забагато фільтрів. Максимальна кількість фільтрів: {0}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(max)
						]))
			};
		case 15:
			var tag = translationKey.a;
			var col = translationKey.b;
			var column = translationKey.c;
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Det er ikke tilladt at tilføje en {0} i {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				Uw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Es dürfen kein {0} in {1} {2} hinzufügen',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				Ux: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Es dürfen kein {0} in {1} {2} hinzufügen',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				Uy: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Es dürfen kein {0} in {1} {2} hinzufügen',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				Uz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Es dürfen kein {0} in {1} {2} hinzufügen',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				UO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'It\'s not allowed to add a {0} in {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				UP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'It\'s not allowed to add a {0} in {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'It\'s not allowed to add a {0} in {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				o: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'It\'s not allowed to add a {0} in {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'It\'s not allowed to add a {0} in {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				UQ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'It\'s not allowed to add a {0} in {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'No se le permite agregar un {0} en {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0} ei saa lisätä kohteeseen {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				U0: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Il n\'est pas permis d\'ajouter {0} dans {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				U1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Il n\'est pas permis d\'ajouter {0} dans {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				U2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Il n\'est pas permis d\'ajouter {0} dans {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				U3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Il n\'est pas permis d\'ajouter {0} dans {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				Vz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Het is niet toegestaan om {0} in {1} {2} te plaatsen',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Het is niet toegestaan om {0} in {1} {2} te plaatsen',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Det er ikke tillatt å legge til en {0} i {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Nie można dodawać {0} w {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Não é permitido colocar {0} em {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Nu este permis să adăugați un {0} în {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Nie je povolené pridať {0} v {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Det är inte tillåtet att lägga till en {0} i {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Не дозволено розміщувати {0} в {1} {2}',
					_List_fromArray(
						[
							tag,
							$elm$core$String$fromInt(col),
							$elm$core$String$toLower(column)
						]))
			};
		case 3:
			var name = translationKey.a;
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Accepter venligst {0} betingelserne.',
					_List_fromArray(
						[name])),
				Uw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bitte akzeptieren Sie die Bedingungen {0}.',
					_List_fromArray(
						[name])),
				Ux: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bitte akzeptieren Sie die Bedingungen {0}.',
					_List_fromArray(
						[name])),
				Uy: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bitte akzeptieren Sie die Bedingungen {0}.',
					_List_fromArray(
						[name])),
				Uz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bitte akzeptieren Sie die Bedingungen {0}.',
					_List_fromArray(
						[name])),
				UO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please accept the {0} conditions.',
					_List_fromArray(
						[name])),
				UP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please accept the {0} conditions.',
					_List_fromArray(
						[name])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please accept the {0} conditions.',
					_List_fromArray(
						[name])),
				o: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please accept the {0} conditions.',
					_List_fromArray(
						[name])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please accept the {0} conditions.',
					_List_fromArray(
						[name])),
				UQ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please accept the {0} conditions.',
					_List_fromArray(
						[name])),
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Por favor acepte las condiciones {0}',
					_List_fromArray(
						[name])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Hyväksy {0} ehdot.',
					_List_fromArray(
						[name])),
				U0: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Veuillez accepter les {0} conditions.',
					_List_fromArray(
						[name])),
				U1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Veuillez accepter les {0} conditions.',
					_List_fromArray(
						[name])),
				U2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Veuillez accepter les {0} conditions.',
					_List_fromArray(
						[name])),
				U3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Veuillez accepter les {0} conditions.',
					_List_fromArray(
						[name])),
				Vz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Graag de {0} voorwaarden accepteren.',
					_List_fromArray(
						[name])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Graag de {0} voorwaarden accepteren.',
					_List_fromArray(
						[name])),
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Godta vilkårene for {0}.',
					_List_fromArray(
						[name])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Zaakceptuj {0} warunki.',
					_List_fromArray(
						[name])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Aceite as {0} condições.',
					_List_fromArray(
						[name])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vă rugăm să acceptați {0} condițiile.',
					_List_fromArray(
						[name])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Prijmite podmienky {0}.',
					_List_fromArray(
						[name])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Godkänn {0} villkoren.',
					_List_fromArray(
						[name])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Прийміть умови {0}.',
					_List_fromArray(
						[name]))
			};
		case 10:
			var mime = translationKey.a;
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Filtillägg {0} är inte tillåtet.',
					_List_fromArray(
						[mime])),
				Uw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dateierweiterung {0} nicht erlaubt.',
					_List_fromArray(
						[mime])),
				Ux: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dateierweiterung {0} nicht erlaubt.',
					_List_fromArray(
						[mime])),
				Uy: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dateierweiterung {0} nicht erlaubt.',
					_List_fromArray(
						[mime])),
				Uz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dateierweiterung {0} nicht erlaubt.',
					_List_fromArray(
						[mime])),
				UO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File extension {0} not allowed.',
					_List_fromArray(
						[mime])),
				UP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File extension {0} not allowed.',
					_List_fromArray(
						[mime])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bestandstype {0} niet toegestaan.',
					_List_fromArray(
						[mime])),
				o: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bestandstype {0} niet toegestaan.',
					_List_fromArray(
						[mime])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bestandstype {0} niet toegestaan.',
					_List_fromArray(
						[mime])),
				UQ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File extension {0} not allowed.',
					_List_fromArray(
						[mime])),
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Extensión de archivo {0} No se permite',
					_List_fromArray(
						[mime])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Tiedostopääte {0} ei ole sallittu.',
					_List_fromArray(
						[mime])),
				U0: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Type de fichier {0} non autorisé.',
					_List_fromArray(
						[mime])),
				U1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Type de fichier {0} non autorisé.',
					_List_fromArray(
						[mime])),
				U2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Type de fichier {0} non autorisé.',
					_List_fromArray(
						[mime])),
				U3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Type de fichier {0} non autorisé.',
					_List_fromArray(
						[mime])),
				Vz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bestandstype {0} niet toegestaan.',
					_List_fromArray(
						[mime])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bestandstype {0} niet toegestaan.',
					_List_fromArray(
						[mime])),
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Filutvidelse {0} er ikke tillatt.',
					_List_fromArray(
						[mime])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Rozszerzenie pliku {0} jest niedozwolone.',
					_List_fromArray(
						[mime])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Tipo de arquivo {0} não permitido.',
					_List_fromArray(
						[mime])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Extensia de fișier {0} nu este permisă.',
					_List_fromArray(
						[mime])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Prípona súboru {0} nie je povolená.',
					_List_fromArray(
						[mime])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Filtillägg {0} är inte tillåtet.',
					_List_fromArray(
						[mime])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Розширення файлу {0} заборонено.',
					_List_fromArray(
						[mime]))
			};
		case 4:
			var length = translationKey.a;
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Den maksimale længde af dette felt er {0} tegn.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				Uw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die maximale Länge dieses Feldes ist {0} Zeichen.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				Ux: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die maximale Länge dieses Feldes ist {0} Zeichen.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				Uy: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die maximale Länge dieses Feldes ist {0} Zeichen.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				Uz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die maximale Länge dieses Feldes ist {0} Zeichen.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				UO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				UP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				o: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				UQ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The maximum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longitud máxima de este campo es {0} caracteres',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Tämän kentän enimmäispituus on {0} merkkiä.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				U0: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longueur maximale de ce champ de saisie est {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				U1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longueur maximale de ce champ de saisie est {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				U2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longueur maximale de ce champ de saisie est {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				U3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longueur maximale de ce champ de saisie est {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				Vz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'De maximale lengte van dit veld is {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'De maximale lengte van dit veld is {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maksimal lengde på dette feltet er {0} tegn.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maksymalna długość tego pola to {0} znaków.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'O comprimento máximo deste campo é de {0} caracteres.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Lungimea maximă a acestui câmp este de {0} caractere.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Maximálna dĺžka tohto poľa je {0} znakov.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Den maximala längden för detta fält är {0} tecken.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Максимальна довжина цього поля – {0} символів.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						]))
			};
		case 5:
			var length = translationKey.a;
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Minimumsfeltet for dette felt er {0} tegn.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				Uw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die Mindestlänge dieses Feldes ist {0} Zeichen.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				Ux: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die Mindestlänge dieses Feldes ist {0} Zeichen.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				Uy: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die Mindestlänge dieses Feldes ist {0} Zeichen.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				Uz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Die Mindestlänge dieses Feldes ist {0} Zeichen.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				UO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The minimum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				UP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The minimum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The minimum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				o: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The minimum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The minimum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				UQ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'The minimum length of this field is {0} characters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longitud mínima de este campo es {0} caracteres',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Tämän kentän vähimmäispituus on {0} merkkiä.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				U0: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longueur minimale de ce champ est {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				U1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longueur minimale de ce champ est {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				U2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longueur minimale de ce champ est {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				U3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'La longueur minimale de ce champ est {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				Vz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'De minimale lengte van dit veld is {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'De minimale lengte van dit veld is {0} karakters.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Minimumslengden for dette feltet er {0} tegn.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Minimalna długość tego pola to {0} znaków.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'O comprimento mínimo deste campo é de {0} caracteres.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Lungimea minimă a acestui câmp este de {0} caractere.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Minimálna dĺžka tohto poľa je {0} znakov.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Minsta längd för detta fält är {0} tecken.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Мінімальна довжина цього поля – {0} символів.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(length)
						]))
			};
		case 6:
			var name = translationKey.a;
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Tilføj din {0}.',
					_List_fromArray(
						[name])),
				Uw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bitte füge dein {0} hinzu.',
					_List_fromArray(
						[name])),
				Ux: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bitte füge dein {0} hinzu.',
					_List_fromArray(
						[name])),
				Uy: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bitte füge dein {0} hinzu.',
					_List_fromArray(
						[name])),
				Uz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bitte füge dein {0} hinzu.',
					_List_fromArray(
						[name])),
				UO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please add your {0}.',
					_List_fromArray(
						[name])),
				UP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please add your {0}.',
					_List_fromArray(
						[name])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please add your {0}.',
					_List_fromArray(
						[name])),
				o: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please add your {0}.',
					_List_fromArray(
						[name])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please add your {0}.',
					_List_fromArray(
						[name])),
				UQ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Please add your {0}.',
					_List_fromArray(
						[name])),
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Por favor agregue su {0}',
					_List_fromArray(
						[name])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Lisää {0}.',
					_List_fromArray(
						[name])),
				U0: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Veuillez ajouter votre {0}.',
					_List_fromArray(
						[name])),
				U1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Veuillez ajouter votre {0}.',
					_List_fromArray(
						[name])),
				U2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Veuillez ajouter votre {0}.',
					_List_fromArray(
						[name])),
				U3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Veuillez ajouter votre {0}.',
					_List_fromArray(
						[name])),
				Vz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Graag je {0} toevoegen.',
					_List_fromArray(
						[name])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Graag je {0} toevoegen.',
					_List_fromArray(
						[name])),
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Legg til {0}.',
					_List_fromArray(
						[name])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dodaj swój {0}.',
					_List_fromArray(
						[name])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Adicione seu {0}.',
					_List_fromArray(
						[name])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vă rugăm să adăugați {0}.',
					_List_fromArray(
						[name])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Pridajte svoj {0}.',
					_List_fromArray(
						[name])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Lägg till din {0}.',
					_List_fromArray(
						[name])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Будь ласка, додайте свій {0}.',
					_List_fromArray(
						[name]))
			};
		case 7:
			var maxSize = translationKey.a;
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Filstørrelse er begrænset til: {0}.',
					_List_fromArray(
						[maxSize])),
				Uw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dateigröße ist begrenzt auf: {0}.',
					_List_fromArray(
						[maxSize])),
				Ux: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dateigröße ist begrenzt auf: {0}.',
					_List_fromArray(
						[maxSize])),
				Uy: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dateigröße ist begrenzt auf: {0}.',
					_List_fromArray(
						[maxSize])),
				Uz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dateigröße ist begrenzt auf: {0}.',
					_List_fromArray(
						[maxSize])),
				UO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File size is limited to: {0}.',
					_List_fromArray(
						[maxSize])),
				UP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File size is limited to: {0}.',
					_List_fromArray(
						[maxSize])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File size is limited to: {0}.',
					_List_fromArray(
						[maxSize])),
				o: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File size is limited to: {0}.',
					_List_fromArray(
						[maxSize])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File size is limited to: {0}.',
					_List_fromArray(
						[maxSize])),
				UQ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'File size is limited to: {0}.',
					_List_fromArray(
						[maxSize])),
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'El tamaño del archivo se limita a: {0}.',
					_List_fromArray(
						[maxSize])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Tiedoston koko on rajoitettu: {0} Mt.',
					_List_fromArray(
						[maxSize])),
				U0: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le fichier ne peut pas dépasser: {0}.',
					_List_fromArray(
						[maxSize])),
				U1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le fichier ne peut pas dépasser: {0}.',
					_List_fromArray(
						[maxSize])),
				U2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le fichier ne peut pas dépasser: {0}.',
					_List_fromArray(
						[maxSize])),
				U3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Le fichier ne peut pas dépasser: {0}.',
					_List_fromArray(
						[maxSize])),
				Vz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bestand mag niet groter zijn dan: {0}.',
					_List_fromArray(
						[maxSize])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Bestand mag niet groter zijn dan: {0}.',
					_List_fromArray(
						[maxSize])),
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Filstørrelsen er begrenset til: {0}.',
					_List_fromArray(
						[maxSize])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Rozmiar pliku jest ograniczony do: {0}.',
					_List_fromArray(
						[maxSize])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'O arquivo não pode ser maior que: {0}.',
					_List_fromArray(
						[maxSize])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Dimensiunea fișierului este limitată la: {0}.',
					_List_fromArray(
						[maxSize])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Veľkosť súboru je obmedzená na: {0}.',
					_List_fromArray(
						[maxSize])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Filstorleken är begränsad till: {0}.',
					_List_fromArray(
						[maxSize])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Розмір файлу обмежено: {0}.',
					_List_fromArray(
						[maxSize]))
			};
		case 13:
			var maxAge = translationKey.a;
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Du skal være yngre end {0} år for at ansøge.',
					_List_fromArray(
						[maxAge])),
				Uw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sie müssen jünger als {0} Jahre alt sein, um sich zu bewerben.',
					_List_fromArray(
						[maxAge])),
				Ux: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sie müssen jünger als {0} Jahre alt sein, um sich zu bewerben.',
					_List_fromArray(
						[maxAge])),
				Uy: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sie müssen jünger als {0} Jahre alt sein, um sich zu bewerben.',
					_List_fromArray(
						[maxAge])),
				Uz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sie müssen jünger als {0} Jahre alt sein, um sich zu bewerben.',
					_List_fromArray(
						[maxAge])),
				UO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be younger than {0} years old to apply.',
					_List_fromArray(
						[maxAge])),
				UP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be younger than {0} years old to apply.',
					_List_fromArray(
						[maxAge])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be younger than {0} years old to apply.',
					_List_fromArray(
						[maxAge])),
				o: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be younger than {0} years old to apply.',
					_List_fromArray(
						[maxAge])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be younger than {0} years old to apply.',
					_List_fromArray(
						[maxAge])),
				UQ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be younger than {0} years old to apply.',
					_List_fromArray(
						[maxAge])),
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Debe ser más joven que {0} Años para aplicar.',
					_List_fromArray(
						[maxAge])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sinun on oltava alle {0} vuotta vanha hakemaan.',
					_List_fromArray(
						[maxAge])),
				U0: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vous devez être âgé de moins de {0} ans pour postuler.',
					_List_fromArray(
						[maxAge])),
				U1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vous devez être âgé de moins de {0} ans pour postuler.',
					_List_fromArray(
						[maxAge])),
				U2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vous devez être âgé de moins de {0} ans pour postuler.',
					_List_fromArray(
						[maxAge])),
				U3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vous devez être âgé de moins de {0} ans pour postuler.',
					_List_fromArray(
						[maxAge])),
				Vz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Je moet jonger dan {0} jaar oud zijn om te solliciteren.',
					_List_fromArray(
						[maxAge])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Je moet jonger dan {0} jaar oud zijn om te solliciteren.',
					_List_fromArray(
						[maxAge])),
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Du skal være yngre end {0} år for at ansøge.',
					_List_fromArray(
						[maxAge])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Aby złożyć wniosek, musisz mieć mniej niż {0} lat.',
					_List_fromArray(
						[maxAge])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Você deve ter menos de {0} anos para se inscrever.',
					_List_fromArray(
						[maxAge])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Trebuie să aveți mai puțin de {0} ani pentru a aplica.',
					_List_fromArray(
						[maxAge])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ak sa chcete prihlásiť, musíte mať menej ako {0} rokov.',
					_List_fromArray(
						[maxAge])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Du måste vara yngre än {0} år för att ansöka.',
					_List_fromArray(
						[maxAge])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Щоб подати заявку, ви маєте бути молодше {0} років.',
					_List_fromArray(
						[maxAge]))
			};
		case 14:
			var minAge = translationKey.a;
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Du skal være {0} år for at ansøge.',
					_List_fromArray(
						[minAge])),
				Uw: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sie müssen {0} Jahre alt sein, um sich zu bewerben.',
					_List_fromArray(
						[minAge])),
				Ux: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sie müssen {0} Jahre alt sein, um sich zu bewerben.',
					_List_fromArray(
						[minAge])),
				Uy: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sie müssen {0} Jahre alt sein, um sich zu bewerben.',
					_List_fromArray(
						[minAge])),
				Uz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sie müssen {0} Jahre alt sein, um sich zu bewerben.',
					_List_fromArray(
						[minAge])),
				UO: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be {0} years old to apply.',
					_List_fromArray(
						[minAge])),
				UP: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be {0} years old to apply.',
					_List_fromArray(
						[minAge])),
				n: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be {0} years old to apply.',
					_List_fromArray(
						[minAge])),
				o: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be {0} years old to apply.',
					_List_fromArray(
						[minAge])),
				p: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be {0} years old to apply.',
					_List_fromArray(
						[minAge])),
				UQ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'You must be {0} years old to apply.',
					_List_fromArray(
						[minAge])),
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Debes ser {0} años de edad para aplicar.',
					_List_fromArray(
						[minAge])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Sinun on oltava {0} vuotta vanha hakemaan.',
					_List_fromArray(
						[minAge])),
				U0: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vous devez avoir plus de {0} ans.',
					_List_fromArray(
						[minAge])),
				U1: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vous devez avoir plus de {0} ans.',
					_List_fromArray(
						[minAge])),
				U2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vous devez avoir plus de {0} ans.',
					_List_fromArray(
						[minAge])),
				U3: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Vous devez avoir plus de {0} ans.',
					_List_fromArray(
						[minAge])),
				Vz: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Je moet ouder zijn dan {0} jaar oud.',
					_List_fromArray(
						[minAge])),
				VA: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Je moet ouder zijn dan {0} jaar oud.',
					_List_fromArray(
						[minAge])),
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Du må være {0} år gammel for å søke.',
					_List_fromArray(
						[minAge])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Aby złożyć wniosek, musisz mieć ukończone {0} lat.',
					_List_fromArray(
						[minAge])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Você deve ter mais de {0} anos.',
					_List_fromArray(
						[minAge])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Trebuie să aveți {0} ani pentru a aplica.',
					_List_fromArray(
						[minAge])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ak chcete podať žiadosť, musíte mať {0} rokov.',
					_List_fromArray(
						[minAge])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Du måste vara {0} år för att ansöka.',
					_List_fromArray(
						[minAge])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Щоб подати заявку, вам має бути {0} років.',
					_List_fromArray(
						[minAge]))
			};
		case 16:
			var age = translationKey.a;
			var minAge = translationKey.b;
			var nl = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Ongeldige leeftijd: {0}. De mimimum leeftijd is: {1}.',
				_List_fromArray(
					[
						$elm$core$String$fromInt(age),
						$elm$core$String$fromInt(minAge)
					]));
			var fr = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Âge non valide: {0}. L\'âge minimum est: {1}.',
				_List_fromArray(
					[
						$elm$core$String$fromInt(age),
						$elm$core$String$fromInt(minAge)
					]));
			var en = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'invalid age: {0}. The minimum age is: {1}.',
				_List_fromArray(
					[
						$elm$core$String$fromInt(age),
						$elm$core$String$fromInt(minAge)
					]));
			var de = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Ungültiges Alter: {0}. Das Mindestalter beträgt: {1}.',
				_List_fromArray(
					[
						$elm$core$String$fromInt(age),
						$elm$core$String$fromInt(minAge)
					]));
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ugyldig alder: {0}. Minimumsalderen er: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						])),
				Uw: de,
				Ux: de,
				Uy: de,
				Uz: de,
				UO: en,
				UP: en,
				n: en,
				o: en,
				p: en,
				UQ: en,
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Edad no válida: {0}. La edad mínima es: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Virheellinen ikä: {0}. Alaikäraja on: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						])),
				U0: fr,
				U1: fr,
				U2: fr,
				U3: fr,
				Vz: nl,
				VA: nl,
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ugyldig alder: {0}. Minimumsalderen er: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Nieprawidłowy wiek: {0}. Minimalny wiek to: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Idade inválida: {0}. A idade mínima é: {1}',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'vârstă nevalidă: {0}. Vârsta minimă este: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'neplatný vek: {0}. Minimálny vek je: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ogiltig ålder: {0}. Minimiåldern är: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'недійсний вік: {0}. Мінімальний вік: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(age),
							$elm$core$String$fromInt(minAge)
						]))
			};
		case 17:
			var hours = translationKey.a;
			var minHours = translationKey.b;
			var nl = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Ongeldig aantal uren: {0}. Het minimum aantal uur is {1}.',
				_List_fromArray(
					[
						$elm$core$String$fromInt(hours),
						$elm$core$String$fromInt(minHours)
					]));
			var fr = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Nombre d\'heures non valide: {0}. Le nombre d\'heures minimum est de {1}.',
				_List_fromArray(
					[
						$elm$core$String$fromInt(hours),
						$elm$core$String$fromInt(minHours)
					]));
			var en = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Invalid amount of hours: {0}. The minimum amount of hours is: {1}.',
				_List_fromArray(
					[
						$elm$core$String$fromInt(hours),
						$elm$core$String$fromInt(minHours)
					]));
			var de = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Ungültige Stundenanzahl: {0}. Die Mindeststundenzahl beträgt {1}.',
				_List_fromArray(
					[
						$elm$core$String$fromInt(hours),
						$elm$core$String$fromInt(minHours)
					]));
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ugyldigt antal timer: {0}. Minimumsantallet af timer er {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						])),
				Uw: de,
				Ux: de,
				Uy: de,
				Uz: de,
				UO: en,
				UP: en,
				n: en,
				o: en,
				p: en,
				UQ: en,
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Número de horas no válido: {0}. El número mínimo de horas es {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Virheellinen tuntimäärä: {0}. Tuntien vähimmäismäärä on {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						])),
				U0: fr,
				U1: fr,
				U2: fr,
				U3: fr,
				Vz: nl,
				VA: nl,
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ugyldig antall timer: {0}. Minste antall timer er {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Nieprawidłowa liczba godzin: {0}. Minimalna liczba godzin to {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Número de horas inválido: {0}. O número mínimo de horas é {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Număr de ore nevalid: {0}. Cantitatea minimă de ore este: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Neplatný počet hodín: {0}. Minimálny počet hodín je: {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Ogiltigt antal timmar: {0}. Minsta antal timmar är {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Недійсна кількість годин: {0}. Мінімальна кількість годин становить {1}.',
					_List_fromArray(
						[
							$elm$core$String$fromInt(hours),
							$elm$core$String$fromInt(minHours)
						]))
			};
		default:
			var filterName = translationKey.a;
			var nl = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Onder {0} zijn reeds de volgende vacaturekenmerken aanwezig:',
				_List_fromArray(
					[filterName]));
			var fr = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Les caractéristiques de poste vacant suivantes sont déjà présentes sous {0} :',
				_List_fromArray(
					[filterName]));
			var en = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'The following vacancy characteristics are already present under {0}:',
				_List_fromArray(
					[filterName]));
			var de = A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'Folgende Leerstandsmerkmale sind bereits unter {0} vorhanden:',
				_List_fromArray(
					[filterName]));
			return {
				Uv: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Følgende stillingskarakteristika er allerede til stede under {0}:',
					_List_fromArray(
						[filterName])),
				Uw: de,
				Ux: de,
				Uy: de,
				Uz: de,
				UO: en,
				UP: en,
				n: en,
				o: en,
				p: en,
				UQ: en,
				US: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Las siguientes características de vacante ya están presentes en {0}:',
					_List_fromArray(
						[filterName])),
				UX: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Seuraavat avoimet ominaisuudet ovat jo olemassa {0} ssa:',
					_List_fromArray(
						[filterName])),
				U0: fr,
				U1: fr,
				U2: fr,
				U3: fr,
				Vz: nl,
				VA: nl,
				A6: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Følgende stillingsegenskaper finnes allerede under {0}:',
					_List_fromArray(
						[filterName])),
				VZ: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Następujące cechy wakatów są już obecne w obszarze {0}:',
					_List_fromArray(
						[filterName])),
				V2: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'As seguintes características da vaga já estão presentes em {0}:',
					_List_fromArray(
						[filterName])),
				Wb: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Următoarele caracteristici ale postului vacant sunt deja prezente sub {0}:',
					_List_fromArray(
						[filterName])),
				Wj: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Nasledujúce charakteristiky voľných pracovných miest sa už nachádzajú pod {0}:',
					_List_fromArray(
						[filterName])),
				Ww: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Följande lediga tjänster finns redan under {0}:',
					_List_fromArray(
						[filterName])),
				WN: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'Наступні характеристики вакансії вже присутні в {0}:',
					_List_fromArray(
						[filterName]))
			};
	}
};
var $author$project$Util$Translation$translate = function () {
	var _v0 = $author$project$Copy$language;
	switch (_v0) {
		case 1:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.Uw;
				},
				$author$project$Util$Translation$translation);
		case 2:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.Ux;
				},
				$author$project$Util$Translation$translation);
		case 3:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.Uy;
				},
				$author$project$Util$Translation$translation);
		case 4:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.Uz;
				},
				$author$project$Util$Translation$translation);
		case 0:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.Uv;
				},
				$author$project$Util$Translation$translation);
		case 5:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.UO;
				},
				$author$project$Util$Translation$translation);
		case 6:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.UP;
				},
				$author$project$Util$Translation$translation);
		case 7:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.UQ;
				},
				$author$project$Util$Translation$translation);
		case 8:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.US;
				},
				$author$project$Util$Translation$translation);
		case 9:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.UX;
				},
				$author$project$Util$Translation$translation);
		case 10:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.U0;
				},
				$author$project$Util$Translation$translation);
		case 12:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.U2;
				},
				$author$project$Util$Translation$translation);
		case 11:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.U1;
				},
				$author$project$Util$Translation$translation);
		case 13:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.U3;
				},
				$author$project$Util$Translation$translation);
		case 14:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.Vz;
				},
				$author$project$Util$Translation$translation);
		case 15:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.VA;
				},
				$author$project$Util$Translation$translation);
		case 16:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.A6;
				},
				$author$project$Util$Translation$translation);
		case 17:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.VZ;
				},
				$author$project$Util$Translation$translation);
		case 18:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.V2;
				},
				$author$project$Util$Translation$translation);
		case 19:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.Wb;
				},
				$author$project$Util$Translation$translation);
		case 20:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.Wj;
				},
				$author$project$Util$Translation$translation);
		case 21:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.Ww;
				},
				$author$project$Util$Translation$translation);
		default:
			return A2(
				$elm$core$Basics$composeL,
				function ($) {
					return $.WN;
				},
				$author$project$Util$Translation$translation);
	}
}();
var $author$project$ShareToolForm$viewPreview = F3(
	function (translations, msg, mediaItem) {
		var file = mediaItem.rp;
		var preview = mediaItem.FG;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('share-tool-form__preview')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('img-container'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'error',
									!$author$project$ShareToolForm$mediaItemAccepted(mediaItem))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(preview.cP)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('img-container__banner bg-color-1 color-white')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$file$File$name(file))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('btn color-white'),
											$elm$html$Html$Events$onClick(msg)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('＋')
										]))
								]))
						])),
					A2(
					$author$project$Util$View$viewIf,
					!$author$project$ShareToolForm$mediaItemAccepted(mediaItem),
					function (_v0) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('error-overlay'),
									$elm$html$Html$Events$onClick(msg)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Util$Translation$translate(
												$author$project$Util$Translation$FileTooBig(preview.bW.b)))
										])),
									$author$project$View$Icon$viewColored($author$project$View$Icon$path.VL),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$clickToRemove)
										]))
								]));
					})
				]));
	});
var $author$project$ShareToolForm$viewPreviews = F4(
	function (translations, form, toMsg, previews) {
		var translate = $author$project$Data$Translation$toString(translations);
		var removePreview = function (index) {
			return _Utils_update(
				form,
				{
					yZ: $elm$core$Maybe$Just(
						A2($author$project$Util$List$removeByIndex, index, previews))
				});
		};
		return (_Utils_cmp(
			$author$project$ShareToolForm$toTotalRequestSize(previews),
			$author$project$ShareToolForm$maxRequestSize.a) > -1) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('share-tool__request-too-big')
				]),
			_List_fromArray(
				[
					$author$project$Component$Message$view(
					{
						cD: translate($author$project$Model$Translation$maxRequestSizeExceededDescription),
						ec: $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Attributes$class('btn btn-submit bg-color-1 color-white'),
										$elm$html$Html$Events$onClick($author$project$ShareToolForm$RedoSelectFiles)
									]),
								_List_fromArray(
									[
										A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$browseMedia)
									]))),
						WC: translate($author$project$Model$Translation$maxRequestSizeExceededTitle)
					})
				])) : A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, preview) {
						return A3(
							$author$project$ShareToolForm$viewPreview,
							translations,
							toMsg(
								removePreview(index)),
							preview);
					}),
				previews));
	});
var $author$project$ShareToolForm$viewMediaUploads = F4(
	function (translations, form, toMsg, toError) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('share-tool__container')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Component$Form$Input$viewFormField,
					'',
					toError('media'),
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('share-tool-form__step-title')
									]),
								_List_fromArray(
									[
										A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$uploadPageStep1)
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('share-tool-form__step-description')
									]),
								_List_fromArray(
									[
										A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$uploadPageMediaLabel)
									])),
								A2(
								$author$project$Util$View$viewMaybe,
								form.yZ,
								A3($author$project$ShareToolForm$viewPreviews, translations, form, toMsg)),
								A2($author$project$ShareToolForm$viewBrowseMediaButton, translations, form.yZ)
							])))
				]));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$Model$Translation$submit = 'submit';
var $author$project$ShareToolForm$viewSubmitButton = F3(
	function (translations, maybeLoading, isDisabled) {
		var classes = _List_fromArray(
			[
				_Utils_Tuple2(
				'loading',
				$elm_community$maybe_extra$Maybe$Extra$isJust(maybeLoading)),
				_Utils_Tuple2('btn btn-submit bg-color-1 color-white', true)
			]);
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('submit'),
					$elm$html$Html$Attributes$classList(classes),
					$elm$html$Html$Attributes$disabled(isDisabled)
				]),
			_List_fromArray(
				[
					A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$submit),
					A2(
					$author$project$Util$View$viewMaybe,
					maybeLoading,
					function (progress) {
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('share-tool-form__progress-bar'),
									A2(
									$elm$html$Html$Attributes$style,
									'width',
									A2(
										$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
										'{0}%',
										_List_fromArray(
											[
												$elm$core$String$fromFloat(100 * progress)
											])))
								]),
							_List_Nil);
					})
				]));
	});
var $author$project$Model$Translation$uploadPageStep2 = 'upload-page-step2';
var $author$project$Model$Translation$uploadPageTagsLabel = 'upload-page-tags-label';
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$ShareToolForm$viewTag = F3(
	function (form, toMsg, _v0) {
		var tagId = _v0.a;
		var tag = _v0.b;
		var toSelectedTagIds = function (checked) {
			return checked ? A2($elm$core$List$cons, tagId, form.eZ) : A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(tagId),
				form.eZ);
		};
		var isChecked = A2($elm$core$List$member, tagId, form.eZ);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('share-tool-form__tag')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$class('form-checkbox'),
							$elm$html$Html$Attributes$id(tag.bj),
							$elm$html$Html$Attributes$name(tag.bj),
							$elm$html$Html$Attributes$checked(isChecked),
							$elm$html$Html$Events$onCheck(
							A2(
								$elm$core$Basics$composeL,
								toMsg,
								function (v) {
									return _Utils_update(
										form,
										{
											eZ: toSelectedTagIds(v)
										});
								}))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(tag.bj)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(tag.bj)
						]))
				]));
	});
var $author$project$ShareToolForm$viewTags = F5(
	function (translations, tags, form, toMsg, toError) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('share-tool__container share-tool-form__tags-field')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Component$Form$Input$viewFormField,
					'',
					toError('tagIds'),
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('share-tool-form__step-title')
										]),
									_List_fromArray(
										[
											A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$uploadPageStep2)
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('share-tool-form__step-description')
										]),
									_List_fromArray(
										[
											A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$uploadPageTagsLabel)
										]))
								]),
							A2(
								$elm$core$List$map,
								A2($author$project$ShareToolForm$viewTag, form, toMsg),
								tags))))
				]));
	});
var $author$project$ShareToolForm$view = function (model) {
	var _v0 = model.Z;
	var form = _v0.a;
	var errorResponse = _v0.b;
	var toError = function (key) {
		if (!errorResponse.$) {
			var validationErrors = errorResponse.a;
			return A2(
				$elm$core$Maybe$andThen,
				$elm$core$Dict$get(
					$author$project$Util$LangCode$toString(model.a9)),
				A2($elm$core$Dict$get, key, validationErrors.UY));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	var updateField = function (f) {
		return $author$project$ShareToolForm$UpdateEmployeeContentForm(
			_Utils_Tuple2(f, errorResponse));
	};
	var allowSubmit = form.l8 && ($author$project$ShareToolForm$mediaAccepted(form.yZ) && $author$project$ShareToolForm$requestSizeAccepted(form.yZ));
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form share-tool-form'),
				$elm$html$Html$Events$onSubmit($author$project$ShareToolForm$CreateEmployeeContent)
			]),
		_List_fromArray(
			[
				A4($author$project$ShareToolForm$viewMediaUploads, model.P$, form, updateField, toError),
				A5($author$project$ShareToolForm$viewTags, model.P$, model.OM, form, updateField, toError),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('share-tool__container')
					]),
				_List_fromArray(
					[
						A3($author$project$ShareToolForm$viewCaption, model.P$, form, updateField),
						A3($author$project$ShareToolForm$viewConsent, model.P$, form, updateField),
						A3($author$project$ShareToolForm$viewSubmitButton, model.P$, model.ce, !allowSubmit)
					]))
			]));
};
var $author$project$ShareToolForm$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$ShareToolForm$decodeFlags,
	{cR: $author$project$ShareToolForm$init, dC: $author$project$ShareToolForm$subscriptions, dJ: $author$project$ShareToolForm$update, dM: $author$project$ShareToolForm$view});
var $author$project$ShareToolEmployeeContentCollection$Flags = F4(
	function (employee, tags, translations, timeZoneOffset) {
		return {pS: employee, OM: tags, Pn: timeZoneOffset, P$: translations};
	});
var $author$project$Model$Employee$Employee = function (employeeNumber) {
	return function (identifier) {
		return function (firstName) {
			return function (lastName) {
				return function (country) {
					return function (preferredLanguage) {
						return function (_function) {
							return function (storeNumber) {
								return function (regionName) {
									return function (locationType) {
										return {mH: country, p$: employeeNumber, r3: firstName, sw: _function, uv: identifier, w1: lastName, x0: locationType, FF: preferredLanguage, HR: regionName, NU: storeNumber};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$Employee$employeeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'employeeLocationType',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'employeeRegionName',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'employeeStoreNumber',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'employeeFunction',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'employeePreferredLanguage',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'employeeCountry',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'employeeLastName',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'employeeFirstName',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'employeeIdentifier',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'employeeEmployeeNumber',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Model$Employee$Employee)))))))))));
var $author$project$ShareToolEmployeeContentCollection$decodeFlags = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'timeZoneOffset',
	$elm$json$Json$Decode$int,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Data$Translation$translationsDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'tags',
			$elm$json$Json$Decode$list(
				$author$project$Data$Entity$decoder($author$project$Model$ShareToolTag$shareToolTagDecoder)),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'employee',
				$author$project$Model$Employee$employeeDecoder,
				$elm$json$Json$Decode$succeed($author$project$ShareToolEmployeeContentCollection$Flags)))));
var $author$project$ShareToolEmployeeContentCollection$GotEmployeeContentStatus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$Status$Loading = {$: 1};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $author$project$Component$Notifications$Notifications = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Component$Notifications$emptyNotifications = A2($author$project$Component$Notifications$Notifications, 0, _List_Nil);
var $author$project$Model$EmployeeContentResponse$EmployeeContentResponse = F3(
	function (employeeEntity, employeeContentUploads, employeeContentEntity) {
		return {pV: employeeContentEntity, pX: employeeContentUploads, pY: employeeEntity};
	});
var $author$project$Model$EmployeeContent$EmployeeContent = F8(
	function (employeeId, uploads, caption, feedback, status, live, inserted, updated) {
		return {ki: caption, pZ: employeeId, rg: feedback, u_: inserted, xQ: live, eW: status, QH: updated, Q_: uploads};
	});
var $author$project$Model$EmployeeContent$Approved = 2;
var $author$project$Model$EmployeeContent$Honors = 3;
var $author$project$Model$EmployeeContent$Pending = 0;
var $author$project$Model$EmployeeContent$Retry = 1;
var $author$project$Model$EmployeeContent$employeeContentStatusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'pending':
				return $elm$json$Json$Decode$succeed(0);
			case 'retry':
				return $elm$json$Json$Decode$succeed(1);
			case 'approved':
				return $elm$json$Json$Decode$succeed(2);
			case 'honors':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$EmployeeContent$employeeContentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'employeeContentUpdated',
	$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'employeeContentInserted',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'employeeContentLive',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'employeeContentStatus',
				$author$project$Model$EmployeeContent$employeeContentStatusDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'employeeContentFeedback',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'employeeContentCaption',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'employeeContentUploads',
							$elm$json$Json$Decode$list($author$project$Data$Id$decoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'employeeContentEmployeeId',
								$author$project$Data$Id$decoder,
								$elm$json$Json$Decode$succeed($author$project$Model$EmployeeContent$EmployeeContent)))))))));
var $author$project$Model$ShareToolUpload$ShareToolUpload = F4(
	function (fileName, inserted, updated, deleted) {
		return {oi: deleted, rr: fileName, u_: inserted, QH: updated};
	});
var $author$project$Model$ShareToolUpload$shareToolUploadDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'shareToolUploadDeleted',
	$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'shareToolUploadUpdated',
		$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'shareToolUploadInserted',
			$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'shareToolUploadFileName',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$ShareToolUpload$ShareToolUpload)))));
var $author$project$Model$EmployeeContentResponse$employeeContentResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'employeeContentEntity',
	$author$project$Data$Entity$decoder($author$project$Model$EmployeeContent$employeeContentDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'employeeContentUploads',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2(
					$elm$json$Json$Decode$index,
					0,
					$author$project$Data$Entity$decoder($author$project$Model$ShareToolUpload$shareToolUploadDecoder)),
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'employeeEntity',
			$author$project$Data$Entity$decoder($author$project$Model$Employee$employeeDecoder),
			$elm$json$Json$Decode$succeed($author$project$Model$EmployeeContentResponse$EmployeeContentResponse))));
var $NoRedInk$http_upgrade_shim$Http$Legacy$emptyBody = $elm$http$Http$emptyBody;
var $NoRedInk$http_upgrade_shim$Http$Legacy$BadPayload = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $NoRedInk$http_upgrade_shim$Http$Legacy$combine = function (result) {
	if (!result.$) {
		var x = result.a;
		return x;
	} else {
		var x = result.a;
		return x;
	}
};
var $NoRedInk$http_upgrade_shim$Http$Legacy$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $NoRedInk$http_upgrade_shim$Http$Legacy$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $NoRedInk$http_upgrade_shim$Http$Legacy$NetworkError = {$: 2};
var $NoRedInk$http_upgrade_shim$Http$Legacy$Timeout = {$: 1};
var $NoRedInk$http_upgrade_shim$Http$Legacy$metadataAndBodyToResponse = F2(
	function (meta, body) {
		return {
			a2: body,
			cL: meta.cL,
			eW: {d_: meta.Wm, bp: meta.Wn},
			dK: meta.dK
		};
	});
var $NoRedInk$http_upgrade_shim$Http$Legacy$fromHttpResponse = function (response) {
	switch (response.$) {
		case 0:
			var url = response.a;
			return $elm$core$Result$Err(
				$NoRedInk$http_upgrade_shim$Http$Legacy$BadUrl(url));
		case 1:
			return $elm$core$Result$Err($NoRedInk$http_upgrade_shim$Http$Legacy$Timeout);
		case 2:
			return $elm$core$Result$Err($NoRedInk$http_upgrade_shim$Http$Legacy$NetworkError);
		case 3:
			var meta = response.a;
			var body = response.b;
			return $elm$core$Result$Err(
				$NoRedInk$http_upgrade_shim$Http$Legacy$BadStatus(
					A2($NoRedInk$http_upgrade_shim$Http$Legacy$metadataAndBodyToResponse, meta, body)));
		default:
			var meta = response.a;
			var body = response.b;
			return $elm$core$Result$Ok(
				A2($NoRedInk$http_upgrade_shim$Http$Legacy$metadataAndBodyToResponse, meta, body));
	}
};
var $NoRedInk$http_upgrade_shim$Http$Legacy$expectJson = function (decoder) {
	return {
		ba: function (response) {
			return A2(
				$elm$core$Result$mapError,
				function (err) {
					return A2(
						$NoRedInk$http_upgrade_shim$Http$Legacy$BadPayload,
						$elm$json$Json$Decode$errorToString(err),
						response);
				},
				A2($elm$json$Json$Decode$decodeString, decoder, response.a2));
		},
		cH: A2(
			$elm$http$Http$expectStringResponse,
			A2($elm$core$Basics$composeL, $NoRedInk$http_upgrade_shim$Http$Legacy$fromHttpResponse, $NoRedInk$http_upgrade_shim$Http$Legacy$combine),
			$elm$core$Result$Ok)
	};
};
var $NoRedInk$http_upgrade_shim$Http$Legacy$request = $elm$core$Basics$identity;
var $author$project$Api$Endpoint$requestLegacy = function (config) {
	var _v0 = config.dK;
	var url = _v0;
	return $NoRedInk$http_upgrade_shim$Http$Legacy$request(
		{a2: config.a2, cH: config.cH, cL: config.cL, c0: config.c0, dF: config.dF, dK: url, e9: config.e9});
};
var $author$project$Api$requestJson = F4(
	function (method, url, body, decoder) {
		return $author$project$Api$Endpoint$requestLegacy(
			{
				a2: body,
				cH: $NoRedInk$http_upgrade_shim$Http$Legacy$expectJson(decoder),
				cL: _List_Nil,
				c0: method,
				dF: $elm$core$Maybe$Nothing,
				dK: url,
				e9: false
			});
	});
var $author$project$Api$get = function (url) {
	return A3($author$project$Api$requestJson, 'GET', url, $NoRedInk$http_upgrade_shim$Http$Legacy$emptyBody);
};
var $author$project$Api$Endpoint$Endpoint = $elm$core$Basics$identity;
var $author$project$Api$Endpoint$endpoint = function (segments) {
	return A2(
		$elm$url$Url$Builder$absolute,
		A2($elm$core$List$cons, 'api', segments),
		_List_Nil);
};
var $author$project$Api$Endpoint$personalEmployeeContentCollection = $author$project$Api$Endpoint$endpoint(
	_List_fromArray(
		['share', 'uploads']));
var $author$project$Data$EmployeeContent$getPersonalCollection = A2(
	$author$project$Api$get,
	$author$project$Api$Endpoint$personalEmployeeContentCollection,
	$elm$json$Json$Decode$list($author$project$Model$EmployeeContentResponse$employeeContentResponseDecoder));
var $author$project$Component$Modal$Confirm$Hidden = {$: 1};
var $author$project$Component$Modal$Confirm$hidden = $author$project$Component$Modal$Confirm$Hidden;
var $author$project$Api$httpLegacyToHttpError = function (err) {
	switch (err.$) {
		case 3:
			var response = err.a;
			return $author$project$Api$BadStatus(response.eW.d_);
		case 0:
			var url = err.a;
			return $author$project$Api$BadUrl(url);
		case 1:
			return $author$project$Api$Timeout;
		case 2:
			return $author$project$Api$NetworkError;
		default:
			var error = err.a;
			return $author$project$Api$DecodeError(error);
	}
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{T9: true, a2: r.a2, cH: r.cH, cL: r.cL, c0: r.c0, dF: r.dF, WM: r.WM, dK: r.dK}));
};
var $NoRedInk$http_upgrade_shim$Http$Legacy$send = F2(
	function (callback, _v0) {
		var method = _v0.c0;
		var headers = _v0.cL;
		var url = _v0.dK;
		var body = _v0.a2;
		var expect = _v0.cH;
		var timeout = _v0.dF;
		var withCredentials = _v0.e9;
		var request_ = {a2: body, cH: expect.cH, cL: headers, c0: method, dF: timeout, WM: $elm$core$Maybe$Nothing, dK: url};
		var handleResponse = function (response) {
			return callback(
				A2($elm$core$Result$andThen, expect.ba, response));
		};
		return A2(
			$elm$core$Platform$Cmd$map,
			handleResponse,
			withCredentials ? $elm$http$Http$riskyRequest(request_) : $elm$http$Http$request(request_));
	});
var $author$project$Api$send = function (msg) {
	return $NoRedInk$http_upgrade_shim$Http$Legacy$send(
		A2(
			$elm$core$Basics$composeL,
			msg,
			$elm$core$Result$mapError($author$project$Api$httpLegacyToHttpError)));
};
var $author$project$ShareToolEmployeeContentCollection$init = function (flags) {
	return _Utils_Tuple2(
		{
			cj: $elm$core$Maybe$Nothing,
			l6: $author$project$Component$Modal$Confirm$hidden,
			pS: flags.pS,
			pT: $author$project$Data$Status$Loading,
			CF: $author$project$Component$Notifications$emptyNotifications,
			OM: flags.OM,
			e$: A2($elm$time$Time$customZone, flags.Pn, _List_Nil),
			P$: flags.P$
		},
		A2($author$project$Api$send, $author$project$ShareToolEmployeeContentCollection$GotEmployeeContentStatus, $author$project$Data$EmployeeContent$getPersonalCollection));
};
var $author$project$ShareToolEmployeeContentCollection$DeleteEmployeeContent = function (a) {
	return {$: 1, a: a};
};
var $author$project$ShareToolEmployeeContentCollection$UpdateConfirmDelete = function (a) {
	return {$: 4, a: a};
};
var $author$project$ShareToolEmployeeContentCollection$confirmDeleteConfig = {
	a2: $elm$core$Basics$always($author$project$Copy$copy.hO),
	tA: $elm$core$Basics$always($author$project$Copy$copy.UJ),
	aK: $author$project$ShareToolEmployeeContentCollection$UpdateConfirmDelete,
	CT: $author$project$ShareToolEmployeeContentCollection$DeleteEmployeeContent
};
var $author$project$Component$Modal$Confirm$Close = {$: 2};
var $author$project$Component$Modal$Confirm$subscriptions = F2(
	function (config, confirm) {
		if (confirm.$ === 1) {
			return $elm$core$Platform$Sub$none;
		} else {
			return $elm$browser$Browser$Events$onKeyDown(
				A2(
					$author$project$Keyboard$matchKey,
					'Escape',
					config.aK($author$project$Component$Modal$Confirm$Close)));
		}
	});
var $author$project$ShareToolEmployeeContentCollection$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($author$project$Component$Modal$Confirm$subscriptions, $author$project$ShareToolEmployeeContentCollection$confirmDeleteConfig, model.l6)
			]));
};
var $author$project$ShareToolEmployeeContentCollection$DeleteToastById = function (a) {
	return {$: 5, a: a};
};
var $author$project$ShareToolEmployeeContentCollection$GotDeleteEmployeeContent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$delete = $author$project$Api$requestJson('DELETE');
var $author$project$Api$Endpoint$employeeContent = function (contentId) {
	return $author$project$Api$Endpoint$endpoint(
		_List_fromArray(
			[
				'employee-content',
				$author$project$Data$Id$toString(contentId)
			]));
};
var $author$project$Data$EmployeeContent$delete = function (contentId) {
	return A3(
		$author$project$Api$delete,
		$author$project$Api$Endpoint$employeeContent(contentId),
		$NoRedInk$http_upgrade_shim$Http$Legacy$emptyBody,
		$elm$json$Json$Decode$succeed(0));
};
var $author$project$Data$Status$Failure = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Status$Success = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$Status$fromResult = function (result) {
	if (!result.$) {
		var x = result.a;
		return $author$project$Data$Status$Success(x);
	} else {
		var err = result.a;
		return $author$project$Data$Status$Failure(err);
	}
};
var $author$project$Util$Translation$BadStatus = function (a) {
	return {$: 0, a: a};
};
var $author$project$Util$Translation$BadStatusDescription = function (a) {
	return {$: 1, a: a};
};
var $author$project$Util$Translation$BadUrlDescription = function (a) {
	return {$: 2, a: a};
};
var $author$project$Util$Translation$httpError = function (error) {
	switch (error.$) {
		case 0:
			var url = error.a;
			return {
				cD: $author$project$Util$Translation$translate(
					$author$project$Util$Translation$BadUrlDescription(url)),
				WC: $author$project$Copy$copy.iP
			};
		case 1:
			return {cD: $author$project$Copy$copy.Po, WC: $author$project$Copy$copy.dF};
		case 2:
			return {cD: $author$project$Copy$copy.Ac, WC: $author$project$Copy$copy.Ab};
		case 3:
			var statusCode = error.a;
			var title = function () {
				if (statusCode === 400) {
					return $author$project$Copy$copy.iO;
				} else {
					return $author$project$Util$Translation$translate(
						$author$project$Util$Translation$BadStatus(statusCode));
				}
			}();
			var description = function () {
				switch (statusCode) {
					case 404:
						return $author$project$Copy$copy.qh;
					case 413:
						return $author$project$Copy$copy.yO;
					case 500:
						return $author$project$Copy$copy.qi;
					default:
						var status = statusCode;
						return $author$project$Util$Translation$translate(
							$author$project$Util$Translation$BadStatusDescription(status));
				}
			}();
			return {cD: description, WC: title};
		case 4:
			var err = error.a;
			return {
				cD: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0} | {1}',
					_List_fromArray(
						[$author$project$Copy$copy.iN, err])),
				WC: $author$project$Copy$copy.iM
			};
		default:
			var err = error.a;
			return {
				cD: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0} | {1}',
					_List_fromArray(
						[$author$project$Copy$copy.iN, err])),
				WC: $author$project$Copy$copy.iM
			};
	}
};
var $author$project$Component$Notifications$Info = 3;
var $author$project$Component$Notifications$Notification = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Component$Notifications$NotificationId = $elm$core$Basics$identity;
var $author$project$Component$Notifications$addNotificationWithId = F3(
	function (level, content, _v0) {
		var counter = _v0.a;
		var notifications = _v0.b;
		return _Utils_Tuple2(
			counter,
			A2(
				$author$project$Component$Notifications$Notifications,
				counter + 1,
				A2(
					$elm$core$List$cons,
					A3($author$project$Component$Notifications$Notification, counter, content, level),
					notifications)));
	});
var $author$project$Component$Notifications$notify = F4(
	function (level, content, toMsg, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var _v1 = A3($author$project$Component$Notifications$addNotificationWithId, level, content, model.CF);
		var id = _v1.a;
		var notifications = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{CF: notifications}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always(
							toMsg(id)),
						$elm$core$Process$sleep(7500)),
						cmd
					])));
	});
var $author$project$Component$Notifications$notifySnackbar = function (description) {
	return A2(
		$author$project$Component$Notifications$notify,
		3,
		{cD: description, WC: ''});
};
var $author$project$Component$Notifications$removeNotification = F2(
	function (id, _v0) {
		var counter = _v0.a;
		var notifications = _v0.b;
		return A2(
			$author$project$Component$Notifications$Notifications,
			counter,
			A2(
				$elm$core$List$filter,
				function (_v1) {
					var id1 = _v1.a;
					return !_Utils_eq(id1, id);
				},
				notifications));
	});
var $author$project$Component$Modal$Confirm$NoOp = {$: 0};
var $author$project$Component$Modal$Confirm$Visible = function (a) {
	return {$: 0, a: a};
};
var $author$project$Component$Modal$Confirm$update = F3(
	function (_v0, msg, confirm) {
		var liftMsg = _v0.aK;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(confirm, $elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2($author$project$Component$Modal$Confirm$Hidden, $elm$core$Platform$Cmd$none);
			default:
				var a = msg.a;
				return _Utils_Tuple2(
					$author$project$Component$Modal$Confirm$Visible(a),
					A2(
						$elm$core$Platform$Cmd$map,
						liftMsg,
						A2(
							$elm$core$Task$attempt,
							$elm$core$Basics$always($author$project$Component$Modal$Confirm$NoOp),
							$elm$browser$Browser$Dom$focus('confirm-delete'))));
		}
	});
var $author$project$ShareToolEmployeeContentCollection$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var maybeId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cj: maybeId}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var contentId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l6: $author$project$Component$Modal$Confirm$hidden}),
					A2(
						$author$project$Api$send,
						$author$project$ShareToolEmployeeContentCollection$GotDeleteEmployeeContent,
						$author$project$Data$EmployeeContent$delete(contentId)));
			case 2:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						model,
						A2($author$project$Api$send, $author$project$ShareToolEmployeeContentCollection$GotEmployeeContentStatus, $author$project$Data$EmployeeContent$getPersonalCollection));
				} else {
					var err = msg.a.a;
					return A3(
						$author$project$Component$Notifications$notifySnackbar,
						$author$project$Util$Translation$httpError(err).cD,
						$author$project$ShareToolEmployeeContentCollection$DeleteToastById,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				}
			case 3:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							pT: $author$project$Data$Status$fromResult(result)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var msg_ = msg.a;
				var _v1 = A3($author$project$Component$Modal$Confirm$update, $author$project$ShareToolEmployeeContentCollection$confirmDeleteConfig, msg_, model.l6);
				var confirm = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{l6: confirm}),
					cmd);
			default:
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							CF: A2($author$project$Component$Notifications$removeNotification, id, model.CF)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Component$Button$Attribute = $elm$core$Basics$identity;
var $author$project$Component$Button$Button = $elm$core$Basics$identity;
var $author$project$Component$Button$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$Button$customCss = function (styles) {
	return $author$project$Component$Button$set(
		function (attribute) {
			return _Utils_update(
				attribute,
				{cB: styles});
		});
};
var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$Property = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2($rtfeldman$elm_css$Css$property, key, arg.dL);
	});
var $rtfeldman$elm_css$Css$marginRight = $rtfeldman$elm_css$Css$prop1('margin-right');
var $author$project$Component$Button$onClick = function (msg_) {
	return $author$project$Component$Button$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					bY: $elm$core$Maybe$Just(msg_)
				});
		});
};
var $author$project$Component$Button$OnlyIcon = function (a) {
	return {$: 3, a: a};
};
var $author$project$Component$Button$onlyIcon = function (iconPath) {
	return $author$project$Component$Button$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					aH: $author$project$Component$Button$OnlyIcon(iconPath)
				});
		});
};
var $author$project$Component$Button$OutlinePrimary = 3;
var $author$project$Component$Button$outlinePrimary = $author$project$Component$Button$set(
	function (attribute) {
		return _Utils_update(
			attribute,
			{W: 3});
	});
var $author$project$Component$Button$Primary = 0;
var $author$project$Component$Button$primary = $author$project$Component$Button$set(
	function (attribute) {
		return _Utils_update(
			attribute,
			{W: 0});
	});
var $rtfeldman$elm_css$Css$PxUnits = 0;
var $rtfeldman$elm_css$Css$Structure$Compatible = 0;
var $rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			fd: 0,
			j1: 0,
			bf: 0,
			E: 0,
			bT: 0,
			bk: 0,
			aq: 0,
			bl: 0,
			bm: 0,
			aI: 0,
			aJ: 0,
			ag: 0,
			bn: 0,
			as: numericValue,
			by: 0,
			bC: unitLabel,
			cd: units,
			dL: _Utils_ap(
				$elm$core$String$fromFloat(numericValue),
				unitLabel)
		};
	});
var $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'px');
var $author$project$Component$Button$ButtonTypeSubmit = 1;
var $author$project$Component$Button$Enabled = 1;
var $author$project$Component$Button$None = {$: 0};
var $author$project$Component$Button$WidthUnbounded = 1;
var $author$project$Component$Button$build = {a$: $elm$core$Maybe$Nothing, a4: 1, dY: '', nl: _List_Nil, cB: _List_Nil, aH: $author$project$Component$Button$None, bj: _List_Nil, bY: $elm$core$Maybe$Nothing, aT: 1, W: 0, bF: 1};
var $rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
	return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
		$elm$virtual_dom$VirtualDom$text(str));
};
var $rtfeldman$elm_css$Html$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
var $author$project$Component$Button$label = function (label_) {
	return $author$project$Component$Button$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					bj: _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label_)
						])
				});
		});
};
var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$batch = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles;
var $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1('border-radius');
var $rtfeldman$elm_css$Css$color = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'color', c.dL);
};
var $rtfeldman$elm_css$Css$cursor = $rtfeldman$elm_css$Css$prop1('cursor');
var $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1('display');
var $rtfeldman$elm_css$Css$fontWeight = function (_v0) {
	var value = _v0.dL;
	return A2($rtfeldman$elm_css$Css$property, 'font-weight', value);
};
var $rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Css$pseudoClass = function (_class) {
	return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
		$rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
};
var $rtfeldman$elm_css$Css$hover = $rtfeldman$elm_css$Css$pseudoClass('hover');
var $rtfeldman$elm_css$Css$inlineBlock = {q: 0, dL: 'inline-block'};
var $rtfeldman$elm_css$Css$noWrap = {bN: 0, cJ: 0, dL: 'nowrap', a_: 0};
var $rtfeldman$elm_css$Css$normal = {rf: 0, bO: 0, aF: 0, bn: 0, DY: 0, dL: 'normal', a_: 0};
var $rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.dL + (' ' + argB.dL));
	});
var $rtfeldman$elm_css$Css$padding2 = $rtfeldman$elm_css$Css$prop2('padding');
var $rtfeldman$elm_css$Css$pointer = {b: 0, dL: 'pointer'};
var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2($elm$core$String$startsWith, '#', str) ? str : A2($elm$core$String$cons, '#', str);
};
var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		gB: 1,
		jy: 0,
		lK: 0,
		s6: 0,
		GN: 0,
		dL: $rtfeldman$elm_css$Css$withPrecedingHash(str)
	};
};
var $elm$core$String$fromList = _String_fromList;
var $rtfeldman$elm_css$Css$validHex = F5(
	function (str, _v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		var toResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromList,
			A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
		var results = _Utils_Tuple2(
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[r1, r2])),
				toResult(
					_List_fromArray(
						[g1, g2]))),
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[b1, b2])),
				toResult(
					_List_fromArray(
						[a1, a2]))));
		if ((((!results.a.a.$) && (!results.a.b.$)) && (!results.b.a.$)) && (!results.b.b.$)) {
			var _v5 = results.a;
			var red = _v5.a.a;
			var green = _v5.b.a;
			var _v6 = results.b;
			var blue = _v6.a.a;
			var alpha = _v6.b.a;
			return {
				gB: alpha / 255,
				jy: blue,
				lK: 0,
				s6: green,
				GN: red,
				dL: $rtfeldman$elm_css$Css$withPrecedingHash(str)
			};
		} else {
			return $rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var $rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2($elm$core$String$startsWith, '#', str) ? A2($elm$core$String$dropLeft, 1, str) : str;
	var _v0 = $elm$core$String$toList(withoutHash);
	_v0$4:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v1 = _v0.b;
				var g = _v1.a;
				var _v2 = _v1.b;
				var b = _v2.a;
				return A5(
					$rtfeldman$elm_css$Css$validHex,
					str,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2('f', 'f'));
			} else {
				if (!_v0.b.b.b.b.b) {
					var r = _v0.a;
					var _v3 = _v0.b;
					var g = _v3.a;
					var _v4 = _v3.b;
					var b = _v4.a;
					var _v5 = _v4.b;
					var a = _v5.a;
					return A5(
						$rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(a, a));
				} else {
					if (_v0.b.b.b.b.b.b) {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v6 = _v0.b;
							var r2 = _v6.a;
							var _v7 = _v6.b;
							var g1 = _v7.a;
							var _v8 = _v7.b;
							var g2 = _v8.a;
							var _v9 = _v8.b;
							var b1 = _v9.a;
							var _v10 = _v9.b;
							var b2 = _v10.a;
							return A5(
								$rtfeldman$elm_css$Css$validHex,
								str,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2('f', 'f'));
						} else {
							if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
								var r1 = _v0.a;
								var _v11 = _v0.b;
								var r2 = _v11.a;
								var _v12 = _v11.b;
								var g1 = _v12.a;
								var _v13 = _v12.b;
								var g2 = _v13.a;
								var _v14 = _v13.b;
								var b1 = _v14.a;
								var _v15 = _v14.b;
								var b2 = _v15.a;
								var _v16 = _v15.b;
								var a1 = _v16.a;
								var _v17 = _v16.b;
								var a2 = _v17.a;
								return A5(
									$rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(a1, a2));
							} else {
								break _v0$4;
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
		} else {
			break _v0$4;
		}
	}
	return $rtfeldman$elm_css$Css$erroneousHex(str);
};
var $author$project$Component$Button$white = $rtfeldman$elm_css$Css$hex('ffffff');
var $rtfeldman$elm_css$Css$whiteSpace = $rtfeldman$elm_css$Css$prop1('white-space');
var $author$project$Component$Button$btn = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$normal),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$color($author$project$Component$Button$white),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]));
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Html$Styled$button = $rtfeldman$elm_css$Html$Styled$node('button');
var $rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 0:
					var str = style.a;
					var key = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, ':', str)));
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 1:
					var selector = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 2:
					var combinator = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 3:
					var pseudoElement = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 4:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 5:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _v1 = style.a;
							var only = _v1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _v2 = style.a;
							var first = _v2.a;
							var rest = _v2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '', 0);
var $rtfeldman$elm_css$Css$alignSelf = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignSelf',
		'align-self',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$center = $rtfeldman$elm_css$Css$prop1('center');
var $rtfeldman$elm_css$Css$flexEnd = $rtfeldman$elm_css$Css$prop1('flex-end');
var $rtfeldman$elm_css$Css$start = $rtfeldman$elm_css$Css$prop1('start');
var $author$project$Component$Button$buttonAlignmentToClass = function (buttonAlignment) {
	switch (buttonAlignment) {
		case 0:
			return $rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$start);
		case 1:
			return $rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$center);
		default:
			return $rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$flexEnd);
	}
};
var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'background-color', c.dL);
};
var $rtfeldman$elm_css$Css$prop3 = F4(
	function (key, argA, argB, argC) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.dL + (' ' + (argB.dL + (' ' + argC.dL))));
	});
var $rtfeldman$elm_css$Css$border3 = $rtfeldman$elm_css$Css$prop3('border');
var $rtfeldman$elm_css$Css$borderColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'border-color', c.dL);
};
var $author$project$Component$Button$brandColor1 = $rtfeldman$elm_css$Css$hex('132834');
var $author$project$Component$Button$brandColor2 = $rtfeldman$elm_css$Css$hex('f8bbbe');
var $author$project$Component$Button$btnSecondaryHover = $rtfeldman$elm_css$Css$hex('132834');
var $rtfeldman$elm_css$Css$solid = {K: 0, aV: 0, dL: 'solid'};
var $rtfeldman$elm_css$Css$transparent = {lK: 0, dL: 'transparent'};
var $author$project$Component$Button$buttonStyleToCss = function (buttonStyle) {
	switch (buttonStyle) {
		case 0:
			return $rtfeldman$elm_css$Css$batch(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$backgroundColor($author$project$Component$Button$brandColor1),
						$rtfeldman$elm_css$Css$color($author$project$Component$Button$white)
					]));
		case 1:
			return $rtfeldman$elm_css$Css$batch(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$backgroundColor($author$project$Component$Button$brandColor2),
						$rtfeldman$elm_css$Css$color($author$project$Component$Button$white)
					]));
		case 2:
			return $rtfeldman$elm_css$Css$batch(_List_Nil);
		case 3:
			return $rtfeldman$elm_css$Css$batch(
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$solid,
						$author$project$Component$Button$brandColor1),
						$rtfeldman$elm_css$Css$color($author$project$Component$Button$brandColor1),
						$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
						$rtfeldman$elm_css$Css$hover(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$borderColor($author$project$Component$Button$btnSecondaryHover),
								$rtfeldman$elm_css$Css$backgroundColor($author$project$Component$Button$btnSecondaryHover),
								$rtfeldman$elm_css$Css$color($author$project$Component$Button$white)
							]))
					]));
		default:
			return $rtfeldman$elm_css$Css$batch(
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(1),
						$rtfeldman$elm_css$Css$solid,
						$author$project$Component$Button$brandColor2),
						$rtfeldman$elm_css$Css$color($author$project$Component$Button$brandColor2),
						$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent)
					]));
	}
};
var $author$project$Component$Button$buttonTypeToString = function (buttonType) {
	if (!buttonType) {
		return 'button';
	} else {
		return 'submit';
	}
};
var $rtfeldman$elm_css$Css$border = $rtfeldman$elm_css$Css$prop1('border');
var $author$project$Component$Button$btnPrimaryHover = $rtfeldman$elm_css$Css$hex('050b0f');
var $rtfeldman$elm_css$Css$UnitlessInteger = 0;
var $rtfeldman$elm_css$Css$int = function (val) {
	return {
		aF: 0,
		cT: 0,
		aJ: 0,
		ag: 0,
		VO: 0,
		c6: 0,
		as: val,
		bC: '',
		cd: 0,
		dL: $elm$core$String$fromInt(val)
	};
};
var $rtfeldman$elm_css$Css$zIndex = $rtfeldman$elm_css$Css$prop1('z-index');
var $author$project$Component$Button$primaryButton = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$border(
			$rtfeldman$elm_css$Css$px(1)),
			$rtfeldman$elm_css$Css$borderColor($author$project$Component$Button$brandColor1),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Component$Button$brandColor1),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int(2)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$borderColor($author$project$Component$Button$btnPrimaryHover),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Component$Button$btnPrimaryHover)
				]))
		]));
var $author$project$Component$Button$secondaryButton = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Component$Button$brandColor1),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Component$Button$brandColor2),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$borderColor($author$project$Component$Button$btnSecondaryHover),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Component$Button$btnSecondaryHover),
					$rtfeldman$elm_css$Css$color($author$project$Component$Button$white)
				]))
		]));
var $author$project$Component$Button$buttonVariantToCss = function (buttonStyle) {
	switch (buttonStyle) {
		case 0:
			return $rtfeldman$elm_css$Css$batch(
				_List_fromArray(
					[$author$project$Component$Button$primaryButton]));
		case 1:
			return $rtfeldman$elm_css$Css$batch(
				_List_fromArray(
					[$author$project$Component$Button$secondaryButton]));
		default:
			return $rtfeldman$elm_css$Css$batch(_List_Nil);
	}
};
var $rtfeldman$elm_css$Css$maxWidth = $rtfeldman$elm_css$Css$prop1('max-width');
var $rtfeldman$elm_css$Css$none = {a0: 0, jx: 0, K: 0, b: 0, q: 0, Ve: 0, uX: 0, ek: 0, bm: 0, aI: 0, ag: 0, e: 0, c: 0, eD: 0, db: 0, V_: 0, ac: 0, dn: 0, Wf: 0, bx: 0, aW: 0, Q: 0, k: 0, WV: 0, dL: 'none'};
var $rtfeldman$elm_css$Css$PercentageUnits = 0;
var $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '%');
var $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1('width');
var $author$project$Component$Button$buttonWidthToCss = function (buttonWidth) {
	switch (buttonWidth) {
		case 1:
			return $rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$none);
		case 0:
			return $rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(100));
		default:
			return $rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$none);
	}
};
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 0:
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 1:
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 2:
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 3:
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 4:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 5:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 6:
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.UB) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.c4, record.UB, keyframesByName),
					declarations);
			case 7:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 8:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{UB: decl, c4: name});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactDeclarations = function (declarations) {
	var _v0 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v0.a;
	var compactedDeclarations = _v0.b;
	return A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
};
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var charset = _v0.kR;
	var imports = _v0.uD;
	var namespaces = _v0.z$;
	var declarations = _v0.UC;
	return {
		kR: charset,
		UC: $rtfeldman$elm_css$Css$Structure$compactDeclarations(declarations),
		uD: imports,
		z$: namespaces
	};
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var $rtfeldman$elm_css$Css$String$mapJoinHelp = F4(
	function (map, sep, strs, result) {
		mapJoinHelp:
		while (true) {
			if (!strs.b) {
				return result;
			} else {
				if (!strs.b.b) {
					var first = strs.a;
					return result + (map(first) + '');
				} else {
					var first = strs.a;
					var rest = strs.b;
					var $temp$map = map,
						$temp$sep = sep,
						$temp$strs = rest,
						$temp$result = result + (map(first) + (sep + ''));
					map = $temp$map;
					sep = $temp$sep;
					strs = $temp$strs;
					result = $temp$result;
					continue mapJoinHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$Css$String$mapJoin = F3(
	function (map, sep, strs) {
		return A4($rtfeldman$elm_css$Css$String$mapJoinHelp, map, sep, strs, '');
	});
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.re + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.dL)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType) {
		case 0:
			return 'print';
		case 1:
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 0:
			var expressions = mediaQuery.a;
			return A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, ' and ', expressions);
		case 1:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 2:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
		'\n',
		mediaQueries);
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		function (_v0) {
			var prop = _v0;
			return prop + ';';
		},
		'',
		properties);
};
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator) {
		case 0:
			return '+';
		case 1:
			return '~';
		case 2:
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 0:
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 1:
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 2:
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 0:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
		case 1:
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors);
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return $rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator) + (' ' + $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement));
	return A2(
		$elm$core$String$append,
		A2($elm$core$String$join, ' ', segments),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = function (_v0) {
	var firstSelector = _v0.a;
	var otherSelectors = _v0.b;
	var properties = _v0.c;
	var selectorStr = A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
		',',
		A2($elm$core$List$cons, firstSelector, otherSelectors));
	return selectorStr + ('{' + ($rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties) + '}'));
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 0:
			var styleBlock = decl.a;
			return $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(styleBlock);
		case 1:
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, ', ', mediaQueries);
			var blocks = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, '\n', styleBlocks);
			return '@media ' + (query + ('{' + (blocks + '}')));
		case 2:
			return 'TODO';
		case 3:
			return 'TODO';
		case 4:
			return 'TODO';
		case 5:
			return 'TODO';
		case 6:
			var name = decl.a.c4;
			var declaration = decl.a.UB;
			return '@keyframes ' + (name + ('{' + (declaration + '}')));
		case 7:
			return 'TODO';
		case 8:
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var charset = _v0.kR;
	var imports = _v0.uD;
	var namespaces = _v0.z$;
	var declarations = _v0.UC;
	return $rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$importToString, '\n', imports) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, '\n', namespaces) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, '\n', declarations) + '')));
};
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 8, a: a};
};
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 0:
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 1:
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2($elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 0:
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 1:
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 0:
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 1:
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 2:
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 3:
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 4:
							return declarations;
						case 5:
							return declarations;
						case 6:
							return declarations;
						case 7:
							return declarations;
						case 8:
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $robinheghan$murmur3$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {a5: charsProcessed, bi: hash, P: seed, bv: shift};
	});
var $robinheghan$murmur3$Murmur3$c1 = 3432918353;
var $robinheghan$murmur3$Murmur3$c2 = 461845907;
var $robinheghan$murmur3$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $robinheghan$murmur3$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $robinheghan$murmur3$Murmur3$finalize = function (data) {
	var acc = (!(!data.bi)) ? (data.P ^ A2(
		$robinheghan$murmur3$Murmur3$multiplyBy,
		$robinheghan$murmur3$Murmur3$c2,
		A2(
			$robinheghan$murmur3$Murmur3$rotlBy,
			15,
			A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, data.bi)))) : data.P;
	var h0 = acc ^ data.a5;
	var h1 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $robinheghan$murmur3$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$robinheghan$murmur3$Murmur3$multiplyBy,
			5,
			A2(
				$robinheghan$murmur3$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$robinheghan$murmur3$Murmur3$multiplyBy,
					$robinheghan$murmur3$Murmur3$c2,
					A2(
						$robinheghan$murmur3$Murmur3$rotlBy,
						15,
						A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, k1))))) + 3864292196;
	});
var $robinheghan$murmur3$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.bi | ((255 & $elm$core$Char$toCode(c)) << data.bv);
		var _v0 = data.bv;
		if (_v0 === 24) {
			return {
				a5: data.a5 + 1,
				bi: 0,
				P: A2($robinheghan$murmur3$Murmur3$mix, data.P, res),
				bv: 0
			};
		} else {
			return {a5: data.a5 + 1, bi: res, P: data.P, bv: data.bv + 8};
		}
	});
var $robinheghan$murmur3$Murmur3$hashString = F2(
	function (seed, str) {
		return $robinheghan$murmur3$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$robinheghan$murmur3$Murmur3$hashFold,
				A4($robinheghan$murmur3$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$initialSeed = 15739;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2($robinheghan$murmur3$Murmur3$hashString, $rtfeldman$elm_css$Hash$initialSeed, str)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 1) {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 9, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (!declaration.$) {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (!declaration.$) {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 0:
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 1:
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 2:
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 3:
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 4:
				return declaration;
			case 5:
				return declaration;
			case 6:
				return declaration;
			case 7:
				return declaration;
			case 8:
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0;
	return declarations;
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v14 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((!_v14.a.$) && (!_v14.b.$)) {
				var nextResultParent = _v14.a.a;
				var originalParent = _v14.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 0:
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 1:
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 2:
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 0:
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 1:
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 2:
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 3:
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 4:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$PageRule(properties)
									]);
							case 5:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 6:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 7:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 3:
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 5:
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{UB: str, c4: name})
							]));
				case 4:
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
	var firstSelector = _v2.a;
	var otherSelectors = _v2.b;
	var styles = _v2.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 0:
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 1:
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 2:
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 3:
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 4:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$PageRule(properties)
				]);
		case 5:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 6:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 7:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var charset = _v0.kR;
	var imports = _v0.uD;
	var namespaces = _v0.z$;
	var snippets = _v0.MM;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {kR: charset, UC: declarations, uD: imports, z$: namespaces};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {kR: $elm$core$Maybe$Nothing, uD: _List_Nil, z$: _List_Nil, MM: snippets};
};
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin = '\u0007';
var $rtfeldman$elm_css$VirtualDom$Styled$templateSelector = $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$ClassSelector($rtfeldman$elm_css$VirtualDom$Styled$classnameStandin)
		]));
var $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate = function (styles) {
	if (!styles.b) {
		return '';
	} else {
		var otherwise = styles;
		return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$VirtualDom$Styled$makeSnippet, styles, $rtfeldman$elm_css$VirtualDom$Styled$templateSelector)
					])));
	}
};
var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var cssTemplate = $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate(styles);
	var classProperty = A2($elm$virtual_dom$VirtualDom$attribute, '', '');
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, true, cssTemplate);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$disabled = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('disabled');
var $rtfeldman$elm_css$VirtualDom$Styled$on = F2(
	function (eventName, handler) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$on, eventName, handler),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Events$on = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Component$Button$btnDisabled = $rtfeldman$elm_css$Css$hex('c8ecec');
var $rtfeldman$elm_css$Css$notAllowed = {b: 0, dL: 'not-allowed'};
var $author$project$Component$Button$stateStyle = function (state) {
	if (!state) {
		return $rtfeldman$elm_css$Css$batch(
			_List_fromArray(
				[
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$Component$Button$btnDisabled),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Component$Button$btnDisabled),
					$rtfeldman$elm_css$Css$hover(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$notAllowed),
							A3(
							$rtfeldman$elm_css$Css$border3,
							$rtfeldman$elm_css$Css$px(1),
							$rtfeldman$elm_css$Css$solid,
							$author$project$Component$Button$btnDisabled),
							$rtfeldman$elm_css$Css$backgroundColor($author$project$Component$Button$btnDisabled)
						]))
				]));
	} else {
		return $rtfeldman$elm_css$Css$batch(_List_Nil);
	}
};
var $rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				return styles;
			} else {
				return A3(
					$elm$core$Dict$insert,
					cssTemplate,
					$rtfeldman$elm_css$Hash$fromString(cssTemplate),
					styles);
			}
		} else {
			return styles;
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string(classname));
			} else {
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string('_unstyled'));
			}
		} else {
			return val;
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', classname);
			} else {
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', '_unstyled');
			}
		} else {
			return val;
		}
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v6, _v7) {
		var key = _v6.a;
		var html = _v6.b;
		var pairs = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 4:
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v0) {
		var nodes = _v0.a;
		var styles = _v0.b;
		switch (html.$) {
			case 4:
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v2 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v2.a;
				var finalStyles = _v2.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration = F3(
	function (template, classname, declaration) {
		return declaration + ('\n' + A3($elm$core$String$replace, $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, classname, template));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return A3($elm$core$Dict$foldl, $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration, '', dict);
};
var $rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration = F2(
	function (scopingPrefix, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (template, classname, declaration) {
					return declaration + ('\n' + A3($elm$core$String$replace, '.' + $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, '#' + (scopingPrefix + ('.' + classname)), template));
				}),
			'',
			dict);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = F2(
	function (maybeNonce, accumulatedStyles) {
		var cssText = function () {
			if (!accumulatedStyles.$) {
				var allStyles = accumulatedStyles.a;
				return $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(allStyles);
			} else {
				var scope = accumulatedStyles.a;
				var rootStyles = accumulatedStyles.b;
				var descendantStyles = accumulatedStyles.c;
				return A2($rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration, scope, rootStyles) + ('\n' + A2($rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration, scope + ' ', descendantStyles));
			}
		}();
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			'span',
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'display: none;'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'class', 'elm-css-style-wrapper')
				]),
			_List_fromArray(
				[
					A3(
					$elm$virtual_dom$VirtualDom$node,
					'style',
					function () {
						if (!maybeNonce.$) {
							var nonce = maybeNonce.a;
							return _List_fromArray(
								[
									A2($elm$virtual_dom$VirtualDom$attribute, 'nonce', nonce)
								]);
						} else {
							return _List_Nil;
						}
					}(),
					$elm$core$List$singleton(
						$elm$virtual_dom$VirtualDom$text(cssText)))
				]));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F4(
	function (maybeNonce, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2(
			$rtfeldman$elm_css$VirtualDom$Styled$toStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles));
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F3(
	function (maybeNonce, accumulatedStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toStyleNode, maybeNonce, accumulatedStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F4(
	function (maybeNonce, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3(
			$rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles),
			keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F5(
	function (maybeNonce, ns, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3(
			$rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles),
			keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F5(
	function (maybeNonce, ns, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2(
			$rtfeldman$elm_css$VirtualDom$Styled$toStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles));
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 4:
			var plainNode = vdom.a;
			return plainNode;
		case 0:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyle, $elm$core$Maybe$Nothing, elemType, properties, children);
		case 1:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
		case 2:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, $elm$core$Maybe$Nothing, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$type_ = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('type');
var $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
var $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode = $rtfeldman$elm_css$VirtualDom$Styled$Unstyled;
var $rtfeldman$elm_css$Html$Styled$fromUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode;
var $rtfeldman$elm_css$Html$Styled$span = $rtfeldman$elm_css$Html$Styled$node('span');
var $author$project$Component$Button$viewButtonIcon = F3(
	function (style, icon, label_) {
		var toIcon = function () {
			if (!style) {
				return $author$project$View$Icon$viewMasked(0);
			} else {
				return $author$project$View$Icon$viewColored;
			}
		}();
		switch (icon.$) {
			case 0:
				return label_;
			case 2:
				var iconPath = icon.a;
				return A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('btn__icon')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
								toIcon(iconPath))
							])),
					label_);
			case 1:
				var iconPath = icon.a;
				return _Utils_ap(
					label_,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('btn__icon')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									toIcon(iconPath))
								]))
						]));
			default:
				var iconPath = icon.a;
				return A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('icon-btn')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
								toIcon(iconPath))
							])),
					label_);
		}
	});
var $author$project$Component$Button$viewButton = function (_v0) {
	var config = _v0;
	var onClickAttributes = function () {
		var _v3 = config.bY;
		if (!_v3.$) {
			var message = _v3.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick(message)
				]);
		} else {
			return _List_Nil;
		}
	}();
	var isDisabled = function () {
		var _v2 = config.aT;
		switch (_v2) {
			case 1:
				return false;
			case 0:
				return true;
			default:
				return true;
		}
	}();
	var alignmentStyle = function () {
		var _v1 = config.a$;
		if (!_v1.$) {
			var alignment = _v1.a;
			return $author$project$Component$Button$buttonAlignmentToClass(alignment);
		} else {
			return $rtfeldman$elm_css$Css$batch(_List_Nil);
		}
	}();
	var combinedStyles = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$batch(
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$Component$Button$btn,
						alignmentStyle,
						$author$project$Component$Button$buttonWidthToCss(config.bF),
						$author$project$Component$Button$buttonStyleToCss(config.W),
						$author$project$Component$Button$buttonVariantToCss(config.W),
						$author$project$Component$Button$stateStyle(config.aT)
					]),
				config.cB))
		]);
	var buttonAttributes = _Utils_ap(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(combinedStyles),
				$rtfeldman$elm_css$Html$Styled$Attributes$disabled(isDisabled),
				$rtfeldman$elm_css$Html$Styled$Attributes$type_(
				$author$project$Component$Button$buttonTypeToString(config.a4))
			]),
		onClickAttributes);
	return $rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			$rtfeldman$elm_css$Html$Styled$button,
			buttonAttributes,
			A3($author$project$Component$Button$viewButtonIcon, config.W, config.aH, config.bj)));
};
var $author$project$Component$Button$view = F2(
	function (name, attributes) {
		return $author$project$Component$Button$viewButton(
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v0, b) {
						var attribute = _v0;
						return attribute(b);
					}),
				$author$project$Component$Button$build,
				A2(
					$elm$core$List$cons,
					$author$project$Component$Button$label(name),
					attributes)));
	});
var $rtfeldman$elm_css$Css$padding = $rtfeldman$elm_css$Css$prop1('padding');
var $author$project$Component$Button$onlyIconButtonStyle = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent)
		]));
var $author$project$Component$Button$viewIconButton = function (_v0) {
	var config = _v0;
	var onClickAttributes = function () {
		var _v1 = config.bY;
		if (!_v1.$) {
			var message = _v1.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick(message)
				]);
		} else {
			return _List_Nil;
		}
	}();
	var iconStyle = _List_fromArray(
		[
			$rtfeldman$elm_css$Css$batch(
			_List_fromArray(
				[$author$project$Component$Button$onlyIconButtonStyle]))
		]);
	var buttonAttributes = _Utils_ap(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(iconStyle),
				$rtfeldman$elm_css$Html$Styled$Attributes$type_(
				$author$project$Component$Button$buttonTypeToString(config.a4))
			]),
		onClickAttributes);
	return $rtfeldman$elm_css$Html$Styled$toUnstyled(
		A2(
			$rtfeldman$elm_css$Html$Styled$button,
			buttonAttributes,
			A3($author$project$Component$Button$viewButtonIcon, config.W, config.aH, config.bj)));
};
var $author$project$Component$Button$viewIcon = function (attributes) {
	return $author$project$Component$Button$viewIconButton(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, b) {
					var attribute = _v0;
					return attribute(b);
				}),
			$author$project$Component$Button$build,
			attributes));
};
var $author$project$Component$Modal$Confirm$view = F2(
	function (config, confirm) {
		if (confirm.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			var a = confirm.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('confirm-modal open')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-background'),
								$elm$html$Html$Events$onClick(
								config.aK($author$project$Component$Modal$Confirm$Close))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-card')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal-card-header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h2,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												config.tA(a))
											])),
										$author$project$Component$Button$viewIcon(
										_List_fromArray(
											[
												$author$project$Component$Button$onlyIcon($author$project$View$Icon$path.VK),
												$author$project$Component$Button$onClick(
												config.aK($author$project$Component$Modal$Confirm$Close))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal-card-body')
									]),
								$author$project$Util$Html$parse(
									config.a2(a))),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('modal-card-footer')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Component$Button$view,
										$author$project$Copy$copy.Un,
										_List_fromArray(
											[
												$author$project$Component$Button$outlinePrimary,
												$author$project$Component$Button$onClick(
												config.aK($author$project$Component$Modal$Confirm$Close)),
												$author$project$Component$Button$customCss(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$marginRight(
														$rtfeldman$elm_css$Css$px(10))
													]))
											])),
										A2(
										$author$project$Component$Button$view,
										$author$project$Copy$copy.UJ,
										_List_fromArray(
											[
												$author$project$Component$Button$primary,
												$author$project$Component$Button$onClick(
												config.CT(a))
											]))
									]))
							]))
					]));
		}
	});
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $author$project$Component$Notifications$viewSnack = F2(
	function (removeNotificationMsg, _v0) {
		var id = _v0.a;
		var description = _v0.b.cD;
		return _Utils_Tuple2(
			$elm$core$String$fromInt(id),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('snackbar__snack')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(description)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								removeNotificationMsg(id)),
								$elm$html$Html$Attributes$class('remove')
							]),
						_List_fromArray(
							[
								$author$project$View$Icon$viewColored($author$project$View$Icon$path.VK)
							]))
					])));
	});
var $author$project$Component$Notifications$viewAsSnackbar = F2(
	function (removeNotificationMsg, _v0) {
		var notifications = _v0.b;
		return A2(
			$author$project$Util$View$viewIfNot,
			$elm$core$List$isEmpty(notifications),
			function (_v1) {
				return A3(
					$elm$html$Html$Keyed$node,
					'div',
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('snackbar')
						]),
					A2(
						$elm$core$List$map,
						$author$project$Component$Notifications$viewSnack(removeNotificationMsg),
						notifications));
			});
	});
var $author$project$Model$Translation$noUploadsFound = 'no-uploads-found';
var $author$project$Model$Translation$noUploadsFoundDescription = 'no-uploads-found-description';
var $author$project$Data$Entity$id = function (_v0) {
	var a = _v0.a;
	return a;
};
var $author$project$Model$Translation$caption = 'caption';
var $author$project$Model$Translation$feedback = 'feedback';
var $author$project$Component$Button$Right = function (a) {
	return {$: 1, a: a};
};
var $author$project$Component$Button$iconRight = function (iconPath) {
	return $author$project$Component$Button$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					aH: $author$project$Component$Button$Right(iconPath)
				});
		});
};
var $author$project$Model$Translation$noFeedbackYet = 'no-feedback-yet';
var $author$project$Component$Modal$Confirm$Show = function (a) {
	return {$: 1, a: a};
};
var $author$project$Component$Modal$Confirm$show = F2(
	function (_v0, a) {
		var liftMsg = _v0.aK;
		return liftMsg(
			$author$project$Component$Modal$Confirm$Show(a));
	});
var $author$project$Model$Translation$tags = 'tags';
var $author$project$Component$Button$unboundedWidth = $author$project$Component$Button$set(
	function (attributes) {
		return _Utils_update(
			attributes,
			{bF: 1});
	});
var $author$project$ShareToolEmployeeContentCollection$viewContentItemTag = function (_v0) {
	var tag = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ec-item__body__tag')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(tag.bj)
			]));
};
var $author$project$ShareToolEmployeeContentCollection$viewContentItemTags = function (tags) {
	return $elm$core$List$isEmpty(tags) ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('-')
			])) : A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ec-item__body__tags')
			]),
		A2($elm$core$List$map, $author$project$ShareToolEmployeeContentCollection$viewContentItemTag, tags));
};
var $author$project$Component$VideoPlayer$Attribute = $elm$core$Basics$identity;
var $author$project$Component$VideoPlayer$VideoPlayer = $elm$core$Basics$identity;
var $author$project$Component$VideoPlayer$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$VideoPlayer$controls = function (showControls) {
	return $author$project$Component$VideoPlayer$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{cw: showControls});
		});
};
var $author$project$Data$FilePath$AudioFilePath = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$FilePath$FilePath = $elm$core$Basics$identity;
var $author$project$Data$FilePath$ImageFilePath = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$FilePath$PdfFilePath = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$FilePath$UnknownFilePath = function (a) {
	return {$: 4, a: a};
};
var $author$project$Data$FilePath$VideoFilePath = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$MimeType$audioFileExtensions = $elm$core$Set$fromList(
	_List_fromArray(
		['mp3', 'wav']));
var $author$project$Data$MimeType$isAudio = function (mediaItem) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (extension) {
				return A2($elm$core$Set$member, extension, $author$project$Data$MimeType$audioFileExtensions);
			},
			$author$project$Data$MimeType$toFileExtension(mediaItem)));
};
var $author$project$Data$MimeType$pdfFileExtensions = $elm$core$Set$fromList(
	_List_fromArray(
		['pdf']));
var $author$project$Data$MimeType$isPdf = function (mediaItem) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (extension) {
				return A2($elm$core$Set$member, extension, $author$project$Data$MimeType$pdfFileExtensions);
			},
			$author$project$Data$MimeType$toFileExtension(mediaItem)));
};
var $author$project$Data$MimeType$videoFileExtensions = $elm$core$Set$fromList(
	_List_fromArray(
		['mp4', 'mov', 'flv', 'avi']));
var $author$project$Data$MimeType$isVideo = function (mediaItem) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (extension) {
				return A2($elm$core$Set$member, extension, $author$project$Data$MimeType$videoFileExtensions);
			},
			$author$project$Data$MimeType$toFileExtension(mediaItem)));
};
var $author$project$Data$MimeType$fromString = function (fileName) {
	return $author$project$Data$MimeType$isImage(fileName) ? $elm$core$Maybe$Just(0) : ($author$project$Data$MimeType$isPdf(fileName) ? $elm$core$Maybe$Just(1) : ($author$project$Data$MimeType$isVideo(fileName) ? $elm$core$Maybe$Just(2) : ($author$project$Data$MimeType$isSvg(fileName) ? $elm$core$Maybe$Just(3) : ($author$project$Data$MimeType$isAudio(fileName) ? $elm$core$Maybe$Just(4) : $elm$core$Maybe$Nothing))));
};
var $author$project$Data$FilePath$fromString = function (path) {
	var _v0 = _Utils_Tuple2(
		A2($elm$core$String$startsWith, '/', path),
		$author$project$Data$MimeType$fromString(path));
	if ((!_v0.a) && (!_v0.b.$)) {
		switch (_v0.b.a) {
			case 2:
				var _v1 = _v0.b.a;
				return $author$project$Data$FilePath$VideoFilePath(path);
			case 1:
				var _v2 = _v0.b.a;
				return $author$project$Data$FilePath$PdfFilePath(path);
			case 0:
				var _v3 = _v0.b.a;
				return $author$project$Data$FilePath$ImageFilePath(path);
			case 3:
				var _v4 = _v0.b.a;
				return $author$project$Data$FilePath$ImageFilePath(path);
			default:
				var _v5 = _v0.b.a;
				return $author$project$Data$FilePath$AudioFilePath(path);
		}
	} else {
		return $author$project$Data$FilePath$UnknownFilePath(path);
	}
};
var $author$project$Component$VideoPlayer$src = function (path) {
	return $author$project$Component$VideoPlayer$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					dA: $elm$core$Maybe$Just(path)
				});
		});
};
var $author$project$Util$Url$staticUrl = function (val) {
	return A2(
		$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
		'/static/uploads/{0}',
		_List_fromArray(
			[val]));
};
var $author$project$Data$FilePath$toStaticUrl = function (_v0) {
	var path = _v0;
	return A2(
		$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
		'/static/uploads/{0}',
		_List_fromArray(
			[path]));
};
var $author$project$Data$FilePath$toString = function (_v0) {
	var a = _v0;
	return a;
};
var $author$project$Component$VideoPlayer$build = {cn: false, cr: '', cw: false, c3: false, de: true, dA: $elm$core$Maybe$Nothing};
var $elm$html$Html$source = _VirtualDom_node('source');
var $author$project$Component$VideoPlayer$viewPlayer = function (_v0) {
	var config = _v0;
	var boolToString = function (bool) {
		return bool ? 'true' : 'false';
	};
	return A2(
		$author$project$Util$View$viewMaybe,
		config.dA,
		function (src_) {
			return A2(
				$elm$html$Html$video,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$autoplay(config.cn),
						$elm$html$Html$Attributes$controls(config.cw),
						A2(
						$elm$html$Html$Attributes$attribute,
						'muted',
						boolToString(config.c3)),
						$elm$html$Html$Attributes$class(config.cr),
						A2(
						$elm$html$Html$Attributes$attribute,
						'playsinline',
						boolToString(config.de))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$source,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src(
								$author$project$Data$FilePath$toString(src_))
							]),
						_List_Nil)
					]));
		});
};
var $author$project$Component$VideoPlayer$view = function (attributes) {
	return $author$project$Component$VideoPlayer$viewPlayer(
		A3(
			$elm$core$List$foldl,
			function (_v0) {
				var attribute = _v0;
				return attribute;
			},
			$author$project$Component$VideoPlayer$build,
			attributes));
};
var $author$project$ShareToolEmployeeContentCollection$viewMediaItem = F2(
	function (filePath, showControls) {
		var _v0 = $author$project$Data$FilePath$fromString(filePath);
		switch (_v0.$) {
			case 3:
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/static/images/audio-placeholder.png')
						]),
					_List_Nil);
			case 0:
				var videoFilePath = _v0.a;
				return $author$project$Component$VideoPlayer$view(
					_List_fromArray(
						[
							$author$project$Component$VideoPlayer$src(
							$author$project$Data$FilePath$toStaticUrl(videoFilePath)),
							$author$project$Component$VideoPlayer$controls(showControls)
						]));
			case 1:
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/static/images/pdf-placeholder.png')
						]),
					_List_Nil);
			case 2:
				var imageFilePath = _v0.a;
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(
							$author$project$Util$Url$staticUrl(
								$author$project$Data$FilePath$toString(imageFilePath)))
						]),
					_List_Nil);
			default:
				var unknownFilePath = _v0.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ec-header__media__placeholder')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Data$FilePath$toString(unknownFilePath))
						]));
		}
	});
var $author$project$ShareToolEmployeeContentCollection$viewContentItemUpload = function (_v0) {
	var src_ = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ec-item__body__upload')
			]),
		_List_fromArray(
			[
				A2($author$project$ShareToolEmployeeContentCollection$viewMediaItem, src_, true)
			]));
};
var $author$project$ShareToolEmployeeContentCollection$viewContentItemUploads = function (uploads) {
	return $elm$core$List$isEmpty(uploads) ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('media placeholder')
			])) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ec-item__body__uploads')
			]),
		A2($elm$core$List$map, $author$project$ShareToolEmployeeContentCollection$viewContentItemUpload, uploads));
};
var $author$project$ShareToolEmployeeContentCollection$viewLabeledContent = F2(
	function (heading, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ec__detail')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(heading)
						])),
					content
				]));
	});
var $author$project$Util$String$withDefault = F2(
	function (_default, value) {
		return $elm$core$String$isEmpty(value) ? _default : value;
	});
var $author$project$ShareToolEmployeeContentCollection$viewContentItemBody = F4(
	function (translations, _v0, uploads, allTags) {
		var contentId = _v0.a;
		var content = _v0.b;
		var translate = $author$project$Data$Translation$toString(translations);
		var itemTags = A2(
			$elm$core$List$filter,
			function (_v2) {
				var tag = _v2.b;
				return A2($elm$core$List$member, contentId, tag.v$);
			},
			allTags);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ec-item__body')
				]),
			_List_fromArray(
				[
					$author$project$ShareToolEmployeeContentCollection$viewContentItemUploads(uploads),
					A2(
					$author$project$ShareToolEmployeeContentCollection$viewLabeledContent,
					translate($author$project$Model$Translation$tags),
					$author$project$ShareToolEmployeeContentCollection$viewContentItemTags(itemTags)),
					A2(
					$author$project$ShareToolEmployeeContentCollection$viewLabeledContent,
					translate($author$project$Model$Translation$caption),
					$elm$html$Html$text(
						A2($author$project$Util$String$withDefault, '_', content.ki))),
					A2(
					$author$project$ShareToolEmployeeContentCollection$viewLabeledContent,
					translate($author$project$Model$Translation$feedback),
					$elm$html$Html$text(
						A2(
							$author$project$Util$String$withDefault,
							translate($author$project$Model$Translation$noFeedbackYet),
							content.rg))),
					A2(
					$author$project$Util$View$viewIf,
					!content.eW,
					function (_v1) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ec-item__body__btn-container')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Component$Button$view,
									$author$project$Copy$copy.TD,
									_List_fromArray(
										[
											$author$project$Component$Button$onClick(
											A2($author$project$Component$Modal$Confirm$show, $author$project$ShareToolEmployeeContentCollection$confirmDeleteConfig, contentId)),
											$author$project$Component$Button$iconRight($author$project$View$Icon$path.UJ),
											$author$project$Component$Button$unboundedWidth
										]))
								]));
					})
				]));
	});
var $author$project$ShareToolEmployeeContentCollection$SetActiveContentItemId = function (a) {
	return {$: 0, a: a};
};
var $ryan_haskell$date_format$DateFormat$DayOfMonthNumber = {$: 5};
var $ryan_haskell$date_format$DateFormat$dayOfMonthNumber = $ryan_haskell$date_format$DateFormat$DayOfMonthNumber;
var $ryan_haskell$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {WD: toAmPm, WE: toMonthAbbreviation, WF: toMonthName, bA: toOrdinalSuffix, WJ: toWeekdayAbbreviation, WK: toWeekdayName};
	});
var $ryan_haskell$date_format$DateFormat$Language$toDutchMonthName = function (month) {
	switch (month) {
		case 0:
			return 'januari';
		case 1:
			return 'februari';
		case 2:
			return 'maart';
		case 3:
			return 'april';
		case 4:
			return 'mei';
		case 5:
			return 'juni';
		case 6:
			return 'juli';
		case 7:
			return 'augustus';
		case 8:
			return 'september';
		case 9:
			return 'oktober';
		case 10:
			return 'november';
		default:
			return 'december';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toDutchSuffix = function (num) {
	return ((num > 20) || ((num === 1) || (num === 8))) ? 'ste' : 'de';
};
var $ryan_haskell$date_format$DateFormat$Language$toDutchWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'maandag';
		case 1:
			return 'dinsdag';
		case 2:
			return 'woensdag';
		case 3:
			return 'donderdag';
		case 4:
			return 'vrijdag';
		case 5:
			return 'zaterdag';
		default:
			return 'zondag';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryan_haskell$date_format$DateFormat$Language$dutch = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	$ryan_haskell$date_format$DateFormat$Language$toDutchMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toDutchMonthName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toDutchWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toDutchWeekdayName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm,
	$ryan_haskell$date_format$DateFormat$Language$toDutchSuffix);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.Nj, posixMinutes) < 0) {
					return posixMinutes + era.G;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $ryan_haskell$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.WD(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		nJ: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		zI: month,
		TQ: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).nJ;
	});
var $ryan_haskell$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $ryan_haskell$date_format$DateFormat$days = _List_fromArray(
	[6, 0, 1, 2, 3, 4, 5]);
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $ryan_haskell$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, 6),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryan_haskell$date_format$DateFormat$days)))));
	});
var $ryan_haskell$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryan_haskell$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $ryan_haskell$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $ryan_haskell$date_format$DateFormat$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).zI;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $ryan_haskell$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryan_haskell$date_format$DateFormat$months))));
	});
var $ryan_haskell$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryan_haskell$date_format$DateFormat$monthPair, zone, posix));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).TQ;
	});
var $ryan_haskell$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryan_haskell$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryan_haskell$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryan_haskell$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $ryan_haskell$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$core$String$toUpper = _String_toUpper;
var $ryan_haskell$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryan_haskell$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryan_haskell$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var firstDay = A2($ryan_haskell$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, firstDay);
		var daysSoFar = A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryan_haskell$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 0:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 1:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.bA(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 2:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 3:
				return language.WE(
					A2($elm$time$Time$toMonth, zone, posix));
			case 4:
				return language.WF(
					A2($elm$time$Time$toMonth, zone, posix));
			case 17:
				return $elm$core$String$fromInt(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 18:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.bA(num));
				}(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 5:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 6:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.bA(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 7:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 8:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 9:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.bA(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 10:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 11:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 12:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.bA(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 13:
				return language.WJ(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 14:
				return language.WK(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 19:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 20:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.bA(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 21:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 15:
				return A2(
					$elm$core$String$right,
					2,
					A2($ryan_haskell$date_format$DateFormat$year, zone, posix));
			case 16:
				return A2($ryan_haskell$date_format$DateFormat$year, zone, posix);
			case 22:
				return $elm$core$String$toUpper(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 23:
				return $elm$core$String$toLower(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 24:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 25:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 26:
				return $elm$core$String$fromInt(
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 27:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 28:
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 29:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 30:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 31:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 32:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 33:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 34:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 35:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryan_haskell$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryan_haskell$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryan_haskell$date_format$DateFormat$HourMilitaryFixed = {$: 25};
var $ryan_haskell$date_format$DateFormat$hourMilitaryFixed = $ryan_haskell$date_format$DateFormat$HourMilitaryFixed;
var $ryan_haskell$date_format$DateFormat$MinuteFixed = {$: 31};
var $ryan_haskell$date_format$DateFormat$minuteFixed = $ryan_haskell$date_format$DateFormat$MinuteFixed;
var $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated = {$: 3};
var $ryan_haskell$date_format$DateFormat$monthNameAbbreviated = $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated;
var $ryan_haskell$date_format$DateFormat$Text = function (a) {
	return {$: 36, a: a};
};
var $ryan_haskell$date_format$DateFormat$text = $ryan_haskell$date_format$DateFormat$Text;
var $ryan_haskell$date_format$DateFormat$YearNumber = {$: 16};
var $ryan_haskell$date_format$DateFormat$yearNumber = $ryan_haskell$date_format$DateFormat$YearNumber;
var $author$project$Util$Date$format = function (timeZone) {
	return A3(
		$ryan_haskell$date_format$DateFormat$formatWithLanguage,
		$ryan_haskell$date_format$DateFormat$Language$dutch,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$yearNumber,
				$ryan_haskell$date_format$DateFormat$text(' - '),
				$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$minuteFixed
			]),
		timeZone);
};
var $author$project$Model$Translation$status = 'status';
var $author$project$Model$Translation$statusApproved = 'status-approved';
var $author$project$Model$Translation$statusHonors = 'status-honors';
var $author$project$Model$Translation$statusPending = 'status-pending';
var $author$project$Model$Translation$statusRetry = 'status-retry';
var $author$project$Data$EmployeeContent$statusToTranslationName = function (status) {
	switch (status) {
		case 0:
			return $author$project$Model$Translation$statusPending;
		case 1:
			return $author$project$Model$Translation$statusRetry;
		case 2:
			return $author$project$Model$Translation$statusApproved;
		default:
			return $author$project$Model$Translation$statusHonors;
	}
};
var $author$project$ShareToolEmployeeContentCollection$viewEmployeeContentStatus = F2(
	function (translations, status) {
		var toStatusClass = function () {
			switch (status) {
				case 0:
					return 'pending';
				case 1:
					return 'retry';
				case 2:
					return 'approved';
				default:
					return 'honors';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ec__detail')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$status)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(toStatusClass)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Data$Translation$text,
							translations,
							$author$project$Data$EmployeeContent$statusToTranslationName(status))
						]))
				]));
	});
var $author$project$Data$EmployeeContent$statusToRating = function (status) {
	switch (status) {
		case 0:
			return 1;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $author$project$ShareToolEmployeeContentCollection$viewEmptyStar = $author$project$View$Icon$viewColored($author$project$View$Icon$path.Ni);
var $author$project$ShareToolEmployeeContentCollection$viewFullStar = $author$project$View$Icon$viewColored($author$project$View$Icon$path.Nh);
var $author$project$ShareToolEmployeeContentCollection$viewEmployeeContentStatusRating = function (status) {
	var viewRating = F2(
		function (filled, total) {
			return $elm$core$List$concat(
				_List_fromArray(
					[
						A2($elm$core$List$repeat, filled, $author$project$ShareToolEmployeeContentCollection$viewFullStar),
						A2($elm$core$List$repeat, total - filled, $author$project$ShareToolEmployeeContentCollection$viewEmptyStar)
					]));
		});
	var maxRating = 3;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ec-item__header__status')
			]),
		A2(
			viewRating,
			$author$project$Data$EmployeeContent$statusToRating(status),
			maxRating));
};
var $author$project$ShareToolEmployeeContentCollection$viewContentItemHeaderDetails = F3(
	function (translations, timeZone, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ec-header__details')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ec-header__details__date')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Util$Date$format, timeZone, content.u_))
						])),
					A2($author$project$ShareToolEmployeeContentCollection$viewEmployeeContentStatus, translations, content.eW),
					$author$project$ShareToolEmployeeContentCollection$viewEmployeeContentStatusRating(content.eW)
				]));
	});
var $author$project$ShareToolEmployeeContentCollection$viewContentItemHeaderUploads = function (uploads) {
	if (!uploads.b) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('media placeholder')
				]));
	} else {
		if (!uploads.b.b) {
			var _v1 = uploads.a;
			var src_ = _v1.b;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ec-header__media')
					]),
				_List_fromArray(
					[
						A2($author$project$ShareToolEmployeeContentCollection$viewMediaItem, src_, false)
					]));
		} else {
			var _v2 = uploads.a;
			var src_ = _v2.b;
			var xs = uploads.b;
			var count = $elm$core$String$fromInt(
				$elm$core$List$length(xs));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ec-header__media')
					]),
				_List_fromArray(
					[
						A2($author$project$ShareToolEmployeeContentCollection$viewMediaItem, src_, false),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ec-header__counter')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
									'+{0}',
									_List_fromArray(
										[count])))
							]))
					]));
		}
	}
};
var $author$project$ShareToolEmployeeContentCollection$viewContentItemHeader = F5(
	function (translations, timeZone, _v0, uploads, isActive) {
		var contentId = _v0.a;
		var content = _v0.b;
		var toMsg = isActive ? $author$project$ShareToolEmployeeContentCollection$SetActiveContentItemId($elm$core$Maybe$Nothing) : $author$project$ShareToolEmployeeContentCollection$SetActiveContentItemId(
			$elm$core$Maybe$Just(contentId));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('ec-header', true),
							_Utils_Tuple2('is-active', isActive)
						])),
					$elm$html$Html$Events$onClick(toMsg)
				]),
			_List_fromArray(
				[
					$author$project$ShareToolEmployeeContentCollection$viewContentItemHeaderUploads(uploads),
					A3($author$project$ShareToolEmployeeContentCollection$viewContentItemHeaderDetails, translations, timeZone, content),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('ec-header__arrow', true),
									_Utils_Tuple2('is-active', isActive)
								]))
						]),
					_List_Nil)
				]));
	});
var $author$project$ShareToolEmployeeContentCollection$viewContentItem = F5(
	function (translations, timeZone, activeContentId, tags, _v0) {
		var employeeContentEntity = _v0.pV;
		var employeeContentUploads = _v0.pX;
		var isActive = _Utils_eq(
			activeContentId,
			$elm$core$Maybe$Just(
				$author$project$Data$Entity$id(employeeContentEntity)));
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A5($author$project$ShareToolEmployeeContentCollection$viewContentItemHeader, translations, timeZone, employeeContentEntity, employeeContentUploads, isActive),
					A2(
					$author$project$Util$View$viewIf,
					isActive,
					function (_v1) {
						return A4($author$project$ShareToolEmployeeContentCollection$viewContentItemBody, translations, employeeContentEntity, employeeContentUploads, tags);
					})
				]));
	});
var $author$project$Data$Entity$value = function (_v0) {
	var b = _v0.b;
	return b;
};
var $author$project$ShareToolEmployeeContentCollection$viewEmployeeBanner = F2(
	function (employee, items) {
		var totalStarCount = A3(
			$elm$core$List$foldl,
			A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Basics$add, $author$project$Data$EmployeeContent$statusToRating),
						function ($) {
							return $.eW;
						}),
					$author$project$Data$Entity$value),
				function ($) {
					return $.pV;
				}),
			0,
			items);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ec-employee-banner')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ec-employee-banner__greeting')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
								'Hi {0}!',
								_List_fromArray(
									[employee.r3])))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ec-employee-banner__star-count')
						]),
					_List_fromArray(
						[
							$author$project$ShareToolEmployeeContentCollection$viewFullStar,
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(totalStarCount))
								]))
						]))
				]));
	});
var $author$project$ShareToolEmployeeContentCollection$viewEmployeeContent = F6(
	function (translations, timeZone, employee, activeContentId, tags, items) {
		return $elm$core$List$isEmpty(items) ? $author$project$Component$Message$view(
			{
				cD: A2($author$project$Data$Translation$toString, translations, $author$project$Model$Translation$noUploadsFoundDescription),
				ec: $elm$core$Maybe$Nothing,
				WC: A2($author$project$Data$Translation$toString, translations, $author$project$Model$Translation$noUploadsFound)
			}) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$ShareToolEmployeeContentCollection$viewEmployeeBanner, employee, items),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ec-list')
						]),
					A2(
						$elm$core$List$map,
						A4($author$project$ShareToolEmployeeContentCollection$viewContentItem, translations, timeZone, activeContentId, tags),
						items))
				]));
	});
var $author$project$Component$Message$viewError = function (error) {
	var _v0 = $author$project$Util$Translation$httpError(error);
	var title = _v0.WC;
	var description = _v0.cD;
	return $author$project$Component$Message$view(
		{cD: description, ec: $elm$core$Maybe$Nothing, WC: title});
};
var $author$project$Util$View$viewLoader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('loading-spinner')
		]),
	_List_Nil);
var $author$project$Util$View$viewPageLoader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('loading-page-container')
		]),
	_List_fromArray(
		[$author$project$Util$View$viewLoader]));
var $author$project$Data$Status$viewSuccess = F2(
	function (status, f) {
		switch (status.$) {
			case 0:
				return $elm$html$Html$text('');
			case 1:
				return $author$project$Util$View$viewPageLoader;
			case 2:
				var error = status.a;
				return $author$project$Component$Message$viewError(error);
			default:
				var a = status.a;
				return f(a);
		}
	});
var $author$project$ShareToolEmployeeContentCollection$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('page-container')
			]),
		_List_fromArray(
			[
				A2($author$project$Component$Modal$Confirm$view, $author$project$ShareToolEmployeeContentCollection$confirmDeleteConfig, model.l6),
				A2($author$project$Component$Notifications$viewAsSnackbar, $author$project$ShareToolEmployeeContentCollection$DeleteToastById, model.CF),
				A2(
				$author$project$Data$Status$viewSuccess,
				model.pT,
				A5($author$project$ShareToolEmployeeContentCollection$viewEmployeeContent, model.P$, model.e$, model.pS, model.cj, model.OM))
			]));
};
var $author$project$ShareToolEmployeeContentCollection$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$ShareToolEmployeeContentCollection$decodeFlags,
	{cR: $author$project$ShareToolEmployeeContentCollection$init, dC: $author$project$ShareToolEmployeeContentCollection$subscriptions, dJ: $author$project$ShareToolEmployeeContentCollection$update, dM: $author$project$ShareToolEmployeeContentCollection$view});
var $author$project$SalaryCalculator$Flags = F2(
	function (salaryCalculators, plainText) {
		return {E9: plainText, aR: salaryCalculators};
	});
var $author$project$Model$SalaryCalculator$SalaryCalculator = function (domainId) {
	return function (vacancyId) {
		return function (label) {
			return function (extraDescription) {
				return function (minHours) {
					return function (maxHours) {
						return function (factorBelowThreshold) {
							return function (salaries) {
								return function (inserted) {
									return function (updated) {
										return {cF: domainId, qT: extraDescription, q4: factorBelowThreshold, u_: inserted, bj: label, er: maxHours, eu: minHours, aQ: salaries, QH: updated, R6: vacancyId};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$Salary$Salaries = $elm$core$Basics$identity;
var $author$project$Model$Salary$Salary = F2(
	function (age, perHour) {
		return {gd: age, EJ: perHour};
	});
var $author$project$Model$Salary$salaryDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'perHour',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'age',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Model$Salary$Salary)));
var $author$project$Model$Salary$salariesDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	$langyu_app$elm_ancillary_nonempty_list$List$Nonempty$Ancillary$decodeArray($author$project$Model$Salary$salaryDecoder));
var $author$project$Model$SalaryCalculator$salaryCalculatorDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'salaryCalculatorUpdated',
	$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'salaryCalculatorInserted',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'salaryCalculatorSalaries',
			$author$project$Model$Salary$salariesDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'salaryCalculatorFactorBelowThreshold',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'salaryCalculatorMaxHours',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'salaryCalculatorMinHours',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'salaryCalculatorExtraDescription',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'salaryCalculatorLabel',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'salaryCalculatorVacancyId',
									$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'salaryCalculatorDomainId',
										$author$project$Data$Id$decoder,
										$elm$json$Json$Decode$succeed($author$project$Model$SalaryCalculator$SalaryCalculator)))))))))));
var $author$project$SalaryCalculator$decodeFlags = A3(
	$elm$json$Json$Decode$map2,
	$author$project$SalaryCalculator$Flags,
	A2(
		$elm$json$Json$Decode$field,
		'salaryCalculators',
		$langyu_app$elm_ancillary_nonempty_list$List$Nonempty$Ancillary$decodeArray(
			$author$project$Data$Entity$decoder($author$project$Model$SalaryCalculator$salaryCalculatorDecoder))),
	A2($elm$json$Json$Decode$field, 'plainText', $author$project$Model$Content$PlainText$plainTextDecoder));
var $mgold$elm_nonempty_list$List$Nonempty$head = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return x;
};
var $author$project$View$SalaryCalculator$State = $elm$core$Basics$identity;
var $author$project$View$SalaryCalculator$getMaxHours = function (salaryCalculatorEntity) {
	return A2(
		$elm$core$Maybe$withDefault,
		40,
		$author$project$Data$Entity$value(salaryCalculatorEntity).er);
};
var $elm$core$List$sortWith = _List_sortWith;
var $mgold$elm_nonempty_list$List$Nonempty$insertWith = F3(
	function (cmp, hd, aList) {
		if (aList.b) {
			var x = aList.a;
			var xs = aList.b;
			return (!A2(cmp, x, hd)) ? A2(
				$mgold$elm_nonempty_list$List$Nonempty$Nonempty,
				x,
				A2(
					$elm$core$List$sortWith,
					cmp,
					A2($elm$core$List$cons, hd, xs))) : A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, hd, aList);
		} else {
			return A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, hd, _List_Nil);
		}
	});
var $elm$core$List$sortBy = _List_sortBy;
var $mgold$elm_nonempty_list$List$Nonempty$sortBy = F2(
	function (f, _v0) {
		var x = _v0.a;
		var xs = _v0.b;
		return A3(
			$mgold$elm_nonempty_list$List$Nonempty$insertWith,
			F2(
				function (a, b) {
					return A2(
						$elm$core$Basics$compare,
						f(a),
						f(b));
				}),
			x,
			A2($elm$core$List$sortBy, f, xs));
	});
var $author$project$Data$SalaryCalculator$toNonEmptySalaries = function (_v0) {
	var salaries = _v0;
	return salaries;
};
var $author$project$Data$SalaryCalculator$minAge = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.aQ;
	},
	A2(
		$elm$core$Basics$composeR,
		$author$project$Data$SalaryCalculator$toNonEmptySalaries,
		A2(
			$elm$core$Basics$composeR,
			$mgold$elm_nonempty_list$List$Nonempty$sortBy(
				function ($) {
					return $.gd;
				}),
			A2(
				$elm$core$Basics$composeR,
				$mgold$elm_nonempty_list$List$Nonempty$head,
				function ($) {
					return $.gd;
				}))));
var $author$project$View$SalaryCalculator$init = function (salaryCalculatorEntity) {
	return {
		gd: $author$project$Data$SalaryCalculator$minAge(
			$author$project$Data$Entity$value(salaryCalculatorEntity)),
		t1: $author$project$View$SalaryCalculator$getMaxHours(salaryCalculatorEntity),
		au: salaryCalculatorEntity
	};
};
var $author$project$SalaryCalculator$init = function (flags) {
	return _Utils_Tuple2(
		{
			E9: flags.E9,
			IW: $author$project$View$SalaryCalculator$init(
				$mgold$elm_nonempty_list$List$Nonempty$head(flags.aR)),
			aR: flags.aR
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$SalaryCalculator$update = F2(
	function (state, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{IW: state}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$View$SalaryCalculator$getMinHours = function (salaryCalculatorEntity) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		$author$project$Data$Entity$value(salaryCalculatorEntity).eu);
};
var $mgold$elm_nonempty_list$List$Nonempty$isSingleton = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return $elm$core$List$isEmpty(xs);
};
var $author$project$View$SalaryCalculator$setAge = F2(
	function (_v0, i) {
		var state = _v0;
		return _Utils_update(
			state,
			{gd: i});
	});
var $author$project$View$SalaryCalculator$setHours = F2(
	function (_v0, i) {
		var state = _v0;
		return _Utils_update(
			state,
			{t1: i});
	});
var $author$project$View$SalaryCalculator$getFactor = function (salaryCalculatorEntity) {
	return $author$project$Data$Entity$value(salaryCalculatorEntity).q4;
};
var $cuducos$elm_format_number$FormatNumber$Locales$Exact = function (a) {
	return {$: 2, a: a};
};
var $author$project$Util$Mustache$Variable = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {UA: decimals, u2: integers, DK: original, dg: prefix, dD: suffix};
	});
var $cuducos$elm_format_number$FormatNumber$Parser$Negative = 2;
var $cuducos$elm_format_number$FormatNumber$Parser$Positive = 0;
var $cuducos$elm_format_number$FormatNumber$Parser$Zero = 1;
var $cuducos$elm_format_number$FormatNumber$Parser$classify = function (formatted) {
	var onlyZeros = A2(
		$elm$core$String$all,
		function (_char) {
			return _char === '0';
		},
		$elm$core$String$concat(
			A2(
				$elm$core$List$append,
				formatted.u2,
				$elm$core$List$singleton(formatted.UA))));
	return onlyZeros ? 1 : ((formatted.DK < 0) ? 2 : 0);
};
var $elm$core$String$filter = _String_filter;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit = F2(
	function (desiredLength, value) {
		var length = $elm$core$String$length(value);
		var missing = (_Utils_cmp(length, desiredLength) < 0) ? $elm$core$Basics$abs(desiredLength - length) : 0;
		return _Utils_ap(
			value,
			A2($elm$core$String$repeat, missing, '0'));
	});
var $cuducos$elm_format_number$FormatNumber$Parser$removeZeros = function (decimals) {
	return (A2($elm$core$String$right, 1, decimals) !== '0') ? decimals : $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(
		A2($elm$core$String$dropRight, 1, decimals));
};
var $cuducos$elm_format_number$FormatNumber$Parser$getDecimals = F2(
	function (locale, digits) {
		var _v0 = locale.UA;
		switch (_v0.$) {
			case 1:
				return $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(digits);
			case 2:
				return digits;
			default:
				var min = _v0.a;
				return A2($cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit, min, digits);
		}
	});
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $cuducos$elm_format_number$FormatNumber$Parser$splitInParts = F2(
	function (locale, value) {
		var toString = function () {
			var _v1 = locale.UA;
			switch (_v1.$) {
				case 1:
					var max = _v1.a;
					return $myrho$elm_round$Round$round(max);
				case 0:
					return $elm$core$String$fromFloat;
				default:
					var exact = _v1.a;
					return $myrho$elm_round$Round$round(exact);
			}
		}();
		var asList = A2(
			$elm$core$String$split,
			'.',
			toString(value));
		var decimals = function () {
			var _v0 = $elm$core$List$tail(asList);
			if (!_v0.$) {
				var values = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(values));
			} else {
				return '';
			}
		}();
		var integers = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(asList));
		return _Utils_Tuple2(integers, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$splitByIndian = function (integers) {
	var thousand = ($elm$core$String$length(integers) > 3) ? A2($elm$core$String$right, 3, integers) : integers;
	var reversedSplitHundreds = function (value) {
		return ($elm$core$String$length(value) > 2) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 2, value),
			reversedSplitHundreds(
				A2($elm$core$String$dropRight, 2, value))) : ((!$elm$core$String$length(value)) ? _List_Nil : _List_fromArray(
			[value]));
	};
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$cons,
			thousand,
			reversedSplitHundreds(
				A2($elm$core$String$dropRight, 3, integers))));
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitByWestern = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitIntegers = F2(
	function (system, integers) {
		if (!system) {
			return $cuducos$elm_format_number$FormatNumber$Parser$splitByWestern(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, integers));
		} else {
			return $cuducos$elm_format_number$FormatNumber$Parser$splitByIndian(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, integers));
		}
	});
var $cuducos$elm_format_number$FormatNumber$Parser$parse = F2(
	function (locale, original) {
		var parts = A2($cuducos$elm_format_number$FormatNumber$Parser$splitInParts, locale, original);
		var integers = A2(
			$cuducos$elm_format_number$FormatNumber$Parser$splitIntegers,
			locale.OD,
			A2($elm$core$String$filter, $elm$core$Char$isDigit, parts.a));
		var decimals = A2($cuducos$elm_format_number$FormatNumber$Parser$getDecimals, locale, parts.b);
		var partial = A5($cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber, original, integers, decimals, '', '');
		var _v0 = $cuducos$elm_format_number$FormatNumber$Parser$classify(partial);
		switch (_v0) {
			case 2:
				return _Utils_update(
					partial,
					{dg: locale.eA, dD: locale.eB});
			case 0:
				return _Utils_update(
					partial,
					{dg: locale.Fn, dD: locale.Fo});
			default:
				return _Utils_update(
					partial,
					{dg: locale.T1, dD: locale.T2});
		}
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals = F2(
	function (locale, decimals) {
		return (decimals === '') ? '' : _Utils_ap(locale.aA, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$stringfy = F2(
	function (locale, formatted) {
		var stringfyDecimals = $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals(locale);
		var integers = A2($elm$core$String$join, locale.ax, formatted.u2);
		var decimals = stringfyDecimals(formatted.UA);
		return $elm$core$String$concat(
			_List_fromArray(
				[formatted.dg, integers, decimals, formatted.dD]));
	});
var $cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A2(
			$cuducos$elm_format_number$FormatNumber$Stringfy$stringfy,
			locale,
			A2($cuducos$elm_format_number$FormatNumber$Parser$parse, locale, number_));
	});
var $cuducos$elm_format_number$FormatNumber$Locales$Min = function (a) {
	return {$: 0, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Western = 0;
var $cuducos$elm_format_number$FormatNumber$Locales$base = {
	aA: '.',
	UA: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
	eA: '−',
	eB: '',
	Fn: '',
	Fo: '',
	OD: 0,
	ax: '',
	T1: '',
	T2: ''
};
var $cuducos$elm_format_number$FormatNumber$Locales$frenchLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$base,
	{
		aA: ',',
		UA: $cuducos$elm_format_number$FormatNumber$Locales$Exact(3),
		ax: '\u202F'
	});
var $mgold$elm_nonempty_list$List$Nonempty$foldl = F3(
	function (f, b, _v0) {
		var x = _v0.a;
		var xs = _v0.b;
		return A3(
			$elm$core$List$foldl,
			f,
			b,
			A2($elm$core$List$cons, x, xs));
	});
var $author$project$Util$NonEmpty$find = function (f) {
	return A2(
		$mgold$elm_nonempty_list$List$Nonempty$foldl,
		F2(
			function (x, acc) {
				if (acc.$ === 1) {
					return f(x) ? $elm$core$Maybe$Just(x) : $elm$core$Maybe$Nothing;
				} else {
					return acc;
				}
			}),
		$elm$core$Maybe$Nothing);
};
var $author$project$Data$SalaryCalculator$getSalaryPerHour = function (age) {
	return A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.aQ;
		},
		A2(
			$elm$core$Basics$composeR,
			$author$project$Data$SalaryCalculator$toNonEmptySalaries,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Util$NonEmpty$find(
					function (v) {
						return _Utils_eq(v.gd, age);
					}),
				$elm$core$Maybe$map(
					function ($) {
						return $.EJ;
					}))));
};
var $author$project$Data$SalaryCalculator$hourConfig = function (weeklyHours) {
	var monthlyHours = weeklyHours * 4.3;
	var yearlyHours = monthlyHours * 12;
	return {ey: monthlyHours, e8: weeklyHours, fb: yearlyHours};
};
var $mgold$elm_nonempty_list$List$Nonempty$reverse = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	var revapp = function (_v1) {
		revapp:
		while (true) {
			var ls = _v1.a;
			var c = _v1.b;
			var rs = _v1.c;
			if (!rs.b) {
				return A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, c, ls);
			} else {
				var r = rs.a;
				var rss = rs.b;
				var $temp$_v1 = _Utils_Tuple3(
					A2($elm$core$List$cons, c, ls),
					r,
					rss);
				_v1 = $temp$_v1;
				continue revapp;
			}
		}
	};
	return revapp(
		_Utils_Tuple3(_List_Nil, x, xs));
};
var $author$project$Data$SalaryCalculator$maxSalaryPerHour = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.aQ;
	},
	A2(
		$elm$core$Basics$composeR,
		$author$project$Data$SalaryCalculator$toNonEmptySalaries,
		A2(
			$elm$core$Basics$composeR,
			$mgold$elm_nonempty_list$List$Nonempty$sortBy(
				function ($) {
					return $.EJ;
				}),
			A2(
				$elm$core$Basics$composeR,
				$mgold$elm_nonempty_list$List$Nonempty$reverse,
				A2(
					$elm$core$Basics$composeR,
					$mgold$elm_nonempty_list$List$Nonempty$head,
					function ($) {
						return $.EJ;
					})))));
var $author$project$Util$Mustache$headSafe = function (xs) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Maybe$Nothing,
		$elm$core$List$head(xs));
};
var $author$project$Util$Mustache$toCapitalCase = function (str) {
	return _Utils_ap(
		$elm$core$String$toUpper(
			A2($elm$core$String$left, 1, str)),
		A2($elm$core$String$dropLeft, 1, str));
};
var $elm$core$String$words = _String_words;
var $author$project$Util$Mustache$toKeyString = function (str) {
	return A3(
		$elm$core$String$replace,
		'}',
		'',
		A3(
			$elm$core$String$replace,
			'{',
			'',
			A3(
				$elm$core$String$replace,
				' ',
				'',
				A2(
					$elm$core$String$join,
					'',
					A2(
						$elm$core$List$map,
						$author$project$Util$Mustache$toCapitalCase,
						$elm$core$String$words(
							$elm$core$String$toLower(str)))))));
};
var $author$project$Util$Mustache$isKey = F4(
	function (key_, val, def, matchValue) {
		return _Utils_eq(
			A2($elm$core$Maybe$map, $author$project$Util$Mustache$toKeyString, matchValue),
			$elm$core$Maybe$Just(key_)) ? val : def;
	});
var $author$project$Util$Mustache$matchKey = F3(
	function (match, f, d) {
		return A2(
			$elm$core$Maybe$withDefault,
			d,
			A2(
				$elm$core$Maybe$map,
				f(d),
				$elm$core$List$head(match.N8)));
	});
var $author$project$Util$Mustache$getSection = F2(
	function (nodes, match) {
		var expand = function (node) {
			if (node.$ === 1) {
				var key_ = node.a;
				var bool = node.b;
				return A3(
					$author$project$Util$Mustache$matchKey,
					match,
					A2($author$project$Util$Mustache$isKey, key_, bool),
					false);
			} else {
				return false;
			}
		};
		return A2($elm$core$List$any, expand, nodes) ? $author$project$Util$Mustache$headSafe(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(match.N8))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Util$Mustache$mustacheRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('{[{]?#\\s?(.+?)\\s?\\i?[}]?}(.+?){[{]?/\\s?(.+?)\\s?\\i?[}]?}'));
var $author$project$Util$Mustache$renderSections = F2(
	function (template, nodes) {
		return A3(
			$elm$regex$Regex$replace,
			$author$project$Util$Mustache$mustacheRegex,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Maybe$withDefault(''),
				$author$project$Util$Mustache$getSection(nodes)),
			template);
	});
var $elm_community$maybe_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (!item.$) {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$Util$Mustache$getVariable = F2(
	function (nodes, match) {
		var getContent = function (node) {
			if (!node.$) {
				var key_ = node.a;
				var val = node.b;
				return A3(
					$author$project$Util$Mustache$matchKey,
					match,
					A2(
						$author$project$Util$Mustache$isKey,
						key_,
						$elm$core$Maybe$Just(val)),
					$elm$core$Maybe$Nothing);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		return A2(
			$elm$core$Maybe$withDefault,
			match.Vq,
			$elm$core$List$head(
				$elm_community$maybe_extra$Maybe$Extra$values(
					A2($elm$core$List$map, getContent, nodes))));
	});
var $author$project$Util$Mustache$varRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('{[{]?\\s?(.+?)\\s?\\i?[}]?}'));
var $author$project$Util$Mustache$renderVariables = F2(
	function (nodes, template) {
		return A3(
			$elm$regex$Regex$replace,
			$author$project$Util$Mustache$varRegex,
			$author$project$Util$Mustache$getVariable(nodes),
			template);
	});
var $author$project$Util$Mustache$render = F2(
	function (nodes, template) {
		return A2(
			$author$project$Util$Mustache$renderVariables,
			nodes,
			A2($author$project$Util$Mustache$renderSections, template, nodes));
	});
var $author$project$Data$SalaryCalculator$interpolateMessage = F5(
	function (salaryCalculator, message, age, hours, factor) {
		var perHour = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Data$SalaryCalculator$maxSalaryPerHour(salaryCalculator),
			A2($author$project$Data$SalaryCalculator$getSalaryPerHour, age, salaryCalculator));
		var locale = $cuducos$elm_format_number$FormatNumber$Locales$frenchLocale;
		var _int = function (v) {
			return $elm$core$String$fromInt(v);
		};
		var hourConfig_ = $author$project$Data$SalaryCalculator$hourConfig(hours);
		var applyFactor = function (h) {
			return (hours <= 12) ? ((perHour * factor) * h) : (perHour * h);
		};
		var toHourSalary = function (h) {
			return A2(
				$cuducos$elm_format_number$FormatNumber$format,
				_Utils_update(
					locale,
					{
						UA: $cuducos$elm_format_number$FormatNumber$Locales$Exact(2)
					}),
				applyFactor(h));
		};
		var perMonth = toHourSalary(hourConfig_.ey);
		var perWeek = toHourSalary(hourConfig_.e8);
		var perYear = toHourSalary(hourConfig_.fb);
		var total = toHourSalary(hours);
		return A2(
			$author$project$Util$Mustache$render,
			_List_fromArray(
				[
					A2(
					$author$project$Util$Mustache$Variable,
					'Age',
					_int(age)),
					A2(
					$author$project$Util$Mustache$Variable,
					'Leeftijd',
					_int(age)),
					A2(
					$author$project$Util$Mustache$Variable,
					'Hours',
					_int(hours)),
					A2(
					$author$project$Util$Mustache$Variable,
					'Uren',
					_int(hours)),
					A2($author$project$Util$Mustache$Variable, 'Function', salaryCalculator.bj),
					A2($author$project$Util$Mustache$Variable, 'Functie', salaryCalculator.bj),
					A2(
					$author$project$Util$Mustache$Variable,
					'Hourly',
					toHourSalary(1)),
					A2(
					$author$project$Util$Mustache$Variable,
					'Peruur',
					toHourSalary(1)),
					A2($author$project$Util$Mustache$Variable, 'Weekly', perWeek),
					A2($author$project$Util$Mustache$Variable, 'Wekelijks', perWeek),
					A2($author$project$Util$Mustache$Variable, 'Monthly', perMonth),
					A2($author$project$Util$Mustache$Variable, 'Maandelijks', perMonth),
					A2($author$project$Util$Mustache$Variable, 'Yearly', perYear),
					A2($author$project$Util$Mustache$Variable, 'Jaarlijks', perYear),
					A2($author$project$Util$Mustache$Variable, 'Totaal', total),
					A2($author$project$Util$Mustache$Variable, 'Total', total)
				]),
			message);
	});
var $author$project$View$SalaryCalculator$viewBodyCalculated = F4(
	function (_v0, plainText, age, hours) {
		var state_ = _v0;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('salary-body-text')
				]),
			$author$project$Util$Html$parse(
				A5(
					$author$project$Data$SalaryCalculator$interpolateMessage,
					$author$project$Data$Entity$value(state_.au),
					plainText,
					age,
					hours,
					$author$project$View$SalaryCalculator$getFactor(state_.au))));
	});
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $author$project$Component$Form$Input$viewRangeInput = F2(
	function (toMsg, config) {
		var widthPercentage = A2($elm$core$Basics$min, 100, ((config.dL - config.bX) / (config.c_ - config.bX)) * 100);
		var widthString = A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0}%',
			_List_fromArray(
				[
					$elm$core$String$fromFloat(widthPercentage)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('range-input', true),
							_Utils_Tuple2('styled', config.dB)
						]))
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$required(config.dl),
									$elm$html$Html$Attributes$type_('range'),
									$elm$html$Html$Attributes$min(
									$elm$core$String$fromFloat(config.bX)),
									$elm$html$Html$Attributes$max(
									$elm$core$String$fromFloat(config.c_)),
									$elm$html$Html$Attributes$step(
									$elm$core$String$fromFloat(config.eX)),
									$elm$html$Html$Attributes$id(
									A2(
										$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
										'{0}-input',
										_List_fromArray(
											[config.ej]))),
									$elm$html$Html$Attributes$value(
									$elm$core$String$fromFloat(config.dL)),
									A2(
									$elm$html$Html$Events$on,
									'input',
									A2(
										$elm$json$Json$Decode$map,
										toMsg,
										A2(
											$elm$json$Json$Decode$at,
											_List_fromArray(
												['target', 'valueAsNumber']),
											$elm$json$Json$Decode$float)))
								]),
							_List_Nil)
						]),
						config.dB ? _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('track')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('range'),
									A2($elm$html$Html$Attributes$style, 'left', widthString)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('thumb'),
									A2($elm$html$Html$Attributes$style, 'left', widthString)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tooltip'),
									A2($elm$html$Html$Attributes$style, 'left', widthString)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										$elm$core$String$fromFloat(config.dL),
										A2(
											$elm$core$Maybe$map,
											function (f) {
												return f(config.dL);
											},
											config.e1)))
								]))
						]) : _List_Nil
					])));
	});
var $mgold$elm_nonempty_list$List$Nonempty$tail = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return xs;
};
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$Component$Form$SelectNonEmpty$viewOption = F4(
	function (current, toTitle, toValue, opt) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					toValue(opt)),
					$elm$html$Html$Attributes$selected(
					A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$apR(opt),
							current)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					toTitle(opt))
				]));
	});
var $author$project$Component$Form$SelectNonEmpty$viewSelect = function (config) {
	var isJust = function (maybeValue) {
		if (maybeValue.$ === 1) {
			return $elm$json$Json$Decode$fail('Value is Nothing');
		} else {
			var value = maybeValue.a;
			return $elm$json$Json$Decode$succeed(value);
		}
	};
	var decoder = A2(
		$elm$json$Json$Decode$andThen,
		A2($elm$core$Basics$composeL, isJust, config.U6),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['target', 'value']),
			$elm$json$Json$Decode$string));
	var _v0 = config.VT;
	var x = _v0.a;
	var xs = _v0.b;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('custom-select')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Events$on,
						'change',
						A2($elm$json$Json$Decode$map, config.WG, decoder))
					]),
				A2(
					$elm$core$List$map,
					A3($author$project$Component$Form$SelectNonEmpty$viewOption, config.Uu, config.WH, config.WI),
					A2($elm$core$List$cons, x, xs)))
			]));
};
var $author$project$View$SalaryCalculator$viewSelect = F2(
	function (_v0, all) {
		var selectedSalaryCalculator = _v0.au;
		return $author$project$Component$Form$SelectNonEmpty$viewSelect(
			{
				Uu: $elm$core$Maybe$Just(
					$elm$core$Basics$eq(selectedSalaryCalculator)),
				U6: function (id) {
					return A2(
						$author$project$Util$NonEmpty$find,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Basics$eq(id),
								$author$project$Data$Id$toString),
							$author$project$Data$Entity$id),
						all);
				},
				VT: _Utils_Tuple2(
					$mgold$elm_nonempty_list$List$Nonempty$head(all),
					$mgold$elm_nonempty_list$List$Nonempty$tail(all)),
				WG: $author$project$View$SalaryCalculator$init,
				WH: A2(
					$elm$core$Basics$composeL,
					function ($) {
						return $.bj;
					},
					$author$project$Data$Entity$value),
				WI: A2($elm$core$Basics$composeL, $author$project$Data$Id$toString, $author$project$Data$Entity$id)
			});
	});
var $author$project$View$SalaryCalculator$getExtraDescription = function (salaryCalculatorEntity) {
	return $author$project$Data$Entity$value(salaryCalculatorEntity).qT;
};
var $author$project$View$SalaryCalculator$viewVacancyExtraDescription = function (salaryCalculatorEntity) {
	return A2(
		$author$project$Util$View$viewMaybe,
		$author$project$View$SalaryCalculator$getExtraDescription(salaryCalculatorEntity),
		function (extraDescription) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('salary-body-text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(extraDescription)
					]));
		});
};
var $author$project$View$SalaryCalculator$viewBodyCalculating = F3(
	function (state, plainText, allTables) {
		var state_ = state;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('salary-calculator-body', true)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Util$View$viewIfNot,
					$mgold$elm_nonempty_list$List$Nonempty$isSingleton(allTables),
					function (_v0) {
						return A2($author$project$View$SalaryCalculator$viewSelect, state, allTables);
					}),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-fields')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Component$Form$Input$viewFormField,
							$author$project$Copy$copy.gd,
							$elm$core$Maybe$Nothing,
							A2(
								$author$project$Component$Form$Input$viewRangeInput,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Basics$round,
									$author$project$View$SalaryCalculator$setAge(state)),
								{
									ej: 'range',
									c_: 99,
									bX: $author$project$Data$SalaryCalculator$minAge(
										$author$project$Data$Entity$value(state_.au)),
									dl: false,
									eX: 1,
									dB: true,
									e1: $elm$core$Maybe$Nothing,
									dL: state_.gd
								})),
							A3(
							$author$project$Component$Form$Input$viewFormField,
							$author$project$Copy$copy.CG,
							$elm$core$Maybe$Nothing,
							A2(
								$author$project$Component$Form$Input$viewRangeInput,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Basics$round,
									$author$project$View$SalaryCalculator$setHours(state)),
								{
									ej: 'range',
									c_: $author$project$View$SalaryCalculator$getMaxHours(state_.au),
									bX: $author$project$View$SalaryCalculator$getMinHours(state_.au),
									dl: false,
									eX: 1,
									dB: true,
									e1: $elm$core$Maybe$Nothing,
									dL: state_.t1
								}))
						])),
					A4($author$project$View$SalaryCalculator$viewBodyCalculated, state, plainText, state_.gd, state_.t1),
					$author$project$View$SalaryCalculator$viewVacancyExtraDescription(state_.au)
				]));
	});
var $author$project$View$SalaryCalculator$view = F2(
	function (config, state) {
		return A2(
			$elm$html$Html$map,
			config.xp,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('salary-calculator-wrapper')
					]),
				_List_fromArray(
					[
						A3($author$project$View$SalaryCalculator$viewBodyCalculating, state, config.E9, config.aR)
					])));
	});
var $author$project$SalaryCalculator$view = function (model) {
	return A2(
		$author$project$View$SalaryCalculator$view,
		{xp: $elm$core$Basics$identity, E9: model.E9.O1, aR: model.aR},
		model.IW);
};
var $author$project$SalaryCalculator$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$SalaryCalculator$decodeFlags,
	{
		cR: $author$project$SalaryCalculator$init,
		dC: $elm$core$Basics$always($elm$core$Platform$Sub$none),
		dJ: $author$project$SalaryCalculator$update,
		dM: $author$project$SalaryCalculator$view
	});
var $author$project$ReferralToolForm$Flags = F6(
	function (translations, currentLangCode, referralFormResponse, domainId, sessionToken, domains) {
		return {a9: currentLangCode, cF: domainId, bb: domains, b5: referralFormResponse, av: sessionToken, P$: translations};
	});
var $author$project$Data$Domains$Domains = $elm$core$Basics$identity;
var $author$project$Data$Domains$decodeZipper = function () {
	var decode = function (x) {
		if (!x.b) {
			return $elm$json$Json$Decode$fail('can\'t make a zipper from an empty list');
		} else {
			var y = x.a;
			var ys = x.b;
			return $elm$json$Json$Decode$succeed(
				A2($wernerdegroot$listzipper$List$Zipper$fromCons, y, ys));
		}
	};
	return A2(
		$elm$core$Basics$composeL,
		$elm$json$Json$Decode$andThen(decode),
		$elm$json$Json$Decode$list);
}();
var $author$project$Data$Domains$domainsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	$author$project$Data$Domains$decodeZipper(
		$author$project$Data$Entity$decoder($author$project$Model$Domain$domainDecoder)));
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$Model$ReferralFormResponse$NestedReferralFormResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$ReferralFormResponse$SimpleReferralFormResponse = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Model$ReferralFormResponse$FilterWithOptions = F2(
	function (filter, options) {
		return {rz: filter, VT: options};
	});
var $author$project$Model$VacancyFilter$VacancyFilter = function (filterType) {
	return function (valueType) {
		return function (sort) {
			return function (domainId) {
				return function (label) {
					return function (enabled) {
						return function (langCode) {
							return function (masterDataType) {
								return function (masterDataOrigin) {
									return function (icon) {
										return function (maskColor) {
											return function (updated) {
												return function (seqNo) {
													return {cF: domainId, qa: enabled, UZ: filterType, aH: icon, bj: label, wS: langCode, yB: maskColor, yF: masterDataOrigin, yG: masterDataType, Lb: seqNo, MX: sort, QH: updated, Sw: valueType};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$MasterDataOrigin$CMS = 0;
var $author$project$Model$MasterDataOrigin$Import = 1;
var $author$project$Model$MasterDataOrigin$masterDataOriginDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'cms':
				return $elm$json$Json$Decode$succeed(0);
			case 'import':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$MasterDataType$OrganizationData = 0;
var $author$project$Model$MasterDataType$VacancyData = 1;
var $author$project$Model$MasterDataType$masterDataTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'organization-data':
				return $elm$json$Json$Decode$succeed(0);
			case 'vacancy-data':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$VacancyFilterSort$Alphabetical = 0;
var $author$project$Model$VacancyFilterSort$CustomOrder = 1;
var $author$project$Model$VacancyFilterSort$VacancyCount = 2;
var $author$project$Model$VacancyFilterSort$vacancyFilterSortDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'alphabetical':
				return $elm$json$Json$Decode$succeed(0);
			case 'custom-order':
				return $elm$json$Json$Decode$succeed(1);
			case 'vacancy-count':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$VacancyFilterValue$HourRange = 0;
var $author$project$Model$VacancyFilterValue$LocationValue = 3;
var $author$project$Model$VacancyFilterValue$SalaryRange = 1;
var $author$project$Model$VacancyFilterValue$TextValue = 2;
var $author$project$Model$VacancyFilterValue$vacancyFilterValueDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'hour-range':
				return $elm$json$Json$Decode$succeed(0);
			case 'salary-range':
				return $elm$json$Json$Decode$succeed(1);
			case 'text-value':
				return $elm$json$Json$Decode$succeed(2);
			case 'location-value':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$VacancyFilter$vacancyFilterDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'vacancyFilterSeqNo',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vacancyFilterUpdated',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'vacancyFilterMaskColor',
			$author$project$Model$MaskColor$maskColorDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'vacancyFilterIcon',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'vacancyFilterMasterDataOrigin',
					$author$project$Model$MasterDataOrigin$masterDataOriginDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'vacancyFilterMasterDataType',
						$author$project$Model$MasterDataType$masterDataTypeDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'vacancyFilterLangCode',
							$author$project$Model$LangCode$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'vacancyFilterEnabled',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'vacancyFilterLabel',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'vacancyFilterDomainId',
										$author$project$Data$Id$decoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'vacancyFilterSort',
											$author$project$Model$VacancyFilterSort$vacancyFilterSortDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'vacancyFilterValueType',
												$author$project$Model$VacancyFilterValue$vacancyFilterValueDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'vacancyFilterFilterType',
													$author$project$Model$VacancyFilterType$vacancyFilterTypeDecoder,
													$elm$json$Json$Decode$succeed($author$project$Model$VacancyFilter$VacancyFilter))))))))))))));
var $author$project$Model$VacancyFilterOption$VacancyFilterOption = function (externalId) {
	return function (externalAts) {
		return function (domainId) {
			return function (filterId) {
				return function (value) {
					return function (displayLabel) {
						return function (className) {
							return function (seqNo) {
								return function (companyLogo) {
									return function (bannerImages) {
										return function (showAsTag) {
											return function (structuredDataType) {
												return function (vacancyIdsMirror) {
													return function (masterDataOrigin) {
														return function (updated) {
															return {iZ: bannerImages, dY: className, l_: companyLogo, oL: displayLabel, cF: domainId, qN: externalAts, qO: externalId, rI: filterId, yF: masterDataOrigin, Lb: seqNo, LF: showAsTag, N4: structuredDataType, QH: updated, R7: vacancyIdsMirror, dL: value};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$Ats$Afas = 0;
var $author$project$Model$Ats$Avature = 1;
var $author$project$Model$Ats$Bullhorn = 2;
var $author$project$Model$Ats$Byner = 3;
var $author$project$Model$Ats$Carerix = 4;
var $author$project$Model$Ats$Connexys = 5;
var $author$project$Model$Ats$ConnexysJson = 6;
var $author$project$Model$Ats$Cornerstone = 7;
var $author$project$Model$Ats$CvWarehouse = 8;
var $author$project$Model$Ats$Daywize = 9;
var $author$project$Model$Ats$DigitalRecruiters = 10;
var $author$project$Model$Ats$Easycruit = 11;
var $author$project$Model$Ats$Emply = 12;
var $author$project$Model$Ats$Greenhouse = 13;
var $author$project$Model$Ats$Harver = 14;
var $author$project$Model$Ats$Hireserve = 15;
var $author$project$Model$Ats$Homerun = 16;
var $author$project$Model$Ats$HomerunJSON = 18;
var $author$project$Model$Ats$HrOffice = 17;
var $author$project$Model$Ats$Jobvite = 19;
var $author$project$Model$Ats$Jobylon = 20;
var $author$project$Model$Ats$Netive = 21;
var $author$project$Model$Ats$Otys = 22;
var $author$project$Model$Ats$Recruitee = 23;
var $author$project$Model$Ats$RecruiteeAts = 24;
var $author$project$Model$Ats$Salesforce = 25;
var $author$project$Model$Ats$SmartRecruiters = 26;
var $author$project$Model$Ats$SuccessFactors = 27;
var $author$project$Model$Ats$Talentsoft = 28;
var $author$project$Model$Ats$Teamtailor = 29;
var $author$project$Model$Ats$Tigris = 30;
var $author$project$Model$Ats$Trakstar = 31;
var $author$project$Model$Ats$Ubeeo = 32;
var $author$project$Model$Ats$UbeeoV2 = 33;
var $author$project$Model$Ats$Webqube = 34;
var $author$project$Model$Ats$Workday = 35;
var $author$project$Model$Ats$atsDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'afas':
				return $elm$json$Json$Decode$succeed(0);
			case 'avature':
				return $elm$json$Json$Decode$succeed(1);
			case 'bullhorn':
				return $elm$json$Json$Decode$succeed(2);
			case 'byner':
				return $elm$json$Json$Decode$succeed(3);
			case 'carerix':
				return $elm$json$Json$Decode$succeed(4);
			case 'connexys':
				return $elm$json$Json$Decode$succeed(5);
			case 'connexys-json':
				return $elm$json$Json$Decode$succeed(6);
			case 'cornerstone':
				return $elm$json$Json$Decode$succeed(7);
			case 'cv-warehouse':
				return $elm$json$Json$Decode$succeed(8);
			case 'daywize':
				return $elm$json$Json$Decode$succeed(9);
			case 'digital-recruiters':
				return $elm$json$Json$Decode$succeed(10);
			case 'easycruit':
				return $elm$json$Json$Decode$succeed(11);
			case 'emply':
				return $elm$json$Json$Decode$succeed(12);
			case 'greenhouse':
				return $elm$json$Json$Decode$succeed(13);
			case 'harver':
				return $elm$json$Json$Decode$succeed(14);
			case 'hireserve':
				return $elm$json$Json$Decode$succeed(15);
			case 'homerun':
				return $elm$json$Json$Decode$succeed(16);
			case 'hr-office':
				return $elm$json$Json$Decode$succeed(17);
			case 'homerun-json':
				return $elm$json$Json$Decode$succeed(18);
			case 'jobvite':
				return $elm$json$Json$Decode$succeed(19);
			case 'jobylon':
				return $elm$json$Json$Decode$succeed(20);
			case 'netive':
				return $elm$json$Json$Decode$succeed(21);
			case 'otys':
				return $elm$json$Json$Decode$succeed(22);
			case 'recruitee':
				return $elm$json$Json$Decode$succeed(23);
			case 'recruitee-ats':
				return $elm$json$Json$Decode$succeed(24);
			case 'salesforce':
				return $elm$json$Json$Decode$succeed(25);
			case 'smart-recruiters':
				return $elm$json$Json$Decode$succeed(26);
			case 'success-factors':
				return $elm$json$Json$Decode$succeed(27);
			case 'talentsoft':
				return $elm$json$Json$Decode$succeed(28);
			case 'teamtailor':
				return $elm$json$Json$Decode$succeed(29);
			case 'tigris':
				return $elm$json$Json$Decode$succeed(30);
			case 'trakstar':
				return $elm$json$Json$Decode$succeed(31);
			case 'ubeeo':
				return $elm$json$Json$Decode$succeed(32);
			case 'ubeeo-v2':
				return $elm$json$Json$Decode$succeed(33);
			case 'webqube':
				return $elm$json$Json$Decode$succeed(34);
			case 'workday':
				return $elm$json$Json$Decode$succeed(35);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$StructuredDataType$EmploymentType = $elm$core$Basics$identity;
var $author$project$Model$EmploymentType$Contractor = 2;
var $author$project$Model$EmploymentType$FullTime = 0;
var $author$project$Model$EmploymentType$Intern = 4;
var $author$project$Model$EmploymentType$Other = 7;
var $author$project$Model$EmploymentType$PartTime = 1;
var $author$project$Model$EmploymentType$PerDiem = 6;
var $author$project$Model$EmploymentType$Temporary = 3;
var $author$project$Model$EmploymentType$Volunteer = 5;
var $author$project$Model$EmploymentType$employmentTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'full-time':
				return $elm$json$Json$Decode$succeed(0);
			case 'part-time':
				return $elm$json$Json$Decode$succeed(1);
			case 'contractor':
				return $elm$json$Json$Decode$succeed(2);
			case 'temporary':
				return $elm$json$Json$Decode$succeed(3);
			case 'intern':
				return $elm$json$Json$Decode$succeed(4);
			case 'volunteer':
				return $elm$json$Json$Decode$succeed(5);
			case 'per-diem':
				return $elm$json$Json$Decode$succeed(6);
			case 'other':
				return $elm$json$Json$Decode$succeed(7);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$StructuredDataType$structuredDataTypeDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Model$EmploymentType$employmentTypeDecoder);
var $author$project$Model$VacancyFilterOptionValue$HourRange = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$VacancyFilterOptionValue$SalaryRange = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$VacancyFilterOptionValue$TextValue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$VacancyFilterOptionValue$HourRangeValue = F2(
	function (minHours, maxHours) {
		return {er: maxHours, eu: minHours};
	});
var $author$project$Model$VacancyFilterOptionValue$hourRangeValueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxHours',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minHours',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Model$VacancyFilterOptionValue$HourRangeValue)));
var $author$project$Model$VacancyFilterOptionValue$SalaryRangeValue = F2(
	function (minSalary, maxSalary) {
		return {yP: maxSalary, ev: minSalary};
	});
var $author$project$Model$VacancyFilterOptionValue$salaryRangeValueDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxSalary',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minSalary',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Model$VacancyFilterOptionValue$SalaryRangeValue)));
var $author$project$Model$VacancyFilterOptionValue$vacancyFilterOptionValueDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'hour-range':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$VacancyFilterOptionValue$hourRangeValueDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$VacancyFilterOptionValue$HourRange));
			case 'salary-range':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$VacancyFilterOptionValue$salaryRangeValueDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$VacancyFilterOptionValue$SalaryRange));
			case 'text-value':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$VacancyFilterOptionValue$TextValue));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$VacancyFilterOption$vacancyFilterOptionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'updated',
	$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'masterDataOrigin',
		$author$project$Model$MasterDataOrigin$masterDataOriginDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'vacancyIdsMirror',
			$elm$json$Json$Decode$list($author$project$Data$Id$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'structuredDataType',
				$elm$json$Json$Decode$nullable($author$project$Model$StructuredDataType$structuredDataTypeDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'showAsTag',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'bannerImages',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'companyLogo',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'seqNo',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'className',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'displayLabel',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'value',
											$author$project$Model$VacancyFilterOptionValue$vacancyFilterOptionValueDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'filterId',
												$author$project$Data$Id$decoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'domainId',
													$author$project$Data$Id$decoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'externalAts',
														$elm$json$Json$Decode$nullable($author$project$Model$Ats$atsDecoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'externalId',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															$elm$json$Json$Decode$succeed($author$project$Model$VacancyFilterOption$VacancyFilterOption))))))))))))))));
var $author$project$Model$ReferralFormResponse$filterWithOptionsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'options',
	$elm$json$Json$Decode$list(
		$author$project$Data$Entity$decoder($author$project$Model$VacancyFilterOption$vacancyFilterOptionDecoder)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'filter',
		$author$project$Data$Entity$decoder($author$project$Model$VacancyFilter$vacancyFilterDecoder),
		$elm$json$Json$Decode$succeed($author$project$Model$ReferralFormResponse$FilterWithOptions)));
var $author$project$Model$ReferralFormResponse$NestedFormArgsResponse = F3(
	function (initialFilterOption, filters, askLocation) {
		return {h6: askLocation, rW: filters, uV: initialFilterOption};
	});
var $author$project$Model$ReferralFormResponse$nestedFormArgsResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'askLocation',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'filters',
		$elm$json$Json$Decode$list($author$project$Model$ReferralFormResponse$filterWithOptionsDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'initialFilterOption',
			$author$project$Data$Entity$decoder($author$project$Model$VacancyFilterOption$vacancyFilterOptionDecoder),
			$elm$json$Json$Decode$succeed($author$project$Model$ReferralFormResponse$NestedFormArgsResponse))));
var $author$project$Model$ReferralFormResponse$referralFormResponseDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'simple-referral-form-response':
				return A2(
					$elm$json$Json$Decode$field,
					'contents',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$bool),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2(
								$elm$json$Json$Decode$index,
								0,
								$elm$json$Json$Decode$list($author$project$Model$ReferralFormResponse$filterWithOptionsDecoder)),
							$elm$json$Json$Decode$succeed($author$project$Model$ReferralFormResponse$SimpleReferralFormResponse))));
			case 'nested-referral-form-response':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list($author$project$Model$ReferralFormResponse$nestedFormArgsResponseDecoder),
					$elm$json$Json$Decode$succeed($author$project$Model$ReferralFormResponse$NestedReferralFormResponse));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$ReferralToolForm$decodeFlags = A7(
	$elm$json$Json$Decode$map6,
	$author$project$ReferralToolForm$Flags,
	$author$project$Data$Translation$translationsDecoder,
	A2($elm$json$Json$Decode$field, 'currentLangCode', $author$project$Model$LangCode$decoder),
	A2($elm$json$Json$Decode$field, 'referralFormResponse', $author$project$Model$ReferralFormResponse$referralFormResponseDecoder),
	A2($elm$json$Json$Decode$field, 'domainId', $author$project$Data$Id$decoder),
	A2($elm$json$Json$Decode$field, 'sessionToken', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'domains', $author$project$Data$Domains$domainsDecoder));
var $author$project$ReferralToolForm$initForm = function (domainKey) {
	return {l8: false, UL: domainKey, d4: '', r3: '', ux: $elm$core$Maybe$Nothing, w1: '', w7: $elm$core$Maybe$Nothing, eq: '', EQ: '', aM: '', WW: _List_Nil};
};
var $author$project$ReferralToolForm$init = function (flags) {
	return _Utils_Tuple2(
		{
			a9: flags.a9,
			UL: flags.cF,
			bb: flags.bb,
			uV: $elm$core$Maybe$Nothing,
			ah: $author$project$View$LocationSuggestions$init,
			C: _Utils_Tuple2(
				$author$project$ReferralToolForm$initForm(flags.cF),
				$elm$core$Maybe$Nothing),
			b5: flags.b5,
			av: $elm$core$Maybe$Just(flags.av),
			P$: flags.P$,
			ce: $elm$core$Maybe$Nothing
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$ReferralToolForm$GotProgress = function (a) {
	return {$: 4, a: a};
};
var $author$project$ReferralToolForm$LocationSuggestionsMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$ReferralToolForm$SetLocationSuggestion = function (a) {
	return {$: 11, a: a};
};
var $author$project$ReferralToolForm$locationSuggestionsConfig = function (model) {
	return {
		cr: 'location-search-only',
		cF: model.UL,
		xp: $author$project$ReferralToolForm$LocationSuggestionsMsg,
		Wh: 1,
		av: model.av,
		Wv: $author$project$View$Autocomplete$Http$Button(
			{Wu: $author$project$ReferralToolForm$SetLocationSuggestion, WL: $elm$core$Maybe$Nothing}),
		e4: 'location-suggestion'
	};
};
var $author$project$ReferralToolForm$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$http$Http$track, 'submit', $author$project$ReferralToolForm$GotProgress),
				A2(
				$author$project$View$LocationSuggestions$subscriptions,
				$author$project$ReferralToolForm$locationSuggestionsConfig(model),
				model.ah)
			]));
};
var $author$project$ReferralToolForm$GotCreateReferral = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$ReferralToolForm$GotPreviews = function (a) {
	return {$: 6, a: a};
};
var $author$project$ReferralToolForm$SelectedFile = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Api$Endpoint$referrals = function (domainKey) {
	return $author$project$Api$Endpoint$endpoint(
		_List_fromArray(
			[
				$author$project$Data$Id$toString(domainKey),
				'referrals'
			]));
};
var $author$project$Api$Endpoint$request = function (config) {
	var _v0 = config.dK;
	var url = _v0;
	return $elm$http$Http$request(
		{a2: config.a2, cH: config.cH, cL: config.cL, c0: config.c0, dF: config.dF, WM: config.WM, dK: url});
};
var $author$project$View$Autocomplete$Http$currentInputValue = function (_v0) {
	var state = _v0;
	return state.T;
};
var $author$project$View$Autocomplete$Http$resetWith = F2(
	function (toString, state) {
		return {
			s: $author$project$Data$Autocomplete$unknown,
			T: A2(
				$elm$core$Maybe$withDefault,
				$author$project$View$Autocomplete$Http$currentInputValue(state),
				A2(
					$elm$core$Maybe$map,
					toString,
					$author$project$View$Autocomplete$Http$currentlyFocussedValue(state))),
			wF: $author$project$Data$Key$newKey
		};
	});
var $author$project$View$LocationSuggestions$resetWithValue = function (_v0) {
	var state = _v0;
	return _Utils_update(
		state,
		{
			U: A2(
				$author$project$View$Autocomplete$Http$resetWith,
				function ($) {
					return $.Vn;
				},
				state.U)
		});
};
var $author$project$Model$ReferralLocation$encodeReferralLocation = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'latitude',
				$elm$json$Json$Encode$float(a.w8)),
				_Utils_Tuple2(
				'longitude',
				$elm$json$Json$Encode$float(a.yg))
			]));
};
var $author$project$ReferralToolForm$toMultiPartBody = function (form) {
	var toLatLongPart = A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$List$singleton,
				$elm$http$Http$stringPart('latLong')),
			$elm$json$Json$Encode$encode(0)),
		$author$project$Model$ReferralLocation$encodeReferralLocation);
	var toLocation = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2($elm$core$Maybe$map, toLatLongPart, form.w7));
	var restOfBody = _List_fromArray(
		[
			A2($elm$http$Http$stringPart, 'firstName', form.r3),
			A2($elm$http$Http$stringPart, 'lastName', form.w1),
			A2($elm$http$Http$stringPart, 'email', form.d4),
			A2($elm$http$Http$stringPart, 'phone', form.aM),
			A2($elm$http$Http$stringPart, 'location', form.eq),
			A2($elm$http$Http$stringPart, 'personalMessage', form.EQ)
		]);
	var optionParts = A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$http$Http$stringPart('optionIds'),
			$author$project$Data$Id$toString),
		form.WW);
	var filePart = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (mediaItem) {
				return _List_fromArray(
					[
						A2($elm$http$Http$filePart, 'personalImage', mediaItem.rp)
					]);
			},
			form.ux));
	var body = _Utils_ap(
		filePart,
		_Utils_ap(
			optionParts,
			_Utils_ap(restOfBody, toLocation)));
	return $elm$http$Http$multipartBody(body);
};
var $author$project$ReferralToolForm$maxImageSize = _Utils_Tuple2(10000000, '10MB');
var $author$project$ReferralToolForm$toPreview = function (base64) {
	var _v0 = $author$project$Data$MimeType$fromBase64(base64);
	if (!_v0.$) {
		return {dV: base64, cP: base64, bW: $author$project$ReferralToolForm$maxImageSize};
	} else {
		return {dV: base64, cP: '/static/images/image-placeholder.png', bW: $author$project$ReferralToolForm$maxImageSize};
	}
};
var $author$project$ReferralToolForm$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var _v1 = model.C;
				var referralForm = _v1.a;
				return _Utils_Tuple2(
					model,
					$author$project$Api$Endpoint$request(
						{
							a2: $author$project$ReferralToolForm$toMultiPartBody(referralForm),
							cH: A2(
								$author$project$Api$expectJson,
								$author$project$ReferralToolForm$GotCreateReferral(referralForm),
								$author$project$Model$RedirectUrl$redirectUrlDecoder),
							cL: _List_Nil,
							c0: 'POST',
							dF: $elm$core$Maybe$Nothing,
							WM: $elm$core$Maybe$Just('submit'),
							dK: $author$project$Api$Endpoint$referrals(referralForm.UL)
						}));
			case 3:
				if (!msg.b.$) {
					var unRedirectUrl = msg.b.a.WP;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(unRedirectUrl));
				} else {
					if (!msg.b.a.$) {
						var form = msg.a;
						var error = msg.b.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									C: _Utils_Tuple2(
										form,
										$elm$core$Maybe$Just(error)),
									ce: $elm$core$Maybe$Nothing
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{ce: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none);
					}
				}
			case 4:
				if (msg.a.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var progress = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ce: $elm$core$Maybe$Just(
									$elm$http$Http$fractionSent(progress))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 5:
				var form = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{C: form}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var maybeOptionId = msg.a;
				var _v2 = model.C;
				var form = _v2.a;
				var errorResponse = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uV: maybeOptionId,
							C: _Utils_Tuple2(
								_Utils_update(
									form,
									{WW: _List_Nil}),
								errorResponse)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$file$File$Select$files,
						_List_fromArray(
							['image/*', 'gif/*']),
						$author$project$ReferralToolForm$SelectedFile));
			case 8:
				var file = msg.a;
				var files = msg.b;
				var fileToMediaItemToUpload = function (f) {
					return A2(
						$elm$core$Task$map,
						function (base64) {
							return {
								rp: f,
								FG: $author$project$ReferralToolForm$toPreview(base64)
							};
						},
						$elm$file$File$toUrl(f));
				};
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$ReferralToolForm$GotPreviews,
						$elm$core$Task$sequence(
							A2(
								$elm$core$List$map,
								fileToMediaItemToUpload,
								A2($elm$core$List$cons, file, files)))));
			case 6:
				if (msg.a.b) {
					var _v3 = msg.a;
					var preview = _v3.a;
					var _v4 = model.C;
					var form = _v4.a;
					var errorResponse = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								C: _Utils_Tuple2(
									_Utils_update(
										form,
										{
											ux: $elm$core$Maybe$Just(preview)
										}),
									errorResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 9:
				var _v5 = model.C;
				var form = _v5.a;
				var error = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							C: _Utils_Tuple2(
								_Utils_update(
									form,
									{ux: $elm$core$Maybe$Nothing}),
								error)
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var locationSuggestionsMsg = msg.a;
				var _v6 = A3(
					$author$project$View$LocationSuggestions$update,
					$author$project$ReferralToolForm$locationSuggestionsConfig(model),
					locationSuggestionsMsg,
					model.ah);
				var locationSuggestionsModel = _v6.a;
				var locationSuggestionsCmds = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ah: locationSuggestionsModel}),
					locationSuggestionsCmds);
			default:
				var location = msg.a;
				var toLatLong = function () {
					var _v8 = _Utils_Tuple2(location.w8, location.yg);
					if ((!_v8.a.$) && (!_v8.b.$)) {
						var lat = _v8.a.a;
						var _long = _v8.b.a;
						return $elm$core$Maybe$Just(
							{w8: lat, yg: _long});
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var _v7 = model.C;
				var form = _v7.a;
				var errorResponse = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ah: $author$project$View$LocationSuggestions$resetWithValue(model.ah),
							C: _Utils_Tuple2(
								_Utils_update(
									form,
									{w7: toLatLong}),
								errorResponse)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$ReferralToolForm$CreateReferral = {$: 1};
var $author$project$ReferralToolForm$UpdateReferralForm = function (a) {
	return {$: 5, a: a};
};
var $author$project$Component$Form$TextInput$Attribute = $elm$core$Basics$identity;
var $author$project$Component$Form$TextInput$TextInput = $elm$core$Basics$identity;
var $author$project$Component$Form$TextInput$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$Form$TextInput$class = function (class_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					cu: $elm$core$Maybe$Just(class_)
				});
		});
};
var $author$project$Component$Form$TextArea$Attribute = $elm$core$Basics$identity;
var $author$project$Component$Form$TextArea$TextArea = $elm$core$Basics$identity;
var $author$project$Component$Form$TextArea$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$Form$TextArea$error = function (error_) {
	return $author$project$Component$Form$TextArea$set(
		function (config) {
			return _Utils_update(
				config,
				{bL: error_});
		});
};
var $author$project$Component$Form$TextInput$error = function (error_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					be: A2(
						$elm$core$Maybe$map,
						function (err) {
							return $rtfeldman$elm_css$Html$Styled$toUnstyled(
								A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('error-message')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(err)
										])));
						},
						error_)
				});
		});
};
var $wernerdegroot$listzipper$List$Zipper$toList = function (z) {
	return _Utils_ap(
		$wernerdegroot$listzipper$List$Zipper$before(z),
		_Utils_ap(
			_List_fromArray(
				[
					$wernerdegroot$listzipper$List$Zipper$current(z)
				]),
			$wernerdegroot$listzipper$List$Zipper$after(z)));
};
var $author$project$Data$Domains$toList = function (_v0) {
	var domains = _v0;
	return $wernerdegroot$listzipper$List$Zipper$toList(domains);
};
var $author$project$Data$Domains$hasMultipleDomains = A2(
	$elm$core$Basics$composeL,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Basics$lt(1),
		$elm$core$List$length),
	$author$project$Data$Domains$toList);
var $author$project$Component$Form$TextArea$hiddenLabel = $author$project$Component$Form$TextArea$set(
	function (config) {
		return _Utils_update(
			config,
			{cM: true});
	});
var $author$project$Component$Form$TextInput$hiddenLabel = function (val) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{cM: val});
		});
};
var $author$project$Component$Form$TextInput$icon = function (path) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					aH: $elm$core$Maybe$Just(path)
				});
		});
};
var $author$project$Component$Form$TextArea$onInput = function (msg_) {
	return $author$project$Component$Form$TextArea$set(
		function (config) {
			return _Utils_update(
				config,
				{
					c9: $elm$core$Maybe$Just(msg_)
				});
		});
};
var $author$project$Component$Form$TextInput$onInput = function (msg_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					c9: $elm$core$Maybe$Just(msg_)
				});
		});
};
var $author$project$Model$Translation$personalMessage = 'personal-message';
var $author$project$Model$Translation$phoneNumberLabel = 'phone-number-label';
var $author$project$Component$Form$TextArea$placeholder = function (placeholder_) {
	return $author$project$Component$Form$TextArea$set(
		function (config) {
			return _Utils_update(
				config,
				{
					dd: $elm$core$Maybe$Just(placeholder_)
				});
		});
};
var $author$project$Component$Form$TextInput$placeholder = function (placeholder_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					dd: $elm$core$Maybe$Just(placeholder_)
				});
		});
};
var $author$project$Model$Translation$referralFormEmailLabel = 'referral-form-email-label';
var $author$project$Model$Translation$referralFormEmailPlaceholder = 'referral-form-email-placeholder';
var $author$project$Model$Translation$referralFormFirstNameLabel = 'referral-form-first-name-label';
var $author$project$Model$Translation$referralFormFirstNamePlaceholder = 'referral-form-first-name-placeholder';
var $author$project$Model$Translation$referralFormLastNameLabel = 'referral-form-last-name-label';
var $author$project$Model$Translation$referralFormLastNamePlaceholder = 'referral-form-last-name-placeholder';
var $author$project$Model$Translation$referralFormMatchingMetadata = 'referral-form-matching-metadata';
var $author$project$Model$Translation$referralFormPhoneNumber = 'referral-form-phone-number';
var $author$project$Model$Translation$referralFormReferSomeoneLabel = 'referral-form-refer-someone-label';
var $author$project$Data$Domains$refocus = F2(
	function (_v0, config) {
		var domains = _v0;
		var focus = function (id) {
			return _Utils_Tuple2(
				id,
				A2(
					$wernerdegroot$listzipper$List$Zipper$findFirst,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$eq(id),
						$author$project$Data$Entity$id),
					domains));
		};
		var _v1 = A2($elm$core$Maybe$map, focus, config.Vr);
		if (!_v1.$) {
			if (!_v1.a.b.$) {
				var _v2 = _v1.a;
				var refocusedDomains = _v2.b.a;
				return _Utils_Tuple2(refocusedDomains, config.Ws);
			} else {
				var _v3 = _v1.a;
				var id = _v3.a;
				var _v4 = _v3.b;
				return _Utils_Tuple2(
					domains,
					config.WS(id));
			}
		} else {
			return _Utils_Tuple2(domains, config.WT);
		}
	});
var $author$project$Component$Form$TextArea$rows = function (rows_) {
	return $author$project$Component$Form$TextArea$set(
		function (config) {
			return _Utils_update(
				config,
				{
					dp: $elm$core$Maybe$Just(rows_)
				});
		});
};
var $author$project$ReferralToolForm$isSelected = F2(
	function (maybeInitialOption, args) {
		return _Utils_eq(
			maybeInitialOption,
			$elm$core$Maybe$Just(
				$author$project$Data$Entity$id(args.uV)));
	});
var $author$project$ReferralToolForm$maybeArgs = F2(
	function (maybeInitialOption, argsList) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				$author$project$ReferralToolForm$isSelected(maybeInitialOption),
				argsList));
	});
var $author$project$ReferralToolForm$toAskLocation = F2(
	function (initialFilterOption, formResponse) {
		if (!formResponse.$) {
			var askLocation = formResponse.b;
			return askLocation;
		} else {
			var args = formResponse.a;
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.h6;
					},
					A2($author$project$ReferralToolForm$maybeArgs, initialFilterOption, args)));
		}
	});
var $author$project$ReferralToolForm$toFilterOptionCount = F2(
	function (maybeInitialOption, response) {
		if (!response.$) {
			var filterOptions = response.a;
			return $elm$core$List$length(filterOptions);
		} else {
			var argList = response.a;
			return A2(
				$elm$core$Maybe$withDefault,
				1,
				A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var filters = _v1.rW;
						return $elm$core$List$length(filters);
					},
					A2($author$project$ReferralToolForm$maybeArgs, maybeInitialOption, argList)));
		}
	});
var $author$project$Component$Form$TextArea$value = function (value_) {
	return $author$project$Component$Form$TextArea$set(
		function (config) {
			return _Utils_update(
				config,
				{dL: value_});
		});
};
var $author$project$Component$Form$TextInput$value = function (value_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{dL: value_});
		});
};
var $author$project$Data$Domains$currentId = function (_v0) {
	var domains = _v0;
	return $author$project$Data$Entity$id(
		$wernerdegroot$listzipper$List$Zipper$current(domains));
};
var $author$project$Component$DomainSelect$domainToLabel = function (_v0) {
	var domain = _v0.b;
	var regionLabel = function () {
		var _v1 = domain.V8;
		switch (_v1) {
			case 0:
				return $author$project$Copy$copy.Ug;
			case 1:
				return $author$project$Copy$copy.Ui;
			case 2:
				return $author$project$Copy$copy.Us;
			case 3:
				return $author$project$Copy$copy.Wy;
			case 4:
				return $author$project$Copy$copy.UK;
			case 5:
				return $author$project$Copy$copy.UN;
			case 6:
				return $author$project$Copy$copy.U_;
			case 7:
				return $author$project$Copy$copy.U5;
			case 8:
				return $author$project$Copy$copy.U7;
			case 9:
				return $author$project$Copy$copy.U8;
			case 10:
				return $author$project$Copy$copy.Vc;
			case 11:
				return $author$project$Copy$copy.Vo;
			case 12:
				return $author$project$Copy$copy.Vy;
			case 13:
				return $author$project$Copy$copy.VI;
			case 15:
				return $author$project$Copy$copy.V$;
			case 16:
				return $author$project$Copy$copy.V0;
			case 17:
				return $author$project$Copy$copy.Wc;
			case 19:
				return $author$project$Copy$copy.Wi;
			case 18:
				return $author$project$Copy$copy.Wk;
			case 20:
				return $author$project$Copy$copy.Wl;
			case 21:
				return $author$project$Copy$copy.Wx;
			case 22:
				return $author$project$Copy$copy.WQ;
			default:
				return $author$project$Copy$copy.WO;
		}
	}();
	return A2(
		$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
		'{0} | {1}',
		_List_fromArray(
			[domain.bj, regionLabel]));
};
var $author$project$Data$Id$fromString = A2(
	$elm$core$Basics$composeL,
	$elm$core$Maybe$map($elm$core$Basics$identity),
	$elm$core$String$toInt);
var $author$project$Data$Domains$toNonEmpty = function (_v0) {
	var domains = _v0;
	return _Utils_Tuple2(
		$wernerdegroot$listzipper$List$Zipper$current(
			$wernerdegroot$listzipper$List$Zipper$first(domains)),
		$wernerdegroot$listzipper$List$Zipper$after(
			$wernerdegroot$listzipper$List$Zipper$first(domains)));
};
var $author$project$Component$DomainSelect$view = F2(
	function (toMsg, domains) {
		var isCurrent = $elm$core$Maybe$Just(
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$eq(
					$author$project$Data$Domains$currentId(domains)),
				$author$project$Data$Entity$id));
		return A2(
			$author$project$Util$View$viewIf,
			$author$project$Data$Domains$hasMultipleDomains(domains),
			function (_v0) {
				return $author$project$Component$Form$SelectNonEmpty$viewSelect(
					{
						Uu: isCurrent,
						U6: $author$project$Data$Id$fromString,
						VT: $author$project$Data$Domains$toNonEmpty(domains),
						WG: toMsg,
						WH: $author$project$Component$DomainSelect$domainToLabel,
						WI: A2($elm$core$Basics$composeL, $author$project$Data$Id$toString, $author$project$Data$Entity$id)
					});
			});
	});
var $author$project$Component$Form$TextArea$build = {cm: false, ct: $elm$core$Maybe$Nothing, cE: false, bL: $elm$core$Maybe$Nothing, cM: false, cO: '', bj: '', c9: $elm$core$Maybe$Nothing, dd: $elm$core$Maybe$Nothing, dl: false, dp: $elm$core$Maybe$Nothing, dL: ''};
var $author$project$Component$Form$TextArea$label = function (label_) {
	return $author$project$Component$Form$TextArea$set(
		function (config) {
			return _Utils_update(
				config,
				{bj: label_});
		});
};
var $elm$html$Html$Attributes$cols = function (n) {
	return A2(
		_VirtualDom_attribute,
		'cols',
		$elm$core$String$fromInt(n));
};
var $author$project$Component$Form$TextArea$viewTextArea = function (_v0) {
	var config = _v0;
	var placeholder_ = A2($elm$core$Maybe$withDefault, config.bj, config.dd);
	var maybeAttributes = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2($elm$core$Maybe$map, $elm$html$Html$Attributes$rows, config.dp),
				A2($elm$core$Maybe$map, $elm$html$Html$Attributes$cols, config.ct),
				A2($elm$core$Maybe$map, $elm$html$Html$Events$onInput, config.c9)
			]));
	var labelClassList = _List_fromArray(
		[
			_Utils_Tuple2('label', true),
			_Utils_Tuple2('visually-hidden', config.cM)
		]);
	var inputAttributes = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('form-input form-textarea'),
			$elm$html$Html$Attributes$disabled(config.cE),
			$elm$html$Html$Attributes$placeholder(placeholder_),
			$elm$html$Html$Attributes$value(config.dL),
			$elm$html$Html$Attributes$id(config.cO),
			$elm$html$Html$Attributes$required(config.dl)
		]);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-field', true),
						_Utils_Tuple2(
						'error',
						$elm_community$maybe_extra$Maybe$Extra$isJust(config.bL))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(labelClassList),
						$elm$html$Html$Attributes$for(config.cO)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(config.bj)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-textarea-wrapper'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('autogrow', config.cm)
							])),
						A2($elm$html$Html$Attributes$attribute, 'data-value', config.dL)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$textarea,
						_Utils_ap(inputAttributes, maybeAttributes),
						_List_Nil)
					])),
				A2(
				$author$project$Util$View$viewMaybe,
				config.bL,
				function (error_) {
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('error-message')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(error_)
							]));
				})
			]));
};
var $author$project$Component$Form$TextArea$view = F2(
	function (label_, attributes) {
		return $author$project$Component$Form$TextArea$viewTextArea(
			A3(
				$elm$core$List$foldl,
				function (_v0) {
					var attribute = _v0;
					return attribute;
				},
				$author$project$Component$Form$TextArea$build,
				A2(
					$elm$core$List$cons,
					$author$project$Component$Form$TextArea$label(label_),
					attributes)));
	});
var $author$project$Component$Form$TextInput$Text = 1;
var $author$project$Component$Form$TextInput$build = {ci: false, cu: $elm$core$Maybe$Nothing, cB: _List_Nil, cE: false, be: $elm$core$Maybe$Nothing, bM: $elm$core$Maybe$Nothing, cI: $elm$core$Maybe$Nothing, cM: false, aH: $elm$core$Maybe$Nothing, cO: $elm$core$Maybe$Nothing, cS: false, bj: '', bV: $elm$core$Maybe$Nothing, c4: $elm$core$Maybe$Nothing, c7: $elm$core$Maybe$Nothing, c9: $elm$core$Maybe$Nothing, dd: $elm$core$Maybe$Nothing, dl: false, dI: 1, dL: '', dN: false};
var $author$project$Component$Form$TextInput$label = function (label_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{bj: label_});
		});
};
var $rtfeldman$elm_css$Html$Styled$Attributes$classList = function (classes) {
	return $rtfeldman$elm_css$Html$Styled$Attributes$class(
		A3(
			$rtfeldman$elm_css$Css$String$mapJoin,
			$elm$core$Tuple$first,
			' ',
			A2($elm$core$List$filter, $elm$core$Tuple$second, classes)));
};
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $rtfeldman$elm_css$Html$Styled$Attributes$for = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('htmlFor');
var $author$project$Component$Form$TextInput$generateId = function (labelText) {
	return A2(
		$elm$core$String$join,
		'-',
		$elm$core$String$words(labelText));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$id = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
var $rtfeldman$elm_css$Html$Styled$input = $rtfeldman$elm_css$Html$Styled$node('input');
var $author$project$Component$Form$TextInput$inputType = function (inputType_) {
	switch (inputType_) {
		case 0:
			return 'email';
		case 2:
			return 'url';
		case 1:
			return 'text';
		default:
			return 'phone';
	}
};
var $rtfeldman$elm_css$Html$Styled$label = $rtfeldman$elm_css$Html$Styled$node('label');
var $rtfeldman$elm_css$Html$Styled$Attributes$name = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('name');
var $rtfeldman$elm_css$Html$Styled$Events$onBlur = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetValue)));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$placeholder = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('placeholder');
var $rtfeldman$elm_css$Html$Styled$Attributes$required = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('required');
var $rtfeldman$elm_css$Html$Styled$Attributes$value = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
var $author$project$Component$Form$TextInput$viewTextInput = function (_v0) {
	var config = _v0;
	var placeholder_ = A2($elm$core$Maybe$withDefault, config.bj, config.dd);
	var maybeClass = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2($elm$core$Maybe$map, $rtfeldman$elm_css$Html$Styled$Attributes$class, config.cu)
			]));
	var maybeAttributes = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2($elm$core$Maybe$map, $rtfeldman$elm_css$Html$Styled$Events$onInput, config.c9),
				A2($elm$core$Maybe$map, $rtfeldman$elm_css$Html$Styled$Events$onBlur, config.c7),
				A2($elm$core$Maybe$map, $rtfeldman$elm_css$Html$Styled$Attributes$name, config.c4)
			]));
	var idValue = function () {
		var _v2 = config.cO;
		if (!_v2.$) {
			var id_ = _v2.a;
			return id_;
		} else {
			return $author$project$Component$Form$TextInput$generateId(config.bj);
		}
	}();
	var inputAttributes = _List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$class('form-input'),
			$rtfeldman$elm_css$Html$Styled$Attributes$type_(
			$author$project$Component$Form$TextInput$inputType(config.dI)),
			$rtfeldman$elm_css$Html$Styled$Attributes$disabled(config.cE),
			$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(placeholder_),
			$rtfeldman$elm_css$Html$Styled$Attributes$value(config.dL),
			$rtfeldman$elm_css$Html$Styled$Attributes$id(idValue),
			$rtfeldman$elm_css$Html$Styled$Attributes$required(config.dl)
		]);
	var labelAttrs = _List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('label', true),
					_Utils_Tuple2('visually-hidden', config.cM)
				])),
			$rtfeldman$elm_css$Html$Styled$Attributes$for(idValue)
		]);
	var attrList = _Utils_ap(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-field', true),
						_Utils_Tuple2(
						'error',
						$elm_community$maybe_extra$Maybe$Extra$isJust(config.be)),
						_Utils_Tuple2(
						'with-icon',
						$elm_community$maybe_extra$Maybe$Extra$isJust(config.aH) || $elm_community$maybe_extra$Maybe$Extra$isJust(config.bV)),
						_Utils_Tuple2('inline', config.cS),
						_Utils_Tuple2('warning', config.dN),
						_Utils_Tuple2('active', config.ci)
					])),
				$rtfeldman$elm_css$Html$Styled$Attributes$css(config.cB)
			]),
		maybeClass);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		attrList,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$fromUnstyled(
				A2(
					$author$project$Util$View$viewIfNot,
					$elm$core$String$isEmpty(config.bj),
					function (_v1) {
						return $rtfeldman$elm_css$Html$Styled$toUnstyled(
							A2(
								$rtfeldman$elm_css$Html$Styled$label,
								labelAttrs,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(config.bj)
									])));
					})),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-field-wrapper')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$fromUnstyled(
						A2($author$project$Util$View$viewMaybe, config.bM, $elm$core$Basics$identity)),
						A2(
						$rtfeldman$elm_css$Html$Styled$input,
						_Utils_ap(inputAttributes, maybeAttributes),
						_List_Nil),
						$rtfeldman$elm_css$Html$Styled$fromUnstyled(
						A2(
							$author$project$Util$View$viewMaybe,
							config.bV,
							$author$project$View$Icon$viewMasked(4))),
						$rtfeldman$elm_css$Html$Styled$fromUnstyled(
						A2($author$project$Util$View$viewMaybe, config.aH, $author$project$View$Icon$viewColored)),
						$rtfeldman$elm_css$Html$Styled$fromUnstyled(
						A2($author$project$Util$View$viewMaybe, config.cI, $elm$core$Basics$identity))
					])),
				$rtfeldman$elm_css$Html$Styled$fromUnstyled(
				A2($author$project$Util$View$viewMaybe, config.be, $elm$core$Basics$identity))
			]));
};
var $author$project$Component$Form$TextInput$view = F2(
	function (label_, attributes) {
		return $rtfeldman$elm_css$Html$Styled$toUnstyled(
			$author$project$Component$Form$TextInput$viewTextInput(
				A3(
					$elm$core$List$foldl,
					function (_v0) {
						var attribute = _v0;
						return attribute;
					},
					$author$project$Component$Form$TextInput$build,
					A2(
						$elm$core$List$cons,
						$author$project$Component$Form$TextInput$label(label_),
						attributes))));
	});
var $author$project$Component$Form$RadioInput$Attribute = $elm$core$Basics$identity;
var $author$project$Component$Form$RadioInput$RadioInput = $elm$core$Basics$identity;
var $author$project$Component$Form$RadioInput$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$Form$RadioInput$error = function (error_) {
	return $author$project$Component$Form$RadioInput$set(
		function (config) {
			return _Utils_update(
				config,
				{bL: error_});
		});
};
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$ReferralToolForm$findOptionById = F2(
	function (allOptions, id) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$eq(id),
				$author$project$Data$Entity$id),
			allOptions);
	});
var $author$project$ReferralToolForm$maybeSelectedOption = F2(
	function (allOptions, form) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				$author$project$ReferralToolForm$findOptionById(allOptions),
				form.WW));
	});
var $author$project$Component$Form$RadioInput$onSelect = function (onSelect_) {
	return $author$project$Component$Form$RadioInput$set(
		function (config) {
			return _Utils_update(
				config,
				{
					eG: $elm$core$Maybe$Just(onSelect_)
				});
		});
};
var $author$project$Data$VacancyFilterOptionValue$toHours = F2(
	function (langCode, _v0) {
		var minHours = _v0.eu;
		var maxHours = _v0.er;
		var toTranslation = ((maxHours === 1) || (langCode === 14)) ? 'uur' : 'uren';
		return _Utils_eq(minHours, maxHours) ? ($elm$core$String$fromInt(minHours) + 'uur') : A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} - {1} {2}',
			_List_fromArray(
				[
					$elm$core$String$fromInt(minHours),
					$elm$core$String$fromInt(maxHours),
					toTranslation
				]));
	});
var $author$project$Data$VacancyFilterOptionValue$toSalary = function (_v0) {
	var minSalary = _v0.ev;
	var maxSalary = _v0.yP;
	return A2(
		$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
		'€{0} - €{1}',
		_List_fromArray(
			[
				$elm$core$String$fromInt(minSalary),
				$elm$core$String$fromInt(maxSalary)
			]));
};
var $author$project$Data$VacancyFilterOptionValue$toText = F2(
	function (langCode, value) {
		switch (value.$) {
			case 0:
				var hourRange = value.a;
				return A2($author$project$Data$VacancyFilterOptionValue$toHours, langCode, hourRange);
			case 2:
				var text = value.a;
				return text;
			default:
				var salaryRange = value.a;
				return $author$project$Data$VacancyFilterOptionValue$toSalary(salaryRange);
		}
	});
var $author$project$Component$Form$RadioInput$build = function (_v0) {
	var label = _v0.bj;
	var name = _v0.c4;
	var options = _v0.VT;
	var toValue = _v0.WI;
	var toLabel = _v0.b7;
	var selectedValue = _v0.ds;
	return {cE: false, bL: $elm$core$Maybe$Nothing, cM: false, bj: label, c4: name, eG: $elm$core$Maybe$Nothing, VT: options, ds: selectedValue, e0: $elm$core$Maybe$Nothing, b7: toLabel, WI: toValue};
};
var $author$project$Component$Form$RadioInput$generateId = function (labelText) {
	return A2(
		$elm$core$String$join,
		'-',
		$elm$core$String$words(labelText));
};
var $author$project$Component$Form$RadioInput$viewRadioButton = F2(
	function (config, radioOption) {
		var onClick_ = function () {
			var _v1 = _Utils_Tuple2(config.eG, config.cE);
			if ((!_v1.a.$) && (!_v1.b)) {
				var onSelect_ = _v1.a.a;
				return _List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						onSelect_(radioOption))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var idValue = function () {
			var _v0 = config.e0;
			if (!_v0.$) {
				var toId_ = _v0.a;
				return toId_(radioOption);
			} else {
				return $author$project$Component$Form$RadioInput$generateId(
					config.b7(radioOption));
			}
		}();
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('radio-button-container'),
					$elm$html$Html$Attributes$for(idValue)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('radio'),
								$elm$html$Html$Attributes$class('radio-button'),
								$elm$html$Html$Attributes$value(
								config.WI(radioOption)),
								$elm$html$Html$Attributes$id(idValue),
								$elm$html$Html$Attributes$checked(
								_Utils_eq(
									$elm$core$Maybe$Just(radioOption),
									config.ds)),
								$elm$html$Html$Attributes$disabled(config.cE),
								$elm$html$Html$Attributes$name(config.c4)
							]),
						onClick_),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('radio-button-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							config.b7(radioOption))
						]))
				]));
	});
var $author$project$Component$Form$RadioInput$viewRadioInput = function (_v0) {
	var config = _v0;
	var labelClassList = _List_fromArray(
		[
			_Utils_Tuple2('label', true),
			_Utils_Tuple2('visually-hidden', config.cM)
		]);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-field', true),
						_Utils_Tuple2(
						'error',
						$elm_community$maybe_extra$Maybe$Extra$isJust(config.bL))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(labelClassList)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(config.bj)
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('radio-input-container')
					]),
				A2(
					$elm$core$List$map,
					$author$project$Component$Form$RadioInput$viewRadioButton(config),
					config.VT)),
				A2(
				$author$project$Util$View$viewMaybe,
				config.bL,
				function (error_) {
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('error-message')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(error_)
							]));
				})
			]));
};
var $author$project$Component$Form$RadioInput$view = F2(
	function (requiredConfig, config) {
		return $author$project$Component$Form$RadioInput$viewRadioInput(
			A3(
				$elm$core$List$foldl,
				function (_v0) {
					var attribute = _v0;
					return attribute;
				},
				$author$project$Component$Form$RadioInput$build(requiredConfig),
				config));
	});
var $author$project$ReferralToolForm$viewFilterRadioInput = F5(
	function (langCode, toMsg, toError, form, filterWithOptions) {
		var filterOptions = filterWithOptions.VT;
		var replaceSelected = function (optionId_) {
			var _v2 = A2($author$project$ReferralToolForm$maybeSelectedOption, filterOptions, form);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var selectedOptionId = _v3.a;
				return A2(
					$elm$core$List$cons,
					optionId_,
					A2(
						$elm$core$List$filter,
						$elm$core$Basics$neq(selectedOptionId),
						form.WW));
			} else {
				return A2($elm$core$List$cons, optionId_, form.WW);
			}
		};
		var onSelectMsg = function (_v1) {
			var optionId_ = _v1.a;
			return _Utils_update(
				form,
				{
					WW: replaceSelected(optionId_)
				});
		};
		var _v0 = filterWithOptions.rz;
		var filterId = _v0.a;
		var filter = _v0.b;
		var radioInputConfig = {
			bj: filter.bj,
			c4: $author$project$Data$Id$toString(filterId),
			VT: filterOptions,
			ds: A2($author$project$ReferralToolForm$maybeSelectedOption, filterOptions, form),
			b7: A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Data$VacancyFilterOptionValue$toText(langCode),
					function ($) {
						return $.dL;
					}),
				$author$project$Data$Entity$value),
			WI: A2($elm$core$Basics$composeL, $author$project$Data$Id$toString, $author$project$Data$Entity$id)
		};
		return A2(
			$author$project$Component$Form$RadioInput$view,
			radioInputConfig,
			_List_fromArray(
				[
					$author$project$Component$Form$RadioInput$error(
					toError('vacancyFilterOptionIds')),
					$author$project$Component$Form$RadioInput$onSelect(
					A2($elm$core$Basics$composeL, toMsg, onSelectMsg))
				]));
	});
var $author$project$ReferralToolForm$viewFiltersWithOptions = F5(
	function (langCode, toMsg, toError, form, filters) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('referral-form-filters-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('referral-form-filters')
						]),
					A2(
						$elm$core$List$map,
						A4($author$project$ReferralToolForm$viewFilterRadioInput, langCode, toMsg, toError, form),
						filters))
				]));
	});
var $author$project$ReferralToolForm$FocusFilterAndResetFilterOptions = function (a) {
	return {$: 2, a: a};
};
var $author$project$Component$Button$ButtonTypeButton = 0;
var $author$project$Component$Button$buttonTypeButton = $author$project$Component$Button$set(
	function (attributes) {
		return _Utils_update(
			attributes,
			{a4: 0});
	});
var $author$project$Component$Button$WidthFillContainer = 0;
var $author$project$Component$Button$fillContainerWidth = $author$project$Component$Button$set(
	function (attributes) {
		return _Utils_update(
			attributes,
			{bF: 0});
	});
var $author$project$Component$Button$Secondary = 1;
var $author$project$Component$Button$secondary = $author$project$Component$Button$set(
	function (attribute) {
		return _Utils_update(
			attribute,
			{W: 1});
	});
var $author$project$ReferralToolForm$viewNestedFilterOptionButton = F3(
	function (langCode, maybeInitialOption, args) {
		var _v0 = args.uV;
		var initialOptionId = _v0.a;
		var initialOption = _v0.b;
		var isSelected_ = _Utils_eq(
			maybeInitialOption,
			$elm$core$Maybe$Just(initialOptionId));
		var buttonStyle = isSelected_ ? $author$project$Component$Button$primary : $author$project$Component$Button$secondary;
		return A2(
			$author$project$Component$Button$view,
			A2($author$project$Data$VacancyFilterOptionValue$toText, langCode, initialOption.dL),
			_List_fromArray(
				[
					$author$project$Component$Button$fillContainerWidth,
					$author$project$Component$Button$buttonTypeButton,
					$author$project$Component$Button$onClick(
					$author$project$ReferralToolForm$FocusFilterAndResetFilterOptions(
						$elm$core$Maybe$Just(initialOptionId))),
					buttonStyle
				]));
	});
var $author$project$ReferralToolForm$viewNoPreferencesButton = function (maybeOptionId) {
	var buttonStyle = $elm_community$maybe_extra$Maybe$Extra$isNothing(maybeOptionId) ? $author$project$Component$Button$primary : $author$project$Component$Button$secondary;
	return A2(
		$author$project$Component$Button$view,
		$author$project$Copy$copy.BO,
		_List_fromArray(
			[
				$author$project$Component$Button$onClick(
				$author$project$ReferralToolForm$FocusFilterAndResetFilterOptions($elm$core$Maybe$Nothing)),
				$author$project$Component$Button$buttonTypeButton,
				buttonStyle
			]));
};
var $author$project$ReferralToolForm$viewFilterOptionSelect = F6(
	function (langCode, toMsg, toError, form, referralFormResponse, maybeInitialOption) {
		if (!referralFormResponse.$) {
			var filtersWithOptions = referralFormResponse.a;
			return A5($author$project$ReferralToolForm$viewFiltersWithOptions, langCode, toMsg, toError, form, filtersWithOptions);
		} else {
			var argsList = referralFormResponse.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('referral-form-tabs-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('referral-form-tabs')
							]),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A2($author$project$ReferralToolForm$viewNestedFilterOptionButton, langCode, maybeInitialOption),
								argsList),
							_List_fromArray(
								[
									$author$project$ReferralToolForm$viewNoPreferencesButton(maybeInitialOption)
								]))),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Util$View$viewMaybe,
								A2($author$project$ReferralToolForm$maybeArgs, maybeInitialOption, argsList),
								function (args) {
									return A5($author$project$ReferralToolForm$viewFiltersWithOptions, langCode, toMsg, toError, form, args.rW);
								})
							]))
					]));
		}
	});
var $author$project$Model$Translation$referralFormUploadLabel = 'referral-form-upload-label';
var $author$project$ReferralToolForm$SelectFile = {$: 7};
var $author$project$ReferralToolForm$viewBrowseMediaButton = function (translations) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Attributes$class('btn btn-submit bg-color-2 color-white'),
				$elm$html$Html$Events$onClick($author$project$ReferralToolForm$SelectFile)
			]),
		_List_fromArray(
			[
				A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$browseMedia)
			]));
};
var $author$project$ReferralToolForm$mediaItemAccepted = function (_v0) {
	var file = _v0.rp;
	var preview = _v0.FG;
	return _Utils_cmp(
		$elm$file$File$size(file),
		preview.bW.a) < 1;
};
var $author$project$ReferralToolForm$viewPreview = F3(
	function (translations, msg, mediaItem) {
		var file = mediaItem.rp;
		var preview = mediaItem.FG;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('share-tool-form__preview')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('img-container'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'error',
									!$author$project$ReferralToolForm$mediaItemAccepted(mediaItem))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(preview.cP)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('img-container__banner bg-color-2 color-white')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$file$File$name(file))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('btn color-white'),
											$elm$html$Html$Events$onClick(msg)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('＋')
										]))
								]))
						])),
					A2(
					$author$project$Util$View$viewIf,
					!$author$project$ReferralToolForm$mediaItemAccepted(mediaItem),
					function (_v0) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('error-overlay'),
									$elm$html$Html$Events$onClick(msg)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Util$Translation$translate(
												$author$project$Util$Translation$FileTooBig(preview.bW.b)))
										])),
									$author$project$View$Icon$viewColored($author$project$View$Icon$path.VL),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$clickToRemove)
										]))
								]));
					})
				]));
	});
var $author$project$ReferralToolForm$viewPreviews = F4(
	function (translations, form, toMsg, preview) {
		return (_Utils_cmp(
			$elm$file$File$size(preview.rp),
			$author$project$ReferralToolForm$maxImageSize.a) > -1) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('share-tool__request-too-big')
				]),
			_List_fromArray(
				[
					$author$project$Component$Message$view(
					{
						cD: A2($author$project$Data$Translation$toString, translations, $author$project$Model$Translation$maxRequestSizeExceededDescription),
						ec: $elm$core$Maybe$Just(
							A2(
								$author$project$Component$Button$view,
								A2($author$project$Data$Translation$toString, translations, $author$project$Model$Translation$browseMedia),
								_List_fromArray(
									[$author$project$Component$Button$secondary]))),
						WC: A2($author$project$Data$Translation$toString, translations, $author$project$Model$Translation$maxRequestSizeExceededTitle)
					})
				])) : A3(
			$author$project$ReferralToolForm$viewPreview,
			translations,
			toMsg(
				_Utils_update(
					form,
					{ux: $elm$core$Maybe$Nothing})),
			preview);
	});
var $author$project$ReferralToolForm$viewMediaUploads = F4(
	function (translations, form, toMsg, toError) {
		return A3(
			$author$project$Component$Form$Input$viewFormField,
			A2($author$project$Data$Translation$toString, translations, $author$project$Model$Translation$referralFormUploadLabel),
			toError('media'),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Util$View$viewMaybe,
						form.ux,
						A3($author$project$ReferralToolForm$viewPreviews, translations, form, toMsg)),
						$author$project$ReferralToolForm$viewBrowseMediaButton(translations)
					])));
	});
var $author$project$ReferralToolForm$view = function (model) {
	var translate = $author$project$Data$Translation$toString(model.P$);
	var _v0 = model.C;
	var form = _v0.a;
	var errorResponse = _v0.b;
	var toError = function (key) {
		if (!errorResponse.$) {
			var validationErrors = errorResponse.a;
			return A2(
				$elm$core$Maybe$andThen,
				$elm$core$Dict$get(
					$author$project$Util$LangCode$toString(model.a9)),
				A2($elm$core$Dict$get, key, validationErrors.UY));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	var toMsg = function (f) {
		return $author$project$ReferralToolForm$UpdateReferralForm(
			_Utils_Tuple2(f, errorResponse));
	};
	var focussedDomains = A2(
		$author$project$Data$Domains$refocus,
		model.bb,
		{
			Vr: $elm$core$Maybe$Just(form.UL),
			Ws: $elm$core$Maybe$Nothing,
			WS: $elm$core$Basics$always($elm$core$Maybe$Nothing),
			WT: $elm$core$Maybe$Nothing
		}).a;
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('referral-form form'),
				$elm$html$Html$Events$onSubmit($author$project$ReferralToolForm$CreateReferral)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Util$View$viewIf,
				$author$project$Data$Domains$hasMultipleDomains(model.bb),
				function (_v1) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-row form-field domain-select')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										translate($author$project$Model$Translation$referralFormReferSomeoneLabel))
									])),
								A2(
								$author$project$Component$DomainSelect$view,
								A2(
									$elm$core$Basics$composeL,
									toMsg,
									function (v) {
										return _Utils_update(
											form,
											{UL: v});
									}),
								focussedDomains)
							]));
				}),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextInput$view,
						translate($author$project$Model$Translation$referralFormFirstNameLabel),
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$error(
								toError('firstName')),
								$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.VW),
								$author$project$Component$Form$TextInput$hiddenLabel(true),
								$author$project$Component$Form$TextInput$onInput(
								A2(
									$elm$core$Basics$composeL,
									toMsg,
									function (v) {
										return _Utils_update(
											form,
											{r3: v});
									})),
								$author$project$Component$Form$TextInput$placeholder(
								translate($author$project$Model$Translation$referralFormFirstNamePlaceholder)),
								$author$project$Component$Form$TextInput$value(form.r3)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextInput$view,
						translate($author$project$Model$Translation$referralFormLastNameLabel),
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$error(
								toError('lastName')),
								$author$project$Component$Form$TextInput$onInput(
								A2(
									$elm$core$Basics$composeL,
									toMsg,
									function (v) {
										return _Utils_update(
											form,
											{w1: v});
									})),
								$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.VW),
								$author$project$Component$Form$TextInput$hiddenLabel(true),
								$author$project$Component$Form$TextInput$placeholder(
								translate($author$project$Model$Translation$referralFormLastNamePlaceholder)),
								$author$project$Component$Form$TextInput$value(form.w1)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextInput$view,
						translate($author$project$Model$Translation$referralFormEmailLabel),
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$error(
								toError('email')),
								$author$project$Component$Form$TextInput$class('email-address'),
								$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.d4),
								$author$project$Component$Form$TextInput$hiddenLabel(true),
								$author$project$Component$Form$TextInput$onInput(
								A2(
									$elm$core$Basics$composeL,
									toMsg,
									function (v) {
										return _Utils_update(
											form,
											{d4: v});
									})),
								$author$project$Component$Form$TextInput$placeholder(
								translate($author$project$Model$Translation$referralFormEmailPlaceholder)),
								$author$project$Component$Form$TextInput$value(form.d4)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextInput$view,
						translate($author$project$Model$Translation$phoneNumberLabel),
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$error(
								toError('phone')),
								$author$project$Component$Form$TextInput$class('phone-number'),
								$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.aM),
								$author$project$Component$Form$TextInput$hiddenLabel(true),
								$author$project$Component$Form$TextInput$onInput(
								A2(
									$elm$core$Basics$composeL,
									toMsg,
									function (v) {
										return _Utils_update(
											form,
											{aM: v});
									})),
								$author$project$Component$Form$TextInput$placeholder(
								translate($author$project$Model$Translation$referralFormPhoneNumber)),
								$author$project$Component$Form$TextInput$value(form.aM)
							]))
					])),
				A2(
				$author$project$Util$View$viewIfNot,
				!A2($author$project$ReferralToolForm$toFilterOptionCount, model.uV, model.b5),
				function (_v2) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-row')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Component$Form$Input$viewFormField,
								translate($author$project$Model$Translation$referralFormMatchingMetadata),
								toError('vacancyFilterOptionIds'),
								A6($author$project$ReferralToolForm$viewFilterOptionSelect, model.a9, toMsg, toError, form, model.b5, model.uV))
							]));
				}),
				A2(
				$author$project$Util$View$viewIf,
				A2($author$project$ReferralToolForm$toAskLocation, model.uV, model.b5),
				function (_v3) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-row')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$View$LocationSuggestions$view,
								$author$project$ReferralToolForm$locationSuggestionsConfig(model),
								model.ah)
							]));
				}),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextArea$view,
						translate($author$project$Model$Translation$personalMessage),
						_List_fromArray(
							[
								$author$project$Component$Form$TextArea$error(
								toError('personalMessage')),
								$author$project$Component$Form$TextArea$onInput(
								A2(
									$elm$core$Basics$composeL,
									toMsg,
									function (v) {
										return _Utils_update(
											form,
											{EQ: v});
									})),
								$author$project$Component$Form$TextArea$hiddenLabel,
								$author$project$Component$Form$TextArea$placeholder(
								translate($author$project$Model$Translation$personalMessage)),
								$author$project$Component$Form$TextArea$value(form.EQ),
								$author$project$Component$Form$TextArea$rows(5)
							]))
					])),
				A4($author$project$ReferralToolForm$viewMediaUploads, model.P$, form, toMsg, toError),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row ')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-field')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Component$Button$view,
								$author$project$Copy$copy.Wq,
								_List_fromArray(
									[$author$project$Component$Button$primary]))
							]))
					]))
			]));
};
var $author$project$ReferralToolForm$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$ReferralToolForm$decodeFlags,
	{cR: $author$project$ReferralToolForm$init, dC: $author$project$ReferralToolForm$subscriptions, dJ: $author$project$ReferralToolForm$update, dM: $author$project$ReferralToolForm$view});
var $author$project$ReferralToolEditForm$Flags = F6(
	function (translations, currentLangCode, domainId, sessionToken, referralEntity, referralFormResponse) {
		return {a9: currentLangCode, cF: domainId, aO: referralEntity, b5: referralFormResponse, av: sessionToken, P$: translations};
	});
var $author$project$Model$Referral$Referral = function (employeeId) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (location) {
					return function (latLong) {
						return function (personalMessage) {
							return function (personalImage) {
								return function (phone) {
									return function (langCode) {
										return function (vacancyFilterOptionIds) {
											return function (uuid) {
												return function (actions) {
													return function (allowed) {
														return function (inserted) {
															return function (updated) {
																return {fq: actions, gy: allowed, d4: email, pZ: employeeId, r3: firstName, u_: inserted, wS: langCode, w1: lastName, w7: latLong, eq: location, EO: personalImage, EQ: personalMessage, aM: phone, QH: updated, RC: uuid, WW: vacancyFilterOptionIds};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$ReferralAction$ReferralAction = F2(
	function (inserted, actionType) {
		return {fm: actionType, u_: inserted};
	});
var $author$project$Model$ReferralAction$ApplicationSend = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$ReferralAction$JobAlert = {$: 3};
var $author$project$Model$ReferralAction$OpenApplicationSend = {$: 1};
var $author$project$Model$ReferralAction$PersonalPageVisited = {$: 2};
var $author$project$Model$ReferralAction$referralActionTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'application-send':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$ReferralAction$ApplicationSend));
			case 'open-application-send':
				return $elm$json$Json$Decode$succeed($author$project$Model$ReferralAction$OpenApplicationSend);
			case 'personal-page-visited':
				return $elm$json$Json$Decode$succeed($author$project$Model$ReferralAction$PersonalPageVisited);
			case 'job-alert':
				return $elm$json$Json$Decode$succeed($author$project$Model$ReferralAction$JobAlert);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$ReferralAction$referralActionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actionType',
	$author$project$Model$ReferralAction$referralActionTypeDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'inserted',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		$elm$json$Json$Decode$succeed($author$project$Model$ReferralAction$ReferralAction)));
var $author$project$Model$ReferralLocation$ReferralLocation = F2(
	function (latitude, longitude) {
		return {w8: latitude, yg: longitude};
	});
var $author$project$Model$ReferralLocation$referralLocationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'longitude',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'latitude',
		$elm$json$Json$Decode$float,
		$elm$json$Json$Decode$succeed($author$project$Model$ReferralLocation$ReferralLocation)));
var $author$project$Model$Referral$referralDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'referralUpdated',
	$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'referralInserted',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'referralAllowed',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'referralActions',
				$elm$json$Json$Decode$list($author$project$Model$ReferralAction$referralActionDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'referralUuid',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'referralVacancyFilterOptionIds',
						$elm$json$Json$Decode$list($author$project$Data$Id$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'referralLangCode',
							$author$project$Model$LangCode$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'referralPhone',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'referralPersonalImage',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'referralPersonalMessage',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'referralLatLong',
											$elm$json$Json$Decode$nullable($author$project$Model$ReferralLocation$referralLocationDecoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'referralLocation',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'referralEmail',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'referralLastName',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'referralFirstName',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'referralEmployeeId',
																$author$project$Data$Id$decoder,
																$elm$json$Json$Decode$succeed($author$project$Model$Referral$Referral)))))))))))))))));
var $author$project$ReferralToolEditForm$decodeFlags = A7(
	$elm$json$Json$Decode$map6,
	$author$project$ReferralToolEditForm$Flags,
	$author$project$Data$Translation$translationsDecoder,
	A2($elm$json$Json$Decode$field, 'currentLangCode', $author$project$Model$LangCode$decoder),
	A2($elm$json$Json$Decode$field, 'domainId', $author$project$Data$Id$decoder),
	A2($elm$json$Json$Decode$field, 'sessionToken', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'referralEntity',
		$author$project$Data$Entity$decoder($author$project$Model$Referral$referralDecoder)),
	A2($elm$json$Json$Decode$field, 'referralFormResponse', $author$project$Model$ReferralFormResponse$referralFormResponseDecoder));
var $author$project$ReferralToolEditForm$initForm = function (_v0) {
	var referral = _v0.b;
	return {l8: false, r3: referral.r3, ux: $elm$core$Maybe$Nothing, w1: referral.w1, w7: $elm$core$Maybe$Nothing, EQ: referral.EQ, aM: referral.aM, WW: referral.WW};
};
var $author$project$ReferralToolEditForm$init = function (flags) {
	return _Utils_Tuple2(
		{
			a9: flags.a9,
			cF: flags.cF,
			uV: $elm$core$List$head(
				$author$project$Data$Entity$value(flags.aO).WW),
			ah: $author$project$View$LocationSuggestions$init,
			aO: flags.aO,
			C: _Utils_Tuple2(
				$author$project$ReferralToolEditForm$initForm(flags.aO),
				$elm$core$Maybe$Nothing),
			b5: flags.b5,
			av: $elm$core$Maybe$Just(flags.av),
			b6: false,
			P$: flags.P$,
			ce: $elm$core$Maybe$Nothing
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$ReferralToolEditForm$GotProgress = function (a) {
	return {$: 3, a: a};
};
var $author$project$ReferralToolEditForm$LocationSuggestionsMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$ReferralToolEditForm$SetLocationSuggestion = function (a) {
	return {$: 10, a: a};
};
var $author$project$ReferralToolEditForm$locationSuggestionsConfig = function (model) {
	return {
		cr: 'location-search-only',
		cF: model.cF,
		xp: $author$project$ReferralToolEditForm$LocationSuggestionsMsg,
		Wh: 1,
		av: model.av,
		Wv: $author$project$View$Autocomplete$Http$Button(
			{Wu: $author$project$ReferralToolEditForm$SetLocationSuggestion, WL: $elm$core$Maybe$Nothing}),
		e4: 'location-suggestion'
	};
};
var $author$project$ReferralToolEditForm$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$http$Http$track, 'submit', $author$project$ReferralToolEditForm$GotProgress),
				A2(
				$author$project$View$LocationSuggestions$subscriptions,
				$author$project$ReferralToolEditForm$locationSuggestionsConfig(model),
				model.ah)
			]));
};
var $author$project$ReferralToolEditForm$GotPatchReferral = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$ReferralToolEditForm$GotPreviews = function (a) {
	return {$: 5, a: a};
};
var $author$project$ReferralToolEditForm$SelectedFile = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Api$Endpoint$referral = function (referralId) {
	return $author$project$Api$Endpoint$endpoint(
		_List_fromArray(
			[
				'referrals',
				$author$project$Data$Id$toString(referralId)
			]));
};
var $author$project$ReferralToolEditForm$toMultiPartBody = function (form) {
	var toLatLongPart = A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$List$singleton,
				$elm$http$Http$stringPart('latLong')),
			$elm$json$Json$Encode$encode(0)),
		$author$project$Model$ReferralLocation$encodeReferralLocation);
	var toLocation = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2($elm$core$Maybe$map, toLatLongPart, form.w7));
	var restOfBody = _List_fromArray(
		[
			A2($elm$http$Http$stringPart, 'firstName', form.r3),
			A2($elm$http$Http$stringPart, 'lastName', form.w1),
			A2($elm$http$Http$stringPart, 'phone', form.aM),
			A2($elm$http$Http$stringPart, 'personalMessage', form.EQ)
		]);
	var optionParts = A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeL,
			$elm$http$Http$stringPart('optionIds'),
			$author$project$Data$Id$toString),
		form.WW);
	var filePart = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (mediaItem) {
				return _List_fromArray(
					[
						A2($elm$http$Http$filePart, 'personalImage', mediaItem.rp)
					]);
			},
			form.ux));
	var body = _Utils_ap(
		filePart,
		_Utils_ap(
			optionParts,
			_Utils_ap(restOfBody, toLocation)));
	return $elm$http$Http$multipartBody(body);
};
var $author$project$ReferralToolEditForm$maxImageSize = _Utils_Tuple2(10000000, '10MB');
var $author$project$ReferralToolEditForm$toPreview = function (base64) {
	var _v0 = $author$project$Data$MimeType$fromBase64(base64);
	if (!_v0.$) {
		return {dV: base64, cP: base64, bW: $author$project$ReferralToolEditForm$maxImageSize};
	} else {
		return {dV: base64, cP: '/static/images/image-placeholder.png', bW: $author$project$ReferralToolEditForm$maxImageSize};
	}
};
var $author$project$ReferralToolEditForm$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var _v1 = model.C;
				var referralForm = _v1.a;
				return _Utils_Tuple2(
					model,
					$author$project$Api$Endpoint$request(
						{
							a2: $author$project$ReferralToolEditForm$toMultiPartBody(referralForm),
							cH: A2(
								$author$project$Api$expectJson,
								$author$project$ReferralToolEditForm$GotPatchReferral(referralForm),
								$elm$json$Json$Decode$succeed(0)),
							cL: _List_Nil,
							c0: 'PATCH',
							dF: $elm$core$Maybe$Nothing,
							WM: $elm$core$Maybe$Just('submit'),
							dK: $author$project$Api$Endpoint$referral(
								$author$project$Data$Entity$id(model.aO))
						}));
			case 2:
				if (!msg.b.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b6: true}),
						$elm$core$Platform$Cmd$none);
				} else {
					if (!msg.b.a.$) {
						var form = msg.a;
						var error = msg.b.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									C: _Utils_Tuple2(
										form,
										$elm$core$Maybe$Just(error)),
									ce: $elm$core$Maybe$Nothing
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{ce: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none);
					}
				}
			case 3:
				if (msg.a.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var progress = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ce: $elm$core$Maybe$Just(
									$elm$http$Http$fractionSent(progress))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 4:
				var form = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{C: form, b6: false}),
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$file$File$Select$files,
						_List_fromArray(
							['image/*', 'gif/*']),
						$author$project$ReferralToolEditForm$SelectedFile));
			case 7:
				var file = msg.a;
				var files = msg.b;
				var fileToMediaItemToUpload = function (f) {
					return A2(
						$elm$core$Task$map,
						function (base64) {
							return {
								rp: f,
								FG: $author$project$ReferralToolEditForm$toPreview(base64)
							};
						},
						$elm$file$File$toUrl(f));
				};
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$ReferralToolEditForm$GotPreviews,
						$elm$core$Task$sequence(
							A2(
								$elm$core$List$map,
								fileToMediaItemToUpload,
								A2($elm$core$List$cons, file, files)))));
			case 5:
				if (msg.a.b) {
					var _v2 = msg.a;
					var preview = _v2.a;
					var _v3 = model.C;
					var form = _v3.a;
					var errorResponse = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								C: _Utils_Tuple2(
									_Utils_update(
										form,
										{
											ux: $elm$core$Maybe$Just(preview)
										}),
									errorResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 8:
				var _v4 = model.C;
				var form = _v4.a;
				var error = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							C: _Utils_Tuple2(
								_Utils_update(
									form,
									{ux: $elm$core$Maybe$Nothing}),
								error)
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var locationSuggestionsMsg = msg.a;
				var _v5 = A3(
					$author$project$View$LocationSuggestions$update,
					$author$project$ReferralToolEditForm$locationSuggestionsConfig(model),
					locationSuggestionsMsg,
					model.ah);
				var locationSuggestionsModel = _v5.a;
				var locationSuggestionsCmds = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ah: locationSuggestionsModel}),
					locationSuggestionsCmds);
			case 10:
				var location = msg.a;
				var toLatLong = function () {
					var _v7 = _Utils_Tuple2(location.w8, location.yg);
					if ((!_v7.a.$) && (!_v7.b.$)) {
						var lat = _v7.a.a;
						var _long = _v7.b.a;
						return $elm$core$Maybe$Just(
							{w8: lat, yg: _long});
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var _v6 = model.C;
				var form = _v6.a;
				var errorResponse = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ah: $author$project$View$LocationSuggestions$resetWithValue(model.ah),
							C: _Utils_Tuple2(
								_Utils_update(
									form,
									{w7: toLatLong}),
								errorResponse)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var maybeOptionId = msg.a;
				var _v8 = model.C;
				var form = _v8.a;
				var errorResponse = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							uV: maybeOptionId,
							C: _Utils_Tuple2(
								_Utils_update(
									form,
									{WW: _List_Nil}),
								errorResponse)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$ReferralToolEditForm$PatchReferral = {$: 1};
var $author$project$ReferralToolEditForm$UpdateReferralForm = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Translation$referralToolChangeFilter = 'referral-tool-change-filter';
var $author$project$ReferralToolEditForm$isSelected = F2(
	function (maybeInitialOption, args) {
		return _Utils_eq(
			maybeInitialOption,
			$elm$core$Maybe$Just(
				$author$project$Data$Entity$id(args.uV)));
	});
var $author$project$ReferralToolEditForm$maybeArgs = F2(
	function (maybeInitialOption, argsList) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				$author$project$ReferralToolEditForm$isSelected(maybeInitialOption),
				argsList));
	});
var $author$project$ReferralToolEditForm$findOptionById = F2(
	function (allOptions, id) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$eq(id),
				$author$project$Data$Entity$id),
			allOptions);
	});
var $author$project$ReferralToolEditForm$maybeSelectedOption = F2(
	function (allOptions, form) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				$author$project$ReferralToolEditForm$findOptionById(allOptions),
				form.WW));
	});
var $author$project$ReferralToolEditForm$viewFilterRadioInput = F5(
	function (langCode, toMsg, toError, form, filterWithOptions) {
		var filterOptions = filterWithOptions.VT;
		var replaceSelected = function (optionId_) {
			var _v2 = A2($author$project$ReferralToolEditForm$maybeSelectedOption, filterOptions, form);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var selectedOptionId = _v3.a;
				return A2(
					$elm$core$List$cons,
					optionId_,
					A2(
						$elm$core$List$filter,
						$elm$core$Basics$neq(selectedOptionId),
						form.WW));
			} else {
				return A2($elm$core$List$cons, optionId_, form.WW);
			}
		};
		var onSelectMsg = function (_v1) {
			var optionId_ = _v1.a;
			return _Utils_update(
				form,
				{
					WW: replaceSelected(optionId_)
				});
		};
		var _v0 = filterWithOptions.rz;
		var filterId = _v0.a;
		var filter = _v0.b;
		var radioInputConfig = {
			bj: filter.bj,
			c4: $author$project$Data$Id$toString(filterId),
			VT: filterOptions,
			ds: A2($author$project$ReferralToolEditForm$maybeSelectedOption, filterOptions, form),
			b7: A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Data$VacancyFilterOptionValue$toText(langCode),
					function ($) {
						return $.dL;
					}),
				$author$project$Data$Entity$value),
			WI: A2($elm$core$Basics$composeL, $author$project$Data$Id$toString, $author$project$Data$Entity$id)
		};
		return A2(
			$author$project$Component$Form$RadioInput$view,
			radioInputConfig,
			_List_fromArray(
				[
					$author$project$Component$Form$RadioInput$error(
					toError('vacancyFilterOptionIds')),
					$author$project$Component$Form$RadioInput$onSelect(
					A2($elm$core$Basics$composeL, toMsg, onSelectMsg))
				]));
	});
var $author$project$ReferralToolEditForm$viewFiltersWithOptions = F5(
	function (langCode, toMsg, toError, form, filters) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('referral-form-filters-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('referral-form-filters')
						]),
					A2(
						$elm$core$List$map,
						A4($author$project$ReferralToolEditForm$viewFilterRadioInput, langCode, toMsg, toError, form),
						filters))
				]));
	});
var $author$project$ReferralToolEditForm$FocusFilterAndResetFilterOptions = function (a) {
	return {$: 11, a: a};
};
var $author$project$ReferralToolEditForm$viewNestedFilterOptionButton = F3(
	function (langCode, maybeInitialOption, args) {
		var _v0 = args.uV;
		var initialOptionId = _v0.a;
		var initialOption = _v0.b;
		var isSelected_ = _Utils_eq(
			maybeInitialOption,
			$elm$core$Maybe$Just(initialOptionId));
		var buttonStyle = isSelected_ ? $author$project$Component$Button$primary : $author$project$Component$Button$secondary;
		return A2(
			$author$project$Component$Button$view,
			A2($author$project$Data$VacancyFilterOptionValue$toText, langCode, initialOption.dL),
			_List_fromArray(
				[
					$author$project$Component$Button$fillContainerWidth,
					$author$project$Component$Button$buttonTypeButton,
					$author$project$Component$Button$onClick(
					$author$project$ReferralToolEditForm$FocusFilterAndResetFilterOptions(
						$elm$core$Maybe$Just(initialOptionId))),
					buttonStyle
				]));
	});
var $author$project$ReferralToolEditForm$viewNoPreferencesButton = function (maybeOptionId) {
	var buttonStyle = $elm_community$maybe_extra$Maybe$Extra$isNothing(maybeOptionId) ? $author$project$Component$Button$primary : $author$project$Component$Button$secondary;
	return A2(
		$author$project$Component$Button$view,
		$author$project$Copy$copy.BO,
		_List_fromArray(
			[
				$author$project$Component$Button$onClick(
				$author$project$ReferralToolEditForm$FocusFilterAndResetFilterOptions($elm$core$Maybe$Nothing)),
				$author$project$Component$Button$buttonTypeButton,
				buttonStyle
			]));
};
var $author$project$ReferralToolEditForm$viewFilterOptionSelect = F6(
	function (langCode, toMsg, toError, form, referralFormResponse, maybeInitialOption) {
		if (!referralFormResponse.$) {
			var filtersWithOptions = referralFormResponse.a;
			return A5($author$project$ReferralToolEditForm$viewFiltersWithOptions, langCode, toMsg, toError, form, filtersWithOptions);
		} else {
			var argsList = referralFormResponse.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('referral-form-tabs-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('referral-form-tabs')
							]),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A2($author$project$ReferralToolEditForm$viewNestedFilterOptionButton, langCode, maybeInitialOption),
								argsList),
							_List_fromArray(
								[
									$author$project$ReferralToolEditForm$viewNoPreferencesButton(maybeInitialOption)
								]))),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Util$View$viewMaybe,
								A2($author$project$ReferralToolEditForm$maybeArgs, maybeInitialOption, argsList),
								function (args) {
									return A5($author$project$ReferralToolEditForm$viewFiltersWithOptions, langCode, toMsg, toError, form, args.rW);
								})
							]))
					]));
		}
	});
var $author$project$ReferralToolEditForm$view = function (model) {
	var translate = $author$project$Data$Translation$toString(model.P$);
	var _v0 = model.C;
	var form = _v0.a;
	var errorResponse = _v0.b;
	var toError = function (key) {
		if (!errorResponse.$) {
			var validationErrors = errorResponse.a;
			return A2(
				$elm$core$Maybe$andThen,
				$elm$core$Dict$get(
					$author$project$Util$LangCode$toString(model.a9)),
				A2($elm$core$Dict$get, key, validationErrors.UY));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	var toMsg = function (f) {
		return $author$project$ReferralToolEditForm$UpdateReferralForm(
			_Utils_Tuple2(f, errorResponse));
	};
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('referral-tool-edit-form'),
				$elm$html$Html$Events$onSubmit($author$project$ReferralToolEditForm$PatchReferral)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextInput$view,
						translate($author$project$Model$Translation$referralFormFirstNameLabel),
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$error(
								toError('firstName')),
								$author$project$Component$Form$TextInput$onInput(
								A2(
									$elm$core$Basics$composeL,
									toMsg,
									function (v) {
										return _Utils_update(
											form,
											{r3: v});
									})),
								$author$project$Component$Form$TextInput$placeholder(
								translate($author$project$Model$Translation$referralFormFirstNamePlaceholder)),
								$author$project$Component$Form$TextInput$value(form.r3)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextInput$view,
						translate($author$project$Model$Translation$referralFormLastNameLabel),
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$error(
								toError('lastName')),
								$author$project$Component$Form$TextInput$onInput(
								A2(
									$elm$core$Basics$composeL,
									toMsg,
									function (v) {
										return _Utils_update(
											form,
											{w1: v});
									})),
								$author$project$Component$Form$TextInput$placeholder(
								translate($author$project$Model$Translation$referralFormLastNamePlaceholder)),
								$author$project$Component$Form$TextInput$value(form.w1)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextInput$view,
						translate($author$project$Model$Translation$phoneNumberLabel),
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$error(
								toError('phone')),
								$author$project$Component$Form$TextInput$onInput(
								A2(
									$elm$core$Basics$composeL,
									toMsg,
									function (v) {
										return _Utils_update(
											form,
											{aM: v});
									})),
								$author$project$Component$Form$TextInput$placeholder(
								translate($author$project$Model$Translation$referralFormPhoneNumber)),
								$author$project$Component$Form$TextInput$value(form.aM)
							]))
					])),
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						translate($author$project$Model$Translation$referralToolChangeFilter))
					])),
				A6($author$project$ReferralToolEditForm$viewFilterOptionSelect, model.a9, toMsg, toError, form, model.b5, model.uV),
				A2(
				$author$project$Util$View$viewIf,
				model.b6,
				function (_v1) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-row success')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text($author$project$Copy$copy.Wr)
									]))
							]));
				}),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row ')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Button$view,
						$author$project$Copy$copy.Wq,
						_List_fromArray(
							[$author$project$Component$Button$primary]))
					]))
			]));
};
var $author$project$ReferralToolEditForm$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$ReferralToolEditForm$decodeFlags,
	{cR: $author$project$ReferralToolEditForm$init, dC: $author$project$ReferralToolEditForm$subscriptions, dJ: $author$project$ReferralToolEditForm$update, dM: $author$project$ReferralToolEditForm$view});
var $author$project$RecruitmentChat$Flags = function (recruitmentChat) {
	return function (recruitmentChats) {
		return function (localStorageState) {
			return function (showRecruitmentChat) {
				return function (showChat) {
					return function (sessionToken) {
						return function (domainId) {
							return function (langCode) {
								return function (today) {
									return function (windowWidth) {
										return function (schemaFields) {
											return function (currentNodesOnly) {
												return {an: currentNodesOnly, cF: domainId, wS: langCode, xU: localStorageState, GA: recruitmentChat, b4: recruitmentChats, eL: schemaFields, av: sessionToken, du: showChat, eP: showRecruitmentChat, e2: today, ch: windowWidth};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$View$ChatBot$LocalStorageState = F4(
	function (nodeId, showFormOfVacancyId, showFormOfNodeId, salaryCalculatorInput) {
		return {ar: nodeId, aj: salaryCalculatorInput, LS: showFormOfNodeId, LT: showFormOfVacancyId};
	});
var $author$project$Dict$Custom$Dict = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Dict$Custom$empty = F2(
	function (f, g) {
		return A3($author$project$Dict$Custom$Dict, f, g, $elm$core$Dict$empty);
	});
var $author$project$Dict$Custom$insert = F3(
	function (k, v, _v0) {
		var f = _v0.a;
		var g = _v0.b;
		var dict = _v0.c;
		return A3(
			$author$project$Dict$Custom$Dict,
			f,
			g,
			A3(
				$elm$core$Dict$insert,
				f(k),
				v,
				dict));
	});
var $author$project$Dict$Custom$fromList = F3(
	function (f, g, list) {
		var ins = F2(
			function (_v0, acc) {
				var k = _v0.a;
				var v = _v0.b;
				return A3($author$project$Dict$Custom$insert, k, v, acc);
			});
		return A3(
			$elm$core$List$foldl,
			ins,
			A2($author$project$Dict$Custom$empty, f, g),
			list);
	});
var $author$project$Dict$Custom$fromListVia = function (_v0) {
	var f = _v0.a;
	var g = _v0.b;
	return A2($author$project$Dict$Custom$fromList, f, g);
};
var $author$project$Dict$Custom$decoderVia = F3(
	function (dict, f, g) {
		return A2(
			$elm$json$Json$Decode$map,
			$author$project$Dict$Custom$fromListVia(dict),
			$elm$json$Json$Decode$list(
				A3(
					$elm$json$Json$Decode$map2,
					$elm$core$Tuple$pair,
					A2($elm$json$Json$Decode$index, 0, f),
					A2($elm$json$Json$Decode$index, 1, g))));
	});
var $author$project$Data$ChatBot$NodeId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$ChatBot$idToInt = function (nodeId) {
	if (nodeId.$ === 1) {
		return 0;
	} else {
		var id = nodeId.a;
		return id;
	}
};
var $author$project$Data$ChatBot$emptyDict = A2($author$project$Dict$Custom$empty, $author$project$Data$ChatBot$idToInt, $author$project$Data$ChatBot$NodeId);
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Data$ChatBot$nodeIdDecoder = A2($elm$json$Json$Decode$map, $author$project$Data$ChatBot$NodeId, $elm$json$Json$Decode$int);
var $author$project$View$ChatBot$localStorageStateDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$View$ChatBot$LocalStorageState,
	A2($elm$json$Json$Decode$field, 'nodeId', $author$project$Data$ChatBot$nodeIdDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'showFormOfVacancyId',
		$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder)),
	A2(
		$elm$json$Json$Decode$field,
		'showFormOfNodeId',
		$elm$json$Json$Decode$nullable($author$project$Data$ChatBot$nodeIdDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'salaryCalculatorInput',
		A3(
			$author$project$Dict$Custom$decoderVia,
			$author$project$Data$ChatBot$emptyDict,
			$author$project$Data$ChatBot$nodeIdDecoder,
			A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (age, hours) {
						return {gd: age, t1: hours};
					}),
				A2($elm$json$Json$Decode$field, 'age', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'hours', $elm$json$Json$Decode$int)))));
var $author$project$Model$RecruitmentChat$RecruitmentChat = F8(
	function (domainId, label, title, introduction, chatBot, botAvatar, inserted, updated) {
		return {jE: botAvatar, kT: chatBot, cF: domainId, u_: inserted, bS: introduction, bj: label, WC: title, QH: updated};
	});
var $author$project$Model$RecruitmentChat$ChatBot$ChatBot = $elm$core$Basics$identity;
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $zwilias$elm_rosetree$Tree$Tree = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $zwilias$elm_rosetree$Tree$tree = $zwilias$elm_rosetree$Tree$Tree;
var $author$project$Util$Tree$decoder = function (decode) {
	return A3(
		$elm$json$Json$Decode$map2,
		$zwilias$elm_rosetree$Tree$tree,
		A2($elm$json$Json$Decode$field, 'label', decode),
		A2(
			$elm$json$Json$Decode$field,
			'children',
			$elm$json$Json$Decode$list(
				$elm$json$Json$Decode$lazy(
					function (_v0) {
						return $author$project$Util$Tree$decoder(decode);
					}))));
};
var $author$project$Model$RecruitmentChat$ChatBot$EmbeddedChatBot = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$RecruitmentChat$ChatBot$Image = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$RecruitmentChat$ChatBot$Link = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$RecruitmentChat$ChatBot$Option = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$RecruitmentChat$ChatBot$Root = {$: 8};
var $author$project$Model$RecruitmentChat$ChatBot$SalaryCalculator = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$RecruitmentChat$ChatBot$Text = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$RecruitmentChat$ChatBot$VacancyOverview = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$RecruitmentChat$ChatBot$Video = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$RecruitmentChat$ChatBot$LinkSettings = F3(
	function (title, url, target) {
		return {OS: target, WC: title, dK: url};
	});
var $author$project$Model$RecruitmentChat$ChatBot$Blank = 0;
var $author$project$Model$RecruitmentChat$ChatBot$Self = 1;
var $author$project$Model$RecruitmentChat$ChatBot$linkTargetDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'blank':
				return $elm$json$Json$Decode$succeed(0);
			case 'self':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$RecruitmentChat$ChatBot$linkSettingsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'target',
	$author$project$Model$RecruitmentChat$ChatBot$linkTargetDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'url',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$LinkSettings))));
var $author$project$Model$RecruitmentChat$ChatBot$VacancyOverviewSettings = F2(
	function (vacancyFilterOptionIds, enableLocationSort) {
		return {UR: enableLocationSort, WW: vacancyFilterOptionIds};
	});
var $author$project$Model$RecruitmentChat$ChatBot$vacancyOverviewSettingsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'enableLocationSort',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vacancyFilterOptionIds',
		$elm$json$Json$Decode$list($author$project$Data$Id$decoder),
		$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$VacancyOverviewSettings)));
var $author$project$Model$RecruitmentChat$ChatBot$nodeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'option':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$Option));
			case 'text':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$Text));
			case 'link':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$RecruitmentChat$ChatBot$linkSettingsDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$Link));
			case 'vacancy-overview':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$RecruitmentChat$ChatBot$vacancyOverviewSettingsDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$VacancyOverview));
			case 'salary-calculator':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
					$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$SalaryCalculator));
			case 'image':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$Image));
			case 'video':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$Video));
			case 'embedded-chat-bot':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
					$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$EmbeddedChatBot));
			case 'root':
				return $elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$ChatBot$Root);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$RecruitmentChat$ChatBot$chatBotDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	$author$project$Util$Tree$decoder($author$project$Model$RecruitmentChat$ChatBot$nodeDecoder));
var $author$project$Model$RecruitmentChat$recruitmentChatDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'recruitmentChatUpdated',
	$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'recruitmentChatInserted',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'recruitmentChatBotAvatar',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'recruitmentChatChatBot',
				$author$project$Model$RecruitmentChat$ChatBot$chatBotDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'recruitmentChatIntroduction',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'recruitmentChatTitle',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'recruitmentChatLabel',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'recruitmentChatDomainId',
								$author$project$Data$Id$decoder,
								$elm$json$Json$Decode$succeed($author$project$Model$RecruitmentChat$RecruitmentChat)))))))));
var $author$project$Model$FormV2Schema$SchemaField = F3(
	function (type_, name, requiredByExport) {
		return {c4: name, If: requiredByExport, dI: type_};
	});
var $author$project$Model$FormFieldV2$AdditionalFile1 = {$: 0};
var $author$project$Model$FormFieldV2$AdditionalFile2 = {$: 1};
var $author$project$Model$FormFieldV2$Address = {$: 2};
var $author$project$Model$FormFieldV2$AddressWithAutoFill = {$: 3};
var $author$project$Model$FormFieldV2$Availability = {$: 4};
var $author$project$Model$FormFieldV2$Button = {$: 5};
var $author$project$Model$FormFieldV2$City = {$: 6};
var $author$project$Model$FormFieldV2$Custom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$FormFieldV2$CustomCanadaProvince = {$: 8};
var $author$project$Model$FormFieldV2$CustomEthnicIdentification = {$: 9};
var $author$project$Model$FormFieldV2$CustomHowDidYouGetHereSelect = {$: 10};
var $author$project$Model$FormFieldV2$CustomIsHispanic = {$: 11};
var $author$project$Model$FormFieldV2$CustomSelect = {$: 12};
var $author$project$Model$FormFieldV2$CustomState = {$: 13};
var $author$project$Model$FormFieldV2$DateOfBirth = {$: 14};
var $author$project$Model$FormFieldV2$EmailAddress = {$: 15};
var $author$project$Model$FormFieldV2$FirstName = {$: 16};
var $author$project$Model$FormFieldV2$GradesBachelor1 = {$: 17};
var $author$project$Model$FormFieldV2$GradesBachelor2 = {$: 18};
var $author$project$Model$FormFieldV2$GradesMaster1 = {$: 19};
var $author$project$Model$FormFieldV2$GradesMaster2 = {$: 20};
var $author$project$Model$FormFieldV2$Heading = {$: 21};
var $author$project$Model$FormFieldV2$HowDidYouGetHere = {$: 22};
var $author$project$Model$FormFieldV2$Image = {$: 23};
var $author$project$Model$FormFieldV2$Internal = {$: 24};
var $author$project$Model$FormFieldV2$InternshipEvaluation1 = {$: 25};
var $author$project$Model$FormFieldV2$InternshipEvaluation2 = {$: 26};
var $author$project$Model$FormFieldV2$IntroText = {$: 27};
var $author$project$Model$FormFieldV2$LastName = {$: 28};
var $author$project$Model$FormFieldV2$Link = {$: 29};
var $author$project$Model$FormFieldV2$LinkedInUrl = {$: 30};
var $author$project$Model$FormFieldV2$Motivation = {$: 31};
var $author$project$Model$FormFieldV2$MotivationTextArea = {$: 32};
var $author$project$Model$FormFieldV2$NewsletterSubscription = {$: 33};
var $author$project$Model$FormFieldV2$OpenCheckboxFour = {$: 34};
var $author$project$Model$FormFieldV2$OpenCheckboxOne = {$: 35};
var $author$project$Model$FormFieldV2$OpenCheckboxThree = {$: 36};
var $author$project$Model$FormFieldV2$OpenCheckboxTwo = {$: 37};
var $author$project$Model$FormFieldV2$OpenText = {$: 38};
var $author$project$Model$FormFieldV2$OrderedList = {$: 39};
var $author$project$Model$FormFieldV2$PhoneNumber = {$: 40};
var $author$project$Model$FormFieldV2$PhoneNumberWithCallingCode = {$: 41};
var $author$project$Model$FormFieldV2$PlainText = {$: 42};
var $author$project$Model$FormFieldV2$Portfolio = {$: 43};
var $author$project$Model$FormFieldV2$PostalCode = {$: 44};
var $author$project$Model$FormFieldV2$Privacy = {$: 45};
var $author$project$Model$FormFieldV2$Referred = {$: 46};
var $author$project$Model$FormFieldV2$Resume = {$: 47};
var $author$project$Model$FormFieldV2$SalaryIndication = {$: 48};
var $author$project$Model$FormFieldV2$ScreeningQuestions = {$: 49};
var $author$project$Model$FormFieldV2$Source = {$: 50};
var $author$project$Model$FormFieldV2$Spacer = {$: 51};
var $author$project$Model$FormFieldV2$StoreData = {$: 52};
var $author$project$Model$FormFieldV2$Thesis = {$: 53};
var $author$project$Model$FormFieldV2$UnorderedList = {$: 54};
var $author$project$Model$FormFieldV2$Url = {$: 55};
var $author$project$Model$FormFieldV2$Usp = {$: 56};
var $author$project$Model$FormFieldV2$Video = {$: 57};
var $author$project$Model$FormFieldV2$XingUrl = {$: 58};
var $author$project$Model$FormFieldV2$fieldNameDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'additional-file1':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$AdditionalFile1);
			case 'additional-file2':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$AdditionalFile2);
			case 'address':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Address);
			case 'address-with-auto-fill':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$AddressWithAutoFill);
			case 'availability':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Availability);
			case 'button':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Button);
			case 'city':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$City);
			case 'custom':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Custom));
			case 'custom-canada-province':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$CustomCanadaProvince);
			case 'custom-ethnic-identification':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$CustomEthnicIdentification);
			case 'custom-how-did-you-get-here-select':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$CustomHowDidYouGetHereSelect);
			case 'custom-is-hispanic':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$CustomIsHispanic);
			case 'custom-select':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$CustomSelect);
			case 'custom-state':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$CustomState);
			case 'date-of-birth':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$DateOfBirth);
			case 'email-address':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$EmailAddress);
			case 'first-name':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$FirstName);
			case 'grades-bachelor1':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$GradesBachelor1);
			case 'grades-bachelor2':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$GradesBachelor2);
			case 'grades-master1':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$GradesMaster1);
			case 'grades-master2':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$GradesMaster2);
			case 'heading':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Heading);
			case 'how-did-you-get-here':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$HowDidYouGetHere);
			case 'image':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Image);
			case 'internal':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Internal);
			case 'internship-evaluation1':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$InternshipEvaluation1);
			case 'internship-evaluation2':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$InternshipEvaluation2);
			case 'intro-text':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$IntroText);
			case 'last-name':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$LastName);
			case 'link':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Link);
			case 'linked-in-url':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$LinkedInUrl);
			case 'motivation':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Motivation);
			case 'motivation-text-area':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$MotivationTextArea);
			case 'newsletter-subscription':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$NewsletterSubscription);
			case 'open-checkbox-four':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$OpenCheckboxFour);
			case 'open-checkbox-one':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$OpenCheckboxOne);
			case 'open-checkbox-three':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$OpenCheckboxThree);
			case 'open-checkbox-two':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$OpenCheckboxTwo);
			case 'open-text':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$OpenText);
			case 'ordered-list':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$OrderedList);
			case 'phone-number':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$PhoneNumber);
			case 'phone-number-with-calling-code':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$PhoneNumberWithCallingCode);
			case 'plain-text':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$PlainText);
			case 'portfolio':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Portfolio);
			case 'postal-code':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$PostalCode);
			case 'privacy':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Privacy);
			case 'referred':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Referred);
			case 'resume':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Resume);
			case 'salary-indication':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$SalaryIndication);
			case 'screening-questions':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$ScreeningQuestions);
			case 'source':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Source);
			case 'spacer':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Spacer);
			case 'store-data':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$StoreData);
			case 'thesis':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Thesis);
			case 'unordered-list':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$UnorderedList);
			case 'url':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Url);
			case 'usp':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Usp);
			case 'video':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Video);
			case 'xing-url':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$XingUrl);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$FormFieldTypeV2$Address = {$: 0};
var $author$project$Model$FormFieldTypeV2$Checkbox = {$: 1};
var $author$project$Model$FormFieldTypeV2$Content = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$FormFieldTypeV2$Date = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$FormFieldTypeV2$DaypartAvailability = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$FormFieldTypeV2$EmailAddress = {$: 5};
var $author$project$Model$FormFieldTypeV2$File = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$FormFieldTypeV2$Phone = {$: 7};
var $author$project$Model$FormFieldTypeV2$ScreeningQuestions = {$: 13};
var $author$project$Model$FormFieldTypeV2$Select = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$FormFieldTypeV2$SelectWithIds = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$FormFieldTypeV2$Text = function (a) {
	return {$: 10, a: a};
};
var $author$project$Model$FormFieldTypeV2$TextArea = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$FormFieldTypeV2$Url = function (a) {
	return {$: 12, a: a};
};
var $author$project$Model$FormFieldTypeV2$DateFieldOptions = F2(
	function (minOffsetFromTodayInYears, maxOffsetFromTodayInYears) {
		return {c$: maxOffsetFromTodayInYears, c1: minOffsetFromTodayInYears};
	});
var $author$project$Model$FormFieldTypeV2$dateFieldOptionsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxOffsetFromTodayInYears',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minOffsetFromTodayInYears',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$DateFieldOptions)));
var $author$project$Model$FormFieldTypeV2$DaypartAvailabilityFieldOptions = function (availableParts) {
	return {Uh: availableParts};
};
var $author$project$Model$FormFieldTypeV2$Friday = 4;
var $author$project$Model$FormFieldTypeV2$Monday = 0;
var $author$project$Model$FormFieldTypeV2$Saturday = 5;
var $author$project$Model$FormFieldTypeV2$Sunday = 6;
var $author$project$Model$FormFieldTypeV2$Thursday = 3;
var $author$project$Model$FormFieldTypeV2$Tuesday = 1;
var $author$project$Model$FormFieldTypeV2$Wednesday = 2;
var $author$project$Model$FormFieldTypeV2$dayOfWeekDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'monday':
				return $elm$json$Json$Decode$succeed(0);
			case 'tuesday':
				return $elm$json$Json$Decode$succeed(1);
			case 'wednesday':
				return $elm$json$Json$Decode$succeed(2);
			case 'thursday':
				return $elm$json$Json$Decode$succeed(3);
			case 'friday':
				return $elm$json$Json$Decode$succeed(4);
			case 'saturday':
				return $elm$json$Json$Decode$succeed(5);
			case 'sunday':
				return $elm$json$Json$Decode$succeed(6);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$FormFieldTypeV2$Afternoon = 1;
var $author$project$Model$FormFieldTypeV2$Evening = 2;
var $author$project$Model$FormFieldTypeV2$Morning = 0;
var $author$project$Model$FormFieldTypeV2$Night = 3;
var $author$project$Model$FormFieldTypeV2$daypartDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'morning':
				return $elm$json$Json$Decode$succeed(0);
			case 'afternoon':
				return $elm$json$Json$Decode$succeed(1);
			case 'evening':
				return $elm$json$Json$Decode$succeed(2);
			case 'night':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$FormFieldTypeV2$daypartAvailabilityFieldOptionsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'availableParts',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$index, 0, $author$project$Model$FormFieldTypeV2$dayOfWeekDecoder),
			A2($elm$json$Json$Decode$index, 1, $author$project$Model$FormFieldTypeV2$daypartDecoder))),
	$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$DaypartAvailabilityFieldOptions));
var $author$project$Model$FormFieldTypeV2$FileFieldOptions = F2(
	function (mimeTypes, maxFileSizeInMB) {
		return {yK: maxFileSizeInMB, zi: mimeTypes};
	});
var $author$project$Model$FormFieldTypeV2$MimeType = $elm$core$Basics$identity;
var $author$project$Model$FormFieldTypeV2$mimeTypeDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Model$FormFieldTypeV2$fileFieldOptionsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxFileSizeInMB',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'mimeTypes',
		$elm$json$Json$Decode$list($author$project$Model$FormFieldTypeV2$mimeTypeDecoder),
		$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$FileFieldOptions)));
var $author$project$Model$FormFieldTypeV2$TextFieldOptions = F2(
	function (minLength, maxLength) {
		return {yM: maxLength, zk: minLength};
	});
var $author$project$Model$FormFieldTypeV2$textFieldOptionsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxLength',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minLength',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$TextFieldOptions)));
var $author$project$Model$FormFieldTypeV2$Default = 0;
var $author$project$Model$FormFieldTypeV2$LinkedInUrl = 2;
var $author$project$Model$FormFieldTypeV2$XingUrl = 1;
var $author$project$Model$FormFieldTypeV2$urlTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'default':
				return $elm$json$Json$Decode$succeed(0);
			case 'xing-url':
				return $elm$json$Json$Decode$succeed(1);
			case 'linked-in-url':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$FormFieldTypeV2$fieldTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'address':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Address);
			case 'checkbox':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Checkbox);
			case 'content':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Content$contentDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Content));
			case 'date':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$FormFieldTypeV2$dateFieldOptionsDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Date));
			case 'daypart-availability':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$FormFieldTypeV2$daypartAvailabilityFieldOptionsDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$DaypartAvailability));
			case 'email-address':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$EmailAddress);
			case 'file':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$FormFieldTypeV2$fileFieldOptionsDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$File));
			case 'phone':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Phone);
			case 'select':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Select));
			case 'select-with-ids':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$list(
						A3(
							$elm$json$Json$Decode$map2,
							$elm$core$Tuple$pair,
							A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$SelectWithIds));
			case 'text':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$FormFieldTypeV2$textFieldOptionsDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Text));
			case 'text-area':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$FormFieldTypeV2$textFieldOptionsDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$TextArea));
			case 'url':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$FormFieldTypeV2$urlTypeDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$Url));
			case 'screening-questions':
				return $elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$ScreeningQuestions);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$FormV2Schema$schemaFieldDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'requiredByExport',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$author$project$Model$FormFieldV2$fieldNameDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type_',
			$author$project$Model$FormFieldTypeV2$fieldTypeDecoder,
			$elm$json$Json$Decode$succeed($author$project$Model$FormV2Schema$SchemaField))));
var $author$project$Util$Date$Today = $elm$core$Basics$identity;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $author$project$Util$Date$todayFromPosix = function (zone) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$core$Basics$identity,
		$justinmimbs$date$Date$fromPosix(zone));
};
var $author$project$Util$Date$todayDecoder = function () {
	var today = F2(
		function (now, offset) {
			return A2(
				$author$project$Util$Date$todayFromPosix,
				A2($elm$time$Time$customZone, offset, _List_Nil),
				$elm$time$Time$millisToPosix(now));
		});
	return A3(
		$elm$json$Json$Decode$map2,
		today,
		A2($elm$json$Json$Decode$field, 'now', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'timeZoneOffset', $elm$json$Json$Decode$int));
}();
var $author$project$RecruitmentChat$decodeFlags = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'currentNodesOnly',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'schemaFields',
		$elm$json$Json$Decode$list($author$project$Model$FormV2Schema$schemaFieldDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'windowWidth',
			$author$project$Browser$Dom$Breakpoint$windowWidthDecoder,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Util$Date$todayDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'langCode',
					$author$project$Model$LangCode$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'domainId',
						$author$project$Data$Id$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'sessionToken',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'showChat',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'showRecruitmentChat',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'localStorageState',
										$elm$json$Json$Decode$oneOf(
											_List_fromArray(
												[
													A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$View$ChatBot$localStorageStateDecoder),
													$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
												])),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'recruitmentChats',
											$elm$json$Json$Decode$list(
												$author$project$Data$Entity$decoder($author$project$Model$RecruitmentChat$recruitmentChatDecoder)),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'recruitmentChat',
												$author$project$Data$Entity$decoder($author$project$Model$RecruitmentChat$recruitmentChatDecoder),
												$elm$json$Json$Decode$succeed($author$project$RecruitmentChat$Flags)))))))))))));
var $author$project$RecruitmentChat$ChatBotMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$RecruitmentChat$HideIntroduction = {$: 3};
var $author$project$RecruitmentChat$autoHideIntroduction = A2(
	$elm$core$Task$perform,
	$elm$core$Basics$identity,
	A2(
		$elm$core$Task$andThen,
		$elm$core$Basics$always(
			$elm$core$Task$succeed($author$project$RecruitmentChat$HideIntroduction)),
		$elm$core$Process$sleep(1000 * 10)));
var $author$project$RecruitmentChat$NoOp = {$: 5};
var $author$project$RecruitmentChat$ShowChatBot = {$: 1};
var $author$project$RecruitmentChat$delayShowChatBot = F2(
	function (mTime, mShowChat) {
		var time = 1000 * A2($elm$core$Maybe$withDefault, 0, mTime);
		var msg = function () {
			if (mTime.$ === 1) {
				return $author$project$RecruitmentChat$NoOp;
			} else {
				return $author$project$RecruitmentChat$ShowChatBot;
			}
		}();
		return $elm_community$maybe_extra$Maybe$Extra$isNothing(mShowChat) ? A2(
			$elm$core$Task$perform,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Task$andThen,
				$elm$core$Basics$always(
					$elm$core$Task$succeed(msg)),
				$elm$core$Process$sleep(time))) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Data$Id$emptyDict = A2($author$project$Dict$Custom$empty, $author$project$Data$Id$toInt, $elm$core$Basics$identity);
var $author$project$Data$Status$NotAsked = {$: 0};
var $zwilias$elm_rosetree$Tree$mapAccumulateHelp = F4(
	function (f, state, acc, stack) {
		mapAccumulateHelp:
		while (true) {
			var _v0 = acc.u;
			if (!_v0.b) {
				var node = A2(
					$zwilias$elm_rosetree$Tree$Tree,
					acc.bj,
					$elm$core$List$reverse(acc.d));
				if (!stack.b) {
					return _Utils_Tuple2(state, node);
				} else {
					var top = stack.a;
					var rest = stack.b;
					var $temp$f = f,
						$temp$state = state,
						$temp$acc = _Utils_update(
						top,
						{
							d: A2($elm$core$List$cons, node, top.d)
						}),
						$temp$stack = rest;
					f = $temp$f;
					state = $temp$state;
					acc = $temp$acc;
					stack = $temp$stack;
					continue mapAccumulateHelp;
				}
			} else {
				if (!_v0.a.b.b) {
					var _v2 = _v0.a;
					var d = _v2.a;
					var rest = _v0.b;
					var _v3 = A2(f, state, d);
					var state_ = _v3.a;
					var label_ = _v3.b;
					var $temp$f = f,
						$temp$state = state_,
						$temp$acc = _Utils_update(
						acc,
						{
							d: A2(
								$elm$core$List$cons,
								A2($zwilias$elm_rosetree$Tree$Tree, label_, _List_Nil),
								acc.d),
							u: rest
						}),
						$temp$stack = stack;
					f = $temp$f;
					state = $temp$state;
					acc = $temp$acc;
					stack = $temp$stack;
					continue mapAccumulateHelp;
				} else {
					var _v4 = _v0.a;
					var d = _v4.a;
					var cs = _v4.b;
					var rest = _v0.b;
					var _v5 = A2(f, state, d);
					var state_ = _v5.a;
					var label_ = _v5.b;
					var $temp$f = f,
						$temp$state = state_,
						$temp$acc = {d: _List_Nil, bj: label_, u: cs},
						$temp$stack = A2(
						$elm$core$List$cons,
						_Utils_update(
							acc,
							{u: rest}),
						stack);
					f = $temp$f;
					state = $temp$state;
					acc = $temp$acc;
					stack = $temp$stack;
					continue mapAccumulateHelp;
				}
			}
		}
	});
var $zwilias$elm_rosetree$Tree$mapAccumulate = F3(
	function (f, s, _v0) {
		var d = _v0.a;
		var cs = _v0.b;
		var _v1 = A2(f, s, d);
		var s_ = _v1.a;
		var d_ = _v1.b;
		return A4(
			$zwilias$elm_rosetree$Tree$mapAccumulateHelp,
			f,
			s_,
			{d: _List_Nil, bj: d_, u: cs},
			_List_Nil);
	});
var $zwilias$elm_rosetree$Tree$map = F2(
	function (f, t) {
		return A3(
			$zwilias$elm_rosetree$Tree$mapAccumulate,
			F2(
				function (_v0, e) {
					return _Utils_Tuple2(
						0,
						f(e));
				}),
			0,
			t).b;
	});
var $author$project$Data$ChatBot$NodeDepth = $elm$core$Basics$identity;
var $author$project$Data$ChatBot$NodeIdUnset = {$: 1};
var $author$project$Data$ChatBot$newNodeWithId = function (node) {
	return {bK: 0, cO: $author$project$Data$ChatBot$NodeIdUnset, bq: node};
};
var $zwilias$elm_rosetree$Tree$children = function (_v0) {
	var c = _v0.b;
	return c;
};
var $zwilias$elm_rosetree$Tree$label = function (_v0) {
	var v = _v0.a;
	return v;
};
var $author$project$Data$ChatBot$setDepthHelper = F2(
	function (depth, tree) {
		return A2(
			$zwilias$elm_rosetree$Tree$tree,
			function (n) {
				return _Utils_update(
					n,
					{bK: depth});
			}(
				$zwilias$elm_rosetree$Tree$label(tree)),
			A2(
				$elm$core$List$map,
				$author$project$Data$ChatBot$setDepthHelper(depth + 1),
				$zwilias$elm_rosetree$Tree$children(tree)));
	});
var $author$project$Data$ChatBot$setDepth = function (tree) {
	return A2(
		$zwilias$elm_rosetree$Tree$tree,
		function (n) {
			return _Utils_update(
				n,
				{bK: 0});
		}(
			$zwilias$elm_rosetree$Tree$label(tree)),
		A2(
			$elm$core$List$map,
			$author$project$Data$ChatBot$setDepthHelper(1),
			$zwilias$elm_rosetree$Tree$children(tree)));
};
var $zwilias$elm_rosetree$Tree$foldlHelp = F4(
	function (f, acc, trees, nextSets) {
		foldlHelp:
		while (true) {
			if (!trees.b) {
				if (nextSets.b) {
					var set = nextSets.a;
					var sets = nextSets.b;
					var $temp$f = f,
						$temp$acc = acc,
						$temp$trees = set,
						$temp$nextSets = sets;
					f = $temp$f;
					acc = $temp$acc;
					trees = $temp$trees;
					nextSets = $temp$nextSets;
					continue foldlHelp;
				} else {
					return acc;
				}
			} else {
				if (!trees.a.b.b) {
					var _v2 = trees.a;
					var d = _v2.a;
					var rest = trees.b;
					var $temp$f = f,
						$temp$acc = A2(f, d, acc),
						$temp$trees = rest,
						$temp$nextSets = nextSets;
					f = $temp$f;
					acc = $temp$acc;
					trees = $temp$trees;
					nextSets = $temp$nextSets;
					continue foldlHelp;
				} else {
					var _v3 = trees.a;
					var d = _v3.a;
					var xs = _v3.b;
					var rest = trees.b;
					var $temp$f = f,
						$temp$acc = A2(f, d, acc),
						$temp$trees = xs,
						$temp$nextSets = A2($elm$core$List$cons, rest, nextSets);
					f = $temp$f;
					acc = $temp$acc;
					trees = $temp$trees;
					nextSets = $temp$nextSets;
					continue foldlHelp;
				}
			}
		}
	});
var $zwilias$elm_rosetree$Tree$foldl = F3(
	function (f, acc, t) {
		return A4(
			$zwilias$elm_rosetree$Tree$foldlHelp,
			f,
			acc,
			_List_fromArray(
				[t]),
			_List_Nil);
	});
var $author$project$Data$ChatBot$maxId = A2(
	$zwilias$elm_rosetree$Tree$foldl,
	F2(
		function (x, acc) {
			return A2(
				$elm$core$Basics$max,
				acc,
				$author$project$Data$ChatBot$idToInt(x.cO));
		}),
	0);
var $author$project$Data$ChatBot$updateNewIds = function (tree) {
	var updateId = F2(
		function (nextId, node) {
			var _v0 = node.cO;
			if (_v0.$ === 1) {
				return _Utils_Tuple2(
					nextId + 1,
					_Utils_update(
						node,
						{
							cO: $author$project$Data$ChatBot$NodeId(nextId)
						}));
			} else {
				return _Utils_Tuple2(nextId, node);
			}
		});
	return A3(
		$zwilias$elm_rosetree$Tree$mapAccumulate,
		F2(
			function (acc, node) {
				return A2(updateId, acc, node);
			}),
		$author$project$Data$ChatBot$maxId(tree) + 1,
		tree).b;
};
var $author$project$Data$ChatBot$fromChatBot = function (_v0) {
	var tree = _v0;
	return $author$project$Data$ChatBot$setDepth(
		$author$project$Data$ChatBot$updateNewIds(
			A2($zwilias$elm_rosetree$Tree$map, $author$project$Data$ChatBot$newNodeWithId, tree)));
};
var $zwilias$elm_rosetree$Tree$singleton = function (v) {
	return A2($zwilias$elm_rosetree$Tree$Tree, v, _List_Nil);
};
var $author$project$Data$ChatBot$emptyTree = $author$project$Data$ChatBot$fromChatBot(
	$zwilias$elm_rosetree$Tree$singleton($author$project$Model$RecruitmentChat$ChatBot$Root));
var $zwilias$elm_rosetree$Tree$Zipper$Zipper = $elm$core$Basics$identity;
var $zwilias$elm_rosetree$Tree$Zipper$fromTree = function (t) {
	return {h: _List_Nil, i: _List_Nil, z: _List_Nil, r8: t};
};
var $author$project$Data$ChatBot$emptyZipper = $zwilias$elm_rosetree$Tree$Zipper$fromTree($author$project$Data$ChatBot$emptyTree);
var $author$project$ScrollToInElement$State = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $tad_lispy$springs$Spring$Spring = $elm$core$Basics$identity;
var $tad_lispy$springs$Spring$create = function (_v0) {
	var strength = _v0.N1;
	var dampness = _v0.nw;
	return {
		nw: A2($elm$core$Basics$pow, dampness, 2),
		N1: strength,
		OS: 0,
		dL: 0,
		aX: 0
	};
};
var $author$project$ScrollToInElement$initWithSettings = F2(
	function (nodeId, settings) {
		return A2(
			$author$project$ScrollToInElement$State,
			nodeId,
			{
				TM: $tad_lispy$springs$Spring$create(settings),
				m: $tad_lispy$springs$Spring$create(settings)
			});
	});
var $author$project$ScrollToInElement$init = function (nodeId) {
	return A2(
		$author$project$ScrollToInElement$initWithSettings,
		nodeId,
		{nw: 4.5, N1: 120});
};
var $author$project$View$ChatBot$empty = {
	D: $elm$core$Maybe$Nothing,
	kT: $author$project$Data$ChatBot$emptyZipper,
	a6: A2($author$project$Dict$Custom$fromListVia, $author$project$Data$Id$emptyDict, _List_Nil),
	an: false,
	aD: $elm$core$Maybe$Nothing,
	ah: $elm$core$Maybe$Nothing,
	bt: $elm$core$Set$empty,
	aj: $author$project$Data$ChatBot$emptyDict,
	aR: $author$project$Data$Id$emptyDict,
	eL: _List_Nil,
	O: $author$project$ScrollToInElement$init('chat-nodes'),
	av: $elm$core$Maybe$Nothing,
	ad: $author$project$Data$ChatBot$emptyDict
};
var $author$project$View$ChatBot$ScrollToMsg = function (a) {
	return {$: 5, a: a};
};
var $zwilias$elm_rosetree$Tree$Zipper$tree = function (_v0) {
	var focus = _v0.r8;
	return focus;
};
var $zwilias$elm_rosetree$Tree$Zipper$label = function (zipper) {
	return $zwilias$elm_rosetree$Tree$label(
		$zwilias$elm_rosetree$Tree$Zipper$tree(zipper));
};
var $zwilias$elm_rosetree$Tree$Zipper$find = F3(
	function (predicate, move, zipper) {
		find:
		while (true) {
			var _v0 = move(zipper);
			if (!_v0.$) {
				var next = _v0.a;
				if (predicate(
					$zwilias$elm_rosetree$Tree$Zipper$label(next))) {
					return $elm$core$Maybe$Just(next);
				} else {
					var $temp$predicate = predicate,
						$temp$move = move,
						$temp$zipper = next;
					predicate = $temp$predicate;
					move = $temp$move;
					zipper = $temp$zipper;
					continue find;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $zwilias$elm_rosetree$Tree$Zipper$firstChild = function (_v0) {
	var zipper = _v0;
	var _v1 = $zwilias$elm_rosetree$Tree$children(zipper.r8);
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var c = _v1.a;
		var cs = _v1.b;
		return $elm$core$Maybe$Just(
			{
				h: cs,
				i: _List_Nil,
				z: A2(
					$elm$core$List$cons,
					{
						h: zipper.h,
						i: zipper.i,
						bj: $zwilias$elm_rosetree$Tree$label(zipper.r8)
					},
					zipper.z),
				r8: c
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$firstOf = F2(
	function (options, v) {
		firstOf:
		while (true) {
			if (!options.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var option = options.a;
				var rest = options.b;
				var _v1 = option(v);
				if (!_v1.$) {
					var r = _v1.a;
					return $elm$core$Maybe$Just(r);
				} else {
					var $temp$options = rest,
						$temp$v = v;
					options = $temp$options;
					v = $temp$v;
					continue firstOf;
				}
			}
		}
	});
var $zwilias$elm_rosetree$Tree$Zipper$nextSibling = function (_v0) {
	var zipper = _v0;
	var _v1 = zipper.h;
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var next = _v1.a;
		var rest = _v1.b;
		return $elm$core$Maybe$Just(
			{
				h: rest,
				i: A2($elm$core$List$cons, zipper.r8, zipper.i),
				z: zipper.z,
				r8: next
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$reconstruct = F4(
	function (focus, before, after, l) {
		return A2(
			$zwilias$elm_rosetree$Tree$tree,
			l,
			_Utils_ap(
				$elm$core$List$reverse(before),
				_Utils_ap(
					_List_fromArray(
						[focus]),
					after)));
	});
var $zwilias$elm_rosetree$Tree$Zipper$parent = function (_v0) {
	var zipper = _v0;
	var _v1 = zipper.z;
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var crumb = _v1.a;
		var rest = _v1.b;
		return $elm$core$Maybe$Just(
			{
				h: crumb.h,
				i: crumb.i,
				z: rest,
				r8: A4($zwilias$elm_rosetree$Tree$Zipper$reconstruct, zipper.r8, zipper.i, zipper.h, crumb.bj)
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$nextSiblingOfAncestor = function (zipper) {
	nextSiblingOfAncestor:
	while (true) {
		var _v0 = $zwilias$elm_rosetree$Tree$Zipper$parent(zipper);
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var parent_ = _v0.a;
			var _v1 = $zwilias$elm_rosetree$Tree$Zipper$nextSibling(parent_);
			if (_v1.$ === 1) {
				var $temp$zipper = parent_;
				zipper = $temp$zipper;
				continue nextSiblingOfAncestor;
			} else {
				var s = _v1.a;
				return $elm$core$Maybe$Just(s);
			}
		}
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$forward = function (zipper) {
	return A2(
		$zwilias$elm_rosetree$Tree$Zipper$firstOf,
		_List_fromArray(
			[$zwilias$elm_rosetree$Tree$Zipper$firstChild, $zwilias$elm_rosetree$Tree$Zipper$nextSibling, $zwilias$elm_rosetree$Tree$Zipper$nextSiblingOfAncestor]),
		zipper);
};
var $zwilias$elm_rosetree$Tree$Zipper$findNext = F2(
	function (f, zipper) {
		return A3($zwilias$elm_rosetree$Tree$Zipper$find, f, $zwilias$elm_rosetree$Tree$Zipper$forward, zipper);
	});
var $zwilias$elm_rosetree$Tree$Zipper$previousSibling = function (_v0) {
	var zipper = _v0;
	var _v1 = zipper.i;
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var previous = _v1.a;
		var rest = _v1.b;
		return $elm$core$Maybe$Just(
			{
				h: A2($elm$core$List$cons, zipper.r8, zipper.h),
				i: rest,
				z: zipper.z,
				r8: previous
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$firstSibling = function (zipper) {
	firstSibling:
	while (true) {
		var _v0 = $zwilias$elm_rosetree$Tree$Zipper$previousSibling(zipper);
		if (_v0.$ === 1) {
			return zipper;
		} else {
			var z = _v0.a;
			var $temp$zipper = z;
			zipper = $temp$zipper;
			continue firstSibling;
		}
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$root = function (zipper) {
	root:
	while (true) {
		var _v0 = $zwilias$elm_rosetree$Tree$Zipper$parent(zipper);
		if (_v0.$ === 1) {
			return $zwilias$elm_rosetree$Tree$Zipper$firstSibling(zipper);
		} else {
			var z = _v0.a;
			var $temp$zipper = z;
			zipper = $temp$zipper;
			continue root;
		}
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$findFromRoot = F2(
	function (f, zipper) {
		var r = $zwilias$elm_rosetree$Tree$Zipper$root(zipper);
		return f(
			$zwilias$elm_rosetree$Tree$Zipper$label(r)) ? $elm$core$Maybe$Just(r) : A2($zwilias$elm_rosetree$Tree$Zipper$findNext, f, r);
	});
var $zwilias$elm_rosetree$Tree$Zipper$append = F2(
	function (t, _v0) {
		var zipper = _v0;
		return _Utils_update(
			zipper,
			{
				h: A2($elm$core$List$cons, t, zipper.h)
			});
	});
var $zwilias$elm_rosetree$Tree$Zipper$toTree = A2($elm$core$Basics$composeL, $zwilias$elm_rosetree$Tree$Zipper$tree, $zwilias$elm_rosetree$Tree$Zipper$root);
var $author$project$Data$ChatBot$withZipper = F3(
	function (id, tree, f) {
		return A2(
			$elm$core$Maybe$withDefault,
			tree,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Data$ChatBot$setDepth, $author$project$Data$ChatBot$updateNewIds),
						$zwilias$elm_rosetree$Tree$Zipper$toTree),
					f),
				A2(
					$zwilias$elm_rosetree$Tree$Zipper$findFromRoot,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$eq(id),
						function ($) {
							return $.cO;
						}),
					$zwilias$elm_rosetree$Tree$Zipper$fromTree(tree))));
	});
var $author$project$Data$ChatBot$appendTree = F3(
	function (toAppend, id, tree) {
		return A3(
			$author$project$Data$ChatBot$withZipper,
			id,
			tree,
			$zwilias$elm_rosetree$Tree$Zipper$append(toAppend));
	});
var $zwilias$elm_rosetree$Tree$Zipper$reconstructWithoutFocus = F3(
	function (l, before, after) {
		return A2(
			$zwilias$elm_rosetree$Tree$tree,
			l,
			_Utils_ap(
				$elm$core$List$reverse(before),
				after));
	});
var $zwilias$elm_rosetree$Tree$Zipper$removeTree = function (_v0) {
	var zipper = _v0;
	var _v1 = _Utils_Tuple3(zipper.z, zipper.i, zipper.h);
	if (_v1.a.b) {
		var _v2 = _v1.a;
		var crumb = _v2.a;
		var rest = _v2.b;
		var before = _v1.b;
		var after = _v1.c;
		return $elm$core$Maybe$Just(
			{
				h: crumb.h,
				i: crumb.i,
				z: rest,
				r8: A3($zwilias$elm_rosetree$Tree$Zipper$reconstructWithoutFocus, crumb.bj, before, after)
			});
	} else {
		if (_v1.b.b) {
			var _v3 = _v1.b;
			var b = _v3.a;
			var bs = _v3.b;
			var after = _v1.c;
			return $elm$core$Maybe$Just(
				{h: after, i: bs, z: _List_Nil, r8: b});
		} else {
			if (!_v1.c.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v4 = _v1.c;
				var a = _v4.a;
				var as_ = _v4.b;
				return $elm$core$Maybe$Just(
					{h: as_, i: _List_Nil, z: _List_Nil, r8: a});
			}
		}
	}
};
var $author$project$Data$ChatBot$deleteNode = F2(
	function (id, tree) {
		return A3(
			$author$project$Data$ChatBot$withZipper,
			id,
			tree,
			function (z) {
				return A2(
					$elm$core$Maybe$withDefault,
					z,
					$zwilias$elm_rosetree$Tree$Zipper$removeTree(z));
			});
	});
var $author$project$Data$ChatBot$embeddedRecruitmentChatIds = A2(
	$zwilias$elm_rosetree$Tree$foldl,
	F2(
		function (x, acc) {
			var _v0 = x.bq;
			if ((_v0.$ === 7) && (!_v0.a.$)) {
				var recruitmentChatId = _v0.a.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(x.cO, recruitmentChatId),
					acc);
			} else {
				return acc;
			}
		}),
	_List_Nil);
var $author$project$Dict$Custom$get = F2(
	function (k, _v0) {
		var f = _v0.a;
		var dict = _v0.c;
		return A2(
			$elm$core$Dict$get,
			f(k),
			dict);
	});
var $author$project$Data$ChatBot$fromChatBotHelper = F3(
	function (recursiveDepth, embeddableChatBots, tree) {
		return $author$project$Data$ChatBot$updateNewIds(
			A4(
				$author$project$Data$ChatBot$replaceEmbeddedChatBot,
				recursiveDepth,
				embeddableChatBots,
				tree,
				$author$project$Data$ChatBot$embeddedRecruitmentChatIds(tree)));
	});
var $author$project$Data$ChatBot$replaceEmbeddedChatBot = F4(
	function (recursiveDepth, embeddableChatBots, tree, idsToReplace) {
		var replace = F2(
			function (_v1, acc) {
				var nodeId = _v1.a;
				var recruitmentChatId = _v1.b;
				var _v0 = A2($author$project$Dict$Custom$get, recruitmentChatId, embeddableChatBots);
				if (_v0.$ === 1) {
					return acc;
				} else {
					var embeddableChatBot = _v0.a;
					return A2(
						$author$project$Data$ChatBot$deleteNode,
						nodeId,
						A3(
							$elm$core$List$foldr,
							F2(
								function (child, acc2) {
									return A3(
										$author$project$Data$ChatBot$appendTree,
										A2($zwilias$elm_rosetree$Tree$map, $author$project$Data$ChatBot$newNodeWithId, child),
										nodeId,
										acc2);
								}),
							acc,
							$zwilias$elm_rosetree$Tree$children(embeddableChatBot)));
				}
			});
		return ($elm$core$List$isEmpty(idsToReplace) || (recursiveDepth > 4)) ? tree : A3(
			$author$project$Data$ChatBot$fromChatBotHelper,
			recursiveDepth + 1,
			embeddableChatBots,
			A3(
				$elm$core$List$foldl,
				replace,
				tree,
				$author$project$Data$ChatBot$embeddedRecruitmentChatIds(tree)));
	});
var $author$project$Data$ChatBot$fromChatBotWithEmbedded = F2(
	function (embeddableChatBots, _v0) {
		var tree = _v0;
		return $author$project$Data$ChatBot$setDepth(
			$author$project$Data$ChatBot$updateNewIds(
				A3(
					$author$project$Data$ChatBot$fromChatBotHelper,
					0,
					embeddableChatBots,
					A2($zwilias$elm_rosetree$Tree$map, $author$project$Data$ChatBot$newNodeWithId, tree))));
	});
var $author$project$View$ChatBot$CheckQueue = function (a) {
	return {$: 4, a: a};
};
var $zwilias$elm_rosetree$Tree$Zipper$children = function (zipper) {
	return $zwilias$elm_rosetree$Tree$children(
		$zwilias$elm_rosetree$Tree$Zipper$tree(zipper));
};
function $author$project$Data$ChatBot$cyclic$before() {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Maybe$withDefault(_List_Nil),
			$elm$core$Maybe$map(
				function (x) {
					return _Utils_ap(
						$author$project$Data$ChatBot$cyclic$before()(x),
						$zwilias$elm_rosetree$Tree$Zipper$children(x));
				})),
		$zwilias$elm_rosetree$Tree$Zipper$parent);
}
var $author$project$Data$ChatBot$before = $author$project$Data$ChatBot$cyclic$before();
$author$project$Data$ChatBot$cyclic$before = function () {
	return $author$project$Data$ChatBot$before;
};
var $author$project$Data$ChatBot$currentAndBefore = function (x) {
	return _Utils_ap(
		$author$project$Data$ChatBot$before(x),
		$zwilias$elm_rosetree$Tree$Zipper$children(x));
};
var $elm$core$Dict$diff = F2(
	function (t1, t2) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, t) {
					return A2($elm$core$Dict$remove, k, t);
				}),
			t1,
			t2);
	});
var $elm$core$Set$diff = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$diff, dict1, dict2);
	});
var $author$project$View$ChatBot$diffQueue = function (model) {
	var activeNodes = $elm$core$Set$fromList(
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Data$ChatBot$idToInt,
					function ($) {
						return $.cO;
					}),
				$zwilias$elm_rosetree$Tree$label),
			$author$project$Data$ChatBot$currentAndBefore(model.kT)));
	return A2($elm$core$Set$diff, activeNodes, model.bt);
};
var $zwilias$elm_rosetree$Tree$foldr = F3(
	function (f, acc, t) {
		return A3(
			$elm$core$List$foldl,
			f,
			acc,
			A3($zwilias$elm_rosetree$Tree$foldl, $elm$core$List$cons, _List_Nil, t));
	});
var $zwilias$elm_rosetree$Tree$flatten = function (t) {
	return A3($zwilias$elm_rosetree$Tree$foldr, $elm$core$List$cons, _List_Nil, t);
};
var $zwilias$elm_rosetree$Tree$indexedMap = F2(
	function (f, t) {
		return A3(
			$zwilias$elm_rosetree$Tree$mapAccumulate,
			F2(
				function (idx, elem) {
					return _Utils_Tuple2(
						idx + 1,
						A2(f, idx, elem));
				}),
			0,
			t).b;
	});
var $author$project$View$ChatBot$nextNode = function (data) {
	var orderIndex = $elm$core$Dict$fromList(
		$zwilias$elm_rosetree$Tree$flatten(
			A2(
				$zwilias$elm_rosetree$Tree$indexedMap,
				F2(
					function (i, n) {
						return _Utils_Tuple2(
							$author$project$Data$ChatBot$idToInt(n.cO),
							i);
					}),
				$zwilias$elm_rosetree$Tree$Zipper$toTree(data.kT))));
	var findNode = function (index) {
		return A2(
			$zwilias$elm_rosetree$Tree$Zipper$findFromRoot,
			function (n) {
				return _Utils_eq(
					$author$project$Data$ChatBot$idToInt(n.cO),
					index);
			},
			data.kT);
	};
	return A2(
		$elm$core$Maybe$map,
		$zwilias$elm_rosetree$Tree$Zipper$label,
		A2(
			$elm$core$Maybe$andThen,
			findNode,
			$elm$core$List$head(
				A2(
					$elm$core$List$sortBy,
					function (i) {
						return A2(
							$elm$core$Maybe$withDefault,
							0,
							A2($elm$core$Dict$get, i, orderIndex));
					},
					$elm$core$Set$toList(
						$author$project$View$ChatBot$diffQueue(data))))));
};
var $author$project$View$ChatBot$nodeTypeToDelay = F2(
	function (currentNodesOnly, nodeType) {
		if (currentNodesOnly) {
			return 0;
		} else {
			switch (nodeType.$) {
				case 1:
					var val = nodeType.a;
					return A3(
						$elm$core$Basics$clamp,
						1250,
						2000,
						$elm$core$String$length(val) * 32);
				case 2:
					return 600;
				case 0:
					var val = nodeType.a;
					return A3(
						$elm$core$Basics$clamp,
						750,
						2000,
						$elm$core$String$length(val) * 16);
				case 3:
					return 600;
				case 4:
					return 600;
				case 5:
					return 600;
				case 6:
					return 600;
				case 7:
					return 600;
				default:
					return 0;
			}
		}
	});
var $author$project$View$ChatBot$queueNextNodeToShow = function (data) {
	var _v0 = $author$project$View$ChatBot$nextNode(data);
	if (_v0.$ === 1) {
		return $elm$core$Platform$Cmd$none;
	} else {
		var node = _v0.a;
		return A2(
			$elm$core$Task$perform,
			function (_v1) {
				return $author$project$View$ChatBot$CheckQueue(node.cO);
			},
			$elm$core$Process$sleep(
				A2($author$project$View$ChatBot$nodeTypeToDelay, data.an, node.bq)));
	}
};
var $author$project$View$ChatBot$GotSalaryCalculator = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Api$Endpoint$defaultSearchParams = {dX: _List_Nil, el: $elm$core$Maybe$Nothing, en: 10, eq: $elm$core$Maybe$Nothing, er: 40, eu: 0, ev: 0, eE: 0};
var $author$project$View$ChatBot$maxResults = 5;
var $author$project$View$ChatBot$chatBotSearchParams = _Utils_update(
	$author$project$Api$Endpoint$defaultSearchParams,
	{en: $author$project$View$ChatBot$maxResults});
var $author$project$Api$Endpoint$salaryCalculator = F2(
	function (domainId, id) {
		return $author$project$Api$Endpoint$endpoint(
			_List_fromArray(
				[
					$author$project$Data$Id$toString(domainId),
					'salary-calculator',
					$author$project$Data$Id$toString(id)
				]));
	});
var $author$project$Data$SalaryCalculator$get = F2(
	function (domainId, salaryCalculatorId) {
		return A2(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$salaryCalculator, domainId, salaryCalculatorId),
			$author$project$Data$Entity$decoder($author$project$Model$SalaryCalculator$salaryCalculatorDecoder));
	});
var $author$project$Model$Translation$Form = 0;
var $author$project$View$ChatBot$FormData = F3(
	function (form, translations, privacyPage) {
		return {bP: form, dh: privacyPage, P$: translations};
	});
var $author$project$View$ChatBot$GotForm = function (a) {
	return {$: 2, a: a};
};
var $author$project$View$ChatBot$HttpError = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$ChatBot$MissingVacancyTemplate = {$: 1};
var $author$project$Model$PageType$PrivacyPage = {$: 7};
var $elm$core$Task$fail = _Scheduler_fail;
var $author$project$Api$Endpoint$form = function (formId) {
	return $author$project$Api$Endpoint$endpoint(
		_List_fromArray(
			[
				'form',
				$author$project$Data$Id$toString(formId)
			]));
};
var $author$project$Model$FormV2$Form = F8(
	function (label, formType, fields, required, isDefaultApplicationForm, externalId, inserted, updated) {
		return {qO: externalId, rn: fields, sk: formType, u_: inserted, vN: isDefaultApplicationForm, bj: label, dl: required, QH: updated};
	});
var $author$project$Model$FormFieldV2$FieldNames = $elm$core$Basics$identity;
var $author$project$Model$FormFieldV2$fieldNamesDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$list($author$project$Model$FormFieldV2$fieldNameDecoder)));
var $author$project$Model$FormFieldV2$Fields = $elm$core$Basics$identity;
var $author$project$Model$FormFieldV2$Field = function (type_) {
	return function (name) {
		return function (defaultLabel) {
			return function (hiddenLabel) {
				return function (label) {
					return function (defaultPlaceholder) {
						return function (placeholder) {
							return function (defaultMissingError) {
								return function (missingError) {
									return function (defaultInvalidError) {
										return function (invalidError) {
											return {UF: defaultInvalidError, UG: defaultLabel, UH: defaultMissingError, UI: defaultPlaceholder, Vd: hiddenLabel, Vj: invalidError, bj: label, Vu: missingError, c4: name, dd: placeholder, dI: type_};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$FormFieldV2$fieldDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'invalidError',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$index, 0, $author$project$Data$Id$decoder),
			A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'defaultInvalidError',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'missingError',
			$elm$json$Json$Decode$list(
				A3(
					$elm$json$Json$Decode$map2,
					$elm$core$Tuple$pair,
					A2($elm$json$Json$Decode$index, 0, $author$project$Data$Id$decoder),
					A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'defaultMissingError',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'placeholder',
					$elm$json$Json$Decode$list(
						A3(
							$elm$json$Json$Decode$map2,
							$elm$core$Tuple$pair,
							A2($elm$json$Json$Decode$index, 0, $author$project$Data$Id$decoder),
							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'defaultPlaceholder',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'label',
							$elm$json$Json$Decode$list(
								A3(
									$elm$json$Json$Decode$map2,
									$elm$core$Tuple$pair,
									A2($elm$json$Json$Decode$index, 0, $author$project$Data$Id$decoder),
									A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string))),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'hiddenLabel',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'defaultLabel',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$author$project$Model$FormFieldV2$fieldNameDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'type_',
											$author$project$Model$FormFieldTypeV2$fieldTypeDecoder,
											$elm$json$Json$Decode$succeed($author$project$Model$FormFieldV2$Field))))))))))));
var $author$project$Model$FormFieldV2$fieldsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$list($author$project$Model$FormFieldV2$fieldDecoder)));
var $author$project$Model$Form$FormType$EventRegistration = 2;
var $author$project$Model$Form$FormType$JobApplication = 0;
var $author$project$Model$Form$FormType$OpenJobApplication = 1;
var $author$project$Model$Form$FormType$UbeeoEventRegistration = 3;
var $author$project$Model$Form$FormType$formTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'job-application':
				return $elm$json$Json$Decode$succeed(0);
			case 'open-job-application':
				return $elm$json$Json$Decode$succeed(1);
			case 'event-registration':
				return $elm$json$Json$Decode$succeed(2);
			case 'ubeeo-event-registration':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$FormV2$formDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'formUpdated',
	$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'formInserted',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'formExternalId',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'formIsDefaultApplicationForm',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'formRequired',
					$author$project$Model$FormFieldV2$fieldNamesDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'formFields',
						$author$project$Model$FormFieldV2$fieldsDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'formFormType',
							$author$project$Model$Form$FormType$formTypeDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'formLabel',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Model$FormV2$Form)))))))));
var $author$project$Data$Form$get = function (formId) {
	return A2(
		$author$project$Api$get,
		$author$project$Api$Endpoint$form(formId),
		$author$project$Data$Entity$decoder($author$project$Model$FormV2$formDecoder));
};
var $author$project$Model$Page$Page = function (backgroundGradient) {
	return function (childSeqNo) {
		return function (discipline) {
			return function (domainId) {
				return function (educationLevel) {
					return function (journeyLevel) {
						return function (footerPosition) {
							return function (headerPosition) {
								return function (inserted) {
									return function (inSitemap) {
										return function (isDeleted) {
											return function (label) {
												return function (langCode) {
													return function (metaDescription) {
														return function (pageType) {
															return function (parentId) {
																return function (path) {
																	return function (_protected) {
																		return function (recruitmentChat) {
																			return function (shareImages) {
																				return function (showChat) {
																					return function (showCookieModal) {
																						return function (showFooter) {
																							return function (showHeader) {
																								return function (templatePageId) {
																									return function (updated) {
																										return function (vacancyId) {
																											return function (whatsappConfig) {
																												return function (seniorityLevel) {
																													return {co: backgroundGradient, kV: childSeqNo, oH: discipline, cF: domainId, pl: educationLevel, sa: footerPosition, tz: headerPosition, cQ: inSitemap, u_: inserted, vO: isDeleted, wv: journeyLevel, bj: label, wS: langCode, zc: metaDescription, VU: pageType, Es: parentId, Ex: path, eI: _protected, GA: recruitmentChat, aS: seniorityLevel, dt: shareImages, du: showChat, dv: showCookieModal, dw: showFooter, dx: showHeader, OY: templatePageId, QH: updated, R6: vacancyId, dO: whatsappConfig};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$Discipline$AdministratieBedrijfsvoering = 0;
var $author$project$Model$Discipline$BouwArchitectuur = 1;
var $author$project$Model$Discipline$BouwmanagementArchitectuurCartografie = 2;
var $author$project$Model$Discipline$CommercieelAdministratiefMedewerkers = 3;
var $author$project$Model$Discipline$FinanceAccounting = 4;
var $author$project$Model$Discipline$FoodBeverage = 5;
var $author$project$Model$Discipline$Gezondheidszorg = 6;
var $author$project$Model$Discipline$Juridisch = 7;
var $author$project$Model$Discipline$KlantenondersteuningService = 8;
var $author$project$Model$Discipline$LandbouwNatuurVisserij = 9;
var $author$project$Model$Discipline$MarketingCommunicatieReclame = 10;
var $author$project$Model$Discipline$MediaDesignCultuur = 11;
var $author$project$Model$Discipline$NutsvoorzieningenAfvalverwerking = 12;
var $author$project$Model$Discipline$OnderwijsInstructie = 13;
var $author$project$Model$Discipline$OnderzoekWetenschap = 14;
var $author$project$Model$Discipline$ProductieMontageReparatie = 15;
var $author$project$Model$Discipline$Retail = 16;
var $author$project$Model$Discipline$SchoonmaakGroenvoorziening = 17;
var $author$project$Model$Discipline$SoftwareInformatietechnologie = 18;
var $author$project$Model$Discipline$SupplyChainLogistiek = 19;
var $author$project$Model$Discipline$ToerismeRecreatieEventmanagement = 20;
var $author$project$Model$Discipline$Transport = 21;
var $author$project$Model$Discipline$UiterlijkeVerzorgingPersoonlijkeDienstverlening = 22;
var $author$project$Model$Discipline$VeiligheidBewaking = 23;
var $author$project$Model$Discipline$ZorgWelzijn = 24;
var $author$project$Model$Discipline$disciplineDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'administratie-bedrijfsvoering':
				return $elm$json$Json$Decode$succeed(0);
			case 'bouw-architectuur':
				return $elm$json$Json$Decode$succeed(1);
			case 'bouwmanagement-architectuur-cartografie':
				return $elm$json$Json$Decode$succeed(2);
			case 'commercieel-administratief-medewerkers':
				return $elm$json$Json$Decode$succeed(3);
			case 'finance-accounting':
				return $elm$json$Json$Decode$succeed(4);
			case 'food-beverage':
				return $elm$json$Json$Decode$succeed(5);
			case 'gezondheidszorg':
				return $elm$json$Json$Decode$succeed(6);
			case 'juridisch':
				return $elm$json$Json$Decode$succeed(7);
			case 'klantenondersteuning-service':
				return $elm$json$Json$Decode$succeed(8);
			case 'landbouw-natuur-visserij':
				return $elm$json$Json$Decode$succeed(9);
			case 'marketing-communicatie-reclame':
				return $elm$json$Json$Decode$succeed(10);
			case 'media-design-cultuur':
				return $elm$json$Json$Decode$succeed(11);
			case 'nutsvoorzieningen-afvalverwerking':
				return $elm$json$Json$Decode$succeed(12);
			case 'onderwijs-instructie':
				return $elm$json$Json$Decode$succeed(13);
			case 'onderzoek-wetenschap':
				return $elm$json$Json$Decode$succeed(14);
			case 'productie-montage-reparatie':
				return $elm$json$Json$Decode$succeed(15);
			case 'retail':
				return $elm$json$Json$Decode$succeed(16);
			case 'schoonmaak-groenvoorziening':
				return $elm$json$Json$Decode$succeed(17);
			case 'software-informatietechnologie':
				return $elm$json$Json$Decode$succeed(18);
			case 'supply-chain-logistiek':
				return $elm$json$Json$Decode$succeed(19);
			case 'toerisme-recreatie-eventmanagement':
				return $elm$json$Json$Decode$succeed(20);
			case 'transport':
				return $elm$json$Json$Decode$succeed(21);
			case 'uiterlijke-verzorging-persoonlijke-dienstverlening':
				return $elm$json$Json$Decode$succeed(22);
			case 'veiligheid-bewaking':
				return $elm$json$Json$Decode$succeed(23);
			case 'zorg-welzijn':
				return $elm$json$Json$Decode$succeed(24);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$EducationLevel$Hbo = 3;
var $author$project$Model$EducationLevel$HboWo = 4;
var $author$project$Model$EducationLevel$Mbo = 2;
var $author$project$Model$EducationLevel$NVT = 0;
var $author$project$Model$EducationLevel$Vmbo = 1;
var $author$project$Model$EducationLevel$Wo = 5;
var $author$project$Model$EducationLevel$educationLevelDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'nvt':
				return $elm$json$Json$Decode$succeed(0);
			case 'vmbo':
				return $elm$json$Json$Decode$succeed(1);
			case 'mbo':
				return $elm$json$Json$Decode$succeed(2);
			case 'hbo':
				return $elm$json$Json$Decode$succeed(3);
			case 'hbo-wo':
				return $elm$json$Json$Decode$succeed(4);
			case 'wo':
				return $elm$json$Json$Decode$succeed(5);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$JourneyLevel$LevelOne = 0;
var $author$project$Model$JourneyLevel$LevelThree = 2;
var $author$project$Model$JourneyLevel$LevelTwo = 1;
var $author$project$Model$JourneyLevel$journeyLevelDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'level-one':
				return $elm$json$Json$Decode$succeed(0);
			case 'level-two':
				return $elm$json$Json$Decode$succeed(1);
			case 'level-three':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$PageType$CmsPage = {$: 0};
var $author$project$Model$PageType$CookiePage = {$: 1};
var $author$project$Model$PageType$Error404 = {$: 2};
var $author$project$Model$PageType$JobAlert = {$: 3};
var $author$project$Model$PageType$JobAlertSuccess = {$: 4};
var $author$project$Model$PageType$JobAlertUnsubscribe = {$: 5};
var $author$project$Model$PageType$JobAlertVerify = {$: 6};
var $author$project$Model$PageType$ReferralPage = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$PageType$ReferralPageTemplate = {$: 9};
var $author$project$Model$PageType$Vacancy404 = function (a) {
	return {$: 10, a: a};
};
var $author$project$Model$PageType$Vacancy404Template = {$: 11};
var $author$project$Model$PageType$VacancyApply = function (a) {
	return {$: 12, a: a};
};
var $author$project$Model$PageType$VacancyApplyTemplate = {$: 13};
var $author$project$Model$PageType$VacancyDetail = function (a) {
	return {$: 14, a: a};
};
var $author$project$Model$PageType$VacancyDetailTemplate = {$: 15};
var $author$project$Model$PageType$VacancyFavorites = {$: 16};
var $author$project$Model$PageType$VacancyOverview = {$: 17};
var $author$project$Model$PageType$VacancyThanks = function (a) {
	return {$: 18, a: a};
};
var $author$project$Model$PageType$VacancyThanksTemplate = {$: 19};
var $author$project$Model$PageType$pageTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'cms-page':
				return $elm$json$Json$Decode$succeed($author$project$Model$PageType$CmsPage);
			case 'cookie-page':
				return $elm$json$Json$Decode$succeed($author$project$Model$PageType$CookiePage);
			case 'error404':
				return $elm$json$Json$Decode$succeed($author$project$Model$PageType$Error404);
			case 'job-alert':
				return $elm$json$Json$Decode$succeed($author$project$Model$PageType$JobAlert);
			case 'job-alert-success':
				return $elm$json$Json$Decode$succeed($author$project$Model$PageType$JobAlertSuccess);
			case 'job-alert-unsubscribe':
				return $elm$json$Json$Decode$succeed($author$project$Model$PageType$JobAlertUnsubscribe);
			case 'job-alert-verify':
				return $elm$json$Json$Decode$succeed($author$project$Model$PageType$JobAlertVerify);
			case 'privacy-page':
				return $elm$json$Json$Decode$succeed($author$project$Model$PageType$PrivacyPage);
			case 'referral-page':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$PageType$ReferralPage));
			case 'referral-page-template':
				return $elm$json$Json$Decode$succeed($author$project$Model$PageType$ReferralPageTemplate);
			case 'vacancy404':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$PageType$Vacancy404));
			case 'vacancy404-template':
				return $elm$json$Json$Decode$succeed($author$project$Model$PageType$Vacancy404Template);
			case 'vacancy-apply':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$PageType$VacancyApply));
			case 'vacancy-apply-template':
				return $elm$json$Json$Decode$succeed($author$project$Model$PageType$VacancyApplyTemplate);
			case 'vacancy-detail':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$PageType$VacancyDetail));
			case 'vacancy-detail-template':
				return $elm$json$Json$Decode$succeed($author$project$Model$PageType$VacancyDetailTemplate);
			case 'vacancy-favorites':
				return $elm$json$Json$Decode$succeed($author$project$Model$PageType$VacancyFavorites);
			case 'vacancy-overview':
				return $elm$json$Json$Decode$succeed($author$project$Model$PageType$VacancyOverview);
			case 'vacancy-thanks':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$PageType$VacancyThanks));
			case 'vacancy-thanks-template':
				return $elm$json$Json$Decode$succeed($author$project$Model$PageType$VacancyThanksTemplate);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$SeniorityLevel$Management = 3;
var $author$project$Model$SeniorityLevel$Professional = 2;
var $author$project$Model$SeniorityLevel$Starter = 1;
var $author$project$Model$SeniorityLevel$Student = 0;
var $author$project$Model$SeniorityLevel$seniorityLevelDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'student':
				return $elm$json$Json$Decode$succeed(0);
			case 'starter':
				return $elm$json$Json$Decode$succeed(1);
			case 'professional':
				return $elm$json$Json$Decode$succeed(2);
			case 'management':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Page$pageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'pageSeniorityLevel',
	$elm$json$Json$Decode$nullable($author$project$Model$SeniorityLevel$seniorityLevelDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'pageWhatsappConfig',
		$elm$json$Json$Decode$nullable($author$project$Model$WhatsappConfig$decodeWhatsappConfig),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'pageVacancyId',
			$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'pageUpdated',
				$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'pageTemplatePageId',
					$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'pageShowHeader',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'pageShowFooter',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'pageShowCookieModal',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'pageShowChat',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'pageShareImages',
										$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'pageRecruitmentChat',
											$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'pageProtected',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'pagePath',
													$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'pageParentId',
														$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'pagePageType',
															$author$project$Model$PageType$pageTypeDecoder,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'pageMetaDescription',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'pageLangCode',
																	$author$project$Model$LangCode$decoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'pageLabel',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'pageIsDeleted',
																			$elm$json$Json$Decode$bool,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'pageInSitemap',
																				$elm$json$Json$Decode$bool,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'pageInserted',
																					$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'pageHeaderPosition',
																						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'pageFooterPosition',
																							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'pageJourneyLevel',
																								$elm$json$Json$Decode$nullable($author$project$Model$JourneyLevel$journeyLevelDecoder),
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'pageEducationLevel',
																									$elm$json$Json$Decode$nullable($author$project$Model$EducationLevel$educationLevelDecoder),
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'pageDomainId',
																										$author$project$Data$Id$decoder,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'pageDiscipline',
																											$elm$json$Json$Decode$nullable($author$project$Model$Discipline$disciplineDecoder),
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'pageChildSeqNo',
																												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'pageBackgroundGradient',
																													$elm$json$Json$Decode$nullable($author$project$Model$BackgroundGradient$backgroundGradientDecoder),
																													$elm$json$Json$Decode$succeed($author$project$Model$Page$Page))))))))))))))))))))))))))))));
var $author$project$Api$Endpoint$endpointWithQueryParameters = F2(
	function (segments, queryParameters) {
		return A2(
			$elm$url$Url$Builder$absolute,
			A2($elm$core$List$cons, 'api', segments),
			queryParameters);
	});
var $author$project$Data$PageType$toQueryParam = function (pageType) {
	return A2(
		$elm$url$Url$Builder$string,
		'page-type',
		function () {
			switch (pageType.$) {
				case 0:
					return 'cms-page';
				case 1:
					return 'cookie-page';
				case 2:
					return 'error404';
				case 3:
					return 'job-alert';
				case 4:
					return 'job-alert-success';
				case 5:
					return 'job-alert-unsubscribe';
				case 6:
					return 'job-alert-verify';
				case 7:
					return 'privacy-page';
				case 8:
					return 'referral-page';
				case 9:
					return 'referral-page-template';
				case 12:
					return 'vacancy-apply';
				case 13:
					return 'vacancy-apply-template';
				case 14:
					return 'vacancy-detail';
				case 15:
					return 'vacancy-detail-template';
				case 19:
					return 'vacancy-thanks-template';
				case 11:
					return 'vacancy-404-template';
				case 16:
					return 'vacancy-favorites';
				case 17:
					return 'vacancy-overview';
				case 18:
					return 'vacancy-thanks';
				default:
					return 'vacancy-404';
			}
		}());
};
var $author$project$Api$Endpoint$pages = F2(
	function (domainId, pageTypes) {
		return A2(
			$author$project$Api$Endpoint$endpointWithQueryParameters,
			_List_fromArray(
				[
					$author$project$Data$Id$toString(domainId),
					'pages'
				]),
			A2($elm$core$List$map, $author$project$Data$PageType$toQueryParam, pageTypes));
	});
var $author$project$Data$Page$getCollection = F2(
	function (domainId, pageTypes) {
		return A2(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$pages, domainId, pageTypes),
			$elm$json$Json$Decode$list(
				$author$project$Data$Entity$decoder($author$project$Model$Page$pageDecoder)));
	});
var $author$project$Model$Translation$Translation = function (name) {
	return function (tags) {
		return function (da) {
			return function (de) {
				return function (deAt) {
					return function (deCh) {
						return function (deLu) {
							return function (en) {
								return function (enGb) {
									return function (enUs) {
										return function (es) {
											return function (fi) {
												return function (fr) {
													return function (frBe) {
														return function (frCh) {
															return function (frLu) {
																return function (nl) {
																	return function (nlBe) {
																		return function (no) {
																			return function (pl) {
																				return function (pt) {
																					return function (ro) {
																						return function (sk) {
																							return function (sv) {
																								return function (uk) {
																									return function (inserted) {
																										return function (updated) {
																											return {Uv: da, Uw: de, Ux: deAt, Uy: deCh, Uz: deLu, UO: en, UP: enGb, UQ: enUs, US: es, UX: fi, U0: fr, U1: frBe, U2: frCh, U3: frLu, u_: inserted, c4: name, Vz: nl, VA: nlBe, A6: no, VZ: pl, V2: pt, Wb: ro, Wj: sk, Ww: sv, OM: tags, WN: uk, QH: updated};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$Translation$translationNameDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Model$Translation$TranslationTags = $elm$core$Basics$identity;
var $author$project$Model$Translation$ReferralTool = 1;
var $author$project$Model$Translation$ShareTool = 2;
var $author$project$Model$Translation$translationTagDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'form':
				return $elm$json$Json$Decode$succeed(0);
			case 'referral-tool':
				return $elm$json$Json$Decode$succeed(1);
			case 'share-tool':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Translation$translationTagsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	$elm$json$Json$Decode$list($author$project$Model$Translation$translationTagDecoder));
var $author$project$Model$Translation$translationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'translationUpdated',
	$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'translationInserted',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'translationUk',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'translationSv',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'translationSk',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'translationRo',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'translationPt',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'translationPl',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'translationNo',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'translationNlBe',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'translationNl',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'translationFrLu',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'translationFrCh',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'translationFrBe',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'translationFr',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'translationFi',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'translationEs',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'translationEnUs',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'translationEnGb',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'translationEn',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'translationDeLu',
																					$elm$json$Json$Decode$string,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'translationDeCh',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'translationDeAt',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'translationDe',
																								$elm$json$Json$Decode$string,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'translationDa',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'translationTags',
																										$author$project$Model$Translation$translationTagsDecoder,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'translationName',
																											$author$project$Model$Translation$translationNameDecoder,
																											$elm$json$Json$Decode$succeed($author$project$Model$Translation$Translation))))))))))))))))))))))))))));
var $author$project$Data$TranslationTag$translationTagToString = function (tag) {
	switch (tag) {
		case 0:
			return 'form';
		case 1:
			return 'referral-tool';
		default:
			return 'share-tool';
	}
};
var $author$project$Api$Endpoint$translations = function (translationTags) {
	var tagsQueryParameter = A2(
		$elm$url$Url$Builder$string,
		'tags',
		A2(
			$elm$core$String$join,
			',',
			A2($elm$core$List$map, $author$project$Data$TranslationTag$translationTagToString, translationTags)));
	return A2(
		$author$project$Api$Endpoint$endpointWithQueryParameters,
		_List_fromArray(
			['translations']),
		_List_fromArray(
			[tagsQueryParameter]));
};
var $author$project$Data$Translation$getCollection = function (translationTags) {
	return A2(
		$author$project$Api$get,
		$author$project$Api$Endpoint$translations(translationTags),
		$elm$json$Json$Decode$list(
			$author$project$Data$Entity$decoder($author$project$Model$Translation$translationDecoder)));
};
var $author$project$Model$VacancyTemplate$VacancyTemplate = function (domainId) {
	return function (label) {
		return function (templateType) {
			return function (inserted) {
				return function (updated) {
					return function (priority) {
						return function (detailPageId) {
							return function (filterOptionIds) {
								return function (formIdV2) {
									return function (recruitmentChatId) {
										return function (showChat) {
											return function (discipline) {
												return function (educationLevel) {
													return function (journeyLevel) {
														return function (seniorityLevel) {
															return function (whatsappConfig) {
																return {oy: detailPageId, oH: discipline, cF: domainId, pl: educationLevel, rO: filterOptionIds, sf: formIdV2, u_: inserted, wv: journeyLevel, bj: label, FJ: priority, GC: recruitmentChatId, aS: seniorityLevel, du: showChat, OZ: templateType, QH: updated, dO: whatsappConfig};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$TemplateType$Custom = 1;
var $author$project$Model$TemplateType$Default = 0;
var $author$project$Model$TemplateType$templateTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'default':
				return $elm$json$Json$Decode$succeed(0);
			case 'custom':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$VacancyTemplate$vacancyTemplateDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'vacancyTemplateWhatsappConfig',
	$elm$json$Json$Decode$nullable($author$project$Model$WhatsappConfig$decodeWhatsappConfig),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vacancyTemplateSeniorityLevel',
		$elm$json$Json$Decode$nullable($author$project$Model$SeniorityLevel$seniorityLevelDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'vacancyTemplateJourneyLevel',
			$elm$json$Json$Decode$nullable($author$project$Model$JourneyLevel$journeyLevelDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'vacancyTemplateEducationLevel',
				$elm$json$Json$Decode$nullable($author$project$Model$EducationLevel$educationLevelDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'vacancyTemplateDiscipline',
					$elm$json$Json$Decode$nullable($author$project$Model$Discipline$disciplineDecoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'vacancyTemplateShowChat',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'vacancyTemplateRecruitmentChatId',
							$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'vacancyTemplateFormIdV2',
								$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'vacancyTemplateFilterOptionIds',
									$elm$json$Json$Decode$list($author$project$Data$Id$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'vacancyTemplateDetailPageId',
										$author$project$Data$Id$decoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'vacancyTemplatePriority',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'vacancyTemplateUpdated',
												$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'vacancyTemplateInserted',
													$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'vacancyTemplateTemplateType',
														$author$project$Model$TemplateType$templateTypeDecoder,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'vacancyTemplateLabel',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'vacancyTemplateDomainId',
																$author$project$Data$Id$decoder,
																$elm$json$Json$Decode$succeed($author$project$Model$VacancyTemplate$VacancyTemplate)))))))))))))))));
var $author$project$Api$Endpoint$vacancyVacancyTemplate = F2(
	function (domainId, vacancyId) {
		return $author$project$Api$Endpoint$endpoint(
			_List_fromArray(
				[
					$author$project$Data$Id$toString(domainId),
					'vacancies',
					$author$project$Data$Id$toString(vacancyId),
					'template'
				]));
	});
var $author$project$Data$Vacancy$getVacancyVacancyTemplate = F2(
	function (domainId, vacancyId) {
		return A2(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$vacancyVacancyTemplate, domainId, vacancyId),
			$author$project$Data$Entity$decoder($author$project$Model$VacancyTemplate$vacancyTemplateDecoder));
	});
var $elm$core$Task$map3 = F4(
	function (func, taskA, taskB, taskC) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return A2(
							$elm$core$Task$andThen,
							function (c) {
								return $elm$core$Task$succeed(
									A3(func, a, b, c));
							},
							taskC);
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$mapError = F2(
	function (convert, task) {
		return A2(
			$elm$core$Task$onError,
			A2($elm$core$Basics$composeL, $elm$core$Task$fail, convert),
			task);
	});
var $NoRedInk$http_upgrade_shim$Http$Legacy$handleTaskResponse = F2(
	function (req, response) {
		var _v0 = $NoRedInk$http_upgrade_shim$Http$Legacy$fromHttpResponse(response);
		if (_v0.$ === 1) {
			var err = _v0.a;
			return $elm$core$Task$fail(err);
		} else {
			var response_ = _v0.a;
			var _v1 = req.cH.ba(response_);
			if (!_v1.$) {
				var payload = _v1.a;
				return $elm$core$Task$succeed(payload);
			} else {
				var err = _v1.a;
				return $elm$core$Task$fail(err);
			}
		}
	});
var $elm$http$Http$resultToTask = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$riskyTask = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{T9: true, a2: r.a2, cH: r.V9, cL: r.cL, c0: r.c0, dF: r.dF, WM: $elm$core$Maybe$Nothing, dK: r.dK});
};
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{T9: false, a2: r.a2, cH: r.V9, cL: r.cL, c0: r.c0, dF: r.dF, WM: $elm$core$Maybe$Nothing, dK: r.dK});
};
var $NoRedInk$http_upgrade_shim$Http$Legacy$toTask = function (req) {
	var taskReq = {
		a2: req.a2,
		cL: req.cL,
		c0: req.c0,
		V9: $elm$http$Http$stringResolver($elm$core$Result$Ok),
		dF: req.dF,
		dK: req.dK
	};
	var task = req.e9 ? $elm$http$Http$riskyTask(taskReq) : $elm$http$Http$task(taskReq);
	return A2(
		$elm$core$Task$andThen,
		$NoRedInk$http_upgrade_shim$Http$Legacy$handleTaskResponse(req),
		task);
};
var $author$project$View$ChatBot$requestFormData = F2(
	function (domainId, _v0) {
		var model = _v0.a;
		var cmds = _v0.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (cmd) {
				return $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[cmd, cmds]));
			},
			function () {
				var _v1 = model.D;
				if (_v1.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var formData = _v1.a;
					var _v2 = formData.bP;
					if (!_v2.$) {
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$attempt,
								$author$project$View$ChatBot$GotForm,
								A2(
									$elm$core$Task$andThen,
									function (_v3) {
										var template = _v3.b;
										var _v4 = template.sf;
										if (_v4.$ === 1) {
											return $elm$core$Task$fail($author$project$View$ChatBot$MissingVacancyTemplate);
										} else {
											var formId = _v4.a;
											return A2(
												$elm$core$Task$mapError,
												A2($elm$core$Basics$composeL, $author$project$View$ChatBot$HttpError, $author$project$Api$httpLegacyToHttpError),
												A4(
													$elm$core$Task$map3,
													$author$project$View$ChatBot$FormData,
													$NoRedInk$http_upgrade_shim$Http$Legacy$toTask(
														$author$project$Data$Form$get(formId)),
													$NoRedInk$http_upgrade_shim$Http$Legacy$toTask(
														$author$project$Data$Translation$getCollection(
															_List_fromArray(
																[0]))),
													A2(
														$elm$core$Task$map,
														$elm$core$List$head,
														$NoRedInk$http_upgrade_shim$Http$Legacy$toTask(
															A2(
																$author$project$Data$Page$getCollection,
																domainId,
																_List_fromArray(
																	[$author$project$Model$PageType$PrivacyPage]))))));
										}
									},
									A2(
										$elm$core$Task$mapError,
										A2($elm$core$Basics$composeL, $author$project$View$ChatBot$HttpError, $author$project$Api$httpLegacyToHttpError),
										$NoRedInk$http_upgrade_shim$Http$Legacy$toTask(
											A2($author$project$Data$Vacancy$getVacancyVacancyTemplate, domainId, formData.R6))))));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			}());
	});
var $author$project$View$ChatBot$GotVacancySearch = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Model$VacancySearch$ResultWithMetadata = F6(
	function (vacancies, total, overviewUrl, distanceInfo, filterFacets, filters) {
		return {oO: distanceInfo, rH: filterFacets, rW: filters, D$: overviewUrl, PG: total, RE: vacancies};
	});
var $author$project$Model$VacancySearch$DistanceInfo = F2(
	function (vacancyId, distanceInKm) {
		return {oN: distanceInKm, R6: vacancyId};
	});
var $author$project$Model$VacancySearch$distanceInfoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'distanceInKm',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vacancyId',
		$author$project$Data$Id$decoder,
		$elm$json$Json$Decode$succeed($author$project$Model$VacancySearch$DistanceInfo)));
var $author$project$Model$VacancySearch$Filter = F3(
	function (filterId, filterLabel, filterEnabled) {
		return {rG: filterEnabled, rI: filterId, rK: filterLabel};
	});
var $author$project$Model$VacancySearch$filterDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'filterEnabled',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'filterLabel',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'filterId',
			$author$project$Data$Id$decoder,
			$elm$json$Json$Decode$succeed($author$project$Model$VacancySearch$Filter))));
var $author$project$Model$VacancySearch$FilterFacet = F5(
	function (filterId, filterOptionId, filterOptionLabel, preFilterVacancyCount, postFilterVacancyCount) {
		return {rI: filterId, rN: filterOptionId, rP: filterOptionLabel, Fq: postFilterVacancyCount, FC: preFilterVacancyCount};
	});
var $author$project$Model$VacancySearch$filterFacetDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'postFilterVacancyCount',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'preFilterVacancyCount',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'filterOptionLabel',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'filterOptionId',
				$author$project$Data$Id$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'filterId',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$VacancySearch$FilterFacet))))));
var $author$project$Model$VacancySearch$VacancyWithLocation = F2(
	function (vacancy, location) {
		return {eq: location, RH: vacancy};
	});
var $author$project$Model$Location$Location = function (externalId) {
	return function (longitude) {
		return function (latitude) {
			return function (langCode) {
				return function (name) {
					return function (country) {
						return function (city) {
							return function (address) {
								return function (postalCode) {
									return function (province) {
										return function (phone) {
											return function (emailAddress) {
												return function (contactPerson) {
													return function (image) {
														return function (inserted) {
															return function (updated) {
																return function (seqNo) {
																	return function (masterDataOrigin) {
																		return {T6: address, le: city, mc: contactPerson, mH: country, bd: emailAddress, qO: externalId, ux: image, u_: inserted, wS: langCode, w8: latitude, yg: longitude, yF: masterDataOrigin, c4: name, aM: phone, Fr: postalCode, F6: province, Lb: seqNo, QH: updated};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$Location$locationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'locationMasterDataOrigin',
	$author$project$Model$MasterDataOrigin$masterDataOriginDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'locationSeqNo',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'locationUpdated',
			$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'locationInserted',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'locationImage',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'locationContactPerson',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'locationEmailAddress',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'locationPhone',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'locationProvince',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'locationPostalCode',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'locationAddress',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'locationCity',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'locationCountry',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'locationName',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'locationLangCode',
															$author$project$Model$LangCode$decoder,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'locationLatitude',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'locationLongitude',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'locationExternalId',
																		$elm$json$Json$Decode$string,
																		$elm$json$Json$Decode$succeed($author$project$Model$Location$Location)))))))))))))))))));
var $author$project$Model$Vacancy$Vacancy = function (externalId) {
	return function (domainId) {
		return function (recruiterId) {
			return function (hiringManagerId) {
				return function (isSpotlight) {
					return function (inserted) {
						return function (updated) {
							return function (deleted) {
								return function (publicationDate) {
									return function (endDate) {
										return function (title) {
											return function (subtitle) {
												return function (summary) {
													return function (description) {
														return function (extraDescription1) {
															return function (extraDescription2) {
																return function (extraDescription3) {
																	return function (extraDescription4) {
																		return function (extraDescription5) {
																			return function (extraDescription6) {
																				return function (extraDescription7) {
																					return function (minHours) {
																						return function (maxHours) {
																							return function (minSalary) {
																								return function (maxSalary) {
																									return function (locationId) {
																										return function (applicationFormType) {
																											return function (ats) {
																												return function (hidden) {
																													return function (monsterBoardExport) {
																														return function (extraMetadataV2) {
																															return function (reference) {
																																return function (indeedTitle) {
																																	return function (linkedInTitle) {
																																		return {hb: applicationFormType, ie: ats, oi: deleted, cD: description, cF: domainId, qc: endDate, qO: externalId, qU: extraDescription1, qV: extraDescription2, qW: extraDescription3, qX: extraDescription4, qY: extraDescription5, qZ: extraDescription6, q_: extraDescription7, q1: extraMetadataV2, tG: hidden, tS: hiringManagerId, uM: indeedTitle, u_: inserted, vR: isSpotlight, xJ: linkedInTitle, xX: locationId, er: maxHours, yP: maxSalary, eu: minHours, ev: minSalary, zG: monsterBoardExport, F9: publicationDate, Gv: recruiterId, GW: reference, Oc: subtitle, Oq: summary, WC: title, QH: updated};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Vacancy$ApplicationFormType$BynerScript = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Vacancy$ApplicationFormType$EmplyApplicationForm = {$: 1};
var $author$project$Vacancy$ApplicationFormType$ExternalUrl = function (a) {
	return {$: 10, a: a};
};
var $author$project$Vacancy$ApplicationFormType$GreenhouseApplicationForm = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Vacancy$ApplicationFormType$GreenhouseIframe = function (a) {
	return {$: 5, a: a};
};
var $author$project$Vacancy$ApplicationFormType$HireserveApplicationForm = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Vacancy$ApplicationFormType$RecruiteeIframe = function (a) {
	return {$: 6, a: a};
};
var $author$project$Vacancy$ApplicationFormType$RecruiteeMatchLab = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Vacancy$ApplicationFormType$SalesforceApplicationForm = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Vacancy$ApplicationFormType$SalesforceWithQuestionnaire = F4(
	function (a, b, c, d) {
		return {$: 9, a: a, b: b, c: c, d: d};
	});
var $author$project$Vacancy$ApplicationFormType$TafkarJobApplicationForm = {$: 0};
var $author$project$Vacancy$ApplicationFormType$applicationFormTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'tafkar-job-application-form':
				return $elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$TafkarJobApplicationForm);
			case 'emply-application-form':
				return $elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$EmplyApplicationForm);
			case 'byner-script':
				return A2(
					$elm$json$Json$Decode$field,
					'contents',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2($elm$json$Json$Decode$index, 2, $elm$json$Json$Decode$string),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string),
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
								$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$BynerScript)))));
			case 'hireserve-application-form':
				return A2(
					$elm$json$Json$Decode$field,
					'contents',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$bool),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$int),
							$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$HireserveApplicationForm))));
			case 'greenhouse-application-form':
				return A2(
					$elm$json$Json$Decode$field,
					'contents',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$GreenhouseApplicationForm))));
			case 'greenhouse-iframe':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$GreenhouseIframe));
			case 'recruitee-iframe':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$RecruiteeIframe));
			case 'recruitee-match-lab':
				return A2(
					$elm$json$Json$Decode$field,
					'contents',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$RecruiteeMatchLab))));
			case 'salesforce-application-form':
				return A2(
					$elm$json$Json$Decode$field,
					'contents',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2($elm$json$Json$Decode$index, 2, $elm$json$Json$Decode$string),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string),
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
								$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$SalesforceApplicationForm)))));
			case 'salesforce-with-questionnaire':
				return A2(
					$elm$json$Json$Decode$field,
					'contents',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2($elm$json$Json$Decode$index, 3, $elm$json$Json$Decode$string),
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($elm$json$Json$Decode$index, 2, $elm$json$Json$Decode$string),
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string),
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
									A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
									$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$SalesforceWithQuestionnaire))))));
			case 'external-url':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Vacancy$ApplicationFormType$ExternalUrl));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$Metadata$AfasMeta = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Metadata$CarerixMeta = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$Metadata$EmplyMeta = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Metadata$HireserveMeta = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Metadata$OtysMeta = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$Metadata$VermaatMeta = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Metadata$WorkdayMeta = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Vacancy$Metadata$Afas = function (whatsapp) {
	return {Tt: whatsapp};
};
var $author$project$Model$Vacancy$Metadata$afasDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'whatsapp',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Model$Vacancy$Metadata$Afas));
var $author$project$Model$Vacancy$Metadata$HireserveMetadata = function (whatsappURL) {
	return {Tz: whatsappURL};
};
var $author$project$Model$Vacancy$Metadata$decodeHireserveMetadata = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'whatsappURL',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Model$Vacancy$Metadata$HireserveMetadata));
var $author$project$Model$Vacancy$Metadata$Otys = F3(
	function (recruiterId, recruiterName, recruiterEmail) {
		return {Gu: recruiterEmail, Gv: recruiterId, Gw: recruiterName};
	});
var $author$project$Model$Vacancy$Metadata$decodeMetadata = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'recruiterEmail',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'recruiterName',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'recruiterId',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Model$Vacancy$Metadata$Otys))));
var $author$project$Model$Vacancy$Metadata$Emply = function (formId) {
	return {U$: formId};
};
var $author$project$Model$Vacancy$Metadata$Emply$decodeMetadata = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'formId',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Model$Vacancy$Metadata$Emply));
var $author$project$Model$Vacancy$Metadata$Carerix$Metadata = function (vacancyId) {
	return {R6: vacancyId};
};
var $author$project$Model$Vacancy$Metadata$Carerix$metadataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'vacancyId',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Model$Vacancy$Metadata$Carerix$Metadata));
var $author$project$Model$Vacancy$Metadata$VermaatMetadata = function (whatsapp) {
	return {Tt: whatsapp};
};
var $author$project$Model$Vacancy$Metadata$vermaatMetadataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'whatsapp',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Model$Vacancy$Metadata$VermaatMetadata));
var $author$project$Model$Vacancy$Metadata$Workday = function (isoCountryCode) {
	return {vV: isoCountryCode};
};
var $author$project$Model$Vacancy$Metadata$workdayDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'isoCountryCode',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Model$Vacancy$Metadata$Workday));
var $author$project$Model$Metadata$metadataDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'vermaat-meta':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Vacancy$Metadata$vermaatMetadataDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Metadata$VermaatMeta));
			case 'workday-meta':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Vacancy$Metadata$workdayDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Metadata$WorkdayMeta));
			case 'hireserve-meta':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Vacancy$Metadata$decodeHireserveMetadata,
					$elm$json$Json$Decode$succeed($author$project$Model$Metadata$HireserveMeta));
			case 'afas-meta':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Vacancy$Metadata$afasDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Metadata$AfasMeta));
			case 'emply-meta':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Vacancy$Metadata$Emply$decodeMetadata,
					$elm$json$Json$Decode$succeed($author$project$Model$Metadata$EmplyMeta));
			case 'carerix-meta':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Vacancy$Metadata$Carerix$metadataDecoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Metadata$CarerixMeta));
			case 'otys-meta':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Model$Vacancy$Metadata$decodeMetadata,
					$elm$json$Json$Decode$succeed($author$project$Model$Metadata$OtysMeta));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$Vacancy$vacancyDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'vacancyLinkedInTitle',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vacancyIndeedTitle',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'vacancyReference',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'vacancyExtraMetadataV2',
				$elm$json$Json$Decode$nullable($author$project$Model$Metadata$metadataDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'vacancyMonsterBoardExport',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'vacancyHidden',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'vacancyAts',
							$author$project$Model$Ats$atsDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'vacancyApplicationFormType',
								$author$project$Vacancy$ApplicationFormType$applicationFormTypeDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'vacancyLocationId',
									$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'vacancyMaxSalary',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'vacancyMinSalary',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'vacancyMaxHours',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'vacancyMinHours',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'vacancyExtraDescription7',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'vacancyExtraDescription6',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'vacancyExtraDescription5',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'vacancyExtraDescription4',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'vacancyExtraDescription3',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'vacancyExtraDescription2',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'vacancyExtraDescription1',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'vacancyDescription',
																					$elm$json$Json$Decode$string,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'vacancySummary',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'vacancySubtitle',
																							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'vacancyTitle',
																								$elm$json$Json$Decode$string,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'vacancyEndDate',
																									$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'vacancyPublicationDate',
																										$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'vacancyDeleted',
																											$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'vacancyUpdated',
																												$elm$json$Json$Decode$nullable($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'vacancyInserted',
																													$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'vacancyIsSpotlight',
																														$elm$json$Json$Decode$bool,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'vacancyHiringManagerId',
																															$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'vacancyRecruiterId',
																																$elm$json$Json$Decode$nullable($author$project$Data$Id$decoder),
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'vacancyDomainId',
																																	$author$project$Data$Id$decoder,
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'vacancyExternalId',
																																		$elm$json$Json$Decode$string,
																																		$elm$json$Json$Decode$succeed($author$project$Model$Vacancy$Vacancy)))))))))))))))))))))))))))))))))));
var $author$project$Model$VacancySearch$vacancyWithLocationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$elm$json$Json$Decode$nullable(
		$author$project$Data$Entity$decoder($author$project$Model$Location$locationDecoder)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vacancy',
		$author$project$Data$Entity$decoder($author$project$Model$Vacancy$vacancyDecoder),
		$elm$json$Json$Decode$succeed($author$project$Model$VacancySearch$VacancyWithLocation)));
var $author$project$Model$VacancySearch$resultWithMetadataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'filters',
	$elm$json$Json$Decode$list($author$project$Model$VacancySearch$filterDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'filterFacets',
		$elm$json$Json$Decode$list($author$project$Model$VacancySearch$filterFacetDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'distanceInfo',
			$elm$json$Json$Decode$list($author$project$Model$VacancySearch$distanceInfoDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'overviewUrl',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'total',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'vacancies',
						$elm$json$Json$Decode$list($author$project$Model$VacancySearch$vacancyWithLocationDecoder),
						$elm$json$Json$Decode$succeed($author$project$Model$VacancySearch$ResultWithMetadata)))))));
var $elm$url$Url$Builder$int = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$core$String$fromInt(value));
	});
var $author$project$Api$Endpoint$vacancySearch = F2(
	function (domainId, params) {
		return A2(
			$author$project$Api$Endpoint$endpointWithQueryParameters,
			_List_fromArray(
				[
					$author$project$Data$Id$toString(domainId),
					'vacancy-search'
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2($elm$url$Url$Builder$int, 's', params.ev),
							A2($elm$url$Url$Builder$int, 'hh', params.er),
							A2($elm$url$Url$Builder$int, 'hl', params.eu),
							A2($elm$url$Url$Builder$int, 'o', params.eE),
							A2($elm$url$Url$Builder$int, 'n', params.en)
						]),
						A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeL,
							$elm$url$Url$Builder$string('f'),
							$author$project$Data$Id$toString),
						params.dX),
						A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$List$singleton,
								$elm$url$Url$Builder$string('keywords')),
							params.el)),
						A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$List$singleton,
								$elm$url$Url$Builder$string('location')),
							params.eq))
					])));
	});
var $author$project$Data$VacancySearch$get = F2(
	function (domainId, params) {
		return A2(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$vacancySearch, domainId, params),
			$author$project$Model$VacancySearch$resultWithMetadataDecoder);
	});
var $author$project$View$ChatBot$requestVacancySearch = F3(
	function (nodeId, domainId, searchParams) {
		return A2(
			$author$project$Api$send,
			A2($author$project$View$ChatBot$GotVacancySearch, nodeId, searchParams),
			A2($author$project$Data$VacancySearch$get, domainId, searchParams));
	});
var $author$project$View$ChatBot$additionalNodeData = F3(
	function (domainId, node, model) {
		var _v0 = node.bq;
		_v0$3:
		while (true) {
			switch (_v0.$) {
				case 7:
					if (!_v0.a.$) {
						var chatBot = A2(
							$zwilias$elm_rosetree$Tree$map,
							function ($) {
								return $.bq;
							},
							$zwilias$elm_rosetree$Tree$Zipper$toTree(model.kT));
						var newModel = _Utils_update(
							model,
							{
								kT: $zwilias$elm_rosetree$Tree$Zipper$fromTree(
									A2($author$project$Data$ChatBot$fromChatBotWithEmbedded, model.a6, chatBot))
							});
						return _Utils_Tuple2(
							newModel,
							$author$project$View$ChatBot$queueNextNodeToShow(newModel));
					} else {
						break _v0$3;
					}
				case 4:
					if (!_v0.a.$) {
						var salaryCalculatorId = _v0.a.a;
						var _v1 = A2($author$project$Dict$Custom$get, salaryCalculatorId, model.aR);
						if (_v1.$ === 1) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										aR: A3($author$project$Dict$Custom$insert, salaryCalculatorId, $author$project$Data$Status$Loading, model.aR)
									}),
								A2(
									$author$project$Api$send,
									$author$project$View$ChatBot$GotSalaryCalculator(salaryCalculatorId),
									A2($author$project$Data$SalaryCalculator$get, domainId, salaryCalculatorId)));
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					} else {
						break _v0$3;
					}
				case 3:
					var settings = _v0.a;
					var searchParams = _Utils_update(
						$author$project$View$ChatBot$chatBotSearchParams,
						{dX: settings.WW});
					var _v2 = A2($author$project$Dict$Custom$get, node.cO, model.ad);
					if (!_v2.$) {
						switch (_v2.a.$) {
							case 0:
								var _v3 = _v2.a;
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							case 1:
								var _v4 = _v2.a;
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							default:
								var _v5 = _v2.a.a;
								var cachedSearchParams = _v5.a;
								return A2(
									$author$project$View$ChatBot$requestFormData,
									domainId,
									_Utils_eq(cachedSearchParams, searchParams) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
										_Utils_update(
											model,
											{
												ad: A3($author$project$Dict$Custom$insert, node.cO, $author$project$Data$Status$Loading, model.ad)
											}),
										A3($author$project$View$ChatBot$requestVacancySearch, node.cO, domainId, searchParams)));
						}
					} else {
						return A2(
							$author$project$View$ChatBot$requestFormData,
							domainId,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										ad: A3($author$project$Dict$Custom$insert, node.cO, $author$project$Data$Status$Loading, model.ad)
									}),
								A3($author$project$View$ChatBot$requestVacancySearch, node.cO, domainId, searchParams)));
					}
				default:
					break _v0$3;
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$View$ChatBot$requestAdditionalNodeData = F2(
	function (domainId, _v0) {
		var model = _v0.a;
		var cmds = _v0.b;
		var step = F2(
			function (node, _v1) {
				var accModel = _v1.a;
				var accCmds = _v1.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (additionalCmds) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[additionalCmds, accCmds]));
					},
					A3(
						$author$project$View$ChatBot$additionalNodeData,
						domainId,
						$zwilias$elm_rosetree$Tree$label(node),
						accModel));
			});
		return A3(
			$elm$core$List$foldl,
			step,
			_Utils_Tuple2(model, cmds),
			$author$project$Data$ChatBot$currentAndBefore(model.kT));
	});
var $author$project$ScrollToInElement$SetTarget = function (a) {
	return {$: 2, a: a};
};
var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var $author$project$ScrollToInElement$scrollToCustomTask = F2(
	function (_v0, f) {
		var nodeId = _v0.a;
		return A2(
			$elm$core$Task$attempt,
			$author$project$ScrollToInElement$SetTarget,
			A2(
				$elm$core$Task$andThen,
				f,
				$elm$browser$Browser$Dom$getViewportOf(nodeId)));
	});
var $author$project$ScrollToInElement$scrollToCustom = F2(
	function (state, f) {
		return A2(
			$author$project$ScrollToInElement$scrollToCustomTask,
			state,
			A2($elm$core$Basics$composeL, $elm$core$Task$succeed, f));
	});
var $author$project$ScrollToInElement$scrollToBottom = function (state) {
	var f = function (_v0) {
		var scene = _v0.We;
		var viewport = _v0.WX;
		return {
			sr: {TM: viewport.TM, m: viewport.m},
			Ps: {TM: viewport.TM, m: scene.tE - viewport.tE}
		};
	};
	return A2($author$project$ScrollToInElement$scrollToCustom, state, f);
};
var $author$project$View$ChatBot$focusOn = F3(
	function (domainId, nodeId, model) {
		var chatBot = A2(
			$zwilias$elm_rosetree$Tree$map,
			function ($) {
				return $.bq;
			},
			$zwilias$elm_rosetree$Tree$Zipper$toTree(model.kT));
		var nextModel = _Utils_update(
			model,
			{
				kT: A2(
					$elm$core$Maybe$withDefault,
					model.kT,
					A2(
						$zwilias$elm_rosetree$Tree$Zipper$findFromRoot,
						function (n) {
							return _Utils_eq(n.cO, nodeId);
						},
						$zwilias$elm_rosetree$Tree$Zipper$fromTree(
							A2($author$project$Data$ChatBot$fromChatBotWithEmbedded, model.a6, chatBot))))
			});
		return A2(
			$author$project$View$ChatBot$requestAdditionalNodeData,
			domainId,
			_Utils_Tuple2(
				nextModel,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2(
							$elm$core$Platform$Cmd$map,
							$author$project$View$ChatBot$ScrollToMsg,
							$author$project$ScrollToInElement$scrollToBottom(model.O)),
							$author$project$View$ChatBot$queueNextNodeToShow(nextModel)
						]))));
	});
var $author$project$View$ChatBot$init = F8(
	function (lift, domainId, maybeLocalStorageState, embeddableChatBots, chatBot, sessionToken, schemaFields, currentOnly) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map(lift),
			function () {
				if (maybeLocalStorageState.$ === 1) {
					var model = _Utils_update(
						$author$project$View$ChatBot$empty,
						{
							kT: $zwilias$elm_rosetree$Tree$Zipper$fromTree(
								A2($author$project$Data$ChatBot$fromChatBotWithEmbedded, embeddableChatBots, chatBot)),
							a6: embeddableChatBots,
							an: currentOnly,
							eL: schemaFields,
							av: sessionToken
						});
					return A2(
						$author$project$View$ChatBot$requestAdditionalNodeData,
						domainId,
						_Utils_Tuple2(
							model,
							$author$project$View$ChatBot$queueNextNodeToShow(model)));
				} else {
					var localStorageState = maybeLocalStorageState.a;
					var model = _Utils_update(
						$author$project$View$ChatBot$empty,
						{
							D: A3(
								$elm$core$Maybe$map2,
								F2(
									function (nodeId, vacancyId) {
										return {bP: $author$project$Data$Status$NotAsked, ar: nodeId, R6: vacancyId};
									}),
								localStorageState.LS,
								localStorageState.LT),
							kT: $zwilias$elm_rosetree$Tree$Zipper$fromTree(
								A2($author$project$Data$ChatBot$fromChatBotWithEmbedded, embeddableChatBots, chatBot)),
							a6: embeddableChatBots,
							aj: localStorageState.aj,
							eL: schemaFields,
							av: sessionToken
						});
					return A3($author$project$View$ChatBot$focusOn, domainId, localStorageState.ar, model);
				}
			}());
	});
var $author$project$RecruitmentChat$init = function (flags) {
	var sessionToken = $elm$core$Maybe$Just(flags.av);
	var recruitmentChats = A2(
		$author$project$Dict$Custom$fromListVia,
		$author$project$Data$Id$emptyDict,
		A2(
			$elm$core$List$map,
			function (_v1) {
				var id = _v1.a;
				var val = _v1.b;
				return _Utils_Tuple2(id, val.kT);
			},
			flags.b4));
	var recruitmentChat = $author$project$Data$Entity$value(flags.GA);
	var _v0 = A8($author$project$View$ChatBot$init, $author$project$RecruitmentChat$ChatBotMsg, recruitmentChat.cF, flags.xU, recruitmentChats, recruitmentChat.kT, sessionToken, flags.eL, flags.an);
	var chatBot = _v0.a;
	var chatBotCmd = _v0.b;
	return _Utils_Tuple2(
		{kT: chatBot, an: flags.an, cF: flags.cF, wS: flags.wS, GA: recruitmentChat, b4: recruitmentChats, eL: flags.eL, av: sessionToken, ak: flags.eP, dy: true, e2: flags.e2, ch: flags.ch},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$RecruitmentChat$delayShowChatBot, flags.du, flags.eP),
					chatBotCmd,
					$author$project$RecruitmentChat$autoHideIntroduction
				])));
};
var $author$project$View$ChatBot$LocationSuggestionsMsg = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$View$ChatBot$OnLocationSelect = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$View$ChatBot$locationSuggestionsConfig = F3(
	function (domainId, nodeId, sessionToken) {
		return {
			cr: '',
			cF: domainId,
			xp: $author$project$View$ChatBot$LocationSuggestionsMsg(nodeId),
			Wh: 1,
			av: sessionToken,
			Wv: $author$project$View$Autocomplete$Http$Button(
				{
					Wu: $author$project$View$ChatBot$OnLocationSelect(nodeId),
					WL: $elm$core$Maybe$Nothing
				}),
			e4: 'location-chatbot'
		};
	});
var $author$project$ScrollToInElement$Tick = function (a) {
	return {$: 1, a: a};
};
var $tad_lispy$springs$Spring$atRest = function (_v0) {
	var _this = _v0;
	return _Utils_eq(_this.dL, _this.OS) && (_this.aX === 0.0);
};
var $author$project$ScrollToInElement$isScrolling = function (_v0) {
	var springs = _v0.b;
	return !($tad_lispy$springs$Spring$atRest(springs.TM) && $tad_lispy$springs$Spring$atRest(springs.m));
};
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {eF: oldTime, Id: request, Ob: subs};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$browser$Browser$AnimationManager$now = _Browser_now(0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(0);
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var request = _v0.Id;
		var oldTime = _v0.eF;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 1) {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var subs = _v0.Ob;
		var oldTime = _v0.eF;
		var send = function (sub) {
			if (!sub.$) {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (!sub.$) {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrameDelta = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Delta(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrameDelta = $elm$browser$Browser$AnimationManager$onAnimationFrameDelta;
var $author$project$ScrollToInElement$subscriptions = F2(
	function (lift, state) {
		return $author$project$ScrollToInElement$isScrolling(state) ? A2(
			$elm$core$Platform$Sub$map,
			lift,
			$elm$browser$Browser$Events$onAnimationFrameDelta($author$project$ScrollToInElement$Tick)) : $elm$core$Platform$Sub$none;
	});
var $author$project$View$ChatBot$subscriptions = F3(
	function (lift, domainId, model) {
		return A2(
			$elm$core$Platform$Sub$map,
			lift,
			$elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2($author$project$ScrollToInElement$subscriptions, $author$project$View$ChatBot$ScrollToMsg, model.O),
						function () {
						var _v0 = model.ah;
						if (_v0.$ === 1) {
							return $elm$core$Platform$Sub$none;
						} else {
							var _v1 = _v0.a;
							var nodeId = _v1.a;
							var locationSuggestions = _v1.b;
							return A2(
								$author$project$View$LocationSuggestions$subscriptions,
								A3($author$project$View$ChatBot$locationSuggestionsConfig, domainId, nodeId, model.av),
								locationSuggestions);
						}
					}()
					])));
	});
var $author$project$RecruitmentChat$subscriptions = function (model) {
	return A3($author$project$View$ChatBot$subscriptions, $author$project$RecruitmentChat$ChatBotMsg, model.cF, model.kT);
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Data$Id$encode = function (_v0) {
	var id = _v0;
	return $elm$json$Json$Encode$int(id);
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Dict$Custom$encode = F3(
	function (_v0, g, h) {
		var f = _v0.b;
		var dict = _v0.c;
		return A2(
			$elm$json$Json$Encode$list,
			function (_v1) {
				var k = _v1.a;
				var v = _v1.b;
				return A2(
					$elm$json$Json$Encode$list,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							g(
							f(k)),
							h(v)
						]));
			},
			$elm$core$Dict$toList(dict));
	});
var $author$project$Data$ChatBot$encodeNodeId = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $author$project$Data$ChatBot$idToInt);
var $author$project$View$ChatBot$encodeLocalStorageState = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nodeId',
				$author$project$Data$ChatBot$encodeNodeId(
					$zwilias$elm_rosetree$Tree$Zipper$label(model.kT).cO)),
				_Utils_Tuple2(
				'showFormOfVacancyId',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Data$Id$encode,
							function ($) {
								return $.R6;
							}),
						model.D))),
				_Utils_Tuple2(
				'showFormOfNodeId',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Data$ChatBot$encodeNodeId,
							function ($) {
								return $.ar;
							}),
						model.D))),
				_Utils_Tuple2(
				'salaryCalculatorInput',
				A3(
					$author$project$Dict$Custom$encode,
					model.aj,
					$author$project$Data$ChatBot$encodeNodeId,
					function (x) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'age',
									$elm$json$Json$Encode$int(x.gd)),
									_Utils_Tuple2(
									'hours',
									$elm$json$Json$Encode$int(x.t1))
								]));
					}))
			]));
};
var $author$project$RecruitmentChat$showRecruitmentChat = _Platform_outgoingPort('showRecruitmentChat', $elm$json$Json$Encode$bool);
var $author$project$View$ChatBot$storeLocalStorageState = _Platform_outgoingPort('storeLocalStorageState', $elm$core$Basics$identity);
var $author$project$View$ChatBot$FormMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Model$Form$FormType$JobApplicationData = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$ChatBot$NoOp = {$: 0};
var $tad_lispy$springs$Spring$jumpTo = F2(
	function (newValue, _v0) {
		var _this = _v0;
		return _Utils_update(
			_this,
			{dL: newValue, aX: 0.0});
	});
var $tad_lispy$springs$Spring$target = function (_v0) {
	var _this = _v0;
	return _this.OS;
};
var $author$project$ScrollToInElement$cancel = function (_v0) {
	var nodeId = _v0.a;
	var springs = _v0.b;
	return A2(
		$author$project$ScrollToInElement$State,
		nodeId,
		{
			TM: A2(
				$tad_lispy$springs$Spring$jumpTo,
				$tad_lispy$springs$Spring$target(springs.TM),
				springs.TM),
			m: A2(
				$tad_lispy$springs$Spring$jumpTo,
				$tad_lispy$springs$Spring$target(springs.m),
				springs.m)
		});
};
var $author$project$View$FormV2$State = $elm$core$Basics$identity;
var $pzp1997$assoc_list$AssocList$D = $elm$core$Basics$identity;
var $pzp1997$assoc_list$AssocList$empty = _List_Nil;
var $author$project$View$FormV2$init = function (config) {
	return {UE: config.UE, UL: config.UL, d7: config.d7, w: $pzp1997$assoc_list$AssocList$empty, d9: config.d9, eL: config.eL, eM: config.eM, aw: $elm$core$Maybe$Nothing, aU: $author$project$Data$Status$NotAsked};
};
var $author$project$Data$Status$map = F2(
	function (f, status) {
		switch (status.$) {
			case 0:
				return $author$project$Data$Status$NotAsked;
			case 1:
				return $author$project$Data$Status$Loading;
			case 2:
				var err = status.a;
				return $author$project$Data$Status$Failure(err);
			default:
				var a = status.a;
				return $author$project$Data$Status$Success(
					f(a));
		}
	});
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$View$ChatBot$scrollToFormNode = function (_v0) {
	var viewport = _v0.WX;
	return A2(
		$elm$core$Task$andThen,
		function (_v1) {
			var chat = _v1.a;
			var form = _v1.b;
			return $elm$core$Task$succeed(
				{
					sr: {TM: viewport.TM, m: viewport.m},
					Ps: {TM: viewport.TM, m: viewport.m + (form.pp.m - chat.pp.m)}
				});
		},
		A3(
			$elm$core$Task$map2,
			$elm$core$Tuple$pair,
			$elm$browser$Browser$Dom$getElement('chat'),
			$elm$browser$Browser$Dom$getElement('form-node')));
};
var $author$project$View$ChatBot$storeLocalStorageState_ = function (_v0) {
	var model = _v0.a;
	var cmds = _v0.b;
	return _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					cmds,
					$author$project$View$ChatBot$storeLocalStorageState(
					$author$project$View$ChatBot$encodeLocalStorageState(model))
				])));
};
var $author$project$View$FormV2$submitStatus = function (_v0) {
	var state = _v0;
	return state.aU;
};
var $author$project$Data$Translation$translationFieldFromLangCode = function (langCode) {
	switch (langCode) {
		case 1:
			return function ($) {
				return $.Uw;
			};
		case 2:
			return function ($) {
				return $.Ux;
			};
		case 3:
			return function ($) {
				return $.Uy;
			};
		case 4:
			return function ($) {
				return $.Uz;
			};
		case 5:
			return function ($) {
				return $.UO;
			};
		case 6:
			return function ($) {
				return $.UP;
			};
		case 7:
			return function ($) {
				return $.UQ;
			};
		case 8:
			return function ($) {
				return $.US;
			};
		case 9:
			return function ($) {
				return $.UX;
			};
		case 10:
			return function ($) {
				return $.U0;
			};
		case 11:
			return function ($) {
				return $.U1;
			};
		case 12:
			return function ($) {
				return $.U2;
			};
		case 13:
			return function ($) {
				return $.U3;
			};
		case 14:
			return function ($) {
				return $.Vz;
			};
		case 15:
			return function ($) {
				return $.VA;
			};
		case 0:
			return function ($) {
				return $.Uv;
			};
		case 16:
			return function ($) {
				return $.A6;
			};
		case 17:
			return function ($) {
				return $.VZ;
			};
		case 18:
			return function ($) {
				return $.V2;
			};
		case 19:
			return function ($) {
				return $.Wb;
			};
		case 20:
			return function ($) {
				return $.Wj;
			};
		case 21:
			return function ($) {
				return $.Ww;
			};
		default:
			return function ($) {
				return $.WN;
			};
	}
};
var $author$project$Data$Translation$translationsFromEntities = F2(
	function (langCode, xs) {
		var toName = function (_v1) {
			var name = _v1;
			return name;
		};
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var t = _v0.b;
					return _Utils_Tuple2(
						toName(t.c4),
						A2($author$project$Data$Translation$translationFieldFromLangCode, langCode, t));
				},
				xs));
	});
var $author$project$ScrollToInElement$NoOp = {$: 0};
var $tad_lispy$springs$Spring$animate = F2(
	function (delta, spring) {
		var _this = spring;
		if ($tad_lispy$springs$Spring$atRest(spring)) {
			return spring;
		} else {
			if (($elm$core$Basics$abs(_this.dL - _this.OS) < 0.05) && ($elm$core$Basics$abs(_this.aX) < 0.05)) {
				return A2($tad_lispy$springs$Spring$jumpTo, _this.OS, spring);
			} else {
				var time = A2($elm$core$Basics$min, delta, 32) / 1000;
				var stretch = _this.OS - _this.dL;
				var force = stretch * _this.N1;
				var damping = _this.aX * _this.nw;
				var acceleration = time * (force - damping);
				var velocity = _this.aX + acceleration;
				var newValue = _this.dL + (velocity * time);
				return _Utils_update(
					_this,
					{dL: newValue, aX: velocity});
			}
		}
	});
var $tad_lispy$springs$Spring$setTarget = F2(
	function (newTarget, _v0) {
		var spring = _v0;
		return _Utils_update(
			spring,
			{OS: newTarget});
	});
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $tad_lispy$springs$Spring$value = function (_v0) {
	var _this = _v0;
	return _this.dL;
};
var $author$project$ScrollToInElement$update = F3(
	function (lift, msg, state) {
		var nodeId = state.a;
		var springs = state.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map(lift),
			function () {
				switch (msg.$) {
					case 0:
						return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
					case 1:
						var delta = msg.a;
						var next = {
							TM: A2($tad_lispy$springs$Spring$animate, delta, springs.TM),
							m: A2($tad_lispy$springs$Spring$animate, delta, springs.m)
						};
						var check = F3(
							function (current, next_, target) {
								return !$elm$core$Basics$round((current - target) + (next_ - target));
							});
						return (A3(
							check,
							$tad_lispy$springs$Spring$value(springs.TM),
							$tad_lispy$springs$Spring$value(next.TM),
							$tad_lispy$springs$Spring$target(next.TM)) && A3(
							check,
							$tad_lispy$springs$Spring$value(springs.m),
							$tad_lispy$springs$Spring$value(next.m),
							$tad_lispy$springs$Spring$target(next.m))) ? _Utils_Tuple2(
							A2(
								$author$project$ScrollToInElement$State,
								nodeId,
								{
									TM: A2(
										$tad_lispy$springs$Spring$jumpTo,
										$tad_lispy$springs$Spring$target(springs.TM),
										springs.TM),
									m: A2(
										$tad_lispy$springs$Spring$jumpTo,
										$tad_lispy$springs$Spring$target(springs.m),
										springs.m)
								}),
							$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							A2($author$project$ScrollToInElement$State, nodeId, next),
							A2(
								$elm$core$Task$attempt,
								function (_v1) {
									return $author$project$ScrollToInElement$NoOp;
								},
								A3(
									$elm$browser$Browser$Dom$setViewportOf,
									nodeId,
									$tad_lispy$springs$Spring$value(next.TM),
									$tad_lispy$springs$Spring$value(next.m))));
					default:
						if (!msg.a.$) {
							var from = msg.a.a.sr;
							var to = msg.a.a.Ps;
							var setCurrent = $author$project$ScrollToInElement$isScrolling(state) ? $tad_lispy$springs$Spring$setTarget : $tad_lispy$springs$Spring$jumpTo;
							return _Utils_Tuple2(
								A2(
									$author$project$ScrollToInElement$State,
									nodeId,
									{
										TM: A2(
											$tad_lispy$springs$Spring$setTarget,
											to.TM,
											A2(setCurrent, from.TM, springs.TM)),
										m: A2(
											$tad_lispy$springs$Spring$setTarget,
											to.m,
											A2(setCurrent, from.m, springs.m))
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
						}
				}
			}());
	});
var $author$project$View$FormV2$FileSelected = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$View$FormV2$GotAddressWithAutoFill = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$View$FormV2$GotFileAsUrl = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$View$FormV2$GotSubmitForm = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$View$FormV2$GotSubmitFormNoContent = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$FormFieldValueV2$FieldValues = $elm$core$Basics$identity;
var $author$project$Model$FormFieldV2$encodeFieldName = function (a) {
	switch (a.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('additional-file1'))
					]));
		case 1:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('additional-file2'))
					]));
		case 2:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('address'))
					]));
		case 3:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('address-with-auto-fill'))
					]));
		case 4:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('availability'))
					]));
		case 5:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('button'))
					]));
		case 6:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('city'))
					]));
		case 7:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('custom')),
						_Utils_Tuple2(
						'contents',
						$elm$json$Json$Encode$string(b))
					]));
		case 8:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('custom-canada-province'))
					]));
		case 9:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('custom-ethnic-identification'))
					]));
		case 10:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('custom-how-did-you-get-here-select'))
					]));
		case 11:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('custom-is-hispanic'))
					]));
		case 12:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('custom-select'))
					]));
		case 13:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('custom-state'))
					]));
		case 14:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('date-of-birth'))
					]));
		case 15:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('email-address'))
					]));
		case 16:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('first-name'))
					]));
		case 17:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('grades-bachelor1'))
					]));
		case 18:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('grades-bachelor2'))
					]));
		case 19:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('grades-master1'))
					]));
		case 20:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('grades-master2'))
					]));
		case 21:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('heading'))
					]));
		case 22:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('how-did-you-get-here'))
					]));
		case 23:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('image'))
					]));
		case 24:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('internal'))
					]));
		case 25:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('internship-evaluation1'))
					]));
		case 26:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('internship-evaluation2'))
					]));
		case 27:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('intro-text'))
					]));
		case 28:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('last-name'))
					]));
		case 29:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('link'))
					]));
		case 30:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('linked-in-url'))
					]));
		case 31:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('motivation'))
					]));
		case 32:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('motivation-text-area'))
					]));
		case 33:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('newsletter-subscription'))
					]));
		case 34:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('open-checkbox-four'))
					]));
		case 35:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('open-checkbox-one'))
					]));
		case 36:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('open-checkbox-three'))
					]));
		case 37:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('open-checkbox-two'))
					]));
		case 38:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('open-text'))
					]));
		case 39:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('ordered-list'))
					]));
		case 40:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('phone-number'))
					]));
		case 41:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('phone-number-with-calling-code'))
					]));
		case 42:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('plain-text'))
					]));
		case 43:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('portfolio'))
					]));
		case 44:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('postal-code'))
					]));
		case 45:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('privacy'))
					]));
		case 46:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('referred'))
					]));
		case 47:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('resume'))
					]));
		case 48:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('salary-indication'))
					]));
		case 49:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('screening-questions'))
					]));
		case 50:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('source'))
					]));
		case 51:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('spacer'))
					]));
		case 52:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('store-data'))
					]));
		case 53:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('thesis'))
					]));
		case 54:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('unordered-list'))
					]));
		case 55:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('url'))
					]));
		case 56:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('usp'))
					]));
		case 57:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('video'))
					]));
		default:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('xing-url'))
					]));
	}
};
var $author$project$Model$FormFieldValueV2$encodeAddressValue = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'street',
				$elm$json$Json$Encode$string(a.NV)),
				_Utils_Tuple2(
				'houseNumber',
				$elm$json$Json$Encode$string(a.t8)),
				_Utils_Tuple2(
				'postalCode',
				$elm$json$Json$Encode$string(a.Fr)),
				_Utils_Tuple2(
				'city',
				$elm$json$Json$Encode$string(a.le))
			]));
};
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {nJ: d, zI: m, TQ: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		eH: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		TQ: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.TQ, 0, date.eH);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.nJ;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.zI;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.eH;
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		Te: 1 + (((rd - week1Day1) / 7) | 0),
		Tf: wy,
		WY: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.Te;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.Tf;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.c2(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.ex(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.c2(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.d0(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.aZ(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.aZ(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.aZ(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.e7(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.aZ(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.aZ(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.G, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	d0: $justinmimbs$date$Date$withOrdinalSuffix,
	ex: $justinmimbs$date$Date$monthToName,
	c2: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	e7: $justinmimbs$date$Date$weekdayToName,
	aZ: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Util$Date$encodeDate = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $justinmimbs$date$Date$toIsoString);
var $author$project$Model$FormFieldTypeV2$encodeDayOfWeek = function (a) {
	switch (a) {
		case 0:
			return $elm$json$Json$Encode$string('monday');
		case 1:
			return $elm$json$Json$Encode$string('tuesday');
		case 2:
			return $elm$json$Json$Encode$string('wednesday');
		case 3:
			return $elm$json$Json$Encode$string('thursday');
		case 4:
			return $elm$json$Json$Encode$string('friday');
		case 5:
			return $elm$json$Json$Encode$string('saturday');
		default:
			return $elm$json$Json$Encode$string('sunday');
	}
};
var $author$project$Model$FormFieldTypeV2$encodeDaypart = function (a) {
	switch (a) {
		case 0:
			return $elm$json$Json$Encode$string('morning');
		case 1:
			return $elm$json$Json$Encode$string('afternoon');
		case 2:
			return $elm$json$Json$Encode$string('evening');
		default:
			return $elm$json$Json$Encode$string('night');
	}
};
var $author$project$Util$Json$encodeEnum = function (toString) {
	return A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, toString);
};
var $author$project$Model$FormFieldValueV2$encodeBase64EncodedFile = function (a) {
	var b = a;
	return $elm$json$Json$Encode$string(b);
};
var $author$project$Model$FormFieldTypeV2$encodeMimeType = function (a) {
	var b = a;
	return $elm$json$Json$Encode$string(b);
};
var $author$project$Model$FormFieldValueV2$encodeFileValue = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'mimeType',
				$author$project$Model$FormFieldTypeV2$encodeMimeType(a.zh)),
				_Utils_Tuple2(
				'base64EncodedFile',
				$author$project$Model$FormFieldValueV2$encodeBase64EncodedFile(a.je)),
				_Utils_Tuple2(
				'filename',
				$elm$json$Json$Encode$string(a.rx))
			]));
};
var $author$project$Model$CountryCallingCode$toString = function (a) {
	switch (a) {
		case 0:
			return 'afghanistan';
		case 1:
			return 'aland-islands';
		case 2:
			return 'albania';
		case 3:
			return 'algeria';
		case 4:
			return 'american-samoa';
		case 5:
			return 'andorra';
		case 6:
			return 'angola';
		case 7:
			return 'anguilla';
		case 8:
			return 'antiguaand-barbuda';
		case 9:
			return 'argentina';
		case 10:
			return 'armenia';
		case 11:
			return 'aruba';
		case 12:
			return 'australia';
		case 13:
			return 'austria';
		case 14:
			return 'azerbaijan';
		case 15:
			return 'bahamas';
		case 16:
			return 'bahrain';
		case 17:
			return 'bangladesh';
		case 18:
			return 'barbados';
		case 19:
			return 'belarus';
		case 20:
			return 'belgium';
		case 21:
			return 'belize';
		case 22:
			return 'benin';
		case 23:
			return 'bermuda';
		case 24:
			return 'bhutan';
		case 25:
			return 'bolivia';
		case 26:
			return 'bosniaand-herzegovina';
		case 27:
			return 'botswana';
		case 28:
			return 'brazil';
		case 29:
			return 'british-indian-ocean-territory';
		case 30:
			return 'british-virgin-islands';
		case 31:
			return 'brunei';
		case 32:
			return 'bulgaria';
		case 33:
			return 'burkina-faso';
		case 34:
			return 'burundi';
		case 35:
			return 'cambodia';
		case 36:
			return 'cameroon';
		case 37:
			return 'canada';
		case 38:
			return 'cape-verde';
		case 39:
			return 'caribbean-netherlands';
		case 40:
			return 'cayman-islands';
		case 41:
			return 'central-african-republic';
		case 42:
			return 'chad';
		case 43:
			return 'chile';
		case 44:
			return 'china';
		case 45:
			return 'christmas-island';
		case 46:
			return 'cocos-keeling-islands';
		case 47:
			return 'colombia';
		case 48:
			return 'comoros';
		case 49:
			return 'cook-islands';
		case 50:
			return 'costa-rica';
		case 51:
			return 'croatia';
		case 52:
			return 'cuba';
		case 53:
			return 'curacao';
		case 54:
			return 'cyprus';
		case 55:
			return 'czech-republic';
		case 56:
			return 'congo';
		case 57:
			return 'denmark';
		case 58:
			return 'djibouti';
		case 59:
			return 'dominica';
		case 60:
			return 'dominican-republic';
		case 61:
			return 'ecuador';
		case 62:
			return 'egypt';
		case 63:
			return 'el-salvador';
		case 64:
			return 'equatorial-guinea';
		case 65:
			return 'eritrea';
		case 66:
			return 'estonia';
		case 67:
			return 'eswatini';
		case 68:
			return 'ethiopia';
		case 69:
			return 'falkland-islands';
		case 70:
			return 'faroe-islands';
		case 71:
			return 'fiji';
		case 72:
			return 'finland';
		case 73:
			return 'france';
		case 74:
			return 'french-guiana';
		case 75:
			return 'french-polynesia';
		case 76:
			return 'gabon';
		case 77:
			return 'gambia';
		case 78:
			return 'georgia';
		case 79:
			return 'germany';
		case 80:
			return 'ghana';
		case 81:
			return 'gibraltar';
		case 82:
			return 'greece';
		case 83:
			return 'greenland';
		case 84:
			return 'grenada';
		case 85:
			return 'guadeloupe';
		case 86:
			return 'guam';
		case 87:
			return 'guatemala';
		case 88:
			return 'guernsey';
		case 89:
			return 'guinea';
		case 90:
			return 'guinea-bissau';
		case 91:
			return 'guyana';
		case 92:
			return 'haiti';
		case 93:
			return 'honduras';
		case 94:
			return 'hong-kong';
		case 95:
			return 'hungary';
		case 96:
			return 'iceland';
		case 97:
			return 'india';
		case 98:
			return 'indonesia';
		case 99:
			return 'iran';
		case 100:
			return 'iraq';
		case 101:
			return 'ireland';
		case 102:
			return 'isleof-man';
		case 103:
			return 'israel';
		case 104:
			return 'italy';
		case 105:
			return 'ivory-coast';
		case 106:
			return 'jamaica';
		case 107:
			return 'japan';
		case 108:
			return 'jersey';
		case 109:
			return 'jordan';
		case 110:
			return 'kazakhstan';
		case 111:
			return 'kenya';
		case 112:
			return 'kiribati';
		case 113:
			return 'kosovo';
		case 114:
			return 'kuwait';
		case 115:
			return 'kyrgyzstan';
		case 116:
			return 'laos';
		case 117:
			return 'latvia';
		case 118:
			return 'lebanon';
		case 119:
			return 'lesotho';
		case 120:
			return 'liberia';
		case 121:
			return 'libya';
		case 122:
			return 'liechtenstein';
		case 123:
			return 'lithuania';
		case 124:
			return 'luxembourg';
		case 125:
			return 'macau';
		case 126:
			return 'macedonia';
		case 127:
			return 'madagascar';
		case 128:
			return 'malawi';
		case 129:
			return 'malaysia';
		case 130:
			return 'maldives';
		case 131:
			return 'mali';
		case 132:
			return 'malta';
		case 133:
			return 'marshall-islands';
		case 134:
			return 'martinique';
		case 135:
			return 'mauritania';
		case 136:
			return 'mauritius';
		case 137:
			return 'mayotte';
		case 138:
			return 'mexico';
		case 139:
			return 'micronesia';
		case 140:
			return 'moldova';
		case 141:
			return 'monaco';
		case 142:
			return 'mongolia';
		case 143:
			return 'montenegro';
		case 144:
			return 'montserrat';
		case 145:
			return 'morocco';
		case 146:
			return 'mozambique';
		case 147:
			return 'myanmar';
		case 148:
			return 'namibia';
		case 149:
			return 'nauru';
		case 150:
			return 'nepal';
		case 151:
			return 'netherlands';
		case 152:
			return 'new-caledonia';
		case 153:
			return 'new-zealand';
		case 154:
			return 'nicaragua';
		case 155:
			return 'niger';
		case 156:
			return 'nigeria';
		case 157:
			return 'niue';
		case 158:
			return 'norfolk-island';
		case 159:
			return 'north-korea';
		case 160:
			return 'northern-mariana-islands';
		case 161:
			return 'norway';
		case 162:
			return 'oman';
		case 163:
			return 'pakistan';
		case 164:
			return 'palau';
		case 165:
			return 'palestine';
		case 166:
			return 'panama';
		case 167:
			return 'papua-new-guinea';
		case 168:
			return 'paraguay';
		case 169:
			return 'peru';
		case 170:
			return 'philippines';
		case 171:
			return 'poland';
		case 172:
			return 'portugal';
		case 173:
			return 'puerto-rico';
		case 174:
			return 'qatar';
		case 175:
			return 'republicofthe-congo';
		case 176:
			return 'romania';
		case 177:
			return 'russia';
		case 178:
			return 'rwanda';
		case 179:
			return 'reunion';
		case 180:
			return 'saint-barthelemy';
		case 181:
			return 'saint-helena-ascensionand-tristanda-cunha';
		case 182:
			return 'saint-kittsand-nevis';
		case 183:
			return 'saint-lucia';
		case 184:
			return 'saint-martin';
		case 185:
			return 'saint-pierreand-miquelon';
		case 186:
			return 'saint-vincentandthe-grenadines';
		case 187:
			return 'samoa';
		case 188:
			return 'san-marino';
		case 189:
			return 'sao-tomeand-principe';
		case 190:
			return 'saudi-arabia';
		case 191:
			return 'senegal';
		case 192:
			return 'serbia';
		case 193:
			return 'seychelles';
		case 194:
			return 'sierra-leone';
		case 195:
			return 'singapore';
		case 196:
			return 'sint-maarten';
		case 197:
			return 'slovakia';
		case 198:
			return 'slovenia';
		case 199:
			return 'solomon-islands';
		case 200:
			return 'somalia';
		case 201:
			return 'south-africa';
		case 202:
			return 'south-korea';
		case 203:
			return 'south-sudan';
		case 204:
			return 'spain';
		case 205:
			return 'sri-lanka';
		case 206:
			return 'sudan';
		case 207:
			return 'suriname';
		case 208:
			return 'svalbardand-jan-mayen';
		case 209:
			return 'sweden';
		case 210:
			return 'switzerland';
		case 211:
			return 'syria';
		case 212:
			return 'taiwan';
		case 213:
			return 'tajikistan';
		case 214:
			return 'tanzania';
		case 215:
			return 'thailand';
		case 216:
			return 'timor-leste';
		case 217:
			return 'togo';
		case 218:
			return 'tokelau';
		case 219:
			return 'tonga';
		case 220:
			return 'trinidadand-tobago';
		case 221:
			return 'tunisia';
		case 222:
			return 'turkey';
		case 223:
			return 'turkmenistan';
		case 224:
			return 'turksand-caicos-islands';
		case 225:
			return 'tuvalu';
		case 226:
			return 'uganda';
		case 227:
			return 'ukraine';
		case 228:
			return 'united-arab-emirates';
		case 229:
			return 'united-kingdom';
		case 230:
			return 'united-states';
		case 231:
			return 'united-states-virgin-islands';
		case 232:
			return 'uruguay';
		case 233:
			return 'uzbekistan';
		case 234:
			return 'vanuatu';
		case 235:
			return 'vatican-city';
		case 236:
			return 'venezuela';
		case 237:
			return 'vietnam';
		case 238:
			return 'wallisand-futuna';
		case 239:
			return 'western-sahara';
		case 240:
			return 'yemen';
		case 241:
			return 'zambia';
		default:
			return 'zimbabwe';
	}
};
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Model$FormFieldValueV2$encodeFieldValue = function (a) {
	switch (a.$) {
		case 0:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('text-value')),
						_Utils_Tuple2(
						'contents',
						$elm$json$Json$Encode$string(b))
					]));
		case 1:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('date-value')),
						_Utils_Tuple2(
						'contents',
						A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $author$project$Util$Date$encodeDate, b))
					]));
		case 2:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('bool-value')),
						_Utils_Tuple2(
						'contents',
						$elm$json$Json$Encode$bool(b))
					]));
		case 3:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('file-value')),
						_Utils_Tuple2(
						'contents',
						A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $author$project$Model$FormFieldValueV2$encodeFileValue, b))
					]));
		case 4:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('select-value')),
						_Utils_Tuple2(
						'contents',
						A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, b))
					]));
		case 5:
			var b = a.a;
			var c = a.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('phone-number-with-calling-code-value')),
						_Utils_Tuple2(
						'contents',
						A2(
							$elm$json$Json$Encode$list,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									A2($author$project$Util$Json$encodeEnum, $author$project$Model$CountryCallingCode$toString, b),
									$elm$json$Json$Encode$string(c)
								])))
					]));
		case 6:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('address-value')),
						_Utils_Tuple2(
						'contents',
						function () {
							var c = b.a;
							var d = b.b;
							return A2(
								$elm$json$Json$Encode$list,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$elm$json$Json$Encode$bool(c),
										$author$project$Model$FormFieldValueV2$encodeAddressValue(d)
									]));
						}())
					]));
		case 7:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('daypart-availability-value')),
						_Utils_Tuple2(
						'contents',
						A2(
							$elm$json$Json$Encode$list,
							function (c) {
								var d = c.a;
								var e = c.b;
								return A2(
									$elm$json$Json$Encode$list,
									$elm$core$Basics$identity,
									_List_fromArray(
										[
											$author$project$Model$FormFieldTypeV2$encodeDayOfWeek(d),
											$author$project$Model$FormFieldTypeV2$encodeDaypart(e)
										]));
							},
							b))
					]));
		default:
			var b = a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tag',
						$elm$json$Json$Encode$string('screening-question-values')),
						_Utils_Tuple2(
						'contents',
						A2($elm$json$Json$Encode$list, $author$project$Model$FormFieldValueV2$encodeScreeningQuestionValue, b))
					]));
	}
};
var $author$project$Model$FormFieldValueV2$encodeScreeningQuestionValue = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$author$project$Model$FormFieldV2$encodeFieldName(a.c4)),
				_Utils_Tuple2(
				'value',
				$author$project$Model$FormFieldValueV2$encodeFieldValue(a.dL))
			]));
};
var $author$project$Model$FormFieldValueV2$encodeFieldValues = function (a) {
	var b = a;
	return A2(
		$elm$json$Json$Encode$list,
		function (c) {
			var d = c.a;
			var e = c.b;
			return A2(
				$elm$json$Json$Encode$list,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$author$project$Model$FormFieldV2$encodeFieldName(d),
						$author$project$Model$FormFieldValueV2$encodeFieldValue(e)
					]));
		},
		b);
};
var $pzp1997$assoc_list$AssocList$toList = function (_v0) {
	var alist = _v0;
	return alist;
};
var $author$project$View$FormV2$encodeFormInput = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$Basics$composeL, $author$project$Model$FormFieldValueV2$encodeFieldValues, $elm$core$Basics$identity),
	$pzp1997$assoc_list$AssocList$toList);
var $author$project$Api$NoContent = 0;
var $author$project$Api$expectNoContent = function (toMsg) {
	return A2(
		$author$project$Api$expectResponse,
		toMsg,
		F2(
			function (_v0, _v1) {
				return $elm$core$Result$Ok(0);
			}));
};
var $author$project$Data$Form$fieldNameToString = function (a) {
	switch (a.$) {
		case 0:
			return 'additional-file1';
		case 1:
			return 'additional-file2';
		case 2:
			return 'address';
		case 3:
			return 'address-with-auto-fill';
		case 4:
			return 'availability';
		case 5:
			return 'button';
		case 6:
			return 'city';
		case 7:
			var val = a.a;
			return val;
		case 9:
			return 'custom-ethnic-identification';
		case 13:
			return 'custom-state';
		case 8:
			return 'custom-canada-province';
		case 10:
			return 'custom-how-did-you-get-here-select';
		case 11:
			return 'custom-is-hispanic';
		case 12:
			return 'custom-select';
		case 47:
			return 'resume';
		case 14:
			return 'date-of-birth';
		case 15:
			return 'email-address';
		case 16:
			return 'first-name';
		case 17:
			return 'grades-bachelor1';
		case 18:
			return 'grades-bachelor2';
		case 19:
			return 'grades-master1';
		case 20:
			return 'grades-master2';
		case 21:
			return 'heading';
		case 23:
			return 'image';
		case 24:
			return 'internal';
		case 25:
			return 'internship-evaluation1';
		case 26:
			return 'internship-evaluation2';
		case 27:
			return 'intro-text';
		case 28:
			return 'last-name';
		case 29:
			return 'link';
		case 30:
			return 'linked-in-url';
		case 31:
			return 'motivation';
		case 32:
			return 'motivation-text-area';
		case 33:
			return 'newsletter-subscription';
		case 22:
			return 'how-did-you-get-here';
		case 39:
			return 'ordered-list';
		case 38:
			return 'open-text';
		case 48:
			return 'salary-indication';
		case 50:
			return 'source';
		case 40:
			return 'phone-number';
		case 41:
			return 'phone-number-with-calling-code';
		case 44:
			return 'postal-code';
		case 42:
			return 'plain-text';
		case 43:
			return 'portfolio';
		case 45:
			return 'privacy';
		case 46:
			return 'referred';
		case 49:
			return 'screening-questions';
		case 35:
			return 'open-checkbox-one';
		case 37:
			return 'open-checkbox-two';
		case 36:
			return 'open-checkbox-three';
		case 34:
			return 'open-checkbox-four';
		case 51:
			return 'spacer';
		case 52:
			return 'store-data';
		case 53:
			return 'thesis';
		case 54:
			return 'unordered-list';
		case 55:
			return 'url';
		case 56:
			return 'usp';
		case 57:
			return 'video';
		default:
			return 'xing-url';
	}
};
var $elm$file$File$Select$file = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			toMsg,
			_File_uploadOne(mimes));
	});
var $author$project$View$FormV2$NoOp = {$: 0};
var $author$project$Browser$Dom$Breakpoint$isBetween = F3(
	function (_v0, _v1, _v2) {
		var x = _v0;
		var a = _v1;
		var b = _v2;
		return (_Utils_cmp(x, a) > 0) && (_Utils_cmp(x, b) < 0);
	});
var $author$project$Browser$Dom$Breakpoint$Breakpoint = $elm$core$Basics$identity;
var $author$project$Browser$Dom$Breakpoint$medium = 1024;
var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var $author$project$Browser$Dom$Breakpoint$small = 768;
var $author$project$View$FormV2$focusOnErrorField = F2(
	function (_v0, error) {
		var form = _v0.b;
		if (error.$ === 1) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var fieldError = error.a.UY;
			var toScrollToWithOffset = function (_v4) {
				var element = _v4.pp;
				var scene = _v4.We;
				return A2(
					$elm$browser$Browser$Dom$setViewport,
					0,
					A3($author$project$Browser$Dom$Breakpoint$isBetween, scene.bF, $author$project$Browser$Dom$Breakpoint$small, $author$project$Browser$Dom$Breakpoint$medium) ? (element.m - 180) : (element.m - 140));
			};
			var focusAndScroll = function (name_) {
				return A2(
					$elm$core$Task$attempt,
					$elm$core$Basics$always($author$project$View$FormV2$NoOp),
					A2(
						$elm$core$Task$andThen,
						function (_v3) {
							return $elm$browser$Browser$Dom$focus(
								$author$project$Data$Form$fieldNameToString(name_));
						},
						A2(
							$elm$core$Task$andThen,
							toScrollToWithOffset,
							$elm$browser$Browser$Dom$getElement(
								$author$project$Data$Form$fieldNameToString(name_)))));
			};
			var _v2 = form.rn;
			var fields = _v2;
			var fieldToFocus = $elm$core$List$head(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.c4;
					},
					A2(
						$elm$core$List$filter,
						function (f) {
							return A2(
								$elm$core$Dict$member,
								$author$project$Data$Form$fieldNameToString(f.c4),
								fieldError);
						},
						$elm$core$List$concat(fields))));
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				A2($elm$core$Maybe$map, focusAndScroll, fieldToFocus));
		}
	});
var $pzp1997$assoc_list$AssocList$remove = F2(
	function (targetKey, _v0) {
		var alist = _v0;
		return A2(
			$elm$core$List$filter,
			function (_v1) {
				var key = _v1.a;
				return !_Utils_eq(key, targetKey);
			},
			alist);
	});
var $pzp1997$assoc_list$AssocList$insert = F3(
	function (key, value, dict) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$remove, key, dict);
		var alteredAlist = _v0;
		return A2(
			$elm$core$List$cons,
			_Utils_Tuple2(key, value),
			alteredAlist);
	});
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $author$project$Browser$Console$logError_ = _Platform_outgoingPort('logError_', $elm$json$Json$Encode$string);
var $author$project$Browser$Console$logError = $author$project$Browser$Console$logError_;
var $author$project$Data$Status$mapFailure = F2(
	function (f, status) {
		switch (status.$) {
			case 0:
				return $author$project$Data$Status$NotAsked;
			case 1:
				return $author$project$Data$Status$Loading;
			case 2:
				var err = status.a;
				return $author$project$Data$Status$Failure(
					f(err));
			default:
				var a = status.a;
				return $author$project$Data$Status$Success(a);
		}
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $author$project$Api$Endpoint$submitEventRegistration = F2(
	function (formId, eventId) {
		return $author$project$Api$Endpoint$endpoint(
			_List_fromArray(
				[
					'form',
					'event',
					$author$project$Data$Id$toString(formId),
					$author$project$Data$Id$toString(eventId)
				]));
	});
var $author$project$Api$Endpoint$submitJobApplication = F3(
	function (formId, vacancyId, queryParameters) {
		return A2(
			$author$project$Api$Endpoint$endpointWithQueryParameters,
			_List_fromArray(
				[
					'form',
					'job-application',
					$author$project$Data$Id$toString(formId),
					$author$project$Data$Id$toString(vacancyId)
				]),
			queryParameters);
	});
var $author$project$Api$Endpoint$submitOpenJobApplication = F3(
	function (formId, domainId, queryParameters) {
		return A2(
			$author$project$Api$Endpoint$endpointWithQueryParameters,
			_List_fromArray(
				[
					'form',
					'open-job-application',
					$author$project$Data$Id$toString(formId),
					$author$project$Data$Id$toString(domainId)
				]),
			queryParameters);
	});
var $author$project$Model$FormFieldValueV2$FileValue_ = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$FormFieldValueV2$Base64EncodedFile = $elm$core$Basics$identity;
var $author$project$View$FormV2$splitDataUrl = function (dataUrl) {
	var _v0 = A2(
		$elm$core$String$split,
		';base64,',
		A2($elm$core$String$dropLeft, 5, dataUrl));
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var mime = _v0.a;
		var _v1 = _v0.b;
		var base64 = _v1.a;
		return $elm$core$Result$Ok(
			_Utils_Tuple2(mime, base64));
	} else {
		var other = _v0;
		return $elm$core$Result$Err(
			'Split data url error, expected two element list but got: ' + $elm$core$String$concat(other));
	}
};
var $author$project$View$FormV2$toFieldValue = F3(
	function (fieldName, file, fileAsUrl) {
		var toFileValue_ = function (_v0) {
			var mimeType = _v0.a;
			var base64EncodedFile = _v0.b;
			return {
				je: base64EncodedFile,
				rx: $elm$file$File$name(file),
				zh: mimeType
			};
		};
		return A2(
			$elm$core$Result$map,
			A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Tuple$pair(fieldName),
						$author$project$Model$FormFieldValueV2$FileValue_),
					$elm$core$Maybe$Just),
				toFileValue_),
			$author$project$View$FormV2$splitDataUrl(fileAsUrl));
	});
var $author$project$View$FormV2$update = F3(
	function (config, msg, state) {
		var state_ = state;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(state, $elm$core$Platform$Cmd$none);
			case 1:
				var progress = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						state_,
						{
							aw: $elm$core$Maybe$Just(progress)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var fieldName = msg.a;
				var fieldValue = msg.b;
				var updateFailure = function (responseError) {
					if (responseError.$ === 1) {
						var err = responseError.a;
						return $author$project$Api$HttpError(err);
					} else {
						var err = responseError.a;
						return $author$project$Api$ValidationError(
							_Utils_update(
								err,
								{
									UY: A2(
										$elm$core$Dict$remove,
										$author$project$Data$Form$fieldNameToString(fieldName),
										err.UY)
								}));
					}
				};
				return _Utils_Tuple2(
					_Utils_update(
						state_,
						{
							w: A3($pzp1997$assoc_list$AssocList$insert, fieldName, fieldValue, state_.w),
							aU: A2($author$project$Data$Status$mapFailure, updateFailure, state_.aU)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var options = msg.a;
				var fieldName = msg.b;
				var mimeTypes = A2(
					$elm$core$List$map,
					function (_v2) {
						var x = _v2;
						return x;
					},
					options.zi);
				return _Utils_Tuple2(
					state_,
					A2(
						$elm$core$Platform$Cmd$map,
						config.xp,
						A2(
							$elm$file$File$Select$file,
							mimeTypes,
							$author$project$View$FormV2$FileSelected(fieldName))));
			case 7:
				var fieldName = msg.a;
				var file = msg.b;
				return _Utils_Tuple2(
					state_,
					A2(
						$elm$core$Platform$Cmd$map,
						config.xp,
						A2(
							$elm$core$Task$attempt,
							A2($author$project$View$FormV2$GotFileAsUrl, fieldName, file),
							$elm$file$File$toUrl(file))));
			case 8:
				if (msg.c.$ === 1) {
					return _Utils_Tuple2(
						state_,
						$author$project$Browser$Console$logError('Unable to load file as URL'));
				} else {
					var fieldName = msg.a;
					var file = msg.b;
					var fileAsUrl = msg.c.a;
					var _v3 = A3($author$project$View$FormV2$toFieldValue, fieldName, file, fileAsUrl);
					if (_v3.$ === 1) {
						var err = _v3.a;
						return _Utils_Tuple2(
							state_,
							$author$project$Browser$Console$logError(err));
					} else {
						var _v4 = _v3.a;
						var fieldName_ = _v4.a;
						var fieldValue = _v4.b;
						return _Utils_Tuple2(
							_Utils_update(
								state_,
								{
									w: A3($pzp1997$assoc_list$AssocList$insert, fieldName_, fieldValue, state_.w)
								}),
							$elm$core$Platform$Cmd$none);
					}
				}
			case 3:
				var post = F2(
					function (expect, endpoint) {
						return $author$project$Api$Endpoint$request(
							{
								a2: $elm$http$Http$jsonBody(
									$author$project$View$FormV2$encodeFormInput(state_.w)),
								cH: expect,
								cL: _List_Nil,
								c0: 'POST',
								dF: $elm$core$Maybe$Nothing,
								WM: $elm$core$Maybe$Just('post'),
								dK: endpoint
							});
					});
				var formType = $author$project$Data$Entity$value(state_.d7).sk;
				return _Utils_Tuple2(
					_Utils_update(
						state_,
						{aU: $author$project$Data$Status$Loading}),
					function () {
						var _v5 = state_.d9;
						switch (_v5.$) {
							case 2:
								var eventId = _v5.a;
								return A2(
									$elm$core$Platform$Cmd$map,
									config.xp,
									A2(
										post,
										$author$project$Api$expectNoContent($author$project$View$FormV2$GotSubmitFormNoContent),
										A2(
											$author$project$Api$Endpoint$submitEventRegistration,
											$author$project$Data$Entity$id(state_.d7),
											eventId)));
							case 0:
								var vacancyId = _v5.a;
								return A2(
									$elm$core$Platform$Cmd$map,
									config.xp,
									A2(
										post,
										A2(
											$author$project$Api$expectJson,
											$author$project$View$FormV2$GotSubmitForm(formType),
											$author$project$Model$RedirectUrl$redirectUrlDecoder),
										A3(
											$author$project$Api$Endpoint$submitJobApplication,
											$author$project$Data$Entity$id(state_.d7),
											vacancyId,
											config.V4)));
							case 1:
								var domainId = _v5.a;
								return A2(
									$elm$core$Platform$Cmd$map,
									config.xp,
									A2(
										post,
										$author$project$Api$expectNoContent($author$project$View$FormV2$GotSubmitFormNoContent),
										A3(
											$author$project$Api$Endpoint$submitOpenJobApplication,
											$author$project$Data$Entity$id(state_.d7),
											domainId,
											config.V4)));
							default:
								return $elm$core$Platform$Cmd$none;
						}
					}());
			case 4:
				if (!msg.b.$) {
					switch (msg.a) {
						case 0:
							var _v6 = msg.a;
							var redirectUrl = msg.b.a;
							return _Utils_Tuple2(
								_Utils_update(
									state_,
									{
										aw: $elm$core$Maybe$Nothing,
										aU: $author$project$Data$Status$Success(0)
									}),
								config.VR(redirectUrl));
						case 2:
							var _v7 = msg.a;
							return _Utils_Tuple2(
								_Utils_update(
									state_,
									{
										aw: $elm$core$Maybe$Nothing,
										aU: $author$project$Data$Status$Success(0)
									}),
								$elm$core$Platform$Cmd$none);
						case 3:
							var _v8 = msg.a;
							return _Utils_Tuple2(state_, $elm$core$Platform$Cmd$none);
						default:
							var _v9 = msg.a;
							return _Utils_Tuple2(state_, $elm$core$Platform$Cmd$none);
					}
				} else {
					var err = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{
								aw: $elm$core$Maybe$Nothing,
								aU: $author$project$Data$Status$Failure(err)
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							config.xp,
							A2($author$project$View$FormV2$focusOnErrorField, state_.d7, err)));
				}
			case 5:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{
								aw: $elm$core$Maybe$Nothing,
								aU: $author$project$Data$Status$Success(0)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							state_,
							{
								aw: $elm$core$Maybe$Nothing,
								aU: $author$project$Data$Status$Failure(err)
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							config.xp,
							A2($author$project$View$FormV2$focusOnErrorField, state_.d7, err)));
				}
			case 9:
				var keyword = msg.a;
				var insertFieldValueMsg = msg.b;
				var params = _List_fromArray(
					[
						A2($elm$url$Url$Builder$string, 'keywords', keyword),
						A2($elm$url$Url$Builder$string, 'service', 'tomtom')
					]);
				return _Utils_Tuple2(
					state,
					A2(
						$elm$core$Platform$Cmd$map,
						config.xp,
						$elm$http$Http$request(
							{
								a2: $elm$http$Http$emptyBody,
								cH: A2(
									$author$project$Api$expectJson,
									$author$project$View$FormV2$GotAddressWithAutoFill(insertFieldValueMsg),
									$elm$json$Json$Decode$list($author$project$Model$Suggestion$locationSuggestionDecoder)),
								cL: _List_Nil,
								c0: 'GET',
								dF: $elm$core$Maybe$Nothing,
								WM: $elm$core$Maybe$Just('addres-with-auto-fill'),
								dK: A2(
									$elm$url$Url$Builder$absolute,
									_List_fromArray(
										[
											'api',
											$author$project$Data$Id$toString(state_.UL),
											'suggestions',
											'locations'
										]),
									params)
							})));
			default:
				if (!msg.b.$) {
					if (!msg.b.a.b) {
						var validationError = $author$project$Api$ValidationError(
							{
								UY: A2(
									$elm$core$Dict$singleton,
									$author$project$Data$Form$fieldNameToString($author$project$Model$FormFieldV2$AddressWithAutoFill),
									A2($elm$core$Dict$singleton, 'nl', $author$project$Copy$copy.Fs)),
								sI: $elm$core$Dict$empty,
								Et: $elm$core$Dict$empty
							});
						return _Utils_Tuple2(
							_Utils_update(
								state_,
								{
									aU: $author$project$Data$Status$Failure(validationError)
								}),
							A2(
								$elm$core$Platform$Cmd$map,
								config.xp,
								A2($author$project$View$FormV2$focusOnErrorField, state_.d7, validationError)));
					} else {
						var insertFieldValueMsg = msg.a;
						var _v10 = msg.b.a;
						var locationSuggestion = _v10.a;
						return _Utils_Tuple2(
							state,
							A2(
								$elm$core$Task$perform,
								$elm$core$Basics$always(
									config.xp(
										insertFieldValueMsg(
											_Utils_Tuple2(locationSuggestion.NZ, locationSuggestion.xT)))),
								$elm$time$Time$now));
					}
				} else {
					var err = msg.b.a;
					return _Utils_Tuple2(
						state,
						A2(
							$elm$core$Platform$Cmd$map,
							config.xp,
							A2($author$project$View$FormV2$focusOnErrorField, state_.d7, err)));
				}
		}
	});
var $author$project$View$ChatBot$updateLocationSuggestions = F5(
	function (domainId, nodeId, locationSuggestionsMsg, locationSuggestions, model) {
		var _v0 = A3(
			$author$project$View$LocationSuggestions$update,
			A3($author$project$View$ChatBot$locationSuggestionsConfig, domainId, nodeId, model.av),
			locationSuggestionsMsg,
			locationSuggestions);
		var locationSuggestionsModel = _v0.a;
		var locationSuggestionsCmds = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					ah: $elm$core$Maybe$Just(
						_Utils_Tuple2(nodeId, locationSuggestionsModel))
				}),
			locationSuggestionsCmds);
	});
var $author$project$View$ChatBot$update = F5(
	function (lift, domainId, langCode, msg, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map(lift),
			function () {
				switch (msg.$) {
					case 0:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 1:
						var nodeId = msg.a;
						var searchParams = msg.b;
						var result = msg.c;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ad: A3(
										$author$project$Dict$Custom$insert,
										nodeId,
										A2(
											$author$project$Data$Status$map,
											$elm$core$Tuple$pair(searchParams),
											$author$project$Data$Status$fromResult(result)),
										model.ad)
								}),
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$View$ChatBot$ScrollToMsg,
								$author$project$ScrollToInElement$scrollToBottom(model.O)));
					case 2:
						var result = msg.a;
						var initForm = F2(
							function (vacancyId, formData) {
								return {
									bP: $author$project$View$FormV2$init(
										{
											UE: 151,
											UL: domainId,
											d7: formData.bP,
											d9: $author$project$Model$Form$FormType$JobApplicationData(vacancyId),
											eL: model.eL,
											eM: _List_Nil
										}),
									dh: formData.dh,
									P$: A2($author$project$Data$Translation$translationsFromEntities, langCode, formData.P$)
								};
							});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									D: A2(
										$elm$core$Maybe$map,
										function (x) {
											return _Utils_update(
												x,
												{
													bP: A2(
														$author$project$Data$Status$map,
														initForm(x.R6),
														$author$project$Data$Status$fromResult(result))
												});
										},
										model.D),
									aD: $elm$core$Maybe$Just('0-input')
								}),
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$View$ChatBot$ScrollToMsg,
								A2($author$project$ScrollToInElement$scrollToCustomTask, model.O, $author$project$View$ChatBot$scrollToFormNode)));
					case 3:
						var nodeId = msg.a;
						return $author$project$View$ChatBot$storeLocalStorageState_(
							A3($author$project$View$ChatBot$focusOn, domainId, nodeId, model));
					case 4:
						var index = msg.a;
						var nextModel = _Utils_update(
							model,
							{
								bt: A2(
									$elm$core$Set$insert,
									$author$project$Data$ChatBot$idToInt(index),
									model.bt)
							});
						return _Utils_Tuple2(
							nextModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$elm$core$Platform$Cmd$map,
										$author$project$View$ChatBot$ScrollToMsg,
										$author$project$ScrollToInElement$scrollToBottom(model.O)),
										$author$project$View$ChatBot$queueNextNodeToShow(nextModel)
									])));
					case 6:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aD: $elm$core$Maybe$Nothing,
									O: $author$project$ScrollToInElement$cancel(model.O)
								}),
							$elm$core$Platform$Cmd$none);
					case 5:
						var scrollToMsg = msg.a;
						var _v1 = A3($author$project$ScrollToInElement$update, $author$project$View$ChatBot$ScrollToMsg, scrollToMsg, model.O);
						var scrollToModel = _v1.a;
						var scrollToCmds = _v1.b;
						var _v2 = function () {
							var _v3 = _Utils_Tuple2(
								$author$project$ScrollToInElement$isScrolling(scrollToModel),
								model.aD);
							if ((!_v3.a) && (!_v3.b.$)) {
								var id = _v3.b.a;
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A2(
										$elm$core$Task$attempt,
										$elm$core$Basics$always($author$project$View$ChatBot$NoOp),
										$elm$browser$Browser$Dom$focus(id)));
							} else {
								return _Utils_Tuple2(model.aD, $elm$core$Platform$Cmd$none);
							}
						}();
						var focusAfterScroll = _v2.a;
						var focusCmd = _v2.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{aD: focusAfterScroll, O: scrollToModel}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[focusCmd, scrollToCmds])));
					case 7:
						var nodeId = msg.a;
						var locationSuggestionsMsg = msg.b;
						var _v4 = model.ah;
						if (_v4.$ === 1) {
							return A5($author$project$View$ChatBot$updateLocationSuggestions, domainId, nodeId, locationSuggestionsMsg, $author$project$View$LocationSuggestions$init, model);
						} else {
							var _v5 = _v4.a;
							var currentNodeId = _v5.a;
							var locationSuggestions = _v5.b;
							return _Utils_eq(nodeId, currentNodeId) ? A5($author$project$View$ChatBot$updateLocationSuggestions, domainId, nodeId, locationSuggestionsMsg, locationSuggestions, model) : A5($author$project$View$ChatBot$updateLocationSuggestions, domainId, nodeId, locationSuggestionsMsg, $author$project$View$LocationSuggestions$init, model);
						}
					case 8:
						var nodeId = msg.a;
						var locationSuggestion = msg.b;
						var searchParams = _Utils_update(
							$author$project$View$ChatBot$chatBotSearchParams,
							{
								eq: $elm$core$Maybe$Just(locationSuggestion.Vn)
							});
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ah: A2(
										$elm$core$Maybe$map,
										$elm$core$Tuple$mapSecond($author$project$View$LocationSuggestions$resetWithValue),
										model.ah)
								}),
							A3($author$project$View$ChatBot$requestVacancySearch, nodeId, domainId, searchParams));
					case 9:
						var nodeId = msg.a;
						var vacancyId = msg.b;
						return $author$project$View$ChatBot$storeLocalStorageState_(
							A2(
								$author$project$View$ChatBot$requestAdditionalNodeData,
								domainId,
								_Utils_Tuple2(
									_Utils_update(
										model,
										{
											D: $elm$core$Maybe$Just(
												{bP: $author$project$Data$Status$NotAsked, ar: nodeId, R6: vacancyId})
										}),
									$elm$core$Platform$Cmd$none)));
					case 10:
						var formMsg = msg.a;
						var _v6 = A2(
							$elm$core$Maybe$map,
							function (x) {
								return _Utils_Tuple3(x.ar, x.R6, x.bP);
							},
							model.D);
						if ((!_v6.$) && (_v6.a.c.$ === 3)) {
							var _v7 = _v6.a;
							var nodeId = _v7.a;
							var vacancyId = _v7.b;
							var formData = _v7.c.a;
							var _v8 = A3(
								$author$project$View$FormV2$update,
								{
									xp: $author$project$View$ChatBot$FormMsg,
									VR: $elm$core$Basics$always($elm$core$Platform$Cmd$none),
									V4: _List_Nil
								},
								formMsg,
								formData.bP);
							var formState = _v8.a;
							var formCmds = _v8.b;
							var _v9 = function () {
								var _v10 = $author$project$View$FormV2$submitStatus(formState);
								if (_v10.$ === 3) {
									return $author$project$View$ChatBot$storeLocalStorageState_(
										A3($author$project$View$ChatBot$focusOn, domainId, nodeId, model));
								} else {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								}
							}();
							var nextModel = _v9.a;
							var nextCmds = _v9.b;
							return _Utils_Tuple2(
								_Utils_update(
									nextModel,
									{
										D: $elm$core$Maybe$Just(
											{
												bP: $author$project$Data$Status$Success(
													_Utils_update(
														formData,
														{bP: formState})),
												ar: nodeId,
												R6: vacancyId
											})
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[formCmds, nextCmds])));
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					case 11:
						return $author$project$View$ChatBot$storeLocalStorageState_(
							_Utils_Tuple2(
								_Utils_update(
									model,
									{D: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$none));
					case 12:
						var salaryCalculatorId = msg.a;
						var result = msg.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aR: A3(
										$author$project$Dict$Custom$insert,
										salaryCalculatorId,
										$author$project$Data$Status$fromResult(result),
										model.aR)
								}),
							$elm$core$Platform$Cmd$none);
					default:
						var nodeId = msg.a;
						var value = msg.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aj: A3($author$project$Dict$Custom$insert, nodeId, value, model.aj)
								}),
							$elm$core$Platform$Cmd$none);
				}
			}());
	});
var $author$project$RecruitmentChat$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ak: $elm$core$Maybe$Just(true)
						}),
					$author$project$RecruitmentChat$showRecruitmentChat(true));
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ak: $elm$core$Maybe$Just(false)
						}),
					$author$project$RecruitmentChat$showRecruitmentChat(false));
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dy: false}),
					$elm$core$Platform$Cmd$none);
			case 0:
				var chatBotMsg = msg.a;
				var _v1 = A5($author$project$View$ChatBot$update, $author$project$RecruitmentChat$ChatBotMsg, model.cF, model.wS, chatBotMsg, model.kT);
				var chatBot = _v1.a;
				var chatBotCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{kT: chatBot}),
					chatBotCmd);
			case 4:
				var _v2 = A8($author$project$View$ChatBot$init, $author$project$RecruitmentChat$ChatBotMsg, model.GA.cF, $elm$core$Maybe$Nothing, model.b4, model.GA.kT, model.av, model.eL, model.an);
				var chatBot = _v2.a;
				var chatBotCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{kT: chatBot}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								chatBotCmd,
								$author$project$View$ChatBot$storeLocalStorageState(
								$author$project$View$ChatBot$encodeLocalStorageState(chatBot))
							])));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$RecruitmentChat$HideChatBot = {$: 2};
var $author$project$RecruitmentChat$ResetChat = {$: 4};
var $author$project$Browser$Dom$Breakpoint$custom = $elm$core$Basics$identity;
var $author$project$Browser$Dom$Breakpoint$zero = 0;
var $author$project$Browser$Dom$Breakpoint$isMobile = function (windowWidth) {
	return A3(
		$author$project$Browser$Dom$Breakpoint$isBetween,
		windowWidth,
		$author$project$Browser$Dom$Breakpoint$zero,
		$author$project$Browser$Dom$Breakpoint$custom(992));
};
var $author$project$View$ChatBot$CancelScroll = {$: 6};
var $author$project$Data$ChatBot$current = function (x) {
	return $zwilias$elm_rosetree$Tree$Zipper$children(x);
};
var $author$project$View$ChatBot$nodeMetadata = function (node) {
	switch (node.$) {
		case 0:
			return {dY: 'chatbot-node-option', _: true};
		case 4:
			return {dY: 'chatbot-node-salarycalculator', _: true};
		case 3:
			return {dY: 'chatbot-node-vacancyoverview', _: false};
		case 1:
			return {dY: 'chatbot-node-text', _: false};
		case 2:
			return {dY: 'chatbot-node-link', _: false};
		case 5:
			return {dY: 'chatbot-node-image', _: false};
		case 6:
			return {dY: 'chatbot-node-video', _: false};
		case 7:
			return {dY: 'chatbot-node-embeddedchatbot', _: false};
		default:
			return {dY: 'chatbot-node-root', _: false};
	}
};
var $author$project$View$ChatBot$nodeClassName = A2(
	$elm$core$Basics$composeL,
	function ($) {
		return $.dY;
	},
	$author$project$View$ChatBot$nodeMetadata);
var $elm_community$maybe_extra$Maybe$Extra$join = function (mx) {
	if (!mx.$) {
		var x = mx.a;
		return x;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Status$withStatus = F3(
	function (status, _default, f) {
		if (status.$ === 3) {
			var a = status.a;
			return f(a);
		} else {
			return _default;
		}
	});
var $author$project$View$ChatBot$getHoursAndAge = F4(
	function (nodeId, salaryCalculatorId, salaryCalculatorInput, salaryCalculators) {
		var mapStatus = function (val) {
			return A3(
				$author$project$Data$Status$withStatus,
				val,
				{gd: 16, t1: 40},
				function (_v0) {
					var salary = _v0.b;
					return {
						gd: $author$project$Data$SalaryCalculator$minAge(salary),
						t1: A2($elm$core$Maybe$withDefault, 40, salary.er)
					};
				});
		};
		var getDefault = A2(
			$elm$core$Maybe$withDefault,
			{gd: 16, t1: 40},
			A2(
				$elm$core$Maybe$map,
				mapStatus,
				$elm_community$maybe_extra$Maybe$Extra$join(
					A2(
						$elm$core$Maybe$map,
						function (id) {
							return A2($author$project$Dict$Custom$get, id, salaryCalculators);
						},
						salaryCalculatorId))));
		return A2(
			$elm$core$Maybe$withDefault,
			getDefault,
			A2($author$project$Dict$Custom$get, nodeId, salaryCalculatorInput));
	});
var $author$project$View$ChatBot$salaryCalculatorInputWithFallback = F3(
	function (salaryCalculatorId, data, nodeId) {
		return A4($author$project$View$ChatBot$getHoursAndAge, nodeId, salaryCalculatorId, data.aj, data.aR);
	});
var $author$project$View$ChatBot$viewImageNode = function (path) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src(path)
				]),
			_List_Nil)
		]);
};
var $author$project$Data$ChatBot$targetToValue = function (target) {
	if (!target) {
		return '_blank';
	} else {
		return '_self';
	}
};
var $author$project$View$ChatBot$viewLinkNode = function (settings) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$target(
					$author$project$Data$ChatBot$targetToValue(settings.OS)),
					$elm$html$Html$Attributes$href(settings.dK)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(settings.WC)
				]))
		]);
};
var $author$project$View$ChatBot$isUserAction = A2(
	$elm$core$Basics$composeL,
	function ($) {
		return $._;
	},
	$author$project$View$ChatBot$nodeMetadata);
var $author$project$View$ChatBot$viewNodeAvatar = F2(
	function (node, maybeAvatar) {
		return A2(
			$author$project$Util$View$viewIfNot,
			$author$project$View$ChatBot$isUserAction(node),
			function (_v0) {
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pop-in chatbot-node-avatar'),
							function () {
							if (maybeAvatar.$ === 1) {
								return $elm$html$Html$Attributes$class('chatbot-node-noavatar');
							} else {
								var avatar = maybeAvatar.a;
								return A2(
									$elm$html$Html$Attributes$style,
									'background-image',
									A2(
										$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
										'url(\'{0}\')',
										_List_fromArray(
											[avatar])));
							}
						}()
						]),
					_List_Nil);
			});
	});
var $author$project$View$ChatBot$FocusOn = function (a) {
	return {$: 3, a: a};
};
var $author$project$View$ChatBot$viewOptionNode = F2(
	function (node, content) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$View$ChatBot$FocusOn(node.cO)),
						$elm$html$Html$Attributes$class('btn btn-submit primary bg-color-1 color-white')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(content)
					]))
			]);
	});
var $author$project$View$ChatBot$OnSalaryCalculatorInput = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Component$Form$NumberInput$Attribute = $elm$core$Basics$identity;
var $author$project$Component$Form$NumberInput$NumberInput = $elm$core$Basics$identity;
var $author$project$Component$Form$NumberInput$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$Form$NumberInput$id = function (id_) {
	return $author$project$Component$Form$NumberInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					cO: $elm$core$Maybe$Just(id_)
				});
		});
};
var $author$project$Data$ChatBot$idToString = A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $author$project$Data$ChatBot$idToInt);
var $author$project$Component$Form$NumberInput$max = function (max_) {
	return $author$project$Component$Form$NumberInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					c_: $elm$core$Maybe$Just(max_)
				});
		});
};
var $author$project$Component$Form$NumberInput$min = function (min_) {
	return $author$project$Component$Form$NumberInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{bX: min_});
		});
};
var $author$project$Component$Form$NumberInput$onInput = function (msg_) {
	return $author$project$Component$Form$NumberInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					c9: $elm$core$Maybe$Just(msg_)
				});
		});
};
var $author$project$Component$Form$NumberInput$placeholder = function (placeholder_) {
	return $author$project$Component$Form$NumberInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					dd: $elm$core$Maybe$Just(placeholder_)
				});
		});
};
var $author$project$Component$Form$NumberInput$value = function (value_) {
	return $author$project$Component$Form$NumberInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{dL: value_});
		});
};
var $author$project$Component$Form$NumberInput$WidthFillContainer = 0;
var $author$project$Component$Form$NumberInput$build = {bL: $elm$core$Maybe$Nothing, cM: false, cO: $elm$core$Maybe$Nothing, cS: false, bj: '', c_: $elm$core$Maybe$Nothing, bX: 0, c4: $elm$core$Maybe$Nothing, c9: $elm$core$Maybe$Nothing, dd: $elm$core$Maybe$Nothing, dl: false, dL: 0, bF: 0};
var $author$project$Component$Form$NumberInput$label = function (label_) {
	return $author$project$Component$Form$NumberInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{bj: label_});
		});
};
var $author$project$Component$Form$NumberInput$Auto = 1;
var $author$project$Component$Form$NumberInput$failOnNegative = F3(
	function (toString, min_, n) {
		return (_Utils_cmp(n, min_) < 0) ? $elm$json$Json$Decode$fail(
			'Expected atleast' + toString(min_)) : $elm$json$Json$Decode$succeed(n);
	});
var $author$project$Component$Form$NumberInput$generateId = function (labelText) {
	return A2(
		$elm$core$String$join,
		'-',
		$elm$core$String$words(labelText));
};
var $author$project$Component$Form$NumberInput$viewNumberInput = function (_v0) {
	var config = _v0;
	var toOnInput = function (toMsg) {
		return A2(
			$elm$html$Html$Events$on,
			'input',
			A2(
				$elm$json$Json$Decode$map,
				toMsg,
				A2(
					$elm$json$Json$Decode$andThen,
					A2($author$project$Component$Form$NumberInput$failOnNegative, $elm$core$String$fromInt, config.bX),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['target', 'valueAsNumber']),
						$elm$json$Json$Decode$int))));
	};
	var placeholder_ = A2($elm$core$Maybe$withDefault, config.bj, config.dd);
	var maybeAttributes = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2($elm$core$Maybe$map, toOnInput, config.c9),
				A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeL, $elm$html$Html$Attributes$max, $elm$core$String$fromInt),
				config.c_),
				A2($elm$core$Maybe$map, $elm$html$Html$Attributes$name, config.c4)
			]));
	var labelClasslist = _List_fromArray(
		[
			_Utils_Tuple2('label', true),
			_Utils_Tuple2('visually-hidden', config.cM)
		]);
	var idValue = function () {
		var _v2 = config.cO;
		if (!_v2.$) {
			var id_ = _v2.a;
			return id_;
		} else {
			return $author$project$Component$Form$NumberInput$generateId(config.bj);
		}
	}();
	var inputAttributes = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('form-input'),
			$elm$html$Html$Attributes$type_('number'),
			$elm$html$Html$Attributes$value(
			$elm$core$String$fromInt(config.dL)),
			$elm$html$Html$Attributes$min(
			$elm$core$String$fromInt(config.bX)),
			$elm$html$Html$Attributes$id(idValue),
			$elm$html$Html$Attributes$placeholder(placeholder_),
			$elm$html$Html$Attributes$required(config.dl)
		]);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-field', true),
						_Utils_Tuple2(
						'error',
						$elm_community$maybe_extra$Maybe$Extra$isJust(config.bL)),
						_Utils_Tuple2('inline', config.cS),
						_Utils_Tuple2('width-auto', config.bF === 1)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-field-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(labelClasslist),
								$elm$html$Html$Attributes$for(idValue)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Util$View$viewIfNot,
								$elm$core$String$isEmpty(config.bj),
								function (_v1) {
									return $elm$html$Html$text(config.bj);
								})
							])),
						A2(
						$elm$html$Html$input,
						_Utils_ap(inputAttributes, maybeAttributes),
						_List_Nil),
						A2(
						$author$project$Util$View$viewMaybe,
						config.bL,
						function (error_) {
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('error-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(error_)
									]));
						})
					]))
			]));
};
var $author$project$Component$Form$NumberInput$view = F2(
	function (label_, attributes) {
		return $author$project$Component$Form$NumberInput$viewNumberInput(
			A3(
				$elm$core$List$foldl,
				function (_v0) {
					var attribute = _v0;
					return attribute;
				},
				$author$project$Component$Form$NumberInput$build,
				A2(
					$elm$core$List$cons,
					$author$project$Component$Form$NumberInput$label(label_),
					attributes)));
	});
var $author$project$View$ChatBot$viewSalaryCalculatorNode = F4(
	function (node, value, salaryCalculatorId, salaryCalculators) {
		var _v0 = A2($author$project$Dict$Custom$get, salaryCalculatorId, salaryCalculators);
		if ((!_v0.$) && (_v0.a.$ === 3)) {
			var _v1 = _v0.a.a;
			var salaryCalculator = _v1.b;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('chatbot-node-salarycalculator-inputs')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('chatbot-node-salarycalculator-input-wrapper')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text($author$project$Copy$copy.gd)
										])),
									A2(
									$author$project$Component$Form$NumberInput$view,
									'',
									_List_fromArray(
										[
											$author$project$Component$Form$NumberInput$onInput(
											function (v) {
												return A2(
													$author$project$View$ChatBot$OnSalaryCalculatorInput,
													node.cO,
													_Utils_update(
														value,
														{gd: v}));
											}),
											$author$project$Component$Form$NumberInput$id(
											$author$project$Data$ChatBot$idToString(node.cO) + 'age'),
											$author$project$Component$Form$NumberInput$value(value.gd),
											$author$project$Component$Form$NumberInput$placeholder(''),
											$author$project$Component$Form$NumberInput$min(
											$author$project$Data$SalaryCalculator$minAge(salaryCalculator))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('chatbot-node-salarycalculator-input-wrapper')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text($author$project$Copy$copy.t1)
										])),
									A2(
									$author$project$Component$Form$NumberInput$view,
									'',
									_List_fromArray(
										[
											$author$project$Component$Form$NumberInput$onInput(
											function (v) {
												return A2(
													$author$project$View$ChatBot$OnSalaryCalculatorInput,
													node.cO,
													_Utils_update(
														value,
														{t1: v}));
											}),
											$author$project$Component$Form$NumberInput$id(
											$author$project$Data$ChatBot$idToString(node.cO) + 'hours'),
											$author$project$Component$Form$NumberInput$value(value.t1),
											$author$project$Component$Form$NumberInput$placeholder(''),
											$author$project$Component$Form$NumberInput$min(0),
											$author$project$Component$Form$NumberInput$max(
											A2($elm$core$Maybe$withDefault, 40, salaryCalculator.er))
										]))
								]))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$View$ChatBot$FocusOn(node.cO)),
							$elm$html$Html$Attributes$class('btn btn-submit primary bg-color-1 color-white')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$Copy$copy.j2)
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Data$ChatBot$findParentOf = function (id) {
	return A2(
		$elm$core$Basics$composeR,
		$zwilias$elm_rosetree$Tree$Zipper$findFromRoot(
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$eq(id),
				function ($) {
					return $.cO;
				})),
		$elm$core$Maybe$andThen($zwilias$elm_rosetree$Tree$Zipper$parent));
};
var $author$project$Data$ChatBot$parentOf = function (id) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Data$ChatBot$findParentOf(id),
		$elm$core$Maybe$map($zwilias$elm_rosetree$Tree$Zipper$label));
};
var $author$project$View$ChatBot$viewTextNode = F3(
	function (node, data, content) {
		var maybeSalaryCalculatorData = function () {
			var _v2 = A2(
				$elm$core$Maybe$map,
				function (parent) {
					return _Utils_Tuple2(parent.bq, parent.cO);
				},
				A2($author$project$Data$ChatBot$parentOf, node.cO, data.kT));
			if (((!_v2.$) && (_v2.a.a.$ === 4)) && (!_v2.a.a.a.$)) {
				var _v3 = _v2.a;
				var salaryCalculatorId = _v3.a.a.a;
				var parentId = _v3.b;
				var _v4 = A2(
					$elm$core$Maybe$map,
					function (v) {
						return _Utils_Tuple2(
							A3(
								$author$project$View$ChatBot$salaryCalculatorInputWithFallback,
								$elm$core$Maybe$Just(salaryCalculatorId),
								data,
								parentId),
							v);
					},
					A2($author$project$Dict$Custom$get, salaryCalculatorId, data.aR));
				if ((!_v4.$) && (_v4.a.b.$ === 3)) {
					var _v5 = _v4.a;
					var inputValue = _v5.a;
					var _v6 = _v5.b.a;
					var salaryCalculator = _v6.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(inputValue, salaryCalculator));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		if (!maybeSalaryCalculatorData.$) {
			var _v1 = maybeSalaryCalculatorData.a;
			var inputValue = _v1.a;
			var salaryCalculator = _v1.b;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$pre,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A5($author$project$Data$SalaryCalculator$interpolateMessage, salaryCalculator, content, inputValue.gd, inputValue.t1, 1))
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$pre,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(content)
						]))
				]);
		}
	});
var $author$project$View$ChatBot$CloseForm = {$: 11};
var $author$project$Util$Url$joinPath = function (segments) {
	return A2($elm$url$Url$Builder$absolute, segments, _List_Nil);
};
var $author$project$View$FormV2$SubmitForm = {$: 3};
var $author$project$Data$Status$isSuccess = function (status) {
	if (status.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$View$FormV2$AlignFlexEnd = 2;
var $author$project$View$FormV2$Combined = 3;
var $author$project$View$FormV2$Joined = 1;
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $author$project$Util$Base$flip = F3(
	function (f, b, a) {
		return A2(f, a, b);
	});
var $author$project$View$FormV2$isCurrentRowOneOrMore = F2(
	function (currentFields, _v0) {
		var oneOrMore = _v0;
		var names = A2(
			$elm$core$List$map,
			function ($) {
				return $.c4;
			},
			currentFields);
		return A2(
			$elm$core$List$any,
			$elm$core$Basics$eq(true),
			A2(
				$elm$core$List$map,
				function (v) {
					return ($elm$core$List$length(v) >= 2) && A2(
						$elm$core$List$all,
						A2($author$project$Util$Base$flip, $elm$core$List$member, names),
						v);
				},
				oneOrMore));
	});
var $author$project$View$FormV2$intersperseOneOrMoreRow = F3(
	function (currentFields, oneOrMoreNames, columns) {
		return A2($author$project$View$FormV2$isCurrentRowOneOrMore, currentFields, oneOrMoreNames) ? A2(
			$elm$core$List$intersperse,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('or')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text($author$project$Copy$copy.Dx)
					])),
			columns) : columns;
	});
var $author$project$View$FormV2$Normal = 0;
var $author$project$View$FormV2$toRowStyle = F2(
	function (oneOrMoreNames, fields) {
		var _v0 = _Utils_Tuple2(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.c4;
				},
				fields),
			A2(
				$elm$core$List$map,
				function ($) {
					return $.dI;
				},
				fields));
		_v0$3:
		while (true) {
			_v0$4:
			while (true) {
				if (_v0.a.b) {
					if (_v0.a.b.b) {
						if (((_v0.a.a.$ === 16) && (_v0.a.b.a.$ === 28)) && (!_v0.a.b.b.b)) {
							var _v1 = _v0.a;
							var _v2 = _v1.a;
							var _v3 = _v1.b;
							var _v4 = _v3.a;
							return 1;
						} else {
							if ((_v0.b.b && (_v0.b.a.$ === 7)) && (!_v0.b.b.b)) {
								break _v0$3;
							} else {
								break _v0$4;
							}
						}
					} else {
						switch (_v0.a.a.$) {
							case 2:
								var _v5 = _v0.a;
								var _v6 = _v5.a;
								return 3;
							case 3:
								var _v7 = _v0.a;
								var _v8 = _v7.a;
								return 3;
							default:
								if ((_v0.b.b && (_v0.b.a.$ === 7)) && (!_v0.b.b.b)) {
									break _v0$3;
								} else {
									break _v0$4;
								}
						}
					}
				} else {
					if ((_v0.b.b && (_v0.b.a.$ === 7)) && (!_v0.b.b.b)) {
						break _v0$3;
					} else {
						break _v0$4;
					}
				}
			}
			return A2($author$project$View$FormV2$isCurrentRowOneOrMore, fields, oneOrMoreNames) ? 2 : 0;
		}
		var _v9 = _v0.b;
		var _v10 = _v9.a;
		return 3;
	});
var $author$project$Model$FormFieldValueV2$AddressValue_ = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$FormFieldValueV2$BoolValue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$FormFieldValueV2$DateValue = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$FormV2$InsertFieldValue = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Model$FormFieldValueV2$PhoneNumberWithCallingCodeValue = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Model$FormFieldValueV2$ScreeningQuestionValues = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$FormFieldValueV2$TextValue = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$CountryCallingCode$all = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242]);
var $author$project$Component$Form$Checkbox$Attribute = $elm$core$Basics$identity;
var $author$project$Component$Form$Checkbox$TextInput = $elm$core$Basics$identity;
var $author$project$Component$Form$Checkbox$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$Form$Checkbox$checked = function (value_) {
	return $author$project$Component$Form$Checkbox$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{bJ: value_});
		});
};
var $author$project$Component$Form$TextInput$Email = 0;
var $author$project$Component$Form$TextInput$type_ = function (inputType_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{dI: inputType_});
		});
};
var $author$project$Component$Form$TextInput$email = $author$project$Component$Form$TextInput$type_(0);
var $author$project$Component$Form$Checkbox$error = function (error_) {
	return $author$project$Component$Form$Checkbox$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{bL: error_});
		});
};
var $author$project$Component$Form$DateInput$Attribute = $elm$core$Basics$identity;
var $author$project$Component$Form$DateInput$DateInput = $elm$core$Basics$identity;
var $author$project$Component$Form$DateInput$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$Form$DateInput$error = function (error_) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					be: A2(
						$elm$core$Maybe$map,
						function (err) {
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('error-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(err)
									]));
						},
						error_)
				});
		});
};
var $author$project$Component$Form$TextInput$extraHtml = function (html) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					bM: $elm$core$Maybe$Just(html)
				});
		});
};
var $author$project$Model$CountryCallingCode$toCode = function (a) {
	switch (a) {
		case 0:
			return '+93';
		case 1:
			return '+358';
		case 2:
			return '+355';
		case 3:
			return '+213';
		case 4:
			return '+1';
		case 5:
			return '+376';
		case 6:
			return '+244';
		case 7:
			return '+1';
		case 8:
			return '+1';
		case 9:
			return '+54';
		case 10:
			return '+374';
		case 11:
			return '+297';
		case 12:
			return '+61';
		case 13:
			return '+43';
		case 14:
			return '+994';
		case 15:
			return '+1';
		case 16:
			return '+973';
		case 17:
			return '+880';
		case 18:
			return '+1';
		case 19:
			return '+375';
		case 20:
			return '+32';
		case 21:
			return '+501';
		case 22:
			return '+229';
		case 23:
			return '+1';
		case 24:
			return '+975';
		case 25:
			return '+591';
		case 26:
			return '+387';
		case 27:
			return '+267';
		case 28:
			return '+55';
		case 29:
			return '+246';
		case 30:
			return '+1';
		case 31:
			return '+673';
		case 32:
			return '+359';
		case 33:
			return '+226';
		case 34:
			return '+257';
		case 35:
			return '+855';
		case 36:
			return '+237';
		case 37:
			return '+1';
		case 38:
			return '+238';
		case 39:
			return '+599';
		case 40:
			return '+1';
		case 41:
			return '+236';
		case 42:
			return '+235';
		case 43:
			return '+56';
		case 44:
			return '+86';
		case 45:
			return '+61';
		case 46:
			return '+61';
		case 47:
			return '+57';
		case 48:
			return '+269';
		case 49:
			return '+682';
		case 50:
			return '+506';
		case 51:
			return '+385';
		case 52:
			return '+53';
		case 53:
			return '+599';
		case 54:
			return '+357';
		case 55:
			return '+420';
		case 56:
			return '+243';
		case 57:
			return '+45';
		case 58:
			return '+253';
		case 59:
			return '+1';
		case 60:
			return '+1';
		case 61:
			return '+593';
		case 62:
			return '+20';
		case 63:
			return '+503';
		case 64:
			return '+240';
		case 65:
			return '+291';
		case 66:
			return '+372';
		case 67:
			return '+268';
		case 68:
			return '+251';
		case 69:
			return '+500';
		case 70:
			return '+298';
		case 71:
			return '+679';
		case 72:
			return '+358';
		case 73:
			return '+33';
		case 74:
			return '+594';
		case 75:
			return '+689';
		case 76:
			return '+241';
		case 77:
			return '+220';
		case 78:
			return '+995';
		case 79:
			return '+49';
		case 80:
			return '+233';
		case 81:
			return '+350';
		case 82:
			return '+30';
		case 83:
			return '+299';
		case 84:
			return '+1';
		case 85:
			return '+590';
		case 86:
			return '+1';
		case 87:
			return '+502';
		case 88:
			return '+44';
		case 89:
			return '+224';
		case 90:
			return '+245';
		case 91:
			return '+592';
		case 92:
			return '+509';
		case 93:
			return '+504';
		case 94:
			return '+852';
		case 95:
			return '+36';
		case 96:
			return '+354';
		case 97:
			return '+91';
		case 98:
			return '+62';
		case 99:
			return '+98';
		case 100:
			return '+964';
		case 101:
			return '+353';
		case 102:
			return '+44';
		case 103:
			return '+972';
		case 104:
			return '+39';
		case 105:
			return '+225';
		case 106:
			return '+1';
		case 107:
			return '+81';
		case 108:
			return '+44';
		case 109:
			return '+962';
		case 110:
			return '+7';
		case 111:
			return '+254';
		case 112:
			return '+686';
		case 113:
			return '+383';
		case 114:
			return '+965';
		case 115:
			return '+996';
		case 116:
			return '+856';
		case 117:
			return '+371';
		case 118:
			return '+961';
		case 119:
			return '+266';
		case 120:
			return '+231';
		case 121:
			return '+218';
		case 122:
			return '+423';
		case 123:
			return '+370';
		case 124:
			return '+352';
		case 125:
			return '+853';
		case 126:
			return '+389';
		case 127:
			return '+261';
		case 128:
			return '+265';
		case 129:
			return '+60';
		case 130:
			return '+960';
		case 131:
			return '+223';
		case 132:
			return '+356';
		case 133:
			return '+692';
		case 134:
			return '+596';
		case 135:
			return '+222';
		case 136:
			return '+230';
		case 137:
			return '+262';
		case 138:
			return '+52';
		case 139:
			return '+691';
		case 140:
			return '+373';
		case 141:
			return '+377';
		case 142:
			return '+976';
		case 143:
			return '+382';
		case 144:
			return '+1';
		case 145:
			return '+212';
		case 146:
			return '+258';
		case 147:
			return '+95';
		case 148:
			return '+264';
		case 149:
			return '+674';
		case 150:
			return '+977';
		case 151:
			return '+31';
		case 152:
			return '+687';
		case 153:
			return '+64';
		case 154:
			return '+505';
		case 155:
			return '+227';
		case 156:
			return '+234';
		case 157:
			return '+683';
		case 158:
			return '+672';
		case 159:
			return '+850';
		case 160:
			return '+1';
		case 161:
			return '+47';
		case 162:
			return '+968';
		case 163:
			return '+92';
		case 164:
			return '+680';
		case 165:
			return '+970';
		case 166:
			return '+507';
		case 167:
			return '+675';
		case 168:
			return '+595';
		case 169:
			return '+51';
		case 170:
			return '+63';
		case 171:
			return '+48';
		case 172:
			return '+351';
		case 173:
			return '+1';
		case 174:
			return '+974';
		case 175:
			return '+242';
		case 176:
			return '+40';
		case 177:
			return '+7';
		case 178:
			return '+250';
		case 179:
			return '+262';
		case 180:
			return '+590';
		case 181:
			return '+290';
		case 182:
			return '+1';
		case 183:
			return '+1';
		case 184:
			return '+590';
		case 185:
			return '+508';
		case 186:
			return '+1';
		case 187:
			return '+685';
		case 188:
			return '+378';
		case 189:
			return '+239';
		case 190:
			return '+966';
		case 191:
			return '+221';
		case 192:
			return '+381';
		case 193:
			return '+248';
		case 194:
			return '+232';
		case 195:
			return '+65';
		case 196:
			return '+1';
		case 197:
			return '+421';
		case 198:
			return '+386';
		case 199:
			return '+677';
		case 200:
			return '+252';
		case 201:
			return '+27';
		case 202:
			return '+82';
		case 203:
			return '+211';
		case 204:
			return '+34';
		case 205:
			return '+94';
		case 206:
			return '+249';
		case 207:
			return '+597';
		case 208:
			return '+47';
		case 209:
			return '+46';
		case 210:
			return '+41';
		case 211:
			return '+963';
		case 212:
			return '+886';
		case 213:
			return '+992';
		case 214:
			return '+255';
		case 215:
			return '+66';
		case 216:
			return '+670';
		case 217:
			return '+228';
		case 218:
			return '+690';
		case 219:
			return '+676';
		case 220:
			return '+1';
		case 221:
			return '+216';
		case 222:
			return '+90';
		case 223:
			return '+993';
		case 224:
			return '+1';
		case 225:
			return '+688';
		case 226:
			return '+256';
		case 227:
			return '+380';
		case 228:
			return '+971';
		case 229:
			return '+44';
		case 230:
			return '+1';
		case 231:
			return '+1';
		case 232:
			return '+598';
		case 233:
			return '+998';
		case 234:
			return '+678';
		case 235:
			return '+39';
		case 236:
			return '+58';
		case 237:
			return '+84';
		case 238:
			return '+681';
		case 239:
			return '+212';
		case 240:
			return '+967';
		case 241:
			return '+260';
		default:
			return '+263';
	}
};
var $author$project$Data$CountryCallingCode$toCountryName = function (countryCallingCode) {
	switch (countryCallingCode) {
		case 0:
			return $author$project$Copy$copy.f9;
		case 1:
			return $author$project$Copy$copy.ge;
		case 2:
			return $author$project$Copy$copy.gf;
		case 3:
			return $author$project$Copy$copy.gg;
		case 4:
			return $author$project$Copy$copy.gG;
		case 5:
			return $author$project$Copy$copy.gN;
		case 6:
			return $author$project$Copy$copy.gO;
		case 7:
			return $author$project$Copy$copy.gP;
		case 8:
			return $author$project$Copy$copy.gQ;
		case 9:
			return $author$project$Copy$copy.hQ;
		case 10:
			return $author$project$Copy$copy.hS;
		case 11:
			return $author$project$Copy$copy.h4;
		case 12:
			return $author$project$Copy$copy.ik;
		case 13:
			return $author$project$Copy$copy.Ug;
		case 14:
			return $author$project$Copy$copy.iA;
		case 15:
			return $author$project$Copy$copy.iQ;
		case 16:
			return $author$project$Copy$copy.iR;
		case 17:
			return $author$project$Copy$copy.iT;
		case 18:
			return $author$project$Copy$copy.jd;
		case 19:
			return $author$project$Copy$copy.ji;
		case 20:
			return $author$project$Copy$copy.Ui;
		case 21:
			return $author$project$Copy$copy.jj;
		case 22:
			return $author$project$Copy$copy.jk;
		case 23:
			return $author$project$Copy$copy.jl;
		case 24:
			return $author$project$Copy$copy.js;
		case 25:
			return $author$project$Copy$copy.jA;
		case 26:
			return $author$project$Copy$copy.jD;
		case 27:
			return $author$project$Copy$copy.jF;
		case 28:
			return $author$project$Copy$copy.jI;
		case 29:
			return $author$project$Copy$copy.jL;
		case 30:
			return $author$project$Copy$copy.jM;
		case 31:
			return $author$project$Copy$copy.jT;
		case 32:
			return $author$project$Copy$copy.jU;
		case 33:
			return $author$project$Copy$copy.jX;
		case 34:
			return $author$project$Copy$copy.jY;
		case 35:
			return $author$project$Copy$copy.j4;
		case 36:
			return $author$project$Copy$copy.j5;
		case 37:
			return $author$project$Copy$copy.kd;
		case 38:
			return $author$project$Copy$copy.kh;
		case 39:
			return $author$project$Copy$copy.ks;
		case 40:
			return $author$project$Copy$copy.kx;
		case 41:
			return $author$project$Copy$copy.kz;
		case 42:
			return $author$project$Copy$copy.kA;
		case 43:
			return $author$project$Copy$copy.kW;
		case 44:
			return $author$project$Copy$copy.Us;
		case 45:
			return $author$project$Copy$copy.lb;
		case 46:
			return $author$project$Copy$copy.lG;
		case 47:
			return $author$project$Copy$copy.lJ;
		case 48:
			return $author$project$Copy$copy.lZ;
		case 49:
			return $author$project$Copy$copy.ml;
		case 50:
			return $author$project$Copy$copy.mF;
		case 51:
			return $author$project$Copy$copy.m3;
		case 52:
			return $author$project$Copy$copy.nd;
		case 53:
			return $author$project$Copy$copy.ne;
		case 54:
			return $author$project$Copy$copy.nu;
		case 55:
			return $author$project$Copy$copy.nv;
		case 56:
			return $author$project$Copy$copy.l7;
		case 57:
			return $author$project$Copy$copy.UK;
		case 58:
			return $author$project$Copy$copy.oQ;
		case 59:
			return $author$project$Copy$copy.oX;
		case 60:
			return $author$project$Copy$copy.oY;
		case 61:
			return $author$project$Copy$copy.o6;
		case 62:
			return $author$project$Copy$copy.pn;
		case 63:
			return $author$project$Copy$copy.po;
		case 64:
			return $author$project$Copy$copy.qf;
		case 65:
			return $author$project$Copy$copy.qg;
		case 66:
			return $author$project$Copy$copy.qn;
		case 67:
			return $author$project$Copy$copy.qo;
		case 68:
			return $author$project$Copy$copy.qp;
		case 69:
			return $author$project$Copy$copy.q7;
		case 70:
			return $author$project$Copy$copy.q8;
		case 71:
			return $author$project$Copy$copy.ro;
		case 72:
			return $author$project$Copy$copy.U_;
		case 73:
			return $author$project$Copy$copy.U5;
		case 74:
			return $author$project$Copy$copy.sn;
		case 75:
			return $author$project$Copy$copy.so;
		case 76:
			return $author$project$Copy$copy.sA;
		case 77:
			return $author$project$Copy$copy.sB;
		case 78:
			return $author$project$Copy$copy.sD;
		case 79:
			return $author$project$Copy$copy.U7;
		case 80:
			return $author$project$Copy$copy.sE;
		case 81:
			return $author$project$Copy$copy.sF;
		case 82:
			return $author$project$Copy$copy.s5;
		case 83:
			return $author$project$Copy$copy.ta;
		case 84:
			return $author$project$Copy$copy.tb;
		case 85:
			return $author$project$Copy$copy.tj;
		case 86:
			return $author$project$Copy$copy.tk;
		case 87:
			return $author$project$Copy$copy.tl;
		case 88:
			return $author$project$Copy$copy.tm;
		case 89:
			return $author$project$Copy$copy.tn;
		case 90:
			return $author$project$Copy$copy.to;
		case 91:
			return $author$project$Copy$copy.tq;
		case 92:
			return $author$project$Copy$copy.tr;
		case 93:
			return $author$project$Copy$copy.tX;
		case 94:
			return $author$project$Copy$copy.tY;
		case 95:
			return $author$project$Copy$copy.ur;
		case 96:
			return $author$project$Copy$copy.ut;
		case 97:
			return $author$project$Copy$copy.uP;
		case 98:
			return $author$project$Copy$copy.uQ;
		case 99:
			return $author$project$Copy$copy.vH;
		case 100:
			return $author$project$Copy$copy.vI;
		case 101:
			return $author$project$Copy$copy.vJ;
		case 102:
			return $author$project$Copy$copy.vU;
		case 103:
			return $author$project$Copy$copy.vW;
		case 104:
			return $author$project$Copy$copy.vZ;
		case 105:
			return $author$project$Copy$copy.v1;
		case 106:
			return $author$project$Copy$copy.v2;
		case 107:
			return $author$project$Copy$copy.v3;
		case 108:
			return $author$project$Copy$copy.v4;
		case 109:
			return $author$project$Copy$copy.wu;
		case 110:
			return $author$project$Copy$copy.wD;
		case 111:
			return $author$project$Copy$copy.wE;
		case 112:
			return $author$project$Copy$copy.wK;
		case 113:
			return $author$project$Copy$copy.wL;
		case 114:
			return $author$project$Copy$copy.wM;
		case 115:
			return $author$project$Copy$copy.wN;
		case 116:
			return $author$project$Copy$copy.wU;
		case 117:
			return $author$project$Copy$copy.w9;
		case 118:
			return $author$project$Copy$copy.xk;
		case 119:
			return $author$project$Copy$copy.xl;
		case 120:
			return $author$project$Copy$copy.xm;
		case 121:
			return $author$project$Copy$copy.xn;
		case 122:
			return $author$project$Copy$copy.xo;
		case 123:
			return $author$project$Copy$copy.xP;
		case 124:
			return $author$project$Copy$copy.Vo;
		case 125:
			return $author$project$Copy$copy.yh;
		case 126:
			return $author$project$Copy$copy.yi;
		case 127:
			return $author$project$Copy$copy.yj;
		case 128:
			return $author$project$Copy$copy.yl;
		case 129:
			return $author$project$Copy$copy.ym;
		case 130:
			return $author$project$Copy$copy.yn;
		case 131:
			return $author$project$Copy$copy.yo;
		case 132:
			return $author$project$Copy$copy.yp;
		case 133:
			return $author$project$Copy$copy.yz;
		case 134:
			return $author$project$Copy$copy.yA;
		case 135:
			return $author$project$Copy$copy.yH;
		case 136:
			return $author$project$Copy$copy.yI;
		case 137:
			return $author$project$Copy$copy.yY;
		case 138:
			return $author$project$Copy$copy.zf;
		case 139:
			return $author$project$Copy$copy.zg;
		case 140:
			return $author$project$Copy$copy.zB;
		case 141:
			return $author$project$Copy$copy.zC;
		case 142:
			return $author$project$Copy$copy.zF;
		case 143:
			return $author$project$Copy$copy.zH;
		case 144:
			return $author$project$Copy$copy.zK;
		case 145:
			return $author$project$Copy$copy.zM;
		case 146:
			return $author$project$Copy$copy.zT;
		case 147:
			return $author$project$Copy$copy.zW;
		case 148:
			return $author$project$Copy$copy.z0;
		case 149:
			return $author$project$Copy$copy.z1;
		case 150:
			return $author$project$Copy$copy.z9;
		case 151:
			return $author$project$Copy$copy.Vy;
		case 152:
			return $author$project$Copy$copy.Aj;
		case 153:
			return $author$project$Copy$copy.AI;
		case 154:
			return $author$project$Copy$copy.A1;
		case 155:
			return $author$project$Copy$copy.A2;
		case 156:
			return $author$project$Copy$copy.A3;
		case 157:
			return $author$project$Copy$copy.A5;
		case 158:
			return $author$project$Copy$copy.Ct;
		case 159:
			return $author$project$Copy$copy.Cu;
		case 160:
			return $author$project$Copy$copy.Cv;
		case 161:
			return $author$project$Copy$copy.VI;
		case 162:
			return $author$project$Copy$copy.CS;
		case 163:
			return $author$project$Copy$copy.El;
		case 164:
			return $author$project$Copy$copy.Em;
		case 165:
			return $author$project$Copy$copy.En;
		case 166:
			return $author$project$Copy$copy.Eo;
		case 167:
			return $author$project$Copy$copy.Ep;
		case 168:
			return $author$project$Copy$copy.Eq;
		case 169:
			return $author$project$Copy$copy.ET;
		case 170:
			return $author$project$Copy$copy.EV;
		case 171:
			return $author$project$Copy$copy.V$;
		case 172:
			return $author$project$Copy$copy.V0;
		case 173:
			return $author$project$Copy$copy.Gf;
		case 174:
			return $author$project$Copy$copy.Gg;
		case 175:
			return $author$project$Copy$copy.Ib;
		case 176:
			return $author$project$Copy$copy.Wc;
		case 177:
			return $author$project$Copy$copy.IJ;
		case 178:
			return $author$project$Copy$copy.IK;
		case 179:
			return $author$project$Copy$copy.Is;
		case 180:
			return $author$project$Copy$copy.IO;
		case 181:
			return $author$project$Copy$copy.IP;
		case 182:
			return $author$project$Copy$copy.IQ;
		case 183:
			return $author$project$Copy$copy.IR;
		case 184:
			return $author$project$Copy$copy.IS;
		case 185:
			return $author$project$Copy$copy.IT;
		case 186:
			return $author$project$Copy$copy.IU;
		case 187:
			return $author$project$Copy$copy.I8;
		case 188:
			return $author$project$Copy$copy.I9;
		case 189:
			return $author$project$Copy$copy.Jb;
		case 190:
			return $author$project$Copy$copy.Jf;
		case 191:
			return $author$project$Copy$copy.K2;
		case 192:
			return $author$project$Copy$copy.Lc;
		case 193:
			return $author$project$Copy$copy.Lh;
		case 194:
			return $author$project$Copy$copy.Mo;
		case 195:
			return $author$project$Copy$copy.Wi;
		case 196:
			return $author$project$Copy$copy.Mq;
		case 197:
			return $author$project$Copy$copy.Wk;
		case 198:
			return $author$project$Copy$copy.ME;
		case 199:
			return $author$project$Copy$copy.MU;
		case 200:
			return $author$project$Copy$copy.MV;
		case 201:
			return $author$project$Copy$copy.M8;
		case 202:
			return $author$project$Copy$copy.M9;
		case 203:
			return $author$project$Copy$copy.Na;
		case 204:
			return $author$project$Copy$copy.Wl;
		case 205:
			return $author$project$Copy$copy.Ng;
		case 206:
			return $author$project$Copy$copy.Op;
		case 207:
			return $author$project$Copy$copy.OA;
		case 208:
			return $author$project$Copy$copy.OB;
		case 209:
			return $author$project$Copy$copy.Wx;
		case 210:
			return $author$project$Copy$copy.Wy;
		case 211:
			return $author$project$Copy$copy.OC;
		case 212:
			return $author$project$Copy$copy.ON;
		case 213:
			return $author$project$Copy$copy.OO;
		case 214:
			return $author$project$Copy$copy.OR;
		case 215:
			return $author$project$Copy$copy.O9;
		case 216:
			return $author$project$Copy$copy.Pp;
		case 217:
			return $author$project$Copy$copy.Pw;
		case 218:
			return $author$project$Copy$copy.Px;
		case 219:
			return $author$project$Copy$copy.Pz;
		case 220:
			return $author$project$Copy$copy.P2;
		case 221:
			return $author$project$Copy$copy.P6;
		case 222:
			return $author$project$Copy$copy.P7;
		case 223:
			return $author$project$Copy$copy.P8;
		case 224:
			return $author$project$Copy$copy.P9;
		case 225:
			return $author$project$Copy$copy.Qa;
		case 226:
			return $author$project$Copy$copy.Qe;
		case 227:
			return $author$project$Copy$copy.WO;
		case 228:
			return $author$project$Copy$copy.Qp;
		case 229:
			return $author$project$Copy$copy.Qq;
		case 230:
			return $author$project$Copy$copy.WQ;
		case 231:
			return $author$project$Copy$copy.Qr;
		case 232:
			return $author$project$Copy$copy.Q4;
		case 233:
			return $author$project$Copy$copy.RD;
		case 234:
			return $author$project$Copy$copy.Sx;
		case 235:
			return $author$project$Copy$copy.Sy;
		case 236:
			return $author$project$Copy$copy.Sz;
		case 237:
			return $author$project$Copy$copy.SN;
		case 238:
			return $author$project$Copy$copy.S6;
		case 239:
			return $author$project$Copy$copy.Ts;
		case 240:
			return $author$project$Copy$copy.TT;
		case 241:
			return $author$project$Copy$copy.T0;
		default:
			return $author$project$Copy$copy.T3;
	}
};
var $author$project$Data$CountryCallingCode$formatWithCountryName = function (countryCallingCode) {
	return A2(
		$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
		'{0} {1}',
		_List_fromArray(
			[
				$author$project$Data$CountryCallingCode$toCountryName(countryCallingCode),
				$author$project$Model$CountryCallingCode$toCode(countryCallingCode)
			]));
};
var $pzp1997$assoc_list$AssocList$get = F2(
	function (targetKey, _v0) {
		get:
		while (true) {
			var alist = _v0;
			if (!alist.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v2 = alist.a;
				var key = _v2.a;
				var value = _v2.b;
				var rest = alist.b;
				if (_Utils_eq(key, targetKey)) {
					return $elm$core$Maybe$Just(value);
				} else {
					var $temp$targetKey = targetKey,
						$temp$_v0 = rest;
					targetKey = $temp$targetKey;
					_v0 = $temp$_v0;
					continue get;
				}
			}
		}
	});
var $pzp1997$assoc_list$AssocList$fromList = function (alist) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, result) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($pzp1997$assoc_list$AssocList$insert, key, value, result);
			}),
		_List_Nil,
		alist);
};
var $author$project$View$FormV2$getScreeningQuestionsValueDict = function (maybeFieldValues) {
	return $pzp1997$assoc_list$AssocList$fromList(
		A2(
			$elm$core$List$map,
			function (field) {
				return _Utils_Tuple2(field.c4, field);
			},
			A2($elm$core$Maybe$withDefault, _List_Nil, maybeFieldValues)));
};
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $author$project$View$FormV2$getValueForDomain = F2(
	function (domainKey, values) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm_community$maybe_extra$Maybe$Extra$join(
				A2(
					$elm$core$Maybe$map,
					function (i) {
						return A2($elm_community$list_extra$List$Extra$getAt, i, values);
					},
					A2(
						$elm_community$list_extra$List$Extra$findIndex,
						A2(
							$elm$core$Basics$composeL,
							$elm$core$Basics$eq(domainKey),
							$elm$core$Tuple$first),
						values))));
	});
var $author$project$Component$Form$DateInput$hiddenLabel = function (val) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{cM: val});
		});
};
var $author$project$Component$Form$Checkbox$htmlLabel = function (label_) {
	return $author$project$Component$Form$Checkbox$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					cN: $elm$core$Maybe$Just(label_)
				});
		});
};
var $author$project$Component$Form$DateInput$icon = function (path) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					aH: $elm$core$Maybe$Just(path)
				});
		});
};
var $author$project$Component$Form$Checkbox$id = function (id_) {
	return $author$project$Component$Form$Checkbox$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					cO: $elm$core$Maybe$Just(id_)
				});
		});
};
var $author$project$Component$Form$DateInput$id = function (id_) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					cO: $elm$core$Maybe$Just(id_)
				});
		});
};
var $author$project$Component$Form$TextArea$id = function (id_) {
	return $author$project$Component$Form$TextArea$set(
		function (config) {
			return _Utils_update(
				config,
				{cO: id_});
		});
};
var $author$project$Component$Form$TextInput$id = function (id_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					cO: $elm$core$Maybe$Just(id_)
				});
		});
};
var $author$project$View$FormV2$insertScreeningQuestionValue = F3(
	function (maybeFieldValues, id, val) {
		return A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			$pzp1997$assoc_list$AssocList$toList(
				A3(
					$pzp1997$assoc_list$AssocList$insert,
					id,
					val,
					$author$project$View$FormV2$getScreeningQuestionsValueDict(maybeFieldValues))));
	});
var $author$project$Component$Form$DateInput$maxOffsetFromTodayInYears = function (maxOffsetFromTodayInYears_) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{c$: maxOffsetFromTodayInYears_});
		});
};
var $author$project$View$FormV2$toScreeningQuestionsValue_ = F2(
	function (maybeScreeningQuestion, extractF) {
		return $elm_community$maybe_extra$Maybe$Extra$join(
			A2(
				$elm$core$Maybe$map,
				extractF,
				$elm_community$maybe_extra$Maybe$Extra$join(
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.dL;
						},
						maybeScreeningQuestion))));
	});
var $author$project$View$FormV2$maybeValue = F3(
	function (config, formInput, extractF) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$View$FormV2$toScreeningQuestionsValue_, config.bo, extractF),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Maybe$Just,
				$elm_community$maybe_extra$Maybe$Extra$join(
					A2(
						$elm$core$Maybe$map,
						extractF,
						A2($pzp1997$assoc_list$AssocList$get, config.a.c4, formInput)))));
	});
var $author$project$Component$Form$DateInput$minOffsetFromTodayInYears = function (minOffsetFromTodayInYears_) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{c1: minOffsetFromTodayInYears_});
		});
};
var $author$project$Component$Form$Checkbox$onCheck = function (msg_) {
	return $author$project$Component$Form$Checkbox$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					c8: $elm$core$Maybe$Just(msg_)
				});
		});
};
var $author$project$Component$Form$DateInput$onInput = function (msg_) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					c9: $elm$core$Maybe$Just(msg_)
				});
		});
};
var $author$project$Component$Form$TextInput$Phone = 3;
var $author$project$Component$Form$TextInput$phone = $author$project$Component$Form$TextInput$type_(3);
var $author$project$Component$Form$Checkbox$required = function (required_) {
	return $author$project$Component$Form$Checkbox$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{dl: required_});
		});
};
var $author$project$Component$Form$TextArea$required = function (required_) {
	return $author$project$Component$Form$TextArea$set(
		function (config) {
			return _Utils_update(
				config,
				{dl: required_});
		});
};
var $author$project$View$FormV2$toAdressValue = function (value_) {
	if (value_.$ === 6) {
		var val = value_.a;
		return $elm$core$Maybe$Just(val);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$FormV2$toBoolValue = function (value_) {
	if (value_.$ === 2) {
		var val = value_.a;
		return $elm$core$Maybe$Just(val);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$FormV2$toDateValue = function (value_) {
	if ((value_.$ === 1) && (!value_.a.$)) {
		var val = value_.a.a;
		return $elm$core$Maybe$Just(val);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$FormV2$toDaypartValue = function (value_) {
	if (value_.$ === 7) {
		var val = value_.a;
		return $elm$core$Maybe$Just(val);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$FormV2$toErrorMessage = function (message) {
	return A2(
		$elm$core$Maybe$map,
		function (errMsgDefault) {
			return (message.cV && (message.dm !== '')) ? message.dm : (((!message.cV) && (message.cU !== '')) ? message.cU : errMsgDefault);
		},
		message.V);
};
var $author$project$View$FormV2$toFileValue = function (value_) {
	if (value_.$ === 3) {
		var val = value_.a;
		return val;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$FormV2$toPhoneWithCallingCodeValue = function (value_) {
	if (value_.$ === 5) {
		var callingCode = value_.a;
		var val = value_.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(callingCode, val));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$FormV2$toPrivacyLabel = F5(
	function (domainKey, translations, privacyPath, name, labels) {
		var translationName = function (type_) {
			return $author$project$Data$Form$fieldNameToString(name) + ('-consent-' + type_);
		};
		var val = function (type_) {
			return A2(
				$author$project$Data$Translation$toString,
				translations,
				translationName(type_));
		};
		var _v0 = _Utils_Tuple2(
			name,
			A2($author$project$View$FormV2$getValueForDomain, domainKey, labels));
		if (_v0.a.$ === 45) {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var v = _v0.b.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('privacy-consent')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('link link-underline'),
										$elm$html$Html$Attributes$target('_blank'),
										$elm$html$Html$Attributes$href(privacyPath)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(v)
									]))
							])));
			} else {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('privacy-consent')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								val('text')),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('link link-underline'),
										$elm$html$Html$Attributes$target('_blank'),
										$elm$html$Html$Attributes$href(privacyPath)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										val('label'))
									]))
							])));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$View$FormV2$toScreeningQuestionFormField = function (screeningQuestion) {
	return {
		d8: {UF: $author$project$Copy$copy.vk, UG: screeningQuestion.bj, UH: $author$project$Copy$copy.zu, UI: $author$project$Copy$copy.Jm, Vd: false, Vj: _List_Nil, bj: _List_Nil, Vu: _List_Nil, c4: $author$project$Model$FormFieldV2$ScreeningQuestions, dd: _List_Nil, dI: screeningQuestion.rm},
		uv: screeningQuestion.cO
	};
};
var $author$project$View$FormV2$toScreeningQuestionsValue = function (value_) {
	if (value_.$ === 8) {
		var valueList = value_.a;
		return $elm$core$Maybe$Just(valueList);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$FormFieldValueV2$SelectValue = function (a) {
	return {$: 4, a: a};
};
var $author$project$Component$Form$Select$viewDefaultOption = F2(
	function (maybeDefault, current) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(''),
					$elm$html$Html$Attributes$selected(
					A2(
						$elm$core$Maybe$withDefault,
						true,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$always(false),
							current)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($elm$core$Maybe$withDefault, '-', maybeDefault))
				]));
	});
var $author$project$Component$Form$Select$viewOption = F4(
	function (current, toTitle, toValue, opt) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					toValue(opt)),
					$elm$html$Html$Attributes$selected(
					A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$apR(opt),
							current)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					toTitle(opt))
				]));
	});
var $author$project$Component$Form$Select$viewSelect = function (config) {
	var isEmpty = function (s) {
		return $elm$core$String$isEmpty(s) ? $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing) : $elm$json$Json$Decode$fail('Not empty');
	};
	var decoder = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				isEmpty,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['target', 'value']),
					$elm$json$Json$Decode$string)),
				A2(
				$elm$json$Json$Decode$map,
				config.U6,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['target', 'value']),
					$elm$json$Json$Decode$string))
			]));
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('custom-select')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Events$on,
						'change',
						A2($elm$json$Json$Decode$map, config.WG, decoder))
					]),
				function () {
					var _v0 = config.VT;
					if (_v0.a.$ === 1) {
						var _v1 = _v0.a;
						var xs = _v0.b;
						return A2(
							$elm$core$List$cons,
							A2($author$project$Component$Form$Select$viewDefaultOption, config.nW, config.Uu),
							A2(
								$elm$core$List$map,
								A3($author$project$Component$Form$Select$viewOption, config.Uu, config.WH, config.WI),
								xs));
					} else {
						var x = _v0.a.a;
						var xs = _v0.b;
						return A2(
							$elm$core$List$map,
							A3($author$project$Component$Form$Select$viewOption, config.Uu, config.WH, config.WI),
							A2($elm$core$List$cons, x, xs));
					}
				}())
			]));
};
var $author$project$View$FormV2$toSelectField = F6(
	function (id, label_, fieldName, options, toMsg, currentValue) {
		var toOption = function (option) {
			return _Utils_Tuple2(
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0}-{1}',
					_List_fromArray(
						[
							$author$project$Data$Form$fieldNameToString(fieldName),
							option
						])),
				option);
		};
		var selectOptions = $elm$core$Dict$fromList(
			A2($elm$core$List$map, toOption, options));
		var selectConfig = {
			Uu: $elm$core$Maybe$Just(
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$eq(currentValue),
						$elm$core$Maybe$Just),
					$elm$core$Tuple$first)),
			nW: $elm$core$Maybe$Nothing,
			U6: $elm$core$Maybe$Just,
			VT: _Utils_Tuple2(
				$elm$core$Maybe$Nothing,
				$elm$core$Dict$toList(selectOptions)),
			WG: A2($elm$core$Basics$composeL, toMsg, $author$project$Model$FormFieldValueV2$SelectValue),
			WH: $elm$core$Tuple$second,
			WI: $elm$core$Tuple$second
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-field')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('label'),
							$elm$html$Html$Attributes$for(id)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label_)
						])),
					$author$project$Component$Form$Select$viewSelect(selectConfig)
				]));
	});
var $author$project$View$FormV2$toSelectValue = function (value_) {
	if ((value_.$ === 4) && (!value_.a.$)) {
		var val = value_.a.a;
		return $elm$core$Maybe$Just(val);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$View$FormV2$toSelectWithIdsField = F5(
	function (id, label_, options, toMsg, currentValue) {
		var selectConfig = {
			Uu: $elm$core$Maybe$Just(
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$eq(currentValue),
						$elm$core$Maybe$Just),
					$elm$core$Tuple$first)),
			nW: $elm$core$Maybe$Nothing,
			U6: $elm$core$Maybe$Just,
			VT: _Utils_Tuple2($elm$core$Maybe$Nothing, options),
			WG: A2($elm$core$Basics$composeL, toMsg, $author$project$Model$FormFieldValueV2$SelectValue),
			WH: $elm$core$Tuple$second,
			WI: $elm$core$Tuple$first
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-field')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('label'),
							$elm$html$Html$Attributes$for(id)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label_)
						])),
					$author$project$Component$Form$Select$viewSelect(selectConfig)
				]));
	});
var $author$project$View$FormV2$toTextValue = function (value_) {
	if (!value_.$) {
		var val = value_.a;
		return $elm$core$Maybe$Just(val);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$toValidationError = F2(
	function (key, errorResponse) {
		if (!errorResponse.$) {
			var validationErrors = errorResponse.a;
			return A2(
				$elm$core$Maybe$andThen,
				$elm$core$Dict$get(
					$author$project$Util$LangCode$toString($author$project$Copy$language)),
				A2($elm$core$Dict$get, key, validationErrors.UY));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Data$FormField$unFieldNamesList = function (_v0) {
	var names = _v0;
	return $elm$core$List$concat(names);
};
var $author$project$Component$Form$TextInput$Url = 2;
var $author$project$Component$Form$TextInput$url = $author$project$Component$Form$TextInput$type_(2);
var $author$project$Component$Form$DateInput$value = function (value_) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					dL: $elm$core$Maybe$Just(value_)
				});
		});
};
var $author$project$View$FormV2$value = F4(
	function (config, formInput, extractF, _default) {
		return A2(
			$elm$core$Maybe$withDefault,
			_default,
			A3($author$project$View$FormV2$maybeValue, config, formInput, extractF));
	});
var $author$project$Component$Form$Checkbox$Checkbox = 0;
var $author$project$Component$Form$Checkbox$build = {bJ: false, cr: $elm$core$Maybe$Nothing, nl: _List_Nil, cE: false, bL: $elm$core$Maybe$Nothing, cN: $elm$core$Maybe$Nothing, cO: $elm$core$Maybe$Nothing, cS: false, bj: '', c4: $elm$core$Maybe$Nothing, c8: $elm$core$Maybe$Nothing, aP: 0, dl: false, dH: $elm$core$Maybe$Nothing, dL: $elm$core$Maybe$Nothing};
var $author$project$Component$Form$Checkbox$label = function (label_) {
	return $author$project$Component$Form$Checkbox$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{bj: label_});
		});
};
var $author$project$Component$Form$Checkbox$Switch = 1;
var $author$project$Component$Tooltip$Attribute = $elm$core$Basics$identity;
var $author$project$Component$Tooltip$Tooltip = $elm$core$Basics$identity;
var $author$project$Component$Tooltip$set = function (_with) {
	return function (_v0) {
		var config = _v0;
		return _with(config);
	};
};
var $author$project$Component$Tooltip$content = function (content_) {
	return $author$project$Component$Tooltip$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{cv: content_});
		});
};
var $author$project$Component$Form$Checkbox$generateId = function (labelText) {
	return A2(
		$elm$core$String$join,
		'-',
		$elm$core$String$words(labelText));
};
var $author$project$Component$Tooltip$build = {ck: $elm$core$Maybe$Nothing, cv: _List_Nil, bj: '', cX: false};
var $author$project$Component$Tooltip$label = function (label_) {
	return $author$project$Component$Tooltip$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{bj: label_});
		});
};
var $author$project$Component$Tooltip$viewTooltip = function (_v0) {
	var config = _v0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('tooltip', true),
						_Utils_Tuple2('left', config.cX)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(config.bj)
						])),
				config.ck),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tooltip-container')
					]),
				_List_fromArray(
					[
						$author$project$View$Icon$viewColored($author$project$View$Icon$path.Vg),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('content-tooltip')
							]),
						config.cv)
					]))
			]));
};
var $author$project$Component$Tooltip$view = F2(
	function (name, attributes) {
		return $author$project$Component$Tooltip$viewTooltip(
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v0, b) {
						var attribute = _v0;
						return attribute(b);
					}),
				$author$project$Component$Tooltip$build,
				A2(
					$elm$core$List$cons,
					$author$project$Component$Tooltip$label(name),
					attributes)));
	});
var $author$project$Component$Form$Checkbox$viewTextInput = function (_v0) {
	var config = _v0;
	var maybeAttributes = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2($elm$core$Maybe$map, $elm$html$Html$Events$onCheck, config.c8),
				A2($elm$core$Maybe$map, $elm$html$Html$Attributes$name, config.c4),
				A2($elm$core$Maybe$map, $elm$html$Html$Attributes$value, config.dL)
			]));
	var label_ = function () {
		var _v7 = config.cN;
		if (!_v7.$) {
			var htmlLabel_ = _v7.a;
			return htmlLabel_;
		} else {
			return $elm$html$Html$text(config.bj);
		}
	}();
	var inputClass = function () {
		var _v6 = config.aP;
		if (!_v6) {
			return 'checkbox';
		} else {
			return 'switch';
		}
	}();
	var idValue = function () {
		var _v5 = config.cO;
		if (!_v5.$) {
			var id_ = _v5.a;
			return id_;
		} else {
			return $author$project$Component$Form$Checkbox$generateId(config.bj);
		}
	}();
	var inputAttributes = _List_fromArray(
		[
			$elm$html$Html$Attributes$type_('checkbox'),
			$elm$html$Html$Attributes$disabled(config.cE),
			$elm$html$Html$Attributes$checked(config.bJ),
			$elm$html$Html$Attributes$required(config.dl),
			$elm$html$Html$Attributes$id(idValue),
			$elm$html$Html$Attributes$class(
			A2(
				$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
				'form-{0}',
				_List_fromArray(
					[inputClass]))),
			$elm$html$Html$Attributes$class(
			A2($elm$core$Maybe$withDefault, '', config.cr))
		]);
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-field', true),
						_Utils_Tuple2(
						'error',
						$elm_community$maybe_extra$Maybe$Extra$isJust(config.bL)),
						_Utils_Tuple2('inline', config.cS)
					])),
			config.nl),
		_List_fromArray(
			[
				A2(
				$author$project$Util$View$viewMaybe,
				config.dH,
				function (_v1) {
					var val = _v1.a;
					var values = _v1.b;
					return A2(
						$author$project$Component$Tooltip$view,
						val,
						_List_fromArray(
							[
								$author$project$Component$Tooltip$content(values)
							]));
				}),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('form-field-wrapper', true),
								_Utils_Tuple2('checkbox-container', true),
								_Utils_Tuple2('switch-container', config.aP === 1),
								_Utils_Tuple2('inline', true)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_Utils_ap(inputAttributes, maybeAttributes),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(inputClass)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Util$View$viewIf,
								!config.aP,
								function (_v2) {
									return A2($author$project$View$Icon$viewMasked, 0, $author$project$View$Icon$path.Up);
								}),
								A2(
								$author$project$Util$View$viewIf,
								config.aP === 1,
								function (_v3) {
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('label')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												config.bJ ? $author$project$Copy$copy.VQ : $author$project$Copy$copy.VP)
											]));
								})
							])),
						A2(
						$author$project$Util$View$viewIfNot,
						_Utils_eq(
							label_,
							$elm$html$Html$text('')),
						function (_v4) {
							return A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('label'),
										$elm$html$Html$Attributes$for(idValue)
									]),
								_List_fromArray(
									[label_]));
						})
					])),
				A2(
				$author$project$Util$View$viewMaybe,
				config.bL,
				function (error_) {
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('error-message')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(error_)
							]));
				})
			]));
};
var $author$project$Component$Form$Checkbox$view = F2(
	function (label_, attributes) {
		return $author$project$Component$Form$Checkbox$viewTextInput(
			A3(
				$elm$core$List$foldl,
				function (_v0) {
					var attribute = _v0;
					return attribute;
				},
				$author$project$Component$Form$Checkbox$build,
				A2(
					$elm$core$List$cons,
					$author$project$Component$Form$Checkbox$label(label_),
					attributes)));
	});
var $author$project$Component$Form$DateInput$build = function (today) {
	return {cE: false, be: $elm$core$Maybe$Nothing, cM: false, aH: $elm$core$Maybe$Nothing, cO: $elm$core$Maybe$Nothing, bj: '', c$: 0, c1: 0, c9: $elm$core$Maybe$Nothing, dd: $elm$core$Maybe$Nothing, dl: false, e2: today, dL: $elm$core$Maybe$Nothing};
};
var $author$project$Component$Form$DateInput$label = function (label_) {
	return $author$project$Component$Form$DateInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{bj: label_});
		});
};
var $justinmimbs$date$Date$Years = 0;
var $justinmimbs$date$Date$Months = 1;
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.TQ - 1)) + ($justinmimbs$date$Date$monthToNumber(date.zI) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.nJ,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.F_;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $author$project$Util$Date$decodeDate = function () {
	var toDate = function (s) {
		var _v0 = $justinmimbs$date$Date$fromIsoString(s);
		if (!_v0.$) {
			var date = _v0.a;
			return $elm$json$Json$Decode$succeed(date);
		} else {
			var err = _v0.a;
			return $elm$json$Json$Decode$fail(err);
		}
	};
	return A2($elm$json$Json$Decode$andThen, toDate, $elm$json$Json$Decode$string);
}();
var $author$project$Component$Form$DateInput$generateId = function (labelText) {
	return A2(
		$elm$core$String$join,
		'-',
		$elm$core$String$words(labelText));
};
var $author$project$Component$Form$DateInput$viewDateInput = function (_v0) {
	var config = _v0;
	var toOnInput = function (onInput_) {
		return A2(
			$elm$html$Html$Events$on,
			'input',
			A2(
				$elm$json$Json$Decode$map,
				onInput_,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['target', 'value']),
					$author$project$Util$Date$decodeDate)));
	};
	var placeholder_ = A2($elm$core$Maybe$withDefault, config.bj, config.dd);
	var maybeAttributes = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2($elm$core$Maybe$map, toOnInput, config.c9)
			]));
	var idValue = function () {
		var _v2 = config.cO;
		if (!_v2.$) {
			var id_ = _v2.a;
			return id_;
		} else {
			return $author$project$Component$Form$DateInput$generateId(config.bj);
		}
	}();
	var labelAttrs = _List_fromArray(
		[
			$elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('label', true),
					_Utils_Tuple2('visually-hidden', config.cM)
				])),
			$elm$html$Html$Attributes$for(idValue)
		]);
	var attrs = _List_fromArray(
		[
			$elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('form-field', true),
					_Utils_Tuple2(
					'error',
					$elm_community$maybe_extra$Maybe$Extra$isJust(config.be)),
					_Utils_Tuple2(
					'with-icon',
					$elm_community$maybe_extra$Maybe$Extra$isJust(config.aH))
				]))
		]);
	var _v1 = config.e2;
	var today = _v1;
	var maxDate = A3($justinmimbs$date$Date$add, 0, config.c$, today);
	var minDate = A3($justinmimbs$date$Date$add, 0, config.c1, today);
	var inputAttributes = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('form-input'),
			$elm$html$Html$Attributes$type_('date'),
			$elm$html$Html$Attributes$min(
			$justinmimbs$date$Date$toIsoString(minDate)),
			$elm$html$Html$Attributes$max(
			$justinmimbs$date$Date$toIsoString(maxDate)),
			$elm$html$Html$Attributes$disabled(config.cE),
			$elm$html$Html$Attributes$placeholder(placeholder_),
			$elm$html$Html$Attributes$value(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, config.dL))),
			$elm$html$Html$Attributes$id(idValue),
			$elm$html$Html$Attributes$required(config.dl)
		]);
	return A2(
		$elm$html$Html$div,
		attrs,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				labelAttrs,
				_List_fromArray(
					[
						$elm$html$Html$text(config.bj)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-field-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_Utils_ap(inputAttributes, maybeAttributes),
						_List_Nil),
						A2($author$project$Util$View$viewMaybe, config.aH, $author$project$View$Icon$viewColored)
					])),
				A2($author$project$Util$View$viewMaybe, config.be, $elm$core$Basics$identity)
			]));
};
var $author$project$Component$Form$DateInput$view = F3(
	function (today_, label_, attributes) {
		return $author$project$Component$Form$DateInput$viewDateInput(
			A3(
				$elm$core$List$foldl,
				function (_v0) {
					var attribute = _v0;
					return attribute;
				},
				$author$project$Component$Form$DateInput$build(today_),
				A2(
					$elm$core$List$cons,
					$author$project$Component$Form$DateInput$label(label_),
					attributes)));
	});
var $author$project$Model$Translation$cityPlaceholder = 'city-placeholder';
var $author$project$Model$Translation$houseNumberPlaceholder = 'house-number-placeholder';
var $author$project$Model$Translation$postalCodePlaceholder = 'postal-code-placeholder';
var $author$project$Model$Translation$streetPlaceholder = 'street-placeholder';
var $author$project$View$FormV2$viewAddressFields = function (config) {
	var _v0 = config.cA;
	var addressIsFilled = _v0.a;
	var addressValue = _v0.b;
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-field')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('address-form-row')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Component$Form$TextInput$view,
							config.bj,
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$id('street'),
									$author$project$Component$Form$TextInput$placeholder(
									A2($author$project$Data$Translation$toString, config.P$, $author$project$Model$Translation$streetPlaceholder)),
									$author$project$Component$Form$TextInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										config.WG,
										function (v) {
											return _Utils_Tuple2(
												addressIsFilled,
												_Utils_update(
													addressValue,
													{NV: v}));
										})),
									$author$project$Component$Form$TextInput$value(addressValue.NV),
									$author$project$Component$Form$TextInput$error(config.V),
									$author$project$Component$Form$TextInput$class('street'),
									$author$project$Component$Form$TextInput$hiddenLabel(config.a.Vd),
									$author$project$Component$Form$TextInput$icon($author$project$Data$Icon$path.T6)
								])),
							A2(
							$author$project$Component$Form$TextInput$view,
							'',
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$id('house-number'),
									$author$project$Component$Form$TextInput$placeholder(
									A2($author$project$Data$Translation$toString, config.P$, $author$project$Model$Translation$houseNumberPlaceholder)),
									$author$project$Component$Form$TextInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										config.WG,
										function (v) {
											return _Utils_Tuple2(
												addressIsFilled,
												_Utils_update(
													addressValue,
													{t8: v}));
										})),
									$author$project$Component$Form$TextInput$value(addressValue.t8),
									$author$project$Component$Form$TextInput$error(config.V),
									$author$project$Component$Form$TextInput$class('house-number'),
									$author$project$Component$Form$TextInput$hiddenLabel(config.a.Vd)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('address-form-row')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Component$Form$TextInput$view,
							'',
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$id('postal-code'),
									$author$project$Component$Form$TextInput$placeholder(
									A2($author$project$Data$Translation$toString, config.P$, $author$project$Model$Translation$postalCodePlaceholder)),
									$author$project$Component$Form$TextInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										config.WG,
										function (v) {
											return _Utils_Tuple2(
												addressIsFilled,
												_Utils_update(
													addressValue,
													{Fr: v}));
										})),
									$author$project$Component$Form$TextInput$value(addressValue.Fr),
									$author$project$Component$Form$TextInput$error(config.V),
									$author$project$Component$Form$TextInput$class('postal-code'),
									$author$project$Component$Form$TextInput$hiddenLabel(config.a.Vd),
									$author$project$Component$Form$TextInput$icon($author$project$Data$Icon$path.T6)
								])),
							A2(
							$author$project$Component$Form$TextInput$view,
							'',
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$id('city'),
									$author$project$Component$Form$TextInput$placeholder(
									A2($author$project$Data$Translation$toString, config.P$, $author$project$Model$Translation$cityPlaceholder)),
									$author$project$Component$Form$TextInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										config.WG,
										function (v) {
											return _Utils_Tuple2(
												addressIsFilled,
												_Utils_update(
													addressValue,
													{le: v}));
										})),
									$author$project$Component$Form$TextInput$value(addressValue.le),
									$author$project$Component$Form$TextInput$error(config.V),
									$author$project$Component$Form$TextInput$class('city'),
									$author$project$Component$Form$TextInput$hiddenLabel(config.a.Vd)
								]))
						]))
				]))
		]);
};
var $author$project$View$FormV2$GetAddressWithAutoFill = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$View$FormV2$isDutchPostalCode = function (input) {
	return A2(
		$elm$regex$Regex$contains,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('^[1-9][0-9]{3}( ?[A-Za-z]{2})$')),
		input);
};
var $author$project$Component$Form$TextInput$onBlur = function (msg_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					c7: $elm$core$Maybe$Just(msg_)
				});
		});
};
var $author$project$View$FormV2$viewAddressWithAutoFillFields = function (config) {
	var _v0 = config.cA;
	var addressIsFilled = _v0.a;
	var addressValue = _v0.b;
	var onBlurMsg = ($author$project$View$FormV2$isDutchPostalCode(addressValue.Fr) && (!addressIsFilled)) ? A2(
		$author$project$View$FormV2$GetAddressWithAutoFill,
		addressValue.Fr + (' ' + addressValue.t8),
		A2(
			$elm$core$Basics$composeL,
			config.WG,
			function (_v1) {
				var maybeStreetName = _v1.a;
				var maybeCity = _v1.b;
				return _Utils_Tuple2(
					true,
					_Utils_update(
						addressValue,
						{
							le: A2($elm$core$Maybe$withDefault, addressValue.le, maybeCity),
							NV: A2($elm$core$Maybe$withDefault, addressValue.NV, maybeStreetName)
						}));
			})) : $author$project$View$FormV2$NoOp;
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-field')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('address-with-autofill-form-row')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Component$Form$TextInput$view,
							'',
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$id('postal-code'),
									$author$project$Component$Form$TextInput$placeholder(
									A2($author$project$Data$Translation$toString, config.P$, $author$project$Model$Translation$postalCodePlaceholder)),
									$author$project$Component$Form$TextInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										config.WG,
										function (v) {
											return _Utils_Tuple2(
												_Utils_eq(v, addressValue.Fr),
												_Utils_update(
													addressValue,
													{Fr: v}));
										})),
									$author$project$Component$Form$TextInput$value(addressValue.Fr),
									$author$project$Component$Form$TextInput$error(config.V),
									$author$project$Component$Form$TextInput$class('postal-code'),
									$author$project$Component$Form$TextInput$hiddenLabel(config.a.Vd),
									$author$project$Component$Form$TextInput$icon($author$project$Data$Icon$path.T6),
									$author$project$Component$Form$TextInput$onBlur(onBlurMsg)
								])),
							A2(
							$author$project$Component$Form$TextInput$view,
							'',
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$id('house-number'),
									$author$project$Component$Form$TextInput$placeholder(
									A2($author$project$Data$Translation$toString, config.P$, $author$project$Model$Translation$houseNumberPlaceholder)),
									$author$project$Component$Form$TextInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										config.WG,
										function (v) {
											return _Utils_Tuple2(
												_Utils_eq(v, addressValue.t8),
												_Utils_update(
													addressValue,
													{t8: v}));
										})),
									$author$project$Component$Form$TextInput$value(addressValue.t8),
									$author$project$Component$Form$TextInput$error(config.V),
									$author$project$Component$Form$TextInput$class('house-number'),
									$author$project$Component$Form$TextInput$hiddenLabel(config.a.Vd),
									$author$project$Component$Form$TextInput$onBlur(onBlurMsg)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('address-with-autofill-form-row')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Component$Form$TextInput$view,
							config.bj,
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$id('street'),
									$author$project$Component$Form$TextInput$placeholder(
									A2($author$project$Data$Translation$toString, config.P$, $author$project$Model$Translation$streetPlaceholder)),
									$author$project$Component$Form$TextInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										config.WG,
										function (v) {
											return _Utils_Tuple2(
												addressIsFilled,
												_Utils_update(
													addressValue,
													{NV: v}));
										})),
									$author$project$Component$Form$TextInput$value(addressValue.NV),
									$author$project$Component$Form$TextInput$class('street'),
									$author$project$Component$Form$TextInput$hiddenLabel(config.a.Vd),
									$author$project$Component$Form$TextInput$icon($author$project$Data$Icon$path.T6)
								])),
							A2(
							$author$project$Component$Form$TextInput$view,
							'',
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$id('city'),
									$author$project$Component$Form$TextInput$placeholder(
									A2($author$project$Data$Translation$toString, config.P$, $author$project$Model$Translation$cityPlaceholder)),
									$author$project$Component$Form$TextInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										config.WG,
										function (v) {
											return _Utils_Tuple2(
												addressIsFilled,
												_Utils_update(
													addressValue,
													{le: v}));
										})),
									$author$project$Component$Form$TextInput$value(addressValue.le),
									$author$project$Component$Form$TextInput$class('city'),
									$author$project$Component$Form$TextInput$hiddenLabel(config.a.Vd)
								]))
						]))
				]))
		]);
};
var $author$project$Model$FormFieldValueV2$DaypartAvailabilityValue = function (a) {
	return {$: 7, a: a};
};
var $author$project$Data$Form$allDayparts = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Data$Form$allDayEveryDay = _List_fromArray(
	[
		_Utils_Tuple2(0, $author$project$Data$Form$allDayparts),
		_Utils_Tuple2(1, $author$project$Data$Form$allDayparts),
		_Utils_Tuple2(2, $author$project$Data$Form$allDayparts),
		_Utils_Tuple2(3, $author$project$Data$Form$allDayparts),
		_Utils_Tuple2(4, $author$project$Data$Form$allDayparts),
		_Utils_Tuple2(5, $author$project$Data$Form$allDayparts),
		_Utils_Tuple2(6, $author$project$Data$Form$allDayparts)
	]);
var $author$project$Data$Form$groupedAndOrderedDayparts = function (_v0) {
	var availableParts = _v0.Uh;
	var availableDays = A2($elm$core$List$map, $elm$core$Tuple$first, availableParts);
	var availableDayparts = A2($elm$core$List$map, $elm$core$Tuple$second, availableParts);
	var accumulateDayparts = F3(
		function (dayOfWeek, daypart, acc) {
			return A2(
				$elm$core$List$member,
				_Utils_Tuple2(dayOfWeek, daypart),
				availableParts) ? A2(
				$elm$core$List$cons,
				$elm$core$Maybe$Just(daypart),
				acc) : (A2($elm$core$List$member, daypart, availableDayparts) ? A2($elm$core$List$cons, $elm$core$Maybe$Nothing, acc) : acc);
		});
	var replaceUnavailable = function (_v1) {
		var dayOfWeek = _v1.a;
		var dayparts = _v1.b;
		return A2($elm$core$List$member, dayOfWeek, availableDays) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				dayOfWeek,
				A3(
					$elm$core$List$foldr,
					accumulateDayparts(dayOfWeek),
					_List_Nil,
					dayparts))) : $elm$core$Maybe$Nothing;
	};
	return A2($elm$core$List$filterMap, replaceUnavailable, $author$project$Data$Form$allDayEveryDay);
};
var $author$project$Data$Form$allDaypartsOrdered = function (daypartAvailabilityFieldOptions) {
	var availableDayparts = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2(
			$elm$core$List$concatMap,
			$elm$core$Tuple$second,
			$author$project$Data$Form$groupedAndOrderedDayparts(daypartAvailabilityFieldOptions)));
	return A2(
		$elm$core$List$filter,
		function (x) {
			return A2($elm$core$List$member, x, availableDayparts);
		},
		$author$project$Data$Form$allDayparts);
};
var $author$project$Data$Form$translateDayOfWeek = function (dayOfWeek) {
	switch (dayOfWeek) {
		case 0:
			return $author$project$Copy$copy.zD;
		case 1:
			return $author$project$Copy$copy.P3;
		case 2:
			return $author$project$Copy$copy.Tc;
		case 3:
			return $author$project$Copy$copy.Pi;
		case 4:
			return $author$project$Copy$copy.sp;
		case 5:
			return $author$project$Copy$copy.Jd;
		default:
			return $author$project$Copy$copy.Or;
	}
};
var $author$project$Component$DaypartAvailability$viewDaypartCheckbox = F4(
	function (toMsg, currentValue, dayOfWeek, maybeDaypart) {
		if (maybeDaypart.$ === 1) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('daypart-field-daypart-hole')
					]),
				_List_Nil);
		} else {
			var daypart = maybeDaypart.a;
			var isChecked = A2(
				$elm$core$List$member,
				_Utils_Tuple2(dayOfWeek, daypart),
				currentValue);
			var updateField = function (_v1) {
				return toMsg(
					isChecked ? A2(
						$elm$core$List$filter,
						$elm$core$Basics$neq(
							_Utils_Tuple2(dayOfWeek, daypart)),
						currentValue) : A2(
						$elm$core$List$cons,
						_Utils_Tuple2(dayOfWeek, daypart),
						currentValue));
			};
			return A2(
				$author$project$Component$Form$Checkbox$view,
				'',
				_List_fromArray(
					[
						$author$project$Component$Form$Checkbox$onCheck(updateField),
						$author$project$Component$Form$Checkbox$checked(isChecked)
					]));
		}
	});
var $author$project$Component$DaypartAvailability$viewDayOfWeek = F3(
	function (toMsg, currentValue, _v0) {
		var dayOfWeek = _v0.a;
		var dayparts = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('daypart-field-dayofweek')
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('daypart-field-dayofweek-label label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$String$left,
										2,
										$author$project$Data$Form$translateDayOfWeek(dayOfWeek)))
								]))
						]),
						A2(
						$elm$core$List$map,
						A3($author$project$Component$DaypartAvailability$viewDaypartCheckbox, toMsg, currentValue, dayOfWeek),
						dayparts)
					])));
	});
var $author$project$Data$Form$translateDaypart = function (daypart) {
	switch (daypart) {
		case 0:
			return $author$project$Copy$copy.zL;
		case 1:
			return $author$project$Copy$copy.gc;
		case 2:
			return $author$project$Copy$copy.qr;
		default:
			return $author$project$Copy$copy.A4;
	}
};
var $author$project$Component$DaypartAvailability$viewDaypartLabel = function (daypart) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('daypart-field-daypart-label')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Data$Form$translateDaypart(daypart))
			]));
};
var $author$project$Component$DaypartAvailability$view = F3(
	function (toMsg, availableOptions, currentValue) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('daypart-field-options')
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('daypart-field-daypart-labels')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Component$DaypartAvailability$viewDaypartLabel,
								$author$project$Data$Form$allDaypartsOrdered(availableOptions)))
						]),
						A2(
						$elm$core$List$map,
						A2($author$project$Component$DaypartAvailability$viewDayOfWeek, toMsg, currentValue),
						$author$project$Data$Form$groupedAndOrderedDayparts(availableOptions))
					])));
	});
var $author$project$View$FormV2$viewDaypart = F5(
	function (field, label_, availableOptions, maybeError, currentValue) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-field', true),
							_Utils_Tuple2('af__daypart-field', true),
							_Utils_Tuple2(
							'error',
							$elm_community$maybe_extra$Maybe$Extra$isJust(maybeError))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label_)
						])),
					A3(
					$author$project$Component$DaypartAvailability$view,
					A2(
						$elm$core$Basics$composeL,
						$author$project$View$FormV2$InsertFieldValue(field.c4),
						$author$project$Model$FormFieldValueV2$DaypartAvailabilityValue),
					availableOptions,
					currentValue),
					A2(
					$author$project$Util$View$viewMaybe,
					maybeError,
					function (message) {
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('error-message')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(message)
								]));
					})
				]));
	});
var $author$project$View$FormV2$SelectFile = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$View$FormV2$viewFileField = F6(
	function (labelVal, placeholder, field, options, maybeError, maybeCurrentValue) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('form-field', true),
								_Utils_Tuple2('af__upload-field', true),
								_Utils_Tuple2(
								'error',
								$elm_community$maybe_extra$Maybe$Extra$isJust(maybeError)),
								_Utils_Tuple2(
								'has-cv-file',
								$elm_community$maybe_extra$Maybe$Extra$isJust(maybeCurrentValue))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('label', true),
										_Utils_Tuple2('visually-hidden', field.Vd)
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(labelVal)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('btn btn-outline border-color-2 color-2'),
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$id(
								$author$project$Data$Form$fieldNameToString(field.c4)),
								$elm$html$Html$Events$onClick(
								A2($author$project$View$FormV2$SelectFile, options, field.c4))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(placeholder)
									]))
							])),
						A2(
						$author$project$Util$View$viewMaybe,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.rx;
							},
							maybeCurrentValue),
						function (filename) {
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('upload__file-name'),
										$elm$html$Html$Attributes$title(filename)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(filename)
									]));
						}),
						A2(
						$author$project$Util$View$viewMaybe,
						maybeError,
						function (err) {
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('error-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(err)
									]));
						})
					]))
			]);
	});
var $author$project$View$FormV2$toScreeningQuestionsHtmlFields = F2(
	function (state_, config) {
		var state = state_;
		var toScreeningQuestionValue = F2(
			function (screeningQuestionConfig, val) {
				return {
					c4: $author$project$Model$FormFieldV2$Custom(screeningQuestionConfig.uv),
					dL: val
				};
			});
		var currentValues = A3($author$project$View$FormV2$maybeValue, config, state.w, $author$project$View$FormV2$toScreeningQuestionsValue);
		var currentValue = function (fieldName) {
			return A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.dL;
				},
				A2(
					$pzp1997$assoc_list$AssocList$get,
					fieldName,
					$author$project$View$FormV2$getScreeningQuestionsValueDict(currentValues)));
		};
		return $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (sqConfig) {
					return A2(
						$author$project$View$FormV2$viewFormField,
						state_,
						_Utils_update(
							config,
							{
								a: sqConfig.d8,
								bo: $elm$core$Maybe$Just(
									{
										ez: function (fieldValue) {
											return A2(
												$author$project$View$FormV2$InsertFieldValue,
												config.a.c4,
												$author$project$Model$FormFieldValueV2$ScreeningQuestionValues(
													A3(
														$author$project$View$FormV2$insertScreeningQuestionValue,
														currentValues,
														$author$project$Model$FormFieldV2$Custom(sqConfig.uv),
														A2(toScreeningQuestionValue, sqConfig, fieldValue))));
										},
										c4: $author$project$Model$FormFieldV2$Custom(sqConfig.uv),
										dL: currentValue(
											$author$project$Model$FormFieldV2$Custom(sqConfig.uv))
									})
							}));
				},
				A2($elm$core$List$map, $author$project$View$FormV2$toScreeningQuestionFormField, state.eM)));
	});
var $author$project$View$FormV2$viewFormField = F2(
	function (state_, config) {
		var state = state_;
		var toTranslation = function (val) {
			return A2($author$project$Data$Translation$toString, config.P$, val);
		};
		var toMsg = function (val) {
			return A2(
				$elm$core$Maybe$withDefault,
				A2($author$project$View$FormV2$InsertFieldValue, config.a.c4, val),
				A2(
					$elm$core$Maybe$map,
					function (f) {
						return f.ez(val);
					},
					config.bo));
		};
		var toDefault = F2(
			function (val, def) {
				return $elm$core$String$isEmpty(val) ? toTranslation(def) : val;
			});
		var requiredMessage = A2(
			$elm$core$Maybe$withDefault,
			config.a.UH,
			A2($author$project$View$FormV2$getValueForDomain, state.UL, config.a.Vu));
		var requiredByExport = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.If;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeL,
							$elm$core$Basics$eq(config.a.c4),
							function ($) {
								return $.c4;
							}),
						state.eL))));
		var label_ = A2(
			$elm$core$Maybe$withDefault,
			A2(
				toDefault,
				config.a.UG,
				$author$project$Data$Form$fieldNameToString(config.a.c4) + '-label'),
			A2($author$project$View$FormV2$getValueForDomain, state.UL, config.a.bj));
		var isRequired = A2(
			$elm$core$List$member,
			config.a.c4,
			A3(
				$elm$core$Basics$composeL,
				$author$project$Data$FormField$unFieldNamesList,
				function ($) {
					return $.dl;
				},
				$author$project$Data$Entity$value(state.d7)));
		var optionalField = !(isRequired || requiredByExport);
		var label = optionalField ? A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} ({1})',
			_List_fromArray(
				[label_, $author$project$Copy$copy.Du])) : label_;
		var invalidMessage = A2(
			$elm$core$Maybe$withDefault,
			config.a.UH,
			A2($author$project$View$FormV2$getValueForDomain, state.UL, config.a.Vj));
		var getPlaceholder = A2(
			$elm$core$Maybe$withDefault,
			A2(
				toDefault,
				config.a.UI,
				$author$project$Data$Form$fieldNameToString(config.a.c4) + '-placeholder'),
			A2($author$project$View$FormV2$getValueForDomain, state.UL, config.a.dd));
		var placeholder = optionalField ? A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} ({1})',
			_List_fromArray(
				[getPlaceholder, $author$project$Copy$copy.Du])) : getPlaceholder;
		var fieldName = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Data$Form$fieldNameToString(config.a.c4),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Data$Form$fieldNameToString,
					function ($) {
						return $.c4;
					}),
				config.bo));
		var maybeError = A2($author$project$Api$toValidationError, fieldName, config.e6);
		var errorMessage = function (_v7) {
			return $author$project$View$FormV2$toErrorMessage(
				{cU: invalidMessage, cV: isRequired, V: maybeError, dm: requiredMessage});
		};
		var textInput = function (extraArgs) {
			return A2(
				$author$project$Component$Form$TextInput$view,
				label,
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$Component$Form$TextInput$id(fieldName),
							$author$project$Component$Form$TextInput$placeholder(placeholder),
							$author$project$Component$Form$TextInput$onInput(
							A2($elm$core$Basics$composeL, toMsg, $author$project$Model$FormFieldValueV2$TextValue)),
							$author$project$Component$Form$TextInput$value(
							A4($author$project$View$FormV2$value, config, state.w, $author$project$View$FormV2$toTextValue, '')),
							$author$project$Component$Form$TextInput$error(
							errorMessage($author$project$View$FormV2$toTextValue)),
							$author$project$Component$Form$TextInput$hiddenLabel(config.a.Vd)
						]),
					extraArgs));
		};
		var fieldHtml = function () {
			var _v0 = config.a.dI;
			switch (_v0.$) {
				case 0:
					var addressConfig = {
						cA: A4(
							$author$project$View$FormV2$value,
							config,
							state.w,
							$author$project$View$FormV2$toAdressValue,
							_Utils_Tuple2(
								false,
								{le: '', t8: '', Fr: '', NV: ''})),
						UL: state.UL,
						a: config.a,
						bj: label,
						V: errorMessage($author$project$View$FormV2$toAdressValue),
						WG: A2($elm$core$Basics$composeL, toMsg, $author$project$Model$FormFieldValueV2$AddressValue_),
						P$: config.P$
					};
					return _Utils_eq(config.a.c4, $author$project$Model$FormFieldV2$Address) ? $author$project$View$FormV2$viewAddressFields(addressConfig) : $author$project$View$FormV2$viewAddressWithAutoFillFields(addressConfig);
				case 1:
					return _List_fromArray(
						[
							A2(
							$author$project$Component$Form$Checkbox$view,
							label,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Component$Form$Checkbox$id(fieldName),
										$author$project$Component$Form$Checkbox$required(isRequired),
										$author$project$Component$Form$Checkbox$onCheck(
										A2($elm$core$Basics$composeL, toMsg, $author$project$Model$FormFieldValueV2$BoolValue)),
										$author$project$Component$Form$Checkbox$checked(
										A4($author$project$View$FormV2$value, config, state.w, $author$project$View$FormV2$toBoolValue, false)),
										$author$project$Component$Form$Checkbox$error(
										errorMessage($author$project$View$FormV2$toBoolValue))
									]),
								A2(
									$elm$core$List$filterMap,
									$elm$core$Basics$identity,
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$map,
											$author$project$Component$Form$Checkbox$htmlLabel,
											A5($author$project$View$FormV2$toPrivacyLabel, state.UL, config.P$, config.bs, config.a.c4, config.a.bj))
										]))))
						]);
				case 2:
					var content = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Data$Content$View$view,
							{gx: false, Q9: false},
							content)
						]);
				case 3:
					var options = _v0.a;
					var val = A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeL, $elm$core$List$singleton, $author$project$Component$Form$DateInput$value),
							A3($author$project$View$FormV2$maybeValue, config, state.w, $author$project$View$FormV2$toDateValue)));
					var attributes = _Utils_ap(
						_List_fromArray(
							[
								$author$project$Component$Form$DateInput$id(fieldName),
								$author$project$Component$Form$DateInput$maxOffsetFromTodayInYears(options.c1),
								$author$project$Component$Form$DateInput$minOffsetFromTodayInYears(options.c$),
								$author$project$Component$Form$DateInput$onInput(
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, toMsg, $author$project$Model$FormFieldValueV2$DateValue),
									$elm$core$Maybe$Just)),
								$author$project$Component$Form$DateInput$error(
								errorMessage($author$project$View$FormV2$toDateValue)),
								$author$project$Component$Form$DateInput$icon($author$project$Data$Icon$path.nI),
								$author$project$Component$Form$DateInput$hiddenLabel(config.a.Vd)
							]),
						val);
					return _List_fromArray(
						[
							A3($author$project$Component$Form$DateInput$view, config.e2, label, attributes)
						]);
				case 4:
					var options = _v0.a;
					return _List_fromArray(
						[
							A5(
							$author$project$View$FormV2$viewDaypart,
							config.a,
							label,
							options,
							errorMessage($author$project$View$FormV2$toDaypartValue),
							A4($author$project$View$FormV2$value, config, state.w, $author$project$View$FormV2$toDaypartValue, _List_Nil))
						]);
				case 10:
					return _List_fromArray(
						[
							textInput(
							function () {
								var _v1 = config.a.c4;
								switch (_v1.$) {
									case 16:
										return _List_fromArray(
											[
												$author$project$Component$Form$TextInput$icon($author$project$Data$Icon$path.VW)
											]);
									case 28:
										return _List_fromArray(
											[
												$author$project$Component$Form$TextInput$icon($author$project$Data$Icon$path.VW)
											]);
									case 40:
										return _List_fromArray(
											[
												$author$project$Component$Form$TextInput$icon($author$project$Data$Icon$path.aM)
											]);
									case 6:
										return _List_fromArray(
											[
												$author$project$Component$Form$TextInput$icon($author$project$Data$Icon$path.T6)
											]);
									default:
										return _List_Nil;
								}
							}())
						]);
				case 5:
					return _List_fromArray(
						[
							textInput(
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$email,
									$author$project$Component$Form$TextInput$icon($author$project$Data$Icon$path.d4)
								]))
						]);
				case 6:
					var fileOptions = _v0.a;
					return A6(
						$author$project$View$FormV2$viewFileField,
						label,
						getPlaceholder,
						config.a,
						fileOptions,
						errorMessage($author$project$View$FormV2$toFileValue),
						A3($author$project$View$FormV2$maybeValue, config, state.w, $author$project$View$FormV2$toFileValue));
				case 7:
					var _v2 = A4(
						$author$project$View$FormV2$value,
						config,
						state.w,
						$author$project$View$FormV2$toPhoneWithCallingCodeValue,
						_Utils_Tuple2(config.UE, ''));
					var code = _v2.a;
					var p = _v2.b;
					var selectConfig = {
						Uu: $elm$core$Maybe$Just(
							$elm$core$Basics$eq(code)),
						U6: $author$project$Model$CountryCallingCode$fromString,
						VT: function () {
							var _v3 = A2($elm$core$List$sortBy, $author$project$Model$CountryCallingCode$toString, $author$project$Model$CountryCallingCode$all);
							if (_v3.b) {
								var hd = _v3.a;
								var rest = _v3.b;
								return _Utils_Tuple2(hd, rest);
							} else {
								return _Utils_Tuple2(code, $author$project$Model$CountryCallingCode$all);
							}
						}(),
						WG: A2(
							$elm$core$Basics$composeL,
							toMsg,
							A2($author$project$Util$Base$flip, $author$project$Model$FormFieldValueV2$PhoneNumberWithCallingCodeValue, p)),
						WH: $author$project$Data$CountryCallingCode$formatWithCountryName,
						WI: $author$project$Model$CountryCallingCode$toString
					};
					return _List_fromArray(
						[
							A2(
							$author$project$Component$Form$TextInput$view,
							label,
							_List_fromArray(
								[
									$author$project$Component$Form$TextInput$id(fieldName),
									$author$project$Component$Form$TextInput$extraHtml(
									$author$project$Component$Form$SelectNonEmpty$viewSelect(selectConfig)),
									$author$project$Component$Form$TextInput$placeholder(placeholder),
									$author$project$Component$Form$TextInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										toMsg,
										$author$project$Model$FormFieldValueV2$PhoneNumberWithCallingCodeValue(code))),
									$author$project$Component$Form$TextInput$value(p),
									$author$project$Component$Form$TextInput$error(
									errorMessage($author$project$View$FormV2$toPhoneWithCallingCodeValue)),
									$author$project$Component$Form$TextInput$phone,
									$author$project$Component$Form$TextInput$icon($author$project$Data$Icon$path.aM),
									$author$project$Component$Form$TextInput$class('phone with-calling-code')
								]))
						]);
				case 13:
					return A2($author$project$View$FormV2$toScreeningQuestionsHtmlFields, state_, config);
				case 8:
					var options = _v0.a;
					return _List_fromArray(
						[
							A6(
							$author$project$View$FormV2$toSelectField,
							fieldName,
							label,
							config.a.c4,
							options,
							toMsg,
							A3($author$project$View$FormV2$maybeValue, config, state.w, $author$project$View$FormV2$toSelectValue))
						]);
				case 9:
					var options = _v0.a;
					return _List_fromArray(
						[
							A5(
							$author$project$View$FormV2$toSelectWithIdsField,
							fieldName,
							label,
							options,
							toMsg,
							A3($author$project$View$FormV2$maybeValue, config, state.w, $author$project$View$FormV2$toSelectValue))
						]);
				case 11:
					return _List_fromArray(
						[
							A2(
							$author$project$Component$Form$TextArea$view,
							label,
							_List_fromArray(
								[
									$author$project$Component$Form$TextArea$id(fieldName),
									$author$project$Component$Form$TextArea$required(isRequired),
									$author$project$Component$Form$TextArea$placeholder(placeholder),
									$author$project$Component$Form$TextArea$onInput(
									A2($elm$core$Basics$composeL, toMsg, $author$project$Model$FormFieldValueV2$TextValue)),
									$author$project$Component$Form$TextArea$value(
									A4($author$project$View$FormV2$value, config, state.w, $author$project$View$FormV2$toTextValue, '')),
									$author$project$Component$Form$TextArea$error(
									errorMessage($author$project$View$FormV2$toTextValue))
								]))
						]);
				default:
					switch (_v0.a) {
						case 2:
							var _v4 = _v0.a;
							return _List_fromArray(
								[
									textInput(
									_List_fromArray(
										[
											$author$project$Component$Form$TextInput$url,
											$author$project$Component$Form$TextInput$icon($author$project$Data$Icon$path.xM)
										]))
								]);
						case 1:
							var _v5 = _v0.a;
							return _List_fromArray(
								[
									textInput(
									_List_fromArray(
										[
											$author$project$Component$Form$TextInput$url,
											$author$project$Component$Form$TextInput$icon($author$project$Data$Icon$path.TN)
										]))
								]);
						default:
							var _v6 = _v0.a;
							return _List_fromArray(
								[
									textInput(
									_List_fromArray(
										[
											$author$project$Component$Form$TextInput$url,
											$author$project$Component$Form$TextInput$icon($author$project$Data$Icon$path.xv)
										]))
								]);
					}
			}
		}();
		return fieldHtml;
	});
var $author$project$View$FormV2$viewFormRow = F8(
	function (requiredFields, state, translations_, validationResponse, today, privacyPagePath, rowIndex, fields) {
		var state_ = state;
		var fieldNames = A2(
			$elm$core$List$map,
			function ($) {
				return $.c4;
			},
			fields);
		var config = F2(
			function (colIndex, field) {
				return {lI: colIndex, UE: state_.UE, a: field, bo: $elm$core$Maybe$Nothing, bs: privacyPagePath, IG: rowIndex, e2: today, P$: translations_, e6: validationResponse};
			});
		var formFields = A3(
			$author$project$View$FormV2$intersperseOneOrMoreRow,
			fields,
			requiredFields,
			$elm$core$List$concat(
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, field) {
							return A2(
								$author$project$View$FormV2$viewFormField,
								state,
								A2(config, index, field));
						}),
					fields)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-row', true),
							_Utils_Tuple2(
							'joined',
							A2($author$project$View$FormV2$toRowStyle, requiredFields, fields) === 1),
							_Utils_Tuple2(
							'combined',
							A2($author$project$View$FormV2$toRowStyle, requiredFields, fields) === 3),
							_Utils_Tuple2(
							'align-flex-end',
							A2($author$project$View$FormV2$toRowStyle, requiredFields, fields) === 2),
							_Utils_Tuple2(
							'has-screening-questions',
							A2($elm$core$List$member, $author$project$Model$FormFieldV2$ScreeningQuestions, fieldNames))
						]))
				]),
			formFields);
	});
var $author$project$Data$Status$isLoading = function (status) {
	if (status.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Model$Translation$submitForm = 'submit-form';
var $author$project$View$FormV2$viewFormSubmitButton = F3(
	function (status, translations, buttonOverwriteText) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-field')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-submit bg-color-1 color-white'),
									$elm$html$Html$Attributes$type_('submit'),
									$elm$html$Html$Attributes$disabled(
									$author$project$Data$Status$isLoading(status))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$withDefault,
											A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$submitForm),
											A2(
												$elm$core$Maybe$map,
												function (t) {
													return $elm$html$Html$text(t);
												},
												buttonOverwriteText))
										]))
								]))
						]))
				]));
	});
var $author$project$Model$Translation$submitFormSuccessMessage = 'submit-form-success-message';
var $author$project$View$FormV2$viewFormSubmitSuccessMessage = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-submit-success-message')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Data$Translation$text, translations, $author$project$Model$Translation$submitFormSuccessMessage)
							]))
					]))
			]));
};
var $author$project$View$FormV2$viewHttpError = function (submitStatus_) {
	if ((submitStatus_.$ === 2) && (submitStatus_.a.$ === 1)) {
		var err = submitStatus_.a.a;
		var _v1 = $author$project$Util$Translation$httpError(err);
		var description = _v1.cD;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-http-error')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								]))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$View$FormV2$viewSubmitProgress = function (_v0) {
	var progress = _v0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-submit-progress')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-submit-progress-bar'),
								A2(
								$elm$html$Html$Attributes$style,
								'transform',
								A2(
									$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
									'translate({0}%,0)',
									_List_fromArray(
										[
											$elm$core$String$fromFloat((progress - 1) * 100)
										])))
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$View$FormV2$view = F2(
	function (config, state) {
		var state_ = state;
		var validationResponse = function () {
			var _v4 = state_.aU;
			if ((_v4.$ === 2) && (!_v4.a.$)) {
				var err = _v4.a.a;
				return $elm$core$Maybe$Just(err);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v0 = state_.d7;
		var form = _v0.b;
		var _v1 = form.rn;
		var fields = _v1;
		return A2(
			$elm$html$Html$map,
			config.xp,
			A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Events$onSubmit($author$project$View$FormV2$SubmitForm),
						$elm$html$Html$Attributes$class('form'),
						$elm$html$Html$Attributes$name('apply-form')
					]),
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$indexedMap,
							A6($author$project$View$FormV2$viewFormRow, form.dl, state, config.P$, validationResponse, config.e2, config.bs),
							fields),
							_List_fromArray(
							[
								A2($author$project$Util$View$viewMaybe, state_.aw, $author$project$View$FormV2$viewSubmitProgress),
								A2(
								$author$project$Util$View$viewIf,
								$author$project$Data$Status$isSuccess(state_.aU),
								function (_v2) {
									return $author$project$View$FormV2$viewFormSubmitSuccessMessage(config.P$);
								}),
								$author$project$View$FormV2$viewHttpError(state_.aU),
								A2(
								$author$project$Util$View$viewIfNot,
								$author$project$Data$Status$isSuccess(state_.aU),
								function (_v3) {
									return A3($author$project$View$FormV2$viewFormSubmitButton, state_.aU, config.P$, config.a3);
								})
							])
						]))));
	});
var $author$project$View$ChatBot$viewForm = F3(
	function (today, _v0, formData) {
		var vacancy = _v0.RH;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('form-node'),
					$elm$html$Html$Attributes$class('chatbot-node-form')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-node-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Data$Entity$value(vacancy).WC)
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$View$ChatBot$CloseForm)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('x')
								]))
						])),
					A2(
					$author$project$View$FormV2$view,
					{
						a3: $elm$core$Maybe$Nothing,
						xp: $author$project$View$ChatBot$FormMsg,
						bs: A2(
							$elm$core$Maybe$withDefault,
							'/',
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeL,
									A2(
										$elm$core$Basics$composeL,
										$author$project$Util$Url$joinPath,
										function ($) {
											return $.Ex;
										}),
									$author$project$Data$Entity$value),
								formData.dh)),
						e2: today,
						P$: formData.P$
					},
					formData.bP)
				]));
	});
var $author$project$View$ChatBot$OnVacancySelect = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $author$project$Data$Metadata$hoursToString = F3(
	function (langCode, mMinHours, mMaxHours) {
		var toHourTranslation = function (hours) {
			return ((langCode === 14) || (!hours)) ? $author$project$Copy$copy.t$ : $author$project$Copy$copy.t1;
		};
		var _v0 = _Utils_Tuple2(mMinHours, mMaxHours);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var minHours = _v0.a.a;
				var maxHours = _v0.b.a;
				return _Utils_eq(minHours, maxHours) ? A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0} {1} {2}',
					_List_fromArray(
						[
							$author$project$Copy$copy.yS,
							$elm$core$String$fromFloat(maxHours),
							toHourTranslation(maxHours)
						])) : A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0} - {1} {2}',
					_List_fromArray(
						[
							$elm$core$String$fromFloat(minHours),
							$elm$core$String$fromFloat(maxHours),
							toHourTranslation(maxHours)
						]));
			} else {
				var minHours = _v0.a.a;
				var _v2 = _v0.b;
				return A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0} {1} {2}',
					_List_fromArray(
						[
							$author$project$Copy$copy.zp,
							$elm$core$String$fromFloat(minHours),
							toHourTranslation(minHours)
						]));
			}
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var maxHours = _v0.b.a;
				return A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0} {1} {2}',
					_List_fromArray(
						[
							$author$project$Copy$copy.yS,
							$elm$core$String$fromFloat(maxHours),
							toHourTranslation(maxHours)
						]));
			} else {
				var _v3 = _v0.a;
				var _v4 = _v0.b;
				return '';
			}
		}
	});
var $elm$html$Html$i = _VirtualDom_node('i');
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $author$project$View$ChatBot$viewVacancyItem = F4(
	function (nodeId, langCode, distanceInfo, searchResult) {
		var _v0 = searchResult.RH;
		var vacancyId = _v0.a;
		var vacancy = _v0.b;
		var findDistanceInfo = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$eq(vacancyId),
					function ($) {
						return $.R6;
					}),
				distanceInfo));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('chatbot-node-vacancy')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(vacancy.WC)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('chatbot-node-vacancy-metadata')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Util$View$viewMaybe,
							searchResult.eq,
							function (_v1) {
								var location = _v1.b;
								return A2(
									$author$project$Util$View$viewIfNot,
									$elm$core$String$isEmpty(location.le),
									function (_v2) {
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(location.le)
												]));
									});
							}),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3($author$project$Data$Metadata$hoursToString, langCode, vacancy.eu, vacancy.er))
								])),
							A2(
							$author$project$Util$View$viewMaybe,
							findDistanceInfo,
							function (info) {
								return A2(
									$elm$html$Html$i,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromFloat(info.oN)),
											$elm$html$Html$text('km')
										]));
							})
						])),
					A2(
					$elm$html$Html$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(
									A2(
										$elm$url$Url$Builder$absolute,
										_List_fromArray(
											['v', vacancy.qO]),
										_List_Nil)),
									$elm$html$Html$Attributes$target('_blank'),
									$elm$html$Html$Attributes$class('link color-2'),
									$elm$html$Html$Attributes$rel('noopener noreferrer')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Copy$copy.GM)
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$class('bg-color-1 color-white'),
									$elm$html$Html$Events$onClick(
									A2(
										$author$project$View$ChatBot$OnVacancySelect,
										nodeId,
										$author$project$Data$Entity$id(searchResult.RH)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Copy$copy.hA)
								]))
						]))
				]));
	});
var $author$project$View$ChatBot$viewVacancyOverviewSettings = F6(
	function (domainId, langCode, today, node, settings, data) {
		var findVacancy = function (vacancyId) {
			return A2(
				$elm$core$Basics$composeL,
				$elm$core$List$head,
				$elm$core$List$filter(
					A2(
						$elm$core$Basics$composeL,
						A2(
							$elm$core$Basics$composeL,
							$elm$core$Basics$eq(vacancyId),
							$author$project$Data$Entity$id),
						function ($) {
							return $.RH;
						})));
		};
		var toJobApplicationFormData = function (vacancies) {
			return A2(
				$elm$core$Maybe$andThen,
				function (formData) {
					return A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$pair(formData),
						A2(findVacancy, formData.R6, vacancies));
				},
				data.D);
		};
		var _v0 = A2($author$project$Dict$Custom$get, node.cO, data.ad);
		if ((!_v0.$) && (_v0.a.$ === 3)) {
			var _v1 = _v0.a.a;
			var results = _v1.b;
			return _List_fromArray(
				[
					A2(
					$author$project$Util$View$viewIf,
					settings.UR,
					function (_v2) {
						var _v3 = data.ah;
						if (_v3.$ === 1) {
							return A2(
								$author$project$View$LocationSuggestions$view,
								A3($author$project$View$ChatBot$locationSuggestionsConfig, domainId, node.cO, data.av),
								$author$project$View$LocationSuggestions$init);
						} else {
							var _v4 = _v3.a;
							var currentNodeId = _v4.a;
							var currentLocationSuggestions = _v4.b;
							return _Utils_eq(node.cO, currentNodeId) ? A2(
								$author$project$View$LocationSuggestions$view,
								A3($author$project$View$ChatBot$locationSuggestionsConfig, domainId, node.cO, data.av),
								currentLocationSuggestions) : A2(
								$author$project$View$LocationSuggestions$view,
								A3($author$project$View$ChatBot$locationSuggestionsConfig, domainId, node.cO, data.av),
								$author$project$View$LocationSuggestions$init);
						}
					}),
					$elm$core$List$isEmpty(results.RE) ? A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$Copy$copy.Ck)
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('chatbot-node-vacancies')
						]),
					A2(
						$elm$core$List$map,
						A3($author$project$View$ChatBot$viewVacancyItem, node.cO, langCode, results.oO),
						results.RE)),
					A2(
					$author$project$Util$View$viewIf,
					_Utils_cmp(results.PG, $author$project$View$ChatBot$maxResults) > 0,
					function (_v5) {
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('chatbot-node-vacancies-more btn bg-color-1 color-white'),
									$elm$html$Html$Attributes$href(results.D$)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
										'{0} ({1}) →',
										_List_fromArray(
											[
												$author$project$Copy$copy.SR,
												$elm$core$String$fromInt(results.PG)
											])))
								]));
					}),
					A2(
					$author$project$Util$View$viewMaybe,
					toJobApplicationFormData(results.RE),
					function (_v6) {
						var formData = _v6.a;
						var vacancy = _v6.b;
						return A2(
							$author$project$Util$View$viewIf,
							_Utils_eq(node.cO, formData.ar),
							function (_v7) {
								return A3(
									$author$project$Data$Status$withStatus,
									formData.bP,
									$elm$html$Html$text(''),
									A2($author$project$View$ChatBot$viewForm, today, vacancy));
							});
					})
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$View$ChatBot$viewVideoNode = function (path) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$video,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$controls(true),
					$elm$html$Html$Attributes$src(path)
				]),
			_List_Nil)
		]);
};
var $author$project$View$ChatBot$viewNode = F6(
	function (domainId, langCode, today, maybeAvatar, data, node) {
		var isNextNode = _Utils_eq(
			$author$project$View$ChatBot$nextNode(data),
			$elm$core$Maybe$Just(node));
		var display = (isNextNode || A2(
			$elm$core$Set$member,
			$author$project$Data$ChatBot$idToInt(node.cO),
			data.bt)) ? A2($elm$html$Html$Attributes$style, 'display', 'inline-flex') : A2($elm$html$Html$Attributes$style, 'display', 'none');
		return A3(
			$elm$html$Html$Keyed$node,
			'div',
			_List_fromArray(
				[
					display,
					$elm$html$Html$Attributes$class('chatbot-node-wrapper'),
					$elm$html$Html$Attributes$class(
					$author$project$View$ChatBot$nodeClassName(node.bq))
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'avatar',
					A2($author$project$View$ChatBot$viewNodeAvatar, node.bq, maybeAvatar)),
					isNextNode ? _Utils_Tuple2(
					'loading',
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fade-in chatbot-node chatbot-loading-node')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('...')
							]))) : A2(
					$elm$core$Tuple$pair,
					'node',
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('appear appear-delay chatbot-node')
							]),
						function () {
							var _v0 = node.bq;
							switch (_v0.$) {
								case 0:
									var content = _v0.a;
									return A2($author$project$View$ChatBot$viewOptionNode, node, content);
								case 4:
									if (!_v0.a.$) {
										var salaryCalculatorId = _v0.a.a;
										return A4(
											$author$project$View$ChatBot$viewSalaryCalculatorNode,
											node,
											A3(
												$author$project$View$ChatBot$salaryCalculatorInputWithFallback,
												$elm$core$Maybe$Just(salaryCalculatorId),
												data,
												node.cO),
											salaryCalculatorId,
											data.aR);
									} else {
										return _List_fromArray(
											[
												$elm$html$Html$text($author$project$Copy$copy.B4)
											]);
									}
								case 3:
									var settings = _v0.a;
									return A6($author$project$View$ChatBot$viewVacancyOverviewSettings, domainId, langCode, today, node, settings, data);
								case 1:
									var content = _v0.a;
									return A3($author$project$View$ChatBot$viewTextNode, node, data, content);
								case 2:
									var settings = _v0.a;
									return $author$project$View$ChatBot$viewLinkNode(settings);
								case 5:
									var path = _v0.a;
									return $author$project$View$ChatBot$viewImageNode(path);
								case 6:
									var path = _v0.a;
									return $author$project$View$ChatBot$viewVideoNode(path);
								case 7:
									return _List_Nil;
								default:
									return _List_Nil;
							}
						}()))
				]));
	});
var $author$project$View$ChatBot$viewChat = F6(
	function (domainId, langCode, today, currentNodesOnly, maybeAvatar, data) {
		var toChatBot = currentNodesOnly ? $author$project$Data$ChatBot$current(data.kT) : $author$project$Data$ChatBot$currentAndBefore(data.kT);
		var keyedNode = function (node) {
			return _Utils_Tuple2(
				$elm$core$String$fromInt(
					$author$project$Data$ChatBot$idToInt(node.cO)),
				A6($author$project$View$ChatBot$viewNode, domainId, langCode, today, maybeAvatar, data, node));
		};
		return A3(
			$elm$html$Html$Keyed$node,
			'div',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('chat-nodes'),
					$elm$html$Html$Attributes$class('chatbot-nodes')
				]),
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeL, keyedNode, $zwilias$elm_rosetree$Tree$label),
				toChatBot));
	});
var $author$project$View$ChatBot$view = F7(
	function (lift, domainId, langCode, today, currentNodesOnly, maybeAvatar, model) {
		var onScroll = $author$project$ScrollToInElement$isScrolling(model.O) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$Events$on,
				'wheel',
				$elm$json$Json$Decode$succeed($author$project$View$ChatBot$CancelScroll))
			]) : _List_Nil;
		return A2(
			$elm$html$Html$map,
			lift,
			A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$id('chat'),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('chatbot'),
						onScroll)),
				_List_fromArray(
					[
						A6($author$project$View$ChatBot$viewChat, domainId, langCode, today, currentNodesOnly, maybeAvatar, model)
					])));
	});
var $author$project$RecruitmentChat$viewOpenChatBot = function (_v0) {
	var botAvatar = _v0.jE;
	var background = function () {
		if (botAvatar.$ === 1) {
			return $elm$html$Html$Attributes$class('no-avatar');
		} else {
			var avatar = botAvatar.a;
			return A2(
				$elm$html$Html$Attributes$style,
				'background-image',
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'url(\'{0}\')',
					_List_fromArray(
						[avatar])));
		}
	}();
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$RecruitmentChat$ShowChatBot),
				$elm$html$Html$Attributes$class('recruitment-chat-open-button'),
				background,
				$elm$html$Html$Attributes$title($author$project$Copy$copy.GA),
				A2($elm$html$Html$Attributes$attribute, 'aria-label', $author$project$Copy$copy.GA)
			]),
		_List_Nil);
};
var $author$project$RecruitmentChat$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('recruitment-chat-inner-wrapper', true),
						_Utils_Tuple2(
						'recruitment-chat-is-open',
						A2($elm$core$Maybe$withDefault, false, model.ak))
					]))
			]),
		_List_fromArray(
			[
				$author$project$RecruitmentChat$viewOpenChatBot(model.GA),
				A2(
				$author$project$Util$View$viewIf,
				A2(
					$elm$core$List$all,
					$elm$core$Basics$eq(true),
					_List_fromArray(
						[
							model.dy,
							$elm_community$maybe_extra$Maybe$Extra$isNothing(model.ak),
							!$elm$core$String$isEmpty(model.GA.bS)
						])),
				function (_v0) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('recruitment-chat-introduction')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(model.GA.bS),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('icon-btn bg-color-2'),
										$elm$html$Html$Events$onClick($author$project$RecruitmentChat$HideIntroduction),
										$elm$html$Html$Attributes$type_('button')
									]),
								_List_fromArray(
									[
										$author$project$View$Icon$viewColored($author$project$View$Icon$path.VK)
									]))
							]));
				}),
				A2(
				$author$project$Util$View$viewIf,
				A2($elm$core$Maybe$withDefault, false, model.ak) && $author$project$Browser$Dom$Breakpoint$isMobile(model.ch),
				function (_v1) {
					return A3(
						$elm$html$Html$node,
						'style',
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('body { overflow-y: hidden; }')
							]));
				}),
				A2(
				$author$project$Util$View$viewIf,
				A2($elm$core$Maybe$withDefault, false, model.ak) || model.an,
				function (_v2) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('recruitment-chat-header')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(model.GA.WC)
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$RecruitmentChat$ResetChat),
										$elm$html$Html$Attributes$class('recruitment-chat-close-button refresh')
									]),
								_List_fromArray(
									[
										$author$project$View$Icon$viewColored($author$project$View$Icon$path.h3)
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$RecruitmentChat$HideChatBot),
										$elm$html$Html$Attributes$class('recruitment-chat-close-button')
									]),
								_List_fromArray(
									[
										$author$project$View$Icon$viewColored($author$project$View$Icon$path.VK)
									]))
							]));
				}),
				A2(
				$author$project$Util$View$viewIf,
				A2($elm$core$Maybe$withDefault, false, model.ak),
				function (_v3) {
					return A7($author$project$View$ChatBot$view, $author$project$RecruitmentChat$ChatBotMsg, model.cF, model.wS, model.e2, model.an, model.GA.jE, model.kT);
				})
			]));
};
var $author$project$RecruitmentChat$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$RecruitmentChat$decodeFlags,
	{cR: $author$project$RecruitmentChat$init, dC: $author$project$RecruitmentChat$subscriptions, dJ: $author$project$RecruitmentChat$update, dM: $author$project$RecruitmentChat$view});
var $author$project$View$LocationSearch$Flags = F3(
	function (domainKey, sessionToken, location) {
		return {UL: domainKey, eq: location, av: sessionToken};
	});
var $author$project$View$LocationSearch$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sessionToken',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'domainKey',
			$author$project$Data$Id$decoder,
			$elm$json$Json$Decode$succeed($author$project$View$LocationSearch$Flags))));
var $author$project$LocationSearch$LocationSearchMsg = $elm$core$Basics$identity;
var $author$project$View$LocationSearch$init = function (flags) {
	var location = A2(
		$elm$core$Maybe$withDefault,
		A3($lydell$elm_app_url$AppUrl$AppUrl, _List_Nil, $elm$core$Dict$empty, $elm$core$Maybe$Nothing),
		A2(
			$elm$core$Maybe$map,
			$lydell$elm_app_url$AppUrl$fromUrl,
			$elm$url$Url$fromString(flags.eq)));
	return _Utils_Tuple2(
		{
			UL: flags.UL,
			eq: location,
			ah: $author$project$View$LocationSuggestions$init,
			av: $elm$core$Maybe$Just(flags.av)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$LocationSearch$init = function (flags) {
	var _v0 = $author$project$View$LocationSearch$init(flags);
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		{wI: model},
		A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
};
var $author$project$View$LocationSearch$LocationSuggestionsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$LocationSearch$toUrl = F2(
	function (url, location) {
		return $lydell$elm_app_url$AppUrl$toString(
			_Utils_update(
				url,
				{
					b3: A3(
						$elm$core$Dict$insert,
						'location',
						_List_fromArray(
							[location]),
						url.b3)
				}));
	});
var $author$project$View$LocationSearch$locationSuggestionsConfig = function (model) {
	return {
		cr: '',
		cF: model.UL,
		xp: $author$project$View$LocationSearch$LocationSuggestionsMsg,
		Wh: 1,
		av: model.av,
		Wv: $author$project$View$Autocomplete$Http$Link(
			{
				Wt: A2(
					$elm$core$Basics$composeL,
					$author$project$View$LocationSearch$toUrl(model.eq),
					function ($) {
						return $.Vn;
					}),
				PL: $elm$core$Maybe$Nothing
			}),
		e4: 'location-suggestion'
	};
};
var $author$project$View$LocationSearch$subscriptions = F2(
	function (lift, model) {
		return A2(
			$elm$core$Platform$Sub$map,
			lift,
			$elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$author$project$View$LocationSuggestions$subscriptions,
						$author$project$View$LocationSearch$locationSuggestionsConfig(model),
						model.ah)
					])));
	});
var $author$project$LocationSearch$subscriptions = function (model) {
	return A2($author$project$View$LocationSearch$subscriptions, $elm$core$Basics$identity, model.wI);
};
var $author$project$View$LocationSearch$update = F2(
	function (msg, model) {
		if (!msg.$) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var locationSuggestionsMsg = msg.a;
			var _v1 = A3(
				$author$project$View$LocationSuggestions$update,
				$author$project$View$LocationSearch$locationSuggestionsConfig(model),
				locationSuggestionsMsg,
				model.ah);
			var locationSuggestionsModel = _v1.a;
			var locationSuggestionsCmds = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{ah: locationSuggestionsModel}),
				locationSuggestionsCmds);
		}
	});
var $author$project$LocationSearch$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A2($author$project$View$LocationSearch$update, subMsg, model.wI);
		var model_ = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{wI: model_}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$View$LocationSearch$OnSubmit = {$: 0};
var $author$project$View$LocationSearch$view = function (model) {
	var msg = $elm$json$Json$Decode$succeed(
		{bp: $author$project$View$LocationSearch$OnSubmit, V1: true, Wo: true});
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-bar-content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-search'),
						A2($elm$html$Html$Events$custom, 'submit', msg)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$View$LocationSuggestions$view,
						$author$project$View$LocationSearch$locationSuggestionsConfig(model),
						model.ah),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('submit'),
								$elm$html$Html$Attributes$class('btn btn-submit bg-color-1 color-white')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text($author$project$Copy$copy.SU)
									]))
							]))
					]))
			]));
};
var $author$project$LocationSearch$view = function (model) {
	return A2(
		$elm$html$Html$map,
		$elm$core$Basics$identity,
		$author$project$View$LocationSearch$view(model.wI));
};
var $author$project$LocationSearch$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$View$LocationSearch$flagsDecoder,
	{cR: $author$project$LocationSearch$init, dC: $author$project$LocationSearch$subscriptions, dJ: $author$project$LocationSearch$update, dM: $author$project$LocationSearch$view});
var $author$project$Model$Component$KeywordSearch$Flags$Flags = F9(
	function (totalVacancies, formSubmitPath, domainId, activeSearchFields, filterOptions, sessionToken, location, vacancySearchLocationEnabled, langCode) {
		return {fu: activeSearchFields, cF: domainId, rQ: filterOptions, sj: formSubmitPath, wS: langCode, eq: location, av: sessionToken, PM: totalVacancies, Sj: vacancySearchLocationEnabled};
	});
var $author$project$Model$SearchFields$KeywordAndLocationSearch = 2;
var $author$project$Model$SearchFields$KeywordSearch = 0;
var $author$project$Model$SearchFields$LocationSearch = 1;
var $author$project$Model$SearchFields$searchFieldsDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'keyword-search':
				return $elm$json$Json$Decode$succeed(0);
			case 'location-search':
				return $elm$json$Json$Decode$succeed(1);
			case 'keyword-and-location-search':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Component$KeywordSearch$Flags$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'langCode',
	$author$project$Model$LangCode$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vacancySearchLocationEnabled',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'location',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sessionToken',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'filterOptions',
					$elm$json$Json$Decode$list(
						$author$project$Data$Entity$decoder($author$project$Model$VacancyFilterOption$vacancyFilterOptionDecoder)),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'activeSearchFields',
						$author$project$Model$SearchFields$searchFieldsDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'domainId',
							$author$project$Data$Id$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'formSubmitPath',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'totalVacancies',
									$elm$json$Json$Decode$int,
									$elm$json$Json$Decode$succeed($author$project$Model$Component$KeywordSearch$Flags$Flags))))))))));
var $author$project$KeywordSearch$KeywordSearchMsg = $elm$core$Basics$identity;
var $author$project$View$KeywordSearch$All = {$: 0};
var $author$project$View$KeywordSearch$WithFilter = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$KeywordSearch$toVisibleTab = function (filterOptions) {
	if (filterOptions.b && (!filterOptions.b.b)) {
		var x = filterOptions.a;
		return $author$project$View$KeywordSearch$WithFilter(x);
	} else {
		return $author$project$View$KeywordSearch$All;
	}
};
var $author$project$View$KeywordSearch$init = function (flags) {
	return _Utils_Tuple2(
		{
			cF: flags.cF,
			rQ: flags.rQ,
			sj: flags.sj,
			wS: flags.wS,
			eq: $elm$url$Url$fromString(flags.eq),
			ah: $author$project$View$LocationSuggestions$init,
			Ju: flags.fu,
			av: $elm$core$Maybe$Just(flags.av),
			PM: flags.PM,
			X: $author$project$View$Autocomplete$Http$init,
			Sj: flags.Sj,
			I: $author$project$View$KeywordSearch$toVisibleTab(flags.rQ)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$KeywordSearch$init = function (flags) {
	var _v0 = $author$project$View$KeywordSearch$init(flags);
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		{wI: model},
		A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
};
var $author$project$View$KeywordSearch$VacancyAutocompleteMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$View$LocationSuggestions$autocomplete = function (_v0) {
	var state = _v0;
	return state.U;
};
var $author$project$Model$Suggestion$VacancySuggestion = F4(
	function (vacancyTitle, vacancyId, vacancyPagePath, vacancyLocationName) {
		return {R6: vacancyId, Sa: vacancyLocationName, Sf: vacancyPagePath, So: vacancyTitle};
	});
var $author$project$Model$Suggestion$vacancySuggestionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'vacancyLocationName',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vacancyPagePath',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'vacancyId',
			$author$project$Data$Id$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'vacancyTitle',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$Suggestion$VacancySuggestion)))));
var $author$project$View$KeywordSearch$requestVacancySuggestion = F4(
	function (domainId, visibleTab, trackingId, keyword) {
		var params = function () {
			if (!visibleTab.$) {
				return _List_fromArray(
					[
						A2($elm$url$Url$Builder$string, 'keywords', keyword)
					]);
			} else {
				var _v1 = visibleTab.a;
				var filterId = _v1.a;
				return _List_fromArray(
					[
						A2($elm$url$Url$Builder$string, 'keywords', keyword),
						A2(
						$elm$url$Url$Builder$int,
						'f',
						$author$project$Data$Id$toInt(filterId))
					]);
			}
		}();
		return $elm$http$Http$request(
			{
				a2: $elm$http$Http$emptyBody,
				cH: A2(
					$elm$http$Http$expectJson,
					$elm$core$Basics$identity,
					A3(
						$elm$json$Json$Decode$map2,
						$elm$core$Tuple$pair,
						A2(
							$elm$json$Json$Decode$index,
							0,
							$elm$json$Json$Decode$list($author$project$Model$Suggestion$vacancySuggestionDecoder)),
						$elm$json$Json$Decode$maybe(
							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$int)))),
				cL: _List_Nil,
				c0: 'GET',
				dF: $elm$core$Maybe$Nothing,
				WM: $elm$core$Maybe$Just(trackingId),
				dK: A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						[
							'api',
							$author$project$Data$Id$toString(domainId),
							'suggestions',
							'vacancies'
						]),
					params)
			});
	});
var $elm$url$Url$Builder$relative = F2(
	function (pathSegments, parameters) {
		return _Utils_ap(
			A2($elm$core$String$join, '/', pathSegments),
			$elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$View$KeywordSearch$removeQueryParam = F2(
	function (param, url) {
		return A2(
			$elm$core$Maybe$withDefault,
			url,
			A2(
				$elm$core$Maybe$map,
				function (regex) {
					return A3(
						$elm$regex$Regex$replace,
						regex,
						$elm$core$Basics$always(''),
						url);
				},
				$elm$regex$Regex$fromString('[&?]' + (param + '=\\d+'))));
	});
var $elm$core$String$trim = _String_trim;
var $author$project$View$KeywordSearch$toUrl = F2(
	function (mLocation, _v0) {
		var keywords = _v0.el;
		var location = _v0.eq;
		var formSubmitPath = _v0.sj;
		var visibleTab = _v0.I;
		var toExistingParams = function (existingQuery) {
			return (A2($elm$core$String$startsWith, '?', existingQuery) || A2($elm$core$String$startsWith, '&', existingQuery)) ? A2($elm$core$String$dropLeft, 1, existingQuery) : existingQuery;
		};
		var ignoreEmptyString = F2(
			function (f, s) {
				return $elm$core$String$isEmpty(
					$elm$core$String$trim(s)) ? _List_Nil : _List_fromArray(
					[
						f(s)
					]);
			});
		var keywordParam = $elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					ignoreEmptyString,
					$elm$url$Url$Builder$string('location'),
					location),
					A2(
					ignoreEmptyString,
					$elm$url$Url$Builder$string('keywords'),
					keywords)
				]));
		var newParams = A2(
			$elm$url$Url$Builder$relative,
			_List_Nil,
			function () {
				if (!visibleTab.$) {
					return keywordParam;
				} else {
					var _v2 = visibleTab.a;
					var filterId = _v2.a;
					return A2(
						$elm$core$List$cons,
						A2(
							$elm$url$Url$Builder$int,
							'f',
							$author$project$Data$Id$toInt(filterId)),
						keywordParam);
				}
			}());
		var emptyParams = $elm$core$String$isEmpty(newParams) ? '' : '{0}&{1}';
		var newQuery = function (existing) {
			return A2(
				$author$project$View$KeywordSearch$removeQueryParam,
				'o',
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					emptyParams,
					_List_fromArray(
						[
							newParams,
							toExistingParams(existing)
						])));
		};
		return A2(
			$elm$core$String$append,
			formSubmitPath,
			A2(
				$elm$core$Maybe$withDefault,
				newParams,
				A2(
					$elm$core$Maybe$map,
					newQuery,
					$elm_community$maybe_extra$Maybe$Extra$join(
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.V3;
							},
							mLocation)))));
	});
var $author$project$View$KeywordSearch$keywordSearchConfig = function (model) {
	var toVacancySuggestionTitle = function (suggestion) {
		return model.Sj ? A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} {1} {2}',
			A2(
				$elm$core$List$cons,
				suggestion.So,
				(!$elm$core$String$isEmpty(suggestion.Sa)) ? _List_fromArray(
					[$author$project$Copy$copy.Si, suggestion.Sa]) : _List_Nil)) : suggestion.So;
	};
	var toTotalRoute = F2(
		function (total, inputValue) {
			return {
				IA: A2(
					$author$project$View$KeywordSearch$toUrl,
					model.eq,
					{
						sj: model.sj,
						el: inputValue,
						eq: $author$project$View$Autocomplete$Http$currentInputValue(
							$author$project$View$LocationSuggestions$autocomplete(model.ah)),
						I: model.I
					}),
				WC: A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'{0} \"{1}\" ({2})',
					_List_fromArray(
						[
							$author$project$Copy$copy.gw,
							inputValue,
							$elm$core$String$fromInt(total)
						]))
			};
		});
	var id = 'vacancy';
	return {
		dT: $elm$core$Maybe$Nothing,
		cO: id,
		xp: $author$project$View$KeywordSearch$VacancyAutocompleteMsg,
		B1: $author$project$Copy$copy.Cs,
		dd: $author$project$Copy$copy.Jr,
		Ie: A3($author$project$View$KeywordSearch$requestVacancySuggestion, model.cF, model.I, id),
		Wv: $author$project$View$Autocomplete$Http$Link(
			{
				Wt: A2(
					$elm$core$Basics$composeL,
					$author$project$Util$Url$joinPath,
					function ($) {
						return $.Sf;
					}),
				PL: $elm$core$Maybe$Just(toTotalRoute)
			}),
		Pu: $elm$core$Basics$always($elm$core$Maybe$Nothing),
		WI: toVacancySuggestionTitle,
		e3: $elm$core$Maybe$Just('all-vacancies'),
		e4: id
	};
};
var $author$project$View$KeywordSearch$LocationSuggestionsMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$View$KeywordSearch$searchFieldsToClass = function (searchFields) {
	switch (searchFields) {
		case 0:
			return 'keyword-search-only';
		case 1:
			return 'location-search-only';
		default:
			return 'keyword-and-location-search';
	}
};
var $author$project$View$KeywordSearch$locationSuggestionsConfig = function (model) {
	var toRoute = function (_v0) {
		var locationDescription = _v0.Vn;
		return A2(
			$author$project$View$KeywordSearch$toUrl,
			model.eq,
			{
				sj: model.sj,
				el: $author$project$View$Autocomplete$Http$currentInputValue(model.X),
				eq: locationDescription,
				I: model.I
			});
	};
	return {
		cr: $author$project$View$KeywordSearch$searchFieldsToClass(model.Ju),
		cF: model.cF,
		xp: $author$project$View$KeywordSearch$LocationSuggestionsMsg,
		Wh: 1,
		av: model.av,
		Wv: $author$project$View$Autocomplete$Http$Link(
			{Wt: toRoute, PL: $elm$core$Maybe$Nothing}),
		e4: 'location-suggestion'
	};
};
var $author$project$View$KeywordSearch$subscriptions = F2(
	function (lift, model) {
		return A2(
			$elm$core$Platform$Sub$map,
			lift,
			$elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						A2(
						$author$project$View$Autocomplete$Http$subscriptions,
						$author$project$View$KeywordSearch$keywordSearchConfig(model),
						model.X),
						A2(
						$author$project$View$LocationSuggestions$subscriptions,
						$author$project$View$KeywordSearch$locationSuggestionsConfig(model),
						model.ah)
					])));
	});
var $author$project$KeywordSearch$subscriptions = function (model) {
	return A2($author$project$View$KeywordSearch$subscriptions, $elm$core$Basics$identity, model.wI);
};
var $author$project$View$Autocomplete$Http$refresh = F3(
	function (lift, config, state) {
		var inputValue = state.T;
		var autocomplete = state.s;
		switch (autocomplete.$) {
			case 0:
				return A4(
					$author$project$View$Autocomplete$Http$update,
					lift,
					config,
					$author$project$View$Autocomplete$Http$OnInput(inputValue),
					state);
			case 1:
				return A4(
					$author$project$View$Autocomplete$Http$update,
					lift,
					config,
					$author$project$View$Autocomplete$Http$OnInput(inputValue),
					state);
			default:
				return A4($author$project$View$Autocomplete$Http$update, lift, config, $author$project$View$Autocomplete$Http$NoOp, state);
		}
	});
var $author$project$View$KeywordSearch$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var location = A2(
					$elm$core$Maybe$withDefault,
					$author$project$View$Autocomplete$Http$currentInputValue(
						$author$project$View$LocationSuggestions$autocomplete(model.ah)),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.Vn;
						},
						$author$project$View$Autocomplete$Http$currentlyFocussedValue(
							$author$project$View$LocationSuggestions$autocomplete(model.ah))));
				var _v1 = $author$project$View$Autocomplete$Http$currentlyFocussedValue(model.X);
				if (!_v1.$) {
					var suggestion = _v1.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(
							$author$project$Util$Url$joinPath(suggestion.Sf)));
				} else {
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(
							A2(
								$author$project$View$KeywordSearch$toUrl,
								model.eq,
								{
									sj: model.sj,
									el: $author$project$View$Autocomplete$Http$currentInputValue(model.X),
									eq: location,
									I: model.I
								})));
				}
			case 1:
				var tab = msg.a;
				var _v2 = A3(
					$author$project$View$Autocomplete$Http$refresh,
					$author$project$View$KeywordSearch$VacancyAutocompleteMsg,
					$author$project$View$KeywordSearch$keywordSearchConfig(model),
					model.X);
				var autocompleteState = _v2.a;
				var autocompleteCmds = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{X: autocompleteState, I: tab}),
					autocompleteCmds);
			case 2:
				var msg_ = msg.a;
				var _v3 = A4(
					$author$project$View$Autocomplete$Http$update,
					$author$project$View$KeywordSearch$VacancyAutocompleteMsg,
					$author$project$View$KeywordSearch$keywordSearchConfig(model),
					msg_,
					model.X);
				var autocompleteState = _v3.a;
				var autocompleteCmds = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ah: $author$project$View$LocationSuggestions$reset(model.ah),
							X: autocompleteState
						}),
					autocompleteCmds);
			default:
				var locationSuggestionsMsg = msg.a;
				var _v4 = A3(
					$author$project$View$LocationSuggestions$update,
					$author$project$View$KeywordSearch$locationSuggestionsConfig(model),
					locationSuggestionsMsg,
					model.ah);
				var locationSuggestionsModel = _v4.a;
				var locationSuggestionsCmds = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ah: locationSuggestionsModel}),
					locationSuggestionsCmds);
		}
	});
var $author$project$KeywordSearch$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A2($author$project$View$KeywordSearch$update, subMsg, model.wI);
		var model_ = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{wI: model_}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$View$KeywordSearch$OnSubmit = {$: 0};
var $author$project$View$KeywordSearch$viewKeywordSearch = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-field', true),
						_Utils_Tuple2(
						$author$project$View$KeywordSearch$searchFieldsToClass(model.Ju),
						true)
					])),
				$elm$html$Html$Attributes$id('form-field-keyword')
			]),
		A2(
			$author$project$View$Autocomplete$Http$view,
			$author$project$View$KeywordSearch$keywordSearchConfig(model),
			model.X));
};
var $author$project$View$KeywordSearch$viewTab = function (model) {
	var msg = $elm$json$Json$Decode$succeed(
		{bp: $author$project$View$KeywordSearch$OnSubmit, V1: true, Wo: true});
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-search'),
					A2($elm$html$Html$Events$custom, 'submit', msg)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = model.Ju;
						switch (_v0) {
							case 0:
								return _List_fromArray(
									[
										$author$project$View$KeywordSearch$viewKeywordSearch(model)
									]);
							case 1:
								return _List_fromArray(
									[
										A2(
										$author$project$View$LocationSuggestions$view,
										$author$project$View$KeywordSearch$locationSuggestionsConfig(model),
										model.ah)
									]);
							default:
								return _List_fromArray(
									[
										$author$project$View$KeywordSearch$viewKeywordSearch(model),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('and-or')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text($author$project$Copy$copy.gM)
											])),
										A2(
										$author$project$View$LocationSuggestions$view,
										$author$project$View$KeywordSearch$locationSuggestionsConfig(model),
										model.ah)
									]);
						}
					}(),
						_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('submit'),
									$elm$html$Html$Attributes$class('btn btn-submit bg-color-1 color-white')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text($author$project$Copy$copy.SU)
										]))
								]))
						])
					])))
		]);
};
var $author$project$View$KeywordSearch$ShowTab = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$KeywordSearch$viewAmount = function (amount) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('amount')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
					'({0})',
					_List_fromArray(
						[
							$elm$core$String$fromInt(amount)
						])))
			]));
};
var $author$project$View$KeywordSearch$viewTabSelectButton = F4(
	function (langCode, totalVacancies, selectedTab, tab) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('btn'),
					$elm$html$Html$Events$onClick(
					$author$project$View$KeywordSearch$ShowTab(tab)),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'selected',
							_Utils_eq(selectedTab, tab))
						]))
				]),
			function () {
				if (!tab.$) {
					return _List_fromArray(
						[
							$elm$html$Html$text($author$project$Copy$copy.gv),
							$author$project$View$KeywordSearch$viewAmount(totalVacancies)
						]);
				} else {
					var _v1 = tab.a;
					var filter = _v1.b;
					return _List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Data$VacancyFilterOptionValue$toText, langCode, filter.dL)),
							$author$project$View$KeywordSearch$viewAmount(
							$elm$core$List$length(filter.R7))
						]);
				}
			}());
	});
var $author$project$View$KeywordSearch$viewTabSelect = F4(
	function (langCode, totalVacancies, visibleTab, filterOptions) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('banner-search-tabs')
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A4($author$project$View$KeywordSearch$viewTabSelectButton, langCode, totalVacancies, visibleTab, $author$project$View$KeywordSearch$All)
						]),
						A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeL,
							A3($author$project$View$KeywordSearch$viewTabSelectButton, langCode, totalVacancies, visibleTab),
							$author$project$View$KeywordSearch$WithFilter),
						filterOptions)
					])));
	});
var $author$project$View$KeywordSearch$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-bar-content')
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					($elm$core$List$length(model.rQ) <= 1) ? _List_Nil : _List_fromArray(
					[
						A4($author$project$View$KeywordSearch$viewTabSelect, model.wS, model.PM, model.I, model.rQ)
					]),
					$author$project$View$KeywordSearch$viewTab(model)
				])));
};
var $author$project$KeywordSearch$view = function (model) {
	return A2(
		$elm$html$Html$map,
		$elm$core$Basics$identity,
		$author$project$View$KeywordSearch$view(model.wI));
};
var $author$project$KeywordSearch$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$Model$Component$KeywordSearch$Flags$flagsDecoder,
	{cR: $author$project$KeywordSearch$init, dC: $author$project$KeywordSearch$subscriptions, dJ: $author$project$KeywordSearch$update, dM: $author$project$KeywordSearch$view});
var $author$project$JobAlertForm$Flags = function (privacyPath) {
	return function (postPath) {
		return function (filters) {
			return function (showLocationFields) {
				return function (email) {
					return function (introduction) {
						return function (domainId) {
							return function (windowWidth) {
								return function (sessionToken) {
									return function (csrfToken) {
										return function (translations) {
											return function (langCode) {
												return function (useDifferentDisciplineLabel) {
													return {a8: csrfToken, cF: domainId, d4: email, rW: filters, bS: introduction, wS: langCode, df: postPath, b2: privacyPath, av: sessionToken, L0: showLocationFields, P$: translations, cf: useDifferentDisciplineLabel, ch: windowWidth};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$JobAlertForm$decodeFlags = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'useDifferentDisciplineLabel',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'langCode',
		$author$project$Model$LangCode$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'translations',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Basics$identity,
				$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'csrfToken',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'sessionToken',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'windowWidth',
						$author$project$Browser$Dom$Breakpoint$windowWidthDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'domainId',
							$author$project$Data$Id$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'introduction',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'email',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'showLocationFields',
										$elm$json$Json$Decode$bool,
										A3(
											$elm$core$Basics$apL,
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required('filters'),
											$elm$json$Json$Decode$list(
												A3(
													$elm$json$Json$Decode$map2,
													$elm$core$Tuple$pair,
													A2(
														$elm$json$Json$Decode$index,
														0,
														$author$project$Data$Entity$decoder($author$project$Model$VacancyFilter$vacancyFilterDecoder)),
													A2(
														$elm$json$Json$Decode$index,
														1,
														$elm$json$Json$Decode$list(
															A3(
																$elm$json$Json$Decode$map2,
																$elm$core$Tuple$pair,
																A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
																A2(
																	$elm$json$Json$Decode$index,
																	1,
																	$elm$json$Json$Decode$list(
																		$author$project$Data$Entity$decoder($author$project$Model$VacancyFilterOption$vacancyFilterOptionDecoder)))))))),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'postPath',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'privacyPath',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$JobAlertForm$Flags))))))))))))));
var $author$project$JobAlertForm$init = function (flags) {
	return _Utils_Tuple2(
		{
			a8: flags.a8,
			cF: flags.cF,
			rW: flags.rW,
			bP: {
				oN: 20,
				d4: flags.d4,
				rW: $author$project$Data$Id$emptyDict,
				r3: '',
				bQ: $elm$core$Maybe$Nothing,
				w1: '',
				eq: A5($author$project$Model$Suggestion$LocationSuggestion, '', $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
				b1: false
			},
			bS: flags.bS,
			wS: flags.wS,
			ah: $author$project$View$LocationSuggestions$init,
			df: flags.df,
			b2: flags.b2,
			av: $elm$core$Maybe$Just(flags.av),
			L0: flags.L0,
			P$: flags.P$,
			cf: flags.cf,
			ch: flags.ch
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$JobAlertForm$LocationSuggestionsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$JobAlertForm$SetLocationSuggestion = function (a) {
	return {$: 2, a: a};
};
var $author$project$JobAlertForm$locationSuggestionsConfig = F2(
	function (domainId, sessionToken) {
		return {
			cr: '',
			cF: domainId,
			xp: $author$project$JobAlertForm$LocationSuggestionsMsg,
			Wh: 1,
			av: sessionToken,
			Wv: $author$project$View$Autocomplete$Http$Button(
				{Wu: $author$project$JobAlertForm$SetLocationSuggestion, WL: $elm$core$Maybe$Nothing}),
			e4: 'location-search-job-alert'
		};
	});
var $author$project$JobAlertForm$subscriptions = function (model) {
	return A2(
		$author$project$View$LocationSuggestions$subscriptions,
		A2($author$project$JobAlertForm$locationSuggestionsConfig, model.cF, model.av),
		model.ah);
};
var $author$project$JobAlertForm$GotSendJobAlertForm = function (a) {
	return {$: 5, a: a};
};
var $author$project$Dict$Custom$toList = function (_v0) {
	var g = _v0.b;
	var dict = _v0.c;
	var cons = F3(
		function (k, v, acc) {
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					g(k),
					v),
				acc);
		});
	return A3($elm$core$Dict$foldr, cons, _List_Nil, dict);
};
var $author$project$JobAlertForm$toOptionList = A2(
	$elm$core$Basics$composeL,
	$elm$core$List$concatMap(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Tuple$second,
			$elm$core$List$concatMap($elm$core$Tuple$second))),
	$author$project$Dict$Custom$toList);
var $author$project$JobAlertForm$encode = function (form) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(form.d4)),
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(form.r3)),
				_Utils_Tuple2(
				'lastName',
				$elm$json$Json$Encode$string(form.w1)),
				_Utils_Tuple2(
				'honeypot',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, form.bQ)),
				_Utils_Tuple2(
				'latitude',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$float, form.eq.w8)),
				_Utils_Tuple2(
				'longitude',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$float, form.eq.yg)),
				_Utils_Tuple2(
				'options',
				A2(
					$elm$json$Json$Encode$list,
					$author$project$Data$Id$encode,
					$author$project$JobAlertForm$toOptionList(form.rW))),
				_Utils_Tuple2(
				'privacy',
				$elm$json$Json$Encode$bool(form.b1)),
				_Utils_Tuple2(
				'distanceInKm',
				$elm$json$Json$Encode$int(form.oN))
			]));
};
var $author$project$Api$Endpoint$jobAlertForm = function (domainId) {
	return $author$project$Api$Endpoint$endpoint(
		_List_fromArray(
			[
				$author$project$Data$Id$toString(domainId),
				'job-alert'
			]));
};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $NoRedInk$http_upgrade_shim$Http$Legacy$header = $elm$http$Http$header;
var $author$project$Api$postWithHeader = F4(
	function (url, headers, body, decoder) {
		return $author$project$Api$Endpoint$requestLegacy(
			{
				a2: body,
				cH: $NoRedInk$http_upgrade_shim$Http$Legacy$expectJson(decoder),
				cL: A2(
					$elm$core$List$map,
					function (_v0) {
						var k = _v0.a;
						var v = _v0.b;
						return A2($NoRedInk$http_upgrade_shim$Http$Legacy$header, k, v);
					},
					headers),
				c0: 'POST',
				dF: $elm$core$Maybe$Nothing,
				dK: url,
				e9: false
			});
	});
var $author$project$JobAlertForm$postData = F3(
	function (domainK, csrfToken, form) {
		return A2(
			$author$project$Api$send,
			$author$project$JobAlertForm$GotSendJobAlertForm,
			A4(
				$author$project$Api$postWithHeader,
				$author$project$Api$Endpoint$jobAlertForm(domainK),
				_List_fromArray(
					[
						_Utils_Tuple2('X-XSRF-TOKEN', csrfToken)
					]),
				$elm$http$Http$jsonBody(
					$author$project$JobAlertForm$encode(form)),
				$author$project$Model$RedirectUrl$redirectUrlDecoder));
	});
var $author$project$JobAlertForm$update = F2(
	function (msg, model) {
		var form = model.bP;
		switch (msg.$) {
			case 0:
				var form_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bP: form_}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var locationSuggestionsMsg = msg.a;
				var _v1 = A3(
					$author$project$View$LocationSuggestions$update,
					A2($author$project$JobAlertForm$locationSuggestionsConfig, model.cF, model.av),
					locationSuggestionsMsg,
					model.ah);
				var locationSuggestionsModel = _v1.a;
				var locationSuggestionsCmds = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ah: locationSuggestionsModel}),
					locationSuggestionsCmds);
			case 2:
				var suggestion = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bP: _Utils_update(
								form,
								{eq: suggestion}),
							ah: $author$project$View$LocationSuggestions$reset(model.ah)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bP: _Utils_update(
								form,
								{
									eq: A5($author$project$Model$Suggestion$LocationSuggestion, '', $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					model,
					A3($author$project$JobAlertForm$postData, model.cF, model.a8, model.bP));
			default:
				if (!msg.a.$) {
					var unRedirectUrl = msg.a.a.WP;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(unRedirectUrl));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$JobAlertForm$ClearLocation = {$: 3};
var $author$project$JobAlertForm$SendJobAlertForm = {$: 4};
var $author$project$JobAlertForm$UpdateForm = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Autocomplete$Http$autocompleteStateIsKnown = function (_v0) {
	var state = _v0;
	var _v1 = state.s;
	if (_v1.$ === 3) {
		return false;
	} else {
		return true;
	}
};
var $author$project$View$LocationSuggestions$autocompleteStateIsKnown = A2($elm$core$Basics$composeL, $author$project$View$Autocomplete$Http$autocompleteStateIsKnown, $author$project$View$LocationSuggestions$autocomplete);
var $elm$html$Html$Attributes$multiple = $elm$html$Html$Attributes$boolProperty('multiple');
var $author$project$Component$Form$Checkbox$name = function (val_) {
	return $author$project$Component$Form$Checkbox$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					c4: $elm$core$Maybe$Just(val_)
				});
		});
};
var $author$project$Component$Form$NumberInput$name = function (name_) {
	return $author$project$Component$Form$NumberInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					c4: $elm$core$Maybe$Just(name_)
				});
		});
};
var $author$project$Component$Form$TextInput$name = function (name_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{
					c4: $elm$core$Maybe$Just(name_)
				});
		});
};
var $author$project$Util$Decode$decodeEventObject = F2(
	function (keys, decoder) {
		return A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$map($elm$core$Tuple$second),
			A2(
				$elm$json$Json$Decode$at,
				keys,
				$elm$json$Json$Decode$keyValuePairs(
					A2($elm$json$Json$Decode$field, 'value', decoder))));
	});
var $author$project$JobAlertForm$findGroupedOption = F2(
	function (displayLabels, _v0) {
		var filterOptions = _v0.b;
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				A2($author$project$Util$Base$flip, $elm$core$List$member, displayLabels),
				$elm$core$Tuple$first),
			filterOptions);
	});
var $elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
	if (m.$ === 1) {
		return _List_Nil;
	} else {
		var x = m.a;
		return _List_fromArray(
			[x]);
	}
};
var $author$project$JobAlertForm$findGroupedOptions = F3(
	function (filterId, filters, displayLabels) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var a = _v0.a;
				var b = _v0.b;
				return _Utils_Tuple2(
					a,
					A2($elm$core$List$map, $author$project$Data$Entity$id, b));
			},
			$elm$core$List$concat(
				$elm_community$maybe_extra$Maybe$Extra$toList(
					A2(
						$elm$core$Maybe$map,
						$author$project$JobAlertForm$findGroupedOption(displayLabels),
						A2(
							$elm_community$list_extra$List$Extra$find,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Data$Entity$id,
									$elm$core$Basics$eq(filterId))),
							filters)))));
	});
var $author$project$JobAlertForm$onOptionSelect = F3(
	function (filterId, form, filters) {
		var groupedOptions = A2($author$project$JobAlertForm$findGroupedOptions, filterId, filters);
		var updateFilters = function (displayLabels) {
			return $author$project$JobAlertForm$UpdateForm(
				_Utils_update(
					form,
					{
						rW: A3(
							$author$project$Dict$Custom$insert,
							filterId,
							groupedOptions(displayLabels),
							form.rW)
					}));
		};
		var decodeMulti = A2(
			$author$project$Util$Decode$decodeEventObject,
			_List_fromArray(
				['target', 'selectedOptions']),
			$elm$json$Json$Decode$string);
		return A2(
			$elm$html$Html$Events$on,
			'change',
			A2($elm$json$Json$Decode$map, updateFilters, decodeMulti));
	});
var $author$project$Component$Form$NumberInput$required = $author$project$Component$Form$NumberInput$set(
	function (attributes) {
		return _Utils_update(
			attributes,
			{dl: true});
	});
var $author$project$Component$Form$TextInput$required = function (required_) {
	return $author$project$Component$Form$TextInput$set(
		function (attributes) {
			return _Utils_update(
				attributes,
				{dl: required_});
		});
};
var $author$project$JobAlertForm$viewCheckbox = F3(
	function (form, filterId, _v0) {
		var displayLabel = _v0.a;
		var groupedOptions = _v0.b;
		var toggleFilterOption = function (options) {
			return A2(
				$elm$core$List$member,
				displayLabel,
				A2($elm$core$List$map, $elm$core$Tuple$first, options)) ? A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$neq(displayLabel),
					$elm$core$Tuple$first),
				options) : A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					displayLabel,
					A2($elm$core$List$map, $author$project$Data$Entity$id, groupedOptions)),
				options);
		};
		var getOptions = A2($author$project$Dict$Custom$get, filterId, form.rW);
		var addOption = A2(
			$elm$core$Maybe$withDefault,
			_List_fromArray(
				[
					_Utils_Tuple2(
					displayLabel,
					A2($elm$core$List$map, $author$project$Data$Entity$id, groupedOptions))
				]),
			A2($elm$core$Maybe$map, toggleFilterOption, getOptions));
		var updateOptions = function (_v1) {
			return $author$project$JobAlertForm$UpdateForm(
				_Utils_update(
					form,
					{
						rW: A3($author$project$Dict$Custom$insert, filterId, addOption, form.rW)
					}));
		};
		return A2(
			$author$project$Component$Form$Checkbox$view,
			displayLabel,
			_List_fromArray(
				[
					$author$project$Component$Form$Checkbox$name('options'),
					$author$project$Component$Form$Checkbox$onCheck(updateOptions),
					$author$project$Component$Form$Checkbox$checked(
					A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map($elm$core$Tuple$first),
								$elm$core$List$member(displayLabel)),
							getOptions)))
				]));
	});
var $author$project$JobAlertForm$view = function (model) {
	var form = model.bP;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('job-alert-form')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('intro-job-alert')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text text-align-left')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(model.bS)
							]))
					])),
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Events$onSubmit($author$project$JobAlertForm$SendJobAlertForm),
						$elm$html$Html$Attributes$class('form')
					]),
				$elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('hidden'),
										$elm$html$Html$Attributes$name('_token'),
										$elm$html$Html$Attributes$value(model.a8)
									]),
								_List_Nil)
							]),
							_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-row')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Component$Form$TextInput$view,
										'',
										_List_fromArray(
											[
												$author$project$Component$Form$TextInput$id('first-name'),
												$author$project$Component$Form$TextInput$placeholder($author$project$Copy$copy.r3),
												$author$project$Component$Form$TextInput$onInput(
												function (v) {
													return $author$project$JobAlertForm$UpdateForm(
														_Utils_update(
															form,
															{r3: v}));
												}),
												$author$project$Component$Form$TextInput$value(form.r3),
												$author$project$Component$Form$TextInput$name('first_name'),
												$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.VW),
												$author$project$Component$Form$TextInput$required(true)
											])),
										A2(
										$author$project$Component$Form$TextInput$view,
										'',
										_List_fromArray(
											[
												$author$project$Component$Form$TextInput$id('last-name'),
												$author$project$Component$Form$TextInput$placeholder($author$project$Copy$copy.w1),
												$author$project$Component$Form$TextInput$onInput(
												function (v) {
													return $author$project$JobAlertForm$UpdateForm(
														_Utils_update(
															form,
															{w1: v}));
												}),
												$author$project$Component$Form$TextInput$value(form.w1),
												$author$project$Component$Form$TextInput$name('last_name'),
												$author$project$Component$Form$TextInput$required(true)
											]))
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$autocomplete(false),
										$elm$html$Html$Attributes$name('password'),
										A2($elm$html$Html$Attributes$attribute, 'style', 'display:none !important'),
										A2($elm$html$Html$Attributes$attribute, 'tabindex', '-1'),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$value(
										A2($elm$core$Maybe$withDefault, '', form.bQ)),
										$elm$html$Html$Events$onInput(
										function (v) {
											return $author$project$JobAlertForm$UpdateForm(
												_Utils_update(
													form,
													{
														bQ: $elm$core$Maybe$Just(v)
													}));
										})
									]),
								_List_Nil),
								A2(
								$author$project$Component$Form$TextInput$view,
								'',
								_List_fromArray(
									[
										$author$project$Component$Form$TextInput$id('email'),
										$author$project$Component$Form$TextInput$placeholder($author$project$Copy$copy.d4),
										$author$project$Component$Form$TextInput$onInput(
										function (v) {
											return $author$project$JobAlertForm$UpdateForm(
												_Utils_update(
													form,
													{d4: v}));
										}),
										$author$project$Component$Form$TextInput$value(form.d4),
										$author$project$Component$Form$TextInput$email,
										$author$project$Component$Form$TextInput$required(true),
										$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.d4),
										$author$project$Component$Form$TextInput$name('email')
									]))
							]),
							function () {
							var _v0 = A3($elm$core$Maybe$map2, $elm$core$Tuple$pair, model.bP.eq.w8, model.bP.eq.yg);
							if (!_v0.$) {
								var _v1 = _v0.a;
								var latitude = _v1.a;
								var longitude = _v1.b;
								return _List_fromArray(
									[
										A2(
										$author$project$Util$View$viewIf,
										model.L0,
										function (_v2) {
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('selected-location')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('label')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text($author$project$Copy$copy.KW)
															])),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('select-location-title')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(model.bP.eq.Vn),
																A2(
																$elm$html$Html$button,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$type_('button'),
																		$elm$html$Html$Events$onClick($author$project$JobAlertForm$ClearLocation)
																	]),
																_List_fromArray(
																	[
																		$author$project$View$Icon$viewColored($author$project$View$Icon$path.H3)
																	]))
															])),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$type_('hidden'),
																$elm$html$Html$Attributes$name('latitude'),
																$elm$html$Html$Attributes$value(
																$elm$core$String$fromFloat(latitude))
															]),
														_List_Nil),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$type_('hidden'),
																$elm$html$Html$Attributes$name('longitude'),
																$elm$html$Html$Attributes$value(
																$elm$core$String$fromFloat(longitude))
															]),
														_List_Nil)
													]));
										})
									]);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Util$View$viewIf,
										model.L0,
										function (_v3) {
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('field input-field form-field')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('label')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text($author$project$Copy$copy.Jp)
															])),
														A2(
														$author$project$View$LocationSuggestions$view,
														A2($author$project$JobAlertForm$locationSuggestionsConfig, model.cF, model.av),
														model.ah)
													]));
										})
									]);
							}
						}(),
							_List_fromArray(
							[
								A2(
								$author$project$Util$View$viewIf,
								model.L0,
								function (_v4) {
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('distance field-container')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Component$Form$NumberInput$view,
												$author$project$Copy$copy.oN,
												_List_fromArray(
													[
														$author$project$Component$Form$NumberInput$onInput(
														function (v) {
															return $author$project$JobAlertForm$UpdateForm(
																_Utils_update(
																	form,
																	{oN: v}));
														}),
														$author$project$Component$Form$NumberInput$id('distance-in-km'),
														$author$project$Component$Form$NumberInput$name('distance_in_km'),
														$author$project$Component$Form$NumberInput$value(form.oN),
														$author$project$Component$Form$NumberInput$placeholder($author$project$Copy$copy.CH),
														$author$project$Component$Form$NumberInput$min(0),
														$author$project$Component$Form$NumberInput$max(10000),
														$author$project$Component$Form$NumberInput$required
													]))
											]));
								})
							]),
							A2(
							$elm$core$List$map,
							function (_v5) {
								var _v6 = _v5.a;
								var filterId = _v6.a;
								var filter = _v6.b;
								var groupedOptions = _v5.b;
								var sortedOptions = A2($elm$core$List$sortBy, $elm$core$Tuple$first, groupedOptions);
								return A2(
									$author$project$Util$View$viewIfNot,
									$elm$core$List$isEmpty(groupedOptions),
									function (_v7) {
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('options')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('field label')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															((filter.UZ === 10) && model.cf) ? $author$project$Copy$copy.nq : A2(
																$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
																'{0} {1}',
																_List_fromArray(
																	[$author$project$Copy$copy.k7, filter.bj])))
														])),
													A2(
													$elm$html$Html$input,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$name('filter_id'),
															$elm$html$Html$Attributes$type_('hidden'),
															$elm$html$Html$Attributes$value(
															$author$project$Data$Id$toString(filterId))
														]),
													_List_Nil),
													A3(
													$author$project$Browser$Dom$Breakpoint$isBetween,
													model.ch,
													$author$project$Browser$Dom$Breakpoint$zero,
													$author$project$Browser$Dom$Breakpoint$custom(992)) ? A2(
													$elm$html$Html$select,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$id('options'),
															$elm$html$Html$Attributes$multiple(true),
															$elm$html$Html$Attributes$name('options'),
															A3($author$project$JobAlertForm$onOptionSelect, filterId, form, model.rW)
														]),
													A2(
														$elm$core$List$map,
														function (_v8) {
															var displayLabel = _v8.a;
															return A2(
																$elm$html$Html$option,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$value(displayLabel),
																		$elm$html$Html$Attributes$selected(
																		A2(
																			$elm$core$Maybe$withDefault,
																			false,
																			A2(
																				$elm$core$Maybe$map,
																				A2(
																					$elm$core$Basics$composeR,
																					$elm$core$List$map($elm$core$Tuple$first),
																					$elm$core$List$member(displayLabel)),
																				A2($author$project$Dict$Custom$get, filterId, form.rW))))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(displayLabel)
																	]));
														},
														sortedOptions)) : A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('checkbox-container')
														]),
													A2(
														$elm$core$List$map,
														A2($author$project$JobAlertForm$viewCheckbox, form, filterId),
														sortedOptions))
												]));
									});
							},
							model.rW),
							_List_fromArray(
							[
								A2(
								$author$project$Component$Form$Checkbox$view,
								'',
								_List_fromArray(
									[
										$author$project$Component$Form$Checkbox$id('privacy'),
										$author$project$Component$Form$Checkbox$name('privacy'),
										$author$project$Component$Form$Checkbox$required(true),
										$author$project$Component$Form$Checkbox$onCheck(
										function (v) {
											return $author$project$JobAlertForm$UpdateForm(
												_Utils_update(
													form,
													{b1: v}));
										}),
										$author$project$Component$Form$Checkbox$checked(form.b1),
										$author$project$Component$Form$Checkbox$htmlLabel(
										A2(
											$elm$core$Maybe$withDefault,
											$elm$html$Html$text(''),
											A5($author$project$View$FormV2$toPrivacyLabel, model.cF, model.P$, model.b2, $author$project$Model$FormFieldV2$Privacy, _List_Nil)))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button-container')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('btn btn-primary bg-color-2 color-white'),
												$elm$html$Html$Attributes$type_('submit'),
												$elm$html$Html$Attributes$disabled(
												$author$project$View$LocationSuggestions$autocompleteStateIsKnown(model.ah))
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text($author$project$Copy$copy.Wq)
													]))
											]))
									]))
							])
						])))
			]));
};
var $author$project$JobAlertForm$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$JobAlertForm$decodeFlags,
	{cR: $author$project$JobAlertForm$init, dC: $author$project$JobAlertForm$subscriptions, dJ: $author$project$JobAlertForm$update, dM: $author$project$JobAlertForm$view});
var $author$project$Form$Flags = function (formEntity) {
	return function (formTypeData) {
		return function (translations) {
			return function (today) {
				return function (buttonOverwriteText) {
					return function (privacyPagePath) {
						return function (defaultCallingCode) {
							return function (domainId) {
								return function (schemaFields) {
									return function (screeningQuestions) {
										return {a3: buttonOverwriteText, UE: defaultCallingCode, cF: domainId, d7: formEntity, d9: formTypeData, bs: privacyPagePath, eL: schemaFields, eM: screeningQuestions, e2: today, P$: translations};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$Form$FormType$EventRegistrationData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Form$FormType$OpenJobApplicationData = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Form$FormType$UbeeoEventRegistrationData = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Form$FormType$formTypeDataDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		switch (a) {
			case 'job-application-data':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Form$FormType$JobApplicationData));
			case 'open-job-application-data':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Form$FormType$OpenJobApplicationData));
			case 'event-registration-data':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Form$FormType$EventRegistrationData));
			case 'ubeeo-event-registration-data':
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contents',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Form$FormType$UbeeoEventRegistrationData));
			default:
				return $elm$json$Json$Decode$fail('No matching constructor');
		}
	},
	A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string));
var $author$project$Model$FormFieldTypeV2$ScreeningQuestion = F3(
	function (id, label, fieldType) {
		return {rm: fieldType, cO: id, bj: label};
	});
var $author$project$Model$FormFieldTypeV2$screeningQuestionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'fieldType',
	$author$project$Model$FormFieldTypeV2$fieldTypeDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'label',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Model$FormFieldTypeV2$ScreeningQuestion))));
var $author$project$Form$decodeFlags = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'screeningQuestions',
	$elm$json$Json$Decode$list($author$project$Model$FormFieldTypeV2$screeningQuestionDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'schemaFields',
		$elm$json$Json$Decode$list($author$project$Model$FormV2Schema$schemaFieldDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'domainId',
			$author$project$Data$Id$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'defaultCallingCode',
				$author$project$Util$Json$enumDecoder($author$project$Model$CountryCallingCode$fromString),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'privacyPagePath',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'buttonOverwriteText',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'today',
							$author$project$Util$Date$todayDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'translations',
								A2(
									$elm$json$Json$Decode$map,
									$elm$core$Basics$identity,
									$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'formTypeData',
									$author$project$Model$Form$FormType$formTypeDataDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'formEntity',
										$author$project$Data$Entity$decoder($author$project$Model$FormV2$formDecoder),
										$elm$json$Json$Decode$succeed($author$project$Form$Flags)))))))))));
var $author$project$Form$init = function (flags) {
	return _Utils_Tuple2(
		{
			a3: flags.a3,
			bP: $author$project$View$FormV2$init(
				{UE: flags.UE, UL: flags.cF, d7: flags.d7, d9: flags.d9, eL: flags.eL, eM: flags.eM}),
			cK: $elm$core$Maybe$Nothing,
			bs: flags.bs,
			e2: flags.e2,
			P$: flags.P$
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Form$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Form$GaInfoReceived = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$GoogleAnalytics$receiveGoogleAnalyticsInfo = _Platform_incomingPort(
	'receiveGoogleAnalyticsInfo',
	A2(
		$elm$json$Json$Decode$andThen,
		function (utmCustom) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (trackingId) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (clientId) {
							return $elm$json$Json$Decode$succeed(
								{dZ: clientId, e4: trackingId, e5: utmCustom});
						},
						A2($elm$json$Json$Decode$field, 'clientId', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'trackingId', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'utmCustom', $elm$json$Json$Decode$string)));
var $author$project$View$FormV2$HttpSendingProgress = $elm$core$Basics$identity;
var $author$project$View$FormV2$UpdateHttpProgress = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$FormV2$subscriptions = function (lift) {
	var toMsg = function (progress) {
		if (!progress.$) {
			var x = progress.a;
			return $author$project$View$FormV2$UpdateHttpProgress(
				$elm$http$Http$fractionSent(x));
		} else {
			return $author$project$View$FormV2$NoOp;
		}
	};
	return A2(
		$elm$http$Http$track,
		'post',
		A2($elm$core$Basics$composeL, lift, toMsg));
};
var $author$project$Form$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Form$FormMsg,
				$author$project$View$FormV2$subscriptions($elm$core$Basics$identity)),
				$author$project$Data$GoogleAnalytics$receiveGoogleAnalyticsInfo($author$project$Form$GaInfoReceived)
			]));
};
var $author$project$Form$redirectTo = _Platform_outgoingPort('redirectTo', $elm$json$Json$Encode$string);
var $author$project$Data$GoogleAnalytics$toParams = function (_v0) {
	var trackingId = _v0.e4;
	var clientId = _v0.dZ;
	var utmCustom = _v0.e5;
	return _List_fromArray(
		[
			A2($elm$url$Url$Builder$string, 'trackingId', trackingId),
			A2($elm$url$Url$Builder$string, 'clientId', clientId),
			A2($elm$url$Url$Builder$string, 'utmCustom', utmCustom)
		]);
};
var $author$project$Form$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var formMsg = msg.a;
			var _v1 = A3(
				$author$project$View$FormV2$update,
				{
					xp: $elm$core$Basics$identity,
					VR: A2(
						$elm$core$Basics$composeL,
						$author$project$Form$redirectTo,
						function ($) {
							return $.WP;
						}),
					V4: A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, $author$project$Data$GoogleAnalytics$toParams, model.cK))
				},
				formMsg,
				model.bP);
			var formModel = _v1.a;
			var formCmds = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{bP: formModel}),
				A2($elm$core$Platform$Cmd$map, $author$project$Form$FormMsg, formCmds));
		} else {
			var gaInfo = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						cK: $elm$core$Maybe$Just(gaInfo)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Form$view = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Form$FormMsg,
		A2(
			$author$project$View$FormV2$view,
			{a3: model.a3, xp: $elm$core$Basics$identity, bs: model.bs, e2: model.e2, P$: model.P$},
			model.bP));
};
var $author$project$Form$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$Form$decodeFlags,
	{cR: $author$project$Form$init, dC: $author$project$Form$subscriptions, dJ: $author$project$Form$update, dM: $author$project$Form$view});
var $author$project$Model$Component$ContactForm$Flags$Flags = F5(
	function (domainId, emailAddress, redirect, buttonText, defaultCallingCode) {
		return {bI: buttonText, UE: defaultCallingCode, cF: domainId, bd: emailAddress, V6: redirect};
	});
var $author$project$Model$Component$ContactForm$Flags$flagsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'defaultCallingCode',
	$author$project$Util$Json$enumDecoder($author$project$Model$CountryCallingCode$fromString),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'buttonText',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'redirect',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'emailAddress',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'domainId',
					$author$project$Data$Id$decoder,
					$elm$json$Json$Decode$succeed($author$project$Model$Component$ContactForm$Flags$Flags))))));
var $author$project$ContactForm$emptyForm = function (defaultCallingCode) {
	return {
		bd: '',
		bQ: $elm$core$Maybe$Nothing,
		bp: '',
		c4: '',
		aM: _Utils_Tuple2(defaultCallingCode, '')
	};
};
var $author$project$ContactForm$init = function (flags) {
	return _Utils_Tuple2(
		{
			bI: flags.bI,
			cF: flags.cF,
			d5: flags.bd,
			bP: $author$project$ContactForm$emptyForm(flags.UE),
			dj: flags.V6,
			aU: $author$project$Data$Status$NotAsked,
			bE: $elm$core$Maybe$Nothing
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$ContactForm$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$ContactForm$GotSubmitForm = function (a) {
	return {$: 2, a: a};
};
var $author$project$ContactForm$encodeContactForm = F2(
	function (emailTo, form) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(form.c4)),
					_Utils_Tuple2(
					'emailTo',
					$elm$json$Json$Encode$string(emailTo)),
					_Utils_Tuple2(
					'emailAddress',
					$elm$json$Json$Encode$string(form.bd)),
					_Utils_Tuple2(
					'contactMsg',
					$elm$json$Json$Encode$string(form.bp)),
					_Utils_Tuple2(
					'honeypot',
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, form.bQ)),
					_Utils_Tuple2(
					'phone',
					A2(
						$elm$json$Json$Encode$list,
						$elm$json$Json$Encode$string,
						_List_fromArray(
							[
								$author$project$Model$CountryCallingCode$toString(form.aM.a),
								form.aM.b
							])))
				]));
	});
var $author$project$Api$Endpoint$submitContactForm = function (domainId) {
	return $author$project$Api$Endpoint$endpoint(
		_List_fromArray(
			[
				'form',
				'contact',
				$author$project$Data$Id$toString(domainId)
			]));
};
var $author$project$ContactForm$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var form = msg.b;
				var validationResponse = A2(
					$elm$core$Maybe$map,
					function (validationErrors) {
						return _Utils_update(
							validationErrors,
							{
								UY: A2($elm$core$Dict$remove, field, validationErrors.UY)
							});
					},
					model.bE);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bP: form, bE: validationResponse}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aU: $author$project$Data$Status$Loading}),
					$author$project$Api$Endpoint$request(
						{
							a2: $elm$http$Http$jsonBody(
								A2($author$project$ContactForm$encodeContactForm, model.d5, model.bP)),
							cH: A2(
								$author$project$Api$expectJson,
								$author$project$ContactForm$GotSubmitForm,
								$elm$json$Json$Decode$succeed(0)),
							cL: _List_Nil,
							c0: 'POST',
							dF: $elm$core$Maybe$Nothing,
							WM: $elm$core$Maybe$Just('post'),
							dK: $author$project$Api$Endpoint$submitContactForm(model.cF)
						}));
			default:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aU: $author$project$Data$Status$Success(0)
							}),
						$elm$core$String$isEmpty(model.dj) ? $elm$core$Platform$Cmd$none : $elm$browser$Browser$Navigation$load(model.dj));
				} else {
					if (!msg.a.a.$) {
						var validationError = msg.a.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aU: $author$project$Data$Status$Failure(
										$author$project$Api$ValidationError(validationError)),
									bE: $elm$core$Maybe$Just(validationError)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aU: $author$project$Data$Status$Failure(err)
								}),
							$elm$core$Platform$Cmd$none);
					}
				}
		}
	});
var $author$project$ContactForm$SubmitForm = {$: 1};
var $author$project$ContactForm$UpdateForm = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$ContactForm$maybeError = F2(
	function (inputId, validationResponse) {
		return A2($author$project$Api$toValidationError, inputId, validationResponse);
	});
var $author$project$ContactForm$phoneField = F3(
	function (_v0, maybeErr, toMsg) {
		var countryCallingCode = _v0.a;
		var phoneNumber = _v0.b;
		var selectConfig = {
			Uu: $elm$core$Maybe$Just(
				$elm$core$Basics$eq(countryCallingCode)),
			U6: $author$project$Model$CountryCallingCode$fromString,
			VT: function () {
				var _v1 = A2($elm$core$List$sortBy, $author$project$Model$CountryCallingCode$toString, $author$project$Model$CountryCallingCode$all);
				if (_v1.b) {
					var hd = _v1.a;
					var rest = _v1.b;
					return _Utils_Tuple2(hd, rest);
				} else {
					return _Utils_Tuple2(countryCallingCode, $author$project$Model$CountryCallingCode$all);
				}
			}(),
			WG: A2(
				$elm$core$Basics$composeL,
				toMsg,
				A2($author$project$Util$Base$flip, $elm$core$Tuple$pair, phoneNumber)),
			WH: $author$project$Data$CountryCallingCode$formatWithCountryName,
			WI: $author$project$Model$CountryCallingCode$toString
		};
		return A2(
			$author$project$Component$Form$TextInput$view,
			'',
			_List_fromArray(
				[
					$author$project$Component$Form$TextInput$id('phoneNumber'),
					$author$project$Component$Form$TextInput$extraHtml(
					$author$project$Component$Form$SelectNonEmpty$viewSelect(selectConfig)),
					$author$project$Component$Form$TextInput$placeholder($author$project$Copy$copy.VY),
					$author$project$Component$Form$TextInput$onInput(
					A2(
						$elm$core$Basics$composeL,
						toMsg,
						$elm$core$Tuple$pair(countryCallingCode))),
					$author$project$Component$Form$TextInput$value(phoneNumber),
					$author$project$Component$Form$TextInput$error(maybeErr),
					$author$project$Component$Form$TextInput$phone,
					$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.aM),
					$author$project$Component$Form$TextInput$class('phone with-calling-code')
				]));
	});
var $author$project$ContactForm$viewError = F2(
	function (inputId, validationResponse) {
		return A2(
			$author$project$Util$View$viewMaybe,
			A2($author$project$ContactForm$maybeError, inputId, validationResponse),
			function (message) {
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('error-message')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						]));
			});
	});
var $author$project$ContactForm$viewTextAreaInput = F5(
	function (toMsg, inputId, val, placeholder_, validationResponse) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-field', true),
							_Utils_Tuple2(
							'error',
							$elm_community$maybe_extra$Maybe$Extra$isJust(
								A2($author$project$ContactForm$maybeError, inputId, validationResponse)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('field-content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$textarea,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$placeholder(placeholder_),
									$elm$html$Html$Attributes$class('form-input form-textarea'),
									$elm$html$Html$Attributes$required(true),
									$elm$html$Html$Attributes$value(val),
									$elm$html$Html$Events$onInput(toMsg),
									$elm$html$Html$Attributes$id(
									A2(
										$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
										'{0}-input',
										_List_fromArray(
											[inputId])))
								]),
							_List_Nil)
						])),
					A2($author$project$ContactForm$viewError, inputId, validationResponse)
				]));
	});
var $author$project$ContactForm$view = function (model) {
	var form = model.bP;
	var validationError = model.bE;
	var buttonTextR = function () {
		var _v1 = model.bI;
		if (_v1.$ === 1) {
			return $author$project$Copy$copy.Wq;
		} else {
			return A2($elm$core$Maybe$withDefault, '', model.bI);
		}
	}();
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form'),
				$elm$html$Html$Events$onSubmit($author$project$ContactForm$SubmitForm)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextInput$view,
						$author$project$Copy$copy.c4,
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$id('name'),
								$author$project$Component$Form$TextInput$placeholder($author$project$Copy$copy.c4),
								$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.VW),
								$author$project$Component$Form$TextInput$onInput(
								function (v) {
									return A2(
										$author$project$ContactForm$UpdateForm,
										'name',
										_Utils_update(
											form,
											{c4: v}));
								}),
								$author$project$Component$Form$TextInput$value(form.c4),
								$author$project$Component$Form$TextInput$error(
								A2($author$project$ContactForm$maybeError, 'name', validationError)),
								$author$project$Component$Form$TextInput$hiddenLabel(true)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Component$Form$TextInput$view,
						$author$project$Copy$copy.d4,
						_List_fromArray(
							[
								$author$project$Component$Form$TextInput$id('email'),
								$author$project$Component$Form$TextInput$placeholder($author$project$Copy$copy.d4),
								$author$project$Component$Form$TextInput$icon($author$project$View$Icon$path.d4),
								$author$project$Component$Form$TextInput$onInput(
								function (v) {
									return A2(
										$author$project$ContactForm$UpdateForm,
										'emailAddress',
										_Utils_update(
											form,
											{bd: v}));
								}),
								$author$project$Component$Form$TextInput$value(form.bd),
								$author$project$Component$Form$TextInput$error(
								A2($author$project$ContactForm$maybeError, 'emailAddress', validationError)),
								$author$project$Component$Form$TextInput$hiddenLabel(true)
							]))
					])),
				A3(
				$author$project$ContactForm$phoneField,
				form.aM,
				A2($author$project$ContactForm$maybeError, 'phone-number-with-calling-code', validationError),
				function (phoneIncludingCallingCode) {
					return A2(
						$author$project$ContactForm$UpdateForm,
						'phone-number-with-calling-code',
						_Utils_update(
							form,
							{aM: phoneIncludingCallingCode}));
				}),
				A5(
				$author$project$ContactForm$viewTextAreaInput,
				function (v) {
					return A2(
						$author$project$ContactForm$UpdateForm,
						'contactMsg',
						_Utils_update(
							form,
							{bp: v}));
				},
				'contactMsg',
				form.bp,
				$author$project$Copy$copy.bp,
				validationError),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$autocomplete(false),
						$elm$html$Html$Attributes$name('password'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'display:none !important'),
						A2($elm$html$Html$Attributes$attribute, 'tabindex', '-1'),
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Attributes$value(
						A2($elm$core$Maybe$withDefault, '', form.bQ)),
						$elm$html$Html$Events$onInput(
						function (v) {
							return A2(
								$author$project$ContactForm$UpdateForm,
								'',
								_Utils_update(
									form,
									{
										bQ: $elm$core$Maybe$Just(v)
									}));
						})
					]),
				_List_Nil),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('submit'),
						$elm$html$Html$Attributes$class('btn bg-color-1 color-white')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(buttonTextR)
					])),
				function () {
				var _v0 = model.aU;
				switch (_v0.$) {
					case 3:
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('success')
								]),
							_List_fromArray(
								[
									$author$project$View$Icon$viewColored($author$project$View$Icon$path.Up),
									$elm$html$Html$text($author$project$Copy$copy.Wr)
								]));
					case 2:
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('error')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Copy$copy.WR)
								]));
					default:
						return $elm$html$Html$text('');
				}
			}()
			]));
};
var $author$project$ContactForm$main = A2(
	$author$project$Browser$Custom$elementWithFlags,
	$author$project$Model$Component$ContactForm$Flags$flagsDecoder,
	{cR: $author$project$ContactForm$init, dC: $author$project$ContactForm$subscriptions, dJ: $author$project$ContactForm$update, dM: $author$project$ContactForm$view});
_Platform_export({'ContactForm':{'init':$author$project$ContactForm$main($elm$json$Json$Decode$value)(0)},'VacancyFilterOptionSearch':{'init':$author$project$VacancyFilterOptionSearch$main($elm$json$Json$Decode$value)(0)},'TravelTime':{'init':$author$project$TravelTime$main($elm$json$Json$Decode$value)(0)},'Slider':{'init':$author$project$Slider$main($elm$json$Json$Decode$value)(0)},'ShareToolForm':{'init':$author$project$ShareToolForm$main($elm$json$Json$Decode$value)(0)},'ShareToolEmployeeContentCollection':{'init':$author$project$ShareToolEmployeeContentCollection$main($elm$json$Json$Decode$value)(0)},'SalaryCalculator':{'init':$author$project$SalaryCalculator$main($elm$json$Json$Decode$value)(0)},'ReferralToolForm':{'init':$author$project$ReferralToolForm$main($elm$json$Json$Decode$value)(0)},'ReferralToolEditForm':{'init':$author$project$ReferralToolEditForm$main($elm$json$Json$Decode$value)(0)},'RecruitmentChat':{'init':$author$project$RecruitmentChat$main($elm$json$Json$Decode$value)(0)},'LocationSearch':{'init':$author$project$LocationSearch$main($elm$json$Json$Decode$value)(0)},'KeywordSearch':{'init':$author$project$KeywordSearch$main($elm$json$Json$Decode$value)(0)},'JobAlertForm':{'init':$author$project$JobAlertForm$main($elm$json$Json$Decode$value)(0)},'Form':{'init':$author$project$Form$main($elm$json$Json$Decode$value)(0)}});}(this));